
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $b7f229489df24bee$exports = {};
$b7f229489df24bee$exports = ".mdc-banner__text{color:var(--mdc-theme-on-surface,#000)}.mdc-banner__graphic{color:var(--mdc-theme-surface,#fff);background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);border-radius:50%}.mdc-banner__content,.mdc-banner__fixed{min-width:344px}@media (width<=480px),(width<=344px){.mdc-banner__content,.mdc-banner__fixed{min-width:100%}}.mdc-banner__content{max-width:720px}.mdc-banner{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);z-index:1;box-sizing:border-box;border-bottom:1px solid #0000001f;flex-shrink:0;width:100%;height:0;display:none;position:relative}.mdc-banner .mdc-banner__fixed{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-bottom-color:#0000001f}@media (width<=480px){.mdc-banner .mdc-banner__fixed{left:0;right:0}.mdc-banner .mdc-banner__text{margin-left:16px;margin-right:36px}[dir=rtl] .mdc-banner .mdc-banner__text,.mdc-banner .mdc-banner__text[dir=rtl]{margin-left:36px;margin-right:16px}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__content{flex-wrap:wrap}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__graphic{margin-bottom:12px}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__text{margin-left:16px;margin-right:8px;padding-bottom:4px}[dir=rtl] .mdc-banner.mdc-banner--mobile-stacked .mdc-banner__text,.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__text[dir=rtl]{margin-left:8px;margin-right:16px}.mdc-banner.mdc-banner--mobile-stacked .mdc-banner__actions{margin-left:auto}}.mdc-banner--opening,.mdc-banner--open,.mdc-banner--closing{display:flex}.mdc-banner--open{transition:height .3s}.mdc-banner--open .mdc-banner__content{transition:transform .3s;transform:translateY(0)}.mdc-banner--closing{transition:height .25s}.mdc-banner--closing .mdc-banner__content{transition:transform .25s}.mdc-banner--centered .mdc-banner__content{margin-left:auto;margin-right:auto;left:0;right:0}.mdc-banner__fixed{box-sizing:border-box;height:inherit;border-bottom-style:solid;border-bottom-width:1px;width:100%;position:fixed}.mdc-banner__content{width:100%;min-height:52px;display:flex;position:absolute;transform:translateY(-100%)}.mdc-banner__graphic-text-wrapper{width:100%;display:flex}.mdc-banner__graphic{text-align:center;flex-shrink:0;width:40px;height:40px;margin:16px 0 16px 16px}[dir=rtl] .mdc-banner__graphic,.mdc-banner__graphic[dir=rtl]{margin-left:0;margin-right:16px}.mdc-banner__icon{position:relative;top:50%;transform:translateY(-50%)}.mdc-banner__text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);flex-grow:1;align-self:center;margin-left:24px;margin-right:90px;padding-top:16px;padding-bottom:16px}[dir=rtl] .mdc-banner__text,.mdc-banner__text[dir=rtl]{margin-left:90px;margin-right:24px}.mdc-banner__actions{flex-shrink:0;align-self:flex-end;padding:8px 8px 8px 0;display:flex}[dir=rtl] .mdc-banner__actions,.mdc-banner__actions[dir=rtl]{padding-left:8px;padding-right:0}.mdc-banner__primary-action:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-banner__primary-action:before,.mdc-banner__primary-action:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-banner__primary-action:hover:before,.mdc-banner__primary-action.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-banner__primary-action.mdc-ripple-upgraded--background-focused:before,.mdc-banner__primary-action:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-banner__primary-action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-banner__primary-action:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-banner__primary-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-banner__secondary-action{margin-left:0;margin-right:8px}.mdc-banner__secondary-action:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-banner__secondary-action:before,.mdc-banner__secondary-action:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-banner__secondary-action:hover:before,.mdc-banner__secondary-action.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-banner__secondary-action.mdc-ripple-upgraded--background-focused:before,.mdc-banner__secondary-action:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-banner__secondary-action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-banner__secondary-action:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-banner__secondary-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}[dir=rtl] .mdc-banner__secondary-action,.mdc-banner__secondary-action[dir=rtl]{margin-left:8px;margin-right:0}.mdc-touch-target-wrapper{display:inline}.mdc-elevation-overlay{border-radius:inherit;pointer-events:none;opacity:0;opacity:var(--mdc-elevation-overlay-opacity,0);background-color:#fff;background-color:var(--mdc-elevation-overlay-color,#fff);transition:opacity .28s cubic-bezier(.4,0,.2,1);position:absolute}.mdc-button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);box-sizing:border-box;line-height:inherit;-webkit-user-select:none;user-select:none;-webkit-appearance:none;vertical-align:middle;border:none;outline:none;justify-content:center;align-items:center;min-width:64px;display:inline-flex;position:relative;overflow:visible}.mdc-button .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-button::-moz-focus-inner{border:0;padding:0}.mdc-button:active{outline:none}.mdc-button:hover{cursor:pointer}.mdc-button:disabled{cursor:default;pointer-events:none}.mdc-button .mdc-button__icon{vertical-align:top;width:1.125rem;height:1.125rem;margin-left:0;margin-right:8px;font-size:1.125rem;display:inline-block}[dir=rtl] .mdc-button .mdc-button__icon,.mdc-button .mdc-button__icon[dir=rtl]{margin-left:8px;margin-right:0}.mdc-button .mdc-button__touch{height:48px;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.mdc-button__label+.mdc-button__icon{margin-left:8px;margin-right:0}[dir=rtl] .mdc-button__label+.mdc-button__icon,.mdc-button__label+.mdc-button__icon[dir=rtl]{margin-left:0;margin-right:8px}svg.mdc-button__icon{fill:currentColor}.mdc-button--raised .mdc-button__icon,.mdc-button--unelevated .mdc-button__icon,.mdc-button--outlined .mdc-button__icon{margin-left:-4px;margin-right:8px}[dir=rtl] .mdc-button--raised .mdc-button__icon,.mdc-button--raised .mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--unelevated .mdc-button__icon,.mdc-button--unelevated .mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--outlined .mdc-button__icon,.mdc-button--outlined .mdc-button__icon[dir=rtl],.mdc-button--raised .mdc-button__label+.mdc-button__icon,.mdc-button--unelevated .mdc-button__label+.mdc-button__icon,.mdc-button--outlined .mdc-button__label+.mdc-button__icon{margin-left:8px;margin-right:-4px}[dir=rtl] .mdc-button--raised .mdc-button__label+.mdc-button__icon,.mdc-button--raised .mdc-button__label+.mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--unelevated .mdc-button__label+.mdc-button__icon,.mdc-button--unelevated .mdc-button__label+.mdc-button__icon[dir=rtl],[dir=rtl] .mdc-button--outlined .mdc-button__label+.mdc-button__icon,.mdc-button--outlined .mdc-button__label+.mdc-button__icon[dir=rtl]{margin-left:-4px;margin-right:8px}.mdc-button--touch{margin-top:6px;margin-bottom:6px}@keyframes mdc-ripple-fg-radius-in{0%{transform:translate(var(--mdc-ripple-fg-translate-start,0))scale(1);animation-timing-function:cubic-bezier(.4,0,.2,1)}to{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1))}}@keyframes mdc-ripple-fg-opacity-in{0%{opacity:0;animation-timing-function:linear}to{opacity:var(--mdc-ripple-fg-opacity,0)}}@keyframes mdc-ripple-fg-opacity-out{0%{opacity:var(--mdc-ripple-fg-opacity,0);animation-timing-function:linear}to{opacity:0}}.mdc-button{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-button .mdc-button__ripple:before,.mdc-button .mdc-button__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-button .mdc-button__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-button .mdc-button__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-button.mdc-ripple-upgraded .mdc-button__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-button.mdc-ripple-upgraded .mdc-button__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-button.mdc-ripple-upgraded--unbounded .mdc-button__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-button.mdc-ripple-upgraded--foreground-activation .mdc-button__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-button.mdc-ripple-upgraded--foreground-deactivation .mdc-button__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-button .mdc-button__ripple:before,.mdc-button .mdc-button__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-button.mdc-ripple-upgraded .mdc-button__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-button .mdc-button__ripple{box-sizing:content-box;width:100%;height:100%;position:absolute;overflow:hidden}.mdc-button:not(.mdc-button--outlined) .mdc-button__ripple{top:0;left:0}.mdc-button--raised{transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-button--raised:hover,.mdc-button--raised:focus{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-button--raised:active{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-button--raised:disabled{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mdc-button--outlined{border-style:solid}.mdc-button{border-radius:4px;border-radius:var(--mdc-shape-small,4px);height:36px;padding:0 8px}.mdc-button:not(:disabled),.mdc-button:disabled{background-color:#0000}.mdc-button:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-button:disabled{color:#00000061}.mdc-button .mdc-button__ripple:before,.mdc-button .mdc-button__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-button:hover .mdc-button__ripple:before,.mdc-button.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-button:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-button .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--unelevated{border-radius:4px;border-radius:var(--mdc-shape-small,4px);height:36px;padding:0 16px}.mdc-button--unelevated:not(:disabled){background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee)}.mdc-button--unelevated:disabled{background-color:#0000001f}.mdc-button--unelevated:not(:disabled){color:var(--mdc-theme-on-primary,#fff)}.mdc-button--unelevated:disabled{color:#00000061}.mdc-button--unelevated .mdc-button__ripple:before,.mdc-button--unelevated .mdc-button__ripple:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-primary,#fff))}.mdc-button--unelevated:hover .mdc-button__ripple:before,.mdc-button--unelevated.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-button--unelevated.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button--unelevated:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-button--unelevated:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button--unelevated:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-button--unelevated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-button--unelevated .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--raised{border-radius:4px;border-radius:var(--mdc-shape-small,4px);height:36px;padding:0 16px}.mdc-button--raised:not(:disabled){background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee)}.mdc-button--raised:disabled{background-color:#0000001f}.mdc-button--raised:not(:disabled){color:var(--mdc-theme-on-primary,#fff)}.mdc-button--raised:disabled{color:#00000061}.mdc-button--raised .mdc-button__ripple:before,.mdc-button--raised .mdc-button__ripple:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-primary,#fff))}.mdc-button--raised:hover .mdc-button__ripple:before,.mdc-button--raised.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-button--raised.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button--raised:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-button--raised:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button--raised:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-button--raised.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-button--raised .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--outlined{border-radius:4px;border-radius:var(--mdc-shape-small,4px);border-width:1px;height:36px;padding:0 15px}.mdc-button--outlined:not(:disabled),.mdc-button--outlined:disabled{background-color:#0000}.mdc-button--outlined:not(:disabled){color:var(--mdc-theme-primary,#6200ee)}.mdc-button--outlined:disabled{color:#00000061}.mdc-button--outlined .mdc-button__ripple:before,.mdc-button--outlined .mdc-button__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-button--outlined:hover .mdc-button__ripple:before,.mdc-button--outlined.mdc-ripple-surface--hover .mdc-button__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-button--outlined.mdc-ripple-upgraded--background-focused .mdc-button__ripple:before,.mdc-button--outlined:not(.mdc-ripple-upgraded):focus .mdc-button__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-button--outlined:not(.mdc-ripple-upgraded) .mdc-button__ripple:after{transition:opacity .15s linear}.mdc-button--outlined:not(.mdc-ripple-upgraded):active .mdc-button__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-button--outlined.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-button--outlined .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-button--outlined:not(:disabled),.mdc-button--outlined:disabled{border-color:#0000001f}.mdc-button--outlined .mdc-button__ripple{border:1px solid #0000;top:-1px;left:-1px}.mdc-button--outlined .mdc-button__touch{width:calc(100% + 2px);left:-1px}.mdc-card{border-radius:4px;border-radius:var(--mdc-shape-medium,4px);background-color:#fff;background-color:var(--mdc-theme-surface,#fff);box-sizing:border-box;flex-direction:column;display:flex;position:relative;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mdc-card .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-card:after{border-radius:4px;border-radius:var(--mdc-shape-medium,4px);box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-card--outlined{border:1px solid #e0e0e0;box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mdc-card--outlined:after{border:none}.mdc-card__content{border-radius:inherit;height:100%}.mdc-card__media{box-sizing:border-box;background-position:50%;background-repeat:no-repeat;background-size:cover;position:relative}.mdc-card__media:before{content:\"\";display:block}.mdc-card__media:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.mdc-card__media:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.mdc-card__media--square:before{margin-top:100%}.mdc-card__media--16-9:before{margin-top:56.25%}.mdc-card__media-content{box-sizing:border-box;position:absolute;inset:0}.mdc-card__primary-action{box-sizing:border-box;color:inherit;cursor:pointer;outline:none;flex-direction:column;text-decoration:none;display:flex;position:relative;overflow:hidden}.mdc-card__primary-action:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.mdc-card__primary-action:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.mdc-card__actions{box-sizing:border-box;flex-direction:row;align-items:center;min-height:52px;padding:8px;display:flex}.mdc-card__actions--full-bleed{padding:0}.mdc-card__action-buttons,.mdc-card__action-icons{box-sizing:border-box;flex-direction:row;align-items:center;display:flex}.mdc-card__action-icons{color:#0009;flex-grow:1;justify-content:flex-end}.mdc-card__action-buttons+.mdc-card__action-icons{margin-left:16px;margin-right:0}[dir=rtl] .mdc-card__action-buttons+.mdc-card__action-icons,.mdc-card__action-buttons+.mdc-card__action-icons[dir=rtl]{margin-left:0;margin-right:16px}.mdc-card__action{box-sizing:border-box;cursor:pointer;-webkit-user-select:none;user-select:none;flex-direction:row;justify-content:center;align-items:center;display:inline-flex}.mdc-card__action:focus{outline:none}.mdc-card__action--button{margin-left:0;margin-right:8px;padding:0 8px}[dir=rtl] .mdc-card__action--button,.mdc-card__action--button[dir=rtl]{margin-left:8px;margin-right:0}.mdc-card__action--button:last-child,[dir=rtl] .mdc-card__action--button:last-child,.mdc-card__action--button:last-child[dir=rtl]{margin-left:0;margin-right:0}.mdc-card__actions--full-bleed .mdc-card__action--button{text-align:left;justify-content:space-between;width:100%;height:auto;max-height:none;margin:0;padding:8px 16px}[dir=rtl] .mdc-card__actions--full-bleed .mdc-card__action--button,.mdc-card__actions--full-bleed .mdc-card__action--button[dir=rtl]{text-align:right}.mdc-card__action--icon{margin:-6px 0;padding:12px}.mdc-card__action--icon:not(:disabled){color:#0009}.mdc-card__primary-action{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-card__primary-action:before,.mdc-card__primary-action:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-card__primary-action:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-card__primary-action:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-card__primary-action.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-card__primary-action.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-card__primary-action.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-card__primary-action.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-card__primary-action.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-card__primary-action:before,.mdc-card__primary-action:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-card__primary-action.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-card__primary-action:before,.mdc-card__primary-action:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-card__primary-action:hover:before,.mdc-card__primary-action.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-card__primary-action.mdc-ripple-upgraded--background-focused:before,.mdc-card__primary-action:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-card__primary-action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-card__primary-action:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-card__primary-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-checkbox{padding:11px;padding:calc((var(--mdc-checkbox-ripple-size,40px) - 18px)/2);margin:0;margin:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2)}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-checkbox:hover .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-ripple-surface--hover .mdc-checkbox__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-checkbox:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after{transition:opacity .15s linear}.mdc-checkbox:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-checkbox.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after{transition:opacity .15s linear}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-checkbox .mdc-checkbox__background{top:11px;top:calc((var(--mdc-checkbox-ripple-size,40px) - 18px)/2);left:11px;left:calc((var(--mdc-checkbox-ripple-size,40px) - 18px)/2)}.mdc-checkbox .mdc-checkbox__native-control{top:0;top:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2);right:0;right:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2);left:0;left:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-ripple-size,40px))/2);width:var(--mdc-checkbox-ripple-size,40px);height:var(--mdc-checkbox-ripple-size,40px);width:40px;height:40px}.mdc-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#018786;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786))}@keyframes mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786{0%{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}50%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786{0%,80%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#018786))}to{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}}.mdc-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786}.mdc-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786}.mdc-checkbox .mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:#00000061;border-color:var(--mdc-checkbox-disabled-color,#00000061);background-color:#0000}.mdc-checkbox .mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{background-color:#00000061;background-color:var(--mdc-checkbox-disabled-color,#00000061);border-color:#0000}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:var(--mdc-checkbox-ink-color,#fff)}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color,#fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:var(--mdc-checkbox-ink-color,#fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color,#fff)}@keyframes mdc-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:29.7833px}50%{animation-timing-function:cubic-bezier(0,0,.2,1)}to{stroke-dashoffset:0}}@keyframes mdc-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}to{transform:scaleX(1)}}@keyframes mdc-checkbox-checked-unchecked-checkmark-path{0%{opacity:1;stroke-dashoffset:0;animation-timing-function:cubic-bezier(.4,0,1,1)}to{opacity:0;stroke-dashoffset:-29.7833px}}@keyframes mdc-checkbox-checked-indeterminate-checkmark{0%{opacity:1;animation-timing-function:cubic-bezier(0,0,.2,1);transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mdc-checkbox-indeterminate-checked-checkmark{0%{opacity:0;animation-timing-function:cubic-bezier(.14,0,0,1);transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mdc-checkbox-checked-indeterminate-mixedmark{0%{animation-timing-function:mdc-animation-deceleration-curve-timing-function;opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mdc-checkbox-indeterminate-checked-mixedmark{0%{opacity:1;animation-timing-function:cubic-bezier(.14,0,0,1);transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mdc-checkbox-indeterminate-unchecked-mixedmark{0%{opacity:1;animation-timing-function:linear;transform:scaleX(1)}32.8%,to{opacity:0;transform:scaleX(0)}}.mdc-checkbox{box-sizing:content-box;white-space:nowrap;cursor:pointer;vertical-align:bottom;flex:0 0 18px;width:18px;height:18px;line-height:0;display:inline-block;position:relative}@media screen and (-ms-high-contrast:active){.mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:graytext;border-color:var(--mdc-checkbox-disabled-color,GrayText);background-color:#0000}.mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background,.mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background,.mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{background-color:#0000;background-color:var(--mdc-checkbox-disabled-color,transparent);border-color:graytext}.mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:var(--mdc-checkbox-ink-color,GrayText)}.mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:graytext;border-color:var(--mdc-checkbox-ink-color,GrayText)}.mdc-checkbox__mixedmark{margin:0 1px}}.mdc-checkbox--disabled{cursor:default;pointer-events:none}.mdc-checkbox__background{box-sizing:border-box;pointer-events:none;will-change:background-color,border-color;background-color:#0000;border:2px solid;border-radius:2px;justify-content:center;align-items:center;width:18px;height:18px;transition:background-color 90ms cubic-bezier(.4,0,.6,1),border-color 90ms cubic-bezier(.4,0,.6,1);display:inline-flex;position:absolute}.mdc-checkbox__checkmark{opacity:0;width:100%;transition:opacity .18s cubic-bezier(.4,0,.6,1);position:absolute;inset:0}.mdc-checkbox--upgraded .mdc-checkbox__checkmark{opacity:1}.mdc-checkbox__checkmark-path{stroke:currentColor;stroke-width:3.12px;stroke-dashoffset:29.7833px;stroke-dasharray:29.7833;transition:stroke-dashoffset .18s cubic-bezier(.4,0,.6,1)}.mdc-checkbox__mixedmark{opacity:0;border-style:solid;border-width:1px;width:100%;height:0;transition:opacity 90ms cubic-bezier(.4,0,.6,1),transform 90ms cubic-bezier(.4,0,.6,1);transform:scaleX(0)rotate(0)}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__background,.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__background,.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__background,.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__background{animation-duration:.18s;animation-timing-function:linear}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__checkmark-path{transition:none;animation:.18s linear mdc-checkbox-unchecked-checked-checkmark-path}.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__mixedmark{transition:none;animation:90ms linear mdc-checkbox-unchecked-indeterminate-mixedmark}.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__checkmark-path{transition:none;animation:90ms linear mdc-checkbox-checked-unchecked-checkmark-path}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__checkmark{transition:none;animation:90ms linear mdc-checkbox-checked-indeterminate-checkmark}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__mixedmark{transition:none;animation:90ms linear mdc-checkbox-checked-indeterminate-mixedmark}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__checkmark{transition:none;animation:.5s linear mdc-checkbox-indeterminate-checked-checkmark}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__mixedmark{transition:none;animation:.5s linear mdc-checkbox-indeterminate-checked-mixedmark}.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__mixedmark{transition:none;animation:.3s linear mdc-checkbox-indeterminate-unchecked-mixedmark}.mdc-checkbox__native-control:checked~.mdc-checkbox__background,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background{transition:border-color 90ms cubic-bezier(0,0,.2,1),background-color 90ms cubic-bezier(0,0,.2,1)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark-path{stroke-dashoffset:0}.mdc-checkbox__native-control{opacity:0;cursor:inherit;margin:0;padding:0;position:absolute}.mdc-checkbox__native-control:disabled{cursor:default;pointer-events:none}.mdc-checkbox--touch{margin:4px;margin:calc((var(--mdc-checkbox-touch-target-size,48px) - var(--mdc-checkbox-ripple-size,40px))/2)}.mdc-checkbox--touch .mdc-checkbox__native-control{top:-4px;top:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-touch-target-size,48px))/2);right:-4px;right:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-touch-target-size,48px))/2);left:-4px;left:calc((var(--mdc-checkbox-ripple-size,40px) - var(--mdc-checkbox-touch-target-size,48px))/2);width:var(--mdc-checkbox-touch-target-size,48px);height:var(--mdc-checkbox-touch-target-size,48px);width:48px;height:48px}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark{opacity:1;transition:opacity .18s cubic-bezier(0,0,.2,1),transform .18s cubic-bezier(0,0,.2,1)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__mixedmark{transform:scaleX(1)rotate(-45deg)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark{opacity:0;transition:opacity 90ms cubic-bezier(.4,0,.6,1),transform 90ms cubic-bezier(.4,0,.6,1);transform:rotate(45deg)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__mixedmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__mixedmark{opacity:1;transform:scaleX(1)rotate(0)}.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark-path,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__mixedmark{transition:none}.mdc-checkbox{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-checkbox .mdc-checkbox__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-checkbox .mdc-checkbox__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-checkbox.mdc-ripple-upgraded--unbounded .mdc-checkbox__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-checkbox.mdc-ripple-upgraded--foreground-activation .mdc-checkbox__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-checkbox.mdc-ripple-upgraded--foreground-deactivation .mdc-checkbox__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{width:100%;height:100%;top:0%;left:0%}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:before,.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-checkbox.mdc-ripple-upgraded .mdc-checkbox__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-checkbox{z-index:0}.mdc-checkbox .mdc-checkbox__ripple:before,.mdc-checkbox .mdc-checkbox__ripple:after{z-index:-1;z-index:var(--mdc-ripple-z-index,-1)}.mdc-checkbox__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-deprecated-chip-trailing-action__touch{width:48px;height:48px;position:absolute;top:50%;left:50%;right:0;transform:translate(-50%,-50%)}.mdc-deprecated-chip-trailing-action{box-sizing:border-box;cursor:pointer;-webkit-appearance:none;background:0 0;border:none;outline:none;justify-content:center;align-items:center;padding:0;display:inline-flex;position:relative}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__icon{width:18px;height:18px;font-size:18px}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action{color:var(--mdc-theme-on-surface,#000)}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__touch{width:26px}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__icon{fill:currentColor;color:inherit}.mdc-deprecated-chip-trailing-action{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--unbounded .mdc-deprecated-chip-trailing-action__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--foreground-activation .mdc-deprecated-chip-trailing-action__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--foreground-deactivation .mdc-deprecated-chip-trailing-action__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{width:100%;height:100%;top:0%;left:0%}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded .mdc-deprecated-chip-trailing-action__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-deprecated-chip-trailing-action:hover .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action.mdc-ripple-surface--hover .mdc-deprecated-chip-trailing-action__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded--background-focused .mdc-deprecated-chip-trailing-action__ripple:before,.mdc-deprecated-chip-trailing-action:not(.mdc-ripple-upgraded):focus .mdc-deprecated-chip-trailing-action__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-deprecated-chip-trailing-action:not(.mdc-ripple-upgraded) .mdc-deprecated-chip-trailing-action__ripple:after{transition:opacity .15s linear}.mdc-deprecated-chip-trailing-action:not(.mdc-ripple-upgraded):active .mdc-deprecated-chip-trailing-action__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-deprecated-chip-trailing-action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-deprecated-chip-trailing-action .mdc-deprecated-chip-trailing-action__ripple{box-sizing:content-box;width:100%;height:100%;position:absolute;overflow:hidden}.mdc-chip__icon--leading{color:#0000008a}.mdc-deprecated-chip-trailing-action{color:#000}.mdc-chip__icon--trailing{color:#0000008a}.mdc-chip__icon--trailing:hover{color:#0000009e}.mdc-chip__icon--trailing:focus{color:#000000de}.mdc-chip__icon.mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden){width:20px;height:20px;font-size:20px}.mdc-deprecated-chip-trailing-action__icon,.mdc-chip__icon.mdc-chip__icon--trailing{width:18px;height:18px;font-size:18px}.mdc-deprecated-chip-trailing-action{margin-left:4px;margin-right:-4px}[dir=rtl] .mdc-deprecated-chip-trailing-action,.mdc-deprecated-chip-trailing-action[dir=rtl]{margin-left:-4px;margin-right:4px}.mdc-chip__icon--trailing{margin-left:4px;margin-right:-4px}[dir=rtl] .mdc-chip__icon--trailing,.mdc-chip__icon--trailing[dir=rtl]{margin-left:-4px;margin-right:4px}.mdc-chip{color:#000000de;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;cursor:pointer;-webkit-appearance:none;background-color:#e0e0e0;border-width:0;border-radius:16px;outline:none;align-items:center;height:32px;padding:0 12px;display:inline-flex;position:relative}.mdc-chip .mdc-chip__ripple{border-radius:16px}.mdc-chip.mdc-chip--selected .mdc-chip__checkmark,.mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden){margin-left:-4px;margin-right:4px}[dir=rtl] .mdc-chip.mdc-chip--selected .mdc-chip__checkmark,.mdc-chip.mdc-chip--selected .mdc-chip__checkmark[dir=rtl],[dir=rtl] .mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden),.mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden)[dir=rtl]{margin-left:4px;margin-right:-4px}.mdc-chip .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-chip::-moz-focus-inner{border:0;padding:0}.mdc-chip:hover{color:var(--mdc-theme-on-surface,#000)}.mdc-chip .mdc-chip__touch{height:48px;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.mdc-chip--exit{opacity:0;transition:opacity 75ms cubic-bezier(.4,0,.2,1),width .15s cubic-bezier(0,0,.2,1),padding .1s linear,margin .1s linear}.mdc-chip__overflow{text-overflow:ellipsis;overflow:hidden}.mdc-chip__text{white-space:nowrap}.mdc-chip__icon{vertical-align:middle;border-radius:50%;outline:none}.mdc-chip__checkmark{height:20px}.mdc-chip__checkmark-path{stroke-width:2px;stroke-dashoffset:29.7833px;stroke-dasharray:29.7833;transition:stroke-dashoffset .15s cubic-bezier(.4,0,.6,1) 50ms}.mdc-chip__primary-action:focus{outline:none}.mdc-chip--selected .mdc-chip__checkmark-path{stroke-dashoffset:0}.mdc-chip__icon--leading,.mdc-chip__icon--trailing{position:relative}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected{color:var(--mdc-theme-primary,#6200ee)}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__icon--leading{color:#6200ee8a}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:hover{color:var(--mdc-theme-primary,#6200ee)}.mdc-chip-set--choice .mdc-chip .mdc-chip__checkmark-path{stroke:var(--mdc-theme-primary,#6200ee)}.mdc-chip-set--choice .mdc-chip--selected{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-chip__checkmark-svg{width:0;height:20px;transition:width .15s cubic-bezier(.4,0,.2,1)}.mdc-chip--selected .mdc-chip__checkmark-svg{width:20px}.mdc-chip-set--filter .mdc-chip__icon--leading{opacity:1;transition:opacity 75ms linear -50ms}.mdc-chip-set--filter .mdc-chip__icon--leading+.mdc-chip__checkmark{opacity:0;transition:opacity 75ms linear 80ms}.mdc-chip-set--filter .mdc-chip__icon--leading+.mdc-chip__checkmark .mdc-chip__checkmark-svg{transition:width}.mdc-chip-set--filter .mdc-chip--selected .mdc-chip__icon--leading{opacity:0}.mdc-chip-set--filter .mdc-chip--selected .mdc-chip__icon--leading+.mdc-chip__checkmark{opacity:1;width:0}.mdc-chip-set--filter .mdc-chip__icon--leading-hidden.mdc-chip__icon--leading{opacity:0;width:0}.mdc-chip-set--filter .mdc-chip__icon--leading-hidden.mdc-chip__icon--leading+.mdc-chip__checkmark{width:20px}.mdc-chip{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-chip .mdc-chip__ripple:before,.mdc-chip .mdc-chip__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-chip .mdc-chip__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-chip .mdc-chip__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-chip.mdc-ripple-upgraded .mdc-chip__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-chip.mdc-ripple-upgraded .mdc-chip__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-chip.mdc-ripple-upgraded--unbounded .mdc-chip__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-chip.mdc-ripple-upgraded--foreground-activation .mdc-chip__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-chip.mdc-ripple-upgraded--foreground-deactivation .mdc-chip__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-chip .mdc-chip__ripple:before,.mdc-chip .mdc-chip__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-chip.mdc-ripple-upgraded .mdc-chip__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-chip .mdc-chip__ripple:before,.mdc-chip .mdc-chip__ripple:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-chip:hover .mdc-chip__ripple:before,.mdc-chip.mdc-ripple-surface--hover .mdc-chip__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-chip.mdc-ripple-upgraded--background-focused .mdc-chip__ripple:before,.mdc-chip.mdc-ripple-upgraded:focus-within .mdc-chip__ripple:before,.mdc-chip:not(.mdc-ripple-upgraded):focus .mdc-chip__ripple:before,.mdc-chip:not(.mdc-ripple-upgraded):focus-within .mdc-chip__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-chip:not(.mdc-ripple-upgraded) .mdc-chip__ripple:after{transition:opacity .15s linear}.mdc-chip:not(.mdc-ripple-upgraded):active .mdc-chip__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-chip.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-chip .mdc-chip__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected .mdc-chip__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:hover .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-surface--hover .mdc-chip__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-upgraded--background-focused .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-upgraded:focus-within .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded):focus .mdc-chip__ripple:before,.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded):focus-within .mdc-chip__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded) .mdc-chip__ripple:after{transition:opacity .15s linear}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected:not(.mdc-ripple-upgraded):active .mdc-chip__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}.mdc-chip-set--choice .mdc-chip.mdc-chip--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.2)}@keyframes mdc-chip-entry{0%{opacity:.4;transform:scale(.8)}to{opacity:1;transform:scale(1)}}.mdc-chip-set{box-sizing:border-box;flex-wrap:wrap;padding:4px;display:flex}.mdc-chip-set .mdc-chip{margin:4px}.mdc-chip-set .mdc-chip--touch{margin-top:8px;margin-bottom:8px}.mdc-chip-set--input .mdc-chip{animation:.1s cubic-bezier(0,0,.2,1) mdc-chip-entry}.mdc-circular-progress__determinate-circle,.mdc-circular-progress__indeterminate-circle-graphic{stroke:var(--mdc-theme-primary,#6200ee)}.mdc-circular-progress__determinate-track{stroke:#0000}@keyframes mdc-circular-progress-container-rotate{to{transform:rotate(360deg)}}@keyframes mdc-circular-progress-spinner-layer-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(1080deg)}}@keyframes mdc-circular-progress-color-1-fade-in-out{0%{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdc-circular-progress-color-2-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}to{opacity:0}}@keyframes mdc-circular-progress-color-3-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}to{opacity:0}}@keyframes mdc-circular-progress-color-4-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}@keyframes mdc-circular-progress-left-spin{0%{transform:rotate(265deg)}50%{transform:rotate(130deg)}to{transform:rotate(265deg)}}@keyframes mdc-circular-progress-right-spin{0%{transform:rotate(-265deg)}50%{transform:rotate(-130deg)}to{transform:rotate(-265deg)}}.mdc-circular-progress{direction:ltr;transition:opacity .25s cubic-bezier(.4,0,.6,1);display:inline-flex;position:relative}.mdc-circular-progress__determinate-container,.mdc-circular-progress__indeterminate-circle-graphic,.mdc-circular-progress__indeterminate-container,.mdc-circular-progress__spinner-layer{width:100%;height:100%;position:absolute}.mdc-circular-progress__determinate-container{transform:rotate(-90deg)}.mdc-circular-progress__indeterminate-container{letter-spacing:0;white-space:nowrap;opacity:0;font-size:0}.mdc-circular-progress__determinate-circle-graphic,.mdc-circular-progress__indeterminate-circle-graphic{fill:#0000}.mdc-circular-progress__determinate-circle{transition:stroke-dashoffset .5s cubic-bezier(0,0,.2,1)}.mdc-circular-progress__gap-patch{box-sizing:border-box;width:5%;height:100%;position:absolute;top:0;left:47.5%;overflow:hidden}.mdc-circular-progress__gap-patch .mdc-circular-progress__indeterminate-circle-graphic{width:2000%;left:-900%;transform:rotate(180deg)}.mdc-circular-progress__circle-clipper{width:50%;height:100%;display:inline-flex;position:relative;overflow:hidden}.mdc-circular-progress__circle-clipper .mdc-circular-progress__indeterminate-circle-graphic{width:200%}.mdc-circular-progress__circle-right .mdc-circular-progress__indeterminate-circle-graphic{left:-100%}.mdc-circular-progress--indeterminate .mdc-circular-progress__determinate-container{opacity:0}.mdc-circular-progress--indeterminate .mdc-circular-progress__indeterminate-container{opacity:1;animation:1.56824s linear infinite mdc-circular-progress-container-rotate}.mdc-circular-progress--indeterminate .mdc-circular-progress__spinner-layer{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-1{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-1-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-2{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-2-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-3{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-3-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__color-4{animation:5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-spinner-layer-rotate,5.332s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-color-4-fade-in-out}.mdc-circular-progress--indeterminate .mdc-circular-progress__circle-left .mdc-circular-progress__indeterminate-circle-graphic{animation:1.333s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-left-spin}.mdc-circular-progress--indeterminate .mdc-circular-progress__circle-right .mdc-circular-progress__indeterminate-circle-graphic{animation:1.333s cubic-bezier(.4,0,.2,1) infinite both mdc-circular-progress-right-spin}.mdc-circular-progress--closed{opacity:0}.mdc-floating-label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);transform-origin:0 0;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:text;will-change:transform;line-height:1.15rem;transition:transform .15s cubic-bezier(.4,0,.2,1),color .15s cubic-bezier(.4,0,.2,1);position:absolute;left:0;overflow:hidden}[dir=rtl] .mdc-floating-label,.mdc-floating-label[dir=rtl]{transform-origin:100% 0;text-align:right;left:auto;right:0}.mdc-floating-label--float-above{cursor:auto}.mdc-floating-label--required:after{content:\"*\";margin-left:1px;margin-right:0}[dir=rtl] .mdc-floating-label--required:after,.mdc-floating-label--required[dir=rtl]:after{margin-left:0;margin-right:1px}.mdc-floating-label--float-above{transform:translateY(-106%)scale(.75)}.mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-standard}@keyframes mdc-floating-label-shake-float-above-standard{0%{transform:translate(0)translateY(-106%)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-106%)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-106%)scale(.75)}to{transform:translate(0)translateY(-106%)scale(.75)}}.mdc-line-ripple:before,.mdc-line-ripple:after{content:\"\";border-bottom-style:solid;width:100%;position:absolute;bottom:0;left:0}.mdc-line-ripple:before{z-index:1;border-bottom-width:1px}.mdc-line-ripple:after{opacity:0;z-index:2;border-bottom-width:2px;transition:transform .18s cubic-bezier(.4,0,.2,1),opacity .18s cubic-bezier(.4,0,.2,1);transform:scaleX(0)}.mdc-line-ripple--active:after{opacity:1;transform:scaleX(1)}.mdc-line-ripple--deactivating:after{opacity:0}.mdc-notched-outline{box-sizing:border-box;text-align:left;pointer-events:none;width:100%;max-width:100%;height:100%;display:flex;position:absolute;top:0;left:0;right:0}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;pointer-events:none;border-top:1px solid;border-bottom:1px solid;height:100%}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:none;width:auto;max-width:calc(100% - 24px)}.mdc-notched-outline .mdc-floating-label{max-width:100%;display:inline-block;position:relative}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:133.333%}.mdc-notched-outline--notched .mdc-notched-outline__notch{border-top:none;padding-left:0;padding-right:8px}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}.mdc-select{display:inline-flex;position:relative}.mdc-select:not(.mdc-select--disabled) .mdc-select__selected-text{color:#000000de}.mdc-select.mdc-select--disabled .mdc-select__selected-text{color:#00000061}.mdc-select:not(.mdc-select--disabled) .mdc-floating-label{color:#0009}.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label{color:#6200eede}.mdc-select.mdc-select--disabled .mdc-floating-label{color:#00000061}.mdc-select:not(.mdc-select--disabled) .mdc-select__dropdown-icon{fill:#0000008a}.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-select__dropdown-icon{fill:var(--mdc-theme-primary,#6200ee)}.mdc-select.mdc-select--disabled .mdc-select__dropdown-icon{fill:#00000061}.mdc-select:not(.mdc-select--disabled)+.mdc-select-helper-text{color:#0009}.mdc-select.mdc-select--disabled+.mdc-select-helper-text{color:#00000061}.mdc-select:not(.mdc-select--disabled) .mdc-select__icon{color:#0000008a}.mdc-select.mdc-select--disabled .mdc-select__icon{color:#00000061}@media screen and (-ms-high-contrast:active){.mdc-select.mdc-select--disabled .mdc-select__selected-text{color:graytext}.mdc-select.mdc-select--disabled .mdc-select__dropdown-icon{fill:red}.mdc-select.mdc-select--disabled .mdc-floating-label{color:graytext}.mdc-select.mdc-select--disabled .mdc-line-ripple:before{border-bottom-color:graytext}.mdc-select.mdc-select--disabled .mdc-notched-outline__leading,.mdc-select.mdc-select--disabled .mdc-notched-outline__notch,.mdc-select.mdc-select--disabled .mdc-notched-outline__trailing{border-color:graytext}.mdc-select.mdc-select--disabled .mdc-select__icon,.mdc-select.mdc-select--disabled+.mdc-select-helper-text{color:graytext}}.mdc-select .mdc-floating-label{pointer-events:none;top:50%;transform:translateY(-50%)}.mdc-select .mdc-select__anchor{padding-left:16px;padding-right:0}[dir=rtl] .mdc-select .mdc-select__anchor,.mdc-select .mdc-select__anchor[dir=rtl]{padding-left:0;padding-right:16px}.mdc-select.mdc-select--with-leading-icon .mdc-select__anchor,[dir=rtl] .mdc-select.mdc-select--with-leading-icon .mdc-select__anchor,.mdc-select.mdc-select--with-leading-icon .mdc-select__anchor[dir=rtl]{padding-left:0;padding-right:0}.mdc-select .mdc-select__icon{width:24px;height:24px;font-size:24px}.mdc-select .mdc-select__dropdown-icon{width:24px;height:24px}.mdc-select .mdc-select__menu .mdc-deprecated-list-item,[dir=rtl] .mdc-select .mdc-select__menu .mdc-deprecated-list-item,.mdc-select .mdc-select__menu .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic{margin-left:0;margin-right:12px}[dir=rtl] .mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic,.mdc-select .mdc-select__menu .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:12px;margin-right:0}.mdc-select__dropdown-icon{pointer-events:none;flex-shrink:0;justify-content:center;align-self:center;align-items:center;margin-left:12px;margin-right:12px;display:inline-flex;position:relative}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-active,.mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{position:absolute;top:0;left:0}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-graphic{width:41.6667%;height:20.8333%}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{opacity:1;transition:opacity 75ms linear 75ms}.mdc-select__dropdown-icon .mdc-select__dropdown-icon-active{opacity:0;transition:opacity 75ms linear}[dir=rtl] .mdc-select__dropdown-icon,.mdc-select__dropdown-icon[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select--activated .mdc-select__dropdown-icon .mdc-select__dropdown-icon-inactive{opacity:0;transition:opacity 49.5ms linear}.mdc-select--activated .mdc-select__dropdown-icon .mdc-select__dropdown-icon-active{opacity:1;transition:opacity .1005s linear 49.5ms}.mdc-select__anchor{box-sizing:border-box;cursor:pointer;outline:none;flex:auto;width:200px;min-width:0;position:relative;overflow:hidden}.mdc-select__anchor .mdc-floating-label--float-above{transform:translateY(-106%)scale(.75)}.mdc-select__selected-text-container{appearance:none;pointer-events:none;box-sizing:border-box;color:inherit;background-color:#0000;border:none;outline:none;flex-grow:1;width:auto;min-width:0;height:28px;padding:0;display:flex}.mdc-select__selected-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;text-align:left;width:100%;display:block;overflow:hidden}[dir=rtl] .mdc-select__selected-text,.mdc-select__selected-text[dir=rtl]{text-align:right}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-floating-label,.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label,.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--invalid+.mdc-select-helper-text--validation-msg{color:var(--mdc-theme-error,#b00020)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-select__dropdown-icon,.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-select__dropdown-icon{fill:var(--mdc-theme-error,#b00020)}.mdc-select--disabled{cursor:default;pointer-events:none}.mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item,[dir=rtl] .mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item,.mdc-select--with-leading-icon .mdc-select__menu .mdc-deprecated-list-item[dir=rtl]{padding-left:12px;padding-right:12px}.mdc-select__menu .mdc-deprecated-list .mdc-select__icon,[dir=rtl] .mdc-select__menu .mdc-deprecated-list .mdc-select__icon,.mdc-select__menu .mdc-deprecated-list .mdc-select__icon[dir=rtl]{margin-left:0;margin-right:0}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--activated,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__graphic,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:var(--mdc-theme-on-surface,#000)}.mdc-select--filled .mdc-select__anchor{align-items:baseline;height:56px;display:flex}.mdc-select--filled .mdc-select__anchor:before{content:\"\";vertical-align:0;width:0;height:40px;display:inline-block}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor .mdc-select__selected-text:before{content:\"​\"}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor .mdc-select__selected-text-container{align-items:center;height:100%;display:inline-flex}.mdc-select--filled.mdc-select--no-label .mdc-select__anchor:before{display:none}.mdc-select--filled .mdc-select__anchor{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:0;border-bottom-left-radius:0}.mdc-select--filled:not(.mdc-select--disabled) .mdc-select__anchor{background-color:#f5f5f5}.mdc-select--filled.mdc-select--disabled .mdc-select__anchor{background-color:#fafafa}.mdc-select--filled:not(.mdc-select--disabled) .mdc-line-ripple:before{border-bottom-color:#0000006b}.mdc-select--filled:not(.mdc-select--disabled):hover .mdc-line-ripple:before{border-bottom-color:#000000de}.mdc-select--filled:not(.mdc-select--disabled) .mdc-line-ripple:after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary,#6200ee)}.mdc-select--filled.mdc-select--disabled .mdc-line-ripple:before{border-bottom-color:#0000000f}.mdc-select--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-select--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 85.3333px)}.mdc-select--filled .mdc-menu-surface--is-open-below{border-top-left-radius:0;border-top-right-radius:0}.mdc-select--filled.mdc-select--focused.mdc-line-ripple:after{opacity:1;transform:scaleY(2)}.mdc-select--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-select--filled .mdc-floating-label,.mdc-select--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label{left:48px;right:initial}[dir=rtl] .mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label,.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-select--filled.mdc-select--with-leading-icon .mdc-floating-label--float-above{max-width:calc(133.333% - 128px)}.mdc-select--invalid:not(.mdc-select--disabled) .mdc-line-ripple:before,.mdc-select--invalid:not(.mdc-select--disabled):hover .mdc-line-ripple:before,.mdc-select--invalid:not(.mdc-select--disabled) .mdc-line-ripple:after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error,#b00020)}.mdc-select--outlined{border:none}.mdc-select--outlined .mdc-select__anchor{height:56px}@keyframes mdc-floating-label-shake-float-above-select-outlined-56px{0%{transform:translate(0)translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-34.75px)scale(.75)}to{transform:translate(0)translateY(-34.75px)scale(.75)}}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}[dir=rtl] .mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}@supports (top:max(0%)){.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px,var(--mdc-shape-small,4px))}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px,var(--mdc-shape-small,4px))*2)}}.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}[dir=rtl] .mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-select--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}@supports (top:max(0%)){.mdc-select--outlined .mdc-select__anchor{padding-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}[dir=rtl] .mdc-select--outlined .mdc-select__anchor,.mdc-select--outlined .mdc-select__anchor[dir=rtl]{padding-left:0}@supports (top:max(0%)){[dir=rtl] .mdc-select--outlined .mdc-select__anchor,.mdc-select--outlined .mdc-select__anchor[dir=rtl]{padding-right:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}.mdc-select--outlined+.mdc-select-helper-text{margin-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}[dir=rtl] .mdc-select--outlined+.mdc-select-helper-text,.mdc-select--outlined+.mdc-select-helper-text[dir=rtl]{margin-left:0}@supports (top:max(0%)){[dir=rtl] .mdc-select--outlined+.mdc-select-helper-text,.mdc-select--outlined+.mdc-select-helper-text[dir=rtl]{margin-right:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}.mdc-select--outlined:not(.mdc-select--disabled) .mdc-select__anchor,.mdc-select--outlined.mdc-select--disabled .mdc-select__anchor{background-color:#0000}.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:#00000061}.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#000000de}.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-width:2px;border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--disabled .mdc-notched-outline__trailing{border-color:#0000000f}.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-select--outlined .mdc-select__anchor{align-items:baseline;display:flex;overflow:visible}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined}.mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-37.25px)scale(1)}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-34.75px)scale(.75)}.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-select--outlined .mdc-select__anchor .mdc-select__selected-text:before{content:\"​\"}.mdc-select--outlined .mdc-select__anchor .mdc-select__selected-text-container{align-items:center;height:100%;display:inline-flex}.mdc-select--outlined .mdc-select__anchor:before{display:none}.mdc-select--outlined .mdc-select__selected-text-container{z-index:1;background-color:#0000;border:none;display:flex}.mdc-select--outlined .mdc-select__icon{z-index:2}.mdc-select--outlined .mdc-floating-label{left:4px;right:initial;line-height:1.15rem}[dir=rtl] .mdc-select--outlined .mdc-floating-label,.mdc-select--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-select--outlined.mdc-select--focused .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__trailing,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled):not(.mdc-select--focused) .mdc-select__anchor:hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error,#b00020)}.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__leading,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__notch,.mdc-select--outlined.mdc-select--invalid:not(.mdc-select--disabled).mdc-select--focused .mdc-notched-outline .mdc-notched-outline__trailing{border-width:2px;border-color:#b00020;border-color:var(--mdc-theme-error,#b00020)}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above{transform:translateY(-37.25px)translate(-32px)scale(1)}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px)translate(32px)scale(1)}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--float-above{font-size:.75rem}.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px)translate(-32px)scale(.75)}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px)translate(32px)scale(.75)}.mdc-select--outlined.mdc-select--with-leading-icon.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined.mdc-select--with-leading-icon .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px}@keyframes mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px{0%{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% - 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(-4% - 32px))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}}[dir=rtl] .mdc-select--outlined.mdc-select--with-leading-icon .mdc-floating-label--shake,.mdc-select--outlined.mdc-select--with-leading-icon[dir=rtl] .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px}@keyframes mdc-floating-label-shake-float-above-select-outlined-leading-icon-56px-rtl{0%{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% + 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(32px - 4%))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}}.mdc-select--outlined.mdc-select--with-leading-icon .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 96px)}.mdc-select--outlined .mdc-menu-surface{margin-bottom:8px}.mdc-select--outlined.mdc-select--no-label .mdc-menu-surface,.mdc-select--outlined .mdc-menu-surface--is-open-below{margin-bottom:0}.mdc-select__anchor{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-select__anchor .mdc-select__ripple:before,.mdc-select__anchor .mdc-select__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-select__anchor .mdc-select__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-select__anchor .mdc-select__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-select__anchor.mdc-ripple-upgraded--unbounded .mdc-select__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-select__anchor.mdc-ripple-upgraded--foreground-activation .mdc-select__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-select__anchor.mdc-ripple-upgraded--foreground-deactivation .mdc-select__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-select__anchor .mdc-select__ripple:before,.mdc-select__anchor .mdc-select__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-select__anchor.mdc-ripple-upgraded .mdc-select__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-select__anchor .mdc-select__ripple:before,.mdc-select__anchor .mdc-select__ripple:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-select__anchor:hover .mdc-select__ripple:before,.mdc-select__anchor.mdc-ripple-surface--hover .mdc-select__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-select__anchor.mdc-ripple-upgraded--background-focused .mdc-select__ripple:before,.mdc-select__anchor:not(.mdc-ripple-upgraded):focus .mdc-select__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-select__anchor .mdc-select__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:hover .mdc-deprecated-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:hover .mdc-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-select__menu .mdc-deprecated-list .mdc-deprecated-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-select-helper-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);margin:0 16px;line-height:normal;display:block}[dir=rtl] .mdc-select-helper-text,.mdc-select-helper-text[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-select-helper-text:before{content:\"\";vertical-align:0;width:0;height:16px;display:inline-block}.mdc-select-helper-text--validation-msg{opacity:0;transition:opacity .18s cubic-bezier(.4,0,.2,1)}.mdc-select--invalid+.mdc-select-helper-text--validation-msg,.mdc-select-helper-text--validation-msg-persistent{opacity:1}.mdc-select--with-leading-icon .mdc-select__icon{box-sizing:border-box;cursor:pointer;-webkit-user-select:none;user-select:none;fill:currentColor;background-color:#0000;border:none;flex-shrink:0;align-self:center;margin-left:12px;margin-right:12px;text-decoration:none;display:inline-block}[dir=rtl] .mdc-select--with-leading-icon .mdc-select__icon,.mdc-select--with-leading-icon .mdc-select__icon[dir=rtl]{margin-left:12px;margin-right:12px}.mdc-select__icon:not([tabindex]),.mdc-select__icon[tabindex=\"-1\"]{cursor:default;pointer-events:none}.mdc-data-table__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit)}.mdc-data-table{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-radius:4px;border-radius:var(--mdc-shape-medium,4px);-webkit-overflow-scrolling:touch;box-sizing:border-box;border:1px solid #0000001f;flex-direction:column;display:inline-flex;position:relative}.mdc-data-table .mdc-data-table__header-cell:first-child{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium,4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:first-child,.mdc-data-table .mdc-data-table__header-cell:first-child[dir=rtl]{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium,4px);border-top-left-radius:0}.mdc-data-table .mdc-data-table__header-cell:last-child{border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-medium,4px)}[dir=rtl] .mdc-data-table .mdc-data-table__header-cell:last-child,.mdc-data-table .mdc-data-table__header-cell:last-child[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-medium,4px);border-top-right-radius:0}.mdc-data-table__row{background-color:inherit}.mdc-data-table__header-cell{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-data-table__row--selected{background-color:#6200ee0a}.mdc-data-table__header-cell:after{border-bottom-color:#0000001f}.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__leading,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__notch,.mdc-data-table__pagination-rows-per-page-select:not(.mdc-select--disabled) .mdc-notched-outline__trailing{border-color:#0000001f}.mdc-data-table__row,.mdc-data-table__pagination{border-top-color:#0000001f}.mdc-data-table__header-cell:after{border-bottom-style:solid;border-bottom-width:1px}.mdc-data-table__row,.mdc-data-table__pagination{border-top-style:solid;border-top-width:1px}.mdc-data-table__row:not(.mdc-data-table__row--selected):hover{background-color:#0000000a}.mdc-data-table__header-cell,.mdc-data-table__pagination-total,.mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__cell{color:#000000de}.mdc-data-table__cell{height:52px}.mdc-data-table__pagination{min-height:52px}.mdc-data-table__header-cell{height:56px}.mdc-data-table__cell,.mdc-data-table__header-cell{padding-left:16px;padding-right:16px}.mdc-data-table__header-cell--checkbox,.mdc-data-table__cell--checkbox{padding-left:4px;padding-right:0}[dir=rtl] .mdc-data-table__header-cell--checkbox,.mdc-data-table__header-cell--checkbox[dir=rtl],[dir=rtl] .mdc-data-table__cell--checkbox,.mdc-data-table__cell--checkbox[dir=rtl]{padding-left:0;padding-right:4px}.mdc-data-table__sort-icon-button{color:#0009}.mdc-data-table__sort-icon-button:before,.mdc-data-table__sort-icon-button:after{background-color:#0009;background-color:var(--mdc-ripple-color,#0009)}.mdc-data-table__sort-icon-button:hover:before,.mdc-data-table__sort-icon-button.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused:before,.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{color:#000000de}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:hover:before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded--background-focused:before,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-data-table__table-container{-webkit-overflow-scrolling:touch;width:100%;overflow-x:auto}.mdc-data-table__table{white-space:nowrap;border-collapse:collapse;table-layout:fixed;border:0;min-width:100%}.mdc-data-table__cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;text-align:left;text-overflow:ellipsis;overflow:hidden}[dir=rtl] .mdc-data-table__cell,.mdc-data-table__cell[dir=rtl],.mdc-data-table__cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__cell--numeric,.mdc-data-table__cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__cell--checkbox{width:1px}.mdc-data-table__header-cell{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit);box-sizing:border-box;text-overflow:ellipsis;text-align:left;outline:none;overflow:hidden}[dir=rtl] .mdc-data-table__header-cell,.mdc-data-table__header-cell[dir=rtl]{text-align:right}.mdc-data-table__header-cell--checkbox{width:1px}.mdc-data-table__header-cell--numeric{text-align:right}[dir=rtl] .mdc-data-table__header-cell--numeric,.mdc-data-table__header-cell--numeric[dir=rtl]{text-align:left}.mdc-data-table__sort-icon-button{opacity:0;width:28px;height:28px;margin-left:4px;margin-right:0;padding:2px;transition:transform .15s cubic-bezier(.4,0,.2,1);transform:rotate(.0001deg)}[dir=rtl] .mdc-data-table__sort-icon-button,.mdc-data-table__sort-icon-button[dir=rtl],.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--numeric .mdc-data-table__sort-icon-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__header-cell--sorted-descending .mdc-data-table__sort-icon-button{transform:rotate(-180deg)}.mdc-data-table__sort-icon-button:focus,.mdc-data-table__header-cell:hover .mdc-data-table__sort-icon-button,.mdc-data-table__header-cell--sorted .mdc-data-table__sort-icon-button{opacity:1}.mdc-data-table__header-cell-wrapper{vertical-align:middle;align-items:center;display:inline-flex}.mdc-data-table__header-cell--with-sort{cursor:pointer}.mdc-data-table__sort-status-label{clip:rect(1px,1px,1px,1px);white-space:nowrap;width:1px;height:1px;position:absolute;overflow:hidden}.mdc-data-table__progress-indicator{width:100%;display:none;position:absolute}.mdc-data-table--in-progress .mdc-data-table__progress-indicator{display:block}.mdc-data-table__scrim{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);opacity:.32;width:100%;height:100%;position:absolute;top:0}.mdc-data-table--sticky-header .mdc-data-table__header-cell{z-index:1;position:sticky;top:0}.mdc-data-table--sticky-header .mdc-data-table__header-cell:after{content:\"\";width:100%;position:absolute;bottom:0;left:0}.mdc-data-table--sticky-header .mdc-data-table__row:first-child{border-top:0}.mdc-data-table__pagination{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;justify-content:flex-end;display:flex}.mdc-data-table__pagination-trailing{flex-wrap:wrap;justify-content:flex-end;align-items:center;margin-left:4px;margin-right:0;display:flex}[dir=rtl] .mdc-data-table__pagination-trailing,.mdc-data-table__pagination-trailing[dir=rtl]{margin-left:0;margin-right:4px}.mdc-data-table__pagination-navigation{align-items:center;display:flex}.mdc-data-table__pagination-button{margin-left:0;margin-right:4px}[dir=rtl] .mdc-data-table__pagination-button .mdc-button__icon,.mdc-data-table__pagination-button .mdc-button__icon[dir=rtl]{transform:rotate(180deg)}[dir=rtl] .mdc-data-table__pagination-button,.mdc-data-table__pagination-button[dir=rtl]{margin-left:4px;margin-right:0}.mdc-data-table__pagination-total{white-space:nowrap;margin-left:14px;margin-right:36px}[dir=rtl] .mdc-data-table__pagination-total,.mdc-data-table__pagination-total[dir=rtl]{margin-left:36px;margin-right:14px}.mdc-data-table__pagination-rows-per-page{align-items:center;margin-left:0;margin-right:22px;display:inline-flex}[dir=rtl] .mdc-data-table__pagination-rows-per-page,.mdc-data-table__pagination-rows-per-page[dir=rtl]{margin-left:22px;margin-right:0}.mdc-data-table__pagination-rows-per-page-label{white-space:nowrap;margin-left:0;margin-right:12px}[dir=rtl] .mdc-data-table__pagination-rows-per-page-label,.mdc-data-table__pagination-rows-per-page-label[dir=rtl]{margin-left:12px;margin-right:0}.mdc-data-table__pagination-rows-per-page-select{min-width:var(--mdc-menu-min-width,80px);min-width:80px;margin:8px 0}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor{width:100%;min-width:80px;height:36px}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-27.25px)scale(1)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-24.75px)scale(.75)}.mdc-data-table__pagination-rows-per-page-select .mdc-select__anchor .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-select-outlined-36px}@keyframes mdc-floating-label-shake-float-above-select-outlined-36px{0%{transform:translate(0)translateY(-24.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-24.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-24.75px)scale(.75)}to{transform:translate(0)translateY(-24.75px)scale(.75)}}.mdc-data-table__pagination-rows-per-page-select .mdc-select__dropdown-icon{width:20px;height:20px}.mdc-data-table__pagination-rows-per-page-select.mdc-select--outlined .mdc-select__anchor :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 56px)}.mdc-data-table__pagination-rows-per-page-select .mdc-deprecated-list-item{height:36px}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple:after{transition:opacity .15s linear}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-data-table__header-row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded,.mdc-data-table__row-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__header-row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:after,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:before,.mdc-data-table__row-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-data-table__row-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee))}@keyframes mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE{0%{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}50%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE{0%,80%{border-color:#6200ee;border-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee));background-color:#6200ee;background-color:var(--mdc-checkbox-checked-color,var(--mdc-theme-secondary,#6200ee))}to{border-color:#0000008a;border-color:var(--mdc-checkbox-unchecked-color,#0000008a);background-color:#0000}}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF6200EE00000000FF6200EE}.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__header-row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-data-table__row-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF6200EE00000000FF6200EE}.mdc-dialog,.mdc-dialog__scrim{box-sizing:border-box;justify-content:center;align-items:center;width:100%;height:100%;position:fixed;top:0;left:0}.mdc-dialog{z-index:7;z-index:var(--mdc-dialog-z-index,7);display:none}.mdc-dialog .mdc-dialog__surface{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-dialog .mdc-dialog__scrim,.mdc-dialog .mdc-dialog__surface-scrim{background-color:#00000052}.mdc-dialog .mdc-dialog__title{color:#000000de}.mdc-dialog .mdc-dialog__content{color:#0009}.mdc-dialog .mdc-dialog__close{color:var(--mdc-theme-on-surface,#000)}.mdc-dialog .mdc-dialog__close:before,.mdc-dialog .mdc-dialog__close:after{background-color:#000;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-surface,#000))}.mdc-dialog .mdc-dialog__close:hover:before,.mdc-dialog .mdc-dialog__close.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded--background-focused:before,.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title,.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions,.mdc-dialog.mdc-dialog--scrollable.mdc-dialog-scroll-divider-footer .mdc-dialog__actions{border-color:#0000001f}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:1px solid #0000001f;margin-bottom:0}.mdc-dialog.mdc-dialog-scroll-divider-header.mdc-dialog--fullscreen .mdc-dialog__header{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-dialog .mdc-dialog__content{padding:20px 24px}.mdc-dialog .mdc-dialog__surface{min-width:280px}@media (width<=592px){.mdc-dialog .mdc-dialog__surface{max-width:calc(100vw - 32px)}}@media (width>=592px){.mdc-dialog .mdc-dialog__surface{max-width:560px}}.mdc-dialog .mdc-dialog__surface{border-radius:4px;border-radius:var(--mdc-shape-medium,4px);max-height:calc(100% - 32px)}@media (width<=960px) and (height<=1440px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:560px;max-height:560px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media (width<=720px) and (height<=1023px) and (width<=672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:calc(100vw - 112px)}}@media (width<=720px) and (height<=1023px) and (width>=672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:560px}}@media (width<=720px) and (height<=1023px) and (height<=720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:calc(100vh - 160px)}}@media (width<=720px) and (height<=1023px) and (height>=720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:560px}}@media (width<=720px) and (height<=1023px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media (width<=720px) and (height<=400px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{border-radius:0;width:100vw;max-width:100vw;height:100vh;max-height:100vh}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{justify-content:flex-start;padding:0 16px 9px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:-8px}}@media (width<=600px) and (height<=960px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{border-radius:0;width:100vw;max-width:100vw;height:100vh;max-height:100vh}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{justify-content:flex-start;padding:0 16px 9px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:-8px}}@media (width>=960px) and (height>=1440px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:calc(100vw - 400px)}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}.mdc-dialog.mdc-dialog__scrim--hidden .mdc-dialog__scrim{opacity:0}.mdc-dialog__scrim{opacity:0;z-index:-1}.mdc-dialog__container{box-sizing:border-box;opacity:0;pointer-events:none;flex-direction:row;justify-content:space-around;align-items:center;height:100%;display:flex;transform:scale(.8)}.mdc-dialog__surface{box-sizing:border-box;pointer-events:auto;flex-direction:column;flex-grow:0;flex-shrink:0;max-width:100%;max-height:100%;display:flex;position:relative;overflow-y:auto;box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mdc-dialog__surface .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}[dir=rtl] .mdc-dialog__surface,.mdc-dialog__surface[dir=rtl]{text-align:right}@media screen and (-ms-high-contrast:active){.mdc-dialog__surface{outline:2px solid windowtext}}.mdc-dialog__surface:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:2px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.mdc-dialog__surface:before{content:none}}.mdc-dialog__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;line-height:normal;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit);box-sizing:border-box;flex-shrink:0;margin:0 0 1px;padding:0 24px 9px;display:block;position:relative}.mdc-dialog__title:before{content:\"\";vertical-align:0;width:0;height:40px;display:inline-block}[dir=rtl] .mdc-dialog__title,.mdc-dialog__title[dir=rtl]{text-align:right}.mdc-dialog--scrollable .mdc-dialog__title{margin-bottom:1px;padding-bottom:15px}.mdc-dialog--fullscreen .mdc-dialog__header{border-bottom:1px solid #0000;justify-content:space-between;align-items:baseline;padding:0 24px 9px;display:inline-flex}.mdc-dialog--fullscreen .mdc-dialog__header .mdc-dialog__close{right:-12px}.mdc-dialog--fullscreen .mdc-dialog__title{border-bottom:0;margin-bottom:0;padding:0}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:0;margin-bottom:0}.mdc-dialog--fullscreen .mdc-dialog__close{top:5px}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__actions{border-top:1px solid #0000}.mdc-dialog__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);box-sizing:border-box;-webkit-overflow-scrolling:touch;flex-grow:1;margin:0;overflow:auto}.mdc-dialog__content>:first-child{margin-top:0}.mdc-dialog__content>:last-child{margin-bottom:0}.mdc-dialog__title+.mdc-dialog__content,.mdc-dialog__header+.mdc-dialog__content{padding-top:0}.mdc-dialog--scrollable .mdc-dialog__title+.mdc-dialog__content{padding-top:8px;padding-bottom:8px}.mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:6px 0 0}.mdc-dialog--scrollable .mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:0}.mdc-dialog__actions{box-sizing:border-box;border-top:1px solid #0000;flex-wrap:wrap;flex-shrink:0;justify-content:flex-end;align-items:center;min-height:52px;margin:0;padding:8px;display:flex;position:relative}.mdc-dialog--stacked .mdc-dialog__actions{flex-direction:column;align-items:flex-end}.mdc-dialog__button{text-align:right;max-width:100%;margin-left:8px;margin-right:0}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{margin-left:0;margin-right:8px}.mdc-dialog__button:first-child,[dir=rtl] .mdc-dialog__button:first-child,.mdc-dialog__button:first-child[dir=rtl]{margin-left:0;margin-right:0}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{text-align:left}.mdc-dialog--stacked .mdc-dialog__button:not(:first-child){margin-top:12px}.mdc-dialog--open,.mdc-dialog--opening,.mdc-dialog--closing{display:flex}.mdc-dialog--opening .mdc-dialog__scrim{transition:opacity .15s linear}.mdc-dialog--opening .mdc-dialog__container{transition:opacity 75ms linear,transform .15s cubic-bezier(0,0,.2,1)}.mdc-dialog--closing .mdc-dialog__scrim,.mdc-dialog--closing .mdc-dialog__container{transition:opacity 75ms linear}.mdc-dialog--closing .mdc-dialog__container{transform:none}.mdc-dialog--open .mdc-dialog__scrim{opacity:1}.mdc-dialog--open .mdc-dialog__container{opacity:1;transform:none}.mdc-dialog--open.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim{opacity:1;z-index:1}.mdc-dialog--open.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{transition:opacity 75ms linear}.mdc-dialog--open.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim{transition:opacity .15s linear}.mdc-dialog__surface-scrim{opacity:0;width:100%;height:100%;display:none;position:absolute}.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{display:block}.mdc-dialog-scroll-lock{overflow:hidden}.mdc-drawer{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-top-left-radius:0;border-top-right-radius:0;border-top-right-radius:var(--mdc-shape-large,0);border-bottom-right-radius:0;border-bottom-right-radius:var(--mdc-shape-large,0);z-index:6;box-sizing:border-box;border-color:#0000001f;border-right-style:solid;border-right-width:1px;border-bottom-left-radius:0;flex-direction:column;flex-shrink:0;width:256px;height:100%;transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);display:flex;overflow:hidden}.mdc-drawer .mdc-drawer__title{color:#000000de}.mdc-drawer .mdc-deprecated-list-group__subheader,.mdc-drawer .mdc-drawer__subtitle,.mdc-drawer .mdc-deprecated-list-item__graphic{color:#0009}.mdc-drawer .mdc-deprecated-list-item{color:#000000de}.mdc-drawer .mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:#6200ee}.mdc-drawer .mdc-deprecated-list-item--activated{color:#6200eede}[dir=rtl] .mdc-drawer,.mdc-drawer[dir=rtl]{border-top-left-radius:0;border-top-left-radius:var(--mdc-shape-large,0);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;border-bottom-left-radius:var(--mdc-shape-large,0)}.mdc-drawer .mdc-deprecated-list-item{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content{margin-left:256px;margin-right:0}[dir=rtl] .mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content,.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing)+.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:256px}[dir=rtl] .mdc-drawer,.mdc-drawer[dir=rtl]{border-left-style:solid;border-left-width:1px;border-right-style:none;border-right-width:0}.mdc-drawer .mdc-deprecated-list-item{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit);height:40px;margin:8px;padding:0 8px}.mdc-drawer .mdc-deprecated-list-item:first-child{margin-top:2px}.mdc-drawer .mdc-deprecated-list-item:last-child{margin-bottom:0}.mdc-drawer .mdc-deprecated-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);margin:0;padding:0 16px;line-height:normal;display:block}.mdc-drawer .mdc-deprecated-list-group__subheader:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}.mdc-drawer .mdc-deprecated-list-divider{margin:3px 0 4px}.mdc-drawer .mdc-deprecated-list-item__text,.mdc-drawer .mdc-deprecated-list-item__graphic{pointer-events:none}.mdc-drawer--animate{transform:translate(-100%)}[dir=rtl] .mdc-drawer--animate,.mdc-drawer--animate[dir=rtl]{transform:translate(100%)}.mdc-drawer--opening{transition-duration:.25s;transform:translate(0)}[dir=rtl] .mdc-drawer--opening,.mdc-drawer--opening[dir=rtl]{transform:translate(0)}.mdc-drawer--closing{transition-duration:.2s;transform:translate(-100%)}[dir=rtl] .mdc-drawer--closing,.mdc-drawer--closing[dir=rtl]{transform:translate(100%)}.mdc-drawer__header{box-sizing:border-box;flex-shrink:0;min-height:64px;padding:0 16px 4px}.mdc-drawer__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit);margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-drawer__title:before{content:\"\";vertical-align:0;width:0;height:36px;display:inline-block}.mdc-drawer__title:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-drawer__subtitle{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);margin-top:0;margin-bottom:0;line-height:normal;display:block}.mdc-drawer__subtitle:before{content:\"\";vertical-align:0;width:0;height:20px;display:inline-block}.mdc-drawer__content{-webkit-overflow-scrolling:touch;height:100%;overflow-y:auto}.mdc-drawer--dismissible{left:0;right:initial;display:none;position:absolute}[dir=rtl] .mdc-drawer--dismissible,.mdc-drawer--dismissible[dir=rtl]{left:initial;right:0}.mdc-drawer--dismissible.mdc-drawer--open{display:flex}.mdc-drawer-app-content{margin-left:0;margin-right:0;position:relative}[dir=rtl] .mdc-drawer-app-content,.mdc-drawer-app-content[dir=rtl]{margin-left:0;margin-right:0}.mdc-drawer--modal{left:0;right:initial;display:none;position:fixed;box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mdc-drawer--modal+.mdc-drawer-scrim{background-color:#00000052}[dir=rtl] .mdc-drawer--modal,.mdc-drawer--modal[dir=rtl]{left:initial;right:0}.mdc-drawer--modal.mdc-drawer--open{display:flex}.mdc-drawer-scrim{z-index:5;width:100%;height:100%;transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);display:none;position:fixed;top:0;left:0}.mdc-drawer--open+.mdc-drawer-scrim{display:block}.mdc-drawer--animate+.mdc-drawer-scrim{opacity:0}.mdc-drawer--opening+.mdc-drawer-scrim{opacity:1;transition-duration:.25s}.mdc-drawer--closing+.mdc-drawer-scrim{opacity:0;transition-duration:.2s}.mdc-elevation--z0{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mdc-elevation--z1{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mdc-elevation--z2{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-elevation--z3{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mdc-elevation--z4{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-elevation--z5{box-shadow:0 3px 5px -1px #0003,0 5px 8px #00000024,0 1px 14px #0000001f}.mdc-elevation--z6{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mdc-elevation--z7{box-shadow:0 4px 5px -2px #0003,0 7px 10px 1px #00000024,0 2px 16px 1px #0000001f}.mdc-elevation--z8{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-elevation--z9{box-shadow:0 5px 6px -3px #0003,0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f}.mdc-elevation--z10{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.mdc-elevation--z11{box-shadow:0 6px 7px -4px #0003,0 11px 15px 1px #00000024,0 4px 20px 3px #0000001f}.mdc-elevation--z12{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mdc-elevation--z13{box-shadow:0 7px 8px -4px #0003,0 13px 19px 2px #00000024,0 5px 24px 4px #0000001f}.mdc-elevation--z14{box-shadow:0 7px 9px -4px #0003,0 14px 21px 2px #00000024,0 5px 26px 4px #0000001f}.mdc-elevation--z15{box-shadow:0 8px 9px -5px #0003,0 15px 22px 2px #00000024,0 6px 28px 5px #0000001f}.mdc-elevation--z16{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mdc-elevation--z17{box-shadow:0 8px 11px -5px #0003,0 17px 26px 2px #00000024,0 6px 32px 5px #0000001f}.mdc-elevation--z18{box-shadow:0 9px 11px -5px #0003,0 18px 28px 2px #00000024,0 7px 34px 6px #0000001f}.mdc-elevation--z19{box-shadow:0 9px 12px -6px #0003,0 19px 29px 2px #00000024,0 7px 36px 6px #0000001f}.mdc-elevation--z20{box-shadow:0 10px 13px -6px #0003,0 20px 31px 3px #00000024,0 8px 38px 7px #0000001f}.mdc-elevation--z21{box-shadow:0 10px 13px -6px #0003,0 21px 33px 3px #00000024,0 8px 40px 7px #0000001f}.mdc-elevation--z22{box-shadow:0 10px 14px -6px #0003,0 22px 35px 3px #00000024,0 8px 42px 7px #0000001f}.mdc-elevation--z23{box-shadow:0 11px 14px -7px #0003,0 23px 36px 3px #00000024,0 9px 44px 8px #0000001f}.mdc-elevation--z24{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mdc-elevation-transition{will-change:box-shadow;transition:box-shadow .28s cubic-bezier(.4,0,.2,1)}.mdc-fab{box-sizing:border-box;fill:currentColor;cursor:pointer;-webkit-user-select:none;user-select:none;-webkit-appearance:none;-moz-appearance:none;background-color:#018786;background-color:var(--mdc-theme-secondary,#018786);border:none;justify-content:center;align-items:center;width:56px;height:56px;padding:0;text-decoration:none;transition:box-shadow .28s cubic-bezier(.4,0,.2,1),opacity 15ms linear 30ms,transform .27s cubic-bezier(0,0,.2,1);display:inline-flex;position:relative;overflow:visible;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mdc-fab .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-fab::-moz-focus-inner{border:0;padding:0}.mdc-fab:hover,.mdc-fab.mdc-ripple-upgraded--background-focused,.mdc-fab:not(.mdc-ripple-upgraded):focus{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-fab:active,.mdc-fab:focus:active{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mdc-fab:active,.mdc-fab:focus{outline:none}.mdc-fab:hover{cursor:pointer}.mdc-fab>svg{width:100%}.mdc-fab .mdc-fab__icon{width:24px;height:24px;font-size:24px}.mdc-fab,.mdc-fab:not(:disabled) .mdc-fab__icon,.mdc-fab:not(:disabled) .mdc-fab__label,.mdc-fab:disabled .mdc-fab__icon,.mdc-fab:disabled .mdc-fab__label{color:var(--mdc-theme-on-secondary,#fff)}.mdc-fab:not(.mdc-fab--extended),.mdc-fab:not(.mdc-fab--extended) .mdc-fab__ripple{border-radius:50%}.mdc-fab--mini{width:40px;height:40px}.mdc-fab--extended{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);border-radius:24px;width:auto;max-width:100%;height:48px;padding-left:20px;padding-right:20px;line-height:normal}.mdc-fab--extended .mdc-fab__ripple{border-radius:24px}.mdc-fab--extended .mdc-fab__icon{margin-left:-8px;margin-right:12px}[dir=rtl] .mdc-fab--extended .mdc-fab__icon,.mdc-fab--extended .mdc-fab__icon[dir=rtl],.mdc-fab--extended .mdc-fab__label+.mdc-fab__icon{margin-left:12px;margin-right:-8px}[dir=rtl] .mdc-fab--extended .mdc-fab__label+.mdc-fab__icon,.mdc-fab--extended .mdc-fab__label+.mdc-fab__icon[dir=rtl]{margin-left:-8px;margin-right:12px}.mdc-fab--touch{margin:4px}.mdc-fab--touch .mdc-fab__touch{width:48px;height:48px;position:absolute;top:50%;left:50%;right:0;transform:translate(-50%,-50%)}.mdc-fab:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-fab__label{text-overflow:ellipsis;white-space:nowrap;justify-content:flex-start;overflow:hidden visible}.mdc-fab__icon{fill:currentColor;will-change:transform;transition:transform .18s cubic-bezier(0,0,.2,1) 90ms}.mdc-fab .mdc-fab__icon{justify-content:center;align-items:center;display:inline-flex}.mdc-fab--exited{opacity:0;transition:opacity 15ms linear .15s,transform .18s cubic-bezier(.4,0,1,1);transform:scale(0)}.mdc-fab--exited .mdc-fab__icon{transition:transform .135s cubic-bezier(.4,0,1,1);transform:scale(0)}.mdc-fab{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-fab .mdc-fab__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-fab .mdc-fab__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-fab.mdc-ripple-upgraded .mdc-fab__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-fab.mdc-ripple-upgraded .mdc-fab__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-fab.mdc-ripple-upgraded--unbounded .mdc-fab__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-fab.mdc-ripple-upgraded--foreground-activation .mdc-fab__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-fab.mdc-ripple-upgraded--foreground-deactivation .mdc-fab__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-fab.mdc-ripple-upgraded .mdc-fab__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-secondary,#fff))}.mdc-fab .mdc-fab__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden}.mdc-fab{z-index:0}.mdc-fab .mdc-fab__ripple:before,.mdc-fab .mdc-fab__ripple:after{z-index:-1;z-index:var(--mdc-ripple-z-index,-1)}.mdc-form-field{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);color:var(--mdc-theme-text-primary-on-background,#000000de);vertical-align:middle;align-items:center;display:inline-flex}.mdc-form-field>label{order:0;margin-left:0;margin-right:auto;padding-left:4px;padding-right:0}[dir=rtl] .mdc-form-field>label,.mdc-form-field>label[dir=rtl]{margin-left:auto;margin-right:0;padding-left:0;padding-right:4px}.mdc-form-field--nowrap>label{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-form-field--align-end>label{order:-1;margin-left:auto;margin-right:0;padding-left:0;padding-right:4px}[dir=rtl] .mdc-form-field--align-end>label,.mdc-form-field--align-end>label[dir=rtl]{margin-left:0;margin-right:auto;padding-left:4px;padding-right:0}.mdc-form-field--space-between{justify-content:space-between}.mdc-form-field--space-between>label,[dir=rtl] .mdc-form-field--space-between>label,.mdc-form-field--space-between>label[dir=rtl]{margin:0}.mdc-icon-button{box-sizing:border-box;fill:currentColor;color:inherit;cursor:pointer;-webkit-user-select:none;user-select:none;background-color:#0000;border:none;outline:none;width:48px;height:48px;padding:12px;font-size:24px;text-decoration:none;display:inline-block;position:relative}.mdc-icon-button svg,.mdc-icon-button img{width:24px;height:24px}.mdc-icon-button:disabled{color:var(--mdc-theme-text-disabled-on-light,#00000061);cursor:default;pointer-events:none}.mdc-icon-button__icon{display:inline-block}.mdc-icon-button__icon.mdc-icon-button__icon--on,.mdc-icon-button--on .mdc-icon-button__icon{display:none}.mdc-icon-button--on .mdc-icon-button__icon.mdc-icon-button__icon--on{display:inline-block}.mdc-icon-button{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-icon-button:before,.mdc-icon-button:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-icon-button:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-icon-button:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-icon-button.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-icon-button.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-icon-button.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-icon-button.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-icon-button.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-icon-button:before,.mdc-icon-button:after{width:100%;height:100%;top:0%;left:0%}.mdc-icon-button.mdc-ripple-upgraded:before,.mdc-icon-button.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-icon-button.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-icon-button:before,.mdc-icon-button:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-icon-button:hover:before,.mdc-icon-button.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-icon-button.mdc-ripple-upgraded--background-focused:before,.mdc-icon-button:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-icon-button:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-icon-button:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-icon-button.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-image-list{flex-wrap:wrap;margin:0 auto;padding:0;display:flex}.mdc-image-list__item,.mdc-image-list__image-aspect-container{box-sizing:border-box;position:relative}.mdc-image-list__item{list-style-type:none}.mdc-image-list__image{width:100%}.mdc-image-list__image-aspect-container .mdc-image-list__image{background-position:50%;background-repeat:no-repeat;background-size:cover;height:100%;position:absolute;inset:0}.mdc-image-list__image-aspect-container{padding-bottom:100%}.mdc-image-list__image,.mdc-image-list--with-text-protection .mdc-image-list__supporting{border-radius:0}.mdc-image-list__supporting{color:var(--mdc-theme-text-primary-on-background,#000000de);box-sizing:border-box;justify-content:space-between;align-items:center;padding:8px 0;line-height:24px;display:flex}.mdc-image-list__label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-image-list--with-text-protection .mdc-image-list__supporting{color:#fff;background:#0009;width:100%;height:48px;padding:0 16px;position:absolute;bottom:0}.mdc-image-list--masonry{display:block}.mdc-image-list--masonry .mdc-image-list__item{break-inside:avoid-column}.mdc-image-list--masonry .mdc-image-list__image{height:auto;display:block}:root{--mdc-layout-grid-margin-desktop:24px;--mdc-layout-grid-gutter-desktop:24px;--mdc-layout-grid-column-width-desktop:72px;--mdc-layout-grid-margin-tablet:16px;--mdc-layout-grid-gutter-tablet:16px;--mdc-layout-grid-column-width-tablet:72px;--mdc-layout-grid-margin-phone:16px;--mdc-layout-grid-gutter-phone:16px;--mdc-layout-grid-column-width-phone:72px}@media (width>=840px){.mdc-layout-grid{box-sizing:border-box;padding:24px;padding:var(--mdc-layout-grid-margin-desktop,24px);margin:0 auto}}@media (width>=600px) and (width<=839px){.mdc-layout-grid{box-sizing:border-box;padding:16px;padding:var(--mdc-layout-grid-margin-tablet,16px);margin:0 auto}}@media (width<=599px){.mdc-layout-grid{box-sizing:border-box;padding:16px;padding:var(--mdc-layout-grid-margin-phone,16px);margin:0 auto}}@media (width>=840px){.mdc-layout-grid__inner{margin:-12px;margin:calc(var(--mdc-layout-grid-gutter-desktop,24px)/2*-1);flex-flow:wrap;align-items:stretch;display:flex}@supports (display:grid){.mdc-layout-grid__inner{grid-gap:24px;grid-gap:var(--mdc-layout-grid-gutter-desktop,24px);grid-template-columns:repeat(12,minmax(0,1fr));margin:0;display:grid}}}@media (width>=600px) and (width<=839px){.mdc-layout-grid__inner{margin:-8px;margin:calc(var(--mdc-layout-grid-gutter-tablet,16px)/2*-1);flex-flow:wrap;align-items:stretch;display:flex}@supports (display:grid){.mdc-layout-grid__inner{grid-gap:16px;grid-gap:var(--mdc-layout-grid-gutter-tablet,16px);grid-template-columns:repeat(8,minmax(0,1fr));margin:0;display:grid}}}@media (width<=599px){.mdc-layout-grid__inner{margin:-8px;margin:calc(var(--mdc-layout-grid-gutter-phone,16px)/2*-1);flex-flow:wrap;align-items:stretch;display:flex}@supports (display:grid){.mdc-layout-grid__inner{grid-gap:16px;grid-gap:var(--mdc-layout-grid-gutter-phone,16px);grid-template-columns:repeat(4,minmax(0,1fr));margin:0;display:grid}}}@media (width>=840px){.mdc-layout-grid__cell{width:calc(33.3333% - var(--mdc-layout-grid-gutter-desktop,24px));box-sizing:border-box;margin:12px;margin:calc(var(--mdc-layout-grid-gutter-desktop,24px)/2);width:calc(33.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell{grid-column-end:span 4;width:auto;margin:0}}.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-desktop{width:calc(8.33333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(8.33333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-desktop{grid-column-end:span 1;width:auto}}.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-desktop{width:calc(16.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(16.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-desktop{grid-column-end:span 2;width:auto}}.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-desktop{width:calc(25% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(25% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-desktop{grid-column-end:span 3;width:auto}}.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-desktop{width:calc(33.3333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(33.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-desktop{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-desktop{width:calc(41.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(41.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-desktop{grid-column-end:span 5;width:auto}}.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-desktop{width:calc(50% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(50% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-desktop{grid-column-end:span 6;width:auto}}.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-desktop{width:calc(58.3333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(58.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-desktop{grid-column-end:span 7;width:auto}}.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-desktop{width:calc(66.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(66.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-desktop{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-desktop{width:calc(75% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(75% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-desktop{grid-column-end:span 9;width:auto}}.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-desktop{width:calc(83.3333% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(83.3333% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-desktop{grid-column-end:span 10;width:auto}}.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-desktop{width:calc(91.6667% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(91.6667% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-desktop{grid-column-end:span 11;width:auto}}.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-desktop{width:calc(100% - var(--mdc-layout-grid-gutter-desktop,24px));width:calc(100% - 24px)}@supports (display:grid){.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-desktop{grid-column-end:span 12;width:auto}}}@media (width>=600px) and (width<=839px){.mdc-layout-grid__cell{width:calc(50% - var(--mdc-layout-grid-gutter-tablet,16px));box-sizing:border-box;margin:8px;margin:calc(var(--mdc-layout-grid-gutter-tablet,16px)/2);width:calc(50% - 16px)}@supports (display:grid){.mdc-layout-grid__cell{grid-column-end:span 4;width:auto;margin:0}}.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-tablet{width:calc(12.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(12.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-tablet{grid-column-end:span 1;width:auto}}.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-tablet{width:calc(25% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(25% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-tablet{grid-column-end:span 2;width:auto}}.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-tablet{width:calc(37.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(37.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-tablet{grid-column-end:span 3;width:auto}}.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-tablet{width:calc(50% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(50% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-tablet{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-tablet{width:calc(62.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(62.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-tablet{grid-column-end:span 5;width:auto}}.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-tablet{width:calc(75% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(75% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-tablet{grid-column-end:span 6;width:auto}}.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-tablet{width:calc(87.5% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(87.5% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-tablet{grid-column-end:span 7;width:auto}}.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-tablet{grid-column-end:span 8;width:auto}}.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-tablet{width:calc(100% - var(--mdc-layout-grid-gutter-tablet,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-tablet{grid-column-end:span 8;width:auto}}}@media (width<=599px){.mdc-layout-grid__cell{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));box-sizing:border-box;margin:8px;margin:calc(var(--mdc-layout-grid-gutter-phone,16px)/2);width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell{grid-column-end:span 4;width:auto;margin:0}}.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-phone{width:calc(25% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(25% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-1,.mdc-layout-grid__cell--span-1-phone{grid-column-end:span 1;width:auto}}.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-phone{width:calc(50% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(50% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-2,.mdc-layout-grid__cell--span-2-phone{grid-column-end:span 2;width:auto}}.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-phone{width:calc(75% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(75% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-3,.mdc-layout-grid__cell--span-3-phone{grid-column-end:span 3;width:auto}}.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-4,.mdc-layout-grid__cell--span-4-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-5,.mdc-layout-grid__cell--span-5-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-6,.mdc-layout-grid__cell--span-6-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-7,.mdc-layout-grid__cell--span-7-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-8,.mdc-layout-grid__cell--span-8-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-9,.mdc-layout-grid__cell--span-9-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-10,.mdc-layout-grid__cell--span-10-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-11,.mdc-layout-grid__cell--span-11-phone{grid-column-end:span 4;width:auto}}.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-phone{width:calc(100% - var(--mdc-layout-grid-gutter-phone,16px));width:calc(100% - 16px)}@supports (display:grid){.mdc-layout-grid__cell--span-12,.mdc-layout-grid__cell--span-12-phone{grid-column-end:span 4;width:auto}}}.mdc-layout-grid__cell--order-1{order:1}.mdc-layout-grid__cell--order-2{order:2}.mdc-layout-grid__cell--order-3{order:3}.mdc-layout-grid__cell--order-4{order:4}.mdc-layout-grid__cell--order-5{order:5}.mdc-layout-grid__cell--order-6{order:6}.mdc-layout-grid__cell--order-7{order:7}.mdc-layout-grid__cell--order-8{order:8}.mdc-layout-grid__cell--order-9{order:9}.mdc-layout-grid__cell--order-10{order:10}.mdc-layout-grid__cell--order-11{order:11}.mdc-layout-grid__cell--order-12{order:12}.mdc-layout-grid__cell--align-top{align-self:flex-start}@supports (display:grid){.mdc-layout-grid__cell--align-top{align-self:start}}.mdc-layout-grid__cell--align-middle{align-self:center}.mdc-layout-grid__cell--align-bottom{align-self:flex-end}@supports (display:grid){.mdc-layout-grid__cell--align-bottom{align-self:end}}@media (width>=840px){.mdc-layout-grid--fixed-column-width{width:calc(var(--mdc-layout-grid-column-width-desktop,72px)*12 + var(--mdc-layout-grid-gutter-desktop,24px)*11 + var(--mdc-layout-grid-margin-desktop,24px)*2);width:1176px}}@media (width>=600px) and (width<=839px){.mdc-layout-grid--fixed-column-width{width:calc(var(--mdc-layout-grid-column-width-tablet,72px)*8 + var(--mdc-layout-grid-gutter-tablet,16px)*7 + var(--mdc-layout-grid-margin-tablet,16px)*2);width:720px}}@media (width<=599px){.mdc-layout-grid--fixed-column-width{width:calc(var(--mdc-layout-grid-column-width-phone,72px)*4 + var(--mdc-layout-grid-gutter-phone,16px)*3 + var(--mdc-layout-grid-margin-phone,16px)*2);width:368px}}.mdc-layout-grid--align-left{margin-left:0;margin-right:auto}.mdc-layout-grid--align-right{margin-left:auto;margin-right:0}@keyframes mdc-linear-progress-primary-indeterminate-translate{0%{transform:translate(0)}20%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(0)}59.15%{transform:translate(83.6714%);transform:translateX(var(--mdc-linear-progress-primary-half,83.6714%));animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352)}to{transform:translate(200.611%);transform:translateX(var(--mdc-linear-progress-primary-full,200.611%))}}@keyframes mdc-linear-progress-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.334731,.12482,.785844,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.661479)}to{transform:scaleX(.08)}}@keyframes mdc-linear-progress-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.515058,.409685);transform:translate(0)}25%{transform:translate(37.6519%);transform:translateX(var(--mdc-linear-progress-secondary-quarter,37.6519%));animation-timing-function:cubic-bezier(.31033,.284058,.8,.733712)}48.35%{transform:translate(84.3862%);transform:translateX(var(--mdc-linear-progress-secondary-half,84.3862%));animation-timing-function:cubic-bezier(.4,.627035,.6,.902026)}to{transform:translate(160.278%);transform:translateX(var(--mdc-linear-progress-secondary-full,160.278%))}}@keyframes mdc-linear-progress-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.205028,.057051,.57661,.453971);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.152313,.196432,.648374,1.00432);transform:scaleX(.457104)}44.15%{animation-timing-function:cubic-bezier(.257759,-.003163,.211762,1.38179);transform:scaleX(.72796)}to{transform:scaleX(.08)}}@keyframes mdc-linear-progress-buffering{0%{transform:rotate(180deg)translate(-10px)}}@keyframes mdc-linear-progress-primary-indeterminate-translate-reverse{0%{transform:translate(0)}20%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(0)}59.15%{transform:translate(-83.6714%);transform:translateX(var(--mdc-linear-progress-primary-half-neg,-83.6714%));animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352)}to{transform:translate(-200.611%);transform:translateX(var(--mdc-linear-progress-primary-full-neg,-200.611%))}}@keyframes mdc-linear-progress-secondary-indeterminate-translate-reverse{0%{animation-timing-function:cubic-bezier(.15,0,.515058,.409685);transform:translate(0)}25%{transform:translate(-37.6519%);transform:translateX(var(--mdc-linear-progress-secondary-quarter-neg,-37.6519%));animation-timing-function:cubic-bezier(.31033,.284058,.8,.733712)}48.35%{transform:translate(-84.3862%);transform:translateX(var(--mdc-linear-progress-secondary-half-neg,-84.3862%));animation-timing-function:cubic-bezier(.4,.627035,.6,.902026)}to{transform:translate(-160.278%);transform:translateX(var(--mdc-linear-progress-secondary-full-neg,-160.278%))}}@keyframes mdc-linear-progress-buffering-reverse{0%{transform:translate(-10px)}}.mdc-linear-progress{outline:1px solid #0000;width:100%;height:4px;transition:opacity .25s cubic-bezier(.4,0,.6,1);position:relative;overflow:hidden;transform:translateZ(0)}.mdc-linear-progress__bar{transform-origin:0 0;width:100%;height:100%;transition:transform .25s cubic-bezier(.4,0,.6,1);animation:none;position:absolute}.mdc-linear-progress__bar-inner{border-top:4px solid;width:100%;animation:none;display:inline-block;position:absolute}.mdc-linear-progress__buffer{width:100%;height:100%;display:flex;position:absolute}.mdc-linear-progress__buffer-dots{background-repeat:repeat-x;background-size:10px 4px;flex:auto;animation:.25s linear infinite mdc-linear-progress-buffering;transform:rotate(180deg)}.mdc-linear-progress__buffer-bar{flex:0 100%;transition:flex-basis .25s cubic-bezier(.4,0,.6,1)}.mdc-linear-progress__primary-bar{transform:scaleX(0)}.mdc-linear-progress__secondary-bar{visibility:hidden}.mdc-linear-progress--indeterminate .mdc-linear-progress__bar{transition:none}.mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{left:-145.167%}.mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{visibility:visible;left:-54.8889%}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation:2s linear infinite mdc-linear-progress-primary-indeterminate-translate}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar>.mdc-linear-progress__bar-inner{animation:2s linear infinite mdc-linear-progress-primary-indeterminate-scale}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation:2s linear infinite mdc-linear-progress-secondary-indeterminate-translate}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar>.mdc-linear-progress__bar-inner{animation:2s linear infinite mdc-linear-progress-secondary-indeterminate-scale}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__bar{transform-origin:100%;right:0}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation-name:mdc-linear-progress-primary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation-name:mdc-linear-progress-secondary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__buffer-dots,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__buffer-dots{animation:.25s linear infinite mdc-linear-progress-buffering-reverse;transform:rotate(0)}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{left:auto;right:-145.167%}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{left:auto;right:-54.8889%}.mdc-linear-progress--closed{opacity:0}.mdc-linear-progress--closed-animation-off .mdc-linear-progress__buffer-dots,.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar,.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar .mdc-linear-progress__bar-inner{animation:none}.mdc-linear-progress__bar-inner{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-linear-progress__buffer-dots{background-image:url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E\")}.mdc-linear-progress__buffer-bar{background-color:#e6e6e6}.mdc-deprecated-list{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);color:var(--mdc-theme-text-primary-on-background,#000000de);margin:0;padding:8px 0;line-height:1.5rem;list-style-type:none}.mdc-deprecated-list:focus{outline:none}.mdc-deprecated-list-item{height:48px}.mdc-deprecated-list-item__secondary-text{color:var(--mdc-theme-text-secondary-on-background,#0000008a)}.mdc-deprecated-list-item__graphic{color:var(--mdc-theme-text-icon-on-background,#00000061);background-color:#0000}.mdc-deprecated-list-item__meta{color:var(--mdc-theme-text-hint-on-background,#00000061)}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__text{opacity:.38}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__text,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__secondary-text{color:var(--mdc-theme-on-surface,#000)}.mdc-deprecated-list-item--selected,.mdc-deprecated-list-item--activated,.mdc-deprecated-list-item--selected .mdc-deprecated-list-item__graphic,.mdc-deprecated-list-item--activated .mdc-deprecated-list-item__graphic{color:var(--mdc-theme-primary,#6200ee)}.mdc-deprecated-list--dense{padding-top:4px;padding-bottom:4px;font-size:.812rem}.mdc-deprecated-list-item{justify-content:flex-start;align-items:center;height:48px;padding:0 16px;display:flex;position:relative;overflow:hidden}.mdc-deprecated-list-item:focus{outline:none}.mdc-deprecated-list-item:not(.mdc-deprecated-list-item--selected):focus:before,.mdc-deprecated-list-item.mdc-ripple-upgraded--background-focused:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-deprecated-list-item.mdc-deprecated-list-item--selected:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:3px double #0000;width:100%;height:100%;position:absolute;top:0;left:0}[dir=rtl] .mdc-deprecated-list-item,.mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-item{height:56px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-item,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item{height:56px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-item,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item{height:56px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--image-list .mdc-deprecated-list-item{height:72px;padding-left:16px;padding-right:16px}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-item,.mdc-deprecated-list--image-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-deprecated-list--video-list .mdc-deprecated-list-item{height:72px;padding-left:0;padding-right:16px}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-item,.mdc-deprecated-list--video-list .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:0}.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic{width:20px;height:20px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list-item__graphic{fill:currentColor;object-fit:cover;flex-shrink:0;justify-content:center;align-items:center;width:24px;height:24px;margin-left:0;margin-right:32px}[dir=rtl] .mdc-deprecated-list-item__graphic,.mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:32px;margin-right:0}.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic{width:24px;height:24px;margin-left:0;margin-right:32px}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:32px;margin-right:0}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__graphic{border-radius:50%;width:40px;height:40px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__graphic{width:40px;height:40px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list--image-list .mdc-deprecated-list-item__graphic{width:56px;height:56px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__graphic{width:100px;height:56px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--video-list .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}.mdc-deprecated-list .mdc-deprecated-list-item__graphic{display:inline-flex}.mdc-deprecated-list-item__meta{margin-left:auto;margin-right:0}.mdc-deprecated-list-item__meta:not(.material-icons){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit)}.mdc-deprecated-list-item[dir=rtl] .mdc-deprecated-list-item__meta,[dir=rtl] .mdc-deprecated-list-item .mdc-deprecated-list-item__meta{margin-left:0;margin-right:auto}.mdc-deprecated-list-item__text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-deprecated-list-item__text[for]{pointer-events:none}.mdc-deprecated-list-item__primary-text{text-overflow:ellipsis;white-space:nowrap;margin-top:0;margin-bottom:-20px;line-height:normal;display:block;overflow:hidden}.mdc-deprecated-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-deprecated-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__primary-text,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__primary-text:before,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-deprecated-list--video-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--image-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item__primary-text:after,.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-deprecated-list-item__secondary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;margin-top:0;line-height:normal;display:block;overflow:hidden}.mdc-deprecated-list-item__secondary-text:before{content:\"\";vertical-align:0;width:0;height:20px;display:inline-block}.mdc-deprecated-list--dense .mdc-deprecated-list-item__secondary-text{font-size:inherit}.mdc-deprecated-list--dense .mdc-deprecated-list-item{height:40px}.mdc-deprecated-list--two-line .mdc-deprecated-list-item__text{align-self:flex-start}.mdc-deprecated-list--two-line .mdc-deprecated-list-item{height:64px}.mdc-deprecated-list--two-line.mdc-deprecated-list--video-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--image-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--avatar-list .mdc-deprecated-list-item,.mdc-deprecated-list--two-line.mdc-deprecated-list--icon-list .mdc-deprecated-list-item{height:72px}.mdc-deprecated-list--two-line.mdc-deprecated-list--icon-list .mdc-deprecated-list-item__graphic{align-self:flex-start;margin-top:16px}.mdc-deprecated-list--two-line.mdc-deprecated-list--dense .mdc-deprecated-list-item,.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item{height:60px}.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic{width:36px;height:36px;margin-left:0;margin-right:16px}[dir=rtl] .mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic,.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:16px;margin-right:0}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item{cursor:pointer}a.mdc-deprecated-list-item{color:inherit;text-decoration:none}.mdc-deprecated-list-divider{border:none;border-bottom:1px solid #0000001f;height:0;margin:0}.mdc-deprecated-list-divider--padded{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list-divider--padded,.mdc-deprecated-list-divider--padded[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list-divider--inset{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list-divider--inset,.mdc-deprecated-list-divider--inset[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list-divider--inset.mdc-deprecated-list-divider--padded{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list-divider--inset.mdc-deprecated-list-divider--padded,.mdc-deprecated-list-divider--inset.mdc-deprecated-list-divider--padded[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--icon-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--avatar-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 72px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 88px);margin-left:72px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:72px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--thumbnail-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 88px);margin-left:88px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:88px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 104px);margin-left:88px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:88px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:calc(100% - 16px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 32px);margin-left:16px;margin-right:0}[dir=rtl] .mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--image-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:16px}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading{width:calc(100% - 116px);margin-left:116px;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading[dir=rtl]{margin-left:0;margin-right:116px}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 16px)}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing{width:calc(100% - 132px);margin-left:116px;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing[dir=rtl]{margin-left:0;margin-right:116px}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding{width:100%;margin-left:0;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--padding[dir=rtl]{margin-left:0;margin-right:0}.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding{width:calc(100% - 16px);margin-left:0;margin-right:0}[dir=rtl] .mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding,.mdc-deprecated-list--video-list .mdc-deprecated-list-divider--inset-leading.mdc-deprecated-list-divider--inset-trailing.mdc-deprecated-list-divider--inset-padding[dir=rtl]{margin-left:0;margin-right:0}.mdc-deprecated-list-group .mdc-deprecated-list{padding:0}.mdc-deprecated-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);margin:.75rem 16px}.mdc-list-item__primary-text{color:var(--mdc-theme-text-primary-on-background,#000000de)}.mdc-list-item__secondary-text{color:var(--mdc-theme-text-secondary-on-background,#0000008a)}.mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--with-trailing-icon .mdc-list-item__end{color:var(--mdc-theme-text-icon-on-background,#00000061);background-color:#0000}.mdc-list-item--with-trailing-meta .mdc-list-item__end{color:var(--mdc-theme-text-hint-on-background,#00000061)}.mdc-list-item--disabled .mdc-list-item__start,.mdc-list-item--disabled .mdc-list-item__content,.mdc-list-item--disabled .mdc-list-item__end{opacity:.38}.mdc-list-item--disabled .mdc-list-item__primary-text,.mdc-list-item--disabled .mdc-list-item__secondary-text,.mdc-list-item--disabled.mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--disabled.mdc-list-item--with-trailing-icon .mdc-list-item__end,.mdc-list-item--disabled.mdc-list-item--with-trailing-meta .mdc-list-item__end{color:var(--mdc-theme-on-surface,#000)}.mdc-list-item--selected .mdc-list-item__primary-text,.mdc-list-item--activated .mdc-list-item__primary-text,.mdc-list-item--selected.mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--activated.mdc-list-item--with-leading-icon .mdc-list-item__start{color:var(--mdc-theme-primary,#6200ee)}.mdc-deprecated-list-group__subheader{color:var(--mdc-theme-text-primary-on-background,#000000de)}@media screen and (-ms-high-contrast:active){.mdc-list-divider:after{content:\"\";border-bottom:1px solid #fff;display:block}}.mdc-list{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);margin:0;padding:8px 0;line-height:1.5rem;list-style-type:none}.mdc-list:focus{outline:none}.mdc-list-item{cursor:pointer;justify-content:flex-start;align-items:stretch;padding:0 16px;display:flex;position:relative;overflow:hidden}.mdc-list-item:focus{outline:none}[dir=rtl] .mdc-list-item,.mdc-list-item[dir=rtl]{padding-left:16px;padding-right:16px}.mdc-list-item.mdc-list-item--with-one-line{height:48px}.mdc-list-item.mdc-list-item--with-two-lines{height:64px}.mdc-list-item.mdc-list-item--with-three-lines{height:88px}.mdc-list-item.mdc-list-item--with-one-line .mdc-list-item__start{align-self:center;margin-top:0}.mdc-list-item.mdc-list-item--with-two-lines .mdc-list-item__start,.mdc-list-item.mdc-list-item--with-three-lines .mdc-list-item__start{align-self:flex-start;margin-top:16px}.mdc-list-item.mdc-list-item--with-one-line .mdc-list-item__end,.mdc-list-item.mdc-list-item--with-two-lines .mdc-list-item__end{align-self:center;margin-top:0}.mdc-list-item.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:16px}.mdc-list-item.mdc-list-item--disabled,.mdc-list-item.mdc-list-item--non-interactive{cursor:auto}.mdc-list-item:not(.mdc-list-item--selected):focus:before,.mdc-list-item.mdc-ripple-upgraded--background-focused:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-list-item.mdc-list-item--selected:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:3px double #0000;width:100%;height:100%;position:absolute;top:0;left:0}a.mdc-list-item{color:inherit;text-decoration:none}.mdc-list-item__start{fill:currentColor;pointer-events:none;flex-shrink:0}.mdc-list-item__end{pointer-events:none;flex-shrink:0}.mdc-list-item__content{text-overflow:ellipsis;white-space:nowrap;pointer-events:none;flex:1;align-self:center;overflow:hidden}.mdc-list-item--with-two-lines .mdc-list-item__content,.mdc-list-item--with-three-lines .mdc-list-item__content{align-self:stretch}.mdc-list-item__content[for]{pointer-events:none}.mdc-list-item__primary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-list-item--with-two-lines .mdc-list-item__primary-text,.mdc-list-item--with-three-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before,.mdc-list-item--with-three-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after,.mdc-list-item--with-three-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item__secondary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;margin-top:0;line-height:normal;display:block;overflow:hidden}.mdc-list-item__secondary-text:before{content:\"\";vertical-align:0;width:0;height:20px;display:inline-block}.mdc-list-item__overline-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-list-item--with-two-lines .mdc-list-item__overline-text,.mdc-list-item--with-three-lines .mdc-list-item__overline-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-two-lines .mdc-list-item__overline-text:before,.mdc-list-item--with-three-lines .mdc-list-item__overline-text:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}.mdc-list-item--with-two-lines .mdc-list-item__overline-text:after,.mdc-list-item--with-three-lines .mdc-list-item__overline-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-avatar.mdc-list-item,.mdc-list-item--with-leading-avatar.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-avatar .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-avatar .mdc-list-item__start,.mdc-list-item--with-leading-avatar .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-avatar .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-avatar.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-avatar.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-avatar .mdc-list-item__start{border-radius:50%}.mdc-list-item--with-leading-icon .mdc-list-item__start{width:24px;height:24px}.mdc-list-item--with-leading-icon.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-icon.mdc-list-item,.mdc-list-item--with-leading-icon.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-icon .mdc-list-item__start{margin-left:16px;margin-right:32px}[dir=rtl] .mdc-list-item--with-leading-icon .mdc-list-item__start,.mdc-list-item--with-leading-icon .mdc-list-item__start[dir=rtl]{margin-left:32px;margin-right:16px}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-icon.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-icon.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-thumbnail.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-thumbnail.mdc-list-item,.mdc-list-item--with-leading-thumbnail.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-thumbnail .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-thumbnail .mdc-list-item__start,.mdc-list-item--with-leading-thumbnail .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-thumbnail .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-thumbnail.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-image.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-image.mdc-list-item,.mdc-list-item--with-leading-image.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-image .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-image .mdc-list-item__start,.mdc-list-item--with-leading-image .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-image .mdc-list-item__start{width:56px;height:56px}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-image.mdc-list-item--with-one-line,.mdc-list-item--with-leading-image.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:8px}.mdc-list-item--with-leading-video.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-video.mdc-list-item,.mdc-list-item--with-leading-video.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-video .mdc-list-item__start{margin-left:0;margin-right:16px}[dir=rtl] .mdc-list-item--with-leading-video .mdc-list-item__start,.mdc-list-item--with-leading-video .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:0}.mdc-list-item--with-leading-video .mdc-list-item__start{width:100px;height:56px}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-video.mdc-list-item--with-one-line,.mdc-list-item--with-leading-video.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-checkbox.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-checkbox.mdc-list-item,.mdc-list-item--with-leading-checkbox.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-checkbox .mdc-list-item__start{margin-left:8px;margin-right:24px}[dir=rtl] .mdc-list-item--with-leading-checkbox .mdc-list-item__start,.mdc-list-item--with-leading-checkbox .mdc-list-item__start[dir=rtl]{margin-left:24px;margin-right:8px}.mdc-list-item--with-leading-checkbox .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:8px}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-checkbox.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-radio.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-radio.mdc-list-item,.mdc-list-item--with-leading-radio.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-radio .mdc-list-item__start{margin-left:8px;margin-right:24px}[dir=rtl] .mdc-list-item--with-leading-radio .mdc-list-item__start,.mdc-list-item--with-leading-radio .mdc-list-item__start[dir=rtl]{margin-left:24px;margin-right:8px}.mdc-list-item--with-leading-radio .mdc-list-item__start{width:40px;height:40px}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:8px}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-radio.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-radio.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-leading-switch.mdc-list-item{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-item--with-leading-switch.mdc-list-item,.mdc-list-item--with-leading-switch.mdc-list-item[dir=rtl]{padding-left:auto;padding-right:0}.mdc-list-item--with-leading-switch .mdc-list-item__start,[dir=rtl] .mdc-list-item--with-leading-switch .mdc-list-item__start,.mdc-list-item--with-leading-switch .mdc-list-item__start[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-leading-switch .mdc-list-item__start{width:36px;height:20px}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__start{align-self:flex-start;margin-top:16px}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__primary-text{margin-top:0;margin-bottom:-20px;line-height:normal;display:block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__primary-text:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines .mdc-list-item__primary-text:after{content:\"\";vertical-align:-20px;width:0;height:20px;display:inline-block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines.mdc-list-item--with-trailing-meta .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:32px;display:inline-block}.mdc-list-item--with-leading-switch.mdc-list-item--with-one-line{height:56px}.mdc-list-item--with-leading-switch.mdc-list-item--with-two-lines{height:72px}.mdc-list-item--with-trailing-icon.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-icon.mdc-list-item,.mdc-list-item--with-trailing-icon.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-icon .mdc-list-item__end,[dir=rtl] .mdc-list-item--with-trailing-icon .mdc-list-item__end,.mdc-list-item--with-trailing-icon .mdc-list-item__end[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-trailing-icon .mdc-list-item__end{width:24px;height:24px}.mdc-list-item--with-trailing-meta.mdc-list-item--with-two-lines .mdc-list-item__end,.mdc-list-item--with-trailing-meta.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:0}.mdc-list-item--with-trailing-meta.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-meta.mdc-list-item,.mdc-list-item--with-trailing-meta.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-meta .mdc-list-item__end{margin-left:28px;margin-right:16px}[dir=rtl] .mdc-list-item--with-trailing-meta .mdc-list-item__end,.mdc-list-item--with-trailing-meta .mdc-list-item__end[dir=rtl]{margin-left:16px;margin-right:28px}.mdc-list-item--with-trailing-meta.mdc-list-item--with-two-lines .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-trailing-meta.mdc-list-item--with-two-lines .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-list-item--with-trailing-meta.mdc-list-item--with-three-lines .mdc-list-item__end{margin-top:0;line-height:normal;display:block}.mdc-list-item--with-trailing-meta.mdc-list-item--with-three-lines .mdc-list-item__end:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-list-item--with-trailing-meta .mdc-list-item__end{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit)}.mdc-list-item--with-trailing-checkbox.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-checkbox.mdc-list-item,.mdc-list-item--with-trailing-checkbox.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-checkbox .mdc-list-item__end{margin-left:24px;margin-right:8px}[dir=rtl] .mdc-list-item--with-trailing-checkbox .mdc-list-item__end,.mdc-list-item--with-trailing-checkbox .mdc-list-item__end[dir=rtl]{margin-left:8px;margin-right:24px}.mdc-list-item--with-trailing-checkbox .mdc-list-item__end{width:40px;height:40px}.mdc-list-item--with-trailing-checkbox.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:8px}.mdc-list-item--with-trailing-radio.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-radio.mdc-list-item,.mdc-list-item--with-trailing-radio.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-radio .mdc-list-item__end{margin-left:24px;margin-right:8px}[dir=rtl] .mdc-list-item--with-trailing-radio .mdc-list-item__end,.mdc-list-item--with-trailing-radio .mdc-list-item__end[dir=rtl]{margin-left:8px;margin-right:24px}.mdc-list-item--with-trailing-radio .mdc-list-item__end{width:40px;height:40px}.mdc-list-item--with-trailing-radio.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:8px}.mdc-list-item--with-trailing-switch.mdc-list-item{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-item--with-trailing-switch.mdc-list-item,.mdc-list-item--with-trailing-switch.mdc-list-item[dir=rtl]{padding-left:0;padding-right:auto}.mdc-list-item--with-trailing-switch .mdc-list-item__end,[dir=rtl] .mdc-list-item--with-trailing-switch .mdc-list-item__end,.mdc-list-item--with-trailing-switch .mdc-list-item__end[dir=rtl]{margin-left:16px;margin-right:16px}.mdc-list-item--with-trailing-switch .mdc-list-item__end{width:36px;height:20px}.mdc-list-item--with-trailing-switch.mdc-list-item--with-three-lines .mdc-list-item__end{align-self:flex-start;margin-top:16px}.mdc-list-group .mdc-deprecated-list{padding:0}.mdc-list-group__subheader{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);margin:.75rem 16px}.mdc-list-divider{background-color:#0000001f;background-clip:content-box;height:1px;padding:0}.mdc-list-divider.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-leading-inset{padding-left:16px;padding-right:auto}[dir=rtl] .mdc-list-divider.mdc-list-divider--with-leading-inset,.mdc-list-divider.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-text.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-icon.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-image.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-avatar.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-switch.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-leading-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-radio.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-leading-inset[dir=rtl],.mdc-list-divider.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-trailing-inset{padding-left:auto;padding-right:16px}[dir=rtl] .mdc-list-divider.mdc-list-divider--with-trailing-inset,.mdc-list-divider.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-text.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-text.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-icon.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-icon.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-image.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-image.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-thumbnail.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-avatar.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-avatar.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-checkbox.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-switch.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-switch.mdc-list-divider--with-trailing-inset[dir=rtl],[dir=rtl] .mdc-list-divider--with-leading-radio.mdc-list-divider--with-trailing-inset,.mdc-list-divider--with-leading-radio.mdc-list-divider--with-trailing-inset[dir=rtl]{padding-left:16px;padding-right:auto}.mdc-list-divider--with-leading-video.mdc-list-divider--with-leading-inset{padding-left:0;padding-right:auto}[dir=rtl] .mdc-list-divider--with-leading-video.mdc-list-divider--with-leading-inset,.mdc-list-divider--with-leading-video.mdc-list-divider--with-leading-inset[dir=rtl]{padding-left:auto;padding-right:0}[dir=rtl] .mdc-list-divider,.mdc-list-divider[dir=rtl]{padding:0}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--unbounded .mdc-deprecated-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-activation .mdc-deprecated-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-deactivation .mdc-deprecated-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:hover .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:hover .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-activated-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-deprecated-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:hover .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.16;opacity:var(--mdc-ripple-hover-opacity,.16)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-activated-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:hover .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.16;opacity:var(--mdc-ripple-hover-opacity,.16)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-deprecated-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:hover .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-deprecated-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-deprecated-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-deprecated-list-item__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-list-item__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:hover .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.2)}:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-deprecated-list-item__ripple,:not(.mdc-deprecated-list-item--disabled).mdc-deprecated-list-item .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-deprecated-list-item--disabled{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--unbounded .mdc-deprecated-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-activation .mdc-deprecated-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-deactivation .mdc-deprecated-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-deprecated-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple:after,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--background-focused .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled:not(.mdc-ripple-upgraded):focus .mdc-deprecated-list-item__ripple:before,.mdc-deprecated-list-item--disabled.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,.mdc-deprecated-list-item--disabled:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-deprecated-list-item--disabled .mdc-deprecated-list-item__ripple,.mdc-deprecated-list-item--disabled .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}:not(.mdc-list-item--disabled).mdc-list-item{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}:not(.mdc-list-item--disabled).mdc-list-item:hover .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-list-item--disabled).mdc-list-item:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-activated-opacity,.12)}:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--activated .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-list-item--disabled).mdc-list-item--activated:hover .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--activated.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.16;opacity:var(--mdc-ripple-hover-opacity,.16)}:not(.mdc-list-item--disabled).mdc-list-item--activated.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--activated:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--activated:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-list-item--disabled).mdc-list-item--activated:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple:before{opacity:.08;opacity:var(--mdc-ripple-selected-opacity,.08)}:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--selected .mdc-list-item__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}:not(.mdc-list-item--disabled).mdc-list-item--selected:hover .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--selected.mdc-ripple-surface--hover .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-hover-opacity,.12)}:not(.mdc-list-item--disabled).mdc-list-item--selected.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,:not(.mdc-list-item--disabled).mdc-list-item--selected:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.2;opacity:var(--mdc-ripple-focus-opacity,.2);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--selected:not(.mdc-ripple-upgraded) .mdc-list-item__ripple:after{transition:opacity .15s linear}:not(.mdc-list-item--disabled).mdc-list-item--selected:not(.mdc-ripple-upgraded):active .mdc-list-item__ripple:after{opacity:.2;opacity:var(--mdc-ripple-press-opacity,.2);transition-duration:75ms}:not(.mdc-list-item--disabled).mdc-list-item--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.2)}:not(.mdc-list-item--disabled).mdc-list-item .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-list-item--disabled{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-list-item--disabled .mdc-list-item__ripple:before,.mdc-list-item--disabled .mdc-list-item__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-list-item--disabled .mdc-list-item__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-list-item--disabled .mdc-list-item__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-list-item--disabled.mdc-ripple-upgraded--unbounded .mdc-list-item__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-list-item--disabled.mdc-ripple-upgraded--foreground-activation .mdc-list-item__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-list-item--disabled.mdc-ripple-upgraded--foreground-deactivation .mdc-list-item__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-list-item--disabled .mdc-list-item__ripple:before,.mdc-list-item--disabled .mdc-list-item__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-list-item--disabled.mdc-ripple-upgraded .mdc-list-item__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-list-item--disabled .mdc-list-item__ripple:before,.mdc-list-item--disabled .mdc-list-item__ripple:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-list-item--disabled.mdc-ripple-upgraded--background-focused .mdc-list-item__ripple:before,.mdc-list-item--disabled:not(.mdc-ripple-upgraded):focus .mdc-list-item__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-list-item--disabled .mdc-list-item__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-menu{min-width:var(--mdc-menu-min-width,112px);min-width:112px}.mdc-menu .mdc-deprecated-list-item__meta,.mdc-menu .mdc-deprecated-list-item__graphic{color:#000000de}.mdc-menu .mdc-deprecated-list{color:#000000de;position:relative}.mdc-menu .mdc-deprecated-list .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-menu .mdc-deprecated-list-divider{margin:8px 0}.mdc-menu .mdc-deprecated-list-item{-webkit-user-select:none;user-select:none}.mdc-menu .mdc-deprecated-list-item--disabled{cursor:auto}.mdc-menu a.mdc-deprecated-list-item .mdc-deprecated-list-item__text,.mdc-menu a.mdc-deprecated-list-item .mdc-deprecated-list-item__graphic{pointer-events:none}.mdc-menu__selection-group{fill:currentColor;padding:0}.mdc-menu__selection-group .mdc-deprecated-list-item{padding-left:56px;padding-right:16px}[dir=rtl] .mdc-menu__selection-group .mdc-deprecated-list-item,.mdc-menu__selection-group .mdc-deprecated-list-item[dir=rtl]{padding-left:16px;padding-right:56px}.mdc-menu__selection-group .mdc-menu__selection-group-icon{left:16px;right:initial;display:none;position:absolute;top:50%;transform:translateY(-50%)}[dir=rtl] .mdc-menu__selection-group .mdc-menu__selection-group-icon,.mdc-menu__selection-group .mdc-menu__selection-group-icon[dir=rtl]{left:initial;right:16px}.mdc-menu-item--selected .mdc-menu__selection-group-icon{display:inline}.mdc-menu-surface{box-sizing:border-box;max-width:var(--mdc-menu-max-width,calc(100vw - 32px));max-height:var(--mdc-menu-max-height,calc(100vh - 32px));transform-origin:0 0;opacity:0;will-change:transform,opacity;z-index:8;background-color:#fff;background-color:var(--mdc-theme-surface,#fff);color:var(--mdc-theme-on-surface,#000);border-radius:4px;border-radius:var(--mdc-shape-medium,4px);transform-origin-left:top left;transform-origin-right:top right;max-width:calc(100vw - 32px);max-height:calc(100vh - 32px);margin:0;padding:0;transition:opacity 30ms linear,transform .12s cubic-bezier(0,0,.2,1),height .25s cubic-bezier(0,0,.2,1);display:none;position:absolute;overflow:auto;transform:scale(1);box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mdc-menu-surface:focus{outline:none}.mdc-menu-surface--open{opacity:1;display:inline-block;transform:scale(1)}.mdc-menu-surface--animating-open{opacity:0;display:inline-block;transform:scale(.8)}.mdc-menu-surface--animating-closed{opacity:0;transition:opacity 75ms linear;display:inline-block}[dir=rtl] .mdc-menu-surface,.mdc-menu-surface[dir=rtl]{transform-origin-left:top right;transform-origin-right:top left}.mdc-menu-surface--anchor{position:relative;overflow:visible}.mdc-menu-surface--fixed{position:fixed}.mdc-menu-surface--fullwidth{width:100%}.mdc-radio{box-sizing:content-box;cursor:pointer;will-change:opacity,transform,border-color,color;flex:none;width:20px;height:20px;padding:10px;display:inline-block;position:relative}.mdc-radio .mdc-radio__native-control:enabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle{border-color:#0000008a}.mdc-radio .mdc-radio__native-control:enabled:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:enabled+.mdc-radio__background .mdc-radio__inner-circle{border-color:#018786;border-color:var(--mdc-theme-secondary,#018786)}.mdc-radio [aria-disabled=true] .mdc-radio__native-control:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control+.mdc-radio__background .mdc-radio__inner-circle,.mdc-radio .mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__inner-circle{border-color:#00000061}.mdc-radio .mdc-radio__background:before{background-color:#018786;background-color:var(--mdc-theme-secondary,#018786);width:40px;height:40px;top:-10px;left:-10px}.mdc-radio .mdc-radio__native-control{width:40px;height:40px;top:0;left:0;right:0}@media screen and (-ms-high-contrast:active){.mdc-radio [aria-disabled=true] .mdc-radio__native-control:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:not(:checked)+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio .mdc-radio__native-control:disabled:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio [aria-disabled=true] .mdc-radio__native-control+.mdc-radio__background .mdc-radio__inner-circle,.mdc-radio .mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__inner-circle{border-color:graytext}}.mdc-radio__background{box-sizing:border-box;width:20px;height:20px;display:inline-block;position:relative}.mdc-radio__background:before{opacity:0;pointer-events:none;content:\"\";border-radius:50%;transition:opacity .12s cubic-bezier(.4,0,.6,1),transform .12s cubic-bezier(.4,0,.6,1);position:absolute;transform:scale(0)}.mdc-radio__outer-circle{box-sizing:border-box;border-style:solid;border-width:2px;border-radius:50%;width:100%;height:100%;transition:border-color .12s cubic-bezier(.4,0,.6,1);position:absolute;top:0;left:0}.mdc-radio__inner-circle{box-sizing:border-box;border-style:solid;border-width:10px;border-radius:50%;width:100%;height:100%;transition:transform .12s cubic-bezier(.4,0,.6,1),border-color .12s cubic-bezier(.4,0,.6,1);position:absolute;top:0;left:0;transform:scale(0)}.mdc-radio__native-control{opacity:0;cursor:inherit;z-index:1;margin:0;padding:0;position:absolute}.mdc-radio--touch{margin:4px}.mdc-radio--touch .mdc-radio__native-control{width:48px;height:48px;top:-4px;left:-4px;right:-4px}.mdc-radio__native-control:checked+.mdc-radio__background,.mdc-radio__native-control:disabled+.mdc-radio__background{transition:opacity .12s cubic-bezier(0,0,.2,1),transform .12s cubic-bezier(0,0,.2,1)}.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__outer-circle,.mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__outer-circle{transition:border-color .12s cubic-bezier(0,0,.2,1)}.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__inner-circle,.mdc-radio__native-control:disabled+.mdc-radio__background .mdc-radio__inner-circle{transition:transform .12s cubic-bezier(0,0,.2,1),border-color .12s cubic-bezier(0,0,.2,1)}.mdc-radio--disabled{cursor:default;pointer-events:none}.mdc-radio__native-control:checked+.mdc-radio__background .mdc-radio__inner-circle{transition:transform .12s cubic-bezier(0,0,.2,1),border-color .12s cubic-bezier(0,0,.2,1);transform:scale(.5)}.mdc-radio__native-control:disabled+.mdc-radio__background,[aria-disabled=true] .mdc-radio__native-control+.mdc-radio__background{cursor:default}.mdc-radio__native-control:focus+.mdc-radio__background:before{opacity:.12;transition:opacity .12s cubic-bezier(0,0,.2,1),transform .12s cubic-bezier(0,0,.2,1);transform:scale(1)}.mdc-radio{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-radio .mdc-radio__ripple:before,.mdc-radio .mdc-radio__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-radio .mdc-radio__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-radio .mdc-radio__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-radio.mdc-ripple-upgraded--unbounded .mdc-radio__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-radio.mdc-ripple-upgraded--foreground-activation .mdc-radio__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-radio.mdc-ripple-upgraded--foreground-deactivation .mdc-radio__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-radio .mdc-radio__ripple:before,.mdc-radio .mdc-radio__ripple:after{width:100%;height:100%;top:0%;left:0%}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:before,.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-radio.mdc-ripple-upgraded .mdc-radio__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-radio .mdc-radio__ripple:before,.mdc-radio .mdc-radio__ripple:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-radio:hover .mdc-radio__ripple:before,.mdc-radio.mdc-ripple-surface--hover .mdc-radio__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-radio.mdc-ripple-upgraded--background-focused .mdc-radio__ripple:before,.mdc-radio:not(.mdc-ripple-upgraded):focus .mdc-radio__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-radio:not(.mdc-ripple-upgraded) .mdc-radio__ripple:after{transition:opacity .15s linear}.mdc-radio:not(.mdc-ripple-upgraded):active .mdc-radio__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-radio.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-radio.mdc-ripple-upgraded .mdc-radio__background:before,.mdc-radio.mdc-ripple-upgraded--background-focused .mdc-radio__background:before{content:none}.mdc-radio__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-ripple-surface{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;outline:none;position:relative;overflow:hidden}.mdc-ripple-surface:before,.mdc-ripple-surface:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-ripple-surface:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-ripple-surface:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-ripple-surface.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-ripple-surface.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-ripple-surface.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-ripple-surface:before,.mdc-ripple-surface:after{background-color:#000;background-color:var(--mdc-ripple-color,#000)}.mdc-ripple-surface:hover:before,.mdc-ripple-surface.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-ripple-surface.mdc-ripple-upgraded--background-focused:before,.mdc-ripple-surface:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-ripple-surface:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-ripple-surface:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-ripple-surface.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-ripple-surface:before,.mdc-ripple-surface:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-ripple-surface.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded],.mdc-ripple-upgraded--unbounded{overflow:visible}.mdc-ripple-surface[data-mdc-ripple-is-unbounded]:before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded]:after,.mdc-ripple-upgraded--unbounded:before,.mdc-ripple-upgraded--unbounded:after{width:100%;height:100%;top:0%;left:0%}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded:before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded:after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded:before,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded:after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-segmented-button{font-size:0;display:inline-block}.mdc-segmented-button__segment{border-color:#0000001f;border-color:var(--mdc-segmented-button-outline-color,#0000001f);color:var(--mdc-segmented-button-unselected-ink-color,#0009);background-color:#fff;background-color:var(--mdc-segmented-button-unselected-container-fill-color,white)}.mdc-segmented-button__segment--selected{color:var(--mdc-segmented-button-selected-ink-color,#6200ee);background-color:#6200ee14;background-color:var(--mdc-segmented-button-selected-container-fill-color,#6200ee14)}.mdc-segmented-button__segment{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);vertical-align:top;border-width:1px 0 1px 1px;align-items:center;min-width:48px;height:36px;padding:0 12px;display:inline-flex;position:relative}.mdc-segmented-button__segment .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-segmented-button__segment:hover{cursor:pointer}.mdc-segmented-button__segment:focus{outline-width:0}.mdc-segmented-button__segment:first-child{border-radius:4px 0 0 4px}.mdc-segmented-button__segment:last-child{border-right-width:1px;border-radius:0 4px 4px 0}.mdc-segmented-button__segment .mdc-segmented-button__segment__touch{height:48px;position:absolute;top:50%;left:0;right:0;transform:translateY(-50%)}.mdc-segmented-button__segment .mdc-segmented-button__segment--touch{margin-top:0;margin-bottom:0}.mdc-touch-target-wrapper .mdc-segmented-button__segment{border-right-width:0;border-radius:0}.mdc-touch-target-wrapper:first-child .mdc-segmented-button__segment{border-radius:4px 0 0 4px}.mdc-touch-target-wrapper:last-child .mdc-segmented-button__segment{border-right-width:1px;border-radius:0 4px 4px 0}.mdc-segmented-button__icon{width:24px;font-size:18px}.mdc-segmented-button__icon+.mdc-segmented-button__label{padding-left:6px}.mdc-segmented-button__segment{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity;overflow:hidden}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-segmented-button__segment.mdc-ripple-upgraded .mdc-segmented-button__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-segmented-button__segment.mdc-ripple-upgraded .mdc-segmented-button__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-segmented-button__segment.mdc-ripple-upgraded--unbounded .mdc-segmented-button__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-segmented-button__segment.mdc-ripple-upgraded--foreground-activation .mdc-segmented-button__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-segmented-button__segment.mdc-ripple-upgraded--foreground-deactivation .mdc-segmented-button__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-segmented-button__segment.mdc-ripple-upgraded .mdc-segmented-button__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-segmented-button__segment .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment .mdc-segmented-button__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,#6200ee)}.mdc-segmented-button__segment:hover .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment.mdc-ripple-surface--hover .mdc-segmented-button__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-segmented-button__segment.mdc-ripple-upgraded--background-focused .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment.mdc-ripple-upgraded:focus-within .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment:not(.mdc-ripple-upgraded):focus .mdc-segmented-button__ripple:before,.mdc-segmented-button__segment:not(.mdc-ripple-upgraded):focus-within .mdc-segmented-button__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-segmented-button__segment:not(.mdc-ripple-upgraded) .mdc-segmented-button__ripple:after{transition:opacity .15s linear}.mdc-segmented-button__segment:not(.mdc-ripple-upgraded):active .mdc-segmented-button__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-segmented-button__segment.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-segmented-button__segment .mdc-segmented-button__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-slider__thumb{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-slider__thumb:before,.mdc-slider__thumb:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-slider__thumb:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-slider__thumb:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-slider__thumb.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-slider__thumb.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-slider__thumb.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-slider__thumb.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-slider__thumb.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-slider__thumb:before,.mdc-slider__thumb:after{width:100%;height:100%;top:0%;left:0%}.mdc-slider__thumb.mdc-ripple-upgraded:before,.mdc-slider__thumb.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-slider__thumb.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-slider__thumb:before,.mdc-slider__thumb:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-slider__thumb:hover:before,.mdc-slider__thumb.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-slider__thumb.mdc-ripple-upgraded--background-focused:before,.mdc-slider__thumb:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-slider__thumb:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-slider__thumb:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-slider__thumb.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-slider{cursor:pointer;touch-action:pan-y;height:48px;margin:0 24px;position:relative}.mdc-slider .mdc-slider__track{width:100%;height:4px;position:absolute;top:50%;transform:translateY(-50%)}.mdc-slider .mdc-slider__track--active,.mdc-slider .mdc-slider__track--inactive{width:100%;height:100%;display:flex;position:absolute}.mdc-slider .mdc-slider__track--active{border-radius:3px;height:6px;top:-1px;overflow:hidden}.mdc-slider .mdc-slider__track--active_fill{box-sizing:border-box;transform-origin:0;border-top:6px solid;width:100%;height:100%;position:relative}[dir=rtl] .mdc-slider .mdc-slider__track--active_fill,.mdc-slider .mdc-slider__track--active_fill[dir=rtl]{transform-origin:100%}.mdc-slider .mdc-slider__track--inactive{border-radius:2px;height:4px;top:0;left:0}.mdc-slider .mdc-slider__track--inactive:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-slider .mdc-slider__track--active_fill{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-slider.mdc-slider--disabled .mdc-slider__track--active_fill{border-color:#000;border-color:var(--mdc-theme-on-surface,#000)}.mdc-slider .mdc-slider__track--inactive{background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);opacity:.24}.mdc-slider.mdc-slider--disabled .mdc-slider__track--inactive{background-color:#000;background-color:var(--mdc-theme-on-surface,#000);opacity:.24}.mdc-slider .mdc-slider__value-indicator-container{pointer-events:none;position:absolute;bottom:44px;left:50%;transform:translate(-50%)}.mdc-slider .mdc-slider__value-indicator{transform-origin:bottom;border-radius:4px;align-items:center;height:32px;padding:0 12px;transition:transform .1s cubic-bezier(.4,0,1,1);display:flex;transform:scale(0)}.mdc-slider .mdc-slider__value-indicator:before{content:\"\";border-top:6px solid;border-left:6px solid #0000;border-right:6px solid #0000;width:0;height:0;position:absolute;bottom:-5px;left:50%;transform:translate(-50%)}.mdc-slider .mdc-slider__value-indicator:after{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-slider .mdc-slider__thumb--with-indicator .mdc-slider__value-indicator-container{pointer-events:auto}.mdc-slider .mdc-slider__thumb--with-indicator .mdc-slider__value-indicator{transition:transform .1s cubic-bezier(0,0,.2,1);transform:scale(1)}@media (prefers-reduced-motion){.mdc-slider .mdc-slider__value-indicator,.mdc-slider .mdc-slider__thumb--with-indicator .mdc-slider__value-indicator{transition:none}}.mdc-slider .mdc-slider__value-indicator-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit)}.mdc-slider .mdc-slider__value-indicator{opacity:.6;background-color:#000}.mdc-slider .mdc-slider__value-indicator:before{border-top-color:#000}.mdc-slider .mdc-slider__value-indicator{color:var(--mdc-theme-on-primary,#fff)}.mdc-slider .mdc-slider__thumb{-webkit-user-select:none;user-select:none;outline:none;width:48px;height:48px;display:flex;position:absolute;left:-24px}.mdc-slider .mdc-slider__thumb--top{z-index:1}.mdc-slider .mdc-slider__thumb--top .mdc-slider__thumb-knob,.mdc-slider .mdc-slider__thumb--top.mdc-slider__thumb:hover .mdc-slider__thumb-knob,.mdc-slider .mdc-slider__thumb--top.mdc-slider__thumb--focused .mdc-slider__thumb-knob{box-sizing:content-box;border:1px solid #fff}.mdc-slider .mdc-slider__thumb-knob{box-sizing:border-box;background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);border:10px solid #6200ee;border-color:var(--mdc-theme-primary,#6200ee);border-radius:50%;width:20px;height:20px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mdc-slider.mdc-slider--disabled .mdc-slider__thumb-knob{background-color:#000;background-color:var(--mdc-theme-on-surface,#000);border-color:#000;border-color:var(--mdc-theme-on-surface,#000)}.mdc-slider .mdc-slider__thumb:before,.mdc-slider .mdc-slider__thumb:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-slider .mdc-slider__thumb:hover:before,.mdc-slider .mdc-slider__thumb.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-slider .mdc-slider__thumb.mdc-ripple-upgraded--background-focused:before,.mdc-slider .mdc-slider__thumb:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-slider .mdc-slider__thumb:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-slider .mdc-slider__thumb:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-slider .mdc-slider__thumb.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-slider .mdc-slider__tick-marks{box-sizing:border-box;justify-content:space-between;align-items:center;width:100%;height:100%;padding:0 1px;display:flex;position:absolute}.mdc-slider .mdc-slider__tick-mark--active,.mdc-slider .mdc-slider__tick-mark--inactive{border-radius:50%;width:2px;height:2px}.mdc-slider .mdc-slider__tick-mark--active,.mdc-slider.mdc-slider--disabled .mdc-slider__tick-mark--active{background-color:#fff;background-color:var(--mdc-theme-on-primary,#fff);opacity:.6}.mdc-slider .mdc-slider__tick-mark--inactive{background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);opacity:.6}.mdc-slider.mdc-slider--disabled .mdc-slider__tick-mark--inactive{background-color:#000;background-color:var(--mdc-theme-on-surface,#000);opacity:.6}.mdc-slider.mdc-slider--disabled{opacity:.38;cursor:auto}.mdc-slider.mdc-slider--disabled .mdc-slider__thumb{pointer-events:none}.mdc-slider--discrete .mdc-slider__thumb,.mdc-slider--discrete .mdc-slider__track--active_fill{transition:transform 80ms}@media (prefers-reduced-motion){.mdc-slider--discrete .mdc-slider__thumb,.mdc-slider--discrete .mdc-slider__track--active_fill{transition:none}}.mdc-slider__input{cursor:pointer;opacity:0;pointer-events:none;width:100%;height:100%;margin:0;position:absolute;top:0;left:0}.mdc-snackbar{z-index:8;box-sizing:border-box;pointer-events:none;-webkit-tap-highlight-color:#0000;justify-content:center;align-items:center;margin:8px;display:none;position:fixed;bottom:0;left:0;right:0}.mdc-snackbar__surface{background-color:#333}.mdc-snackbar__label{color:#ffffffde}.mdc-snackbar__surface{min-width:344px}@media (width<=480px),(width<=344px){.mdc-snackbar__surface{min-width:100%}}.mdc-snackbar__surface{border-radius:4px;border-radius:var(--mdc-shape-small,4px);max-width:672px;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mdc-snackbar--opening,.mdc-snackbar--open,.mdc-snackbar--closing{display:flex}.mdc-snackbar--open .mdc-snackbar__label,.mdc-snackbar--open .mdc-snackbar__actions{visibility:visible}.mdc-snackbar--leading{justify-content:flex-start}.mdc-snackbar--stacked .mdc-snackbar__label{padding-bottom:12px;padding-left:16px;padding-right:8px}[dir=rtl] .mdc-snackbar--stacked .mdc-snackbar__label,.mdc-snackbar--stacked .mdc-snackbar__label[dir=rtl]{padding-left:8px;padding-right:16px}.mdc-snackbar--stacked .mdc-snackbar__surface{flex-direction:column;align-items:flex-start}.mdc-snackbar--stacked .mdc-snackbar__actions{align-self:flex-end;margin-bottom:8px}.mdc-snackbar__surface{box-sizing:border-box;opacity:0;justify-content:flex-start;align-items:center;padding-left:0;padding-right:8px;display:flex;transform:scale(.8)}.mdc-snackbar__surface:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}[dir=rtl] .mdc-snackbar__surface,.mdc-snackbar__surface[dir=rtl]{padding-left:8px;padding-right:0}.mdc-snackbar--open .mdc-snackbar__surface{opacity:1;pointer-events:auto;transition:opacity .15s cubic-bezier(0,0,.2,1),transform .15s cubic-bezier(0,0,.2,1);transform:scale(1)}.mdc-snackbar--closing .mdc-snackbar__surface{transition:opacity 75ms cubic-bezier(.4,0,1,1);transform:scale(1)}.mdc-snackbar__label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);box-sizing:border-box;visibility:hidden;flex-grow:1;width:100%;margin:0;padding:14px 8px 14px 16px}[dir=rtl] .mdc-snackbar__label,.mdc-snackbar__label[dir=rtl]{padding-left:8px;padding-right:16px}.mdc-snackbar__label:before{content:attr(data-mdc-snackbar-label-text);display:inline}.mdc-snackbar__actions{box-sizing:border-box;visibility:hidden;flex-shrink:0;align-items:center;display:flex}.mdc-snackbar__action:not(:disabled){color:#bb86fc}.mdc-snackbar__action:before,.mdc-snackbar__action:after{background-color:#bb86fc;background-color:var(--mdc-ripple-color,#bb86fc)}.mdc-snackbar__action:hover:before,.mdc-snackbar__action.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-snackbar__action.mdc-ripple-upgraded--background-focused:before,.mdc-snackbar__action:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-snackbar__action:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-snackbar__action:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-snackbar__action.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-snackbar__dismiss{color:#ffffffde}.mdc-snackbar__dismiss:before,.mdc-snackbar__dismiss:after{background-color:#ffffffde;background-color:var(--mdc-ripple-color,#ffffffde)}.mdc-snackbar__dismiss:hover:before,.mdc-snackbar__dismiss.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-snackbar__dismiss.mdc-ripple-upgraded--background-focused:before,.mdc-snackbar__dismiss:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-snackbar__dismiss:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-snackbar__dismiss:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-snackbar__dismiss.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-snackbar__dismiss.mdc-snackbar__dismiss{width:36px;height:36px;padding:9px;font-size:18px}.mdc-snackbar__dismiss.mdc-snackbar__dismiss svg,.mdc-snackbar__dismiss.mdc-snackbar__dismiss img{width:18px;height:18px}.mdc-snackbar__action+.mdc-snackbar__dismiss{margin-left:8px;margin-right:0}[dir=rtl] .mdc-snackbar__action+.mdc-snackbar__dismiss,.mdc-snackbar__action+.mdc-snackbar__dismiss[dir=rtl]{margin-left:0;margin-right:8px}.mdc-switch__thumb-underlay{left:-14px;right:initial;width:48px;height:48px;top:-17px}[dir=rtl] .mdc-switch__thumb-underlay,.mdc-switch__thumb-underlay[dir=rtl]{left:initial;right:-14px}.mdc-switch__native-control{width:64px;height:48px}.mdc-switch{-webkit-user-select:none;user-select:none;outline:none;display:inline-block;position:relative}.mdc-switch.mdc-switch--checked .mdc-switch__track{background-color:#018786;background-color:var(--mdc-theme-secondary,#018786)}.mdc-switch.mdc-switch--checked .mdc-switch__thumb{background-color:#018786;background-color:var(--mdc-theme-secondary,#018786);border-color:#018786;border-color:var(--mdc-theme-secondary,#018786)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__track{background-color:#000;background-color:var(--mdc-theme-on-surface,#000)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb{background-color:#fff;background-color:var(--mdc-theme-surface,#fff);border-color:#fff;border-color:var(--mdc-theme-surface,#fff)}.mdc-switch__native-control{left:0;right:initial;opacity:0;cursor:pointer;pointer-events:auto;margin:0;transition:transform 90ms cubic-bezier(.4,0,.2,1);position:absolute;top:0}[dir=rtl] .mdc-switch__native-control,.mdc-switch__native-control[dir=rtl]{left:initial;right:0}.mdc-switch__track{box-sizing:border-box;opacity:.38;border:1px solid #0000;border-radius:7px;width:36px;height:14px;transition:opacity 90ms cubic-bezier(.4,0,.2,1),background-color 90ms cubic-bezier(.4,0,.2,1),border-color 90ms cubic-bezier(.4,0,.2,1)}.mdc-switch__thumb-underlay{justify-content:center;align-items:center;transition:transform 90ms cubic-bezier(.4,0,.2,1),background-color 90ms cubic-bezier(.4,0,.2,1),border-color 90ms cubic-bezier(.4,0,.2,1);display:flex;position:absolute;transform:translate(0)}.mdc-switch__thumb{box-sizing:border-box;pointer-events:none;z-index:1;border:10px solid;border-radius:50%;width:20px;height:20px;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-switch--checked .mdc-switch__track{opacity:.54}.mdc-switch--checked .mdc-switch__thumb-underlay{transform:translate(16px)}[dir=rtl] .mdc-switch--checked .mdc-switch__thumb-underlay,.mdc-switch--checked .mdc-switch__thumb-underlay[dir=rtl],.mdc-switch--checked .mdc-switch__native-control{transform:translate(-16px)}[dir=rtl] .mdc-switch--checked .mdc-switch__native-control,.mdc-switch--checked .mdc-switch__native-control[dir=rtl]{transform:translate(16px)}.mdc-switch--disabled{opacity:.38;pointer-events:none}.mdc-switch--disabled .mdc-switch__thumb{border-width:1px}.mdc-switch--disabled .mdc-switch__native-control{cursor:default;pointer-events:none}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:before,.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:after{background-color:#9e9e9e;background-color:var(--mdc-ripple-color,#9e9e9e)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:hover:before,.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay.mdc-ripple-upgraded--background-focused:before,.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-switch:not(.mdc-switch--checked) .mdc-switch__thumb-underlay.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-switch__thumb-underlay{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-switch__thumb-underlay:before,.mdc-switch__thumb-underlay:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-switch__thumb-underlay:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-switch__thumb-underlay:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--unbounded:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--foreground-activation:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--foreground-deactivation:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-switch__thumb-underlay:before,.mdc-switch__thumb-underlay:after{width:100%;height:100%;top:0%;left:0%}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:before,.mdc-switch__thumb-underlay.mdc-ripple-upgraded:after{top:var(--mdc-ripple-top,calc(50% - 50%));left:var(--mdc-ripple-left,calc(50% - 50%));width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-switch__thumb-underlay:before,.mdc-switch__thumb-underlay:after{background-color:#018786;background-color:var(--mdc-ripple-color,var(--mdc-theme-secondary,#018786))}.mdc-switch__thumb-underlay:hover:before,.mdc-switch__thumb-underlay.mdc-ripple-surface--hover:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-switch__thumb-underlay.mdc-ripple-upgraded--background-focused:before,.mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):focus:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-switch__thumb-underlay:not(.mdc-ripple-upgraded):active:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-switch__thumb-underlay.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-tab{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase);box-sizing:border-box;text-align:center;white-space:nowrap;cursor:pointer;-webkit-appearance:none;z-index:1;background:0 0;border:none;outline:none;flex:1 0 auto;justify-content:center;min-width:90px;margin:0;padding:0 24px;display:flex;position:relative}.mdc-tab .mdc-tab__text-label{color:#0009}.mdc-tab .mdc-tab__icon{color:#0000008a;fill:currentColor}.mdc-tab::-moz-focus-inner{border:0;padding:0}.mdc-tab--min-width{flex:0 auto}.mdc-tab__content{height:inherit;pointer-events:none;justify-content:center;align-items:center;display:flex;position:relative}.mdc-tab__text-label{z-index:2;line-height:1;transition:color .15s linear;display:inline-block}.mdc-tab__icon{z-index:2;width:24px;height:24px;font-size:24px;transition:color .15s linear}.mdc-tab--stacked .mdc-tab__content{flex-direction:column;justify-content:center;align-items:center}.mdc-tab--stacked .mdc-tab__text-label{padding-top:6px;padding-bottom:4px}.mdc-tab--active .mdc-tab__text-label{color:var(--mdc-theme-primary,#6200ee)}.mdc-tab--active .mdc-tab__icon{color:var(--mdc-theme-primary,#6200ee);fill:currentColor}.mdc-tab--active .mdc-tab__text-label,.mdc-tab--active .mdc-tab__icon{transition-delay:.1s}.mdc-tab:not(.mdc-tab--stacked) .mdc-tab__icon+.mdc-tab__text-label{padding-left:8px;padding-right:0}[dir=rtl] .mdc-tab:not(.mdc-tab--stacked) .mdc-tab__icon+.mdc-tab__text-label,.mdc-tab:not(.mdc-tab--stacked) .mdc-tab__icon+.mdc-tab__text-label[dir=rtl]{padding-left:0;padding-right:8px}.mdc-tab{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000}.mdc-tab .mdc-tab__ripple:before,.mdc-tab .mdc-tab__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-tab .mdc-tab__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-tab .mdc-tab__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-tab.mdc-ripple-upgraded .mdc-tab__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-tab.mdc-ripple-upgraded .mdc-tab__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-tab.mdc-ripple-upgraded--unbounded .mdc-tab__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-tab.mdc-ripple-upgraded--foreground-activation .mdc-tab__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-tab.mdc-ripple-upgraded--foreground-deactivation .mdc-tab__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-tab .mdc-tab__ripple:before,.mdc-tab .mdc-tab__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-tab.mdc-ripple-upgraded .mdc-tab__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-tab .mdc-tab__ripple:before,.mdc-tab .mdc-tab__ripple:after{background-color:#6200ee;background-color:var(--mdc-ripple-color,var(--mdc-theme-primary,#6200ee))}.mdc-tab:hover .mdc-tab__ripple:before,.mdc-tab.mdc-ripple-surface--hover .mdc-tab__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-tab.mdc-ripple-upgraded--background-focused .mdc-tab__ripple:before,.mdc-tab:not(.mdc-ripple-upgraded):focus .mdc-tab__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-tab:not(.mdc-ripple-upgraded) .mdc-tab__ripple:after{transition:opacity .15s linear}.mdc-tab:not(.mdc-ripple-upgraded):active .mdc-tab__ripple:after{opacity:.12;opacity:var(--mdc-ripple-press-opacity,.12);transition-duration:75ms}.mdc-tab.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.12)}.mdc-tab__ripple{will-change:transform,opacity;width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden}.mdc-tab-bar{width:100%}.mdc-tab{height:48px}.mdc-tab--stacked{height:72px}.mdc-tab-indicator{pointer-events:none;z-index:1;justify-content:center;width:100%;height:100%;display:flex;position:absolute;top:0;left:0}.mdc-tab-indicator .mdc-tab-indicator__content--underline{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-tab-indicator .mdc-tab-indicator__content--icon{color:var(--mdc-theme-secondary,#018786)}.mdc-tab-indicator .mdc-tab-indicator__content--underline{border-top-width:2px}.mdc-tab-indicator .mdc-tab-indicator__content--icon{height:34px;font-size:34px}.mdc-tab-indicator__content{transform-origin:0;opacity:0}.mdc-tab-indicator__content--underline{box-sizing:border-box;border-top-style:solid;align-self:flex-end;width:100%}.mdc-tab-indicator__content--icon{align-self:center;margin:0 auto}.mdc-tab-indicator--active .mdc-tab-indicator__content{opacity:1}.mdc-tab-indicator .mdc-tab-indicator__content{transition:transform .25s cubic-bezier(.4,0,.2,1)}.mdc-tab-indicator--no-transition .mdc-tab-indicator__content{transition:none}.mdc-tab-indicator--fade .mdc-tab-indicator__content{transition:opacity .15s linear}.mdc-tab-indicator--active.mdc-tab-indicator--fade .mdc-tab-indicator__content{transition-delay:.1s}.mdc-tab-scroller{overflow-y:hidden}.mdc-tab-scroller.mdc-tab-scroller--animating .mdc-tab-scroller__scroll-content{transition:transform .25s cubic-bezier(.4,0,.2,1)}.mdc-tab-scroller__test{width:100px;height:100px;position:absolute;top:-9999px;overflow-x:scroll}.mdc-tab-scroller__scroll-area{-webkit-overflow-scrolling:touch;display:flex;overflow-x:hidden}.mdc-tab-scroller__scroll-area::-webkit-scrollbar{display:none}.mdc-tab-scroller__test::-webkit-scrollbar{display:none}.mdc-tab-scroller__scroll-area--scroll{overflow-x:scroll}.mdc-tab-scroller__scroll-content{will-change:transform;flex:1 0 auto;display:flex;position:relative;transform:none}.mdc-tab-scroller--align-start .mdc-tab-scroller__scroll-content{justify-content:flex-start}.mdc-tab-scroller--align-end .mdc-tab-scroller__scroll-content{justify-content:flex-end}.mdc-tab-scroller--align-center .mdc-tab-scroller__scroll-content{justify-content:center}.mdc-tab-scroller--animating .mdc-tab-scroller__scroll-area{-webkit-overflow-scrolling:auto}.mdc-text-field--filled{--mdc-ripple-fg-size:0;--mdc-ripple-left:0;--mdc-ripple-top:0;--mdc-ripple-fg-scale:1;--mdc-ripple-fg-translate-end:0;--mdc-ripple-fg-translate-start:0;-webkit-tap-highlight-color:#0000;will-change:transform,opacity}.mdc-text-field--filled .mdc-text-field__ripple:before,.mdc-text-field--filled .mdc-text-field__ripple:after{opacity:0;pointer-events:none;content:\"\";border-radius:50%;position:absolute}.mdc-text-field--filled .mdc-text-field__ripple:before{z-index:1;z-index:var(--mdc-ripple-z-index,1);transition:opacity 15ms linear,background-color 15ms linear}.mdc-text-field--filled .mdc-text-field__ripple:after{z-index:0;z-index:var(--mdc-ripple-z-index,0)}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple:before{transform:scale(var(--mdc-ripple-fg-scale,1))}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple:after{transform-origin:50%;top:0;left:0;transform:scale(0)}.mdc-text-field--filled.mdc-ripple-upgraded--unbounded .mdc-text-field__ripple:after{top:var(--mdc-ripple-top,0);left:var(--mdc-ripple-left,0)}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-activation .mdc-text-field__ripple:after{animation:.225s forwards mdc-ripple-fg-radius-in,75ms forwards mdc-ripple-fg-opacity-in}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-deactivation .mdc-text-field__ripple:after{transform:translate(var(--mdc-ripple-fg-translate-end,0))scale(var(--mdc-ripple-fg-scale,1));animation:.15s mdc-ripple-fg-opacity-out}.mdc-text-field--filled .mdc-text-field__ripple:before,.mdc-text-field--filled .mdc-text-field__ripple:after{width:200%;height:200%;top:-50%;left:-50%}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple:after{width:var(--mdc-ripple-fg-size,100%);height:var(--mdc-ripple-fg-size,100%)}.mdc-text-field__ripple{pointer-events:none;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-text-field{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);box-sizing:border-box;will-change:opacity,transform,color;border-bottom-right-radius:0;border-bottom-left-radius:0;align-items:baseline;padding:0 16px;display:inline-flex;position:relative;overflow:hidden}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-floating-label{color:#0009}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:#000000de}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input::placeholder{color:#0000008a}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input:-ms-input-placeholder{color:#0000008a}.mdc-text-field .mdc-text-field__input{caret-color:var(--mdc-theme-primary,#6200ee)}.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-helper-text,.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field-character-counter,.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:#0009}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--leading,.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:#0000008a}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--prefix,.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--suffix{color:#0009}.mdc-text-field .mdc-floating-label{pointer-events:none;top:50%;transform:translateY(-50%)}.mdc-text-field__input{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);appearance:none;background:0 0;border:none;border-radius:0;width:100%;min-width:0;height:28px;padding:0;transition:opacity .15s cubic-bezier(.4,0,.2,1)}.mdc-text-field__input::-ms-clear{display:none}.mdc-text-field__input::-webkit-calendar-picker-indicator{display:none}.mdc-text-field__input:focus{outline:none}.mdc-text-field__input:invalid{box-shadow:none}.mdc-text-field__input::placeholder{opacity:0;transition:opacity 67ms cubic-bezier(.4,0,.2,1)}.mdc-text-field__input:-ms-input-placeholder{opacity:0;transition:opacity 67ms cubic-bezier(.4,0,.2,1)}.mdc-text-field--no-label .mdc-text-field__input::placeholder,.mdc-text-field--focused .mdc-text-field__input::placeholder,:is(.mdc-text-field--no-label .mdc-text-field__input:-ms-input-placeholder,.mdc-text-field--focused .mdc-text-field__input:-ms-input-placeholder){opacity:1;transition-duration:.11s;transition-delay:40ms}.mdc-text-field__affix{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);opacity:0;white-space:nowrap;height:28px;transition:opacity .15s cubic-bezier(.4,0,.2,1)}.mdc-text-field--label-floating .mdc-text-field__affix,.mdc-text-field--no-label .mdc-text-field__affix{opacity:1}@supports ((-webkit-hyphens:none)){.mdc-text-field--outlined .mdc-text-field__affix{align-self:center;align-items:center;height:100%;display:inline-flex}}.mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field__affix--prefix,.mdc-text-field__affix--prefix[dir=rtl]{padding-left:2px;padding-right:0}.mdc-text-field--end-aligned .mdc-text-field__affix--prefix{padding-left:0;padding-right:12px}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--end-aligned .mdc-text-field__affix--prefix[dir=rtl],.mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field__affix--suffix,.mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:12px}.mdc-text-field--end-aligned .mdc-text-field__affix--suffix{padding-left:2px;padding-right:0}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--end-aligned .mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:2px}.mdc-text-field--filled{height:56px}.mdc-text-field--filled .mdc-text-field__ripple:before,.mdc-text-field--filled .mdc-text-field__ripple:after{background-color:#000000de;background-color:var(--mdc-ripple-color,#000000de)}.mdc-text-field--filled:hover .mdc-text-field__ripple:before,.mdc-text-field--filled.mdc-ripple-surface--hover .mdc-text-field__ripple:before{opacity:.04;opacity:var(--mdc-ripple-hover-opacity,.04)}.mdc-text-field--filled.mdc-ripple-upgraded--background-focused .mdc-text-field__ripple:before,.mdc-text-field--filled:not(.mdc-ripple-upgraded):focus .mdc-text-field__ripple:before{opacity:.12;opacity:var(--mdc-ripple-focus-opacity,.12);transition-duration:75ms}.mdc-text-field--filled:before{content:\"\";vertical-align:0;width:0;height:40px;display:inline-block}.mdc-text-field--filled:not(.mdc-text-field--disabled){background-color:#f5f5f5}.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:#0000006b}.mdc-text-field--filled:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before{border-bottom-color:#000000de}.mdc-text-field--filled .mdc-line-ripple:after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary,#6200ee)}.mdc-text-field--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-text-field--filled .mdc-floating-label,.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-106%)scale(.75)}.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{height:100%}.mdc-text-field--filled.mdc-text-field--no-label .mdc-floating-label,.mdc-text-field--filled.mdc-text-field--no-label:before{display:none}@supports ((-webkit-hyphens:none)){.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__affix{align-self:center;align-items:center;height:100%;display:inline-flex}}.mdc-text-field--outlined{height:56px;overflow:visible}.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-37.25px)scale(1)}.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-34.75px)scale(.75)}.mdc-text-field--outlined .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-text-field-outlined}@keyframes mdc-floating-label-shake-float-above-text-field-outlined{0%{transform:translate(0)translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-34.75px)scale(.75)}to{transform:translate(0)translateY(-34.75px)scale(.75)}}.mdc-text-field--outlined .mdc-text-field__input{height:100%}.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{border-color:#00000061}.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#000000de}.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#6200ee;border-color:var(--mdc-theme-primary,#6200ee)}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}@supports (top:max(0%)){.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px,var(--mdc-shape-small,4px))}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px,var(--mdc-shape-small,4px))*2)}}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small,4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small,4px);border-bottom-left-radius:0}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small,4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small,4px)}@supports (top:max(0%)){.mdc-text-field--outlined,.mdc-text-field--outlined+.mdc-text-field-helper-line{padding-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px));padding-right:max(16px,var(--mdc-shape-small,4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-left:0}@supports (top:max(0%)){.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-right:max(16px,var(--mdc-shape-small,4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-right:0}@supports (top:max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:max(16px,var(--mdc-shape-small,4px))}}.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-right:0}@supports (top:max(0%)){.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-left:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0}@supports (top:max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-right:max(16px,calc(var(--mdc-shape-small,4px) + 4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-text-field--outlined .mdc-text-field__ripple:before,.mdc-text-field--outlined .mdc-text-field__ripple:after{content:none}.mdc-text-field--outlined .mdc-floating-label{left:4px;right:initial}[dir=rtl] .mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-text-field--outlined .mdc-text-field__input{background-color:#0000;display:flex;border:none!important}.mdc-text-field--outlined .mdc-notched-outline{z-index:1}.mdc-text-field--textarea{flex-direction:column;align-items:center;width:auto;height:auto;padding:0;transition:none}.mdc-text-field--textarea .mdc-floating-label{top:19px}.mdc-text-field--textarea .mdc-floating-label:not(.mdc-floating-label--float-above){transform:none}.mdc-text-field--textarea .mdc-text-field__input{box-sizing:border-box;resize:none;flex-grow:1;height:auto;min-height:1.5rem;padding:0 16px;line-height:1.5rem;overflow:hidden auto}.mdc-text-field--textarea.mdc-text-field--filled:before{display:none}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-10.25px)scale(.75)}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-textarea-filled}@keyframes mdc-floating-label-shake-float-above-textarea-filled{0%{transform:translate(0)translateY(-10.25px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-10.25px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-10.25px)scale(.75)}to{transform:translate(0)translateY(-10.25px)scale(.75)}}.mdc-text-field--textarea.mdc-text-field--filled .mdc-text-field__input{margin-top:23px;margin-bottom:9px}.mdc-text-field--textarea.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem;transform:translateY(-27.25px)scale(1)}.mdc-text-field--textarea.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem;transform:translateY(-24.75px)scale(.75)}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-textarea-outlined}@keyframes mdc-floating-label-shake-float-above-textarea-outlined{0%{transform:translate(0)translateY(-24.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(4%)translateY(-24.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(-4%)translateY(-24.75px)scale(.75)}to{transform:translate(0)translateY(-24.75px)scale(.75)}}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label{top:18px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field__input{margin-bottom:2px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter{align-self:flex-end;padding:0 16px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter:after{content:\"\";vertical-align:-16px;width:0;height:16px;display:inline-block}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter:before{display:none}.mdc-text-field__resizer{resize:both;flex-direction:column;flex-grow:1;align-self:stretch;min-width:-webkit-fill-available;max-width:100%;min-height:56px;max-height:100%;display:inline-flex;overflow:hidden}.mdc-text-field--filled .mdc-text-field__resizer{transform:translateY(-1px)}.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translateY(1px)}.mdc-text-field--outlined .mdc-text-field__resizer{transform:translate(-1px)translateY(-1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer,.mdc-text-field--outlined .mdc-text-field__resizer[dir=rtl]{transform:translate(1px)translateY(-1px)}.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translate(1px)translateY(1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input[dir=rtl],[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter[dir=rtl]{transform:translate(-1px)translateY(1px)}.mdc-text-field--with-leading-icon{padding-left:0;padding-right:16px}[dir=rtl] .mdc-text-field--with-leading-icon,.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:16px;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label{left:48px;right:initial;max-width:calc(100% - 48px)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 85.3333px)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-text-field--with-leading-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-37.25px)translate(-32px)scale(1)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px)translate(32px)scale(1)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px)translate(-32px)scale(.75)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px)translate(32px)scale(.75)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-text-field-outlined-leading-icon}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon{0%{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% - 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(-4% - 32px))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 - 32px))translateY(-34.75px)scale(.75)}}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake,.mdc-text-field--with-leading-icon.mdc-text-field--outlined[dir=rtl] .mdc-floating-label--shake{animation:.25s mdc-floating-label-shake-float-above-text-field-outlined-leading-icon}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon-rtl{0%{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}33%{animation-timing-function:cubic-bezier(.5,0,.701732,.495819);transform:translate(calc(4% + 32px))translateY(-34.75px)scale(.75)}66%{animation-timing-function:cubic-bezier(.302435,.381352,.55,.956352);transform:translate(calc(32px - 4%))translateY(-34.75px)scale(.75)}to{transform:translate(calc(0 + 32px))translateY(-34.75px)scale(.75)}}.mdc-text-field--with-trailing-icon{padding-left:16px;padding-right:0}[dir=rtl] .mdc-text-field--with-trailing-icon,.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0;padding-right:16px}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 85.3333px)}.mdc-text-field--with-trailing-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(133.333% - 128px)}.mdc-text-field-helper-line{box-sizing:border-box;justify-content:space-between;display:flex}.mdc-text-field+.mdc-text-field-helper-line{padding-left:16px;padding-right:16px}.mdc-form-field>.mdc-text-field+label{align-self:flex-start}.mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:#6200eede}.mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--focused .mdc-notched-outline__trailing{border-width:2px}.mdc-text-field--focused+.mdc-text-field-helper-line .mdc-text-field-helper-text:not(.mdc-text-field-helper-text--validation-msg){opacity:1}.mdc-text-field--focused.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-text-field--focused.mdc-text-field--outlined.mdc-text-field--textarea .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple:before,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error,#b00020)}.mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{opacity:1}.mdc-text-field--disabled{pointer-events:none}.mdc-text-field--disabled .mdc-text-field__input{color:#00000061}.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:#00000061}.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:#00000061}.mdc-text-field--disabled .mdc-floating-label,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text,.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:#00000061}.mdc-text-field--disabled .mdc-text-field__icon--leading,.mdc-text-field--disabled .mdc-text-field__icon--trailing{color:#0000004d}.mdc-text-field--disabled .mdc-text-field__affix--prefix,.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:#00000061}.mdc-text-field--disabled .mdc-line-ripple:before{border-bottom-color:#0000000f}.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:#0000000f}@media screen and (-ms-high-contrast:active){.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:graytext}.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:graytext}.mdc-text-field--disabled .mdc-floating-label,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text,.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter,.mdc-text-field--disabled .mdc-text-field__icon--leading,.mdc-text-field--disabled .mdc-text-field__icon--trailing,.mdc-text-field--disabled .mdc-text-field__affix--prefix,.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:graytext}.mdc-text-field--disabled .mdc-line-ripple:before{border-bottom-color:graytext}.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:graytext}}.mdc-text-field--disabled .mdc-floating-label{cursor:default}.mdc-text-field--disabled.mdc-text-field--filled{background-color:#fafafa}.mdc-text-field--disabled.mdc-text-field--filled .mdc-text-field__ripple{display:none}.mdc-text-field--disabled .mdc-text-field__input{pointer-events:auto}.mdc-text-field--end-aligned .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--end-aligned .mdc-text-field__input[dir=rtl]{text-align:left}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix{direction:ltr}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--leading,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--leading{order:1}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{order:2}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input{order:3}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{order:4}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--trailing,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--trailing{order:5}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--prefix{padding-right:12px}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--suffix{padding-left:2px}.mdc-text-field-helper-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);opacity:0;will-change:opacity;margin:0;line-height:normal;transition:opacity .15s cubic-bezier(.4,0,.2,1);display:block}.mdc-text-field-helper-text:before{content:\"\";vertical-align:0;width:0;height:16px;display:inline-block}.mdc-text-field-helper-text--persistent{opacity:1;will-change:initial;transition:none}.mdc-text-field-character-counter{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);white-space:nowrap;margin-top:0;margin-left:auto;margin-right:0;padding-left:16px;padding-right:0;line-height:normal;display:block}.mdc-text-field-character-counter:before{content:\"\";vertical-align:0;width:0;height:16px;display:inline-block}[dir=rtl] .mdc-text-field-character-counter,.mdc-text-field-character-counter[dir=rtl]{margin-left:0;margin-right:auto;padding-left:0;padding-right:16px}.mdc-text-field__icon{cursor:pointer;align-self:center}.mdc-text-field__icon:not([tabindex]),.mdc-text-field__icon[tabindex=\"-1\"]{cursor:default;pointer-events:none}.mdc-text-field__icon svg{display:block}.mdc-text-field__icon--leading{margin-left:16px;margin-right:8px}[dir=rtl] .mdc-text-field__icon--leading,.mdc-text-field__icon--leading[dir=rtl]{margin-left:8px;margin-right:16px}.mdc-text-field__icon--trailing{margin-left:0;margin-right:0;padding:12px}[dir=rtl] .mdc-text-field__icon--trailing,.mdc-text-field__icon--trailing[dir=rtl]{margin-left:0;margin-right:0}:root{--mdc-theme-primary:#6200ee;--mdc-theme-secondary:#018786;--mdc-theme-background:#fff;--mdc-theme-surface:#fff;--mdc-theme-error:#b00020;--mdc-theme-on-primary:#fff;--mdc-theme-on-secondary:#fff;--mdc-theme-on-surface:#000;--mdc-theme-on-error:#fff;--mdc-theme-text-primary-on-background:#000000de;--mdc-theme-text-secondary-on-background:#0000008a;--mdc-theme-text-hint-on-background:#00000061;--mdc-theme-text-disabled-on-background:#00000061;--mdc-theme-text-icon-on-background:#00000061;--mdc-theme-text-primary-on-light:#000000de;--mdc-theme-text-secondary-on-light:#0000008a;--mdc-theme-text-hint-on-light:#00000061;--mdc-theme-text-disabled-on-light:#00000061;--mdc-theme-text-icon-on-light:#00000061;--mdc-theme-text-primary-on-dark:white;--mdc-theme-text-secondary-on-dark:#ffffffb3;--mdc-theme-text-hint-on-dark:#ffffff80;--mdc-theme-text-disabled-on-dark:#ffffff80;--mdc-theme-text-icon-on-dark:#ffffff80}.mdc-theme--primary{color:var(--mdc-theme-primary,#6200ee)!important}.mdc-theme--secondary{color:var(--mdc-theme-secondary,#018786)!important}.mdc-theme--background{background-color:#fff;background-color:var(--mdc-theme-background,#fff)}.mdc-theme--surface{background-color:#fff;background-color:var(--mdc-theme-surface,#fff)}.mdc-theme--error{color:var(--mdc-theme-error,#b00020)!important}.mdc-theme--on-primary{color:var(--mdc-theme-on-primary,#fff)!important}.mdc-theme--on-secondary{color:var(--mdc-theme-on-secondary,#fff)!important}.mdc-theme--on-surface{color:var(--mdc-theme-on-surface,#000)!important}.mdc-theme--on-error{color:var(--mdc-theme-on-error,#fff)!important}.mdc-theme--text-primary-on-background{color:var(--mdc-theme-text-primary-on-background,#000000de)!important}.mdc-theme--text-secondary-on-background{color:var(--mdc-theme-text-secondary-on-background,#0000008a)!important}.mdc-theme--text-hint-on-background{color:var(--mdc-theme-text-hint-on-background,#00000061)!important}.mdc-theme--text-disabled-on-background{color:var(--mdc-theme-text-disabled-on-background,#00000061)!important}.mdc-theme--text-icon-on-background{color:var(--mdc-theme-text-icon-on-background,#00000061)!important}.mdc-theme--text-primary-on-light{color:var(--mdc-theme-text-primary-on-light,#000000de)!important}.mdc-theme--text-secondary-on-light{color:var(--mdc-theme-text-secondary-on-light,#0000008a)!important}.mdc-theme--text-hint-on-light{color:var(--mdc-theme-text-hint-on-light,#00000061)!important}.mdc-theme--text-disabled-on-light{color:var(--mdc-theme-text-disabled-on-light,#00000061)!important}.mdc-theme--text-icon-on-light{color:var(--mdc-theme-text-icon-on-light,#00000061)!important}.mdc-theme--text-primary-on-dark{color:var(--mdc-theme-text-primary-on-dark,white)!important}.mdc-theme--text-secondary-on-dark{color:var(--mdc-theme-text-secondary-on-dark,#ffffffb3)!important}.mdc-theme--text-hint-on-dark{color:var(--mdc-theme-text-hint-on-dark,#ffffff80)!important}.mdc-theme--text-disabled-on-dark{color:var(--mdc-theme-text-disabled-on-dark,#ffffff80)!important}.mdc-theme--text-icon-on-dark{color:var(--mdc-theme-text-icon-on-dark,#ffffff80)!important}.mdc-theme--primary-bg{background-color:#6200ee!important;background-color:var(--mdc-theme-primary,#6200ee)!important}.mdc-theme--secondary-bg{background-color:#018786!important;background-color:var(--mdc-theme-secondary,#018786)!important}.mdc-tooltip__surface,.mdc-tooltip__caret-surface-top,.mdc-tooltip__caret-surface-bottom{border-radius:4px;border-radius:var(--mdc-shape-small,4px)}.mdc-tooltip__surface{color:var(--mdc-theme-text-primary-on-dark,white);word-break:break-all;word-break:var(--mdc-tooltip-word-break,normal);overflow-wrap:anywhere;background-color:#0009}.mdc-tooltip{z-index:2}.mdc-tooltip--showing-transition .mdc-tooltip__surface-animation{transition:opacity .15s cubic-bezier(0,0,.2,1),transform .15s cubic-bezier(0,0,.2,1)}.mdc-tooltip--hide-transition .mdc-tooltip__surface-animation{transition:opacity 75ms cubic-bezier(.4,0,1,1)}.mdc-tooltip__title{color:var(--mdc-theme-text-primary-on-light,#000000de)}.mdc-tooltip__content{color:#0009}.mdc-tooltip__content-link{color:var(--mdc-theme-primary,#6200ee)}.mdc-tooltip{display:none;position:fixed}.mdc-tooltip.mdc-tooltip--rich .mdc-tooltip__surface,.mdc-tooltip.mdc-tooltip--rich .mdc-tooltip__caret-surface-top,.mdc-tooltip.mdc-tooltip--rich .mdc-tooltip__caret-surface-bottom{background-color:#fff}.mdc-tooltip-wrapper--rich{position:relative}.mdc-tooltip--shown,.mdc-tooltip--showing,.mdc-tooltip--hide{display:inline-flex}.mdc-tooltip--shown.mdc-tooltip--rich,.mdc-tooltip--showing.mdc-tooltip--rich,.mdc-tooltip--hide.mdc-tooltip--rich{display:inline-block;position:absolute;left:-320px}.mdc-tooltip__surface{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit);box-sizing:border-box;text-align:center;min-width:40px;max-width:200px;min-height:24px;max-height:40vh;padding:4px 8px;line-height:16px;overflow:hidden}.mdc-tooltip__surface:before{box-sizing:border-box;border-radius:inherit;content:\"\";pointer-events:none;border:1px solid #0000;width:100%;height:100%;position:absolute;top:0;left:0}.mdc-tooltip--rich .mdc-tooltip__surface{border-radius:4px;flex-direction:column;align-items:flex-start;min-width:40px;max-width:320px;min-height:24px;line-height:20px;display:flex;position:relative;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-tooltip--rich .mdc-tooltip__surface .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-tooltip--multiline .mdc-tooltip__surface{text-align:left}[dir=rtl] .mdc-tooltip--multiline .mdc-tooltip__surface,.mdc-tooltip--multiline .mdc-tooltip__surface[dir=rtl]{text-align:right}.mdc-tooltip__surface .mdc-tooltip__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;line-height:normal;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit);margin:0 8px;display:block}.mdc-tooltip__surface .mdc-tooltip__title:before{content:\"\";vertical-align:0;width:0;height:28px;display:inline-block}.mdc-tooltip__surface .mdc-tooltip__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;line-height:normal;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-align:left;max-width:calc(100% - 16px);margin:0 8px 16px;display:block}.mdc-tooltip__surface .mdc-tooltip__content:before{content:\"\";vertical-align:0;width:0;height:24px;display:inline-block}[dir=rtl] .mdc-tooltip__surface .mdc-tooltip__content,.mdc-tooltip__surface .mdc-tooltip__content[dir=rtl]{text-align:right}.mdc-tooltip__surface .mdc-tooltip__content-link{text-decoration:none}.mdc-tooltip__surface-animation{opacity:0;will-change:transform,opacity;transform:scale(.8)}.mdc-tooltip--shown .mdc-tooltip__surface-animation{opacity:1;transform:scale(1)}.mdc-tooltip--hide .mdc-tooltip__surface-animation{transform:scale(1)}.mdc-tooltip__caret-surface-top,.mdc-tooltip__caret-surface-bottom{width:24px;height:24px;position:absolute}.mdc-tooltip__caret-surface-top .mdc-elevation-overlay,.mdc-tooltip__caret-surface-bottom .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-tooltip__caret-surface-bottom{z-index:-1;outline:1px solid #0000;box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mdc-top-app-bar{background-color:#6200ee;background-color:var(--mdc-theme-primary,#6200ee);color:#fff;box-sizing:border-box;z-index:4;flex-direction:column;justify-content:space-between;width:100%;display:flex;position:fixed}.mdc-top-app-bar .mdc-top-app-bar__action-item,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon{color:var(--mdc-theme-on-primary,#fff)}.mdc-top-app-bar .mdc-top-app-bar__action-item:before,.mdc-top-app-bar .mdc-top-app-bar__action-item:after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:after{background-color:#fff;background-color:var(--mdc-ripple-color,var(--mdc-theme-on-primary,#fff))}.mdc-top-app-bar .mdc-top-app-bar__action-item:hover:before,.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-surface--hover:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:hover:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-surface--hover:before{opacity:.08;opacity:var(--mdc-ripple-hover-opacity,.08)}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded--background-focused:before,.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):focus:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded--background-focused:before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):focus:before{opacity:.24;opacity:var(--mdc-ripple-focus-opacity,.24);transition-duration:75ms}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):after{transition:opacity .15s linear}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):active:after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):active:after{opacity:.24;opacity:var(--mdc-ripple-press-opacity,.24);transition-duration:75ms}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity,.24)}.mdc-top-app-bar__row{box-sizing:border-box;width:100%;height:64px;display:flex;position:relative}.mdc-top-app-bar__section{z-index:1;flex:auto;align-items:center;min-width:0;padding:8px 12px;display:inline-flex}.mdc-top-app-bar__section--align-start{order:-1;justify-content:flex-start}.mdc-top-app-bar__section--align-end{order:1;justify-content:flex-end}.mdc-top-app-bar__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit);text-overflow:ellipsis;white-space:nowrap;z-index:1;padding-left:20px;padding-right:0;overflow:hidden}[dir=rtl] .mdc-top-app-bar__title,.mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--short-collapsed{border-radius:0 0 24px}[dir=rtl] .mdc-top-app-bar--short-collapsed,.mdc-top-app-bar--short-collapsed[dir=rtl]{border-radius:0 0 0 24px}.mdc-top-app-bar--short{width:100%;transition:width .25s cubic-bezier(.4,0,.2,1);top:0;left:0;right:auto}[dir=rtl] .mdc-top-app-bar--short,.mdc-top-app-bar--short[dir=rtl]{left:auto;right:0}.mdc-top-app-bar--short .mdc-top-app-bar__row{height:56px}.mdc-top-app-bar--short .mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short .mdc-top-app-bar__title{opacity:1;transition:opacity .2s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed{width:56px;transition:width .3s cubic-bezier(.4,0,.2,1);box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__title{display:none}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__action-item{transition:padding .15s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item{width:112px}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--dense .mdc-top-app-bar__row{height:48px}.mdc-top-app-bar--dense .mdc-top-app-bar__section{padding:0 4px}.mdc-top-app-bar--dense .mdc-top-app-bar__title{padding-left:12px;padding-right:0}[dir=rtl] .mdc-top-app-bar--dense .mdc-top-app-bar__title,.mdc-top-app-bar--dense .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:12px}.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:128px}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{align-self:flex-end;padding-bottom:2px}.mdc-top-app-bar--prominent .mdc-top-app-bar__action-item,.mdc-top-app-bar--prominent .mdc-top-app-bar__navigation-icon{align-self:flex-start}.mdc-top-app-bar--fixed{transition:box-shadow .2s linear}.mdc-top-app-bar--fixed-scrolled{transition:box-shadow .2s linear;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:96px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__section{padding:0 12px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-bottom:9px;padding-left:20px;padding-right:0}[dir=rtl] .mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title,.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--fixed-adjust{padding-top:64px}.mdc-top-app-bar--dense-fixed-adjust{padding-top:48px}.mdc-top-app-bar--short-fixed-adjust{padding-top:56px}.mdc-top-app-bar--prominent-fixed-adjust{padding-top:128px}.mdc-top-app-bar--dense-prominent-fixed-adjust{padding-top:96px}@media (width<=599px){.mdc-top-app-bar__row{height:56px}.mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short{transition:width .2s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed{transition:width .25s cubic-bezier(.4,0,.2,1)}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-bottom:6px}.mdc-top-app-bar--fixed-adjust{padding-top:56px}}.mdc-typography{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-font-family,inherit)}.mdc-typography--headline1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline1-font-family,var(--mdc-typography-font-family,inherit));font-size:6rem;font-size:var(--mdc-typography-headline1-font-size,6rem);line-height:6rem;line-height:var(--mdc-typography-headline1-line-height,6rem);font-weight:300;font-weight:var(--mdc-typography-headline1-font-weight,300);letter-spacing:-.015625em;letter-spacing:var(--mdc-typography-headline1-letter-spacing,-.015625em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline1-text-decoration,inherit);text-decoration:var(--mdc-typography-headline1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline1-text-transform,inherit)}.mdc-typography--headline2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline2-font-family,var(--mdc-typography-font-family,inherit));font-size:3.75rem;font-size:var(--mdc-typography-headline2-font-size,3.75rem);line-height:3.75rem;line-height:var(--mdc-typography-headline2-line-height,3.75rem);font-weight:300;font-weight:var(--mdc-typography-headline2-font-weight,300);letter-spacing:-.00833333em;letter-spacing:var(--mdc-typography-headline2-letter-spacing,-.00833333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline2-text-decoration,inherit);text-decoration:var(--mdc-typography-headline2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline2-text-transform,inherit)}.mdc-typography--headline3{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline3-font-family,var(--mdc-typography-font-family,inherit));font-size:3rem;font-size:var(--mdc-typography-headline3-font-size,3rem);line-height:3.125rem;line-height:var(--mdc-typography-headline3-line-height,3.125rem);font-weight:400;font-weight:var(--mdc-typography-headline3-font-weight,400);letter-spacing:normal;letter-spacing:var(--mdc-typography-headline3-letter-spacing,normal);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline3-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline3-text-decoration,inherit);text-decoration:var(--mdc-typography-headline3-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline3-text-transform,inherit)}.mdc-typography--headline4{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline4-font-family,var(--mdc-typography-font-family,inherit));font-size:2.125rem;font-size:var(--mdc-typography-headline4-font-size,2.125rem);line-height:2.5rem;line-height:var(--mdc-typography-headline4-line-height,2.5rem);font-weight:400;font-weight:var(--mdc-typography-headline4-font-weight,400);letter-spacing:.00735294em;letter-spacing:var(--mdc-typography-headline4-letter-spacing,.00735294em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);text-decoration:var(--mdc-typography-headline4-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline4-text-transform,inherit)}.mdc-typography--headline5{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline5-font-family,var(--mdc-typography-font-family,inherit));font-size:1.5rem;font-size:var(--mdc-typography-headline5-font-size,1.5rem);line-height:2rem;line-height:var(--mdc-typography-headline5-line-height,2rem);font-weight:400;font-weight:var(--mdc-typography-headline5-font-weight,400);letter-spacing:normal;letter-spacing:var(--mdc-typography-headline5-letter-spacing,normal);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline5-text-transform,inherit)}.mdc-typography--headline6{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit)}.mdc-typography--subtitle1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit)}.mdc-typography--subtitle2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-subtitle2-font-size,.875rem);line-height:1.375rem;line-height:var(--mdc-typography-subtitle2-line-height,1.375rem);font-weight:500;font-weight:var(--mdc-typography-subtitle2-font-weight,500);letter-spacing:.00714286em;letter-spacing:var(--mdc-typography-subtitle2-letter-spacing,.00714286em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle2-text-transform,inherit)}.mdc-typography--body1{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit)}.mdc-typography--body2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit)}.mdc-typography--caption{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-caption-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-caption-font-size,.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight,400);letter-spacing:.0333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing,.0333333em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-decoration:var(--mdc-typography-caption-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform,inherit)}.mdc-typography--button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-button-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-button-font-size,.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height,2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight,500);letter-spacing:.0892857em;letter-spacing:var(--mdc-typography-button-letter-spacing,.0892857em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-button-text-decoration,none);text-decoration:var(--mdc-typography-button-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform,uppercase)}.mdc-typography--overline{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-overline-font-family,var(--mdc-typography-font-family,inherit));font-size:.75rem;font-size:var(--mdc-typography-overline-font-size,.75rem);line-height:2rem;line-height:var(--mdc-typography-overline-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-overline-font-weight,500);letter-spacing:.166667em;letter-spacing:var(--mdc-typography-overline-letter-spacing,.166667em);text-decoration:none;-webkit-text-decoration:var(--mdc-typography-overline-text-decoration,none);-webkit-text-decoration:var(--mdc-typography-overline-text-decoration,none);text-decoration:var(--mdc-typography-overline-text-decoration,none);text-transform:uppercase;text-transform:var(--mdc-typography-overline-text-transform,uppercase)}.material-icons-outlined,.material-icons{text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;-webkit-font-smoothing:antialiased;text-rendering:optimizelegibility;-moz-osx-font-smoothing:grayscale;direction:ltr;font-family:Material Icons Outlined;font-size:24px;font-style:normal;font-weight:400;line-height:1;display:inline-block}@font-face{font-family:Material Icons Outlined;font-style:normal;font-display:swap;font-weight:400;src:url(material-icons-outlined-all-400-normal.d9672557.woff2)format(\"woff2\"),url(material-icons-outlined-all-400-normal.7ace03fd.woff)format(\"woff\")}:host{--mdc-typography-headline1-font-size:96px;--mdc-typography-headline1-line-height:96px;--mdc-typography-headline2-font-size:60px;--mdc-typography-headline2-line-height:60px;--mdc-typography-headline3-font-size:48px;--mdc-typography-headline3-line-height:50px;--mdc-typography-headline4-font-size:34px;--mdc-typography-headline4-line-height:40px;--mdc-typography-headline5-font-size:24px;--mdc-typography-headline5-line-height:32px;--mdc-typography-headline6-font-size:20px;--mdc-typography-headline6-line-height:32px;--mdc-typography-subtitle1-font-size:16px;--mdc-typography-subtitle1-line-height:28px;--mdc-typography-subtitle2-font-size:14px;--mdc-typography-subtitle2-line-height:22px;--mdc-typography-body1-font-size:16px;--mdc-typography-body1-line-height:24px;--mdc-typography-body2-font-size:14px;--mdc-typography-body2-line-height:20px;--mdc-typography-caption-font-size:12px;--mdc-typography-caption-line-height:20px;--mdc-typography-button-font-size:14px;--mdc-typography-button-line-height:36px;--mdc-typography-overline-font-size:12px;--mdc-typography-overline-line-height:32px;font-size:16px}.mdc-select--outlined .mdc-select__anchor.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-select--outlined .mdc-select__anchor .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:16px}.mdc-select--outlined .mdc-floating-label,.mdc-floating-label{line-height:16px;overflow:visible}.mdc-select--outlined .mdc-notched-outline,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch{line-height:16px}h1,h2{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline5-font-family,var(--mdc-typography-font-family,inherit));font-size:1.5rem;font-size:var(--mdc-typography-headline5-font-size,1.5rem);line-height:2rem;line-height:var(--mdc-typography-headline5-line-height,2rem);font-weight:400;font-weight:var(--mdc-typography-headline5-font-weight,400);letter-spacing:normal;letter-spacing:var(--mdc-typography-headline5-letter-spacing,normal);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-decoration:var(--mdc-typography-headline5-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline5-text-transform,inherit)}h3{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-headline6-font-family,var(--mdc-typography-font-family,inherit));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size,1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height,2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight,500);letter-spacing:.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing,.0125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-decoration:var(--mdc-typography-headline6-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform,inherit)}h4,h5,h6{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-subtitle1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size,1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height,1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight,400);letter-spacing:.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing,.009375em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-decoration:var(--mdc-typography-subtitle1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform,inherit);font-weight:500}p,li{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit)}h1+h1,h1+h2,h1+h3,h1+h4,h1+h5,h1+h6,h1+p,h1+ul,h1+ol,h2+h1,h2+h2,h2+h3,h2+h4,h2+h5,h2+h6,h2+p,h2+ul,h2+ol,h3+h1,h3+h2,h3+h3,h3+h4,h3+h5,h3+h6,h3+p,h3+ul,h3+ol,h4+h1,h4+h2,h4+h3,h4+h4,h4+h5,h4+h6,h4+p,h4+ul,h4+ol,h5+h1,h5+h2,h5+h3,h5+h4,h5+h5,h5+h6,h5+p,h5+ul,h5+ol,h6+h1,h6+h2,h6+h3,h6+h4,h6+h5,h6+h6,h6+p,h6+ul,h6+ol,p+h1,p+h2,p+h3,p+h4,p+h5,p+h6,p+p,p+ul,p+ol,ul+h1,ul+h2,ul+h3,ul+h4,ul+h5,ul+h6,ul+p,ul+ul,ul+ol,ol+h1,ol+h2,ol+h3,ol+h4,ol+h5,ol+h6,ol+p,ol+ul,ol+ol,li:first-child p{margin-top:0}li:last-child p{margin-bottom:0}h1,h2,h3,h4,h5,h6{align-items:center;display:flex}.form-wrapper{flex-flow:column;display:flex}.form-wrapper__inner{flex-flow:row;gap:24px;display:flex}.menu{background-color:#f5f5f5;border-right:1px solid #ccc;flex:none;width:-moz-fit-content;width:fit-content;max-width:300px}.menu-item__text,.menu .mdc-deprecated-list-group__subheader{text-overflow:ellipsis;white-space:collapse nowrap;display:block;overflow:hidden}.menu-item__text{line-height:48px}.menu .mdc-deprecated-list-group__subheader{color:var(--mdc-theme-primary,#6200ee);line-height:28px}.menu .mdc-deprecated-list{margin-bottom:26px}.page__buttons{flex-flow:row-reverse wrap;margin-top:16px;display:flex}.page__buttons .page-button--prev{margin-right:auto}.ticket{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);flex-flow:column;align-items:stretch;line-height:24px;display:flex}.ticket--summary.ticket{align-items:stretch}.ticket--disabled{color:var(--mdc-theme-text-hint-on-background,#00000061)}.ticket:not(.ticket--summary)+.ticket{margin-top:16px}.ticket__label{cursor:pointer;flex-flow:row;display:flex}.ticket:not(.ticket--summary) .ticket__label:not(.ticket__label--no-option){font-weight:700}.ticket--summary .ticket__label{cursor:default}.ticket--disabled .ticket__label{cursor:not-allowed}.ticket__native-control{flex:none;width:48px;height:24px;position:relative}.ticket__native-control .mdc-touch-target-wrapper{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.ticket__price{text-align:right;min-width:88px;margin-left:auto;padding-left:8px}.ticket__description{color:var(--mdc-theme-text-hint-on-background,#00000061);margin-left:48px;padding-right:96px}.ticket__description p:first-child{margin-top:0}.ticket__description p:last-child{margin-bottom:0}.ticket__error{color:var(--mdc-theme-error,#b00020);margin-left:48px}.form-field-wrapper{flex-flow:wrap;margin-left:-16px;margin-right:-16px;display:flex}.form-field{flex:none;min-width:calc(50% - 32px);max-width:calc(100% - 32px);padding-left:16px;padding-right:16px}.form-field--full-width{min-width:calc(100% - 32px)}.form-field--checkbox,.form-field--radio-group{max-width:calc(100% - 116dppx);min-width:calc(50% - 16px);padding-left:0}.form-field--checkbox.form-field--full-width,.form-field--radio-group.form-field--full-width{min-width:calc(100% - 16px)}.form-field--radio-group{flex-flow:column;display:flex}.form-field--checkbox .mdc-form-field+.mdc-text-field-helper-line,.form-field--radio-group .mdc-form-field+.mdc-text-field-helper-line{padding-left:52px}.form-field--checkbox .mdc-form-field,.form-field--radio-group .mdc-form-field{margin-bottom:1rem}.form-field mdc-text-field,.form-field mdc-select{width:100%}.form-field--summary{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);align-items:center;display:flex}.summary{width:100%}.summary :first-child{margin-top:0}.summary h1,.summary h2,.summary h3{margin-top:20px;margin-bottom:0}.summary h4,.summary h5,.summary h6{margin-top:10px;margin-bottom:0}.summary h5,.summary h6{display:none}.summary h1+h1,.summary h1+h2,.summary h1+h3,.summary h1+h4,.summary h1+h5,.summary h1+h6,.summary h1+p,.summary h1+ul,.summary h1+ol,.summary h2+h1,.summary h2+h2,.summary h2+h3,.summary h2+h4,.summary h2+h5,.summary h2+h6,.summary h2+p,.summary h2+ul,.summary h2+ol,.summary h3+h1,.summary h3+h2,.summary h3+h3,.summary h3+h4,.summary h3+h5,.summary h3+h6,.summary h3+p,.summary h3+ul,.summary h3+ol,.summary h4+h1,.summary h4+h2,.summary h4+h3,.summary h4+h4,.summary h4+h5,.summary h4+h6,.summary h4+p,.summary h4+ul,.summary h4+ol,.summary h5+h1,.summary h5+h2,.summary h5+h3,.summary h5+h4,.summary h5+h5,.summary h5+h6,.summary h5+p,.summary h5+ul,.summary h5+ol,.summary h6+h1,.summary h6+h2,.summary h6+h3,.summary h6+h4,.summary h6+h5,.summary h6+h6,.summary h6+p,.summary h6+ul,.summary h6+ol,.summary p+h1,.summary p+h2,.summary p+h3,.summary p+h4,.summary p+h5,.summary p+h6,.summary p+p,.summary p+ul,.summary p+ol,.summary ul+h1,.summary ul+h2,.summary ul+h3,.summary ul+h4,.summary ul+h5,.summary ul+h6,.summary ul+p,.summary ul+ul,.summary ul+ol,.summary ol+h1,.summary ol+h2,.summary ol+h3,.summary ol+h4,.summary ol+h5,.summary ol+h6,.summary ol+p,.summary ol+ul,.summary ol+ol{margin-top:0}.summary p{margin-top:0;margin-bottom:0}.form-field label p:first-child{margin-top:0}.form-field label p:last-child{margin-bottom:0}.mdc-text-field-helper-line{flex:1 0 100%;min-height:1rem;line-height:1rem}.form-field--invalid .mdc-text-field-helper-line,.form-field--invalid+.mdc-text-field-helper-line{padding-left:16px;padding-right:16px}.form-field--invalid .mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg,.form-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{opacity:1;color:var(--mdc-theme-error,#b00020)}.mdc-form-field+.mdc-text-field-helper-line{margin-top:-1rem;padding-left:32px;padding-right:32px}.form-field--global-validation .mdc-text-field-helper-text{font-weight:700}.validation-errors{margin:0;padding:0;list-style-type:none}.validation-errors a{cursor:pointer}.validation-errors .mdc-text-field-helper-text--validation-msg{opacity:1;color:var(--mdc-theme-error,#b00020)}.chosen-ticket{border:1px solid #ccc;width:calc(100% - 48px);margin:16px 16px 0;padding:12px 8px}.total{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);border-top:1px solid #000;flex-flow:row;flex:1 0 calc(100% - 32px);padding:0 16px;font-weight:700;display:flex}.total span:last-child{white-space:nowrap;margin-left:auto}.total+.total{border-top:none}.login{color:var(--mdc-theme-primary,#6200ee);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body1-font-family,var(--mdc-typography-font-family,inherit));font-size:1rem;font-size:var(--mdc-typography-body1-font-size,1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height,1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight,400);letter-spacing:.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing,.03125em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-decoration:var(--mdc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform,inherit);flex-flow:column;display:flex}.login__form{margin-top:16px}.login__after{color:var(--mdc-theme-text-hint-on-background,#00000061)}.error-view{padding:16px}.error-view h1{margin-top:0}.loading{justify-content:center;padding:16px;display:flex}.debug-banner{color:var(--mdc-theme-on-error,#fff);background-color:#b00020;background-color:var(--mdc-theme-error,#b00020);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:inherit;font-family:var(--mdc-typography-body2-font-family,var(--mdc-typography-font-family,inherit));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size,.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height,1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571em;letter-spacing:var(--mdc-typography-body2-letter-spacing,.0178571em);-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);text-align:center;margin-bottom:8px;padding:8px}hr{background-color:#00000061;background-color:var(--mdc-theme-text-hint-on-background,#00000061);border:none;width:calc(100% - 32px);height:1px}.current-person{color:var(--mdc-theme-primary,#6200ee)}";


var $b0acb6cf65ffb89e$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return n(r, t, e, u, a, c);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return function(i) {
                                    return n(r, t, e, u, a, c, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(c) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, t, e, u, a, c, i, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, c) {
        return 6 === n.a ? n.f(r, t, e, u, a, c) : n(r)(t)(e)(u)(a)(c);
    }
    function A7(n, r, t, e, u, a, c, i) {
        return 7 === n.a ? n.f(r, t, e, u, a, c, i) : n(r)(t)(e)(u)(a)(c)(i);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, h(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var t, e = [], u = c(n, r, 0, e); u && (t = e.pop()); u = c(t.a, t.b, 0, e));
        return u;
    }
    function c(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (t > 100) return e.push(h(n, r)), !0;
        for(var a in 0 > n.$ && (n = vt(n), r = vt(r)), n)if (!c(n[a], r[a], t + 1, e)) return !1;
        return !0;
    }
    var i = F2(a), o = F2(function(n, r) {
        return !a(n, r);
    });
    function f(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = f(n.a, r.a)) || (t = f(n.b, r.b)) ? t : f(n.c, r.c);
        for(; n.b && r.b && !(t = f(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var s = F2(function(n, r) {
        return 0 > f(n, r);
    }), d = F2(function(n, r) {
        return f(n, r) > 0;
    }), b = F2(function(n, r) {
        return f(n, r) >= 0;
    }), l = F2(function(n, r) {
        var t = f(n, r);
        return 0 > t ? pt : t ? mt : $t;
    }), v = 0;
    function h(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function g(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function $(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var m = F2(p);
    function p(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = k(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = k(n.a, r);
        return t;
    }
    var w = {
        $: 0
    };
    function k(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var _ = F2(k);
    function y(n) {
        for(var r = w, t = n.length; t--;)r = k(n[t], r);
        return r;
    }
    function x(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var H = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return y(e);
    }), A = F4(function(n, r, t, e) {
        for(var u = []; r.b && t.b && e.b; r = r.b, t = t.b, e = e.b)u.push(A3(n, r.a, t.a, e.a));
        return y(u);
    }), P = F2(function(n, r) {
        return y(x(r).sort(function(r, t) {
            return f(n(r), n(t));
        }));
    }), B = F2(function(n, r) {
        return n + r;
    }), N = F2(function(n, r) {
        return n * r;
    }), L = F2(Math.pow), I = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? u(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), T = Math.ceil, S = Math.floor, C = Math.round, E = Math.log, z = isNaN, X = F2(function(n, r) {
        return n + r;
    }), j = F2(function(n, r) {
        return n + r;
    }), q = F2(function(n, r) {
        for(var t = [], e = r.length, u = 0; e > u;){
            var a = r[u], c = r.charCodeAt(u);
            u++, 55296 > c || c > 56319 || (a += r[u], u++), n(a) && t.push(a);
        }
        return t.join("");
    }), M = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], c = t.charCodeAt(u);
            u++, 55296 > c || c > 56319 || (a += t[u], u++), r = A2(n, a, r);
        }
        return r;
    }), R = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), O = F2(function(n, r) {
        return r.split(n);
    }), D = F2(function(n, r) {
        return r.join(n);
    }), F = F3(function(n, r, t) {
        return t.slice(n, r);
    }), V = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), Z = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), G = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), Y = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), U = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return w;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return y(u);
    });
    function Q(n) {
        return n + "";
    }
    function J(n) {
        return {
            $: 2,
            b: n
        };
    }
    var K = J(function(n) {
        return "number" != typeof n ? wn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? xt(n) : !isFinite(n) || n % 1 ? wn("an INT", n) : xt(n);
    }), W = J(function(n) {
        return "boolean" == typeof n ? xt(n) : wn("a BOOL", n);
    }), nn = J(function(n) {
        return "number" == typeof n ? xt(n) : wn("a FLOAT", n);
    }), rn = J(function(n) {
        return xt(n);
    }), tn = J(function(n) {
        return "string" == typeof n ? xt(n) : n instanceof String ? xt(n + "") : wn("a STRING", n);
    }), en = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), un = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function an(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var cn = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), on = F2(function(n, r) {
        return an(n, [
            r
        ]);
    }), fn = F3(function(n, r, t) {
        return an(n, [
            r,
            t
        ]);
    }), sn = F4(function(n, r, t, e) {
        return an(n, [
            r,
            t,
            e
        ]);
    }), dn = F5(function(n, r, t, e, u) {
        return an(n, [
            r,
            t,
            e,
            u
        ]);
    }), bn = F6(function(n, r, t, e, u, a) {
        return an(n, [
            r,
            t,
            e,
            u,
            a
        ]);
    }), ln = F7(function(n, r, t, e, u, a, c) {
        return an(n, [
            r,
            t,
            e,
            u,
            a,
            c
        ]);
    }), vn = F2(function(n, r) {
        try {
            return gn(n, JSON.parse(r));
        } catch (n) {
            return wt(A2(kt, "This is not valid JSON! " + n.message, r));
        }
    }), hn = F2(function(n, r) {
        return gn(n, r);
    });
    function gn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? xt(n.c) : wn("null", r);
            case 3:
                return mn(r) ? $n(n.b, r, y) : wn("a LIST", r);
            case 4:
                return mn(r) ? $n(n.b, r, pn) : wn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return wn("an OBJECT with a field named `" + t + "`", r);
                var e = gn(n.b, r[t]);
                return _e(e) ? e : wt(A2(_t, t, e.a));
            case 7:
                var u = n.e;
                return mn(r) ? r.length > u ? (e = gn(n.b, r[u]), _e(e) ? e : wt(A2(yt, u, e.a))) : wn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : wn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || mn(r)) return wn("an OBJECT", r);
                var a = w;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (e = gn(n.b, r[c]), !_e(e)) return wt(A2(_t, c, e.a));
                    a = k(h(c, e.a), a);
                }
                return xt(Zt(a));
            case 9:
                for(var i = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (e = gn(o[f], r), !_e(e)) return e;
                    i = i(e.a);
                }
                return xt(i);
            case 10:
                return e = gn(n.b, r), _e(e) ? gn(n.h(e.a), r) : e;
            case 11:
                for(var s = w, d = n.g; d.b; d = d.b){
                    if (e = gn(d.a, r), _e(e)) return e;
                    s = k(e.a, s);
                }
                return wt(Ht(Zt(s)));
            case 1:
                return wt(A2(kt, n.a, r));
            case 0:
                return xt(n.a);
        }
    }
    function $n(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var c = gn(n, r[a]);
            if (!_e(c)) return wt(A2(yt, a, c.a));
            u[a] = c.a;
        }
        return xt(t(u));
    }
    function mn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function pn(n) {
        return A2(ke, n.length, function(r) {
            return n[r];
        });
    }
    function wn(n, r) {
        return wt(A2(kt, "Expecting " + n, r));
    }
    function kn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return kn(n.b, r.b);
            case 6:
                return n.d === r.d && kn(n.b, r.b);
            case 7:
                return n.e === r.e && kn(n.b, r.b);
            case 9:
                return n.f === r.f && _n(n.g, r.g);
            case 10:
                return n.h === r.h && kn(n.b, r.b);
            case 11:
                return _n(n.g, r.g);
        }
    }
    function _n(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!kn(n[e], r[e])) return !1;
        return !0;
    }
    var yn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function xn(n) {
        return n;
    }
    var Hn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function An(n) {
        return F2(function(r, t) {
            return t.push(n(r)), t;
        });
    }
    function Pn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Bn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Nn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Ln = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), In = 0;
    function Tn(n) {
        var r = {
            $: 0,
            e: In++,
            f: n,
            g: null,
            h: []
        };
        return Xn(r), r;
    }
    function Sn(n, r) {
        n.h.push(r), Xn(n);
    }
    var Cn = F2(function(n, r) {
        return Bn(function(t) {
            Sn(n, r), t(Pn(v));
        });
    }), En = !1, zn = [];
    function Xn(n) {
        if (zn.push(n), !En) {
            for(En = !0; n = zn.shift();)jn(n);
            En = !1;
        }
    }
    function jn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Xn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var qn = {};
    function Mn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, c = n.f;
        function i(n) {
            return A2(Nn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : a && c ? A4(e, t, i.i, i.j, n) : A3(e, t, a ? i.i : i.j, n);
                }
            });
        }
        return t.h = Tn(A2(Nn, i, n.b));
    }
    var Rn = F2(function(n, r) {
        return Bn(function(t) {
            n.g(r), t(Pn(v));
        });
    }), On = F2(function(n, r) {
        return A2(Cn, n.h, {
            $: 0,
            a: r
        });
    });
    function Dn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Fn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Vn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), Zn = [], Gn = !1;
    function Yn(n, r, t) {
        if (Zn.push({
            p: n,
            q: r,
            r: t
        }), !Gn) {
            Gn = !0;
            for(var e; e = Zn.shift();)Un(e.p, e.q, e.r);
            Gn = !1;
        }
    }
    function Un(n, r, t) {
        var e = {};
        for(var u in Qn(!0, r, e, null), Qn(!1, t, e, null), n)Sn(n[u], {
            $: "fx",
            a: e[u] || {
                i: w,
                j: w
            }
        });
    }
    function Qn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? qn[r].e : qn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: w,
                        j: w
                    }, n ? t.i = k(r, t.i) : t.j = k(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var c = r.m; c.b; c = c.b)Qn(n, c.a, t, e);
                return;
            case 3:
                return void Qn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Jn(n) {
        qn[n] && u(3);
    }
    function Kn(n, r) {
        return Jn(n), qn[n] = {
            e: Wn,
            u: r,
            a: nr
        }, Dn(n);
    }
    var Wn = F2(function(n, r) {
        return r;
    });
    function nr(n) {
        var r = [], t = qn[n].u, e = Bn(function(n) {
            var r = setTimeout(function() {
                n(Pn(v));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return qn[n].b = e, qn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, c = t(u.a), i = 0; a.length > i; i++)a[i](c);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function rr(n, r) {
        return Jn(n), qn[n] = {
            f: er,
            u: r,
            a: ur
        }, Dn(n);
    }
    var tr, er = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function ur(n, r) {
        var t = w, e = qn[n].u, a = Pn(null);
        return qn[n].b = a, qn[n].c = F3(function(n, r) {
            return t = r, a;
        }), {
            send: function(n) {
                var a = A2(hn, e, n);
                _e(a) || u(4);
                for(var c = a.a, i = t; i.b; i = i.b)r(i.a(c));
            }
        };
    }
    var ar = "undefined" != typeof document ? document : {};
    function cr(n, r) {
        n.appendChild(r);
    }
    function ir(n) {
        return {
            $: 0,
            a: n
        };
    }
    var or = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Ar(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), fr = or(void 0), sr = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var c = e.a;
                a += c.b.b || 0, u.push(c);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Ar(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), dr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), br = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), lr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), vr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), hr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), gr = /^script$/i, $r = /^(on|formAction$)/i, mr = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, pr = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function wr(n) {
        return gr.test(n) ? "p" : n;
    }
    function kr(n) {
        return pr.test(n) ? "" : n;
    }
    var _r, yr = F2(function(n, r) {
        return "a0" === r.$ ? A2(br, r.n, function(n, r) {
            var t = Be(r);
            return {
                $: r.$,
                a: t ? A3(Ae, 3 > t ? xr : Hr, Pe(n), r.a) : A2(He, n, r.a)
            };
        }(n, r.o)) : r;
    }), xr = F2(function(n, r) {
        return h(n(r.a), r.b);
    }), Hr = F2(function(n, r) {
        return {
            ax: n(r.ax),
            dR: r.dR,
            dB: r.dB
        };
    });
    function Ar(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var c = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Pr(c, u, a) : c[u] = a;
            } else "className" === u ? Pr(r, u, a) : r[u] = a;
        }
        return r;
    }
    function Pr(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Br(n, r) {
        var t = n.$;
        if (5 === t) return Br(n.k || (n.k = n.m()), r);
        if (0 === t) return ar.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (c = Br(e, a)).elm_event_node_ref = a, c;
        }
        if (3 === t) return Nr(c = n.h(n.g), r, n.d), c;
        var c = n.f ? ar.createElementNS(n.f, n.c) : ar.createElement(n.c);
        tr && "a" == n.c && c.addEventListener("click", tr(c)), Nr(c, r, n.d);
        for(var i = n.e, o = 0; i.length > o; o++)cr(c, Br(1 === t ? i[o] : i[o].b, r));
        return c;
    }
    function Nr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Lr(n, u) : "a0" === e ? Sr(n, r, u) : "a3" === e ? Ir(n, u) : "a4" === e ? Tr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Lr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Ir(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Tr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Sr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], c = e[u];
            if (a) {
                if (c) {
                    if (c.q.$ === a.$) {
                        c.q = a;
                        continue;
                    }
                    n.removeEventListener(u, c);
                }
                c = Cr(r, a), n.addEventListener(u, c, _r && {
                    passive: 2 > Be(a)
                }), e[u] = c;
            } else n.removeEventListener(u, c), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                _r = !0;
            }
        }));
    } catch (n) {}
    function Cr(n, r) {
        function t(r) {
            var e = t.q, u = gn(e.a, r);
            if (_e(u)) {
                for(var a, c = Be(e), i = u.a, o = c ? 3 > c ? i.a : i.ax : i, f = 1 == c ? i.b : 3 == c && i.dR, s = (f && r.stopPropagation(), (2 == c ? i.b : 3 == c && i.dB) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var d = a.length; d--;)o = a[d](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Er(n, r) {
        return n.$ == r.$ && kn(n.a, r.a);
    }
    function zr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Xr(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void zr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var c = n.l, i = r.l, o = c.length, f = o === i.length; f && o--;)f = c[o] === i[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Xr(n.k, r.k, s, 0), void (s.length > 0 && zr(t, 1, e, s));
                case 4:
                    for(var d = n.j, b = r.j, l = !1, v = n.k; 4 === v.$;)l = !0, "object" != typeof d ? d = [
                        d,
                        v.j
                    ] : d.push(v.j), v = v.k;
                    for(var h = r.k; 4 === h.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        h.j
                    ] : b.push(h.j), h = h.k;
                    return l && d.length !== b.length ? void zr(t, 0, e, r) : ((l ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(d, b) : d === b) || zr(t, 2, e, b), void Xr(v, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && zr(t, 3, e, r.a));
                case 1:
                    return void jr(n, r, t, e, Mr);
                case 2:
                    return void jr(n, r, t, e, Rr);
                case 3:
                    if (n.h !== r.h) return void zr(t, 0, e, r);
                    var g = qr(n.d, r.d);
                    g && zr(t, 4, e, g);
                    var $ = r.i(n.g, r.g);
                    return void ($ && zr(t, 5, e, $));
            }
        }
    }
    function jr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = qr(n.d, r.d);
            a && zr(t, 4, e, a), u(n, r, t, e);
        } else zr(t, 0, e, r);
    }
    function qr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], c = r[u];
                a === c && "value" !== u && "checked" !== u || "a0" === t && Er(a, c) || ((e = e || {})[u] = c);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = qr(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Mr(n, r, t, e) {
        var u = n.e, a = r.e, c = u.length, i = a.length;
        c > i ? zr(t, 6, e, {
            v: i,
            i: c - i
        }) : i > c && zr(t, 7, e, {
            v: c,
            e: a
        });
        for(var o = i > c ? c : i, f = 0; o > f; f++){
            var s = u[f];
            Xr(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Rr(n, r, t, e) {
        for(var u = [], a = {}, c = [], i = n.e, o = r.e, f = i.length, s = o.length, d = 0, b = 0, l = e; f > d && s > b;){
            var v = (A = i[d]).a, h = (P = o[b]).a, g = A.b, $ = P.b, m = void 0, p = void 0;
            if (v !== h) {
                var w = i[d + 1], k = o[b + 1];
                if (w) {
                    var _ = w.a, y = w.b;
                    p = h === _;
                }
                if (k) {
                    var x = k.a, H = k.b;
                    m = v === x;
                }
                if (m && p) Xr(g, H, u, ++l), Dr(a, u, v, $, b, c), l += g.b || 0, Fr(a, u, v, y, ++l), l += y.b || 0, d += 2, b += 2;
                else if (m) l++, Dr(a, u, h, $, b, c), Xr(g, H, u, l), l += g.b || 0, d += 1, b += 2;
                else if (p) Fr(a, u, v, g, ++l), l += g.b || 0, Xr(y, $, u, ++l), l += y.b || 0, d += 2, b += 1;
                else {
                    if (!w || _ !== x) break;
                    Fr(a, u, v, g, ++l), Dr(a, u, h, $, b, c), l += g.b || 0, Xr(y, H, u, ++l), l += y.b || 0, d += 2, b += 2;
                }
            } else Xr(g, $, u, ++l), l += g.b || 0, d++, b++;
        }
        for(; f > d;){
            var A;
            l++, Fr(a, u, (A = i[d]).a, g = A.b, l), l += g.b || 0, d++;
        }
        for(; s > b;){
            var P, B = B || [];
            Dr(a, u, (P = o[b]).a, P.b, void 0, B), b++;
        }
        (u.length > 0 || c.length > 0 || B) && zr(t, 8, e, {
            w: u,
            x: c,
            y: B
        });
    }
    var Or = "_elmW6BL";
    function Dr(n, r, t, e, u, a) {
        var c = n[t];
        if (!c) return a.push({
            r: u,
            A: c = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = c);
        if (1 === c.c) {
            a.push({
                r: u,
                A: c
            }), c.c = 2;
            var i = [];
            return Xr(c.z, e, i, c.r), c.r = u, void (c.s.s = {
                w: i,
                A: c
            });
        }
        Dr(n, r, t + Or, e, u, a);
    }
    function Fr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var c = [];
                return Xr(e, a.z, c, u), void zr(r, 9, u, {
                    w: c,
                    A: a
                });
            }
            Fr(n, r, t + Or, e, u);
        } else {
            var i = zr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function Vr(n, r, t, e) {
        Zr(n, r, t, 0, 0, r.b, e);
    }
    function Zr(n, r, t, e, u, a, c) {
        for(var i = t[e], o = i.r; o === u;){
            var f = i.$;
            if (1 === f) Vr(n, r.k, i.s, c);
            else if (8 === f) i.t = n, i.u = c, (s = i.s.w).length > 0 && Zr(n, r, s, 0, u, a, c);
            else if (9 === f) {
                i.t = n, i.u = c;
                var s, d = i.s;
                d && (d.A.s = n, (s = d.w).length > 0 && Zr(n, r, s, 0, u, a, c));
            } else i.t = n, i.u = c;
            if (!(i = t[++e]) || (o = i.r) > a) return e;
        }
        var b = r.$;
        if (4 === b) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return Zr(n, l, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var v = r.e, h = n.childNodes, g = 0; v.length > g; g++){
            u++;
            var $ = 1 === b ? v[g] : v[g].b, m = u + ($.b || 0);
            if (!(u > o || o > m || (i = t[e = Zr(h[g], $, t, e, u, m, c)]) && (o = i.r) <= a)) return e;
            u = m;
        }
        return e;
    }
    function Gr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Yr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Yr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Br(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Nr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Gr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, c = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Br(a[e], r.u), c);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Gr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = ar.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                cr(t, 2 === u.c ? u.s : Br(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Gr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var c = u[a], i = c.A, o = 2 === i.c ? i.s : Br(i.z, r.u);
                        n.insertBefore(o, n.childNodes[c.r]);
                    }
                    return e && cr(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function Ur(n) {
        if (3 === n.nodeType) return ir(n.textContent);
        if (1 !== n.nodeType) return ir("");
        for(var r = w, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = k(A2(hr, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), c = w, i = n.childNodes;
        for(e = i.length; e--;)c = k(Ur(i[e]), c);
        return A3(fr, a, r, c);
    }
    var Qr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, c) {
            var i = A2(hn, n, r ? r.flags : void 0);
            _e(i) || u(2);
            var o = {}, f = t(i.a), s = f.a, d = c(l, s), b = function(n, r) {
                var t;
                for(var e in qn){
                    var u = qn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Mn(u, r);
                }
                return t;
            }(o, l);
            function l(n, r) {
                var t = A2(e, n, s);
                d(s = t.a, r), Yn(o, t.b, a(s));
            }
            return Yn(o, f.b, a(s)), b ? {
                ports: b
            } : {};
        }(r, e, n.hw, n.cv, n.is, function(r, t) {
            var u = n.iP, a = e.node, c = Ur(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Jr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Jr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Xr(n, r, t, 0), t;
                }(c, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Vr(n, r, t, e), Gr(n, t));
                }(a, c, e, r), c = t;
            });
        });
    }), Jr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Kr = F2(function(n, r) {
        var t = "g";
        n.hU && (t += "m"), n.gw && (t += "i");
        try {
            return st(RegExp(r, t));
        } catch (n) {
            return dt;
        }
    }), Wr = F2(function(n, r) {
        return null !== r.match(n);
    }), nt = F3(function(n, r, t) {
        for(var e, u = [], a = 0, c = t, i = r.lastIndex, o = -1; a++ < n && (e = r.exec(c)) && o != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var d = e[f];
                s[--f] = d ? st(d) : dt;
            }
            u.push(A4(Ou, e[0], e.index, a, y(s))), o = r.lastIndex;
        }
        return r.lastIndex = i, y(u);
    }), rt = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var c = arguments[e];
                a[--e] = c ? st(c) : dt;
            }
            return t(A4(Ou, r, arguments[arguments.length - 2], u, y(a)));
        });
    }), tt = 1 / 0, et = F5(function(n, r, t, e, u) {
        for(var a = n.length, c = u.length >= r + a, i = 0; c && a > i;){
            var o = u.charCodeAt(r);
            c = n[i++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[i++] === u[r++] : 1));
        }
        return g(c ? r : -1, t, e);
    }), ut = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), at = F5(function(n, r, t, e, u) {
        for(var a = u.indexOf(n, r), c = 0 > a ? u.length : a + n.length; c > r;){
            var i = u.charCodeAt(r++);
            10 === i ? (e = 1, t++) : (e++, 55296 == (63488 & i) && r++);
        }
        return g(a, t, e);
    }), ct = F3(function(n, r, t) {
        return Bn(function(e) {
            function u(n) {
                e(r(t.b2.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Pi);
            }), a.addEventListener("timeout", function() {
                u(Li);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? Ai : xi, function(n) {
                        return {
                            bi: n.responseURL,
                            fV: n.status,
                            ip: n.statusText,
                            a6: it(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.b2.b, a));
            }), Ii(t.f1) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || Tn(A2(Ti, n, h(t, Ni({
                        $9: e.loaded,
                        dO: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || Tn(A2(Ti, n, h(t, Bi({
                        ib: e.loaded,
                        dO: e.lengthComputable ? st(e.total) : dt
                    }))));
                });
            }(n, a, t.f1.a);
            try {
                a.open(t.x, t.bi, !0);
            } catch (n) {
                return u(Hi(t.bi));
            }
            return function(n, r) {
                for(var t = r.a6; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.bh.a || 0, n.responseType = r.b2.d, n.withCredentials = r.gp;
            }(a, t), t.n.a && a.setRequestHeader("Content-Type", t.n.a), a.send(t.n.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function it(n) {
        if (!n) return Gc;
        for(var r = Gc, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var c = u.substring(0, a), i = u.substring(a + 2);
                r = A3(Ri, c, function(n) {
                    return st(Ii(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var ot = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), ft = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), st = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dt = {
        $: 1
    }, bt = _, lt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(lt, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), vt = function(n) {
        return A3(lt, F3(function(n, r, t) {
            return A2(bt, h(n, r), t);
        }), w, n);
    }, ht = function(n) {
        return A3(lt, F3(function(n, r, t) {
            return A2(bt, n, t);
        }), w, n);
    }, gt = function(n) {
        return ht(n);
    }, $t = 1, mt = 2, pt = 0, wt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), _t = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), yt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), xt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ht = function(n) {
        return {
            $: 2,
            a: n
        };
    }, At = B, Pt = V, Bt = m, Nt = yn, Lt = Q, It = F2(function(n, r) {
        return A2(D, n, x(r));
    }), Tt = F2(function(n, r) {
        return y(A2(O, n, r));
    }), St = function(n) {
        return A2(It, "\n    ", A2(Tt, "\n", n));
    }, Ct = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Et = function(n) {
        return A3(Ct, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, zt = H, Xt = F3(function(n, r, t) {
        for(;;){
            if (f(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(bt, r, t);
            n = e, r = u, t = a;
        }
    }), jt = F2(function(n, r) {
        return A3(Xt, n, r, w);
    }), qt = F2(function(n, r) {
        return A3(zt, n, A2(jt, 0, Et(r) - 1), r);
    }), Mt = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Rt = function(n) {
        var r = Mt(n);
        return r >= 97 && 122 >= r;
    }, Ot = function(n) {
        var r = Mt(n);
        return 90 >= r && r >= 65;
    }, Dt = function(n) {
        return Rt(n) || Ot(n);
    }, Ft = function(n) {
        var r = Mt(n);
        return 57 >= r && r >= 48;
    }, Vt = function(n) {
        return Rt(n) || Ot(n) || Ft(n);
    }, Zt = function(n) {
        return A3(Ct, bt, w, n);
    }, Gt = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? dt : st(55296 > r || r > 56319 ? h(n[0], n.slice(1)) : h(n[0] + n[1], n.slice(2)));
    }, Yt = F2(function(n, r) {
        return "\n\n(" + Lt(n + 1) + ") " + St(Ut(r));
    }), Ut = function(n) {
        return A2(Qt, n, w);
    }, Qt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n = Gt(t);
                    if (1 === n.$) return !1;
                    var r = n.a, e = r.b;
                    return Dt(r.a) && A2(Pt, Vt, e);
                }();
                n = e, r = A2(bt, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + Lt(n.a) + "]";
                n = e, r = A2(bt, a, r);
                continue n;
            case 2:
                var c = n.a;
                if (c.b) {
                    if (c.b.b) {
                        var i = (r.b ? "The Json.Decode.oneOf at json" + A2(It, "", Zt(r)) : "Json.Decode.oneOf") + " failed in the following " + Lt(Et(c)) + " ways:";
                        return A2(It, "\n\n", A2(bt, i, A2(qt, Yt, c)));
                    }
                    n = e = c.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(It, "", Zt(r)) : "!");
            default:
                var o = n.a, f = n.b;
                return (i = r.b ? "Problem with the value at json" + A2(It, "", Zt(r)) + ":\n\n    " : "Problem with the given value:\n\n") + St(A2(Nt, 4, f)) + "\n\n" + o;
        }
    }), Jt = 32, Kt = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Wt = [], ne = T, re = F2(function(n, r) {
        return E(r) / E(n);
    }), te = function(n) {
        return n;
    }, ee = ne(A2(re, 2, Jt)), ue = A4(Kt, 0, ee, Wt, Wt), ae = t, ce = F2(function(n, r) {
        return n(r);
    }), ie = F2(function(n, r) {
        return r(n);
    }), oe = i, fe = S, se = function(n) {
        return n.length;
    }, de = d, be = F2(function(n, r) {
        return f(n, r) > 0 ? n : r;
    }), le = N, ve = e, he = F2(function(n, r) {
        for(;;){
            var t = A2(ve, Jt, n), e = t.b, u = A2(bt, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Zt(u);
            n = e, r = u;
        }
    }), ge = function(n) {
        return n.a;
    }, $e = F2(function(n, r) {
        for(;;){
            var t = ne(r / Jt);
            if (1 === t) return A2(ve, Jt, n).a;
            n = A2(he, n, w), r = t;
        }
    }), me = F2(function(n, r) {
        if (r.o) {
            var t = r.o * Jt, e = fe(A2(re, Jt, t - 1)), u = n ? Zt(r.t) : r.t, a = A2($e, u, r.o);
            return A4(Kt, se(r.r) + t, A2(be, 5, e * ee), a, r.r);
        }
        return A4(Kt, se(r.r), ee, Wt, r.r);
    }), pe = s, we = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(me, !1, {
                t: e,
                o: t / Jt | 0,
                r: u
            });
            var a = {
                $: 1,
                a: A3(ae, Jt, r, n)
            };
            r -= Jt, e = A2(bt, a, e);
        }
    }), ke = F2(function(n, r) {
        if (n > 0) {
            var t = n % Jt;
            return A5(we, r, n - t - Jt, n, w, A3(ae, t, n - t, r));
        }
        return ue;
    }), _e = function(n) {
        return !n.$;
    }, ye = cn, xe = W, He = on, Ae = fn, Pe = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Be = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Ne = function(n) {
        return n;
    }, Le = F6(function(n, r, t, e, u, a) {
        return {
            hd: a,
            aL: r,
            p: e,
            aP: t,
            aQ: n,
            h9: u
        };
    }), Ie = Z, Te = function(n) {
        return n.length;
    }, Se = F, Ce = F2(function(n, r) {
        return 1 > n ? r : A3(Se, n, Te(r), r);
    }), Ee = U, ze = function(n) {
        return "" === n;
    }, Xe = F2(function(n, r) {
        return 1 > n ? "" : A3(Se, 0, n, r);
    }), je = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return dt;
            r = 10 * r + a - 48;
        }
        return u == e ? dt : st(45 == t ? -r : r);
    }, qe = F5(function(n, r, t, e, u) {
        if (ze(u) || A2(Ie, "@", u)) return dt;
        var a = A2(Ee, ":", u);
        if (a.b) {
            if (a.b.b) return dt;
            var c = a.a, i = je(A2(Ce, c + 1, u));
            if (1 === i.$) return dt;
            var o = i;
            return st(A6(Le, n, A2(Xe, c, u), o, r, t, e));
        }
        return st(A6(Le, n, u, dt, r, t, e));
    }), Me = F4(function(n, r, t, e) {
        if (ze(e)) return dt;
        var u = A2(Ee, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(qe, n, A2(Ce, a, e), r, t, A2(Xe, a, e));
        }
        return A5(qe, n, "/", r, t, e);
    }), Re = F3(function(n, r, t) {
        if (ze(t)) return dt;
        var e = A2(Ee, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(Me, n, st(A2(Ce, u + 1, t)), r, A2(Xe, u, t));
        }
        return A4(Me, n, dt, r, t);
    }), Oe = F2(function(n, r) {
        if (ze(r)) return dt;
        var t = A2(Ee, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(Re, n, st(A2(Ce, e + 1, r)), A2(Xe, e, r));
        }
        return A3(Re, n, dt, r);
    }), De = G, Fe = function(n) {
        return A2(De, "http://", n) ? A2(Oe, 0, A2(Ce, 7, n)) : A2(De, "https://", n) ? A2(Oe, 1, A2(Ce, 8, n)) : dt;
    }, Ve = function() {
        for(;;);
    }, Ze = Pn, Ge = Ze(0), Ye = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var c = a.a, i = a.b;
                if (i.b) {
                    var o = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, c, A2(n, o, A2(n, f.a, t > 500 ? A3(Ct, n, r, Zt(s)) : A4(Ye, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, c, A2(n, o, r)));
                }
                return A2(n, u, A2(n, c, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Ue = F3(function(n, r, t) {
        return A4(Ye, n, r, 0, t);
    }), Qe = F2(function(n, r) {
        return A3(Ue, F2(function(r, t) {
            return A2(bt, n(r), t);
        }), w, r);
    }), Je = Nn, Ke = F2(function(n, r) {
        return A2(Je, function(r) {
            return Ze(n(r));
        }, r);
    }), We = F3(function(n, r, t) {
        return A2(Je, function(r) {
            return A2(Je, function(t) {
                return Ze(A2(n, r, t));
            }, t);
        }, r);
    }), nu = Rn, ru = F2(function(n, r) {
        var t = r;
        return function(n) {
            return Bn(function(r) {
                r(Pn(Tn(n)));
            });
        }(A2(Je, nu(n), t));
    });
    qn.Task = {
        b: Ge,
        c: F3(function(n, r) {
            var t;
            return A2(Ke, function() {
                return 0;
            }, (t = A2(Qe, ru(n), r), A3(Ue, We(bt), Ze(w), t)));
        }),
        d: F3(function() {
            return Ze(0);
        }),
        e: F2(function(n, r) {
            return A2(Ke, n, r);
        }),
        f: undefined
    };
    var tu, eu, uu = Dn("Task"), au = F2(function(n, r) {
        return uu(A2(Ke, n, r));
    }), cu = Qr, iu = en, ou = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fu = function(n) {
        switch(n){
            case "de":
                return ou(0);
            case "en":
                return ou(1);
            case "es":
                return ou(2);
            case "fr":
                return ou(3);
            case "ru":
                return ou(4);
            default:
                return {
                    $: 1,
                    a: n
                };
        }
    }, su = {
        $: 0
    }, du = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), bu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lu = F3(function(n, r, t) {
        return n(r(t));
    }), vu = Ln, hu = F2(function(n, r) {
        return uu(A2(vu, A2(lu, A2(lu, Ze, n), wt), A2(Je, A2(lu, A2(lu, Ze, n), xt), r)));
    }), gu = F3(function(n, r, t) {
        return {
            cX: t,
            dC: n,
            dL: r
        };
    }), $u = function(n) {
        return A3(Ct, F2(function(n, r) {
            return A3(Hn, n.a, n.b, r);
        }), {}, n);
    }, mu = function(n) {
        var r = n;
        return {
            a1: r.a1,
            cV: function(n) {
                return $u(Zt(r.cV(n)));
            }
        };
    }, pu = F3(function(n, r, t) {
        return r(n(t));
    }), wu = function(n) {
        return n.a1;
    }, ku = function(n) {
        return n.cV;
    }, _u = F3(function(n, r, t) {
        return {
            a1: A2(ye, A2(pu, n, wu), wu(t)),
            cV: A2(lu, ku(t), r)
        };
    }), yu = C, xu = X, Hu = function(n) {
        return A2(xu, n, "");
    }, Au = F3(function(n, r, t) {
        return n > 0 ? A3(Au, n >> 1, p(r, r), 1 & n ? p(t, r) : t) : t;
    }), Pu = F2(function(n, r) {
        return A3(Au, n, r, "");
    }), Bu = F3(function(n, r, t) {
        return p(A2(Pu, n - Te(t), Hu(r)), t);
    }), Nu = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, Lu = I, Iu = function(n) {
        var r = function(n) {
            return 10 > n ? Lt(n) : Hu(Nu(87 + n));
        };
        return 16 > n ? r(n) : p(Iu(n / 16 | 0), r(A2(Lu, 16, n)));
    }, Tu = A2(pu, Iu, A2(Bu, 2, "0")), Su = function(n) {
        var r = function(n) {
            return {
                a_: n.d,
                cG: n.c,
                c3: n.b,
                dH: n.a
            };
        }(n), t = r.cG, e = r.c3, u = r.dH;
        return A2(It, "", A2(bt, "#", A2(Qe, A2(pu, yu, Tu), y([
            255 * u,
            255 * e,
            255 * t
        ]))));
    }, Cu = F2(function(n) {
        return n;
    }), Eu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zu = null, Xu = function(n) {
        return {
            a1: Eu(n),
            cV: Cu(zu)
        };
    }, ju = F2(function(n, r) {
        return r.$ ? dt : n(r.a);
    }), qu = F2(function(n, r) {
        return r.$ ? wt(r.a) : n(r.a);
    }), Mu = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(bt, e.a, t);
    }), Ru = F2(function(n, r) {
        return A3(Ue, Mu(n), w, r);
    }), Ou = F4(function(n, r, t, e) {
        return {
            d: r,
            fe: n,
            hX: t,
            dS: e
        };
    }), Du = nt, Fu = F2(function(n, r) {
        return r.$ ? wt(n) : xt(r.a);
    }), Vu = Kr, Zu = function(n) {
        return A2(Vu, {
            gw: !1,
            hU: !1
        }, n);
    }, Gu = function(n) {
        return n.b ? st(n.a) : dt;
    }, Yu = F2(function(n, r) {
        return r.$ ? dt : st(n(r.a));
    }), Uu = F2(function(n, r) {
        return r.$ ? wt(r.a) : xt(n(r.a));
    }), Qu = F2(function(n, r) {
        return Mt(r) - Mt(n);
    }), Ju = F3(function(n, r, t) {
        var e = Mt(t);
        return 1 > f(Mt(n), e) && 1 > f(e, Mt(r));
    }), Ku = F2(function(n, r) {
        var t = function(t) {
            return 0 > f(t, n) ? xt(t) : wt({
                $: 1,
                a: r
            });
        }, e = A3(Ju, "0", "9", r) ? xt(A2(Qu, "0", r)) : A3(Ju, "a", "z", r) ? xt(10 + A2(Qu, "a", r)) : A3(Ju, "A", "Z", r) ? xt(10 + A2(Qu, "A", r)) : wt({
            $: 0,
            a: r
        });
        return A2(qu, t, e);
    }), Wu = F2(function(n, r) {
        var t = Gt(r);
        if (1 === t.$) return xt(0);
        var e = t.a, u = e.b;
        return A2(qu, function(r) {
            return A2(qu, function(t) {
                return xt(r + t * n);
            }, A2(Wu, n, u));
        }, A2(Ku, n, e.a));
    }), na = function(n) {
        for(var r = n.length, t = Array(r), e = 0; r > e;){
            var u = n.charCodeAt(e);
            55296 > u || u > 56319 ? (t[r - e] = n[e], e++) : (t[r - e] = n[e + 1], t[r - ++e] = n[e - 1], e++);
        }
        return t.join("");
    }, ra = F2(function(n, r) {
        return 2 > n || n > 36 ? wt({
            $: 2,
            a: n
        }) : A2(Wu, n, na(r));
    }), ta = ra(16), ea = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ua = F3(function(n, r, t) {
        return A4(ea, n, r, t, 1);
    }), aa = F4(function(n, r, t, e) {
        return A4(ea, n, r, t, e);
    }), ca = L, ia = F2(function(n, r) {
        var t = A2(ca, 10, n);
        return yu(r * t) / t;
    }), oa = R, fa = function(n) {
        return A3(oa, bt, w, n);
    }, sa = function(n) {
        return n.toLowerCase();
    }, da = (tu = function(n) {
        var r = fa(n);
        if (r.b && !r.b.b) {
            var t = r.a;
            return x(y([
                t,
                t
            ])).join("");
        }
        return n;
    }, A2(pu, sa, A2(pu, function(n) {
        return A2(Yu, function(r) {
            return A3(Du, 1, r, n);
        }, Zu("^#?(?:(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))|(?:([a-f\\d])([a-f\\d])([a-f\\d]))|(?:([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2}))|(?:([a-f\\d])([a-f\\d])([a-f\\d])([a-f\\d])))$"));
    }, A2(pu, ju(Gu), A2(pu, Yu(function(n) {
        return n.dS;
    }), A2(pu, Yu(Ru(Ne)), A2(pu, Fu("Parsing hex regex failed"), qu(function(n) {
        var r = A2(Qe, A2(pu, tu, A2(pu, ta, Uu(te))), n);
        n: for(;;){
            if (r.b && !r.a.$ && r.b.b && !r.b.a.$ && r.b.b.b && !r.b.b.a.$) {
                if (r.b.b.b.b) {
                    if (r.b.b.b.a.$ || r.b.b.b.b.b) break n;
                    var t = r.b, e = t.b;
                    return xt(A4(aa, r.a.a / 255, t.a.a / 255, e.a.a / 255, A2(ia, 2, e.b.a.a / 255)));
                }
                var u = r.b;
                return xt(A3(ua, r.a.a / 255, u.a.a / 255, u.b.a.a / 255));
            }
            break n;
        }
        return wt("Parsing ints from hex failed");
    })))))))), ba = function(n) {
        return 7 === Te(n) ? da(n) : wt("Parsing hex regex failed");
    }, la = F2(function(n, r) {
        return {
            a1: r,
            cV: n
        };
    }), va = tn, ha = xn, ga = A2(la, ha, va), $a = function(n) {
        return {
            a1: Pe(n),
            cV: function() {
                return zu;
            }
        };
    }, ma = F3(function(n, r, t) {
        return t.$ ? n(t.a) : r(t.a);
    }), pa = A3(_u, A2(lu, A2(ma, Xu, $a), ba), Su, ga), wa = F4(function(n, r, t, e) {
        var u = e;
        return {
            a1: A3(Ae, F2(function(n, r) {
                return n(r);
            }), u.a1, A2(iu, n, wu(t))),
            cV: function(e) {
                return A2(bt, h(n, A2(ku, t, r(e))), u.cV(e));
            }
        };
    }), ka = function(n) {
        return {
            a1: Pe(n),
            cV: function() {
                return w;
            }
        };
    }, _a = mu(A4(wa, "error", function(n) {
        return n.cX;
    }, pa, A4(wa, "secondary", function(n) {
        return n.dL;
    }, pa, A4(wa, "primary", function(n) {
        return n.dC;
    }, pa, ka(gu))))), ya = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xa = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Ha = function(n) {
        return A2(It, "", n);
    }, Aa = function(n) {
        return function(n) {
            switch(n.$){
                case 0:
                    return "expecting '" + n.a + "'";
                case 1:
                    return "expecting int";
                case 2:
                    return "expecting hex";
                case 3:
                    return "expecting octal";
                case 4:
                    return "expecting binary";
                case 5:
                    return "expecting float";
                case 6:
                    return "expecting number";
                case 7:
                    return "expecting variable";
                case 8:
                    return "expecting symbol '" + n.a + "'";
                case 9:
                    return "expecting keyword '" + n.a + "'";
                case 10:
                    return "expecting end";
                case 11:
                    return "unexpected char";
                case 12:
                    return "problem " + n.a;
                default:
                    return "bad repeat";
            }
        }(n.h7) + " at row " + Lt(n.ih) + ", col " + Lt(n.eo);
    }, Pa = F2(function(n, r) {
        if (r.b) {
            var t = r.b;
            return A2(bt, r.a, A3(Ue, F2(function(r, t) {
                return A2(bt, n, A2(bt, r, t));
            }), w, t));
        }
        return w;
    }), Ba = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Na = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), La = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Ba, e.a, e.b);
            var u = e.a, a = e.c, c = n(e.b)(a);
            if (1 === c.$) {
                var i = c.a;
                return A2(Ba, u || i, c.b);
            }
            return i = c.a, A3(Na, u || i, c.b, c.c);
        };
    }), Ia = La, Ta = {
        $: 10
    }, Sa = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ca = F4(function(n, r, t, e) {
        return {
            eo: r,
            gI: e,
            h7: t,
            ih: n
        };
    }), Ea = {
        $: 0
    }, za = F2(function(n, r) {
        return A2(Sa, Ea, A4(Ca, n.ih, n.eo, r, n.gH));
    }), Xa = function(n) {
        return function(r) {
            return a(Te(r.dP), r.f) ? A3(Na, !1, 0, r) : A2(Ba, !1, A2(za, r, n));
        };
    }, ja = Xa(Ta), qa = ut, Ma = function(n) {
        return -n;
    }, Ra = F5(function(n, r, t, e, u) {
        for(;;){
            var c = A3(qa, n, r, u.dP);
            if (a(c, -1)) return A3(Na, 0 > f(u.f, r), 0, {
                eo: e,
                gH: u.gH,
                j: u.j,
                f: r,
                ih: t,
                dP: u.dP
            });
            a(c, -2) ? (r += 1, t += 1, e = 1) : (r = c, e += 1);
        }
    }), Oa = function(n) {
        return function(r) {
            return A5(Ra, n, r.f, r.ih, r.eo, r);
        };
    }, Da = Oa, Fa = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Ba, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(Na, e.a, A2(n, A3(Se, r.f, a.f, r.dP), u), a);
        };
    }), Va = function(n) {
        return A2(Fa, Cu, n);
    }, Za = Va, Ga = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Ya = function(n) {
        return function(r) {
            return A2(Ba, !1, A2(za, r, n));
        };
    }, Ua = function(n) {
        return Ya(Ga(n));
    }, Qa = function(n) {
        return function(r) {
            return A3(Na, !1, n, r);
        };
    }, Ja = Qa, Ka = A2(Ia, function(n) {
        if (Te(n) > 9) return Ua("Expected at most 9 digits, but got " + Lt(Te(n)));
        var r = function(n) {
            if (0 === n.length || /[\sxbo]/.test(n)) return dt;
            var r = +n;
            return r == r ? st(r) : dt;
        }("0." + n);
        return r.$ ? Ua('Invalid float: "' + n + '"') : Ja(yu(1e3 * r.a));
    }, Za(Da(Ft))), Wa = Ne, nc = F6(function(n, r, t, e, u, a) {
        return Wa(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), rc = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Ba, t.a, t.b);
            var a = t.a, c = t.b, i = u(t.c);
            if (1 === i.$) {
                var o = i.a;
                return A2(Ba, a || o, i.b);
            }
            o = i.a;
            var f = i.c;
            return A3(Na, a || o, A2(n, c, i.b), f);
        };
    }), tc = F2(function(n, r) {
        return A3(rc, Cu, n, r);
    }), ec = tc, uc = F2(function(n, r) {
        return A3(rc, ce, n, r);
    }), ac = uc, cc = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ic = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(cc, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(Ba, !1, r);
        }
    }), oc = function(n) {
        return function(r) {
            return A3(ic, r, Ea, n);
        };
    }, fc = oc, sc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bc = j, lc = {
        $: 11
    }, vc = F2(function(n, r) {
        return function(t) {
            var e = A3(qa, n, t.f, t.dP);
            return a(e, -1) ? A2(Ba, !1, A2(za, t, r)) : a(e, -2) ? A3(Na, !0, 0, {
                eo: 1,
                gH: t.gH,
                j: t.j,
                f: t.f + 1,
                ih: t.ih + 1,
                dP: t.dP
            }) : A3(Na, !0, 0, {
                eo: t.eo + 1,
                gH: t.gH,
                j: t.j,
                f: e,
                ih: t.ih,
                dP: t.dP
            });
        };
    }), hc = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(Ba, n || a, u.b);
            var a = u.a, c = u.b, i = u.c;
            if (c.$) return A3(Na, n || a, c.a, i);
            n = n || a, r = c.a, e = i;
        }
    }), gc = F2(function(n, r) {
        return function(t) {
            return A4(hc, !1, n, r, t);
        };
    }), $c = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Ba, e.a, e.b);
            var u = e.c;
            return A3(Na, e.a, n(e.b), u);
        };
    }), mc = $c, pc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kc = function(n) {
        return n.$ ? pc(n.a) : wc(n.a);
    }, _c = F2(function(n, r) {
        return A2(gc, n, function(n) {
            return A2(mc, kc, r(n));
        });
    }), yc = function(n) {
        return A2(_c, "", function(r) {
            if (a(Te(r), n)) {
                var t = je(r);
                return t.$ ? Ua('Invalid integer: "' + r + '"') : A2(mc, sc, Ja(t.a));
            }
            return A2(mc, function(n) {
                return dc(A2(bc, r, n));
            }, Za(A2(vc, Ft, lc)));
        });
    }, xc = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Hc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ac = et, Pc = function(n) {
        return !n;
    }, Bc = function(n) {
        var r = n.a, t = n.b, e = !ze(r);
        return function(n) {
            var u = A5(Ac, r, n.f, n.ih, n.eo, n.dP), c = u.a, i = u.b, o = u.c;
            return a(c, -1) ? A2(Ba, !1, A2(za, n, t)) : A3(Na, e, 0, {
                eo: o,
                gH: n.gH,
                j: n.j,
                f: c,
                ih: i,
                dP: n.dP
            });
        };
    }, Nc = Bc, Lc = function(n) {
        return Nc(A2(Hc, n, xc(n)));
    }, Ic = function(n) {
        return Ua("Invalid day: " + Lt(n));
    }, Tc = o, Sc = function(n) {
        return !(A2(Lu, 4, n) || !A2(Lu, 100, n) && A2(Lu, 400, n));
    }, Cc = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, Ec = A2(Ia, function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return Ic(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !Sc(r) ? e - 1 : e) + (Cc(r) - Cc(1970)));
            return Ja(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? Ic(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !Sc(r) ? Ic(e) : u(26784e5);
            case 3:
                return e > 31 ? Ic(e) : u(50976e5);
            case 4:
                return e > 30 ? Ic(e) : u(7776e6);
            case 5:
                return e > 31 ? Ic(e) : u(10368e6);
            case 6:
                return e > 30 ? Ic(e) : u(130464e5);
            case 7:
                return e > 31 ? Ic(e) : u(156384e5);
            case 8:
                return e > 31 ? Ic(e) : u(183168e5);
            case 9:
                return e > 30 ? Ic(e) : u(209952e5);
            case 10:
                return e > 31 ? Ic(e) : u(235872e5);
            case 11:
                return e > 30 ? Ic(e) : u(262656e5);
            case 12:
                return e > 31 ? Ic(e) : u(288576e5);
            default:
                return Ua('Invalid month: "' + Lt(t) + '"');
        }
    }, A2(ac, A2(ac, A2(ac, Ja(F3(function(n, r, t) {
        return g(n, r, t);
    })), yc(4)), fc(y([
        A2(ac, A2(ec, Ja(Ne), Lc("-")), yc(2)),
        yc(2)
    ]))), fc(y([
        A2(ac, A2(ec, Ja(Ne), Lc("-")), yc(2)),
        yc(2)
    ])))), zc = (eu = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(ac, Ja(Ne), fc(y([
        A2(mc, function() {
            return 0;
        }, Lc("Z")),
        A2(ac, A2(ac, A2(ac, Ja(eu), fc(y([
            A2(mc, function() {
                return 1;
            }, Lc("+")),
            A2(mc, function() {
                return -1;
            }, Lc("-"))
        ]))), yc(2)), fc(y([
            A2(ac, A2(ec, Ja(Ne), Lc(":")), yc(2)),
            yc(2),
            Ja(0)
        ]))),
        A2(ec, Ja(0), ja)
    ])))), Xc = A2(Ia, function(n) {
        return fc(y([
            A2(ac, A2(ac, A2(ac, A2(ac, A2(ac, A2(ec, Ja(nc(n)), Lc("T")), yc(2)), fc(y([
                A2(ac, A2(ec, Ja(Ne), Lc(":")), yc(2)),
                yc(2)
            ]))), fc(y([
                A2(ac, A2(ec, Ja(Ne), Lc(":")), yc(2)),
                yc(2),
                Ja(0)
            ]))), fc(y([
                A2(ac, A2(ec, Ja(Ne), Lc(".")), Ka),
                Ja(0)
            ]))), A2(ec, zc, ja)),
            A2(ec, Ja(A6(nc, n, 0, 0, 0, 0, 0)), ja)
        ]));
    }, Ec), jc = F3(function(n, r, t) {
        return {
            eo: r,
            h7: t,
            ih: n
        };
    }), qc = function(n) {
        return A3(jc, n.ih, n.eo, n.h7);
    }, Mc = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(bt, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Mc, e, r);
                continue n;
        }
    }), Rc = F2(function(n, r) {
        var t = n({
            eo: 1,
            gH: w,
            j: 1,
            f: 0,
            ih: 1,
            dP: r
        });
        return t.$ ? wt(A2(Mc, t.b, w)) : xt(t.b);
    }), Oc = F2(function(n, r) {
        var t = A2(Rc, n, r);
        return t.$ ? wt(A2(Qe, qc, t.a)) : xt(t.a);
    }), Dc = A2(ye, function(n) {
        var r = function(n) {
            return A2(Oc, Xc, n);
        }(n);
        return 1 === r.$ ? Eu(Ha(A2(Pa, "; ", A2(Qe, Aa, r.a)))) : Pe(r.a);
    }, va), Fc = xa(y([
        A2(He, function(n) {
            return A2(ya, n, {
                bO: !1
            });
        }, Dc),
        A3(Ae, ya, A2(iu, "closedAfter", Dc), A2(He, function(n) {
            return {
                bO: n
            };
        }, A2(iu, "allowCodes", xe)))
    ])), Vc = A2(He, fu, va), Zc = {
        $: -2
    }, Gc = Zc, Yc = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Uc = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Yc, n, r, t, e, u);
            var a = e.d;
            return c = e.e, A5(Yc, 0, e.b, e.c, A5(Yc, 1, a.b, a.c, a.d, a.e), A5(Yc, 1, r, t, c, u));
        }
        var c, i = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Yc, n, i, o, A5(Yc, 0, r, t, e, f), s) : A5(Yc, 0, r, t, A5(Yc, 1, e.b, e.c, e.d, c = e.e), A5(Yc, 1, i, o, f, s));
    }), Qc = l, Jc = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Yc, 0, n, r, Zc, Zc);
        var e = t.a, u = t.b, a = t.c, c = t.d, i = t.e;
        switch(A2(Qc, n, u)){
            case 0:
                return A5(Uc, e, u, a, A3(Jc, n, r, c), i);
            case 1:
                return A5(Yc, e, u, r, c, i);
            default:
                return A5(Uc, e, u, a, c, A3(Jc, n, r, i));
        }
    }), Kc = F3(function(n, r, t) {
        var e = A3(Jc, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Yc, 1, e.b, e.c, e.d, e.e);
    }), Wc = function(n) {
        return A3(Ct, F2(function(n, r) {
            return A3(Kc, n.a, n.b, r);
        }), Gc, n);
    }, ni = function(n) {
        return {
            $: 8,
            b: n
        };
    }, ri = function(n) {
        return A2(He, Wc, ni(n));
    }, ti = function(n) {
        return ri(n);
    }, ei = F2(function(n, r) {
        return A3(Ue, F2(function(r, t) {
            return n(r) ? A2(bt, r, t) : t;
        }), w, r);
    }), ui = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return dt;
            var e = t.b;
            if (r(t.a)) return st(n);
            n += 1, t = e;
        }
    })(0), ai = function(n) {
        return {
            $: 3,
            b: n
        };
    }, ci = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), ii = F2(function(n, r) {
        return A2(ci, function(r) {
            return a(r, n);
        }, r);
    }), oi = function(n) {
        return n.b ? st(h(n.a, n.b)) : dt;
    }, fi = function(n) {
        return A2(ye, function(n) {
            var r = oi(n);
            return 1 === r.$ ? Eu("expected non-empty list, but got []") : Pe(r.a);
        }, ai(n));
    }, si = function(n) {
        return {
            $: 5,
            c: n
        };
    }, di = function(n) {
        return xa(y([
            si(dt),
            A2(He, st, n)
        ]));
    }, bi = Ae(ie), li = F2(function(n, r) {
        return A3(Ue, iu, r, n);
    }), vi = hn, hi = rn, gi = F3(function(n, r, t) {
        var e = function(n) {
            return xa(y([
                n,
                si(t)
            ]));
        };
        return A2(ye, function(u) {
            var a = A2(vi, A2(li, n, hi), u);
            if (a.$) return Pe(t);
            var c = a.a, i = A2(vi, e(r), c);
            return i.$ ? A2(li, n, e(r)) : Pe(i.a);
        }, hi);
    }), $i = F4(function(n, r, t, e) {
        return A2(bi, A3(gi, y([
            n
        ]), r, t), e);
    }), mi = F3(function(n, r, t) {
        return A2(bi, A2(iu, n, r), t);
    }), pi = P, wi = F4(function(n, r, t, e) {
        for(;;){
            if (!t.b) return Zt(e);
            var u = t.a, a = t.b, c = n(u);
            A2(ii, c, r) ? t = a : (r = A2(bt, c, r), t = a, e = A2(bt, u, e));
        }
    }), ki = F2(function(n, r) {
        return A4(wi, n, w, r, w);
    }), _i = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), yi = A3(mi, "paymentMethods", ai(A3(Ae, F2(function(n, r) {
        return {
            bt: n,
            bL: r
        };
    }), A2(iu, "label", ti(va)), A2(iu, "value", va))), A3(mi, "live", xe, A3(mi, "colorScheme", wu(_a), A4($i, "closedAfter", di(Fc), dt, A3(mi, "closedText", ti(va), A3(mi, "confirmationText", ti(va), A3(mi, "locales", fi(Vc), Pe(F7(function(n, r, t, e, u, a, c) {
        return {
            gB: e,
            bV: t,
            eq: u,
            ag: r,
            hI: a,
            hJ: n,
            h4: function(n) {
                var r = n.eH;
                return A2(pi, function(n) {
                    return A2(_i, -1, A2(ui, oe(n.bL), y([
                        "invoice",
                        "creditcard",
                        "paypal",
                        "ec-terminal"
                    ])));
                }, A2(ki, function(n) {
                    return n.bL;
                }, A2(ei, function(n) {
                    return !A2(ii, n.bL, A2(Qe, function(n) {
                        return n.bL;
                    }, r));
                }, p(c, n.e3))));
            }
        };
    }))))))))), xi = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Hi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ai = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Pi = {
        $: 2
    }, Bi = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ni = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Li = {
        $: 1
    }, Ii = function(n) {
        return !n.$;
    }, Ti = On, Si = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return dt;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(Qc, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return st(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Ci = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, i = t.c, e = t.d, s = t.e, A5(Yc, 1, n.b, n.c, A5(Yc, 0, r.b, r.c, r.d, r.e), A5(Yc, 0, c, i, e, s));
            }
            var e, u = n.d, a = n.e, c = a.b, i = a.c, o = (e = a.d).d, f = e.e, s = a.e;
            return A5(Yc, 0, e.b, e.c, A5(Yc, 1, n.b, n.c, A5(Yc, 0, u.b, u.c, u.d, u.e), o), A5(Yc, 1, c, i, f, s));
        }
        return n;
    }, Ei = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, d = t.d, b = t.e, A5(Yc, 1, e = n.b, u = n.c, A5(Yc, 0, r.b, r.c, r.d, i = r.e), A5(Yc, 0, f, s, d, b));
            }
            var e = n.b, u = n.c, a = n.d, c = a.d, i = a.e, o = n.e, f = o.b, s = o.c, d = o.d, b = o.e;
            return A5(Yc, 0, a.b, a.c, A5(Yc, 1, c.b, c.c, c.d, c.e), A5(Yc, 1, e, u, i, A5(Yc, 0, f, s, d, b)));
        }
        return n;
    }, zi = F7(function(n, r, t, e, u, a, c) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === c.$ && 1 === c.a) {
                    if (-1 === c.d.$) {
                        if (1 === c.d.a) return Ei(r);
                        break n;
                    }
                    return Ei(r);
                }
                break n;
            }
            return r;
        }
        return A5(Yc, t, a.b, a.c, a.d, A5(Yc, 0, e, u, a.e, c));
    }), Xi = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, c = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var i = Ci(n);
                    if (-1 === i.$) {
                        var o = i.e;
                        return A5(Uc, i.a, i.b, i.c, Xi(i.d), o);
                    }
                    return Zc;
                }
                return A5(Yc, r, t, e, Xi(u), c);
            }
            return A5(Yc, r, t, e, Xi(u), c);
        }
        return Zc;
    }, ji = F2(function(n, r) {
        if (-2 === r.$) return Zc;
        var t = r.a, e = r.b, u = r.c, a = r.d, c = r.e;
        if (0 > f(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var i = a.d;
                if (-1 !== i.$ || i.a) {
                    var o = Ci(r);
                    if (-1 === o.$) {
                        var s = o.e;
                        return A5(Uc, o.a, o.b, o.c, A2(ji, n, o.d), s);
                    }
                    return Zc;
                }
                return A5(Yc, t, e, u, A2(ji, n, a), c);
            }
            return A5(Yc, t, e, u, A2(ji, n, a), c);
        }
        return A2(qi, n, A7(zi, n, r, t, e, u, a, c));
    }), qi = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, c = r.d, i = r.e;
            if (a(n, e)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === o.$ ? A5(Uc, t, o.b, o.c, c, Xi(i)) : Zc;
            }
            return A5(Uc, t, e, u, c, A2(ji, n, i));
        }
        return Zc;
    }), Mi = F2(function(n, r) {
        var t = A2(ji, n, r);
        return -1 !== t.$ || t.a ? t : A5(Yc, 1, t.b, t.c, t.d, t.e);
    }), Ri = F3(function(n, r, t) {
        var e = r(A2(Si, n, t));
        return e.$ ? A2(Mi, n, t) : A3(Kc, n, e.a, t);
    }), Oi = {
        $: 0
    }, Di = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Fi = {
        $: 2
    }, Vi = {
        $: 1
    }, Zi = vn, Gi = F2(function(n, r) {
        return r.$ ? wt(n(r.a)) : xt(r.a);
    }), Yi = A2(ot, "", Ne), Ui = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Qi = Ui, Ji = function(n) {
        return A2(ft, "application/json", A2(Nt, 0, n));
    }, Ki = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wi = function(n) {
        return n.$ ? Ki(n.a) : Ze(n.a);
    }, no = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), ro = F2(function(n, r) {
        var t = function(n) {
            var t;
            return {
                n: A3(no, Oi, Ji, r.n),
                a6: n,
                x: r.x,
                bf: (t = function() {
                    return r.a1;
                }, Yi(function(n) {
                    switch(n.$){
                        case 0:
                            return wt({
                                $: 0,
                                a: n.a
                            });
                        case 1:
                            return wt(Vi);
                        case 2:
                            return wt(Fi);
                        case 3:
                            return wt(function(n) {
                                return {
                                    $: 3,
                                    a: n
                                };
                            }(n.a.fV));
                        default:
                            var r = n.b;
                            return A2(Gi, A2(lu, Di, Ut), A2(Zi, t(), r));
                    }
                })),
                bh: dt,
                bi: p("http://localhost:8080", r.p)
            };
        };
        if (1 === n.$) return e = t(w), A3(ct, 0, Wi, {
            gp: !1,
            n: e.n,
            b2: e.bf,
            a6: e.a6,
            x: e.x,
            bh: e.bh,
            f1: dt,
            bi: e.bi
        });
        var e, u = n.a;
        return function(n) {
            return A3(ct, 0, Wi, {
                gp: !0,
                n: n.n,
                b2: n.bf,
                a6: n.a6,
                x: n.x,
                bh: n.bh,
                f1: dt,
                bi: n.bi
            });
        }(t(y([
            A2(Qi, "X-Cookie", u.gJ + "=" + u.gK)
        ])));
    }), to = F2(function(n, r) {
        return A2(ro, n, {
            n: dt,
            a1: r.a1,
            x: "GET",
            p: r.p
        });
    }), eo = function(n) {
        return A2(to, n, {
            a1: yi,
            p: "/public/settings.json"
        });
    }, uo = xa(y([
        A3(mi, "updateText", ti(va), A3(mi, "afterLogin", ti(va), A3(mi, "beforeLogin", ti(va), Pe(F3(function(n, r, t) {
            return st({
                d9: r,
                ec: n,
                iL: t
            });
        }))))),
        Pe(dt)
    ])), ao = dt, co = function(n) {
        return A2(vu, function(n) {
            return 3 === n.$ && 404 === n.a ? Ze(ao) : Ki(n);
        }, A2(to, n, {
            a1: uo,
            p: "/public/userAccountSettings.json"
        }));
    }, io = F3(function(n, r, t) {
        return A2(n, t, r);
    }), oo = F2(function(n, r) {
        return h(n, r);
    }), fo = A3(Ae, F2(function(n, r) {
        return {
            cT: r,
            e$: n
        };
    }), A2(iu, "_id", va), A2(iu, "emailAddress", va)), so = F3(function(n, r, t) {
        return h(A3(du, n, r(t), su), A2(hu, bu, A2(Je, function(r) {
            if (1 === r.$) return Ze(wt(dt));
            var t = r.a;
            return A2(Je, function(r) {
                return r.$ ? A2(Ke, A2(lu, wt, st), A2(Ke, A2(io, oo, t), eo(n.ad))) : Ze(xt(r.a));
            }, A2(vu, function(n) {
                return 3 === n.$ ? Ze(dt) : Ki(n);
            }, A2(to, n.ad, {
                a1: A2(He, st, fo),
                p: "/public/user-account/whoami"
            })));
        }, co(n.ad))));
    }), bo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ho = function(n) {
        return {
            $: 4,
            a: n
        };
    }, go = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $o = function(n) {
        return {
            $: 7,
            a: n
        };
    }, mo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, po = {
        $: 3
    }, wo = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ko = F5(function(n, r, t, e, u) {
        return {
            ef: n,
            ek: r,
            eC: t,
            e: u,
            fS: e
        };
    }), _o = function(n) {
        if (n.$) return n.a;
        switch(n.a){
            case 0:
                return "de";
            case 1:
                return "en";
            case 2:
                return "es";
            case 3:
                return "fr";
            default:
                return "ru";
        }
    }, yo = A2(lu, ha, _o), xo = A2(la, yo, Vc), Ho = oo, Ao = F3(function(n, r, t) {
        var e = t;
        return {
            a1: r(e.a1),
            cV: n(e.cV)
        };
    }), Po = F2(function(n, r) {
        return A3(Ct, An(n), [], r);
    }), Bo = A2(Ao, Po, ai), No = function(n) {
        return A2(bt, n.a, n.b);
    }, Lo = function(n) {
        return A3(_u, function(n) {
            return n.b ? $a(A2(Ho, n.a, n.b)) : Xu("expected non-empty list, but got `[]'");
        }, No, Bo(n));
    }, Io = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Lt(n.a);
    }), To = F3(function(n, r, t) {
        return 1 === r.$ ? t : p(t, p(n, r.a));
    }), So = function(n) {
        return A3(To, "#", n.hd, A3(To, "?", n.h9, p(A2(Io, n.aP, p(n.aQ ? "https://" : "http://", n.aL)), n.p)));
    }, Co = A3(_u, function(n) {
        var r = Fe(n);
        return r.$ ? Xu("expected URL, but got `" + n + "'") : $a(r.a);
    }, So, ga), Eo = mu(A4(wa, "locale", function(n) {
        return n.e;
    }, xo, A4(wa, "shopperResultUrl", function(n) {
        return n.fS;
    }, Co, A4(wa, "endpoint", function(n) {
        return n.eC;
    }, Co, A4(wa, "checkoutId", function(n) {
        return n.ek;
    }, ga, A4(wa, "brands", function(n) {
        return n.ef;
    }, Lo(ga), ka(ko))))))), zo = F5(function(n, r, t, e, u) {
        return {
            gZ: n,
            bt: r,
            fE: t,
            dY: u,
            f3: e
        };
    }), Xo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qo = nn, Mo = K, Ro = xa(y([
        A2(He, Xo, A2(iu, "flat-price", Mo)),
        A2(He, jo, A2(iu, "percentage", qo))
    ])), Oo = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Do = A2(iu, "if-num-persons", A3(Ae, Oo, A2(iu, "numPersons", Mo), A2(He, function(n) {
        return {
            go: n
        };
    }, A2(iu, "allPersons", xe)))), Fo = Gc, Vo = bn, Zo = F2(function(n, r) {
        return A3(Kc, n, 0, r);
    }), Go = function(n) {
        return A3(Ct, Zo, Fo, n);
    }, Yo = A2(lu, He(Go), ai), Uo = A6(Vo, zo, A2(iu, "discountId", va), A2(iu, "label", ti(va)), A2(iu, "rate", Ro), A2(iu, "trigger", Do), xa(y([
        A2(iu, "ticketIds", Yo(va)),
        Pe(Fo)
    ]))), Qo = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Jo = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ko = F2(function(n, r) {
        return {
            g4: r,
            hv: n
        };
    }), Wo = F6(function(n, r, t, e, u, a) {
        return {
            en: r,
            eM: e,
            hs: u,
            b4: a,
            fa: n,
            aB: t
        };
    }), nf = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ef = {
        $: 3
    }, uf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, af = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cf = function(n) {
        return {
            $: 5,
            a: n
        };
    }, of = function(n) {
        return A2(ye, n, Pe(0));
    };
    function ff() {
        var n = A2(He, af, A2(ye, A2(pu, Zt, Pe), ni(of(function() {
            return ff();
        })))), r = A2(He, rf, ai(of(function() {
            return ff();
        })));
        return xa(y([
            n,
            r,
            si(ef),
            A2(He, cf, va),
            A2(He, uf, qo),
            A2(He, tf, xe)
        ]));
    }
    var sf = ff();
    ff = function() {
        return sf;
    };
    var df = A3(Ae, nf, A2(iu, "field", va), A2(iu, "value", sf)), bf = ln, lf = A7(bf, Wo, A2(iu, "language", Yo(va)), A2(iu, "codes", Yo(va)), A2(iu, "tickets", Yo(va)), A2(iu, "fieldValues", ai(df)), A2(iu, "ifFree", xe), xa(y([
        A2(iu, "ifUpdate", xe),
        Pe(!1)
    ]))), vf = lf, hf = A3(Ae, Ko, A2(iu, "include", lf), A2(iu, "exclude", vf)), gf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $f = {
        $: 1
    }, mf = {
        $: 2
    }, pf = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), wf = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kf = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), _f = function(n) {
        return {
            $: 6,
            a: n
        };
    }, yf = {
        $: 7
    }, xf = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Hf = F5(function(n, r, t, e, u) {
        return {
            a5: u,
            br: n,
            bt: r,
            be: t,
            bj: e
        };
    }), Af = {
        $: 0
    }, Pf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Bf = {
        $: 2
    }, Nf = {
        $: 4
    }, Lf = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), If = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Tf = A2(ye, Ne, A3(Ae, F2(function(n, r) {
        return A3(no, Eu("expected regular expression, but got `" + n + "'"), function(t) {
            return Pe({
                cY: r,
                fs: t,
                dw: n
            });
        }, Zu("^" + n + "$"));
    }), A2(iu, "pattern", va), A2(iu, "errorMessage", ti(va))));
    function Sf() {
        return A2(ye, function(n) {
            switch(n){
                case "bool":
                    return Pe(Af);
                case "choice":
                    return A2(He, Pf, A2(iu, "values", ti(fi(A2(He, function(n) {
                        return {
                            bL: n
                        };
                    }, va)))));
                case "email":
                    return Pe(Bf);
                case "string":
                    return A2(He, If, xa(y([
                        A2(iu, "customValidation", A2(He, st, Tf)),
                        Pe(dt)
                    ])));
                case "file":
                    return Pe(Nf);
                case "or":
                    return A3(Ae, Lf, A2(iu, "validatorA", Sf()), A2(iu, "validatorB", Sf()));
                default:
                    return Eu("expected validator, but got `" + n + "'");
            }
        }, A2(iu, "type", va));
    }
    var Cf = Sf();
    Sf = function() {
        return Cf;
    };
    var Ef = A6(Vo, Hf, A2(iu, "inputField", va), A2(iu, "label", ti(va)), A2(iu, "required", xe), A2(iu, "validator", Cf), xa(y([
        A2(iu, "fullwidth", xe),
        Pe(!1)
    ]))), zf = F2(function(n, r) {
        var t = r.b;
        return h(n(r.a), t);
    }), Xf = A2(lu, Wc, Qe(zf(_o))), jf = y([
        0,
        1,
        2,
        3,
        4
    ]), qf = function(n) {
        return Xf(A2(Qe, function(r) {
            return h(ou(r), n(r));
        }, jf));
    }, Mf = un, Rf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Of = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Df = {
        $: 2
    }, Ff = A2(ye, function(n) {
        switch(n){
            case "bool":
                return A2(He, Rf, A2(iu, "description", ti(va)));
            case "choice":
                return A3(Ae, Of, A2(He, function(n) {
                    return {
                        dG: n
                    };
                }, xa(y([
                    A2(iu, "radio", xe),
                    Pe(!1)
                ]))), A2(iu, "variants", ti(fi(xa(y([
                    A2(He, function(n) {
                        return {
                            bt: n,
                            bL: n
                        };
                    }, va),
                    A3(Ae, F2(function(n, r) {
                        return {
                            bt: n,
                            bL: r
                        };
                    }), A2(iu, "label", va), A2(iu, "value", va))
                ]))))));
            case "string":
                return Pe(Df);
            case "paymentMethod":
                var r = ai(A3(Ae, F2(function(n, r) {
                    return {
                        bt: n,
                        bL: r
                    };
                }), A2(iu, "label", ti(va)), A2(iu, "value", va)));
                return A3(Ae, F2(function(n, r) {
                    return {
                        $: 3,
                        a: {
                            eH: r,
                            e3: n
                        }
                    };
                }), xa(y([
                    A2(iu, "includePaymentMethods", r),
                    Pe(w)
                ])), xa(y([
                    A2(iu, "excludePaymentMethods", r),
                    Pe(w)
                ])));
            case "fileUpload":
                return A3(Ae, F2(function(n, r) {
                    return {
                        $: 4,
                        a: {
                            d7: n,
                            hM: r
                        }
                    };
                }), A2(iu, "accept", va), A2(iu, "maxSize", Mo));
            default:
                return Eu("expected input type, but got `" + n + "'");
        }
    }, A2(iu, "type", va)), Vf = Ff, Zf = function(n) {
        return xa(y([
            A2(He, st, n),
            Pe(dt)
        ]));
    };
    function Gf() {
        var n;
        return A3(Ae, Jo, A2(iu, "fieldConfig", hf), A2(iu, "fieldType", (n = of(function() {
            return Gf();
        }), xa(y([
            A2(iu, "chosenTicket", A2(He, gf, A2(iu, "ticketFields", ai(va)))),
            A2(iu, "currentPerson", Pe($f)),
            A2(iu, "currentPrice", Pe(mf)),
            A2(iu, "input", A3(Ae, pf, A2(iu, "inputConfig", Ef), A2(iu, "inputType", Vf))),
            A2(iu, "markdown", A2(He, wf, A2(iu, "content", ti(va)))),
            A2(iu, "persons", A3(Ae, kf, xa(y([
                A2(iu, "personsConfig", A2(He, function(n) {
                    return {
                        bw: n
                    };
                }, A2(iu, "limit", A3(Ae, oo, A2(Mf, 0, Zf(Mo)), A2(Mf, 1, Zf(Mo)))))),
                Pe({
                    bw: h(dt, dt)
                })
            ])), A2(iu, "fields", ai(n)))),
            A2(iu, "section", A3(Ae, F2(function(n, r) {
                return _f({
                    bo: n,
                    a4: r
                });
            }), A2(iu, "fieldMap", di(fi(va))), A2(iu, "fields", ai(n)))),
            A2(iu, "summary", Pe(yf)),
            A2(iu, "ticketSelection", A2(He, xf, A7(bf, F6(function(n, r, t, e, u, a) {
                return {
                    eL: t,
                    di: n,
                    fo: a,
                    be: r,
                    dX: e,
                    dY: u
                };
            }), A2(iu, "multiple", xe), A2(iu, "required", xe), xa(y([
                A2(iu, "extraTickets", A3(Ae, F2(function(n, r) {
                    return st({
                        e2: r,
                        fr: n
                    });
                }), A2(iu, "paragraph", ti(va)), A2(iu, "identifier", ti(va)))),
                Pe(dt)
            ])), A2(iu, "ticketField", va), A2(iu, "ticketIds", ai(va)), xa(y([
                A2(iu, "optionalText", ti(va)),
                Pe(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Ich nehme nicht teil.";
                        case 1:
                            return "I don't intent to participate.";
                        case 2:
                            return "No voy a participar.";
                        case 3:
                            return "Je ne souhaite pas participer.";
                        default:
                            return "\u042F \u043D\u0435 \u0431\u0443\u0434\u0443 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u0438\u044F.";
                    }
                }))
            ])))))
        ])))));
    }
    var Yf = Gf();
    Gf = function() {
        return Yf;
    };
    var Uf, Qf, Jf, Kf, Wf, ns, rs, ts, es = F3(function(n, r, t) {
        return {
            g4: t,
            hv: r,
            bc: n
        };
    }), us = sn, as = A4(us, es, A2(iu, "perPerson", xe), A2(iu, "include", lf), A2(iu, "exclude", vf)), cs = A3(Ae, Qo, A2(iu, "pageConfig", as), A2(iu, "fields", ai(Yf))), is = F9(function(n, r, t, e, u, a, c, i, o) {
        return {
            el: u,
            eA: t,
            eQ: i,
            e4: c,
            a9: o,
            bt: r,
            fz: a,
            dF: e,
            fZ: n
        };
    }), os = function(n) {
        return {
            dI: n
        };
    }, fs = A2(He, os, A2(iu, "remaining", Mo)), ss = (Uf = F2(function(n, r) {
        return A2(ye, function(n) {
            return A2(He, ie(n), r);
        }, n);
    }), A2(Uf, A2(iu, "invalid", xe), A2(Uf, xa(y([
        A2(iu, "freeOfCharge", xe),
        Pe(!1)
    ])), A2(Uf, A2(iu, "includedVat", di(Mo)), A2(Uf, A2(iu, "price", di(Mo)), A2(Uf, A2(iu, "codeId", di(va)), A2(Uf, A2(iu, "quota", di(fs)), A2(Uf, A2(iu, "description", di(ti(va))), A2(Uf, A2(iu, "label", ti(va)), A2(Uf, A2(iu, "ticketId", va), Pe(is))))))))))), ds = Gc, bs = F2(function(n, r) {
        return {
            gM: n,
            gN: r
        };
    }), ls = xn, vs = A2(la, ls, Mo), hs = mu(A4(wa, "currentPerson", function(n) {
        return n.gN;
    }, vs, A4(wa, "currentPage", function(n) {
        return n.gM;
    }, vs, ka(bs)))), gs = ku(hs), $s = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3($s, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), ms = F3(function(n, r, t) {
        return A3($s, F3(function(t, e, u) {
            return A3(Hn, n(t), r(e), u);
        }), {}, t);
    }), ps = F3(function(n, r, t) {
        var e = t;
        return A3($s, F3(function(r, t, e) {
            return A2(n, r, e);
        }), r, e);
    }), ws = F2(function(n, r) {
        return A3(ps, An(n), [], r);
    }), ks = function(n) {
        return n.$ ? $u(y([
            h("ticketIds", A2(ws, ha, n.a.dY))
        ])) : zu;
    }, _s = F2(function(n, r) {
        return n(r);
    }), ys = _s(A2(no, zu, A2(ms, Ne, ls))), xs = function(n) {
        switch(n.$){
            case 0:
                return zu;
            case 1:
                return $u(y([
                    h("maybeTicketId", zu),
                    h("maybeExtraTickets", zu)
                ]));
            default:
                var r = n.a.hN;
                return $u(y([
                    h("maybeTicketId", ha(n.a.fZ)),
                    h("maybeExtraTickets", A3(no, zu, ls, r))
                ]));
        }
    }, Hs = function(n) {
        switch(n.$){
            case 0:
                return $u(y([
                    h("parsed", ys(n.a))
                ]));
            case 1:
                return $u(y([
                    h("single-selection", xs(n.a))
                ]));
            default:
                return $u(y([
                    h("multiple-selections", ks(n.a))
                ]));
        }
    }, As = xn, Ps = xn, Bs = function(n) {
        switch(n.$){
            case 0:
                return $u(A2(Qe, function(n) {
                    return h(n.a, Bs(n.b));
                }, n.a));
            case 1:
                return A2(Po, Bs, n.a);
            case 5:
                return ha(n.a);
            case 2:
                return As(n.a);
            case 3:
                return zu;
            default:
                return Ps(n.a);
        }
    }, Ns = function(n) {
        return $u(y([
            h("tickets", A3(ms, Ne, Hs, n.aB)),
            h("fields", A3(ms, Ne, Bs, n.a4))
        ]));
    }, Ls = function(n) {
        var r, t, e;
        return $u(y([
            h("cursor", gs(n.b0)),
            h("orderInput", (t = n.h0, $u(y([
                h("fields", A3(ms, Ne, Bs, t.a4)),
                h("persons", A3(ms, Lt, Ns, t.dy)),
                h("tickets", A3(ms, Ne, Hs, t.aB)),
                h("globalTickets", (e = t.he, A3(ms, Ne, Hs, e)))
            ])))),
            h("showErrors", (r = n.cn, $u(y(r.$ ? [
                h("allPages", $u(w))
            ] : [
                h("selectPages", $u(y([
                    h("cursors", A2(Po, gs, r.a))
                ])))
            ]))))
        ]));
    }, Is = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ts = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ss = ai(va), Cs = A3(Ae, F2(function(n, r) {
        return {
            a4: r,
            aB: n
        };
    }), xa(y([
        A2(iu, "tickets", ri(Ss)),
        Pe(Gc)
    ])), A2(iu, "fields", ri(sf))), Es = F3(function(n, r, t) {
        if (1 === r.$) return wt(r.a);
        var e = r.a;
        return 1 === t.$ ? wt(t.a) : xt(A2(n, e, t.a));
    }), zs = A2(Ue, Es(bt), xt(w)), Xs = function(n) {
        return A2(ye, function(n) {
            return A3(ma, Eu, Pe, A2(Uu, Wc, zs(A2(Qe, function(n) {
                var r = n.a, t = n.b;
                return A2(Fu, "expected int key, but got `" + r + "'", A2(Yu, function(n) {
                    return h(n, t);
                }, je(r)));
            }, vt(n)))));
        }, ri(n));
    }, js = (Qf = xa(y([
        A2(iu, "tickets", ri(Ss)),
        Pe(Gc)
    ])), Jf = A2(iu, "persons", Xs(Cs)), Kf = A2(iu, "locale", Vc), Wf = A2(iu, "fields", ri(sf)), ns = xa(y([
        Pe(dt),
        A2(iu, "discount", di(va))
    ])), rs = xa(y([
        A2(iu, "code", di(va)),
        Pe(dt)
    ])), xa(y([
        A6(Vo, F5(function(n, r, t, e, u) {
            return Is({
                cI: t,
                ah: u,
                a4: n,
                e: e,
                dy: r
            });
        }), Wf, Jf, rs, Kf, ns),
        A6(Vo, F5(function(n, r, t, e, u) {
            return Ts({
                cI: t,
                ah: u,
                a4: n,
                e: e,
                aB: r
            });
        }), Wf, Qf, rs, Kf, ns)
    ]))), qs = F2(function(n, r) {
        var t = r.e$;
        return A2(to, n, {
            a1: Pe(0),
            p: "/public/payment/status?id=" + t
        });
    }), Ms = F2(function(n, r) {
        var t;
        return A2(vu, function(n) {
            return 3 === n.$ && 404 === n.a ? Ze(w) : Ki(n);
        }, A2(to, n, {
            a1: ai(ss),
            p: "/public/tickets.json" + (t = r.cI, t.$ ? "" : "?code=" + t.a)
        }));
    }), Rs = Ne, Os = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ds = function(n) {
        return st(A3(Ct, function(n) {
            return A2(Ri, n, A2(lu, A2(lu, st, At(1)), _i(0)));
        }, Gc, n));
    }, Fs = A2(lu, Os, Ds), Vs = F2(function(n, r) {
        if (-2 === r.$) return Zc;
        var t = r.b, e = r.d, u = r.e;
        return A5(Yc, r.a, t, A2(n, t, r.c), A2(Vs, n, e), A2(Vs, n, u));
    }), Zs = F2(function(n, r) {
        return A3($s, F3(function(r, t, e) {
            var u = e.a, a = e.b;
            return A2(n, r, t) ? h(A3(Kc, r, t, u), a) : h(u, A3(Kc, r, t, a));
        }), h(Gc, Gc), r);
    }), Gs = F2(function(n, r) {
        return h({
            a4: r.a4,
            aB: A2(Vs, function() {
                return Fs;
            }, r.aB)
        }, Rs(A2(Zs, F2(function(r) {
            return A2(ii, r, n);
        }), A2(Vs, function() {
            return Fs;
        }, r.aB)).a));
    }), Ys = F2(function(n, r) {
        return h(r.a, n(r.b));
    }), Us = F2(function(n, r) {
        return A3($s, Kc, r, n);
    }), Qs = F2(function(n, r) {
        return A2(Us, n, r);
    }), Js = Gc, Ks = A2(Ct, Qs, Js), Ws = function(n) {
        return n.b;
    }, nd = F2(function(n, r) {
        return A5(Yc, 1, n, r, Zc, Zc);
    }), rd = function(n) {
        return A3(lt, F3(function(n, r, t) {
            return A2(bt, r, t);
        }), w, n);
    }, td = F2(function(n, r) {
        var t, e = A2(Ys, A2(lu, Ks, rd), h(A2(Vs, function() {
            return ge;
        }, t = A2(Vs, function() {
            return Gs(n);
        }, r.$ ? r.a.dy : A2(nd, 0, {
            a4: Gc,
            aB: r.a.aB
        }))), A2(Vs, function() {
            return Ws;
        }, t)));
        return {
            a4: r.a.a4,
            he: e.b,
            dy: e.a,
            aB: Gc
        };
    }), ed = {
        $: 1
    }, ud = {
        gM: 0,
        gN: 0
    }, ad = F2(function(n, r) {
        return r.b ? A3(Ue, bt, r, n) : n;
    }), cd = function(n) {
        return A3(Ue, ad, w, n);
    }, id = F2(function(n, r) {
        return cd(A2(Qe, n, r));
    }), od = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 7:
            default:
                return w;
            case 5:
                return A2(id, n, r.b);
            case 6:
                return A2(id, n, r.a.a4);
        }
    }), fd = function(n) {
        return A2(bt, n, A2(od, fd, n.b));
    }, sd = function(n) {
        return A2(id, fd, n.b);
    }, dd = ci(function(n) {
        return A2(ci, function(n) {
            return 5 === n.b.$;
        }, sd(n));
    }), bd = function(n) {
        var r = dd(n);
        return A2(id, function(n) {
            var t = n.a;
            return A2(Ru, function(n) {
                var e = n.b;
                return 8 === e.$ && r && !t.bc ? st(e.a.dX) : dt;
            }, sd(n));
        }, n);
    }, ld = function(n) {
        return n.a;
    }, vd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hd = {
        a4: Gc,
        he: Js,
        dy: Gc,
        aB: Gc
    }, gd = {
        b0: ud,
        h0: hd,
        cn: vd(w)
    }, $d = Kn("inspect", Ne), md = b, pd = function(n) {
        return 1 === n.$;
    }, wd = F3(function(n, r, t) {
        var e = t.b.bO;
        return f(r, t.a) > -1 && (!e || pd(n));
    }), kd = function(n) {
        return 1 !== n.$;
    }, _d = F4(function(n, r, t, e) {
        return A2(Je, function(r) {
            return A2(Je, function(t) {
                return A2(Je, function(e) {
                    return Ze(A3(n, r, t, e));
                }, e);
            }, t);
        }, r);
    }), yd = F5(function(n, r, t, e, u) {
        return A2(Je, function(r) {
            return A2(Je, function(t) {
                return A2(Je, function(e) {
                    return A2(Je, function(u) {
                        return Ze(A4(n, r, t, e, u));
                    }, u);
                }, e);
            }, t);
        }, r);
    }), xd = F2(function(n, r) {
        return A2(vu, A2(lu, Ki, n), r);
    }), Hd = Kn("mountCheckout", Ne), Ad = Fn, Pd = Ad(w), Bd = (ts = Wa, Bn(function(n) {
        n(Pn(ts(Date.now())));
    })), Nd = F2(function(n, r) {
        return 1 === r.$ ? n : r;
    }), Ld = F4(function(n, r, t, e) {
        return {
            cI: r,
            el: n,
            eI: e,
            eR: t
        };
    }), Id = dn, Td = A5(Id, Ld, A2(iu, "codeId", va), A2(iu, "code", va), Zf(A2(iu, "freeTickets", ri(fi(va)))), Zf(A2(iu, "exhibitor", va))), Sd = F2(function(n, r) {
        var t = r.cI;
        return A2(vu, function(n) {
            return 3 === n.$ && 409 === n.a ? Ze(wt(t)) : Ki(n);
        }, A2(to, n, {
            a1: xa(y([
                A2(He, xt, Td),
                A2(He, wt, Pe(t))
            ])),
            p: "/public/redeem-code?code=" + t
        }));
    }), Cd = function(n) {
        return n.$ ? Ki(n.a) : Ze(n.a);
    }, Ed = F2(function(n, r) {
        return n.$ ? r : A2(bt, n.a, r);
    }), zd = A2(Ue, Ed, w), Xd = wu(hs), jd = xa(y([
        A2(iu, "selectPages", A2(He, vd, A2(iu, "cursors", ai(Xd)))),
        A2(iu, "allPages", Pe(ed))
    ])), qd = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Md = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Rd = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Od = {
        $: 0
    }, Dd = xa(y([
        A2(He, function(n) {
            return Rd({
                dY: n
            });
        }, A2(iu, "ticketIds", Yo(va))),
        si(Od)
    ])), Fd = A2(He, Ne, di(ri(Mo))), Vd = {
        $: 1
    }, Zd = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gd = {
        $: 0
    }, Yd = xa(y([
        A3(Ae, F2(function(n, r) {
            return 1 === n.$ ? Vd : Zd({
                hN: r,
                fZ: n.a
            });
        }), A2(iu, "maybeTicketId", di(va)), A2(iu, "maybeExtraTickets", di(Mo))),
        si(Gd)
    ])), Ud = xa(y([
        A2(He, Os, A2(iu, "parsed", Fd)),
        A2(He, Md, A2(iu, "single-selection", Yd)),
        A2(He, qd, A2(iu, "multiple-selections", Dd))
    ])), Qd = A2(He, Ne, ri(Ud)), Jd = A3(Ae, F2(function(n, r) {
        return {
            a4: r,
            aB: n
        };
    }), A2(iu, "tickets", ri(Ud)), A2(iu, "fields", ri(sf))), Kd = function() {
        var n = A2(iu, "tickets", ri(Ud)), r = A2(iu, "persons", Xs(Jd)), t = xa(y([
            A2(iu, "globalTickets", Qd),
            Pe(Js)
        ])), e = A2(iu, "fields", ri(sf));
        return xa(y([
            A5(Id, F4(function(n, r, t, e) {
                return {
                    a4: n,
                    he: e,
                    dy: r,
                    aB: t
                };
            }), e, r, n, t),
            A4(us, F3(function(n, r, t) {
                return {
                    a4: n,
                    he: t,
                    dy: r,
                    aB: Gc
                };
            }), e, r, t),
            A4(us, F3(function(n, r, t) {
                return {
                    a4: n,
                    he: t,
                    dy: Gc,
                    aB: r
                };
            }), e, n, t)
        ]));
    }(), Wd = A4(us, F3(function(n, r, t) {
        return {
            b0: n,
            h0: r,
            cn: t
        };
    }), A2(iu, "cursor", Xd), A2(iu, "orderInput", Kd), A2(iu, "showErrors", jd)), nb = F2(function(n, r) {
        var t = A3(no, Ze(dt), function(n) {
            return A2(xd, vo, A2(Ke, st, Cd(A2(vi, A2(He, _i(gd), di(Wd)), n))));
        }, n.d2), e = F2(function(n, r) {
            if (n.$) return Ze(dt);
            var t, e = n.a;
            return Ze(st((t = A2(td, bd(r), e), {
                b0: ud,
                h0: t,
                cn: ed
            })));
        }), u = A2(Nd, n.ad, A2(ju, Ws, r)), a = A3(no, A2(xd, go, function(n) {
            return A2(vu, function(n) {
                return 3 === n.$ && 404 === n.a ? Ze(w) : Ki(n);
            }, A2(to, n, {
                a1: ai(Uo),
                p: "/public/discounts.json"
            }));
        }(u)), function(n) {
            return A2(xd, vo, Cd(A2(vi, ai(Uo), n)));
        }, n.aq), c = A3(no, A2(xd, go, function(n) {
            return A2(vu, function(n) {
                return 3 === n.$ && 404 === n.a ? Ze(w) : Ki(n);
            }, A2(to, n, {
                a1: A2(iu, "values", ai(cs)),
                p: "/public/pages.json"
            }));
        }(u)), function(n) {
            return A2(xd, vo, Cd(A2(vi, ai(cs), n)));
        }, n.B), i = A3(no, A2(xd, go, A2(Ms, u, {
            cI: n.cI
        })), function(n) {
            return A2(xd, vo, Cd(A2(vi, ai(ss), n)));
        }, n.aB);
        return h(po, A2(au, $o, A2(vu, function(n) {
            return Ze(h(bo({
                gX: ou(0),
                cX: n,
                e: ou(0)
            }), Pd));
        }, A2(Je, function(c) {
            var o = c.ba, f = c.B, s = c.aD;
            return A2(Ke, function(c) {
                var d, b = c.em, l = c.aS, v = c.fl, g = ld(l.hJ), $ = o.$ ? A3(no, g, fu, n.e) : o.a.a.e;
                return A2(_i, h(po, A2(au, $o, A2(vu, function(n) {
                    return Ze(h(bo({
                        gX: g,
                        cX: n,
                        e: $
                    }), Pd));
                }, A5(yd, F4(function(t, e, a, c) {
                    if (1 === b.$) return h({
                        $: 1,
                        a: {
                            cI: b.a,
                            gX: g,
                            e: $
                        }
                    }, Pd);
                    var i = {
                        ad: u,
                        cI: b.a,
                        ag: 1 === o.$ ? l.ag : A3(no, l.ag, function(n) {
                            return n.iL;
                        }, s),
                        gX: g,
                        ao: dt,
                        aq: e,
                        aj: ds,
                        c_: n,
                        v: A2(_i, gd, A2(Nd, c, a)),
                        ak: n.ak,
                        e: $,
                        ba: o,
                        bA: !1,
                        aN: Fe(n.aN),
                        B: f,
                        aS: l,
                        aB: t,
                        cv: kd(c),
                        f5: A2(Yu, ge, r),
                        aD: s,
                        aE: n.aE
                    };
                    return h(mo(i), $d(Ls(i.v)));
                }), i, a, t, A2(e, o, f))))), Gu(zd(y([
                    (d = n.db, !d.$ && d.a ? st(h(po, Pd)) : dt),
                    A2(Yu, function(n) {
                        return h(bo({
                            gX: g,
                            cX: lo(n),
                            e: $
                        }), Pd);
                    }, n.cJ),
                    A2(Yu, function(n) {
                        var r = A2(vi, wu(Eo), n);
                        if (r.$) return h(bo({
                            gX: g,
                            cX: vo(r.a),
                            e: $
                        }), Pd);
                        var t = r.a;
                        return h(wo({
                            aH: t,
                            gX: g,
                            e: $
                        }), Hd(A2(ku, Eo, t)));
                    }, n.aH),
                    A2(Yu, function(n) {
                        return h(po, A2(au, $o, A2(vu, function(n) {
                            return Ze(h(bo({
                                gX: g,
                                cX: n,
                                e: $
                            }), Pd));
                        }, A2(xd, go, A2(Ke, function() {
                            return h(ho({
                                ag: l.ag,
                                gX: g,
                                ak: n,
                                e: $
                            }), Pd);
                        }, A2(qs, u, {
                            e$: n
                        }))))));
                    }, n.e$),
                    A2(ju, function(n) {
                        return A3(wd, 1 === b.$ ? st(0) : 1 === b.a.$ ? dt : st(0), v, n) ? st(h({
                            $: 6,
                            a: {
                                bV: l.bV,
                                gX: g,
                                e: $
                            }
                        }, Pd)) : dt;
                    }, l.gB)
                ]))));
            }, A4(_d, F3(function(n, r, t) {
                return {
                    em: t,
                    fl: n,
                    aS: r
                };
            }), Bd, A2(xd, go, eo(u)), function(r) {
                return A3(no, Ze(xt(dt)), function(n) {
                    return A2(Ke, Uu(st), A2(xd, go, A2(Sd, u, {
                        cI: n
                    })));
                }, r.$ ? n.cI : r.a.a.cI);
            }(o)));
        }, A2(Je, function(n) {
            var r = n.a, t = n.b;
            return A2(Ke, function(n) {
                return {
                    ba: n,
                    B: r,
                    aD: t
                };
            }, t.$ ? Ze(dt) : A2(xd, go, function(n) {
                return A2(vu, function(n) {
                    return 3 === n.$ && 404 === n.a ? Ze(dt) : Ki(n);
                }, A2(to, n, {
                    a1: A2(He, st, js),
                    p: "/public/registration.json"
                }));
            }(u)));
        }, A3(We, oo, c, A2(xd, go, co(u))))))));
    }), rb = function(n) {
        return A3(so, {
            ad: n.ad,
            e: A2(Yu, fu, n.e),
            id: n.aN
        }, nb, n);
    }, tb = function(n) {
        return {
            $: 6,
            a: n
        };
    }, eb = Vn, ub = Fn, ab = ub(w), cb = F2(function(n, r) {
        var t = r.c;
        return 5 === t.$ ? A2(eb, tb, n(t.a)) : ab;
    }), ib = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ob = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sb = function(n) {
        return {
            $: 4,
            a: n
        };
    }, db = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bb = rr("setDiscounts", hi), lb = rr("setLocale", va), vb = rr("setPages", hi), hb = rr("setTickets", hi), gb = rr("setWidth", xa(y([
        si(dt),
        A2(He, st, Mo)
    ]))), $b = cb(function() {
        return ub(y([
            vb(A2(lu, fb, vi(ai(cs)))),
            lb(A2(lu, A2(lu, ob, xt), fu)),
            hb(A2(lu, sb, vi(ai(ss)))),
            bb(A2(lu, ib, vi(ai(Uo)))),
            gb(db)
        ]));
    }), mb = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pb = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wb = function(n) {
        return {
            $: 5,
            a: n
        };
    }, kb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _b = function(n) {
        return {
            $: 5,
            a: n
        };
    }, yb = F2(function(n, r) {
        return {
            gJ: n,
            gK: r
        };
    }), xb = F2(function(n, r) {
        var t = r.p, e = r.a1;
        return A2(ro, n, {
            n: st(r.n),
            a1: e,
            x: "POST",
            p: t
        });
    }), Hb = F3(function(n, r, t) {
        var e = t.gG;
        return A2(xb, n, {
            n: $u(y([
                h("emailAddress", ha(t.cT)),
                h("confirmEmailAddress", A3(no, zu, ha, e)),
                h("referringUrl", ha(r))
            ])),
            a1: A2(ye, function(n) {
                switch(n){
                    case "ConfirmEmailAddress":
                        return A2(He, function(n) {
                            return {
                                $: 0,
                                a: {
                                    cT: n
                                }
                            };
                        }, A2(iu, "emailAddress", va));
                    case "LoginCodeSent":
                        return A2(He, function(n) {
                            return {
                                $: 1,
                                a: {
                                    cT: n
                                }
                            };
                        }, A2(iu, "emailAddress", va));
                    case "LoggedIn":
                        return A3(Ae, F2(function(n, r) {
                            return {
                                $: 2,
                                a: {
                                    ad: r,
                                    f5: n
                                }
                            };
                        }), A2(iu, "user", fo), A2(iu, "auth", A3(Ae, yb, A2(iu, "cookieName", va), A2(iu, "cookieValue", va))));
                    default:
                        return Eu("expected LoginResponse, but got tag `" + n + "'");
                }
            }, A2(iu, "tag", va)),
            p: "/public/user-account/login"
        });
    }), Ab = Vn, Pb = function(n) {
        return n.trim();
    }, Bb = F3(function(n, r, t) {
        var e = t.a, u = t.b, a = h(r, t.c);
        n: for(;;){
            r: for(;;)switch(a.a.$){
                case 1:
                    return h(1 === a.b.$ ? A3(du, e, u, kb($(d = a.b.a, {
                        cT: a.a.a
                    }))) : t, Pd);
                case 3:
                    if (1 === a.b.$) {
                        var c = Pb((d = a.b.a).cT);
                        return h(A3(du, e, u, kb($(d, {
                            db: !0
                        }))), A2(hu, _b, A3(Hb, dt, e.id, {
                            gG: dt,
                            cT: c
                        })));
                    }
                    return h(t, Pd);
                case 2:
                    return h(3 === a.b.$ ? A3(du, e, u, pb($(s = a.b.a, {
                        gG: a.a.a
                    }))) : t, Pd);
                case 4:
                    if (3 === a.b.$) {
                        var i = Pb((s = a.b.a).gG);
                        return h(A3(du, e, u, pb($(s, {
                            db: !0
                        }))), A2(hu, _b, A3(Hb, dt, e.id, {
                            gG: st(i),
                            cT: s.cT
                        })));
                    }
                    return h(t, Pd);
                case 5:
                    if (a.a.a.$) switch(a.b.$){
                        case 1:
                            return h(A3(du, e, u, kb($(d = a.b.a, {
                                cX: st(a.a.a.a)
                            }))), Pd);
                        case 3:
                            return h(A3(du, e, u, pb($(s = a.b.a, {
                                cX: st(a.a.a.a)
                            }))), Pd);
                        default:
                            break n;
                    }
                    else switch(a.a.a.a.$){
                        case 2:
                            var o = a.a.a.a.a.ad, f = a.a.a.a.a.f5;
                            return A2(lu, Ys(Ab(tb)), zf(A2(lu, A2(du, e, u), wb)))(u(st(h(f, st(o)))));
                        case 1:
                            switch(a.b.$){
                                case 1:
                                    return h(A3(du, e, u, mb({
                                        cT: a.a.a.a.a.cT,
                                        aS: (d = a.b.a).aS
                                    })), Pd);
                                case 3:
                                    var s;
                                    return h(A3(du, e, u, mb({
                                        cT: a.a.a.a.a.cT,
                                        aS: (s = a.b.a).aS
                                    })), Pd);
                                default:
                                    break n;
                            }
                        default:
                            var d;
                            if (1 === a.b.$) return h(A3(du, e, u, pb({
                                gG: "",
                                cT: a.a.a.a.a.cT,
                                cX: dt,
                                db: !1,
                                aS: (d = a.b.a).aS,
                                aD: d.aD
                            })), Pd);
                            break n;
                    }
                case 6:
                    if (5 === a.b.$) {
                        var b = a.a.a, l = a.b.a;
                        return A2(lu, Ys(Ab(tb)), zf(A2(lu, A2(du, e, u), wb)))(A2(n, b, l));
                    }
                    return b = a.a.a, h(t, Pd);
                default:
                    if (a.a.a.$) {
                        if (a.b.$) break r;
                        return h(t, Pd);
                    }
                    if (a.a.a.a.$) {
                        if (1 === a.a.a.a.a.$) {
                            if (a.b.$) break r;
                            return A2(lu, Ys(Ab(tb)), zf(A2(lu, A2(du, e, u), wb)))(u(dt));
                        }
                        if (a.b.$) break r;
                        var v = a.a.a.a.a.a;
                        return h(A3(du, e, u, kb({
                            cT: "",
                            cX: dt,
                            db: !1,
                            aS: v.a,
                            aD: v.b
                        })), Pd);
                    }
                    if (a.b.$) break r;
                    return f = a.a.a.a.a, A2(lu, Ys(Ab(tb)), zf(A2(lu, A2(du, e, u), wb)))(u(st(h(f, dt))));
            }
            return h(t, Pd);
        }
        return h(t, Pd);
    }), Nb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lb = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ib = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Tb = F3(function(n, r, t) {
        return {
            $: 8,
            a: n,
            b: r,
            c: t
        };
    }), Sb = F2(function(n, r) {
        var t = A2(Qe, function(n) {
            return n.e4;
        }, r), e = A2(Qe, function(n) {
            return n.fz;
        }, r), u = n.fE;
        if (u.$) {
            var a = u.a;
            return {
                e4: fe(A3(Ct, At, 0, A2(Qe, A2(lu, le(a), te), t))),
                fz: fe(A3(Ct, At, 0, A2(Qe, A2(lu, le(a), te), e)))
            };
        }
        var c = u.a;
        return {
            e4: fe(A3(Ct, At, 0, t) * (c / A3(Ct, At, 0, e))),
            fz: c
        };
    }), Cb = function(n) {
        return n.$ ? A2(Qe, function(n) {
            return h(n, 1);
        }, gt(n.a.dY)) : w;
    }, Eb = _s(A2(no, w, vt)), zb = function(n) {
        switch(n.$){
            case 0:
            case 1:
                return w;
            default:
                return y([
                    h(n.a.fZ, A2(_i, 1, n.a.hN))
                ]);
        }
    }, Xb = function(n) {
        switch(n.$){
            case 0:
                return Eb(n.a);
            case 1:
                return zb(n.a);
            default:
                return Cb(n.a);
        }
    }, jb = F2(function(n, r) {
        return A2(Us, n, r);
    }), qb = F2(function(n, r) {
        return A3($s, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(Kc, r, t, e) : e;
        }), Gc, r);
    }), Mb = F2(function(n, r) {
        return !A2(Si, n, r).$;
    }), Rb = F2(function(n, r) {
        return A2(qb, F2(function(n) {
            return A2(Mb, n, r);
        }), n);
    }), Ob = F2(function(n, r) {
        return A2(Rb, n, r);
    }), Db = function(n) {
        return -2 === n.$;
    }, Fb = function(n) {
        return Db(n);
    }, Vb = F2(function(n, r) {
        return A2(Us, n, r);
    }), Zb = F2(function(n, r) {
        return !!Fb(r.dY) || A2(lu, Pc, Fb)(A2(Ob, r.dY, A3(Ct, Vb, Fo, A2(Qe, function(r) {
            return Go(A2(Ru, function(n) {
                return n.b > 0 ? st(n.a) : dt;
            }, A2(id, Xb, rd(A2(jb, n.he, r.aB)))));
        }, rd(n.dy)))));
    }), Gb = F2(function(n, r) {
        for(;;){
            if (!r.b) return dt;
            var t = r.a, e = r.b;
            if (n(t)) return st(t);
            r = e;
        }
    }), Yb = F2(function(n, r) {
        return A2(id, Xb, rd(A2(jb, n.he, r.aB)));
    }), Ub = F4(function(n, r, t, e) {
        return A2(Qe, function(r) {
            var t = r.a, e = n(r.b);
            return {
                e4: t * e.e4,
                fz: t * e.fz
            };
        }, A2(Ru, function(n) {
            var t = n.a;
            return A2(Yu, oo(n.b), A2(Gb, A2(lu, oe(t), function(n) {
                return n.fZ;
            }), r.aB));
        }, A2(Yb, t, e)));
    }), Qb = Ub(function(n) {
        return {
            e4: A2(_i, 0, n.e4),
            fz: A2(_i, 0, n.fz)
        };
    }), Jb = F2(function(n, r) {
        for(;;){
            if (-2 === r.$) return n;
            var t = r.d;
            n = A2(Jb, n + 1, r.e), r = t;
        }
    }), Kb = function(n) {
        return A2(Jb, 0, n);
    }, Wb = F3(function(n, r, t) {
        if (A2(Zb, r, t)) {
            var e = t.f3, u = e.a, a = e.b.go;
            return f(Kb(r.dy), u) > -1 ? st(A2(id, A2(Qb, n, r), A2(Qe, Ws, A2(ei, function(n) {
                return f(n.a + 1, u) > -1 || a;
            }, A2(qt, oo, rd(r.dy)))))) : dt;
        }
        return dt;
    }), nl = F3(function(n, r, t) {
        return A2(ju, function(n) {
            return n.fz > 0 ? st(n) : dt;
        }, A2(Yu, Sb(t), A3(Wb, n, r, t)));
    }), rl = F3(function(n, r, t) {
        return Gu(Zt(A2(pi, A2(lu, function(n) {
            return n.fz;
        }, Ws), A2(Ru, function(t) {
            return A2(Yu, oo(t), A3(nl, n, r, t));
        }, t))));
    }), tl = function(n) {
        return n.$ ? n : {
            $: 1,
            a: n.a
        };
    }, el = Po(ha), ul = function(n) {
        return $u(y([
            h("tickets", A3(ms, Ne, el, n.aB)),
            h("fields", A3(ms, Ne, Bs, n.a4))
        ]));
    }, al = function(n) {
        var r;
        return $u(y(n.$ ? [
            h("persons", A3(ms, Lt, ul, (r = n.a).dy)),
            h("fields", A3(ms, Ne, Bs, r.a4)),
            h("code", A3(no, zu, ha, r.cI)),
            h("locale", yo(r.e)),
            h("discount", A3(no, zu, ha, r.ah))
        ] : [
            h("fields", A3(ms, Ne, Bs, (r = n.a).a4)),
            h("tickets", A3(ms, Ne, el, r.aB)),
            h("code", A3(no, zu, ha, r.cI)),
            h("locale", yo(r.e)),
            h("discount", A3(no, zu, ha, r.ah))
        ]));
    }, cl = function(n) {
        return encodeURIComponent(n);
    }, il = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ol = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fl = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sl = F5(function(n, r, t, e, u) {
        return {
            ef: n,
            ek: r,
            eC: t,
            e: u,
            fS: e
        };
    }), dl = mu(A4(wa, "locale", function(n) {
        return n.e;
    }, xo, A4(wa, "shopperResultUrl", function(n) {
        return n.fS;
    }, Co, A4(wa, "endpoint", function(n) {
        return n.eC;
    }, Co, A4(wa, "checkoutId", function(n) {
        return n.ek;
    }, ga, A4(wa, "brands", function(n) {
        return n.ef;
    }, Lo(ga), ka(sl))))))), bl = function(n) {
        return {
            cX: n
        };
    }, ll = A2(He, bl, xa(y([
        A2(iu, "error", va),
        A2(iu, "error", A2(iu, "message", va))
    ]))), vl = mu(A4(wa, "transactionId", function(n) {
        return n.e$;
    }, ga, ka(function(n) {
        return {
            e$: n
        };
    }))), hl = xa(y([
        A2(He, il, wu(dl)),
        A2(He, ol, ll),
        A2(He, fl, wu(vl))
    ])), gl = F5(function(n, r, t, e, u) {
        return A2(xb, n, {
            n: al(r),
            a1: hl,
            p: "/public/payment/prepare?id=" + t + "&frontendPrice=" + (Lt(e) + A3(no, "", A2(lu, A2(lu, Bt("&referringUrl="), cl), So), u))
        });
    }), $l = function(n) {
        return {
            cI: n.cI,
            gX: n.gX,
            aq: n.aq,
            aj: n.aj,
            e: n.e,
            ba: n.ba,
            aS: n.aS,
            aB: n.aB,
            aD: n.aD
        };
    }, ml = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pl = {
        a4: Gc,
        aB: Gc
    }, wl = F3(function(n, r, t) {
        if (n.b.b) {
            if ("persons" === n.a && n.b.b.b && !n.b.b.b.b) {
                var e = n.b, u = e.b.a, a = je(e.a);
                return 1 === a.$ ? t : $(t, {
                    dy: A3(Ri, a.a, A2(lu, A2(lu, st, function(n) {
                        return $(n, {
                            a4: A2(r, u, n.a4)
                        });
                    }), _i(pl)), t.dy)
                });
            }
            return t;
        }
        return $(t, {
            a4: A2(r, u = n.a, t.a4)
        });
    }), kl = F5(function(n, r, t, e, u) {
        var c = e;
        return a(A2(Yu, function(n) {
            return n.a;
        }, A2(Si, n, c)), st(r)) ? h(A3(Kc, n, A2(ml, r, t), c), $(u, {
            h0: A3(wl, n, Mi, u.h0)
        })) : h(c, u);
    }), _l = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), yl = F5(function(n, r, t, e, u) {
        var a = n.hM, c = e;
        return h(f(t.dO, a) > 0 ? A3(Kc, r, A2(_l, t, a), c) : A3(Kc, r, {
            $: 0,
            a: t
        }, c), $(u, {
            h0: A3(wl, r, Mi, u.h0)
        }));
    }), xl = F5(function(n, r, t, e, u) {
        var c = e;
        return a(A2(Yu, function(n) {
            return n.a;
        }, A2(Si, n, c)), st(r)) ? h(A2(Mi, n, c), $(u, {
            h0: A3(wl, n, F2(function(n, r) {
                return A3(Kc, n, cf(t), r);
            }), u.h0)
        })) : h(c, u);
    }), Hl = Kn("navigated", function() {
        return zu;
    }), Al = Kn("submit", Ne), Pl = fr("b"), Bl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Nl = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ll = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Il = F2(function(n, r) {
        return !A2(ci, A2(lu, Pc, n), r);
    }), Tl = fr("a"), Sl = F2(function(n, r) {
        return A2(vr, n, ha(r));
    }), Cl = function(n) {
        var r;
        return A2(Sl, "href", mr.test(r = n) ? "" : r);
    }, El = F2(function(n, r) {
        return 1 === n.$ ? r.$ ? wt(A2(bt, n.a, r.a)) : xt(r.a) : xt(n.a);
    }), zl = function(n) {
        return !n.b;
    }, Xl = F2(function(n, r) {
        return zl(r) ? "<" + n + ">" : "<" + n + " " + function(n) {
            return A2(It, " ", A2(Qe, function(n) {
                return n.dj + '="' + n.bL + '"';
            }, n));
        }(r) + ">";
    }), jl = function(n) {
        var r, t = A2(Qe, function(n) {
            return n;
        }, n);
        return r = A3(Ct, F2(function(n, r) {
            return F3(function(t, e, u) {
                return A2(El, A3(n, t, e, u), A3(r, t, e, u));
            });
        }), F3(function() {
            return wt(w);
        }), t), F3(function(n, t, e) {
            return A2(Gi, function(r) {
                if (r.b) {
                    if (r.b.b) return "oneOf failed parsing this value:\n    " + A2(Xl, n, t) + "\n\nParsing failed in the following 2 ways:\n\n\n" + A2(It, "\n\n", A2(qt, F2(function(n, r) {
                        return "(" + Lt(n + 1) + ") " + r;
                    }), r)) + "\n";
                    var e = r.a;
                    return "Problem with the given value:\n\n" + A2(Xl, n, t) + "\n\n" + e + "\n";
                }
                return "Ran into a oneOf with no possibilities!";
            }, A3(r, n, t, e));
        });
    }, ql = fr("span"), Ml = lr, Rl = F2(function(n, r) {
        return F3(function(t) {
            return a(t, n) ? xt(r) : wt("Expected " + n + " but was " + t);
        });
    }), Ol = jl(y([
        A2(Rl, "center", function(n) {
            return A2(ql, y([
                A2(Ml, "text-align", "center")
            ]), n);
        })
    ])), Dl = Sl("target"), Fl = Sl("title"), Vl = Sl("align"), Zl = Sl("alt"), Gl = fr("blockquote"), Yl = fr("br"), Ul = F2(function(n, r) {
        return A2(vr, n, As(r));
    }), Ql = Ul("checked"), Jl = Sl("className"), Kl = fr("code"), Wl = fr("del"), nv = Ul("disabled"), rv = fr("em"), tv = fr("h1"), ev = fr("h2"), uv = fr("h3"), av = fr("h4"), cv = fr("h5"), iv = fr("h6"), ov = fr("hr"), fv = fr("img"), sv = fr("input"), dv = fr("li"), bv = fr("ol"), lv = fr("p"), vv = fr("pre"), hv = function(n) {
        return y([
            n
        ]);
    }, gv = function(n) {
        return A2(Sl, "src", kr(n));
    }, $v = fr("strong"), mv = fr("table"), pv = fr("tbody"), wv = fr("td"), kv = ir, _v = fr("th"), yv = fr("thead"), xv = fr("tr"), Hv = Sl("type"), Av = fr("ul"), Pv = function(n) {
        return y(n.trim().split(/\s+/g));
    }, Bv = $({
        gt: Gl(w),
        gC: function(n) {
            var r, t = n.n, e = !(r = A2(Yu, Pv, n.fa)).$ && r.a.b ? y([
                Jl("language-" + r.a.a)
            ]) : w;
            return A2(vv, w, y([
                A2(Kl, e, y([
                    kv(t)
                ]))
            ]));
        },
        gD: function(n) {
            return A2(Kl, w, y([
                kv(n)
            ]));
        },
        g1: function(n) {
            return A2(rv, w, n);
        },
        hi: A2(Yl, w, w),
        hk: function(n) {
            var r = n.gy;
            switch(n.hF){
                case 0:
                    return A2(tv, w, r);
                case 1:
                    return A2(ev, w, r);
                case 2:
                    return A2(uv, w, r);
                case 3:
                    return A2(av, w, r);
                case 4:
                    return A2(cv, w, r);
                default:
                    return A2(iv, w, r);
            }
        },
        hq: jl(w),
        ht: function(n) {
            var r = n.iG;
            if (r.$) return A2(fv, y([
                gv(n.dP),
                Zl(n.cA)
            ]), w);
            var t = r.a;
            return A2(fv, y([
                gv(n.dP),
                Zl(n.cA),
                Fl(t)
            ]), w);
        },
        hH: F2(function(n, r) {
            var t = n.iG;
            if (t.$) return A2(Tl, y([
                Cl(n.a2)
            ]), r);
            var e = t.a;
            return A2(Tl, y([
                Cl(n.a2),
                Fl(e)
            ]), r);
        }),
        h1: F2(function(n, r) {
            var t;
            return A2(bv, 1 === n ? y([
                (t = n, A2(Sl, "start", Lt(t)))
            ]) : w, A2(Qe, function(n) {
                return A2(dv, w, n);
            }, r));
        }),
        fr: lv(w),
        iq: function(n) {
            return A2(Wl, w, n);
        },
        ir: function(n) {
            return A2($v, w, n);
        },
        iu: mv(w),
        iv: pv(w),
        iw: function(n) {
            return wv(A2(_i, w, A2(Yu, hv, A2(Yu, Vl, A2(Yu, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        ix: yv(w),
        iy: function(n) {
            return _v(A2(_i, w, A2(Yu, hv, A2(Yu, Vl, A2(Yu, function(n) {
                switch(n){
                    case 0:
                        return "left";
                    case 2:
                        return "center";
                    default:
                        return "right";
                }
            }, n)))));
        },
        iz: xv(w),
        iA: kv,
        iB: A2(ov, w, w),
        iJ: function(n) {
            return A2(Av, w, A2(Qe, function(n) {
                var r = n.a, t = n.b, e = function() {
                    switch(r){
                        case 0:
                            return kv("");
                        case 1:
                            return A2(sv, y([
                                nv(!0),
                                Ql(!1),
                                Hv("checkbox")
                            ]), w);
                        default:
                            return A2(sv, y([
                                nv(!0),
                                Ql(!0),
                                Hv("checkbox")
                            ]), w);
                    }
                }();
                return A2(dv, w, A2(bt, e, t));
            }, n));
        }
    }, {
        hq: Ol,
        hH: F2(function(n, r) {
            if (A2(De, "tel:", n.a2)) return A2(Tl, y([
                Cl(n.a2)
            ]), r);
            if (A2(De, "mailto:", n.a2)) return A2(Tl, y([
                Cl(n.a2)
            ]), r);
            var t = n.iG;
            if (t.$) return A2(Tl, y([
                Cl(n.a2),
                Dl("_blank")
            ]), r);
            var e = t.a;
            return A2(Tl, y([
                Cl(n.a2),
                Fl(e),
                Dl("_blank")
            ]), r);
        })
    }), Nv = {
        g9: Ne,
        ie: Bv
    }, Lv = fr("div"), Iv = F2(function(n, r) {
        return r.$ ? n(r.a) : r.a;
    }), Tv = A2(lu, Si, _o), Sv = F2(function(n, r) {
        var t = n.e;
        return A2(Nd, A2(Tv, n.gX, r), A2(Tv, t, r));
    }), Cv = F2(function(n, r) {
        return A2(lu, _i(r), Sv(n));
    }), Ev = F3(function(n, r, t) {
        n: for(;;){
            if (!t.b) return r;
            var e = t.a, u = t.b;
            switch(e.$){
                case 0:
                    var a = e.a;
                    if (a.$) {
                        i = n, o = A2(n, e, r), n = i, r = o, t = u;
                        continue n;
                    }
                    var c = a.c, i = n, o = A2(n, e, r);
                    n = i, r = o, t = p(c, u);
                    continue n;
                case 1:
                    var f = A2(id, function(n) {
                        return n.b;
                    }, s = e.b);
                    i = n, o = A2(n, e, r), n = i, r = o, t = p(f, u);
                    continue n;
                case 2:
                    var s = e.c;
                    i = n, o = A2(n, e, r), n = i, r = o, t = p(cd(s), u);
                    continue n;
                case 3:
                    s = e.a, i = n, o = A2(n, e, r), n = i, r = o, t = p(s, u);
                    continue n;
                default:
                    i = n, o = A2(n, e, r), n = i, r = o, t = u;
                    continue n;
            }
        }
    }), zv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Xv = {
        gU: ".",
        gV: {
            $: 0,
            a: 0
        },
        dk: "\u2212",
        dl: "",
        fx: "",
        fy: "",
        cq: 0,
        iC: "",
        gj: "",
        gk: ""
    }, jv = $(Xv, {
        gV: zv(2),
        iC: ","
    }), qv = $(jv, {
        gU: ",",
        iC: "."
    }), Mv = jv, Rv = $(Xv, {
        gU: ",",
        gV: zv(3),
        iC: "."
    }), Ov = F5(function(n, r, t, e, u) {
        return {
            gV: t,
            e7: r,
            fq: n,
            dA: e,
            dT: u
        };
    }), Dv = q, Fv = function(n) {
        return 0 > n ? -n : n;
    }, Vv = F2(function(n, r) {
        var t = Te(r), e = 0 > f(t, n) ? Fv(n - t) : 0;
        return p(r, A2(Pu, e, "0"));
    }), Zv = F2(function(n, r) {
        return 1 > n ? r : A3(Se, 0, -n, r);
    }), Gv = F2(function(n, r) {
        return 1 > n ? "" : A3(Se, -n, Te(r), r);
    }), Yv = function(n) {
        return "0" !== A2(Gv, 1, n) ? n : Yv(A2(Zv, 1, n));
    }, Uv = F2(function(n, r) {
        var t = n.gV;
        switch(t.$){
            case 1:
                return Yv(r);
            case 2:
                return r;
            default:
                return A2(Vv, t.a, r);
        }
    }), Qv = Q, Jv = F2(function(n, r) {
        var t = A2(ci, function(n) {
            return "0" !== n && "." !== n;
        }, fa(r));
        return p(n && t ? "-" : "", r);
    }), Kv = function(n) {
        var r = n.a, t = n.b;
        if ("9" === r) {
            var e = Gt(t);
            return 1 === e.$ ? "01" : A2(xu, "0", Kv(e.a));
        }
        var u = Mt(r);
        return u >= 48 && 57 > u ? A2(xu, Nu(u + 1), t) : "0";
    }, Wv = z, nh = F3(function(n, r, t) {
        return p(t, A2(Pu, n - Te(t), Hu(r)));
    }), rh = function(n) {
        var r = A2(Tt, ".", n);
        return r.b ? h(r.a, r.b.b ? r.b.a : "0") : h("0", "0");
    }, th = F3(function(n, r, t) {
        if ((e = t) === 1 / 0 || e === -1 / 0 || Wv(t)) return Qv(t);
        var e, u = 0 > t, a = rh(function(n) {
            var r = A2(Tt, "e", Qv(Fv(n)));
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b.a, u = A2(_i, 0, je(A2(De, "+", e) ? A2(Ce, 1, e) : e)), a = rh(t), c = p(a.a, a.b), i = 0 > u ? A2(_i, "0", A2(Yu, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Yu, zf(Hu), Gt(p(A2(Pu, Fv(u), "0"), c))))) : A3(nh, u + 1, "0", c);
                    return p(0 > n ? "-" : "", i);
                }
                return p(0 > n ? "-" : "", t = r.a);
            }
            return "";
        }(Fv(t))), c = a.a, i = a.b, o = Te(c) + r, s = p(A2(Pu, 1 - o, "0"), A3(nh, o, "0", p(c, i))), d = Te(s), b = A2(be, 1, o), l = A2(n, u, A3(Se, b, d, s)), v = A3(Se, 0, b, s), h = l ? na(A2(_i, "1", A2(Yu, Kv, Gt(na(v))))) : v, g = Te(h), $ = "0" === h ? h : r > 0 ? 0 > f(r, Te(i)) ? A3(Se, 0, g - r, h) + "." + A3(Se, g - r, g, h) : p(c + ".", A3(nh, r, "0", i)) : p(h, A2(Pu, Fv(r), "0"));
        return A2(Jv, u, $);
    })(F2(function(n, r) {
        var t, e = Gt(r);
        return 1 !== e.$ && ("5" === e.a.a ? "" !== e.a.b || !n : (t = Mt(e.a.a)) > 53 && n || t >= 53 && !n);
    })), eh = function(n) {
        return n.b ? st(n.b) : dt;
    }, uh = F2(function(n, r) {
        var t, e = function() {
            var r = n.gV;
            switch(r.$){
                case 1:
                default:
                    return th(r.a);
                case 0:
                    return Qv;
            }
        }(), u = A2(Tt, ".", e(r)), a = (t = eh(u)).$ ? "" : A2(_i, "", Gu(t.a));
        return h(A2(_i, "", Gu(u)), a);
    }), ah = F2(function(n, r) {
        return n ? function(n) {
            var r = Te(n) > 3 ? A2(Gv, 3, n) : n, t = function(n) {
                return Te(n) > 2 ? A2(bt, A2(Gv, 2, n), t(A2(Zv, 2, n))) : Te(n) ? y([
                    n
                ]) : w;
            };
            return Zt(A2(bt, r, t(A2(Zv, 3, n))));
        }(A2(Dv, Ft, r)) : function(n) {
            var r = function(n) {
                return Te(n) > 3 ? A2(bt, A2(Gv, 3, n), r(A2(Zv, 3, n))) : y([
                    n
                ]);
            };
            return Zt(r(n));
        }(A2(Dv, Ft, r));
    }), ch = F2(function(n, r) {
        var t, e = A2(uh, n, r), u = A5(Ov, r, A2(ah, n.cq, A2(Dv, Ft, e.a)), A2(Uv, n, e.b), "", "");
        switch(A2(Pt, function(n) {
            return "0" === n;
        }, Ha(A2(ad, (t = u).e7, hv(t.gV)))) ? 1 : 0 > t.fq ? 2 : 0){
            case 2:
                return $(u, {
                    dA: n.dk,
                    dT: n.dl
                });
            case 0:
                return $(u, {
                    dA: n.fx,
                    dT: n.fy
                });
            default:
                return $(u, {
                    dA: n.gj,
                    dT: n.gk
                });
        }
    }), ih = F2(function(n, r) {
        return "" === r ? "" : p(n.gU, r);
    }), oh = F2(function(n, r) {
        var t = ih(n), e = A2(It, n.iC, r.e7), u = t(r.gV);
        return Ha(y([
            r.dA,
            e,
            u,
            r.dT
        ]));
    }), fh = F2(function(n, r) {
        return A2(oh, n, A2(ch, n, r));
    }), sh = $(Xv, {
        gU: ",",
        gV: zv(3),
        iC: "\u202F"
    }), dh = Mv, bh = F2(function(n, r) {
        var t = function() {
            if (n.$) return Xv;
            switch(n.a){
                case 0:
                    return qv;
                case 1:
                    return Mv;
                case 2:
                    return Rv;
                case 3:
                    return sh;
                default:
                    return dh;
            }
        }();
        return A2(fh, $(t, {
            gV: zv(2)
        }), r / 100) + "\xa0EUR";
    }), lh = function(n) {
        return Vs(A2(lu, n, fu));
    }, vh = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), hh = function(n) {
        return A2(Zv, Te(".json"), A2(It, "-", A2(vh, 1, A2(lu, _i(w), eh)(A2(Tt, "-", n)))));
    }, gh = function(n) {
        return 2 === n.$ ? st(n.a) : dt;
    }, $h = function(n) {
        return 5 === n.$ ? st(n.a) : dt;
    }, mh = F3(function(n, r, t) {
        return A3(Ct, At, 0, A2(Qe, n, A2(Ru, function(n) {
            return A2(Gb, A2(lu, oe(n), function(n) {
                return n.fZ;
            }), r.aB);
        }, t)));
    }), ph = F3(function(n, r, t) {
        return A3(Ct, At, 0, A2(Qe, A2(mh, n, r), rd(t)));
    }), wh = F3(function(n, r, t) {
        return 1 === t.$ ? 0 : t.a.$ ? A3(Ct, At, 0, A2(Qe, function(t) {
            return A3(ph, n, r, t.aB);
        }, rd(t.a.a.dy))) : A3(ph, n, r, t.a.a.aB);
    }), kh = F2(function(n, r) {
        return A3(wh, function(n) {
            return A2(_i, 0, n.fz);
        }, n, r);
    }), _h = F2(function(n, r) {
        return A3(wh, function(n) {
            return A2(_i, 0, n.e4);
        }, n, r);
    }), yh = function(n) {
        return "Problem at row " + Lt(n.ih) + "\n" + function(n) {
            switch(n.$){
                case 0:
                    return "Expecting " + n.a;
                case 1:
                    return "Expecting int";
                case 2:
                    return "Expecting hex";
                case 3:
                    return "Expecting octal";
                case 4:
                    return "Expecting binary";
                case 5:
                    return "Expecting float";
                case 6:
                    return "Expecting number";
                case 7:
                    return "Expecting variable";
                case 8:
                    return "Expecting symbol " + n.a;
                case 9:
                    return "Expecting keyword " + n.a;
                case 10:
                    return "Expecting keyword end";
                case 11:
                    return "Unexpected char";
                case 12:
                    return n.a;
                default:
                    return "Bad repeat";
            }
        }(n.h7);
    }, xh = {
        $: 10
    }, Hh = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Ah = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ph = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Bh = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nh = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Lh = {
        $: 0
    }, Ih = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Th = {
        $: 8
    }, Sh = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ch = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Eh = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jh = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), qh = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Mh = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), Rh = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Oh = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Dh = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Fh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Vh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zh = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), Gh = F6(function(n, r, t, e, u, a) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u,
            f: a
        };
    }), Yh = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Uh = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Qh = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Jh = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Kh = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Wh = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ng = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rg = {
        $: 8
    }, tg = {
        $: 7
    }, eg = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ug = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ag = F2(function(n, r) {
        return {
            b: A2(bt, r, n.b),
            c: n.c
        };
    }), cg = function(n) {
        var r = n;
        return function(n) {
            var t = r(n);
            return 1 === t.$ ? A2(Ba, !1, t.b) : A3(Na, !1, t.b, t.c);
        };
    }, ig = function(n) {
        switch(n){
            case " ":
            case "	":
                return !0;
            default:
                return !1;
        }
    }, og = A2(Hc, "\r", Ih("a carriage return")), fg = A2(Hc, "\n", Ih("a newline")), sg = oc(y([
        Bc(fg),
        A2(tc, Bc(og), oc(y([
            Bc(fg),
            Qa(0)
        ])))
    ])), dg = A2($c, function() {
        return xh;
    }, A2(tc, cg(Oa(ig)), sg)), bg = A2(Hc, " ", Ih("a space")), lg = y([
        Nc(A2(Hc, ">", Ih(">"))),
        A2(tc, cg(Nc(bg)), oc(y([
            Nc(A2(Hc, ">", Ih(" >"))),
            Nc(A2(Hc, " >", Ih("  >"))),
            Nc(A2(Hc, "  >", Ih("   >")))
        ])))
    ]), vg = function(n) {
        switch(n){
            case "\n":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, hg = Oa(A2(lu, Pc, vg)), gg = Xa(Ih("the end of the input")), $g = oc(y([
        sg,
        gg
    ])), mg = A2(uc, A2(tc, A2(tc, Qa(Hh), oc(lg)), oc(y([
        Nc(bg),
        Qa(0)
    ]))), A2(tc, Va(hg), $g)), pg = function(n) {
        return A2(It, "\n", A2(Qe, yh, n));
    }, wg = Y, kg = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !A2(wg, n.a, "\n");
            case 12:
                if ((t = n.a).b) {
                    n = t.a;
                    continue n;
                }
                return !1;
            case 4:
                var r = n.e;
                if (r.b) {
                    var t;
                    if ((t = r.a).b) {
                        n = t.a;
                        continue n;
                    }
                    return !1;
                }
                return !1;
            case 0:
                return !0;
            default:
                return !1;
        }
    }, _g = function(n) {
        return {
            $: 3,
            a: n
        };
    }, yg = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), xg = Ih("at least 1 tag name character"), Hg = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "	":
            case "/":
            case "<":
            case ">":
            case '"':
            case "'":
            case "=":
                return !1;
            default:
                return !0;
        }
    }, Ag = A2(Fa, F2(function(n) {
        return sa(n);
    }), A2(tc, A2(vc, Hg, xg), Oa(Hg))), Pg = Ag, Bg = function(n) {
        return Bc(A2(Hc, n, xc(n)));
    }, Ng = Wc(y([
        h("amp", "&"),
        h("lt", "<"),
        h("gt", ">"),
        h("apos", "'"),
        h("quot", '"')
    ])), Lg = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return xt(t);
            var e = r.a, u = r.b;
            switch(e){
                case "0":
                    n = a = n - 1, r = c = u, t = i = t;
                    continue n;
                case "1":
                    var a = n - 1, c = u, i = t + A2(ca, 16, n);
                    n = a, r = c, t = i;
                    continue n;
                case "2":
                    a = n - 1, c = u, i = t + 2 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "3":
                    a = n - 1, c = u, i = t + 3 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "4":
                    a = n - 1, c = u, i = t + 4 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "5":
                    a = n - 1, c = u, i = t + 5 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "6":
                    a = n - 1, c = u, i = t + 6 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "7":
                    a = n - 1, c = u, i = t + 7 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "8":
                    a = n - 1, c = u, i = t + 8 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "9":
                    a = n - 1, c = u, i = t + 9 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "a":
                    a = n - 1, c = u, i = t + 10 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "b":
                    a = n - 1, c = u, i = t + 11 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "c":
                    a = n - 1, c = u, i = t + 12 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "d":
                    a = n - 1, c = u, i = t + 13 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "e":
                    a = n - 1, c = u, i = t + 14 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                case "f":
                    a = n - 1, c = u, i = t + 15 * A2(ca, 16, n), n = a, r = c, t = i;
                    continue n;
                default:
                    return wt(Hu(e) + " is not a valid hexadecimal character.");
            }
        }
    }), Ig = function(n) {
        var r = function(n) {
            var r, t = A2(De, "#x", r = n) ? A2(Gi, Ga, A2(Uu, Nu, function(n) {
                if (ze(n)) return wt("Empty strings are not valid hexadecimal strings.");
                var r = function() {
                    if (A2(De, "-", n)) {
                        var r = A2(_i, w, eh(fa(n)));
                        return A2(Uu, Ma, A3(Lg, Et(r) - 1, r, 0));
                    }
                    return A3(Lg, Te(n) - 1, fa(n), 0);
                }();
                return A2(Gi, function(r) {
                    return A2(It, " ", y([
                        '"' + n + '"',
                        "is not a valid hexadecimal string because",
                        r
                    ]));
                }, r);
            }(A2(Ce, 2, r)))) : A2(De, "#", r) ? A2(Fu, Ga("Invalid escaped character: " + r), A2(Yu, Nu, je(A2(Ce, 1, r)))) : A2(Fu, Ga('No entity named "&' + r + ';" found.'), A2(Si, r, Ng));
            return t.$ ? Ya(t.a) : Qa(t.a);
        }, t = function(r) {
            return !a(r, n) && ";" !== r;
        };
        return A2(uc, A2(tc, Qa(Ne), Bg("&")), A2(tc, A2(La, r, Va(A2(tc, A2(vc, t, Ih("an entity character")), Oa(t)))), Bg(";")));
    }, Tg = F3(function(n, r, t) {
        return A2(La, function(r) {
            return oc(y([
                A2($c, function(n) {
                    return wc(p(t, p(r, Hu(n))));
                }, Ig(n)),
                Qa(pc(p(t, r)))
            ]));
        }, Va(Oa(r)));
    }), Sg = function(n) {
        return A2(gc, "", A2(Tg, n, function(r) {
            return !a(r, n) && "&" !== r;
        }));
    }, Cg = oc(y([
        A2(uc, A2(tc, Qa(Ne), Bg('"')), A2(tc, Sg('"'), Bg('"'))),
        A2(uc, A2(tc, Qa(Ne), Bg("'")), A2(tc, Sg("'"), Bg("'")))
    ])), Eg = F2(function(n, r) {
        return st(r.$ ? n : r.a);
    }), zg = function(n) {
        switch(n){
            case " ":
            case "\r":
            case "\n":
            case "	":
                return !0;
            default:
                return !1;
        }
    }, Xg = Oa(zg), jg = function(n) {
        return oc(y([
            A2(uc, A2(uc, Qa(F2(function(r, t) {
                return wc(A3(Ri, sa(r), Eg(t), n));
            })), A2(tc, A2(tc, A2(tc, Pg, Xg), Bg("=")), Xg)), A2(tc, Cg, Xg)),
            Qa(pc(n))
        ]));
    }, qg = A2($c, A2($s, F3(function(n, r, t) {
        return A2(bt, {
            dj: n,
            bL: r
        }, t);
    }), w), A2(gc, Gc, jg)), Mg = function(n) {
        return function(r) {
            var t = A5(at, n, r.f, r.ih, r.eo, r.dP), e = t.a, u = t.b, a = t.c, c = 0 > e ? Te(r.dP) : e;
            return A3(Na, 0 > f(r.f, c), 0, {
                eo: a,
                gH: r.gH,
                j: r.j,
                f: c,
                ih: u,
                dP: r.dP
            });
        };
    }, Rg = A2(uc, A2(tc, Qa(Ne), Bg("<![CDATA[")), A2(tc, Va(Mg("]]>")), Bg("]]>"))), Og = F2(function(n, r) {
        return A2($c, function(n) {
            return n(r);
        }, oc(n));
    }), Dg = function(n) {
        var r = A2(La, function(r) {
            return a(n, r) ? Qa(0) : Ya(Ga("tag name mismatch: " + n + " and " + r));
        }, Ag);
        return A2(tc, A2(tc, A2(tc, A2(tc, Bg("</"), Xg), r), Xg), Bg(">"));
    }, Fg = function(n) {
        return A2(Hc, n, Ih(n));
    }, Vg = A2(uc, A2(tc, Qa(function(n) {
        return {
            $: 2,
            a: n
        };
    }), Bc(Fg("<!--"))), A2(tc, Va(Mg("-->")), Bc(Fg("-->")))), Zg = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Gg = Ih("at least 1 uppercase character"), Yg = Va(A2(tc, A2(vc, Ot, Gg), Oa(Ot))), Ug = A2(tc, A2(vc, zg, Ih("at least one whitespace")), Oa(zg)), Qg = A2(uc, A2(uc, A2(tc, Qa(Zg), Bg("<!")), A2(tc, Yg, Ug)), A2(tc, Va(Mg(">")), Bg(">"))), Jg = A2(uc, A2(tc, Qa(function(n) {
        return {
            $: 4,
            a: n
        };
    }), Bg("<?")), A2(tc, Va(Mg("?>")), Bg("?>"))), Kg = function(n) {
        switch(n){
            case "<":
            case "&":
                return !1;
            default:
                return !0;
        }
    }, Wg = y([
        A2($c, function() {
            return wc(0);
        }, A2(tc, A2(vc, Kg, Ih("is not & or <")), Oa(Kg))),
        A2($c, function() {
            return wc(0);
        }, Ig("<")),
        Qa(pc(0))
    ]), n$ = Va(A2(gc, 0, function() {
        return oc(Wg);
    })), r$ = function(n) {
        return A2(gc, w, Og(t$(n)));
    }, t$ = function(n) {
        return y([
            A2($c, F2(function(n, r) {
                return pc(Zt(r));
            }), Dg(n)),
            A2(La, function(r) {
                return ze(r) ? A2($c, F2(function(n, r) {
                    return pc(Zt(r));
                }), Dg(n)) : Qa(function(n) {
                    return wc(A2(bt, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(r), n));
                });
            }, n$),
            A2($c, F2(function(n, r) {
                return wc(A2(bt, n, r));
            }), u$())
        ]);
    }, e$ = function(n) {
        return A2(uc, A2(uc, A2(tc, Qa(yg(n)), Xg), A2(tc, qg, Xg)), oc(y([
            A2($c, function() {
                return w;
            }, Bg("/>")),
            A2(uc, A2(tc, Qa(Ne), Bg(">")), r$(n))
        ])));
    };
    function u$() {
        return oc(y([
            A2($c, _g, Rg),
            Jg,
            Vg,
            Qg,
            a$()
        ]));
    }
    function a$() {
        return A2(uc, A2(tc, Qa(Ne), Bg("<")), A2(La, e$, Ag));
    }
    var c$ = u$();
    u$ = function() {
        return c$;
    };
    var i$ = a$();
    a$ = function() {
        return i$;
    };
    var o$, f$, s$, d$ = A2(Hc, "	", Ih("a tab")), b$ = oc(y([
        Nc(d$),
        A2(tc, cg(Nc(bg)), oc(y([
            Nc(A2(Hc, "   ", xc("Indentation"))),
            Nc(A2(Hc, " 	", xc("Indentation"))),
            Nc(A2(Hc, "  	", xc("Indentation")))
        ])))
    ])), l$ = A2(uc, A2(tc, Qa(Rh), b$), A2(tc, Va(hg), $g)), v$ = function(n) {
        return !A2(Lu, 2, n);
    }, h$ = function(n) {
        return n ? 1 : 0;
    }, g$ = F3(function(n, r, t) {
        var e = h(r, t);
        return "" === e.a ? t : "" === e.b ? r : p(r, p(n, t));
    }), $$ = F2(function(n, r) {
        return n + "\n" + r;
    }), m$ = A2(Fa, F2(function(n) {
        return Vh(n);
    }), hg), p$ = A2(tc, m$, $g), w$ = F4(function(n, r, t, e) {
        return {
            n: e,
            hA: r,
            hL: t,
            h$: n
        };
    }), k$ = function(n) {
        return A3(Na, !1, n.eo, n);
    }, _$ = A2(uc, Qa(function(n) {
        return h(n, "");
    }), A2(tc, k$, $g)), y$ = function(n) {
        return A2(tc, A2(vc, n, Ga("Expected one or more character")), Oa(n));
    }, x$ = A2(uc, A2(uc, A2(tc, Qa(F2(function(n, r) {
        return h(n, r);
    })), y$(ig)), k$), A2(tc, Va(hg), $g)), H$ = A2(Hc, ")", Ih("a `)`")), A$ = A2(Hc, ".", Ih("a `.`")), P$ = oc(y([
        A2(tc, Qa(0), Nc(A$)),
        A2(tc, Qa(1), Nc(H$))
    ])), B$ = A2(Fa, F2(function(n) {
        return A2(_i, 0, je(n));
    }), y$(Ft)), N$ = A2(La, function(n) {
        return n > 999999999 ? Ya(Ga("Starting numbers must be nine digits or less.")) : Qa(n);
    }, B$), L$ = Bc(bg), I$ = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(bt, t, n), r -= 1;
        }
    }), T$ = F2(function(n, r) {
        return A3(I$, w, n, r);
    }), S$ = F2(function(n, r) {
        var t = A2(T$, n, r);
        if (t.b) {
            var e = t.a, u = t.b;
            return A3(Ct, F2(function(n, r) {
                return oc(y([
                    A2(tc, n, r),
                    Qa(0)
                ]));
            }), oc(y([
                e,
                Qa(0)
            ])), u);
        }
        return Qa(0);
    }), C$ = function(n) {
        return 1 === n ? Qa(n) : Ya(Ga("Lists inside a paragraph or after a paragraph without a blank line must start with 1"));
    }, E$ = function(n) {
        return A2($c, function(n) {
            return A6(Gh, !0, n.hA, n.hL, n.h$, w, n.n);
        }, function(n) {
            return A2(uc, A2(uc, A2(uc, A2(uc, A2(uc, Qa(F5(function(n, r, t, e, u) {
                var a = u.a, c = u.b;
                return a - e > 4 ? A4(w$, r, e - n + 1, t, p(A2(Pu, a - e - 1, " "), c)) : A4(w$, r, a - n, t, c);
            })), k$), cg(function(n) {
                return n ? A2(La, C$, A2(uc, A2(tc, Qa(Ne), A2(S$, 3, L$)), N$)) : A2(uc, A2(tc, Qa(Ne), A2(S$, 3, L$)), N$);
            }(n))), cg(P$)), k$), n ? x$ : oc(y([
                _$,
                x$
            ])));
        }(n));
    }, z$ = {
        $: 1
    }, X$ = F3(function(n, r, t) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t
        };
    }), j$ = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), q$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, M$ = function(n) {
        var r = n, t = r.d$;
        switch(t.$){
            case 0:
                return q$(r.iA);
            case 1:
                return z$;
            case 2:
                return function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(r.iA);
            case 3:
                var e = t.a;
                return A3(j$, e.b, dt, y([
                    q$(e.a)
                ]));
            case 4:
                var u = t.a;
                return A3(j$, u.a, u.b, R$(r.s));
            case 5:
                var a = t.a;
                return A3(X$, a.a, a.b, R$(r.s));
            case 6:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(t.a);
            case 7:
                return A2(Nh, t.a, R$(r.s));
            default:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(R$(r.s));
        }
    }, R$ = function(n) {
        return A2(Qe, M$, n);
    }, O$ = F2(function(n, r) {
        return {
            i: r.i - n.u,
            s: r.s,
            k: r.k - n.u,
            iA: r.iA,
            C: r.C - n.u,
            u: r.u - n.u,
            d$: r.d$
        };
    }), D$ = F2(function(n, r) {
        return {
            i: n.i,
            s: A2(bt, A2(O$, n, r), n.s),
            k: n.k,
            iA: n.iA,
            C: n.C,
            u: n.u,
            d$: n.d$
        };
    }), F$ = function(n) {
        var r = n;
        return {
            i: r.i,
            s: V$(r.s),
            k: r.k,
            iA: r.iA,
            C: r.C,
            u: r.u,
            d$: r.d$
        };
    }, V$ = function(n) {
        var r = A2(pi, function(n) {
            return n.k;
        }, n);
        return r.b ? A3(Z$, r.b, r.a, w) : w;
    }, Z$ = F3(function(n, r, t) {
        for(;;){
            var e = r;
            if (!n.b) return A2(bt, F$(e), t);
            var u = n.a, a = n.b;
            1 > f(e.i, u.k) ? (n = a, r = u, t = A2(bt, F$(e), t)) : 0 > f(e.k, u.k) && f(e.i, u.i) > 0 ? (n = a, r = A2(D$, e, u)) : (n = a, r = e);
        }
    }), G$ = {
        $: 0
    }, Y$ = /.^/, U$ = A2(_i, Y$, Zu("&#([0-9]{1,8});")), Q$ = rt(tt), J$ = function(n) {
        return function(n) {
            return 9 === n || 10 === n || 13 === n || 133 === n || n >= 32 && 126 >= n || n >= 160 && 55295 >= n || n >= 57344 && 64975 >= n || n >= 65008 && 65533 >= n || n >= 65536 && 1114109 >= n;
        }(n) && !function(n) {
            var r = A2(Lu, 16, n), t = A2(Lu, 131070, n);
            return !(131070 > n || (0 > t || t > 15) && (65536 > t || t > 65551) || 14 !== r && 15 !== r);
        }(n) ? Hu(Nu(n)) : Hu(Nu(65533));
    }, K$ = A2(Q$, U$, function(n) {
        var r = n.dS;
        if (r.b && !r.a.$) {
            var t = je(r.a.a);
            return t.$ ? n.fe : J$(t.a);
        }
        return n.fe;
    }), W$ = A2(_i, Y$, Zu("&([0-9a-zA-Z]+);")), nm = Wc(y([
        h("quot", 34),
        h("amp", 38),
        h("apos", 39),
        h("lt", 60),
        h("gt", 62),
        h("nbsp", 160),
        h("iexcl", 161),
        h("cent", 162),
        h("pound", 163),
        h("curren", 164),
        h("yen", 165),
        h("brvbar", 166),
        h("sect", 167),
        h("uml", 168),
        h("copy", 169),
        h("ordf", 170),
        h("laquo", 171),
        h("not", 172),
        h("shy", 173),
        h("reg", 174),
        h("macr", 175),
        h("deg", 176),
        h("plusmn", 177),
        h("sup2", 178),
        h("sup3", 179),
        h("acute", 180),
        h("micro", 181),
        h("para", 182),
        h("middot", 183),
        h("cedil", 184),
        h("sup1", 185),
        h("ordm", 186),
        h("raquo", 187),
        h("frac14", 188),
        h("frac12", 189),
        h("frac34", 190),
        h("iquest", 191),
        h("Agrave", 192),
        h("Aacute", 193),
        h("Acirc", 194),
        h("Atilde", 195),
        h("Auml", 196),
        h("Aring", 197),
        h("AElig", 198),
        h("Ccedil", 199),
        h("Egrave", 200),
        h("Eacute", 201),
        h("Ecirc", 202),
        h("Euml", 203),
        h("Igrave", 204),
        h("Iacute", 205),
        h("Icirc", 206),
        h("Iuml", 207),
        h("ETH", 208),
        h("Ntilde", 209),
        h("Ograve", 210),
        h("Oacute", 211),
        h("Ocirc", 212),
        h("Otilde", 213),
        h("Ouml", 214),
        h("times", 215),
        h("Oslash", 216),
        h("Ugrave", 217),
        h("Uacute", 218),
        h("Ucirc", 219),
        h("Uuml", 220),
        h("Yacute", 221),
        h("THORN", 222),
        h("szlig", 223),
        h("agrave", 224),
        h("aacute", 225),
        h("acirc", 226),
        h("atilde", 227),
        h("auml", 228),
        h("aring", 229),
        h("aelig", 230),
        h("ccedil", 231),
        h("egrave", 232),
        h("eacute", 233),
        h("ecirc", 234),
        h("euml", 235),
        h("igrave", 236),
        h("iacute", 237),
        h("icirc", 238),
        h("iuml", 239),
        h("eth", 240),
        h("ntilde", 241),
        h("ograve", 242),
        h("oacute", 243),
        h("ocirc", 244),
        h("otilde", 245),
        h("ouml", 246),
        h("divide", 247),
        h("oslash", 248),
        h("ugrave", 249),
        h("uacute", 250),
        h("ucirc", 251),
        h("uuml", 252),
        h("yacute", 253),
        h("thorn", 254),
        h("yuml", 255),
        h("OElig", 338),
        h("oelig", 339),
        h("Scaron", 352),
        h("scaron", 353),
        h("Yuml", 376),
        h("fnof", 402),
        h("circ", 710),
        h("tilde", 732),
        h("Alpha", 913),
        h("Beta", 914),
        h("Gamma", 915),
        h("Delta", 916),
        h("Epsilon", 917),
        h("Zeta", 918),
        h("Eta", 919),
        h("Theta", 920),
        h("Iota", 921),
        h("Kappa", 922),
        h("Lambda", 923),
        h("Mu", 924),
        h("Nu", 925),
        h("Xi", 926),
        h("Omicron", 927),
        h("Pi", 928),
        h("Rho", 929),
        h("Sigma", 931),
        h("Tau", 932),
        h("Upsilon", 933),
        h("Phi", 934),
        h("Chi", 935),
        h("Psi", 936),
        h("Omega", 937),
        h("alpha", 945),
        h("beta", 946),
        h("gamma", 947),
        h("delta", 948),
        h("epsilon", 949),
        h("zeta", 950),
        h("eta", 951),
        h("theta", 952),
        h("iota", 953),
        h("kappa", 954),
        h("lambda", 955),
        h("mu", 956),
        h("nu", 957),
        h("xi", 958),
        h("omicron", 959),
        h("pi", 960),
        h("rho", 961),
        h("sigmaf", 962),
        h("sigma", 963),
        h("tau", 964),
        h("upsilon", 965),
        h("phi", 966),
        h("chi", 967),
        h("psi", 968),
        h("omega", 969),
        h("thetasym", 977),
        h("upsih", 978),
        h("piv", 982),
        h("ensp", 8194),
        h("emsp", 8195),
        h("thinsp", 8201),
        h("zwnj", 8204),
        h("zwj", 8205),
        h("lrm", 8206),
        h("rlm", 8207),
        h("ndash", 8211),
        h("mdash", 8212),
        h("lsquo", 8216),
        h("rsquo", 8217),
        h("sbquo", 8218),
        h("ldquo", 8220),
        h("rdquo", 8221),
        h("bdquo", 8222),
        h("dagger", 8224),
        h("Dagger", 8225),
        h("bull", 8226),
        h("hellip", 8230),
        h("permil", 8240),
        h("prime", 8242),
        h("Prime", 8243),
        h("lsaquo", 8249),
        h("rsaquo", 8250),
        h("oline", 8254),
        h("frasl", 8260),
        h("euro", 8364),
        h("image", 8465),
        h("weierp", 8472),
        h("real", 8476),
        h("trade", 8482),
        h("alefsym", 8501),
        h("larr", 8592),
        h("uarr", 8593),
        h("rarr", 8594),
        h("darr", 8595),
        h("harr", 8596),
        h("crarr", 8629),
        h("lArr", 8656),
        h("uArr", 8657),
        h("rArr", 8658),
        h("dArr", 8659),
        h("hArr", 8660),
        h("forall", 8704),
        h("part", 8706),
        h("exist", 8707),
        h("empty", 8709),
        h("nabla", 8711),
        h("isin", 8712),
        h("notin", 8713),
        h("ni", 8715),
        h("prod", 8719),
        h("sum", 8721),
        h("minus", 8722),
        h("lowast", 8727),
        h("radic", 8730),
        h("prop", 8733),
        h("infin", 8734),
        h("ang", 8736),
        h("and", 8743),
        h("or", 8744),
        h("cap", 8745),
        h("cup", 8746),
        h("int", 8747),
        h("there4", 8756),
        h("sim", 8764),
        h("cong", 8773),
        h("asymp", 8776),
        h("ne", 8800),
        h("equiv", 8801),
        h("le", 8804),
        h("ge", 8805),
        h("sub", 8834),
        h("sup", 8835),
        h("nsub", 8836),
        h("sube", 8838),
        h("supe", 8839),
        h("oplus", 8853),
        h("otimes", 8855),
        h("perp", 8869),
        h("sdot", 8901),
        h("lceil", 8968),
        h("rceil", 8969),
        h("lfloor", 8970),
        h("rfloor", 8971),
        h("lang", 9001),
        h("rang", 9002),
        h("loz", 9674),
        h("spades", 9824),
        h("clubs", 9827),
        h("hearts", 9829),
        h("diams", 9830)
    ])), rm = A2(Q$, W$, function(n) {
        var r = n.dS;
        if (r.b && !r.a.$) {
            var t = A2(Si, r.a.a, nm);
            return t.$ ? n.fe : Hu(Nu(t.a));
        }
        return n.fe;
    }), tm = A2(Q$, A2(_i, Y$, Zu("(\\\\+)([!\"#$%&\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])")), function(n) {
        var r = n.dS;
        if (r.b && !r.a.$ && r.b.b && !r.b.a.$) {
            var t = r.b.a.a;
            return p(A2(Pu, Te(r.a.a) / 2 | 0, "\\"), t);
        }
        return n.fe;
    }), em = A2(_i, Y$, Zu("&#[Xx]([0-9a-fA-F]{1,8});")), um = M, am = A2(Q$, em, function(n) {
        var r, t = n.dS;
        return t.b && !t.a.$ ? J$((r = t.a.a, A3(um, F2(function(n, r) {
            return 16 * r + A2(Lu, 39, Mt(n)) - 9;
        }), 0, sa(r)))) : n.fe;
    }), cm = function(n) {
        var r = tm(n);
        return A2(Ie, "&", r) ? am(K$(rm(r))) : r;
    }, im = function(n) {
        return {
            i: 0,
            s: w,
            k: 0,
            iA: cm(n),
            C: 0,
            u: 0,
            d$: G$
        };
    }, om = F3(function(n, r, t) {
        var e = r, u = {
            i: e.i,
            s: A3(fm, e.iA, w, e.s),
            k: e.k,
            iA: e.iA,
            C: e.C,
            u: e.u,
            d$: e.d$
        };
        if (t.b) {
            var c = t.a;
            return c.d$.$ ? a(e.i, c.k) ? A2(bt, u, t) : 0 > f(e.i, c.k) ? A2(bt, u, A2(bt, im(A3(Se, e.i, c.k, n)), t)) : t : A2(bt, u, t);
        }
        var i = A2(Ce, e.i, n);
        return ze(i) ? y([
            u
        ]) : y([
            u,
            im(i)
        ]);
    }), fm = F3(function(n, r, t) {
        for(;;){
            if (!t.b) {
                if (r.b) {
                    var e = r.a;
                    return e.k > 0 ? A2(bt, im(A2(Xe, e.k, n)), r) : r;
                }
                return ze(n) ? w : y([
                    im(n)
                ]);
            }
            var u = t.b, a = n, c = A3(om, n, t.a, r);
            n = a, r = c, t = u;
        }
    }), sm = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return w;
            var e = r.a, u = r.b;
            if (n.b) {
                var a = n.a, c = n.b;
                if (0 > f(a.d, e.d)) {
                    if (t) {
                        n = c, t += 1;
                        continue n;
                    }
                    return A2(bt, a, A3(sm, c, r, t + 1));
                }
                if (t > 1) {
                    r = u, t -= 1;
                    continue n;
                }
                if (1 === t) return A2(bt, e, A3(sm, n, u, t - 1));
                r = u, t = 0;
            } else if (t > 1) r = u, t -= 1;
            else {
                if (1 === t) return A2(bt, e, A3(sm, n, u, t - 1));
                r = u, t = 0;
            }
        }
    }), dm = A2(_i, Y$, Zu("(\\\\*)(\\<)")), bm = nt(tt), lm = {
        $: 4
    }, vm = function(n) {
        var r = n.dS;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = A2(_i, 0, A2(Yu, Te, r.a));
            return v$(t) ? st({
                d: n.d + t,
                da: 1,
                h: lm
            }) : dt;
        }
        return dt;
    }, hm = A2(_i, Y$, Zu("(\\\\*)(\\>)")), gm = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $m = function(n) {
        var r = n.dS;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = A2(_i, 0, A2(Yu, Te, r.a));
            return st({
                d: n.d + t,
                da: 1,
                h: v$(t) ? gm(1) : gm(0)
            });
        }
        return dt;
    }, mm = A2(_i, Y$, Zu("(\\\\*)([^*])?(\\*+)([^*])?")), pm = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), wm = A2(um, F2(function(n, r) {
        return r || function(n) {
            switch(n){
                case "!":
                case '"':
                case "#":
                case "%":
                case "&":
                case "'":
                case "(":
                case ")":
                case "*":
                case ",":
                case "-":
                case ".":
                case "/":
                case ":":
                case ";":
                case "?":
                case "@":
                case "[":
                case "]":
                case "_":
                case "{":
                case "}":
                case "~":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), km = A2(um, F2(function(n, r) {
        return r || function(n) {
            switch(n){
                case " ":
                case "\f":
                case "\n":
                case "\r":
                case "	":
                case "\v":
                case "\xa0":
                case "\u2028":
                case "\u2029":
                    return !0;
                default:
                    return !1;
            }
        }(n);
    }), !1), _m = function(n) {
        if (n.$) return 0;
        var r = n.a;
        return ze(r) || km(r) ? 0 : wm(r) ? 1 : 2;
    }, ym = F3(function(n, r, t) {
        var e = t.dS;
        if (e.b && e.b.b && e.b.b.b && !e.b.b.a.$ && e.b.b.b.b) {
            var u = e.a, a = e.b, c = a.a, i = a.b, o = i.a.a, f = _m(i.b.a), s = c.$ ? 0 : Te(c.a), d = t.d && !s ? st(A3(Se, t.d - 1, t.d, r)) : c, b = u.$ ? 0 : Te(u.a), l = !v$(b) && !s || !d.$ && "\\" === d.a, v = l ? Te(o) - 1 : Te(o), h = l ? 1 : _m(d);
            return 0 >= v || "_" === n && 2 === h && 2 === f ? dt : st({
                d: t.d + b + s + (l ? 1 : 0),
                da: v,
                h: A2(pm, n, {
                    ca: h,
                    cl: f
                })
            });
        }
        return dt;
    }), xm = A2(_i, Y$, Zu("(\\\\*)(\\`+)")), Hm = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Am = function(n) {
        var r = n.dS;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = r.b.a.a, e = A2(_i, 0, A2(Yu, Te, r.a));
            return st({
                d: n.d + e,
                da: Te(t),
                h: v$(e) ? Hm(1) : Hm(0)
            });
        }
        return dt;
    }, Pm = A2(_i, Y$, Zu("(?:(\\\\+)|( {2,}))\\n")), Bm = {
        $: 8
    }, Nm = function(n) {
        var r = n.dS;
        n: for(;;){
            if (r.b) {
                if (r.a.$) {
                    if (r.b.b && !r.b.a.$) return st({
                        d: n.d,
                        da: Te(n.fe),
                        h: Bm
                    });
                    break n;
                }
                var t = Te(r.a.a);
                return v$(t) ? dt : st({
                    d: n.d + t - 1,
                    da: 2,
                    h: Bm
                });
            }
            break n;
        }
        return dt;
    }, Lm = (Zu("(?:(\\\\+)|( *))\\n"), A2(_i, Y$, Zu("(\\\\*)(\\])"))), Im = {
        $: 3
    }, Tm = function(n) {
        var r = n.dS;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = A2(_i, 0, A2(Yu, Te, r.a));
            return v$(t) ? st({
                d: n.d + t,
                da: 1,
                h: Im
            }) : dt;
        }
        return dt;
    }, Sm = A2(_i, Y$, Zu("(\\\\*)(\\!)?(\\[)")), Cm = {
        $: 2
    }, Em = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zm = function(n) {
        var r = n.dS;
        if (r.b && r.b.b && r.b.b.b && !r.b.b.a.$) {
            var t = r.b.a, e = A2(_i, 0, A2(Yu, Te, r.a)), u = !v$(e), a = u ? n.d + e + 1 : n.d + e;
            return u ? t.$ ? dt : st({
                d: a,
                da: 1,
                h: Em(0)
            }) : st(t.$ ? {
                d: a,
                da: 1,
                h: Em(0)
            } : {
                d: a,
                da: 2,
                h: Cm
            });
        }
        return dt;
    }, Xm = function(n) {
        return {
            $: 9,
            a: n
        };
    }, jm = function(n) {
        var r = n.dS;
        if (r.b && r.b.b && !r.b.a.$) {
            var t = r.b.a.a, e = A2(_i, 0, A2(Yu, Te, r.a)), u = v$(e) ? h(Te(t), Xm(1)) : h(Te(t), Xm(0));
            return st({
                d: n.d + e,
                da: u.a,
                h: u.b
            });
        }
        return dt;
    }, qm = A2(_i, Y$, Zu("(\\\\*)(~{2,})([^~])?")), Mm = A2(_i, Y$, Zu("(\\\\*)([^_])?(\\_+)([^_])?")), Rm = F2(function(n, r) {
        if (n.b) {
            var t = n.a, e = n.b;
            if (r.b) {
                var u = r.a, a = r.b;
                return 0 > f(t.d, u.d) ? A2(bt, t, A2(Rm, e, r)) : A2(bt, u, A2(Rm, n, a));
            }
            return n;
        }
        return r;
    }), Om = {
        $: 2
    }, Dm = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Fm = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Vm = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Zm = {
        $: 8
    }, Gm = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ym = Wr, Um = A2(_i, Y$, Zu("%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)")), Qm = A2(pu, cl, A2(Q$, Um, function(n) {
        return A2(_i, n.fe, function(n) {
            try {
                return st(decodeURIComponent(n));
            } catch (n) {
                return dt;
            }
        }(n.fe));
    })), Jm = A2(_i, Y$, Zu("^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$")), Km = A2(_i, Y$, Zu("^\\[\\s*([^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*)\\s*\\]")), Wm = function(n) {
        return n;
    }, np = A2(pu, Wm, sa), rp = F2(function(n, r) {
        return h(Qm(cm(n)), A2(Yu, cm, r));
    }), tp = F3(function(n, r, t) {
        var e, u = ze(e = A2(_i, n.iA, A2(_i, dt, A2(ju, A2(pu, function(n) {
            return n.dS;
        }, Gu), t)))) ? n.iA : e, a = A2(Si, np(u), r);
        if (1 === a.$) return dt;
        var c = a.a, i = c.a, o = c.b, f = 5 === n.d$.$ ? Fm(A2(rp, i, o)) : Vm(A2(rp, i, o)), s = t.$ ? 0 : Te(t.a.fe);
        return st($(n, {
            i: n.i + s,
            d$: f
        }));
    }), ep = F3(function(n, r, t) {
        return A3(tp, r, t, Gu(A3(Du, 1, Km, n)));
    }), up = " \\t\\f\\v\\r\\n", ap = A2(_i, Y$, Zu("^\\(\\s*(?:<([^<>\\f\\v\\r\\n]*)>|([^" + up + "\\(\\)\\\\]*(?:\\\\.[^" + up + "\\(\\)\\\\]*)*))(?:[" + up + "]+(?:'([^'\\\\]*(?:\\\\.[^'\\\\]*)*)'|\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?\\s*\\)")), cp = function(n) {
        var r = F2(function(n, r) {
            return r.$ ? n : st(r.a);
        });
        return A3(Ct, r, dt, n);
    }, ip = F2(function(n, r) {
        var t, e = r.dS;
        if (e.b && e.b.b && e.b.b.b && e.b.b.b.b && e.b.b.b.b.b) {
            var u = e.a, a = e.b, c = a.a, i = a.b, o = i.b, f = cp(y([
                i.a,
                o.a,
                o.b.a
            ])), s = cp(y([
                u,
                c
            ]));
            return st((t = A2(_i, "", s), $(n, {
                i: n.i + Te(r.fe),
                d$: (5 === n.d$.$ ? Fm : Vm)(A2(rp, t, f))
            })));
        }
        return dt;
    }), op = F3(function(n, r, t) {
        var e = r, u = A3(Du, 1, ap, n);
        if (u.b) {
            var a = A2(ip, e, u.a);
            return a.$ ? A3(ep, n, e, t) : st(a.a);
        }
        return A3(ep, n, e, t);
    }), fp = F2(function(n, r) {
        var t = n, e = ei(function(n) {
            var r = n;
            return f(t.i, r.k) > 0 && 0 > f(t.i, r.i);
        });
        return zl(r) || zl(e(r)) ? st(A2(bt, t, r)) : dt;
    }), sp = A2(_i, Y$, Zu("^([a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$")), dp = function(n) {
        var r = n;
        return A2(Ym, sp, r.iA) ? xt($(r, {
            d$: Gm(h(r.iA, "mailto:" + Qm(r.iA)))
        })) : wt(r);
    }, bp = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return dt;
            var e = t.a, u = t.b;
            if (r(e)) return st(g(e, Zt(n), u));
            n = A2(bt, e, n), t = u;
        }
    }), lp = F2(function(n, r) {
        return A3(bp, w, n, r);
    }), vp = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), hp = function(n) {
        return A3(Na, !1, n.f, n);
    }, gp = F2(function(n, r) {
        var t = r, e = A2(uc, A2(uc, A2(uc, Qa(F3(function(n, r, t) {
            return {
                eZ: r,
                da: t - n
            };
        })), hp), c$), hp), u = A2(Rc, e, A2(Ce, t.k, n));
        return u.$ ? dt : st({
            d: t.k,
            da: u.a.da,
            h: A2(vp, 0, u.a.eZ)
        });
    }), $p = F2(function(n, r) {
        return r.$ ? n(r.a) : r;
    }), mp = F2(function(n, r) {
        var t = r.h;
        return !t.$ && a(t.a ? r.da : r.da - 1, n.da);
    }), pp = function(n) {
        switch(n.h.$){
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, wp = F2(function(n, r) {
        var t = r.h;
        if (7 === t.$) {
            var e = t.b, u = n.h;
            if (7 === u.$) {
                var c = u.b;
                return !(!a(t.a, u.a) || (a(e.ca, e.cl) || a(c.ca, c.cl)) && !A2(Lu, 3, n.da + r.da) && (A2(Lu, 3, n.da) || A2(Lu, 3, r.da)));
            }
            return !1;
        }
        return !1;
    }), kp = F2(function(n, r) {
        var t, e, u = 9 === (e = r.h).$ ? h(!0, e.a ? r.da : r.da - 1) : h(!1, 0), c = u.a, i = u.b, o = 9 === (t = n.h).$ ? h(!0, t.a ? n.da : n.da - 1) : h(!1, 0);
        return o.a && c && a(o.b, i);
    }), _p = {
        $: 1
    }, yp = F2(function(n, r) {
        return {
            i: n.d + n.da,
            s: w,
            k: n.d,
            iA: "",
            C: 0,
            u: 0,
            d$: r
        };
    }), xp = F2(function(n, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.a, e = n.b;
            8 !== t.h.$ ? n = e : (n = e, r = A2(bt, A2(yp, t, _p), r));
        }
    }), Hp = F2(function(n, r) {
        var t = n;
        return A2(ei, function(n) {
            return f(n.d, t.i) > -1;
        }, r);
    }), Ap = F6(function(n, r, t, e, u, a) {
        var c, i = a.c, o = A2($p, dp, A2(Ym, Jm, (c = A7(zp, e, u, function(n) {
            return n;
        }, Om, a.a, n, w)).iA) ? xt($(c, {
            d$: Gm(h(c.iA, Qm(c.iA)))
        })) : wt(c));
        if (1 === o.$) {
            if (1 === r) {
                var f = A2(gp, u, o.a);
                return f.$ ? dt : st(h(A2(bt, f.a, i), t));
            }
            return dt;
        }
        return st(h(i, A2(bt, o.a, t)));
    }), Pp = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A5(Ip, Zt(r), w, t, e, u);
            var a = n.a, c = n.b, i = a.h;
            switch(i.$){
                case 0:
                    var o = A2(lp, mp(a), r);
                    if (o.$) {
                        n = c, r = A2(bt, a, r);
                        continue n;
                    }
                    var f = A5(Bp, a, t, e, u, o.a);
                    n = c, r = h = f.a, t = g = f.b;
                    continue n;
                case 5:
                    var s = i.a, d = function(n) {
                        return 4 === n.h.$;
                    }, b = A2(lp, d, r);
                    if (b.$) {
                        n = c, r = A2(ei, A2(lu, Pc, d), r);
                        continue n;
                    }
                    var l = A6(Ap, a, s, t, e, u, b.a);
                    if (l.$) {
                        n = c, r = A2(ei, A2(lu, Pc, d), r);
                        continue n;
                    }
                    var v = l.a, h = v.a, g = v.b;
                    n = c, r = A2(ei, A2(lu, Pc, d), h), t = g;
                    continue n;
                default:
                    n = c, r = A2(bt, a, r);
                    continue n;
            }
        }
    }), Bp = F5(function(n, r, t, e, u) {
        var a, c = u.a, i = u.c, o = (a = c.h).$ || a.a ? c : $(c, {
            d: c.d + 1,
            da: c.da - 1
        });
        return h(i, A2(bt, A7(zp, t, e, Wm, Om, o, n, w), r));
    }), Np = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A5(Cp, Zt(r), w, t, e, u);
            var c = n.a, i = n.b, o = c.h;
            if (7 !== o.$) n = i, r = A2(bt, c, r);
            else {
                var s = o.a, d = o.b.cl, b = o.b.ca;
                if (a(b, d)) {
                    if (!d || "_" === s && 1 !== d) {
                        n = i;
                        continue n;
                    }
                    var l = A2(lp, wp(c), r);
                    if (l.$) {
                        n = i, r = A2(bt, c, r);
                        continue n;
                    }
                    var v = A5(Lp, e, u, c, i, l.a);
                    n = v.a, r = v.c, t = A2(bt, v.b, t);
                    continue n;
                }
                if (0 > f(b, d)) {
                    n = i, r = A2(bt, c, r);
                    continue n;
                }
                var h = A2(lp, wp(c), r);
                if (h.$) {
                    n = i;
                    continue n;
                }
                var g = A5(Lp, e, u, c, i, h.a);
                n = g.a, r = g.c, t = A2(bt, g.b, t);
            }
        }
    }), Lp = F5(function(n, r, t, e, u) {
        var a = u.a, c = u.b, i = u.c, o = a.da - t.da, f = o ? o > 0 ? {
            bU: t,
            bC: $(a, {
                d: a.d + o,
                da: t.da
            }),
            ck: A2(bt, $(a, {
                da: o
            }), i),
            cs: e
        } : {
            bU: $(t, {
                da: a.da
            }),
            bC: a,
            ck: i,
            cs: A2(bt, $(t, {
                d: t.d + a.da,
                da: -o
            }), e)
        } : {
            bU: t,
            bC: a,
            ck: i,
            cs: e
        }, s = A7(zp, n, r, function(n) {
            return n;
        }, function(n) {
            return {
                $: 7,
                a: n
            };
        }(f.bC.da), f.bC, f.bU, Zt(c));
        return g(f.cs, s, f.ck);
    }), Ip = F5(function(n, r, t, e, u) {
        for(;;){
            if (!n.b) return A5(Tp, Zt(r), w, t, e, u);
            var a = n.a, c = n.b, i = a.h;
            6 !== i.$ ? (n = c, r = A2(bt, a, r)) : (n = c, t = A2(bt, A2(yp, a, Dm(i.b)), t));
        }
    }), Tp = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A5(Np, Zt(r), w, t, e, u);
            var a = n.a, c = n.b;
            if (3 !== a.h.$) n = c, r = A2(bt, a, r);
            else {
                var i = A2(lp, pp, r);
                if (i.$) {
                    n = c;
                    continue n;
                }
                var o = A6(Sp, a, c, t, e, u, i.a);
                if (o.$) {
                    n = c;
                    continue n;
                }
                var f = o.a;
                n = f.a, r = f.c, t = f.b;
            }
        }
    }), Sp = F6(function(n, r, t, e, u, a) {
        var c = a.a, i = a.b, o = a.c, f = g(r, t, p(i, o)), s = A2(Ce, n.d + 1, u), d = function(n) {
            return 1 === n.h.$ ? $(n, {
                h: Em(1)
            }) : n;
        }, b = function(r) {
            return A7(zp, e, u, function(n) {
                return n;
            }, r ? Vm(h("", dt)) : Fm(h("", dt)), c, n, Zt(i));
        }, l = c.h;
        switch(l.$){
            case 2:
                var v = b(!1), m = A3(op, s, v, e);
                if (1 === m.$) return st(f);
                var w = A2(fp, y = m.a, t);
                if (w.$) return st(f);
                var k = w.a;
                return st(g(A2(Hp, y, r), k, o));
            case 1:
                if (l.a) return st(f);
                v = b(!0);
                var _ = A3(op, s, v, e);
                if (1 === _.$) return st(f);
                var y, x = A2(fp, y = _.a, t);
                return x.$ ? st(f) : (k = x.a, st(g(A2(Hp, y, r), k, A2(Qe, d, o))));
            default:
                return dt;
        }
    }), Cp = F5(function(n, r, t, e, u) {
        n: for(;;){
            if (!n.b) return A2(xp, Zt(r), t);
            var a = n.a, c = n.b;
            if (9 !== a.h.$) n = c, r = A2(bt, a, r);
            else {
                var i = A2(lp, kp(a), r);
                if (i.$) {
                    n = c, r = A2(bt, a, r);
                    continue n;
                }
                var o = A5(Ep, a, t, e, u, i.a);
                n = c, r = o.a, t = o.b;
            }
        }
    }), Ep = F5(function(n, r, t, e, u) {
        var a, c = u.a, i = u.c, o = 9 !== (a = c.h).$ || a.a ? c : $(c, {
            d: c.d + 1,
            da: c.da - 1
        });
        return h(i, A2(bt, A7(zp, t, e, Wm, Zm, o, n, w), r));
    }), zp = F7(function(n, r, t, e, u, a, c) {
        var i = u.d + u.da, o = a.d, f = t(A3(Se, i, o, r)), s = u.d, d = a.d + a.da, b = {
            i: d,
            s: w,
            k: s,
            iA: f,
            C: o,
            u: i,
            d$: e
        };
        return {
            i: d,
            s: A2(Qe, function(n) {
                return A2(O$, b, n);
            }, A4(Xp, c, w, n, r)),
            k: s,
            iA: f,
            C: o,
            u: i,
            d$: e
        };
    }), Xp = F4(function(n, r, t, e) {
        return A5(Pp, n, w, r, t, e);
    }), jp = F2(function(n, r) {
        var t = Pb(r), e = function(n) {
            var r;
            return A2(Rm, A3(sm, A2(pi, function(n) {
                return n.d;
            }, A2(Ru, vm, A2(bm, dm, n))), A2(pi, function(n) {
                return n.d;
            }, A2(Ru, $m, A2(bm, hm, n))), 0), A2(Rm, (r = n, A2(Ru, Nm, A2(bm, Pm, r))), A2(Rm, function(n) {
                return A2(Ru, Tm, A2(bm, Lm, n));
            }(n), A2(Rm, function(n) {
                return A2(Ru, zm, A2(bm, Sm, n));
            }(n), A2(Rm, function(n) {
                return A2(Ru, jm, A2(bm, qm, n));
            }(n), A2(Rm, function(n) {
                return A2(Ru, A2(ym, "_", n), A2(bm, Mm, n));
            }(n), A2(Rm, function(n) {
                return A2(Ru, A2(ym, "*", n), A2(bm, mm, n));
            }(n), function(n) {
                return A2(Ru, Am, A2(bm, xm, n));
            }(n))))))));
        }(t);
        return R$(A3(fm, t, w, V$(A4(Xp, e, w, n, t))));
    }), qp = oc(y([
        Bc(A2(Hc, " ", Ih(" "))),
        Bc(A2(Hc, ">", Ih(">"))),
        A2(tc, A2(tc, A2(vc, Dt, Ih("Alpha")), Oa(function(n) {
            return Vt(n) || "-" === n;
        })), oc(y([
            Bc(A2(Hc, ":", Ih(":"))),
            Bc(A2(Hc, "@", Ih("@"))),
            Bc(A2(Hc, "\\", Ih("\\"))),
            Bc(A2(Hc, "+", Ih("+"))),
            Bc(A2(Hc, ".", Ih(".")))
        ])))
    ])), Mp = cg(A2(Fa, F2(function(n) {
        return Vh(n);
    }), A2(tc, A2(tc, A2(tc, Bc(A2(Hc, "<", Ih("<"))), qp), hg), $g))), Rp = function(n) {
        return Bc(A2(Hc, n, Ih(n)));
    }, Op = function(n) {
        var r = n.a, t = n.b, e = A2(_i, pc(t), A2(Yu, function(n) {
            return pc(A2(bt, n, t));
        }, r)), u = A2(_i, wc(h(dt, t)), A2(Yu, function(n) {
            return wc(h(dt, A2(bt, n, t)));
        }, r)), a = function(n) {
            return wc(h(st(function(n) {
                return p(A2(_i, "", r), n);
            }(n)), t));
        };
        return oc(y([
            A2($c, function() {
                return e;
            }, Rp("|\n")),
            A2($c, function() {
                return e;
            }, Rp("\n")),
            A2($c, function() {
                return e;
            }, Xa(Ih("end"))),
            A2(tc, cg(Qa(a("|"))), Rp("\\\\|")),
            A2(tc, cg(Qa(a("\\"))), Rp("\\\\")),
            A2(tc, cg(Qa(a("|"))), Rp("\\|")),
            A2(tc, cg(Qa(u)), Rp("|")),
            A2(Fa, F2(function(n) {
                return a(n);
            }), A2(vc, Cu(!0), Ga("No character found")))
        ]));
    }, Dp = A2($c, A2(Ct, F2(function(n, r) {
        return A2(bt, Pb(n), r);
    }), w), A2(gc, h(dt, w), Op)), Fp = A2(uc, A2(tc, Qa(Ne), oc(y([
        Rp("|"),
        Qa(0)
    ]))), Dp), Vp = F2(function(n, r) {
        var t, e = n.b, u = A2(Rc, Fp, r);
        return u.$ ? wt("Unable to parse previous line as a table header") : a(Et(t = u.a), Et(e)) ? xt(function(n) {
            return A3(zt, F2(function(n, r) {
                return {
                    bN: r,
                    bt: n
                };
            }), n, e);
        }(t)) : wt("Tables must have the same number of header columns (" + Lt(Et(t)) + ") as delimiter columns (" + Lt(Et(e)) + ")");
    }), Zp = F2(function(n, r) {
        return {
            n: r,
            fa: n
        };
    }), Gp = {
        bS: "`",
        b9: 0,
        cr: A2(Hc, "`", Ih("a '`'"))
    }, Yp = function(n) {
        switch(n){
            case 1:
                return Qa(0);
            case 2:
                return Qa(1);
            case 3:
                return Qa(2);
            case 4:
                return Qa(3);
            default:
                return Ya(Ih("Fenced code blocks should be indented no more than 3 spaces"));
        }
    }, Up = F2(function(n, r) {
        var t = A3(Ct, F2(function(n, r) {
            return A2(tc, r, n);
        }), Qa(0), A2(T$, n, Bc(r.cr)));
        return A2(Fa, F2(function(n) {
            return h(r, Te(n));
        }), A2(tc, t, Oa(oe(r.bS))));
    }), Qp = {
        bS: "~",
        b9: 1,
        cr: A2(Hc, "~", Ih("a `~`"))
    }, Jp = oc(y([
        A2(tc, A2(tc, L$, oc(y([
            L$,
            Qa(0)
        ]))), oc(y([
            L$,
            Qa(0)
        ]))),
        Qa(0)
    ])), Kp = A2(uc, A2(uc, A2(tc, Qa(F2(function(n, r) {
        return {
            bT: r.a,
            c6: n,
            da: r.b
        };
    })), Jp), A2(La, Yp, k$)), oc(y([
        A2(Up, 3, Gp),
        A2(Up, 3, Qp)
    ]))), Wp = oe(" "), nw = F2(function(n, r) {
        return A2(tc, A2(tc, A2(tc, A2(tc, Qa(0), Jp), A2(Up, n, r)), Oa(Wp)), $g);
    }), rw = function(n) {
        return A3(Na, !1, n.dP, n);
    }, tw = function(n) {
        var r, t = n.a, e = n.b;
        return oc(y([
            A2(tc, Qa(pc(e)), Xa(Ta)),
            A2(Fa, F2(function(n) {
                return wc(h(t, p(e, n)));
            }), sg),
            cg(A2(tc, Qa(pc(e)), A2(nw, t.da, t.bT))),
            A2(uc, A2(uc, A2(uc, Qa(F3(function(n, r, u) {
                return wc(h(t, p(e, A3(Se, n, r, u))));
            })), (r = t.c6, A2(uc, A2(tc, Qa(Ne), A2(S$, r, L$)), A2(tc, A2(tc, hp, hg), $g)))), hp), rw)
        ]));
    }, ew = A2(La, function(n) {
        var r;
        return A2(uc, A2(uc, Qa(Zp), A2(tc, (r = n.bT, A2(Fa, F2(function(n) {
            var r = Pb(n);
            return "" === r ? dt : st(r);
        }), Oa(r.b9 ? A2(lu, Pc, vg) : function(n) {
            return "`" !== n && !vg(n);
        }))), $g)), function(n) {
            return A2(gc, h(n, ""), tw);
        }(n));
    }, Kp), uw = A2(Hc, "#", Ih("a `#`")), aw = Oa(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), cw = A2(uc, A2(uc, A2(tc, A2(tc, Qa(Ch), A2(La, function(n) {
        var r = Te(n);
        return 4 > r ? Qa(r) : Ya(Ih("heading with < 4 spaces in front"));
    }, Va(aw))), Nc(uw)), A2(La, function(n) {
        var r = Te(n) + 1;
        return 7 > r ? Qa(r) : Ya(Ih("heading with < 7 #'s"));
    }, Va(Oa(function(n) {
        return "#" === n;
    })))), oc(y([
        A2(tc, Qa(""), Nc(fg)),
        A2(uc, A2(tc, Qa(Ne), oc(y([
            Nc(bg),
            Nc(d$)
        ]))), A2(Fa, F2(function(n) {
            var r, t;
            return r = Pb(n), t = function(n) {
                for(;;){
                    if (!A2(wg, "#", n)) return n;
                    n = A2(Zv, 1, n);
                }
            }(r), A2(wg, " ", t) || ze(t) ? t.replace(/\s+$/, "") : r;
        }), hg))
    ]))), iw = at, ow = F4(function(n, r, t, e) {
        return A2(Sa, Ea, A4(Ca, n, r, t, e));
    }), fw = function(n) {
        var r = n.a, t = n.b;
        return function(n) {
            var e = A5(iw, r, n.f, n.ih, n.eo, n.dP), u = e.a, c = e.b, i = e.c;
            return a(u, -1) ? A2(Ba, !1, A4(ow, c, i, t, n.gH)) : A3(Na, 0 > f(n.f, u), 0, {
                eo: i,
                gH: n.gH,
                j: n.j,
                f: u,
                ih: c,
                dP: n.dP
            });
        };
    }, sw = A2(Hc, ">", Ih("a `>`")), dw = F3(function(n, r, t) {
        return {
            eo: r,
            gH: t,
            ih: n
        };
    }), bw = F2(function(n, r) {
        return {
            eo: r.eo,
            gH: n,
            j: r.j,
            f: r.f,
            ih: r.ih,
            dP: r.dP
        };
    }), lw = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(A2(bw, A2(bt, A3(dw, r.ih, r.eo, n), r.gH), r));
            return e.$ ? e : A3(Na, e.a, e.b, A2(bw, r.gH, e.c));
        };
    }), vw = function(n) {
        switch(n){
            case " ":
            case "\n":
            case "	":
            case "\v":
            case "\f":
            case "\r":
                return !0;
            default:
                return !1;
        }
    }, hw = A2(Hc, "<", Ih("a `<`")), gw = A2(lw, "link destination", oc(y([
        A2(uc, A2(tc, Qa(cl), Nc(hw)), A2(tc, Va(fw(sw)), Nc(sw))),
        Va(y$(A2(lu, Pc, vw)))
    ]))), $w = A2(Hc, "]", Ih("a `]`")), mw = A2(Hc, "[", Ih("a `[`")), pw = A2(uc, A2(tc, Qa(np), Nc(mw)), A2(tc, Va(fw($w)), Nc(A2(Hc, "]:", Ih("]:"))))), ww = A2(Hc, '"', Ih("a double quote")), kw = function(n) {
        return A2(Ie, "\n\n", n) ? Ya(Ih("no blank line")) : Qa(n);
    }, _w = A2(tc, Oa(function(n) {
        return !vg(n) && vw(n);
    }), $g), yw = A2(tc, A2(vc, vw, Ih("Required whitespace")), Oa(vw)), xw = A2(Hc, "'", Ih("a single quote")), Hw = (o$ = A2(uc, A2(tc, Qa(st), Nc(xw)), A2(tc, A2(tc, A2(La, kw, Va(fw(xw))), Nc(xw)), _w)), f$ = A2(uc, A2(tc, Qa(st), Nc(ww)), A2(tc, A2(tc, A2(La, kw, Va(fw(ww))), Nc(ww)), _w)), A2(lw, "title", oc(y([
        cg(A2(uc, A2(tc, Qa(Ne), yw), oc(y([
            f$,
            o$,
            Qa(dt)
        ])))),
        A2(tc, Qa(dt), _w)
    ])))), Aw = A2(lw, "link reference definition", A2(uc, A2(uc, A2(uc, A2(tc, Qa(F3(function(n, r, t) {
        return h(n, {
            a2: r,
            iG: t
        });
    })), Jp), A2(tc, A2(tc, A2(tc, pw, Oa(ig)), oc(y([
        sg,
        Qa(0)
    ]))), Oa(ig))), gw), Hw)), Pw = Oa(ig), Bw = function(n) {
        var r = Rp(Hu(n));
        return A2(tc, A2(tc, A2(tc, A2(tc, A2(tc, A2(tc, A2(tc, Qa(0), r), Pw), r), Pw), r), Oa(function(r) {
            return a(r, n) || ig(r);
        })), $g);
    }, Nw = oc(y([
        Bw("-"),
        Bw("*"),
        Bw("_")
    ])), Lw = oc(y([
        A2(uc, A2(tc, A2(tc, A2(tc, Qa(Ne), L$), oc(y([
            L$,
            Qa(0)
        ]))), oc(y([
            L$,
            Qa(0)
        ]))), Nw),
        Nw
    ])), Iw = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), Tw = A2(Hc, "=", Ih("a `=`")), Sw = A2(Hc, "-", Ih("a `-`")), Cw = (s$ = F3(function(n, r, t) {
        return A2(tc, A2(tc, Qa(n), Bc(r)), Oa(oe(t)));
    }), A2(Fa, F2(function(n, r) {
        return A2(Iw, r, n);
    }), A2(uc, A2(tc, Qa(Ne), Jp), A2(tc, A2(tc, oc(y([
        A3(s$, 0, Tw, "="),
        A3(s$, 1, Sw, "-")
    ])), Oa(ig)), $g)))), Ew = function(n) {
        return {
            $: 9,
            a: n
        };
    }, zw = Oa(ig), Xw = function(n) {
        return oc(y([
            A2(vc, n, Ga("Character not found")),
            Qa(0)
        ]));
    }, jw = function(n) {
        var r;
        return oc(y([
            cg(A2($c, function() {
                return pc(n);
            }, Rp("|\n"))),
            A2($c, function() {
                return pc(n);
            }, Rp("\n")),
            A2($c, function() {
                return pc(n);
            }, Xa(Ih("end"))),
            cg(A2(tc, A2(tc, Qa(pc(n)), Rp("|")), Xa(Ih("end")))),
            A2(uc, A2(tc, A2(tc, Qa(function(r) {
                return wc(A2(bt, r, n));
            }), (r = n, zl(r) ? oc(y([
                Rp("|"),
                Qa(0)
            ])) : Rp("|"))), zw), A2(tc, Va(A2(tc, A2(tc, A2(tc, Qa(0), Xw(function(n) {
                return ":" === n;
            })), y$(function(n) {
                return "-" === n;
            })), Xw(function(n) {
                return ":" === n;
            }))), zw))
        ]));
    }, qw = function(n) {
        var r = h(A2(De, ":", n), A2(wg, ":", n));
        return r.a ? st(r.b ? 2 : 0) : r.b ? st(1) : dt;
    }, Mw = A2($c, Ew, A2(La, function(n) {
        var r = n.a.f4, t = n.b;
        return zl(t) ? Ya(Ih("Must have at least one column in delimiter row.")) : 1 !== Et(t) || A2(De, "|", r) && A2(wg, "|", r) ? Qa(n) : Ya(Ga("Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity."));
    }, A2(Fa, F2(function(n, r) {
        return A2(ng, {
            fF: n,
            f4: Pb(n)
        }, A2(Qe, qw, Zt(r)));
    }), A2(gc, w, jw)))), Rw = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(bt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Ow = F2(function(n, r) {
        return Zt(A3(Rw, n, r, w));
    }), Dw = F3(function(n, r, t) {
        if (r > 0) {
            var e = h(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return y([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, c = a.b;
                                return y([
                                    a.a,
                                    c.a,
                                    c.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, o = i.b, f = o.b, s = f.b, d = s.b;
                                return A2(bt, i.a, A2(bt, o.a, A2(bt, f.a, A2(bt, s.a, n > 1e3 ? A2(Ow, r - 4, d) : A3(Dw, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return y([
                e.b.a
            ]);
        }
        return w;
    }), Fw = F2(function(n, r) {
        return A3(Dw, 0, n, r);
    }), Vw = F2(function(n, r) {
        var t = Et(r);
        switch(A2(Qc, n, t)){
            case 0:
                return A2(Fw, n, r);
            case 1:
                return r;
            default:
                return p(r, A2(T$, n - t, ""));
        }
    }), Zw = function(n) {
        var r, t = n.a, e = n.b;
        return A2($c, function(n) {
            return Kh(A2(Wh, t, p(e, y([
                n
            ]))));
        }, (r = Et(t), A2(La, function(n) {
            return zl(n) || A2(Il, ze, n) ? Ya(Ga("A line must have at least one column")) : Qa(A2(Vw, r, n));
        }, Fp)));
    }, Gw = {
        $: 2
    }, Yw = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Uw = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Qw = F4(function(n, r, t, e) {
        var u = e.a, a = e.b, c = u - t;
        return c > 4 ? g(r, t - n + 1, function() {
            switch(a.$){
                case 0:
                    var n = a.b;
                    return A2(Uw, a.a, p(A2(Pu, c - 1, " "), n));
                case 1:
                    return n = a.a, Yw(p(A2(Pu, c - 1, " "), n));
                default:
                    return Gw;
            }
        }()) : g(r, u - n, a);
    }), Jw = A2(uc, Qa(function(n) {
        return h(n, Gw);
    }), A2(tc, k$, $g)), Kw = oc(y([
        A2(tc, Qa(1), Nc(A2(Hc, "[x] ", xc("[x] ")))),
        A2(tc, Qa(1), Nc(A2(Hc, "[X] ", xc("[X] ")))),
        A2(tc, Qa(0), Nc(A2(Hc, "[ ] ", xc("[ ] "))))
    ])), Ww = A2(uc, oc(y([
        A2(uc, Qa(Uw), A2(tc, Kw, Oa(ig))),
        Qa(Yw)
    ])), A2(tc, Va(hg), $g)), nk = A2(uc, A2(uc, A2(tc, Qa(F2(function(n, r) {
        return h(n, r);
    })), y$(ig)), k$), Ww), rk = oc(y([
        A2(tc, A2(tc, Qa(0), A2(S$, 3, L$)), Nc(A2(Hc, "-", xc("-")))),
        A2(tc, Qa(1), Nc(A2(Hc, "+", xc("+")))),
        A2(tc, Qa(2), Nc(A2(Hc, "*", xc("*"))))
    ])), tk = function(n) {
        var r = F2(function(n, r) {
            switch(r.$){
                case 0:
                    return {
                        n: r.b,
                        hL: n,
                        l: st(1 === r.a)
                    };
                case 1:
                    return {
                        n: r.a,
                        hL: n,
                        l: dt
                    };
                default:
                    return {
                        n: "",
                        hL: n,
                        l: dt
                    };
            }
        });
        return A2($c, function(n) {
            return A4(ug, !0, n.b, w, A2(r, n.a, n.c));
        }, function(n) {
            return A2(uc, A2(uc, A2(uc, A2(uc, Qa(Qw), k$), cg(rk)), k$), n ? nk : oc(y([
                Jw,
                nk
            ])));
        }(n));
    }, ek = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), uk = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = sk(n.c);
                if (u.$) return wt(u.a);
                var a = zh(A3(qh, t, e, u.a));
                return xt(A2(bt, a, r));
            case 1:
                var c = bk(n.a);
                return c.$ ? wt(Ih(A2(It, "\n", A2(Qe, yh, c.a)))) : xt(p(Zt(c.a), r));
            case 2:
                return xt(A2(bt, zh(Xh(n.a)), r));
            case 3:
                return xt(A2(bt, zh(Ah(n.a)), r));
            case 4:
                return xt(A2(bt, zh(Qh(n.a)), r));
            default:
                return xt(A2(bt, zh(A2(jh, n.a, n.b)), r));
        }
    }), ak = function(n) {
        var r = n.c;
        n: for(; r.b;)switch(r.a.$){
            case 11:
                var t = r.a.a, e = r.b, u = A2(Rc, _k(), t);
                return u.$ ? Ya(Ga(pg(u.a))) : Qa({
                    b: p(n.b, (w = u.a).b),
                    c: A2(bt, Uh(w.c), e)
                });
            case 3:
                var a = r.a, c = a.a, i = a.b, o = a.c, f = a.d, s = (e = r.b, A2(Rc, _k(), f.n));
                if (s.$) return Ya(Ga(pg(s.a)));
                var d = !A2(ii, xh, (w = s.a).c) && c;
                return Qa({
                    b: p(n.b, w.b),
                    c: A2(bt, A4(ug, d, i, A2(bt, {
                        n: w.c,
                        l: f.l
                    }, o), f), e)
                });
            case 4:
                var b = r.a, l = (c = b.a, i = b.b, b.c), v = b.d, h = (o = b.e, f = b.f, e = r.b, A2(Rc, _k(), f));
                return h.$ ? Ya(Ga(pg(h.a))) : (d = !A2(ii, xh, (w = h.a).c) && c, Qa({
                    b: p(n.b, w.b),
                    c: A2(bt, A6(Gh, d, i, l, v, A2(bt, w.c, o), f), e)
                }));
            case 10:
                if (!r.b.b) break n;
                switch(r.b.a.$){
                    case 3:
                        var g = r.b, $ = g.a, m = (c = $.a, i = $.b, o = $.c, f = $.d, e = g.b, A2(Rc, _k(), f.n));
                        return m.$ ? Ya(Ga(pg(m.a))) : (d = !A2(ii, xh, (w = m.a).c) && c, Qa({
                            b: p(n.b, w.b),
                            c: A2(bt, A4(ug, d, i, A2(bt, {
                                n: w.c,
                                l: f.l
                            }, o), f), e)
                        }));
                    case 4:
                        var w, k = r.b, _ = k.a, y = (c = _.a, i = _.b, l = _.c, v = _.d, o = _.e, f = _.f, e = k.b, A2(Rc, _k(), f));
                        return y.$ ? Ya(Ga(pg(y.a))) : (d = !A2(ii, xh, (w = y.a).c) && c, Qa({
                            b: p(n.b, w.b),
                            c: A2(bt, A6(Gh, d, i, l, v, A2(bt, w.c, o), f), e)
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return Qa(n);
    }, ck = F2(function(n, r) {
        var t = h(r, n.c);
        n: for(; t.b.b;)switch(t.b.a.$){
            case 5:
                if (5 === t.a.$) {
                    var e = t.b, u = e.b;
                    return Qa({
                        b: n.b,
                        c: A2(bt, Bh({
                            n: A2($$, e.a.a.n, t.a.a.n),
                            fa: dt
                        }), u)
                    });
                }
                break n;
            case 6:
                switch(t.a.$){
                    case 6:
                        var c = t.b;
                        return u = c.b, Qa({
                            b: n.b,
                            c: A2(bt, Rh(A2($$, c.a.a, t.a.a)), u)
                        });
                    case 10:
                        var i = t.b;
                        return u = i.b, Qa({
                            b: n.b,
                            c: A2(bt, Rh(A2($$, i.a.a, "\n")), u)
                        });
                    default:
                        break n;
                }
            case 11:
                var o = t.b, f = o.a.a;
                switch(u = o.b, r.$){
                    case 11:
                        return Qa({
                            b: n.b,
                            c: A2(bt, Hh(A2($$, f, s = r.a)), u)
                        });
                    case 1:
                        var s = r.a, d = A2(Rc, _k(), f);
                        if (d.$) return Ya(Ga(pg(d.a)));
                        var b = (nn = d.a).c;
                        if (b.b) {
                            if (kg(b.a) && !A2(wg, "\n", f)) return Qa({
                                b: n.b,
                                c: A2(bt, Hh(A2($$, f, s)), u)
                            });
                            var l = A2(Rc, _k(), f);
                            if (l.$) return Ya(Ga(pg(l.a)));
                            var v = l.a;
                            return Qa({
                                b: p(n.b, nn.b),
                                c: A2(bt, r, A2(bt, Uh(v.c), u))
                            });
                        }
                        var g = A2(Rc, _k(), f);
                        return g.$ ? Ya(Ga(pg(g.a))) : (v = g.a, Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, Uh(v.c), u))
                        }));
                    case 6:
                        s = r.a;
                        var m = A2(Rc, _k(), f);
                        if (m.$) return Ya(Ga(pg(m.a)));
                        var k = (nn = m.a).c;
                        if (k.b && 1 === k.a.$) return Qa({
                            b: n.b,
                            c: A2(bt, Hh(A3(g$, " ", f, s)), u)
                        });
                        var _ = A2(Rc, _k(), f);
                        return _.$ ? Ya(Ga(pg(_.a))) : (v = _.a, Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, Uh(v.c), u))
                        }));
                    default:
                        var y = A2(Rc, _k(), f);
                        return y.$ ? Ya(Ga(pg(y.a))) : Qa({
                            b: p(n.b, (nn = y.a).b),
                            c: A2(bt, r, A2(bt, Uh(nn.c), u))
                        });
                }
            case 3:
                var x = t.b, H = x.a, A = H.a, P = H.b, B = H.c, N = H.d;
                switch(u = x.b, r.$){
                    case 3:
                        var L = r.b;
                        if (a(N.hL, (q = r.d).hL)) {
                            var I = A2(Rc, _k(), N.n);
                            return I.$ ? Ya(Ga(pg(I.a))) : Qa(A2(ii, xh, (nn = I.a).c) ? {
                                b: p(n.b, nn.b),
                                c: A2(bt, A4(ug, !1, L, A2(bt, {
                                    n: nn.c,
                                    l: N.l
                                }, B), q), u)
                            } : {
                                b: p(n.b, nn.b),
                                c: A2(bt, A4(ug, A, L, A2(bt, {
                                    n: nn.c,
                                    l: N.l
                                }, B), q), u)
                            });
                        }
                        var T = A2(Rc, _k(), N.n);
                        if (T.$) return Ya(Ga(pg(T.a)));
                        var S = !A2(ii, xh, (nn = T.a).c) && A;
                        return Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, A4(ug, S, P, A2(bt, {
                                n: nn.c,
                                l: N.l
                            }, B), q), u))
                        });
                    case 1:
                        return Qa({
                            b: n.b,
                            c: A2(bt, A4(ug, A, P, B, $(N, {
                                n: A3(g$, "\n", N.n, s = r.a)
                            })), u)
                        });
                    default:
                        var C = A2(Rc, _k(), N.n);
                        return C.$ ? Ya(Ga(pg(C.a))) : (S = !A2(ii, xh, (nn = C.a).c) && A, Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, A4(ug, S, P, A2(bt, {
                                n: nn.c,
                                l: N.l
                            }, B), N), u))
                        }));
                }
            case 4:
                var E = t.b, z = E.a, X = (A = z.a, P = z.b, z.c), j = z.d;
                switch(B = z.e, N = z.f, u = E.b, r.$){
                    case 4:
                        L = r.b;
                        var q = r.f;
                        if (a(X, r.c)) {
                            var M = A2(Rc, _k(), N);
                            return M.$ ? Ya(Ga(pg(M.a))) : (S = !A2(ii, xh, (nn = M.a).c) && A, Qa({
                                b: p(n.b, nn.b),
                                c: A2(bt, A6(Gh, S, L, X, j, A2(bt, nn.c, B), q), u)
                            }));
                        }
                        var R = A2(Rc, _k(), N);
                        return R.$ ? Ya(Ga(pg(R.a))) : (S = !A2(ii, xh, (nn = R.a).c) && A, Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, A6(Gh, S, P, X, j, A2(bt, nn.c, B), N), u))
                        }));
                    case 1:
                        return Qa({
                            b: n.b,
                            c: A2(bt, A6(Gh, A, P, X, j, B, N + "\n" + (s = r.a)), u)
                        });
                    default:
                        var O = A2(Rc, _k(), N);
                        return O.$ ? Ya(Ga(pg(O.a))) : (S = !A2(ii, xh, (nn = O.a).c) && A, Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, A6(Gh, S, P, X, j, A2(bt, nn.c, B), N), u))
                        }));
                }
            case 1:
                switch(t.a.$){
                    case 1:
                        var D = t.b;
                        return u = D.b, Qa({
                            b: n.b,
                            c: A2(bt, Vh(A3(g$, "\n", f = D.a.a, s = t.a.a)), u)
                        });
                    case 13:
                        if (t.a.a) {
                            var F = t.b;
                            return u = F.b, Qa({
                                b: n.b,
                                c: A2(bt, A2(Ch, 2, F.a.a), u)
                            });
                        }
                        var V = t.b;
                        u = V.b;
                        return Qa({
                            b: n.b,
                            c: A2(bt, A2(Ch, 1, V.a.a), u)
                        });
                    case 9:
                        var Z = t.a.a, G = Z.a, Y = t.b, U = Y.a.a, Q = (u = Y.b, A2(Vp, A2(ng, G, Z.b), U));
                        return Qa(Q.$ ? {
                            b: n.b,
                            c: A2(bt, Vh(A3(g$, "\n", U, G.fF)), u)
                        } : {
                            b: n.b,
                            c: A2(bt, Kh(A2(Wh, Q.a, w)), u)
                        });
                    default:
                        break n;
                }
            case 8:
                if (8 === t.a.$) return u = t.b.b, Qa({
                    b: n.b,
                    c: A2(bt, Kh(t.a.a), u)
                });
                break n;
            case 10:
                if (!t.b.b.b) break n;
                switch(t.b.b.a.$){
                    case 4:
                        var J = t.b.b, K = J.a, W = (A = K.a, P = K.b, X = K.c, j = K.d, B = K.e, N = K.f, u = J.b, A2(Rc, _k(), N));
                        if (W.$) return Ya(Ga(pg(W.a)));
                        var nn = W.a;
                        if (4 === r.$) {
                            L = r.b;
                            var rn = r.f;
                            return Qa({
                                b: p(n.b, nn.b),
                                c: A2(bt, A6(Gh, !1, L, X, j, A2(bt, nn.c, B), rn), u)
                            });
                        }
                        return Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, xh, A2(bt, A6(Gh, A, P, X, j, A2(bt, nn.c, B), N), u)))
                        });
                    case 3:
                        var tn = t.b.b, en = tn.a, un = (A = en.a, P = en.b, B = en.c, N = en.d, u = tn.b, A2(Rc, _k(), N.n));
                        return un.$ ? Ya(Ga(pg(un.a))) : (nn = un.a, 3 === r.$ ? (rn = r.d, Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, A4(ug, !1, P, A2(bt, {
                                n: nn.c,
                                l: N.l
                            }, B), rn), u)
                        })) : Qa({
                            b: p(n.b, nn.b),
                            c: A2(bt, r, A2(bt, xh, A2(bt, A4(ug, A, P, A2(bt, {
                                n: nn.c,
                                l: N.l
                            }, B), N), u)))
                        }));
                    default:
                        break n;
                }
            default:
                break n;
        }
        return Qa({
            b: n.b,
            c: A2(bt, r, n.c)
        });
    }), ik = F2(function(n, r) {
        var t = r, e = Wc(A2(Qe, Ys(function(n) {
            return h(n.a2, n.iG);
        }), n));
        return A2(Qe, ok, A2(jp, e, t));
    }), ok = function(n) {
        switch(n.$){
            case 0:
                return function(n) {
                    return {
                        $: 7,
                        a: n
                    };
                }(n.a);
            case 1:
                return Th;
            case 2:
                return function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(n.a);
            case 3:
                return A3(Dh, n.a, n.b, A2(Qe, ok, t = n.c));
            case 4:
                return A3(Mh, n.a, n.b, A2(Qe, ok, t = n.c));
            case 5:
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(fk(n.a));
            case 6:
                var r = n.a, t = n.b;
                switch(r){
                    case 1:
                        return Bl(A2(Qe, ok, t));
                    case 2:
                        return Ll(A2(Qe, ok, t));
                    default:
                        return v$(r) ? Ll(y([
                            ok(A2(Nh, r - 2, t))
                        ])) : Bl(y([
                            ok(A2(Nh, r - 1, t))
                        ]));
                }
            default:
                return function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(A2(Qe, ok, t = n.a));
        }
    }, fk = function(n) {
        switch(n.$){
            case 1:
                return Xh("TODO this never happens, but use types to drop this case.");
            case 0:
                return A3(qh, n.a, n.b, A2(id, function(n) {
                    return 1 === n.$ ? wk(n.a) : y([
                        zh(fk(n))
                    ]);
                }, n.c));
            case 2:
                return Xh(n.a);
            case 3:
                return Ah(n.a);
            case 4:
                return Qh(n.a);
            default:
                return A2(jh, n.a, n.b);
        }
    }, sk = function(n) {
        return A2(dk, n, w);
    }, dk = F2(function(n, r) {
        for(;;){
            if (!n.b) return xt(Zt(r));
            var t = n.b, e = A2(uk, n.a, r);
            if (e.$) return wt(e.a);
            n = t, r = e.a;
        }
    }), bk = function(n) {
        var r = A2(Rc, A2(tc, _k(), gg), n);
        if (1 === r.$) return wt(r.a);
        var t = lk(r.a);
        return 1 === t.$ ? A2(Rc, Ya(t.a), "") : xt(A2(ei, function(n) {
            return !(5 === n.$ && !n.a.b);
        }, t.a));
    }, lk = function(n) {
        return A3(vk, n, n.c, w);
    }, vk = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return xt(t);
            var e = r.b, u = A2(gk, n.b, r.a);
            switch(u.$){
                case 1:
                    r = e, t = A2(bt, u.a, t);
                    continue n;
                case 0:
                    r = e;
                    continue n;
                default:
                    return wt(u.a);
            }
        }
    }), hk = F2(function(n, r) {
        return A2(Qe, function(r) {
            var t = r.bN;
            return A3($k, n, function(n) {
                return {
                    bN: t,
                    bt: n
                };
            }, r.bt);
        }, r);
    }), gk = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = function(n) {
                    switch(n){
                        case 1:
                            return xt(0);
                        case 2:
                            return xt(1);
                        case 3:
                            return xt(2);
                        case 4:
                            return xt(3);
                        case 5:
                            return xt(4);
                        case 6:
                            return xt(5);
                        default:
                            return wt(Ih("A heading with 1 to 6 #'s, but found " + Lt(n)));
                    }
                }(r.a);
                return e.$ ? Oh(e.a) : Yh(A2(Sh, e.a, A2(ik, n, t)));
            case 1:
                return Yh(Nl(A2(ik, n, t = r.a)));
            case 2:
                return Yh(zh(r.a));
            case 3:
                var u = r.a, a = r.c, c = F2(function(r, t) {
                    var e, u = r.$ ? 0 : r.a ? 2 : 1, a = (e = lk({
                        b: n,
                        c: t
                    })).$ ? w : e.a;
                    return A2(Fh, u, a);
                });
                return Yh(A2(eg, h$(u), Zt(A2(Qe, function(n) {
                    return A2(c, n.l, n.n);
                }, a))));
            case 4:
                var i = r.d;
                return a = r.e, c = function(r) {
                    var t = lk({
                        b: n,
                        c: r
                    });
                    return t.$ ? w : t.a;
                }, Yh(A3(Zh, h$(u = r.a), i, Zt(A2(Qe, c, a))));
            case 5:
                return Yh(Ph(r.a));
            case 7:
                return Yh(rg);
            case 10:
            case 11:
                return Lh;
            case 12:
                var o = lk({
                    b: n,
                    c: r.a
                });
                return o.$ ? Oh(o.a) : Yh(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(o.a));
            case 6:
                return Yh(Ph({
                    n: r.a,
                    fa: dt
                }));
            case 8:
                var f = r.a, s = f.b;
                return Yh(A2(Jh, A2(hk, n, f.a), A2(mk, n, s)));
            case 9:
                return Yh(Nl(A2(ik, n, r.a.a.fF)));
            default:
                return Yh(Nl(A2(ik, n, r.b)));
        }
    }), $k = F3(function(n, r, t) {
        return r(A2(ik, n, t));
    }), mk = F2(function(n, r) {
        return A2(Qe, function(r) {
            return A2(Qe, function(r) {
                return A3($k, n, Ne, r);
            }, r);
        }, r);
    }), pk = function(n) {
        return oc(y([
            A2($c, function() {
                return pc(n);
            }, gg),
            A2($c, function(r) {
                return wc(A2(ag, n, r));
            }, cg(Aw)),
            function() {
                var r = n.c;
                n: for(; r.b;)switch(r.a.$){
                    case 1:
                        return A2($c, function(n) {
                            return wc(n);
                        }, A2(La, ck(n), xk()));
                    case 8:
                        var t = r.a.a;
                        return A2($c, function(n) {
                            return wc(n);
                        }, A2(La, ck(n), oc(y([
                            yk(),
                            Zw(t)
                        ]))));
                    case 3:
                        var e = r.a, u = e.a, a = e.b, c = e.c, i = e.d, o = r.b, f = F2(function(n, r) {
                            return $(n, {
                                c: A2(bt, xh, A2(bt, A4(ug, u, a, c, $(i, {
                                    n: A3(g$, "", i.n, r)
                                })), o))
                            });
                        }), s = F2(function(n, r) {
                            return $(n, {
                                c: A2(bt, A4(ug, u, a, c, $(i, {
                                    n: A3(g$, "\n", i.n, r)
                                })), o)
                            });
                        });
                        return oc(y([
                            A2($c, function(n) {
                                return wc(n);
                            }, A2($c, function() {
                                return A2(f, n, "\n");
                            }, dg)),
                            A2($c, function(n) {
                                return wc(n);
                            }, A2($c, s(n), A2(uc, A2(tc, Qa(Ne), Nc(A2(Hc, A2(Pu, a, " "), xc("Indentation")))), A2(tc, Va(hg), $g)))),
                            A2($c, function(n) {
                                return wc(n);
                            }, A2(La, ck(n), Hk()))
                        ]));
                    case 4:
                        var d = r.a, b = (u = d.a, a = d.b, d.c), l = d.d;
                        return c = d.e, i = d.f, o = r.b, f = F2(function(n, r) {
                            return $(n, {
                                c: A2(bt, xh, A2(bt, A6(Gh, u, a, b, l, c, i + "\n" + r), o))
                            });
                        }), s = F2(function(n, r) {
                            return $(n, {
                                c: A2(bt, A6(Gh, u, a, b, l, c, i + "\n" + r), o)
                            });
                        }), oc(y([
                            A2($c, function(n) {
                                return wc(n);
                            }, A2($c, function() {
                                return A2(f, n, "\n");
                            }, dg)),
                            A2($c, function(n) {
                                return wc(n);
                            }, A2($c, s(n), A2(uc, A2(tc, Qa(Ne), Nc(A2(Hc, A2(Pu, a, " "), xc("Indentation")))), A2(tc, Va(hg), $g)))),
                            A2($c, function(n) {
                                return wc(n);
                            }, A2(La, ck(n), Hk()))
                        ]));
                    case 10:
                        if (!r.b.b) break n;
                        switch(r.b.a.$){
                            case 3:
                                var v = r.b, h = v.a;
                                return u = h.a, a = h.b, c = h.c, i = h.d, o = v.b, f = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(bt, xh, A2(bt, A4(ug, u, a, c, $(i, {
                                            n: A3(g$, "", i.n, r)
                                        })), o))
                                    });
                                }), s = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(bt, A4(ug, u, a, c, $(i, {
                                            n: A3(g$, "\n", i.n, r)
                                        })), o)
                                    });
                                }), "" === Pb(i.n) ? A2($c, function(n) {
                                    return wc(n);
                                }, A2(La, ck(n), yk())) : oc(y([
                                    A2($c, function(n) {
                                        return wc(n);
                                    }, A2($c, function() {
                                        return A2(f, n, "\n");
                                    }, dg)),
                                    A2($c, function(n) {
                                        return wc(n);
                                    }, A2($c, s(n), A2(uc, A2(tc, Qa(Ne), Nc(A2(Hc, A2(Pu, a, " "), xc("Indentation")))), A2(tc, Va(hg), $g)))),
                                    A2($c, function(n) {
                                        return wc(n);
                                    }, A2(La, ck(n), yk()))
                                ]));
                            case 4:
                                var g = r.b, m = g.a;
                                return u = m.a, a = m.b, b = m.c, l = m.d, c = m.e, i = m.f, o = g.b, f = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(bt, xh, A2(bt, A6(Gh, u, a, b, l, c, i + "\n" + r), o))
                                    });
                                }), s = F2(function(n, r) {
                                    return $(n, {
                                        c: A2(bt, A6(Gh, u, a, b, l, c, i + "\n" + r), o)
                                    });
                                }), "" === Pb(i) ? A2($c, function(n) {
                                    return wc(n);
                                }, A2(La, ck(n), yk())) : oc(y([
                                    A2($c, function(n) {
                                        return wc(n);
                                    }, A2($c, function() {
                                        return A2(f, n, "\n");
                                    }, dg)),
                                    A2($c, function(n) {
                                        return wc(n);
                                    }, A2($c, s(n), A2(uc, A2(tc, Qa(Ne), Nc(A2(Hc, A2(Pu, a, " "), xc("Indentation")))), A2(tc, Va(hg), $g)))),
                                    A2($c, function(n) {
                                        return wc(n);
                                    }, A2(La, ck(n), yk()))
                                ]));
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return A2($c, function(n) {
                    return wc(n);
                }, A2(La, ck(n), yk()));
            }(),
            A2($c, function(n) {
                return wc(n);
            }, A2(La, ck(n), p$))
        ]));
    }, wk = function(n) {
        return A2(ek, w, bk(n));
    }, kk = function(n) {
        switch(n.$){
            case 1:
                return Qa(Vh(n.a));
            case 0:
                var r = n.a, t = n.b, e = sk(n.c);
                return e.$ ? Ya(e.a) : Qa(Eh(A3(qh, r, t, e.a)));
            case 2:
                return Qa(Eh(Xh(n.a)));
            case 3:
                return Qa(Eh(Ah(n.a)));
            case 4:
                return Qa(Eh(Qh(n.a)));
            default:
                return Qa(Eh(A2(jh, n.a, n.b)));
        }
    };
    function _k() {
        return A2(La, ak, A2(gc, {
            b: w,
            c: w
        }, pk));
    }
    function yk() {
        return oc(y([
            Mp,
            dg,
            mg,
            A2($c, Bh, cg(ew)),
            l$,
            A2($c, function() {
                return tg;
            }, cg(Lw)),
            tk(!1),
            E$(!1),
            cg(cw),
            Ak()
        ]));
    }
    function xk() {
        return oc(y([
            Mp,
            dg,
            mg,
            A2($c, Bh, cg(ew)),
            cg(Cw),
            A2($c, function() {
                return tg;
            }, cg(Lw)),
            tk(!0),
            E$(!0),
            cg(cw),
            Ak(),
            cg(Mw)
        ]));
    }
    function Hk() {
        return oc(y([
            Mp,
            dg,
            mg,
            A2($c, Bh, cg(ew)),
            A2($c, function() {
                return tg;
            }, cg(Lw)),
            tk(!1),
            E$(!1),
            cg(cw),
            Ak()
        ]));
    }
    function Ak() {
        return A2(La, kk, c$);
    }
    var Pk = _k();
    _k = function() {
        return Pk;
    };
    var Bk = yk();
    yk = function() {
        return Bk;
    };
    var Nk = xk();
    xk = function() {
        return Nk;
    };
    var Lk = Hk();
    Hk = function() {
        return Lk;
    };
    var Ik = Ak();
    Ak = function() {
        return Ik;
    };
    var Tk, Sk, Ck, Ek = A2(Ue, Es(bt), xt(w)), zk = function(n) {
        switch(n.$){
            case 5:
                return Xk(n.a);
            case 0:
                var r = n.a;
                if (r.$) return "";
                var t = r.c;
                return A3(Ev, F2(function(n, r) {
                    return p(r, zk(n));
                }), "", t);
            case 1:
                return A2(It, "\n", A2(Qe, function(n) {
                    return A2(It, "\n", A2(Qe, zk, n.b));
                }, n.b));
            case 2:
                return A2(It, "\n", A2(Qe, function(n) {
                    return A2(It, "\n", A2(Qe, zk, n));
                }, n.c));
            case 3:
                return A2(It, "\n", A2(Qe, zk, t = n.a));
            case 4:
                return Xk(n.b);
            case 6:
                var e = n.b;
                return A2(It, "\n", cd(y([
                    A2(Qe, Xk, A2(Qe, function(n) {
                        return n.bt;
                    }, n.a)),
                    cd(A2(Qe, Qe(Xk), e))
                ])));
            case 7:
                return n.a.n;
            default:
                return "";
        }
    }, Xk = function(n) {
        return A3(Ct, jk, "", n);
    }, jk = F2(function(n, r) {
        switch(n.$){
            case 7:
            case 6:
                return p(r, n.a);
            case 8:
                return r + " ";
            case 1:
            case 2:
                return p(r, Xk(n.c));
            case 0:
                var t = n.a;
                if (t.$) return r;
                var e = t.c;
                return A3(Ev, F2(function(n, r) {
                    return p(r, zk(n));
                }), r, e);
            default:
                return p(r, Xk(n.a));
        }
    }), qk = F5(function(n, r, t, e, u) {
        var a = e;
        return A2(qu, function(e) {
            return A2(Uu, function(n) {
                return n(e);
            }, A3(a, n, r, t));
        }, Ek(u));
    }), Mk = F3(function(n, r, t) {
        var e = A2(Fk, n, r);
        return e.$ ? t : A2(bt, e.a, t);
    }), Rk = F2(function(n, r) {
        return A2(Ru, Ok(n), r);
    }), Ok = function(n) {
        return function(r) {
            switch(r.$){
                case 4:
                    var t = r.a;
                    return st(A2(Uu, function(r) {
                        return n.hk({
                            gy: r,
                            hF: t,
                            ia: Xk(e)
                        });
                    }, A2(Vk, n, e = r.b)));
                case 5:
                    var e;
                    return st(A2(Uu, n.fr, A2(Vk, n, e = r.a)));
                case 0:
                    var u = r.a;
                    return u.$ ? dt : st(A4(Dk, n, u.a, u.b, u.c));
                case 1:
                    var a = r.a;
                    return st(A2(Uu, function(r) {
                        return n.iJ(A2(Qe, function(n) {
                            return A2(Fh, n.a, cd(n.b));
                        }, r));
                    }, Ek(A2(Qe, function(r) {
                        var t = r.b;
                        return A2(Uu, Fh(r.a), Ek(A2(Ru, function(r) {
                            var t = h(a, r);
                            return 1 === t.a && 5 === t.b.$ ? st(A2(Vk, n, t.b.a)) : A2(Yu, Uu(hv), A2(Ok, n, r));
                        }, t)));
                    }, r.b))));
                case 2:
                    a = r.a;
                    var c = r.b;
                    return st(A2(Uu, function(r) {
                        return A2(n.h1, c, A2(Qe, function(n) {
                            return cd(n);
                        }, r));
                    }, Ek(A2(Qe, function(r) {
                        return Ek(A2(Ru, function(r) {
                            var t = h(a, r);
                            return 1 === t.a && 5 === t.b.$ ? st(A2(Vk, n, t.b.a)) : A2(Yu, Uu(hv), A2(Ok, n, r));
                        }, r));
                    }, r.c))));
                case 7:
                    return st(xt(n.gC(r.a)));
                case 8:
                    return st(xt(n.iB));
                case 3:
                    return st(A2(Uu, n.gt, Ek(A2(Rk, n, r.a))));
                default:
                    var i = r.a, o = r.b, f = Ek(A2(Qe, function(r) {
                        var t = r.bt;
                        return A2(Uu, oo(r.bN), A2(Vk, n, t));
                    }, i)), s = A2(Uu, function(r) {
                        return n.ix(hv(n.iz(A2(Qe, function(r) {
                            return A2(n.iy, r.a, r.b);
                        }, r))));
                    }, f), d = function(r) {
                        return A2(Uu, n.iz, A2(Uu, qt(F2(function(r, t) {
                            return A2(n.iw, A2(ju, function(n) {
                                return n.bN;
                            }, Gu(A2(vh, r, i))), t);
                        })), Ek(A2(Qe, Vk(n), r))));
                    }, b = Ek(A2(Qe, d, o));
                    return st(A3(Es, F2(function(r, t) {
                        return n.iu(A2(bt, r, function(r) {
                            return zl(r) ? w : y([
                                n.iv(r)
                            ]);
                        }(t)));
                    }), s, b));
            }
        };
    }, Dk = F4(function(n, r, t, e) {
        return A5(qk, r, t, e, n.hq, A2(Rk, n, e));
    }), Fk = F2(function(n, r) {
        switch(r.$){
            case 4:
                return st(A2(Uu, n.ir, A2(Vk, n, r.a)));
            case 3:
                return st(A2(Uu, n.g1, A2(Vk, n, r.a)));
            case 5:
                return st(A2(Uu, n.iq, A2(Vk, n, r.a)));
            case 2:
                var t = r.a, e = r.b;
                return st(xt(n.ht({
                    cA: Xk(r.c),
                    dP: t,
                    iG: e
                })));
            case 7:
                return st(xt(n.iA(r.a)));
            case 6:
                return st(xt(n.gD(r.a)));
            case 1:
                var u = r.a;
                return e = r.b, st(A2(qu, function(r) {
                    return xt(A2(n.hH, {
                        a2: u,
                        iG: e
                    }, r));
                }, A2(Vk, n, r.c)));
            case 8:
                return st(xt(n.hi));
            default:
                var a = r.a;
                return a.$ ? dt : st(A4(Dk, n, a.a, a.b, a.c));
        }
    }), Vk = F2(function(n, r) {
        return Ek(A3(Ue, Mk(n), w, r));
    }), Zk = F2(function(n, r) {
        return Ek(A2(Rk, n, r));
    }), Gk = F2(function(n, r) {
        return A2(qu, A2(lu, Zk(n.ie), n.g9), A2(Gi, A2(pu, Qe(yh), It("\n\n")), bk(r)));
    }), Yk = Gk(Nv), Uk = F2(function(n, r) {
        return n(r);
    }), Qk = function(n) {
        return n.$ ? st(n.a) : dt;
    }, Jk = F3(function(n, r, t) {
        for(;;){
            var e = $(t, {
                iI: A2(ju, A2(lu, Qk, function(n) {
                    return n.bp;
                }), n),
                ct: A2(Yu, function(n) {
                    return n.ct;
                }, n)
            }), u = A2(Uk, r, e), c = {
                bp: u.bp,
                ct: u.ct
            };
            if (a(st(c), n)) return h(u, e);
            n = st(c), t = e;
        }
    }), Kk = F2(function(n, r) {
        return A3(Jk, dt, n, r);
    }), Wk = function(n) {
        return A2(It, " ", A2(Ru, $h, A2(Ru, function(r) {
            return Gu(zd(A2(Qe, function(r) {
                return A2(Si, r, n.a4);
            }, r)));
        }, y([
            y([
                "Anrede",
                "Title"
            ]),
            y([
                "Titel",
                "Official title"
            ]),
            y([
                "Vorname",
                "First name"
            ]),
            y([
                "Nachname",
                "Last name"
            ])
        ]))));
    }, n_ = F4(function(n, r, t, e) {
        return {
            gH: n,
            b$: {
                gM: 0,
                gN: 0
            },
            e$: 1,
            bc: !1,
            cn: vd(w),
            bE: e,
            iI: dt,
            ct: dt,
            d2: r,
            iQ: t
        };
    }), r_ = dr, t_ = r_, e_ = F4(function(n, r, t, e) {
        var u, c, i, o = A4(n_, r, t, (u = n, {
            gz: function() {
                return w;
            },
            gN: function() {
                return w;
            },
            gO: function() {
                return w;
            },
            hx: function(n) {
                var r = n.gH, t = n.hy, e = n.hz;
                return y([
                    A2(lv, w, y([
                        A2(Lv, w, function() {
                            switch(e.$){
                                case 0:
                                    var u = e.a, a = A3(Cv, n.gH, "", A2(_i, !1, gh(n.d2)) ? qf(function(n) {
                                        switch(n){
                                            case 0:
                                                return "ja";
                                            case 1:
                                                return "yes";
                                            case 2:
                                                return "s\xed";
                                            case 3:
                                                return "oui";
                                            default:
                                                return "\u0434\u0430";
                                        }
                                    }) : qf(function(n) {
                                        switch(n){
                                            case 0:
                                                return "nein";
                                            case 1:
                                            case 2:
                                                return "no";
                                            case 3:
                                                return "non";
                                            default:
                                                return "\u043D\u0435\u0442";
                                        }
                                    }));
                                    return cd(y([
                                        A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), Yk(A3(Cv, n.gH, "", u) + ":\xa0" + a))
                                    ]));
                                case 1:
                                    var c = e.b, i = (a = $h(n.d2), A2(Yu, function(r) {
                                        return A3(no, r, function(n) {
                                            return n.bt;
                                        }, A2(Gb, A2(lu, oe(r), function(n) {
                                            return n.bL;
                                        }), A3(Cv, n.gH, w, A2(lh, function() {
                                            return No;
                                        }, c))));
                                    }, a));
                                    return y([
                                        kv(A3(Cv, n.gH, "", "$guestCodes" === A3(Cv, n.gH, "", t.bt) ? qf(function(n) {
                                            return 1 === n ? "Number of guest codes" : "Anzahl G\xe4stecodes";
                                        }) : t.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", i))
                                    ]);
                                case 2:
                                    a = $h(n.d2);
                                    var o = A2(ju, function(n) {
                                        return ze(n) ? dt : st(n);
                                    }, A2(Yu, Pb, a));
                                    return y([
                                        kv(A3(Cv, n.gH, "", t.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", o))
                                    ]);
                                case 3:
                                    return a = $h(n.d2), c = r.aS.h4({
                                        eH: w,
                                        e3: w
                                    }), i = A2(Yu, function(n) {
                                        return A3(no, n, A2(lu, A2(Cv, r, ""), function(n) {
                                            return n.bt;
                                        }), A2(Gb, A2(lu, oe(n), function(n) {
                                            return n.bL;
                                        }), c));
                                    }, a), y([
                                        kv(A3(Cv, n.gH, "", t.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", i))
                                    ]);
                                default:
                                    return i = A2(Yu, hh, $h(n.d2)), y([
                                        kv(A3(Cv, n.gH, "", t.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", i))
                                    ]);
                            }
                        }())
                    ]))
                ]);
            },
            hK: (c = function(n) {
                return A2(Ev, F2(function(r, t) {
                    n: for(; 4 === r.$;)switch(r.a){
                        case 1:
                            var e = r.b;
                            return p(t, y([
                                Nl(y(n ? [
                                    Bl(e)
                                ] : [
                                    Ll(e)
                                ]))
                            ]));
                        case 2:
                            return e = r.b, p(t, y([
                                Nl(n ? w : y([
                                    Bl(e)
                                ]))
                            ]));
                        default:
                            break n;
                    }
                    return t;
                }), w);
            }, i = F2(function(n, r) {
                return $(r, {
                    g9: c(n)
                });
            }), function(n) {
                var r = n.ii;
                return A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), A2(Gk, A2(i, n.bc, Nv), A3(Cv, n.gH, "", r)));
            }),
            hP: function() {
                return w;
            },
            hR: function(n) {
                return n.gH.aB;
            },
            h2: function(n) {
                var r = n.g7;
                return n.bc && a(n.b$.gN, u) ? r : w;
            },
            dy: function(n) {
                return cd(A2(qt, function(r) {
                    return bt(A2(lv, w, y([
                        A2(rv, w, y([
                            kv(p(A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "Teilnehmende Person ";
                                    case 1:
                                        return "Participant ";
                                    case 2:
                                        return "Persona participante ";
                                    case 3:
                                        return "Personne participante ";
                                    default:
                                        return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ";
                                }
                            })), Lt(r + 1)))
                        ]))
                    ])));
                }, n.g8));
            },
            it: function(n) {
                if (!A2(Il, function(n) {
                    return !A2(_i, 0, n.fz);
                }, n.gH.aB)) {
                    var r = A2(_h, n.gH, n.ct), t = A2(kh, n.gH, n.ct), e = A3(no, h(dt, {
                        e4: 0,
                        fz: 0
                    }), zf(st), A3(rl, n.gH, n.d2.h0, n.gH.aq)), u = e.a, a = e.b;
                    return y([
                        A3(no, kv(""), function() {
                            return A2(Lv, w, y([
                                kv(A3(Cv, n.gH, "", qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "enthaltene MwSt. (vor Rabatt)";
                                        case 1:
                                            return "tax (included before discount)";
                                        case 2:
                                            return "IVA incluido (antes del descuento)";
                                        case 3:
                                            return "TVA incluse (avant remise)";
                                        default:
                                            return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421 (\u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                    }
                                }))),
                                kv(": "),
                                kv(r ? A2(bh, n.gH.e, r) : A3(Cv, n.gH, "", qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "steuerfrei";
                                        case 1:
                                            return "free of tax";
                                        case 2:
                                            return "libre de impuestos";
                                        case 3:
                                            return "exon\xe9r\xe9 d'imp\xf4t";
                                        default:
                                            return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                    }
                                })))
                            ]));
                        }, u),
                        A3(no, kv(""), function() {
                            return A2(Lv, w, y([
                                kv(A3(Cv, n.gH, "", qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Gesamtsumme (vor Rabatt)";
                                        case 1:
                                            return "Price (total before discount)";
                                        case 2:
                                            return "Importe (total antes del descuento)";
                                        case 3:
                                            return "Montant total (avant remise)";
                                        default:
                                            return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F \u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                    }
                                }))),
                                kv(": "),
                                kv(t ? A2(bh, n.gH.e, t) : A3(Cv, n.gH, "", qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "kostenfrei";
                                        case 1:
                                            return "free of cost";
                                        case 2:
                                            return "gratis";
                                        case 3:
                                            return "gratuit";
                                        default:
                                            return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                    }
                                })))
                            ]));
                        }, u),
                        A3(no, kv(""), function(r) {
                            return A2(Lv, w, y([
                                kv(A3(Cv, n.gH, "", qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Rabatt";
                                        case 1:
                                            return "Discount";
                                        case 2:
                                            return "Descuento";
                                        case 3:
                                            return "Remise";
                                        default:
                                            return "\u0421\u043A\u0438\u0434\u043A\u0430";
                                    }
                                }))),
                                kv(" ("),
                                kv(A3(Cv, n.gH, "", r.bt)),
                                kv("): "),
                                kv(A2(bh, n.gH.e, -a.fz))
                            ]));
                        }, u),
                        A2(Lv, w, y([
                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "enthaltene MwSt.";
                                    case 1:
                                        return "tax (included)";
                                    case 2:
                                        return "IVA incluido";
                                    case 3:
                                        return "TVA incluse";
                                    default:
                                        return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421";
                                }
                            }))),
                            kv(": "),
                            kv(r ? A2(bh, n.gH.e, r - a.e4) : A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "steuerfrei";
                                    case 1:
                                        return "free of tax";
                                    case 2:
                                        return "libre de impuestos";
                                    case 3:
                                        return "exon\xe9r\xe9 d'imp\xf4t";
                                    default:
                                        return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                }
                            })))
                        ])),
                        A2(Lv, w, y([
                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "Gesamtsumme";
                                    case 1:
                                        return "Price (total)";
                                    case 2:
                                        return "Importe (total)";
                                    case 3:
                                        return "Montant total";
                                    default:
                                        return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F)";
                                }
                            }))),
                            kv(": "),
                            kv(t ? A2(bh, n.gH.e, t - a.fz) : A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "kostenfrei";
                                    case 1:
                                        return "free of cost";
                                    case 2:
                                        return "gratis";
                                    case 3:
                                        return "gratuit";
                                    default:
                                        return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                }
                            })))
                        ]))
                    ]);
                }
                return w;
            },
            iE: function(n) {
                var r = n.il, t = A2(Ru, function(n) {
                    return A2(Yu, function(r) {
                        return h(r.b, n);
                    }, A2(Gb, A2(lu, oe(n.fZ), ge), r));
                }, n.gH.aB);
                return t.b ? A2(Qe, function(r) {
                    var t = r.a, e = r.b;
                    return A2(Lv, w, y([
                        kv(Lt(t) + "x\xa0" + A3(Cv, n.gH, "", e.bt)),
                        kv("\xa0"),
                        A3(no, kv(""), function(r) {
                            return kv(!r && e.eQ ? "kostenfrei" : (t > 1 ? Bt("\xe1\xa0") : Ne)(A2(bh, n.gH.e, r)));
                        }, e.fz)
                    ]));
                }, t) : y([
                    kv(A3(Cv, n.gH, "", n.fo))
                ]);
            }
        }), function() {
            return w;
        }), f = A2(Kk, e, o).a;
        return p(y([
            A2(lv, y([
                A2(Ml, "color", Su(r.aS.eq.dC))
            ]), y([
                A2(Pl, w, y([
                    kv(A3(no, "", Wk, A2(Si, n, t.h0.dy)))
                ]))
            ]))
        ]), A2(Qe, t_(function() {
            return 0;
        }), f.iP));
    }), u_ = function(n) {
        return Is({
            cI: n.cI,
            ah: n.ah,
            a4: Gc,
            e: n.e,
            dy: Gc
        });
    }, a_ = function(n) {
        return Ts({
            cI: n.cI,
            ah: n.ah,
            a4: Gc,
            e: n.e,
            aB: Gc
        });
    }, c_ = F3(function(n, r, t) {
        return function(e) {
            var u = A2(Yu, ge, A3(rl, r, t.h0, r.aq));
            return e((n ? u_ : a_)({
                cI: A2(Yu, function(n) {
                    return n.cI;
                }, r.cI),
                ah: A2(Yu, function(n) {
                    return n.gZ;
                }, u),
                e: r.e
            }));
        };
    }), i_ = function(n) {
        return A2(Vs, function() {
            return id(function(n) {
                return A2(T$, n.b, n.a);
            });
        }, A2(Vs, function() {
            return Xb;
        }, n));
    }, o_ = F2(function(n, r) {
        var t = n.h0.he;
        if (r.$) {
            var e = r.a;
            return Is($(e, {
                dy: A2(Vs, F2(function(n, r) {
                    return $(r, {
                        aB: A2(Us, i_(t), r.aB)
                    });
                }), e.dy)
            }));
        }
        var u = r.a;
        return Ts($(u, {
            aB: A2(Us, i_(t), u.aB)
        }));
    }), f_ = F2(function(n, r) {
        return h(n, A2(bt, r.a, r.b));
    }), s_ = F2(function(n, r) {
        return A2(lu, A2(Ue, n, r), No);
    }), d_ = F2(function(n, r) {
        return No(r).b ? A3(s_, f_, r, n) : n;
    }), b_ = F2(function(n, r) {
        return function(t) {
            var e, u = 2 * t.e$, a = $(t, {
                e$: 2 * t.e$ + 1
            }), c = A2(Uk, r, a), i = $(t, {
                e$: u
            }), o = A2(Uk, n, i);
            return {
                bp: (e = h(o.bp, c.bp), 1 === e.a.$ ? wt(1 === e.b.$ ? A2(d_, e.a.a, e.b.a) : e.a.a) : 1 === e.b.$ ? wt(e.b.a) : xt((0, e.b.a)(e.a.a))),
                ct: c.ct(o.ct),
                iP: p(o.iP, c.iP)
            };
        };
    }), l_ = F2(function(n, r) {
        return function(t) {
            var e = A2(Uk, r, t);
            return {
                bp: A2(Uu, n, e.bp),
                ct: n(e.ct),
                iP: e.iP
            };
        };
    }), v_ = function(n) {
        return function() {
            return {
                bp: xt(n),
                ct: n,
                iP: w
            };
        };
    }, h_ = function(n) {
        if (n.b) {
            var r = n.a, t = n.b;
            return A3(Ct, F2(function(n, r) {
                return A2(b_, r, A2(b_, n, v_(bt)));
            }), A2(l_, hv, r), t);
        }
        return v_(w);
    }, g_ = F2(function(n, r) {
        return A2(Mb, n, r);
    }), $_ = ii, m_ = F2(function(n, r) {
        return A2(ci, Ne, y([
            !Fb(r.fa) && A2(g_, _o(n.e), r.fa),
            !Fb(r.en) && A2(ci, function(r) {
                return a(st(r), n.el);
            }, gt(r.en)),
            !Fb(r.aB) && A2(ci, function(r) {
                return A2(ci, function(n) {
                    return A2($_, r, n);
                }, rd(n.iF));
            }, gt(r.aB)),
            !zl(r.eM) && A2(ci, function(r) {
                var t = r.a, e = r.b, u = n.gN;
                if (u.$) return A3(no, !1, function(n) {
                    if (n.$) return r = n.a.a4, a(st(e), A2(Si, t, r));
                    var r = n.a.a4;
                    return a(st(e), A2(Si, t, r));
                }, n.ct);
                var c = u.a;
                return A3(no, !1, function(n) {
                    return !!n.$ && A3(no, !1, function(n) {
                        var r = n.a4;
                        return a(st(e), A2(Si, t, r));
                    }, A2(Si, c, n.a.dy));
                }, n.ct) || A3(no, !1, function(n) {
                    if (n.$) return r = n.a.a4, a(st(e), A2(Si, t, r));
                    var r = n.a.a4;
                    return a(st(e), A2(Si, t, r));
                }, n.ct);
            }, r.eM),
            r.hs && !A2(kh, n, n.ct)
        ]));
    }), p_ = F2(function(n, r) {
        return A2(Il, Ne, y([
            Fb(r.fa) || A2(g_, _o(n.e), r.fa),
            Fb(r.en) || A2(ci, function(r) {
                return a(st(r), n.el);
            }, gt(r.en)),
            Fb(r.aB) || A2(ci, function(r) {
                return A2(ci, $_(r), rd(n.iF));
            }, gt(r.aB)),
            zl(r.eM) || A2(ci, function(r) {
                var t = r.a, e = r.b, u = n.gN;
                if (u.$) return A3(no, !1, function(n) {
                    if (n.$) return r = n.a.a4, a(st(e), A2(Si, t, r));
                    var r = n.a.a4;
                    return a(st(e), A2(Si, t, r));
                }, n.ct);
                var c = u.a;
                return A3(no, !1, function(n) {
                    return !!n.$ && A3(no, !1, function(n) {
                        var r = n.a4;
                        return a(st(e), A2(Si, t, r));
                    }, A2(Si, c, n.a.dy));
                }, n.ct) || A3(no, !1, function(n) {
                    if (n.$) return r = n.a.a4, a(st(e), A2(Si, t, r));
                    var r = n.a.a4;
                    return a(st(e), A2(Si, t, r));
                }, n.ct);
            }, r.eM),
            !r.hs || !A2(kh, n, n.ct),
            !r.b4 || n.hD
        ]));
    }), w_ = F6(function(n, r, t, e, u, a) {
        var c = a.a, i = {
            el: A2(Yu, function(n) {
                return n.el;
            }, n.cI),
            gN: e,
            hD: kd(n.ba),
            e: n.e,
            h0: r,
            iF: u,
            aB: n.aB,
            ct: t
        }, o = A2(m_, i, c.g4);
        return A2(p_, i, c.hv) && !o ? y([
            a
        ]) : w;
    }), k_ = F2(function(n, r) {
        return A2(id, function(r) {
            var t = r.b;
            return y([
                A2(Jo, r.a, function() {
                    switch(t.$){
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 7:
                        default:
                            return t;
                        case 5:
                            return A2(kf, t.a, A2(k_, n, t.b));
                        case 6:
                            var r = t.a;
                            return _f($(r, {
                                a4: A2(k_, n, r.a4)
                            }));
                    }
                }())
            ]);
        }, A2(id, n, r));
    }), __ = F5(function(n, r, t, e, u) {
        return A2(lu, A2(lu, Gu, k_(A5(w_, n, r, t, e, u))), hv);
    }), y_ = F6(function(n, r, t, e, u, a) {
        var c = a.b;
        return A2(Qo, a.a, A2(Ru, A5(__, n, r, t, e, u), c));
    }), x_ = F6(function(n, r, t, e, u, a) {
        var c = a.a, i = function() {
            if (1 === u.$) return Gc;
            if (u.a.$) {
                var n = u.a.a.dy, r = A2(Si, A2(_i, 0, e), n);
                return 1 === r.$ ? Gc : r.a.aB;
            }
            return u.a.a.aB;
        }(), o = {
            el: A2(Yu, function(n) {
                return n.el;
            }, n.cI),
            gN: e,
            hD: kd(n.ba),
            e: n.e,
            h0: r,
            iF: i,
            aB: n.aB,
            ct: t
        }, f = A2(m_, o, c.g4);
        return A2(p_, o, c.hv) && !f ? st(a) : dt;
    }), H_ = A, A_ = F3(function(n, r, t) {
        var e = Kb(r.d2.h0.dy) - 1, u = A2(Ru, function(n) {
            var t = n.h2, e = n.b0, u = n.hB;
            return A2(Yu, function(n) {
                return {
                    b0: e,
                    hB: u,
                    h2: n
                };
            }, A6(x_, r.gH, r.d2.h0, r.ct, t.a.bc ? st(e.gN) : dt, r.ct, t));
        }, A2(pi, function(n) {
            var r = n.b0;
            return g(n.bc, r.gN, r.gM);
        }, cd(A2(qt, F2(function(n, r) {
            var t = r.a, u = r.b, a = r.c;
            return a.a.bc ? A2(Qe, function(r) {
                return {
                    b0: {
                        gM: n,
                        gN: r
                    },
                    hB: t,
                    h2: a,
                    bc: u
                };
            }, A2(jt, 0, e)) : y([
                {
                    b0: {
                        gM: n,
                        gN: 0
                    },
                    hB: t,
                    h2: a,
                    bc: u
                }
            ]);
        }), A3(Ct, F2(function(n, r) {
            var t = r.a, e = t.a, u = t.b, a = r.b;
            return n.a.bc ? h(h(!0, u), p(a, y([
                g(!e, u + 1, n)
            ]))) : h(h(!1, u + 2), p(a, y([
                g(!1, u + 2, n)
            ])));
        }), h(h(!1, 0), w), t).b))));
        return A4(H_, F3(function(n, t, e) {
            var u, a;
            return {
                cL: {
                    b$: t.b0,
                    hV: A2(Yu, function(n) {
                        return n.b0;
                    }, e),
                    h6: A2(Yu, function(n) {
                        return n.b0;
                    }, n)
                },
                hB: t.hB,
                h2: (u = t.b0.gN, a = function() {
                    var n = r.ct;
                    if (1 === n.$) return Gc;
                    if (n.a.$) {
                        var t = A2(Si, u, n.a.a.dy);
                        return 1 === t.$ ? Gc : t.a.aB;
                    }
                    return n.a.a.aB;
                }(), A6(y_, r.gH, r.d2.h0, r.ct, t.h2.a.bc ? st(t.b0.gN) : dt, a, t.h2))
            };
        }), A2(bt, dt, A2(Qe, st, u)), u, p(A2(Qe, st, A2(lu, _i(w), eh)(u)), y([
            dt
        ])));
    }), P_ = function(n) {
        return af(y([
            h("name", cf(n.dj)),
            h("size", uf(n.dO)),
            h("type", cf(n.d$)),
            h("lastModified", uf(n.c9)),
            h("dataURL", cf(n.cN))
        ]));
    }, B_ = A2(Ia, function(n) {
        return 1 > Te(n) ? Ua("Domain has to be atleast 1 character long.") : Ja(n);
    }, Za(A2(ec, Ja(0), Da(function(n) {
        return (Vt(n) || "-" === n) && "@" !== n && "." !== n;
    })))), N_ = A2(Ia, function(n) {
        return A2(De, ".", n) || A2(wg, ".", n) || !a(A2(Ee, "..", n), w) ? Ua("localPart can't start or end with a dot, nor can there be double dots") : a(Pb(n), n) ? Ja(n) : Ua("localPart can't be wrapped with whitespace");
    }, Za(A2(ec, Ja(0), Da(function(n) {
        return "+" !== n && "@" !== n && "\\" !== n && '"' !== n;
    })))), L_ = A2(Ia, function(n) {
        return 2 > Te(n) ? Ua("Tld needs to be at least 2 character long.") : Ja(n);
    }, Za(A2(ec, Ja(0), Da(function(n) {
        return Ot(n) || Rt(n) || "-" === n;
    })))), I_ = (Tk = F2(function(n, r) {
        return A2(_c, w, function(t) {
            return fc(y([
                A2(ac, A2(ec, Ja(function(n) {
                    return dc(A2(bt, n, t));
                }), Lc(Hu(n))), r),
                A2(mc, function() {
                    return sc(Zt(t));
                }, Ja(0))
            ]));
        });
    }), A2(ac, A2(ac, A2(ac, A2(ac, Ja(F4(function(n, r, t, e) {
        var u = A2(It, "", y([
            n,
            r.b ? "+" + A2(It, "+", r) : ""
        ]));
        return Te(u) > 64 || 1 > Et(e) ? dt : st({
            cS: t,
            dc: n,
            dV: r,
            dZ: e
        });
    })), N_), A2(ec, A2(Tk, "+", N_), Lc("@"))), B_), A2(ec, A2(Tk, ".", L_), ja))), T_ = F5(function(n, r, t, e, u) {
        return {
            cN: u,
            c9: e,
            dj: n,
            dO: r,
            d$: t
        };
    }), S_ = F6(function(n, r, t, e, u, a) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ || 1 === u.$ || 1 === a.$ ? dt : st(A5(n, r.a, t.a, e.a, u.a, a.a));
    }), C_ = function(n) {
        if (4 === n.$) {
            var r = n.a, t = fe(r);
            return r - t ? dt : st(t);
        }
        return dt;
    }, E_ = function(n) {
        if (n.$) return dt;
        var r = n.a;
        return A6(S_, T_, A2(ju, A2(lu, $h, Ws), A2(Gb, A2(lu, oe("name"), ge), r)), A2(ju, A2(lu, C_, Ws), A2(Gb, A2(lu, oe("size"), ge), r)), A2(ju, A2(lu, $h, Ws), A2(Gb, A2(lu, oe("type"), ge), r)), A2(ju, A2(lu, A2(lu, Yu(Wa), C_), Ws), A2(Gb, A2(lu, oe("lastModified"), ge), r)), A2(ju, A2(lu, $h, Ws), A2(Gb, A2(lu, oe("dataURL"), ge), r)));
    }, z_ = F4(function(n, r, t, e) {
        var u = t.be;
        switch(r.$){
            case 5:
                var a = r.a, c = A4(z_, n, r.b, {
                    be: u
                }, e), i = h(A4(z_, n, a, {
                    be: u
                }, e), c);
                return i.a.$ ? i.b.$ ? wt(i.b.a) : xt(i.b.a) : xt(i.a.a);
            case 0:
                var o = A2(_i, !1, A2(ju, gh, e));
                return u && !o ? wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Diese Angabe ist verpflichtend.";
                        case 1:
                            return "Please indicate your agreement.";
                        case 2:
                            return "Esta informaci\xf3n es obligatoria.";
                        case 3:
                            return "Cette mention est obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435.";
                    }
                })) : xt(tf(o));
            case 1:
                var f = r.a, s = A3(no, "", Pb, A2(ju, $h, e));
                return u && ze(s) ? wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte treffen Sie eine Auswahl.";
                        case 1:
                            return "Please select an option.";
                        case 2:
                            return "Por favor, selecciona una opci\xf3n.";
                        case 3:
                            return "Veuillez s\xe9lectionner une option.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442.";
                    }
                })) : !u && ze(s) || A2(ii, s, A2(Qe, function(n) {
                    return n.bL;
                }, A3(Cv, n, w, A2(lh, function() {
                    return No;
                }, f)))) ? xt(cf(s)) : wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                }));
            case 2:
                return s = A3(no, "", Pb, A2(ju, $h, e)), u && ze(s) ? wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                })) : !u && ze(s) || kd(function(n) {
                    var r = A2(Oc, I_, n);
                    return r.$ ? dt : r.a;
                }(s)) ? xt(cf(s)) : wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Diese E-Mail-Adresse ist ung\xfcltig.";
                        case 1:
                            return "This email address is not valid.";
                        case 2:
                            return "Esta direcci\xf3n de correo no es v\xe1lida.";
                        case 3:
                            return "Cette adresse e-mail n'est pas valide.";
                        default:
                            return "\u042D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D.";
                    }
                }));
            case 3:
                var d = r.a;
                return s = A3(no, "", Pb, A2(ju, $h, e)), u && ze(s) ? wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                })) : A2(Uu, function() {
                    return cf(s);
                }, A3(no, xt(0), function(n) {
                    var r = n.cY;
                    return A2(Ym, n.fs, s) ? xt(0) : wt(r);
                }, d));
            default:
                var b = A2(ju, E_, e);
                return u && pd(b) ? wt(qf(function(n) {
                    switch(n){
                        case 0:
                            return "Bitte f\xfcllen Sie dieses Pflichtfeld.";
                        case 1:
                            return "Please fill this mandatory field.";
                        case 2:
                            return "Por favor, rellena este campo obligatorio.";
                        case 3:
                            return "Veuillez remplir ce champ obligatoire.";
                        default:
                            return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435.";
                    }
                })) : xt(A3(no, ef, P_, b));
        }
    }), X_ = F3(function(n, r, t) {
        return function(e) {
            return {
                bp: xt(n),
                ct: n,
                iP: A2(Qe, t_(Ve), e.iQ.gz({
                    gH: e.gH,
                    e$: e.e$,
                    iD: t,
                    d2: r
                }))
            };
        };
    }), j_ = X_, q_ = F2(function(n, r) {
        var t = n, e = r;
        return {
            eS: function(n) {
                return e.eS(t.eS(n));
            },
            cv: F2(function(n, r) {
                return A2(t.cv, e.cv(n), r);
            })
        };
    }), M_ = F2(function(n, r) {
        return {
            eS: n,
            cv: r
        };
    }), R_ = F2(function(n, r) {
        return A2(M_, A2(lu, _i(n), Si(r)), function(t) {
            return A2(Ri, r, A2(lu, A2(lu, st, t), _i(n)));
        });
    }), O_ = A2(M_, function(n) {
        return n.a4;
    }, F2(function(n, r) {
        return $(r, {
            a4: n(r.a4)
        });
    })), D_ = function(n) {
        return A2(q_, O_, A2(R_, cf(""), n));
    }, F_ = A2(M_, function(n) {
        return n.a4;
    }, F2(function(n, r) {
        return $(r, {
            a4: n(r.a4)
        });
    })), V_ = F2(function(n, r) {
        return n.eS(r);
    }), Z_ = F3(function(n, r, t) {
        return A2(n.cv, Cu(r), t);
    }), G_ = function(n) {
        return {
            eS: V_(n),
            fR: Z_(n)
        };
    }, Y_ = F2(function(n, r) {
        return !!r.$ || A2(ii, n, r.a);
    }), U_ = function(n) {
        return h(n, w);
    }, Q_ = F3(function(n, r, t) {
        return {
            cY: t,
            e$: r,
            fd: n
        };
    }), J_ = F3(function(n, r, t) {
        var e = n.fv;
        return function(n) {
            var u = n.d2, a = A2(Gi, A2(lu, A2(lu, U_, A2(Q_, n.b$, Lt(n.e$))), A2(Cv, n.gH, "")), A2(r.bj, {
                be: r.be
            }, st(u))), c = A2(Y_, n.b$, n.cn) && 1 === a.$ ? st(ld(a.a)) : dt;
            return {
                bp: a,
                ct: u,
                iP: n.iQ.hx({
                    gH: n.gH,
                    b$: n.b$,
                    e$: n.e$,
                    hy: r,
                    hz: t,
                    fv: e,
                    iN: c,
                    d2: n.d2
                })
            };
        };
    }), K_ = J_, W_ = l_, ny = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ry = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ty = {
        $: 0
    }, ey = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), uy = F2(function(n, r) {
        switch(r.$){
            case 0:
                return ty;
            case 1:
                return ny(n(r.a));
            case 2:
                return A2(ry, r.a, n(r.b));
            default:
                return A3(ey, r.a, r.b, r.c);
        }
    }), ay = F2(function(n, r) {
        var t = n.fR, e = n.eS;
        return function(n) {
            var u = A2(Uk, r, {
                gH: n.gH,
                b$: n.b$,
                e$: n.e$,
                bc: n.bc,
                cn: n.cn,
                bE: n.bE,
                iI: n.iI,
                ct: n.ct,
                d2: e(n.d2),
                iQ: n.iQ
            });
            return {
                bp: u.bp,
                ct: u.ct,
                iP: A2(Qe, t_(uy(A2(io, t, n.d2))), u.iP)
            };
        };
    }), cy = ay, iy = F2(function(n, r) {
        return function(t) {
            return {
                bp: xt(n),
                ct: n,
                iP: A2(Qe, t_(ny), t.iQ.hK({
                    gH: t.gH,
                    b$: t.b$,
                    e$: t.e$,
                    bc: t.bc,
                    ii: r
                }))
            };
        };
    }), oy = iy, fy = function(n) {
        return function(r) {
            return A2(Uk, n(r), r);
        };
    }, sy = F2(function(n, r) {
        var t, e = r.b;
        switch(e.$){
            case 0:
            case 1:
            case 2:
            case 5:
            case 7:
            default:
                return dt;
            case 3:
                var u = e.a, a = e.b;
                return st(A2(W_, F2(function(n, r) {
                    return $(r, {
                        a4: A3(Kc, u.br, n, r.a4)
                    });
                }), A2(cy, G_((t = u.br, A2(q_, F_, A2(R_, cf(""), t)))), fy(function(r) {
                    return A3(K_, {
                        fv: n.e8 ? st(r.b$.gN) : dt
                    }, {
                        a5: u.a5,
                        br: u.br,
                        bt: u.bt,
                        be: u.be,
                        bj: A2(z_, r.gH, u.bj)
                    }, a);
                }))));
            case 4:
                var c = e.a;
                return st(A2(cy, {
                    eS: function() {
                        return {
                            gM: 0,
                            gN: 0
                        };
                    },
                    fR: F2(function(n, r) {
                        return r;
                    })
                }, A2(oy, Ne, c)));
            case 6:
                var i = e.a;
                return st(A2(W_, A2(Ct, lu, Ne), h_(A2(Ru, sy(n), i.a4))));
        }
    }), dy = A2(M_, function(n) {
        return n.he;
    }, F2(function(n, r) {
        return $(r, {
            he: n(r.he)
        });
    })), by = dt, ly = Os(by), vy = {
        a4: Gc,
        aB: Gc
    }, hy = F2(function(n, r) {
        var t;
        return r.$ ? Is($(t = r.a, {
            a4: n(t.a4)
        })) : Ts($(t = r.a, {
            a4: n(t.a4)
        }));
    }), gy = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Is($(t, {
                dy: n(t.dy)
            }));
        }
        return r;
    }), $y = F6(function(n, r, t, e, u, a) {
        var c = A3($s, F3(function(e, u, a) {
            n: for(;;){
                var c = a.a, i = a.b;
                if (c.b) {
                    var o = c.a, s = o.a, d = o.b, b = c.b;
                    if (0 > f(s, e)) {
                        a = h(b, A3(n, s, d, i));
                        continue n;
                    }
                    return f(s, e) > 0 ? h(c, A3(t, e, u, i)) : h(b, A4(r, s, d, u, i));
                }
                return h(c, A3(t, e, u, i));
            }
        }), h(vt(e), a), u), i = c.a, o = c.b;
        return A3(Ct, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), o, i);
    }), my = A2(M_, function(n) {
        return n.dy;
    }, F2(function(n, r) {
        return $(r, {
            dy: n(r.dy)
        });
    })), py = function(n) {
        return A2(q_, my, A2(R_, pl, n));
    }, wy = A2(Ct, F2(function(n, r) {
        var t = h(n, r);
        return t.a.$ ? wt(1 === t.b.$ ? A2(d_, t.a.a, t.b.a) : t.a.a) : t.b.$ ? wt(t.b.a) : xt(A2(bt, t.a.a, t.b.a));
    }), xt(w)), ky = F2(function(n, r) {
        return function(t) {
            var e = Db(t.d2) ? A2(nd, 0, pl) : t.d2, u = A2(Qe, function(n) {
                var e, u = n.a, a = n.b;
                return A2(Uk, A2(l_, Yu(nd(u)), A2(ay, {
                    eS: function() {
                        return st(a);
                    },
                    fR: F2(function(n, r) {
                        return A3(no, A2(Mi, u, r), function(n) {
                            return A3(Kc, u, n, r);
                        }, n);
                    })
                }, A2(l_, st, A2(ay, {
                    eS: function() {
                        return a;
                    },
                    fR: F2(function(n) {
                        return st(n);
                    })
                }, r)))), $(t, {
                    b$: (e = t.b$, $(e, {
                        gN: u
                    }))
                }));
            }, vt(e)), a = A2(lu, A2(Ct, Us, Gc), zd)(A2(Qe, function(n) {
                return n.ct;
            }, u)), c = A3(no, !1, pe(Kb(e)), n.bw.a) ? wt(U_(A3(Q_, t.b$, Lt(t.e$), A3(Cv, t.gH, "", qf(function() {
                return "Bitte geben Sie mindestens " + Lt(A2(_i, 0, n.bw.a)) + " Personen an.";
            }))))) : A3(no, !1, de(Kb(e)), n.bw.b) ? wt(U_(A3(Q_, t.b$, Lt(t.e$), A3(Cv, t.gH, "", qf(function() {
                return "Bitte geben Sie h\xf6chstens " + Lt(A2(_i, 0, n.bw.b)) + " Personen an.";
            }))))) : A2(Uu, A2(lu, A2(Ct, Us, Gc), zd), wy(A2(Qe, function(n) {
                return n.bp;
            }, u))), i = A2(Y_, t.b$, t.cn) && 1 === c.$ ? st(ld(c.a)) : dt;
            return {
                bp: c,
                ct: a,
                iP: t.iQ.dy({
                    gH: t.gH,
                    g8: A2(Qe, function(n) {
                        return n.iP;
                    }, u),
                    e$: t.e$,
                    bw: n.bw,
                    iN: i,
                    d2: e
                })
            };
        };
    }), _y = ky, yy = A2(M_, function(n) {
        return n.aB;
    }, F2(function(n, r) {
        return $(r, {
            aB: n(r.aB)
        });
    })), xy = function(n) {
        return !!n.$;
    }, Hy = _s(kd), Ay = function(n) {
        return 0 !== n.$;
    }, Py = function(n) {
        switch(n.$){
            case 0:
                return !1;
            case 1:
                return !0;
            default:
                return kd(n.a.hN);
        }
    }, By = function(n) {
        return 1 === n.eL.$ ? Ay : Py;
    }, Ny = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Hy(r.a);
            case 1:
                return A2(By, n, r.a);
            default:
                return xy(r.a);
        }
    }), Ly = F2(function(n, r) {
        var t = n.hW, e = n.hC, u = r.eL, a = r.be, c = r.di;
        return function(n) {
            var i = function(r) {
                return Lt(n.e$) + "-" + Lt(r);
            }, o = n.iQ.hR({
                gH: n.gH,
                dX: r.dX,
                dY: r.dY
            }), f = A2(ei, function(n) {
                return A2(ii, n.a, A2(Qe, function(n) {
                    return n.fZ;
                }, o));
            }, (e ? Qe(function(n) {
                return h(n.a, t);
            }) : Ne)(Xb(n.d2))), s = A2(id, function(n) {
                return A2(T$, n.b, n.a);
            }, f), d = A2(Qe, function(n) {
                return n.fZ;
            }, o), b = A2(Il, function(n) {
                return A2(ii, n, d);
            }, A2(Qe, ge, Xb(n.d2))), l = a && zl(f) || !a && !A2(Ny, {
                eL: dt
            }, n.d2) || A2(Ny, {
                eL: u
            }, n.d2) && !b ? wt(U_(A3(Q_, n.b$, i(0), A3(Cv, n.gH, "Bitte w\xe4hlen Sie ein Ticket.", qf(function(n) {
                return 1 === n ? "Please select a ticket." : "Bitte w\xe4hlen Sie ein Ticket.";
            }))))) : A2(Ny, {
                eL: u
            }, n.d2) ? xt(s) : wt(U_(A3(Q_, n.b$, i(1), A3(Cv, n.gH, "Bitte treffen Sie eine Auswahl.", qf(function(n) {
                switch(n){
                    case 0:
                        return "Bitte treffen Sie eine Auswahl.";
                    case 1:
                        return "Please select an option.";
                    case 2:
                        return "Por favor, selecciona una opci\xf3n.";
                    case 3:
                        return "Veuillez s\xe9lectionner une option.";
                    default:
                        return "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442.";
                }
            }))))), v = A2(Y_, n.b$, n.cn) && 1 === l.$ ? st(ld(l.a)) : dt;
            return !A2(Y_, n.b$, n.cn) || pd(v), {
                bp: l,
                ct: s,
                iP: n.iQ.iE({
                    gs: o,
                    gH: n.gH,
                    eL: u,
                    e$: n.e$,
                    di: c,
                    fo: r.fo,
                    be: a,
                    il: f,
                    dX: r.dX,
                    ct: n.ct,
                    iN: v,
                    d2: n.d2
                })
            };
        };
    }), Iy = Ly, Ty = F2(function(n, r) {
        var t, e = n.bc, u = n.hC, a = n.bo, c = n.gN, i = r.b, o = A2(M_, function(n) {
            return n.h0;
        }, F2(function(n, r) {
            return $(r, {
                h0: n(r.h0)
            });
        })), f = cy(G_(o));
        switch(i.$){
            case 0:
                var s = i.a;
                return fy(function(n) {
                    var r = n.d2;
                    return A3(j_, Ne, A2(jb, A2(V_, A2(q_, o, dy), r), A2(V_, A2(q_, A2(q_, o, py(c)), yy), r)), s);
                });
            case 1:
                return f(A2(cy, G_(py(c)), (t = Ne, function(n) {
                    return {
                        bp: xt(t),
                        ct: t,
                        iP: A2(Qe, t_(Ve), n.iQ.gN({
                            gH: n.gH,
                            e$: n.e$,
                            d2: n.d2
                        }))
                    };
                })));
            case 2:
                return function(n) {
                    return function(r) {
                        return {
                            bp: xt(n),
                            ct: n,
                            iP: A2(Qe, t_(Ve), r.iQ.gO({
                                gH: r.gH,
                                e$: r.e$,
                                ct: r.ct,
                                d2: r.d2
                            }))
                        };
                    };
                }(Ne);
            case 3:
                var d = i.a, b = i.b, l = 1 === a.$ ? d.br : A2(It, ".", p(No(a.a), y([
                    d.br
                ])));
                return f(A2(W_, F2(function(n, r) {
                    return e ? A2(gy, function(r) {
                        var t = A2(_i, vy, A2(Si, c, r));
                        return A3(Kc, c, $(t, {
                            a4: A3(Kc, l, n, t.a4)
                        }), r);
                    }, r) : A2(hy, A2(Kc, l, n), r);
                }), A2(cy, G_(e ? A2(q_, py(c), D_(l)) : D_(l)), fy(function(n) {
                    return A3(K_, {
                        fv: e ? st(c) : dt
                    }, {
                        a5: d.a5,
                        br: l,
                        bt: d.bt,
                        be: d.be,
                        bj: A2(z_, n.gH, d.bj)
                    }, b);
                }))));
            case 4:
                var v = i.a;
                return A2(cy, {
                    eS: function(n) {
                        return n.b0;
                    },
                    fR: F2(function(n, r) {
                        return $(r, {
                            b0: n
                        });
                    })
                }, A2(oy, Ne, v));
            case 5:
                var h = i.a, g = i.b;
                return fy(function(n) {
                    return f(A2(W_, F2(function(n, r) {
                        return A2(gy, function(r) {
                            return A6($y, F3(function(n, r, t) {
                                return A3(Kc, n, r(vy), t);
                            }), F4(function(n, r, t, e) {
                                return A3(Kc, n, r(t), e);
                            }), F3(function(n, r, t) {
                                return A3(Kc, n, r, t);
                            }), n, r, Gc);
                        }, r);
                    }), A2(cy, G_(my), A2(_y, h, A2(W_, A2(Ct, lu, Ne), h_(A2(Ru, sy({
                        e8: !0,
                        h0: n.d2.h0
                    }), g)))))));
                });
            case 6:
                var m = i.a;
                return A2(W_, A2(Ct, lu, Ne), h_(A2(Qe, Ty({
                    gN: c,
                    bo: m.bo,
                    hC: u,
                    bc: e
                }), m.a4)));
            case 7:
                return function(n) {
                    return function(r) {
                        return {
                            bp: xt(n),
                            ct: n,
                            iP: r.iQ.it({
                                gH: r.gH,
                                e$: r.e$,
                                cn: r.cn,
                                bE: r.bE,
                                ct: r.ct,
                                d2: r.d2
                            })
                        };
                    };
                }(Ne);
            default:
                if (m = i.a, u) return fy(function(n) {
                    var r = n.d2;
                    return A2(W_, function() {
                        return Ne;
                    }, A2(cy, G_(A2(q_, o, A2(q_, dy, function(n) {
                        return A2(q_, A2(M_, function(n) {
                            return n;
                        }, F2(function(n, r) {
                            return n(r);
                        })), A2(R_, ly, n));
                    }(m.dX)))), A2(Iy, {
                        gN: c,
                        hC: u,
                        hW: Kb(r.h0.dy)
                    }, m)));
                });
                var w = G_(A2(q_, py(c), A2(q_, yy, A2(R_, ly, m.dX)))), k = F2(function(n, r) {
                    var t;
                    return r.$ ? Is($(t = r.a, {
                        dy: A3(Ri, c, A2(lu, A2(lu, st, function(r) {
                            return $(r, {
                                aB: A3(Kc, m.dX, n, r.aB)
                            });
                        }), _i(vy)), t.dy)
                    })) : Ts($(t = r.a, {
                        aB: A3(Kc, m.dX, n, t.aB)
                    }));
                });
                return fy(function(r) {
                    return f(A2(W_, k, A2(cy, w, A2(Iy, {
                        gN: c,
                        hC: n.hC,
                        hW: Kb(r.d2.h0.dy)
                    }, m))));
                });
        }
    }), Sy = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), Cy = F3(function(n, r, t) {
        var e = n.h6, u = n.hV, a = n.b$, c = r.bc, i = r.hB, o = t;
        return function(n) {
            var r = o($(n, {
                b$: a,
                bc: c,
                cn: n.d2.cn
            })), t = A3(Sy, !1, Cu(!0), r.bp);
            return {
                bp: r.bp,
                ct: r.ct,
                iP: n.iQ.h2({
                    gH: n.gH,
                    b$: a,
                    g7: r.iP,
                    e$: n.e$,
                    hB: i,
                    hV: u,
                    bc: c,
                    h6: e,
                    iI: n.iI,
                    ct: n.ct,
                    iM: t,
                    d2: n.d2
                })
            };
        };
    }), Ey = Cy, zy = function(n) {
        var r = dd(n);
        return fy(function(t) {
            var e = t.d2, u = t.gH;
            return A3(lu, A2(lu, A2(lu, W_(o_(e)), W_(A3(c_, r, u, e))), W_(A2(Ct, lu, Ne))), h_, A2(Qe, function(n) {
                var t = n.h2, e = n.cL, u = t.a, a = t.b;
                return A3(Ey, e, {
                    hB: n.hB,
                    bc: u.bc
                }, A2(W_, A2(Ct, lu, Ne), h_(A2(Qe, Ty({
                    gN: e.b$.gN,
                    bo: dt,
                    hC: r && !u.bc,
                    bc: u.bc
                }), a))));
            }, A3(A_, r, t, n)));
        });
    }, Xy = F2(function(n, r) {
        var t = r.p, e = r.a1;
        return A2(ro, n, {
            n: st(r.n),
            a1: e,
            x: "PUT",
            p: t
        });
    }), jy = F3(function(n, r, t) {
        return A2(Xy, n, {
            n: al(r),
            a1: hl,
            p: "/public/registration.json?frontendPrice=" + Lt(t)
        });
    }), qy = function(n) {
        return $u(y([
            h("name", ha(n.dj)),
            h("size", ls(n.dO)),
            h("type", ha(n.d$)),
            h("lastModified", ls(n.c9)),
            h("dataURL", ha(n.cN))
        ]));
    }, My = F2(function(n, r) {
        return A2(xb, n, {
            n: qy(r),
            a1: va,
            p: "/public/upload"
        });
    }), Ry = F2(function(n, r) {
        var t = h(r, Pd), e = h(n, r);
        n: for(;;){
            r: for(;;){
                t: for(;;){
                    e: for(;;){
                        u: for(;;){
                            a: for(;;){
                                c: for(;;){
                                    i: for(;;){
                                        o: for(;;){
                                            f: for(;;){
                                                s: for(;;)switch(e.b.$){
                                                    case 3:
                                                        if (7 === e.a.$) return e.a.a;
                                                        break r;
                                                    case 0:
                                                        if (7 === e.a.$) break n;
                                                        break t;
                                                    case 1:
                                                        if (7 === e.a.$) break n;
                                                        break e;
                                                    case 2:
                                                        switch(e.a.$){
                                                            case 7:
                                                                break n;
                                                            case 11:
                                                                var u = !a((l = e.a.a).b0, (I = e.b.a).v.b0);
                                                                return h(mo($(I, {
                                                                    ao: A2(Yu, tl, I.ao),
                                                                    v: l
                                                                })), Ad(y([
                                                                    $d(Ls(l)),
                                                                    u ? Hl(0) : Pd
                                                                ])));
                                                            case 1:
                                                                switch(e.a.a.$){
                                                                    case 0:
                                                                        var c = e.a.a.a, i = A2(td, bd((I = e.b.a).B), c), o = A3(no, 0, A2(lu, function(n) {
                                                                            return n.fz;
                                                                        }, Ws), A3(rl, I, i, I.aq)), s = A2(kh, I, st(c)) - o;
                                                                        return h(mo(I), Ad(y([
                                                                            Al(al(c)),
                                                                            A2(hu, Ib, I.cv ? A3(jy, I.ad, c, s) : A5(gl, I.ad, c, I.ak, s, I.aN))
                                                                        ])));
                                                                    case 1:
                                                                        return u = !a((l = e.a.a.a).b0, (I = e.b.a).v.b0), h(mo($(I, {
                                                                            v: l
                                                                        })), Ad(y([
                                                                            $d(Ls(l)),
                                                                            u ? Hl(0) : Pd
                                                                        ])));
                                                                    case 2:
                                                                        var d = e.a.a, b = d.a, l = d.b, v = (I = e.b.a).v, g = zy(I.B), m = $l(I);
                                                                        return h(mo($(I, {
                                                                            ao: st(Nb({
                                                                                bY: A4(e_, b, m, v, g),
                                                                                dq: l
                                                                            }))
                                                                        })), Pd);
                                                                    case 3:
                                                                        var p = e.a.a, k = p.a, _ = A5(yl, k, A = p.b, P = p.c, (I = e.b.a).aj, I.v);
                                                                        return h(mo($(I, {
                                                                            aj: _.a,
                                                                            v: l = _.b
                                                                        })), Ad(y([
                                                                            $d(Ls(l)),
                                                                            1 > f(P.dO, k.hM) ? A2(hu, A2(Tb, A, P), A2(My, I.ad, P)) : Pd
                                                                        ])));
                                                                    case 4:
                                                                        return h(mo($(I = e.b.a, {
                                                                            bA: e.a.a.a
                                                                        })), Pd);
                                                                    default:
                                                                        return h(mo(I = e.b.a), A2(hu, Lb, A2(xb, I.ad, {
                                                                            n: $u(w),
                                                                            a1: Pe(0),
                                                                            p: "/public/user-account/logout"
                                                                        })));
                                                                }
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                if (e.a.c.$) {
                                                                    var x = e.a, H = A5(kl, A = x.a, P = x.b, x.c.a, (I = e.b.a).aj, I.v);
                                                                    return h(mo($(I, {
                                                                        aj: H.a,
                                                                        v: l = H.b
                                                                    })), $d(Ls(l)));
                                                                }
                                                                var A, P, B = e.a, N = A5(xl, A = B.a, P = B.b, B.c.a, (I = e.b.a).aj, I.v);
                                                                return h(mo($(I, {
                                                                    aj: N.a,
                                                                    v: l = N.b
                                                                })), $d(Ls(l)));
                                                            case 0:
                                                                return h(1 === e.a.a.$ ? bo({
                                                                    gX: (I = e.b.a).gX,
                                                                    cX: vo(e.a.a.a),
                                                                    e: I.e
                                                                }) : mo($(I = e.b.a, {
                                                                    B: e.a.a.a
                                                                })), Pd);
                                                            case 2:
                                                                return h(1 === e.a.a.$ ? bo({
                                                                    gX: (I = e.b.a).gX,
                                                                    cX: vo(e.a.a.a),
                                                                    e: I.e
                                                                }) : mo($(I = e.b.a, {
                                                                    e: e.a.a.a
                                                                })), Pd);
                                                            case 3:
                                                                if (1 === e.a.a.$) return h(bo({
                                                                    gX: (I = e.b.a).gX,
                                                                    cX: lo("internal error"),
                                                                    e: I.e
                                                                }), Pd);
                                                                switch(e.a.a.a.$){
                                                                    case 2:
                                                                        return h(ho({
                                                                            ag: (I = e.b.a).ag,
                                                                            gX: I.gX,
                                                                            ak: I.ak,
                                                                            e: I.e
                                                                        }), Pd);
                                                                    case 0:
                                                                        var L = e.a.a.a.a;
                                                                        return h(wo({
                                                                            aH: L,
                                                                            gX: (I = e.b.a).gX,
                                                                            e: I.e
                                                                        }), Hd(A2(ku, Eo, L)));
                                                                    default:
                                                                        return h(bo({
                                                                            gX: (I = e.b.a).gX,
                                                                            cX: lo(e.a.a.a.a.cX),
                                                                            e: I.e
                                                                        }), Pd);
                                                                }
                                                            case 4:
                                                                return h(1 === e.a.a.$ ? bo({
                                                                    gX: (I = e.b.a).gX,
                                                                    cX: vo(e.a.a.a),
                                                                    e: I.e
                                                                }) : mo($(I = e.b.a, {
                                                                    aB: e.a.a.a
                                                                })), Pd);
                                                            case 5:
                                                                return h(1 === e.a.a.$ ? bo({
                                                                    gX: (I = e.b.a).gX,
                                                                    cX: vo(e.a.a.a),
                                                                    e: I.e
                                                                }) : mo($(I = e.b.a, {
                                                                    aq: e.a.a.a
                                                                })), Pd);
                                                            case 6:
                                                                return h(mo($(I = e.b.a, {
                                                                    aE: e.a.a
                                                                })), Pd);
                                                            case 10:
                                                                var I;
                                                                return h(mo($(I = e.b.a, {
                                                                    ao: dt
                                                                })), Pd);
                                                            default:
                                                                return t;
                                                        }
                                                    case 4:
                                                        switch(e.a.$){
                                                            case 7:
                                                                break n;
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                break a;
                                                            case 3:
                                                                if (1 === e.a.a.$) break c;
                                                                if (1 === e.a.a.a.$) break i;
                                                                break o;
                                                            default:
                                                                break o;
                                                        }
                                                    case 6:
                                                        switch(e.a.$){
                                                            case 7:
                                                                break n;
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                break a;
                                                            case 3:
                                                                if (1 === e.a.a.$) break c;
                                                                if (1 === e.a.a.a.$) break i;
                                                                break f;
                                                            default:
                                                                break f;
                                                        }
                                                    default:
                                                        switch(e.a.$){
                                                            case 7:
                                                                break n;
                                                            case 9:
                                                                break u;
                                                            case 8:
                                                                break a;
                                                            case 3:
                                                                if (1 === e.a.a.$) break c;
                                                                if (1 === e.a.a.a.$) break i;
                                                                break s;
                                                            default:
                                                                break s;
                                                        }
                                                }
                                                return t;
                                            }
                                            return t;
                                        }
                                        return t;
                                    }
                                    return t;
                                }
                                return h(r, Pd);
                            }
                            return t;
                        }
                        return h(r, Pd);
                    }
                    return t;
                }
                return t;
            }
            return t;
        }
        return t;
    }), Oy = F2(function(n, r) {
        var t = h(n, r);
        n: for(;;){
            if (6 === t.a.$ && 9 === t.a.a.$) {
                if (t.a.a.a.$) {
                    if (5 === t.b.c.$ && 2 === t.b.c.a.$) return h(r, Pd);
                    break n;
                }
                if (5 === t.b.c.$ && 2 === t.b.c.a.$) return rb(t.b.c.a.a.c_);
                break n;
            }
            break n;
        }
        return A3(Bb, Ry, n, r);
    }), Dy = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vy = {
        $: 3
    }, Zy = {
        $: 4
    }, Gy = F2(function(n, r) {
        return A2(hr, function(n) {
            return $r.test(n) ? "data-" + n : n;
        }(n), kr(r));
    }), Yy = Gy, Uy = function(n) {
        return A2(It, " ", A2(Qe, function(n) {
            return n.a + ": " + Su(n.b) + ";";
        }, y([
            h("--mdc-theme-primary", n.dC),
            h("--mdc-theme-secondary", n.dL),
            h("--mdc-theme-error", n.cX)
        ])));
    }, Qy = {
        cy: w,
        cR: !1,
        ap: !1,
        bq: dt,
        c5: dt,
        hP: dt,
        dp: dt,
        dW: dt,
        bH: !0,
        cu: !1
    }, Jy = {
        cy: w,
        dx: !1,
        d1: !0
    }, Ky = {
        cy: w,
        cH: !1
    }, Wy = {
        cy: w,
        ap: !1,
        cW: !1,
        a5: !1,
        bt: dt,
        bv: dt,
        dd: dt,
        cb: dt,
        dg: dt,
        cc: dt,
        dn: dt,
        $7: dt,
        dr: dt,
        fs: dt,
        dz: dt,
        dA: dt,
        be: !1,
        dQ: dt,
        dT: dt,
        cu: dt,
        d$: dt,
        d0: !0,
        bL: dt
    }, nx = function(n) {
        return n.ap ? st(Jl("mdc-text-field--disabled")) : dt;
    }, rx = F2(function(n, r) {
        return A2(vr, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && pr.test(n) ? "" : n;
        }(r));
    }), tx = rx, ex = function(n) {
        return st(A2(tx, "disabled", As(n.ap)));
    }, ux = function(n) {
        return n.cW ? st(Jl("mdc-text-field--end-aligned")) : dt;
    }, ax = function(n) {
        return n ? dt : st(Jl("mdc-text-field--filled"));
    }, cx = st(A2(tx, "foucClassNames", A2(Po, ha, y([
        "mdc-text-field--label-floating"
    ])))), ix = function(n) {
        return n.a5 ? st(Jl("mdc-text-field--fullwidth")) : dt;
    }, ox = function(n) {
        var r = n.bt;
        return n.a5 ? A2(Yu, Yy("aria-label"), r) : dt;
    }, fx = br, sx = F2(function(n, r) {
        return A2(fx, n, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r));
    }), dx = function(n) {
        return A2(sx, "blur", Pe(n));
    }, bx = function(n) {
        return A2(Yu, dx, n.dn);
    }, lx = A2(li, y([
        "target",
        "value"
    ]), va), vx = function(n) {
        return A2(Yu, function(n) {
            return A2(sx, "change", A2(He, n, lx));
        }, n.$7);
    }, hx = st(Jl("mdc-text-field__input")), gx = function(n) {
        return h(n, !0);
    }, $x = F2(function(n, r) {
        return A2(fx, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r));
    }), mx = function(n) {
        return A2($x, "input", A2(He, gx, A2(He, n, lx)));
    }, px = function(n) {
        return A2(Yu, mx, n.dr);
    }, wx = function(n) {
        var r = n.cb;
        return A2(Yu, A2(lu, Yy("maxLength"), Lt), r);
    }, kx = function(n) {
        var r = n.cc;
        return A2(Yu, A2(lu, Yy("minLength"), Lt), r);
    }, _x = Sl("placeholder"), yx = function(n) {
        return A2(Yu, _x, n.dz);
    }, xx = function(n) {
        var r;
        return A2(sv, A2(Ru, Ne, y([
            hx,
            (r = n, A2(Yu, Hv, r.d$)),
            ox(n),
            yx(n),
            px(n),
            bx(n),
            vx(n),
            kx(n),
            wx(n)
        ])), w);
    }, Hx = function(n) {
        var r = n.bL, t = "mdc-floating-label--float-above", e = "mdc-floating-label", u = h(n.a5, n.bt);
        if (u.a || u.b.$) return kv("");
        var a = u.b.a;
        return A2(ql, y([
            Jl("" !== A2(_i, "", r) ? e + " " + t : e),
            A2(tx, "foucClassNames", A2(Po, ha, y([
                t
            ])))
        ]), y([
            kv(a)
        ]));
    }, Ax = function(n) {
        var r = n.bL;
        return n.a5 || a(n.bt, dt) || "" === A2(_i, "", r) ? dt : st(Jl("mdc-text-field--label-floating"));
    }, Px = hr("class"), Bx = A2(iu, "keyCode", Mo), Nx = function(n) {
        return A2(sx, "click", Pe(n));
    }, Lx = function(n) {
        return A2(hr, "tabIndex", Lt(n));
    }, Ix = F2(function(n, r) {
        if (1 === r.$) return kv("");
        if (r.a.$) return t = r.a.a.ap, e = r.a.a.fn, u = r.a.a.cg, a = r.a.a.bP, A2(r.a.a.cf, A2(bt, Px("mdc-text-field__icon"), A2(bt, Px(n), function() {
            if (e.$) return a;
            var n = e.a;
            return t ? A2(bt, Lx(-1), A2(bt, A2(Yy, "role", "button"), a)) : A2(bt, Lx(0), A2(bt, A2(Yy, "role", "button"), A2(bt, Nx(n), A2(bt, A2(sx, "keydown", A2(ye, function(r) {
                return 13 === r ? Pe(n) : Eu("");
            }, Bx)), a))));
        }())), u);
        var t = r.a.a.ap, e = r.a.a.fn, u = r.a.a.cg, a = r.a.a.bP;
        return A2(r.a.a.cf, A2(bt, Jl("mdc-text-field__icon"), A2(bt, Jl(n), function() {
            if (e.$) return a;
            var n = e.a;
            return t ? A2(bt, Lx(-1), A2(bt, A2(Yy, "role", "button"), a)) : A2(bt, Lx(0), A2(bt, A2(Yy, "role", "button"), A2(bt, Nx(n), A2(bt, A2(sx, "keydown", A2(ye, function(r) {
                return 13 === r ? Pe(n) : Eu("");
            }, Bx)), a))));
        }())), u);
    }), Tx = function(n) {
        return A2(Ix, "mdc-text-field__icon--leading", n.bv);
    }, Sx = A2(ql, y([
        Jl("mdc-line-ripple")
    ]), w), Cx = function(n) {
        return st(A2(tx, "maxLength", ls(A2(_i, -1, n.cb))));
    }, Ex = function(n) {
        return st(A2(tx, "max", ha(A2(_i, "", A2(Yu, Lt, n.dd)))));
    }, zx = function(n) {
        return st(A2(tx, "minLength", ls(A2(_i, -1, n.cc))));
    }, Xx = function(n) {
        return st(A2(tx, "min", ha(A2(_i, "", A2(Yu, Lt, n.dg)))));
    }, jx = function(n) {
        return fr(wr(n));
    }, qx = A2(ql, y([
        Jl("mdc-notched-outline__leading")
    ]), w), Mx = function(n) {
        return A2(ql, y([
            Jl("mdc-notched-outline__notch")
        ]), y([
            Hx(n)
        ]));
    }, Rx = A2(ql, y([
        Jl("mdc-notched-outline__trailing")
    ]), w), Ox = function(n) {
        return A2(ql, y([
            Jl("mdc-notched-outline")
        ]), y([
            qx,
            Mx(n),
            Rx
        ]));
    }, Dx = function(n) {
        return n ? st(Jl("mdc-text-field--outlined")) : dt;
    }, Fx = function(n) {
        return st(A2(tx, "pattern", A2(_i, zu, A2(Yu, ha, n.fs))));
    }, Vx = Jl("mdc-text-field__affix mdc-text-field__affix--prefix"), Zx = function(n) {
        var r = n.dA;
        if (r.$) return kv("");
        var t = r.a;
        return A2(ql, y([
            Vx
        ]), y([
            kv(t)
        ]));
    }, Gx = function(n) {
        return st(A2(tx, "required", As(n.be)));
    }, Yx = A2(ql, y([
        Jl("mdc-text-field__ripple")
    ]), w), Ux = st(Jl("mdc-text-field")), Qx = function(n) {
        return st(A2(tx, "step", ha(A2(_i, "", A2(Yu, Lt, n.dQ)))));
    }, Jx = Jl("mdc-text-field__affix mdc-text-field__affix--suffix"), Kx = function(n) {
        var r = n.dT;
        if (r.$) return kv("");
        var t = r.a;
        return A2(ql, y([
            Jx
        ]), y([
            kv(t)
        ]));
    }, Wx = function(n) {
        return A2(Ix, "mdc-text-field__icon--trailing", n.cu);
    }, nH = function(n) {
        return st(A2(tx, "valid", As(n.d0)));
    }, rH = function(n) {
        var r = n.bL;
        return A2(Yu, A2(lu, tx("value"), ha), r);
    }, tH = function(n) {
        return a(n.bv, dt) ? dt : st(Jl("mdc-text-field--with-leading-icon"));
    }, eH = function(n) {
        return a(n.cu, dt) ? dt : st(Jl("mdc-text-field--with-trailing-icon"));
    }, uH = F2(function(n, r) {
        var t, e = r.cy;
        return A3(jx, "mdc-text-field", p(A2(Ru, Ne, y([
            Ux,
            (t = r, a(t.bt, dt) ? st(Jl("mdc-text-field--no-label")) : dt),
            ax(n),
            Dx(n),
            ix(r),
            Ax(r),
            cx,
            nx(r),
            tH(r),
            eH(r),
            ux(r),
            rH(r),
            ex(r),
            Gx(r),
            nH(r),
            Fx(r),
            zx(r),
            Cx(r),
            Xx(r),
            Ex(r),
            Qx(r)
        ])), e), y(n ? [
            Tx(r),
            Zx(r),
            xx(r),
            Kx(r),
            Ox(r),
            Wx(r)
        ] : [
            Yx,
            Tx(r),
            Zx(r),
            xx(r),
            Kx(r),
            Hx(r),
            Sx,
            Wx(r)
        ]));
    }), aH = function(n) {
        return A2(uH, !1, n);
    }, cH = st(A2(Yy, "aria-hidden", "true")), iH = st(Jl("mdc-text-field-helper-text")), oH = function(n) {
        return n.d1 ? st(Jl("mdc-text-field-helper-text--validation-msg")) : dt;
    }, fH = F2(function(n, r) {
        var t, e = n.cy;
        return A2(Lv, p(A2(Ru, Ne, y([
            iH,
            (t = n, t.dx ? st(Jl("mdc-text-field-helper-text--persistent")) : dt),
            oH(n),
            cH
        ])), e), y([
            kv(r)
        ]));
    }), sH = {
        $: 0
    }, dH = A2(Lv, y([
        Jl("mdc-linear-progress__buffer-bar")
    ]), w), bH = A2(Lv, y([
        Jl("mdc-linear-progress__buffer-dots")
    ]), w), lH = A2(Lv, y([
        Jl("mdc-linear-progress__buffer")
    ]), y([
        dH,
        bH
    ])), vH = function(n) {
        return st(A2(tx, "buffer", Ps(2 === n.$ ? n.b : 1)));
    }, hH = function(n) {
        return st(A2(tx, "determinate", As(!a(n, sH))));
    }, gH = st(A2(Ml, "display", "block")), $H = A2(Lv, y([
        Jl("mdc-linear-progress__bar-inner")
    ]), w), mH = A2(Lv, y([
        Jl("mdc-linear-progress__bar mdc-linear-progress__primary-bar")
    ]), y([
        $H
    ])), pH = function(n) {
        return st(A2(tx, "progress", Ps(function() {
            switch(n.$){
                case 1:
                case 2:
                    return n.a;
                default:
                    return 0;
            }
        }())));
    }, wH = st(A2(Yy, "role", "progressbar")), kH = st(Jl("mdc-linear-progress")), _H = A2(Lv, y([
        Jl("mdc-linear-progress__bar mdc-linear-progress__secondary-bar")
    ]), y([
        $H
    ])), yH = function(n) {
        return n.$ ? dt : st(Jl("mdc-linear-progress--indeterminate"));
    }, xH = F2(function(n, r) {
        var t, e = r.cy;
        return A3(jx, "mdc-linear-progress", p(A2(Ru, Ne, y([
            kH,
            gH,
            wH,
            yH(n),
            hH(n),
            pH(n),
            vH(n),
            (t = r, st(A2(tx, "closed", As(t.cH))))
        ])), e), y([
            lH,
            mH,
            _H
        ]));
    }), HH = F2(function(n, r) {
        return $(r, {
            cR: n
        });
    }), AH = F2(function(n, r) {
        return $(r, {
            ap: n
        });
    }), PH = F2(function(n, r) {
        return $(r, {
            bt: n
        });
    }), BH = F2(function(n, r) {
        return $(r, {
            dp: st(n)
        });
    }), NH = F2(function(n, r) {
        return $(r, {
            dr: st(n)
        });
    }), LH = F2(function(n, r) {
        return $(r, {
            dx: n
        });
    }), IH = F2(function(n, r) {
        return $(r, {
            bH: n
        });
    }), TH = F2(function(n, r) {
        return $(r, {
            d0: n
        });
    }), SH = F2(function(n, r) {
        return $(r, {
            d1: n
        });
    }), CH = F2(function(n, r) {
        return $(r, {
            bL: n
        });
    }), EH = fr("button"), zH = function(n) {
        return A2(Yu, Nx, n.dp);
    }, XH = function(n) {
        return st(nv(n.ap));
    }, jH = function(n) {
        return A2(Yu, Cl, n.bq);
    }, qH = function(n) {
        return st(A2(ql, y([
            Jl("mdc-button__label")
        ]), y([
            kv(n)
        ])));
    }, MH = function(n) {
        var r = n;
        return A2(Yu, t_(Ve), function() {
            var n = r.c5;
            if (n.$) return dt;
            if (n.a.$) return t = n.a.a.cg, e = n.a.a.bP, st(A2(n.a.a.cf, A2(bt, Px("mdc-button__icon"), A2(bt, A2(Yy, "aria-hidden", "true"), e)), t));
            var t = n.a.a.cg, e = n.a.a.bP;
            return st(A2(n.a.a.cf, A2(bt, Jl("mdc-button__icon"), A2(bt, A2(Yy, "aria-hidden", "true"), e)), t));
        }());
    }, RH = function(n) {
        return n.cu ? dt : MH(n);
    }, OH = function(n) {
        var r = n.ch;
        return A2(Yu, A2(lu, sx("MDCMenuSurface:close"), Pe), r);
    }, DH = {
        cy: w,
        cC: !1,
        cR: !1,
        b7: !0,
        cm: !0,
        d_: !1,
        iO: !1,
        d6: !1
    }, FH = function(n) {
        return n.cC ? st(Jl("mdc-deprecated-list--avatar-list")) : dt;
    }, VH = function(n) {
        var r = function(n) {
            return 0 === n.$ ? st(n.b.dp) : dt;
        }, t = A2(ye, function(t) {
            var e = function(t) {
                return A2(ju, Ne, Gu(A2(vh, t, A2(Ru, Ne, A2(Qe, r, n)))));
            }(t);
            return e.$ ? Eu("") : Pe(e.a);
        }, A2(li, y([
            "detail",
            "index"
        ]), Mo));
        return st(A2(sx, "MDCList:action", t));
    }, ZH = function(n) {
        return st(A2(tx, "interactive", As(n.b7)));
    }, GH = st(Jl("mdc-deprecated-list")), YH = function(n) {
        var r = A2(Ru, Ne, A2(qt, F2(function(n, r) {
            return 0 === r.$ ? a(r.b.im, dt) ? dt : st(n) : dt;
        }), A2(ei, function(n) {
            return 0 === n.$;
        }, n)));
        return st(A2(tx, "selectedIndex", A2(Po, ls, r)));
    }, UH = function(n) {
        return n.d_ ? st(Jl("mdc-deprecated-list--two-line")) : dt;
    }, QH = function(n) {
        return st(A2(tx, "wrapFocus", As(n.d6)));
    }, JH = F3(function(n, r, t) {
        var e, u = n.cy, a = n.b7, c = n.cm, i = A2(bt, r, t);
        return A3(jx, "mdc-list", p(A2(Ru, Ne, y([
            GH,
            (e = n, e.cR ? st(Jl("mdc-deprecated-list--dense")) : dt),
            FH(n),
            UH(n),
            QH(n),
            VH(i),
            YH(i),
            ZH(n)
        ])), u), A2(Qe, function(n) {
            return 0 === n.$ ? (0, n.a)($(n.b, {
                cm: c && a
            })) : n.a;
        }, i));
    }), KH = function(n) {
        return st(A2(tx, "quickOpen", As(n.dE)));
    }, WH = st(Jl("mdc-menu mdc-menu-surface")), nA = F2(function(n, r) {
        return $(r, {
            cm: n
        });
    }), rA = F2(function(n, r) {
        return $(r, {
            d6: n
        });
    }), tA = F3(function(n, r, t) {
        var e, u = n.cy;
        return A3(jx, "mdc-menu", p(A2(Ru, Ne, y([
            WH,
            (e = n, st(A2(tx, "open", As(e.ds)))),
            KH(n),
            OH(n)
        ])), u), y([
            A3(JH, A2(rA, !0, A2(nA, !1, DH)), r, t)
        ]));
    }), eA = st(A2(Lv, y([
        Jl("mdc-button__ripple")
    ]), w)), uA = st(Jl("mdc-button")), aA = function(n) {
        return st(A2(tx, "tabIndex", ls(n.ap ? -1 : 0)));
    }, cA = function(n) {
        var r = n.dW;
        return a(n.bq, dt) ? dt : A2(Yu, Dl, r);
    }, iA = function(n) {
        return n.bH ? st(Jl("mdc-button--touch")) : dt;
    }, oA = function(n) {
        return n.bH ? st(A2(Lv, y([
            Jl("mdc-button__touch")
        ]), w)) : dt;
    }, fA = function(n) {
        return n.cu ? MH(n) : dt;
    }, sA = function(n) {
        switch(n){
            case 0:
                return dt;
            case 1:
                return st(Jl("mdc-button--raised"));
            case 2:
                return st(Jl("mdc-button--unelevated"));
            default:
                return st(Jl("mdc-button--outlined"));
        }
    }, dA = F3(function(n, r, t) {
        var e, u, c = r, i = c.ap, o = c.bH, f = c.cy;
        return function(n) {
            var r = c.hP;
            if (1 === r.$) return n;
            var t = r.a, e = t.a, u = t.b, a = t.c;
            return A2(Lv, y([
                Jl("mdc-menu-surface--anchor")
            ]), y([
                n,
                A3(tA, e, u, a)
            ]));
        }((e = A3(jx, "mdc-button", w, y([
            A2(a(c.bq, dt) || i ? EH : Tl, p(A2(Ru, Ne, y([
                uA,
                sA(n),
                (u = r, u.cR ? st(Jl("mdc-button--dense")) : dt),
                iA(r),
                XH(r),
                aA(r),
                jH(r),
                cA(r),
                zH(r)
            ])), f), A2(Ru, Ne, y([
                eA,
                RH(r),
                qH(t),
                fA(r),
                oA(r)
            ])))
        ])), o ? A2(Lv, y([
            Jl("mdc-touch-target-wrapper")
        ]), y([
            e
        ])) : e));
    }), bA = F2(function(n, r) {
        return A3(dA, 2, n, r);
    }), lA = A2(lu, A2(ma, function(n) {
        return y([
            A2(vv, w, y([
                kv(n)
            ]))
        ]);
    }, Ne), Yk), vA = F2(function(n, r) {
        var t, e = F2(function(n, r) {
            var t = n.aS;
            return Lv(p(y([
                Jl("login"),
                A2(Yy, "style", Uy(t.eq))
            ]), r));
        });
        switch(r.c.$){
            case 1:
                var u = r.a, c = r.c.a, i = "" === Pb(c.cT) || c.db, o = ld(c.aS.hJ);
                return A3(e, c, w, y([
                    A2(Lv, y([
                        Jl("login__before")
                    ]), lA(A3(Cv, {
                        gX: o,
                        e: A2(_i, o, u.e)
                    }, "", c.aD.ec))),
                    A2(Lv, y([
                        Jl("login__form")
                    ]), y([
                        aH(A2(TH, pd(c.cX), A2(NH, Fy, A2(CH, st(c.cT), A2(PH, st("E-Mail-Adresse"), Wy))))),
                        A2(Lv, y([
                            Jl("mdc-text-field-helper-line")
                        ]), y([
                            A2(fH, A2(LH, !0, A2(SH, !0, Jy)), A3(no, "", function() {
                                return "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut.";
                            }, c.cX))
                        ])),
                        A2(bA, A2(BH, Vy, A2(AH, i, A2(IH, !0, A2(HH, !0, Qy)))), "Anmelden")
                    ])),
                    A2(Lv, y([
                        Jl("login__after")
                    ]), lA(A3(Cv, {
                        gX: o,
                        e: A2(_i, o, u.e)
                    }, "", c.aD.d9)))
                ]));
            case 3:
                u = r.a;
                var f = r.c.a, s = Pb(f.cT);
                return o = ld(f.aS.hJ), i = !a(Pb(f.gG), s) || f.db, A3(e, f, w, y([
                    A2(Lv, y([
                        Jl("login__before")
                    ]), lA(A3(Cv, {
                        gX: o,
                        e: A2(_i, o, u.e)
                    }, "", f.aD.ec))),
                    A2(Lv, y([
                        Jl("login__form")
                    ]), y([
                        aH(A2(TH, pd(f.cX), A2(CH, st(f.cT), A2(PH, st("E-Mail-Adresse"), Wy)))),
                        A2(Yl, w, w),
                        aH(A2(TH, pd(f.cX), A2(NH, Dy, A2(CH, st(f.gG), A2(PH, st("E-Mail-Adresse best\xe4tigen"), Wy))))),
                        A2(Lv, y([
                            Jl("mdc-text-field-helper-line")
                        ]), y([
                            A2(fH, A2(LH, !0, A2(SH, !0, Jy)), A3(no, "", function() {
                                return "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut.";
                            }, f.cX))
                        ])),
                        A2(bA, A2(BH, Zy, A2(AH, i, A2(IH, !0, A2(HH, !0, Qy)))), "Anmelden")
                    ])),
                    A2(Lv, y([
                        Jl("login__after")
                    ]), lA(A3(Cv, {
                        gX: o,
                        e: A2(_i, o, u.e)
                    }, "", f.aD.d9)))
                ]));
            case 2:
                u = r.a;
                var d = r.c.a;
                return o = ld(d.aS.hJ), A3(e, d, w, y([
                    A2(lv, w, y([
                        kv(A3(Cv, {
                            gX: o,
                            e: A2(_i, o, u.e)
                        }, "", qf(function(n) {
                            return 1 === n ? "Please follow the link in the email to complete your authentication." : "Bitte folgen Sie dem Link in der E-Mail um die Authentifizierung abzuschlie\xdfen.";
                        })))
                    ])),
                    A2(lv, w, y([
                        kv(A3(Cv, {
                            gX: o,
                            e: A2(_i, o, u.e)
                        }, "", qf(function(n) {
                            return 1 === n ? "An email has been sent to" : "Es wurde eine E-Mail an ";
                        }))),
                        A2($v, w, y([
                            kv(d.cT)
                        ])),
                        kv(A3(Cv, {
                            gX: o,
                            e: A2(_i, o, u.e)
                        }, "", qf(function(n) {
                            return 1 === n ? ". You can close this window." : " versendet. Dieses Fenster kann geschlossen werden.";
                        })))
                    ]))
                ]));
            case 4:
                u = r.a;
                var b = r.c.a;
                return o = ld(b.aS.hJ), A3(e, b, y([
                    Jl("login--form")
                ]), y([
                    A2(lv, w, y([
                        kv(A3(Cv, {
                            gX: o,
                            e: A2(_i, o, u.e)
                        }, "", qf(function(n) {
                            return 1 === n ? "Logging in.." : "Sie werden angemeldet..";
                        })))
                    ])),
                    (t = Ky, A2(xH, sH, t))
                ]));
            case 5:
                return u = r.a, A2(t_, tb, n(r.c.a));
            default:
                return u = r.a, kv("");
        }
    }), hA = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gA = fr("details"), $A = function(n) {
        switch(n.$){
            case 1:
                return "decode error: " + Ut(n.a);
            case 2:
                return "http error: " + function(n) {
                    switch(n.$){
                        case 0:
                            return "bad url: " + n.a;
                        case 1:
                            return "timeout";
                        case 2:
                            return "network error";
                        case 3:
                            return "bad status: " + Lt(n.a);
                        default:
                            return "bad body: " + n.a;
                    }
                }(n.a);
            case 3:
                return "markdown error: " + n.a;
            default:
                return n.a;
        }
    }, mA = fr("summary"), pA = function(n) {
        return A2(Lv, y([
            Jl("error-view")
        ]), y([
            A3(ma, function(n) {
                return A2(vv, w, y([
                    kv(n)
                ]));
            }, Lv(w), Yk(A3(Cv, n, "", qf(function(n) {
                switch(n){
                    case 0:
                        return "\n# Technischer Fehler\n\nLeider ist ein unerwarteter Fehler aufgetreten.\n";
                    case 1:
                        return "\n# Technical error\n\nUnfortunately, we have encountered an unexpected error.\n";
                    case 2:
                        return '\n# Error t\xe9cnico\n\nDesafortunadamente, se ha producido un error inesperado."\n';
                    case 3:
                        return "\nErreur technique\n\nUne erreur inattendue est malheureusement survenue.\n";
                    default:
                        return "\n\u0421\u0431\u043E\u0439 \u0432 \u0440\u0430\u0431\u043E\u0442\u0435 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F\n\n\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043C\u044B \u0441\u0442\u043E\u043B\u043A\u043D\u0443\u043B\u0438\u0441\u044C \u0441 \u043D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u043D\u043E\u0439 \u043E\u0448\u0438\u0431\u043A\u043E\u0439.\n";
                }
            })))),
            A2(gA, w, y([
                A2(mA, w, y([
                    kv(A3(Cv, n, "", qf(function(n) {
                        switch(n){
                            case 0:
                                return "Technische Details";
                            case 1:
                                return "Technical details";
                            case 2:
                                return "Detalles t\xe9cnicos";
                            case 3:
                                return "D\xe9tails techniques";
                            default:
                                return "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0441\u0442\u0438";
                        }
                    })))
                ])),
                A2(vv, w, y([
                    kv($A(n.cX))
                ]))
            ])),
            A3(ma, function(n) {
                return A2(vv, w, y([
                    kv(n)
                ]));
            }, Lv(w), Yk(A3(Cv, n, "", qf(function(n) {
                switch(n){
                    case 0:
                        return "\nBei Fragen zur Registrierung stehen wir Ihnen gern unter den folgenden Kontaktdaten zur Verf\xfcgung:\n\nFrau Shaira Quihano - Telefon: [+49(0)511 898813-16](tel:+49511898813-16) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    case 1:
                        return "\nPlease do not hesitate to contact us in case of any further questions regarding your registration.\n\nPhone: [+49(0)511 898813-0](tel:+49511898813-0) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    case 2:
                        return "\nSi tiene alguna pregunta sobre la inscripci\xf3n, no dude en ponerse en contacto con nosotros utilizando los siguientes datos de contacto:\n\nTel\xe9fono: [+49(0)511 898813-0](tel:+49511898813-0) - Correo electr\xf3nico: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    case 3:
                        return "\nSi vous avez des questions concernant l'enregistrement, n'h\xe9sitez pas \xe0 nous contacter aux coordonn\xe9es suivantes:\n\nT\xe9l.: [+49(0)511 898813-0](tel:+49511898813-0) - E-mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                    default:
                        return "\n\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u0430\u0448\u0435\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u043E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u043A \u043D\u0430\u043C:\n\n\u0413-\u0436\u0430 \u0421\u0430\u043D\u0434\u0440\u0438\u043D\u0435 \u0427\u0435\u0445, \u0442\u0435\u043B\u0435\u0444\u043E\u043D: [+49(0)511 898813-0](tel:+49511 898813-0) - \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                }
            }))))
        ]));
    }, wA = (Ck = Bv, $(Ck, {
        hk: function(n) {
            var r = n.gy;
            switch(n.hF){
                case 0:
                    return A2(tv, y([
                        Jl("form-field form-field--full-width")
                    ]), r);
                case 1:
                    return A2(ev, y([
                        Jl("form-field form-field--full-width")
                    ]), r);
                case 2:
                    return A2(uv, y([
                        Jl("form-field form-field--full-width")
                    ]), r);
                case 3:
                    return A2(av, y([
                        Jl("form-field form-field--full-width")
                    ]), r);
                case 4:
                    return A2(cv, y([
                        Jl("form-field form-field--full-width")
                    ]), r);
                default:
                    return A2(iv, y([
                        Jl("form-field form-field--full-width")
                    ]), r);
            }
        },
        fr: lv(y([
            Jl("form-field form-field--full-width")
        ]))
    })), kA = function(n) {
        return {
            $: 11,
            a: n
        };
    }, _A = {
        $: 10
    }, yA = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xA = {
        $: 12
    }, HA = {
        cy: w,
        g3: !0,
        b3: !1,
        ch: dt,
        ds: !1,
        dK: !0
    }, AA = function(n) {
        var r = n.ch;
        return A2(Yu, A2(lu, sx("MDCDialog:close"), Pe), r);
    }, PA = A2(Yy, "role", "alertdialog"), BA = A2(Yy, "aria-modal", "true"), NA = function(n) {
        var r = n.bY;
        return st(A2(Lv, y([
            Jl("mdc-dialog__content")
        ]), r));
    }, LA = Jl("mdc-dialog__surface"), IA = {
        cy: w,
        ap: !1,
        bq: dt,
        bt: dt,
        hP: dt,
        dp: dt,
        dW: dt
    }, TA = F3(function(n, r, t) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            bP: r,
            cf: n,
            cg: t
        });
    }), SA = fr("i"), CA = function(n) {
        return A2(Yu, Nx, n.dp);
    }, EA = function(n) {
        return st(nv(n.ap));
    }, zA = st(Jl("mdc-icon-button")), XA = Jl("mdc-menu-surface--anchor"), jA = function(n) {
        var r = n.dW;
        return a(n.bq, dt) ? dt : A2(Yu, Dl, r);
    }, qA = F2(function(n, r) {
        var t, e = n, u = e.ap, c = e.cy;
        return function(n) {
            var r = e.hP;
            if (1 === r.$) return n;
            var t = r.a, u = t.a, a = t.b, c = t.c;
            return A2(Lv, y([
                XA
            ]), y([
                n,
                A3(tA, u, a, c)
            ]));
        }(A3(jx, "mdc-icon-button", w, y([
            A2(a(e.bq, dt) || u ? EH : Tl, p(A2(Ru, Ne, y([
                zA,
                (t = n, A2(Yu, Cl, t.bq)),
                jA(n),
                EA(n),
                CA(n)
            ])), c), y([
                A2(t_, Ve, function() {
                    if (r.$) return n = r.a.cg, t = r.a.bP, A2(r.a.cf, A2(bt, Px("mdc-icon-button__icon"), t), n);
                    var n = r.a.cg, t = r.a.bP;
                    return A2(r.a.cf, A2(bt, Jl("mdc-icon-button__icon"), t), n);
                }())
            ]))
        ])));
    }), MA = F2(function(n, r) {
        return $(r, {
            dp: st(n)
        });
    }), RA = function(n) {
        var r = n.iG;
        if (r.$) return dt;
        var t = r.a;
        return st(A2(Lv, y([
            Jl("mdc-dialog__title")
        ]), y([
            kv(t)
        ])));
    }, OA = F2(function(n, r) {
        var t = n.ch;
        return st(A2(Lv, y([
            Jl("mdc-dialog__header")
        ]), A2(Ru, Ne, y([
            RA(r),
            st(A2(Lv, y([
                Jl("mdc-dialog__close"),
                A2(Ml, "position", "relative")
            ]), y([
                A2(qA, (t.$ ? Ne : MA(t.a))(IA), A3(TA, SA, y([
                    Jl("material-icons")
                ]), y([
                    kv("close")
                ])))
            ])))
        ]))));
    }), DA = F2(function(n, r) {
        var t, e, u = n;
        return A2(Lv, y([
            LA,
            PA,
            BA
        ]), A2(Ru, Ne, y([
            u.b3 ? A2(OA, n, r) : RA(r),
            NA(r),
            (t = r, e = t.gm, zl(e) ? dt : st(A2(Lv, y([
                Jl("mdc-dialog__actions")
            ]), e)))
        ])));
    }), FA = F2(function(n, r) {
        return A2(Lv, y([
            Jl("mdc-dialog__container")
        ]), y([
            A2(DA, n, r)
        ]));
    }), VA = function(n) {
        return st(A2(tx, "open", As(n.ds)));
    }, ZA = st(Jl("mdc-dialog")), GA = function(n) {
        return st(A2(tx, "scrimClickAction", ha(n.dK ? "close" : "")));
    }, YA = A2(Lv, y([
        Jl("mdc-dialog__scrim")
    ]), w), UA = F2(function(n, r) {
        var t, e = n.cy;
        return A3(jx, "mdc-dialog", p(A2(Ru, Ne, y([
            ZA,
            (t = n, t.b3 ? st(Jl("mdc-dialog--fullscreen")) : dt),
            VA(n),
            GA(n),
            AA(n)
        ])), e), y([
            A2(FA, n, r),
            YA
        ]));
    }), QA = F2(function(n, r) {
        return A2(UA, n, {
            gm: r.gm,
            bY: r.bY,
            iG: st(r.iG)
        });
    }), JA = A2(Yy, "data-mdc-dialog-button-default", ""), KA = function(n) {
        return n.a;
    }, WA = function(n) {
        return 964 > n ? 1 : 0;
    }, nP = A2(no, 0, WA), rP = function(n) {
        return !n.$;
    }, tP = {
        cy: w,
        ap: !1,
        bq: dt,
        b7: !1,
        dp: dt,
        cm: !1,
        im: dt,
        dW: dt
    }, eP = Jl("mdc-theme--error"), uP = Jl("mdc-deprecated-list-group"), aP = F2(function(n, r) {
        return A2(Lv, A2(bt, uP, n), r);
    }), cP = F2(function(n, r) {
        return A3(Ue, F2(function(r, t) {
            if (t.b) {
                var e = t.a, u = e.a, a = e.b, c = t.b;
                return A2(n, r, u) ? A2(bt, h(r, A2(bt, u, a)), c) : A2(bt, h(r, w), t);
            }
            return y([
                h(r, w)
            ]);
        }), w, r);
    }), iP = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), oP = function(n) {
        return a(n.im, st(1)) ? st(Jl("mdc-deprecated-list-item--activated")) : dt;
    }, fP = function(n) {
        return a(n.im, dt) ? dt : st(A2(Yy, "aria-selected", "true"));
    }, sP = function(n) {
        return n.ap ? st(Jl("mdc-deprecated-list-item--disabled")) : dt;
    }, dP = function(n) {
        return A2(tx, "interactive", As(n.b7));
    }, bP = st(Jl("mdc-deprecated-list-item")), lP = A2(ql, y([
        Jl("mdc-deprecated-list-item__ripple")
    ]), w), vP = function(n) {
        return a(n.im, st(0)) ? st(Jl("mdc-deprecated-list-item--selected")) : dt;
    }, hP = function(n) {
        var r = n.dW;
        return a(n.bq, dt) ? dt : A2(Yu, Dl, r);
    }, gP = F2(function(n, r) {
        var t, e = n.bq, u = n.cy;
        return A2(F2(function(r, t) {
            var u;
            return A3(jx, "mdc-list-item", p(y([
                (u = n, A2(tx, "ripples", As(u.cm))),
                dP(n)
            ]), a(e, dt) ? r : w), a(e, dt) ? t : y([
                A2(Tl, r, t)
            ]));
        }), p(A2(Ru, Ne, y([
            bP,
            (t = n, A2(Yu, Cl, t.bq)),
            hP(n),
            sP(n),
            vP(n),
            oP(n),
            fP(n)
        ])), u), A2(bt, lP, r));
    }), $P = F2(function(n, r) {
        return A2(iP, function(n) {
            return A2(gP, n, r);
        }, n);
    }), mP = F2(function(n, r) {
        var t = r.b;
        return h(n(r.a), A2(Qe, n, t));
    }), pP = F2(function(n, r) {
        var t = r.b;
        return a(n, r.a) || A2(ii, n, t);
    }), wP = fr("nav"), kP = F2(function(n, r) {
        return $(r, {
            dp: st(n)
        });
    }), _P = F2(function(n, r) {
        return $(r, {
            im: n
        });
    }), yP = Jl("mdc-deprecated-list-group__subheader"), xP = F2(function(n, r) {
        return A2(ql, A2(bt, yP, n), r);
    }), HP = qf(function(n) {
        switch(n){
            case 0:
                return "Zusammenfassung";
            case 1:
                return "Summary";
            case 2:
                return "Resumen";
            case 3:
                return "R\xe9capitulatif";
            default:
                return "\u041A\u0440\u0430\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435";
        }
    }), AP = function(n) {
        var r = n.b;
        switch(r.$){
            case 0:
            case 1:
            case 2:
            case 3:
            default:
                return w;
            case 4:
                return y([
                    r.a
                ]);
            case 5:
                return A2(id, AP, r.b);
            case 6:
                return A2(id, AP, r.a.a4);
            case 7:
                return y([
                    A2(lh, function() {
                        return Bt("## ");
                    }, HP)
                ]);
        }
    }, PP = F2(function(n, r) {
        var t = r.a.bc, e = A2(Gk, {
            g9: A2(Ev, F2(function(n, r) {
                return 4 === n.$ && 1 === n.a ? p(r, y([
                    A2(Sh, t ? 3 : 2, n.b)
                ])) : r;
            }), w),
            ie: {
                gt: function() {
                    return "";
                },
                gC: function() {
                    return "";
                },
                gD: function() {
                    return "";
                },
                g1: function() {
                    return "";
                },
                hi: "",
                hk: function(n) {
                    return n.ia;
                },
                hq: jl(w),
                ht: function() {
                    return "";
                },
                hH: F2(function() {
                    return "";
                }),
                h1: F2(function() {
                    return "";
                }),
                fr: function() {
                    return "";
                },
                iq: function() {
                    return "";
                },
                ir: function() {
                    return "";
                },
                iu: function() {
                    return "";
                },
                iv: function() {
                    return "";
                },
                iw: F2(function() {
                    return "";
                }),
                ix: function() {
                    return "";
                },
                iy: F2(function() {
                    return "";
                }),
                iz: function() {
                    return "";
                },
                iA: function(n) {
                    return n;
                },
                iB: "",
                iJ: function() {
                    return "";
                }
            }
        }, Ha(A2(Pa, "\n\n", A2(Ru, Sv(n), A2(id, AP, r.b)))));
        return e.$ ? e.a : Ha(e.a);
    }), BP = F2(function(n, r) {
        return A2(n, r.a, r.b);
    }), NP = F7(function(n, r, t, e, u, c, i) {
        var o = A3(JH, DH, A2($P, A2(kP, dt, tP), y([
            A2(Lv, y([
                Jl("menu-item__text")
            ]), y([
                kv(A3(Cv, n, "", qf(function(n) {
                    return 1 === n ? "Log out" : "Abmelden";
                })))
            ]))
        ])), w), f = function(r) {
            var t = r.h2, e = r.cL.b$, u = A2(Y_, e, i.d2.cn) && A3(no, !1, A2(lu, pP(e), mP(function(n) {
                return n.fd;
            })), c);
            return A2($P, A2(kP, st(e), A2(_P, a(e, i.d2.b0) ? st(1) : dt, tP)), y([
                A2(Lv, y([
                    Jl("menu-item__text")
                ]), (u ? A2(lu, hv, ql(y([
                    eP
                ]))) : Ne)(y([
                    kv(A2(PP, n, t))
                ])))
            ]));
        }, s = dd(r);
        return A2(wP, y([
            Jl("menu")
        ]), y([
            A2(aP, w, p(A2(id, function(n) {
                var r = n.a, t = n.b;
                return (r.h2.a.bc ? bt(A2(xP, w, y([
                    kv(A3(no, "", Wk, A2(Si, r.cL.b$.gN, i.d2.h0.dy)))
                ]))) : Ne)(y([
                    A2(BP, JH(DH), A2(Ho, f(r), A2(Qe, f, t)))
                ]));
            }, A2(cP, F2(function(n, r) {
                var t = function(n) {
                    return n.h2.a.bc;
                }, e = F4(function(n, r, t, e) {
                    return A2(e, n(r), n(t));
                }), u = function(n) {
                    return n.cL.b$.gN;
                };
                return A4(e, t, n, r, oe) && A4(e, u, n, r, oe);
            }), A3(A_, s, i, r))), y([
                o
            ])))
        ]));
    }), LP = {
        cy: w,
        ch: dt,
        ds: !1,
        dE: !1
    }, IP = function(n) {
        return A2(lu, A2(lu, oi, ei(n)), No);
    }, TP = F3(function(n, r, t) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            bP: r,
            cf: n,
            cg: t
        });
    }), SP = F2(function(n, r) {
        return $(r, {
            c5: n
        });
    }), CP = F2(function(n, r) {
        return $(r, {
            ch: st(n)
        });
    }), EP = F2(function(n, r) {
        return $(r, {
            ds: n
        });
    }), zP = F6(function(n, r, t, e, u, c) {
        var i = n.bA, o = A2($P, A2(kP, xt(dt), tP), y([
            A2(Lv, y([
                Jl("menu-item__text")
            ]), y([
                kv(A3(Cv, n, "", qf(function(n) {
                    return 1 === n ? "Log out" : "Abmelden";
                })))
            ]))
        ])), f = function(r) {
            var t = r.h2, e = r.cL.b$, i = A2(Y_, e, c.d2.cn) && A3(no, !1, A2(lu, pP(e), mP(function(n) {
                return n.fd;
            })), u);
            return A2($P, A2(kP, xt(st(e)), A2(_P, a(e, c.d2.b0) ? st(1) : dt, tP)), y([
                A2(Lv, y([
                    Jl("menu-item__text")
                ]), (i ? A2(lu, hv, ql(y([
                    eP
                ]))) : Ne)(y([
                    kv(A2(PP, n, t))
                ])))
            ]));
        }, s = dd(r), d = A3(A_, s, c, r), b = A2(Yu, function(n) {
            return n.h2;
        }, A2(Gb, function(n) {
            return a(n.cL.b$, c.d2.b0);
        }, d));
        return A3(no, kv(""), function(r) {
            return A2(Lv, y([
                Jl("mobile-menu"),
                XA
            ]), y([
                A2(bA, A2(HH, !0, A2(SP, st(A3(TP, SA, y([
                    Jl("material-icons")
                ]), y([
                    kv("menu")
                ]))), A2(BH, wt(!0), Qy))), A3(no, "Navigation", A2(lu, Bt("Navigation: "), PP(n)), b)),
                A2(BP, tA(A2(CP, wt(!1), A2(EP, i, LP))), r)
            ]));
        }, oi(p(A2(id, function(n) {
            var r, t, e, i, o = n.a, s = n.b;
            return (o.h2.a.bc ? bt((t = A2(Si, (r = o.cL.b$).gN, c.d2.h0.dy), i = !!A2(Y_, e = r, c.d2.cn) && !u.$ && 1 !== A2(IP, function(n) {
                return a(n.fd, e);
            }, u.a).$, A2($P, A2(kP, xt(st(e)), A2(_P, a(e, c.d2.b0) ? st(1) : dt, tP)), y([
                A2(Lv, y([
                    Jl("menu-item__text")
                ]), (i ? A2(lu, hv, ql(y([
                    eP
                ]))) : Ne)(y([
                    kv(A3(no, "", Wk, t))
                ])))
            ])))) : Ne)(A2(bt, f(o), A2(Qe, f, s)));
        }, A2(cP, F2(function(n, r) {
            var t = function(n) {
                return n.h2.a.bc;
            }, e = F4(function(n, r, t, e) {
                return A2(e, n(r), n(t));
            }), u = function(n) {
                return n.cL.b$.gN;
            };
            return A4(e, t, n, r, oe) && A4(e, u, n, r, oe);
        }), d)), y([
            o
        ]))));
    }), XP = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), jP = F2(function(n, r) {
        return $(r, {
            ch: st(n)
        });
    }), qP = F2(function(n, r) {
        return $(r, {
            ds: n
        });
    }), MP = F2(function(n, r) {
        return A3(dA, 0, n, r);
    }), RP = function(n) {
        return {
            $: 1,
            a: n
        };
    }, OP = {
        $: 5
    }, DP = function(n) {
        return {
            $: 4,
            a: n
        };
    }, FP = yr, VP = function(n) {
        return sr(wr(n));
    }, ZP = hr("d"), GP = hr("fill"), YP = or("http://www.w3.org/2000/svg"), UP = YP("path"), QP = YP("svg"), JP = hr("viewBox"), KP = A2(Lv, y([
        Jl("mdc-checkbox__background")
    ]), y([
        A2(QP, y([
            Px("mdc-checkbox__checkmark"),
            JP("0 0 24 24")
        ]), y([
            A2(UP, y([
                Px("mdc-checkbox__checkmark-path"),
                GP("none"),
                ZP("M1.73,12.91 8.1,19.28 22.79,4.59")
            ]), w)
        ])),
        A2(Lv, y([
            Jl("mdc-checkbox__mixedmark")
        ]), w)
    ])), WP = function(n) {
        return st(A2(tx, "checked", As(a(n.co, st(1)))));
    }, nB = function(n) {
        return st(A2(tx, "disabled", As(n.ap)));
    }, rB = function(n) {
        return st(A2(tx, "indeterminate", As(a(n.co, st(2)))));
    }, tB = function(n) {
        var r;
        return A2(sv, A2(Ru, Ne, y([
            st(Hv("checkbox")),
            st(Jl("mdc-checkbox__native-control")),
            WP(n),
            rB(n),
            (r = n, A2(Yu, function(n) {
                return A2(sx, "change", Pe(n));
            }, r.$7))
        ])), w);
    }, eB = A2(Lv, y([
        Jl("mdc-checkbox__ripple")
    ]), w), uB = st(Jl("mdc-checkbox")), aB = function(n) {
        var r, t, e = n.cy, u = n.bH;
        return r = A3(jx, "mdc-checkbox", p(A2(Ru, Ne, y([
            uB,
            (t = n, t.bH ? st(Jl("mdc-checkbox--touch")) : dt),
            WP(n),
            rB(n),
            nB(n)
        ])), e), y([
            tB(n),
            KP,
            eB
        ])), u ? A2(Lv, y([
            Jl("mdc-touch-target-wrapper")
        ]), y([
            r
        ])) : r;
    }, cB = function(n) {
        return Jl(A2(It, " ", A2(Qe, ge, A2(ei, Ws, n))));
    }, iB = {
        cy: w,
        ap: !1,
        $7: dt,
        co: dt,
        bH: !0
    }, oB = {
        cy: w,
        cH: !1,
        c2: !1,
        bt: dt,
        dO: 0
    }, fB = {
        cy: w,
        cz: !1,
        c0: dt,
        bt: dt,
        dp: dt
    }, sB = {
        cy: w,
        aG: !1,
        ap: !1,
        $7: dt,
        bH: !0
    }, dB = {
        cy: w,
        ap: !1,
        bt: dt,
        bv: dt,
        $7: dt,
        be: !1,
        dM: dt,
        d0: !0
    }, bB = function(n) {
        return {
            cy: w,
            ap: !1,
            bL: n.bL
        };
    }, lB = F3(function(n, r, t) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            bP: r,
            ap: !1,
            cf: n,
            cg: t,
            fn: dt
        });
    }), vB = A3(mi, "dataURL", va, A3(mi, "lastModified", A2(He, Wa, Mo), A3(mi, "type", va, A3(mi, "size", Mo, A3(mi, "name", va, Pe(T_)))))), hB = Sl("htmlFor"), gB = function(n) {
        return A2(Yu, Nx, n.dp);
    }, $B = fr("label"), mB = function(n) {
        var r, t = n.bt;
        return A2($B, A2(Ru, Ne, y([
            (r = n, A2(Yu, hB, r.c0)),
            gB(n)
        ])), y([
            kv(A2(_i, "", t))
        ]));
    }, pB = st(Jl("mdc-form-field")), wB = F2(function(n, r) {
        var t, e = n.cy;
        return A3(jx, "mdc-form-field", p(A2(Ru, Ne, y([
            pB,
            (t = n, t.cz ? st(Jl("mdc-form-field--align-end")) : dt)
        ])), e), p(r, y([
            mB(n)
        ])));
    }), kB = F2(function(n, r) {
        return A2(Si, n, r);
    }), _B = function(n) {
        var r = n.iN;
        return A2(Lv, y([
            Jl("mdc-text-field-helper-line")
        ]), y([
            A2(fH, A2(SH, !0, A2(LH, !0, Jy)), A3(no, "", function(n) {
                return n.cY;
            }, r))
        ]));
    }, yB = Sl("id"), xB = st(A2(Yy, "aria-value-max", "1")), HB = st(A2(Yy, "aria-value-min", "0")), AB = function(n) {
        return A2(Yu, A2(lu, A2(lu, Yy("aria-value-now"), Qv), function(n) {
            return n.dD;
        }), n);
    }, PB = function(n) {
        return st(A2(tx, "closed", As(n.cH)));
    }, BB = function(n) {
        return Px(a(n, dt) ? "mdc-circular-progress__indeterminate-circle" : "mdc-circular-progress__determinate-circle");
    }, NB = YP("circle"), LB = hr("cx"), IB = function(n) {
        var r = n.dO;
        return LB(function() {
            switch(r){
                case 0:
                    return "24";
                case 1:
                    return "16";
                default:
                    return "12";
            }
        }());
    }, TB = hr("cy"), SB = function(n) {
        var r = n.dO;
        return TB(function() {
            switch(r){
                case 0:
                    return "24";
                case 1:
                    return "16";
                default:
                    return "12";
            }
        }());
    }, CB = hr("r"), EB = function(n) {
        var r = n.dO;
        return CB(function() {
            switch(r){
                case 0:
                    return "18";
                case 1:
                    return "12.5";
                default:
                    return "8.75";
            }
        }());
    }, zB = hr("stroke-dasharray"), XB = hr("stroke-dashoffset"), jB = F2(function(n, r) {
        var t = r.dO;
        return A3(lu, XB, Qv, function() {
            var r = h(n, t);
            if (r.a.$) switch(r.b){
                case 0:
                    return 56.549;
                case 1:
                    return 39.27;
                default:
                    return 27.489;
            }
            else switch(r.b){
                case 0:
                    return 113.097;
                case 1:
                    return 78.54;
                default:
                    return 54.978;
            }
        }());
    }), qB = F4(function(n, r, t, e) {
        var u, a;
        return A2(NB, p(y([
            IB(e),
            SB(e),
            EB(e),
            (u = e, a = u.dO, A3(lu, zB, Qv, function() {
                switch(a){
                    case 0:
                        return 113.097;
                    case 1:
                        return 78.54;
                    default:
                        return 54.978;
                }
            }())),
            A2(jB, t, e),
            n(e)
        ]), A2(Ru, Ne, y([
            A2(Yu, ie(t), r)
        ]))), w);
    }), MB = hr("stroke-width"), RB = function(n) {
        var r = n.dO;
        return A3(lu, MB, Qv, function() {
            switch(r){
                case 0:
                    return 4;
                case 1:
                    return 3;
                default:
                    return 2.5;
            }
        }());
    }, OB = Px("mdc-circular-progress__determinate-track"), DB = function(n) {
        return A2(NB, y([
            OB,
            IB(n),
            SB(n),
            EB(n),
            RB(n)
        ]), w);
    }, FB = function(n) {
        var r = n.dO;
        return JP(function() {
            switch(r){
                case 0:
                    return "0 0 48 48";
                case 1:
                    return "0 0 32 32";
                default:
                    return "0 0 24 24";
            }
        }());
    }, VB = F2(function(n, r) {
        return A2(QP, y([
            Px("mdc-circular-progress__determinate-circle-graphic"),
            FB(oB)
        ]), y([
            DB(r),
            A4(qB, RB, st(BB), n, r)
        ]));
    }), ZB = F2(function(n, r) {
        return A2(Lv, y([
            Jl("mdc-circular-progress__determinate-container")
        ]), y([
            A2(VB, n, r)
        ]));
    }), GB = function(n) {
        return st(A2(tx, "determinate", As(!a(n, dt))));
    }, YB = F2(function(n, r) {
        return A2(QP, y([
            Px("mdc-circular-progress__indeterminate-circle-graphic"),
            FB(r)
        ]), y([
            A4(qB, n, dt, dt, r)
        ]));
    }), UB = function(n) {
        var r = n.dO;
        return A3(lu, MB, Qv, function() {
            switch(r){
                case 0:
                    return 3.2;
                case 1:
                    return 2.4;
                default:
                    return 2;
            }
        }());
    }, QB = F2(function(n, r) {
        return A2(Lv, A2(bt, Jl("mdc-circular-progress__spinner-layer"), r), y([
            A2(Lv, y([
                Jl("mdc-circular-progress__circle-clipper"),
                Jl("mdc-circular-progress__circle-left")
            ]), y([
                A2(YB, RB, n)
            ])),
            A2(Lv, y([
                Jl("mdc-circular-progress__gap-patch")
            ]), y([
                A2(YB, UB, n)
            ])),
            A2(Lv, y([
                Jl("mdc-circular-progress__circle-clipper"),
                Jl("mdc-circular-progress__circle-right")
            ]), y([
                A2(YB, RB, n)
            ]))
        ]));
    }), JB = function(n) {
        var r = n.c2;
        return A2(Lv, y([
            Jl("mdc-circular-progress__indeterminate-container")
        ]), y(r ? [
            A2(QB, n, y([
                Jl("mdc-circular-progress__color-1")
            ])),
            A2(QB, n, y([
                Jl("mdc-circular-progress__color-2")
            ])),
            A2(QB, n, y([
                Jl("mdc-circular-progress__color-3")
            ])),
            A2(QB, n, y([
                Jl("mdc-circular-progress__color-4")
            ]))
        ] : [
            A2(QB, n, w)
        ]));
    }, KB = function(n) {
        return a(n, dt) ? st(Jl("mdc-circular-progress--indeterminate")) : dt;
    }, WB = function(n) {
        return A2(Yu, A2(lu, A2(lu, tx("progress"), Ps), function(n) {
            return n.dD;
        }), n);
    }, nN = st(A2(Yy, "role", "progressbar")), rN = st(Jl("mdc-circular-progress")), tN = F2(function(n, r) {
        var t, e, u = r.cy;
        return A3(jx, "mdc-circular-progress", p(A2(Ru, Ne, y([
            rN,
            KB(n),
            nN,
            (t = r, e = t.bt, A2(Yu, Yy("aria-label"), e)),
            HB,
            xB,
            AB(n),
            GB(n),
            WB(n),
            PB(r)
        ])), p(function(n) {
            var r = n.dO, t = Lt(function() {
                switch(r){
                    case 0:
                        return 48;
                    case 1:
                        return 36;
                    default:
                        return 24;
                }
            }()) + "px";
            return y([
                A2(Ml, "width", t),
                A2(Ml, "height", t)
            ]);
        }(r), u)), y([
            A2(ZB, A2(_i, st({
                dD: 0
            }), A2(Yu, st, n)), r),
            JB(r)
        ]));
    }), eN = function(n) {
        return A2(tN, dt, n);
    }, uN = function(n) {
        return h(n.gM, n.gN);
    }, aN = F2(function(n, r) {
        return r.$ ? ed : vd(A4(wi, Ne, w, A2(pi, uN, A2(bt, n, r.a)), w));
    }), cN = F2(function(n, r) {
        return A3(dA, 3, n, r);
    }), iN = Jl("mdc-select__anchor"), oN = function(n) {
        return A2(Yy, "aria-expanded", n ? "true" : "false");
    }, fN = A2(Yy, "role", "button"), sN = F2(function(n, r) {
        return A2(Lv, p(y([
            iN,
            fN,
            A2(Yy, "aria-haspopup", "listbox"),
            oN(!1)
        ]), n), r);
    }), dN = function(n) {
        return st(A2(tx, "disabled", As(n.ap)));
    }, bN = hr("fill-rule"), lN = hr("points"), vN = YP("polygon"), hN = hr("stroke"), gN = A2(SA, y([
        Jl("mdc-select__dropdown-icon")
    ]), y([
        A2(QP, y([
            Px("mdc-select__dropdown-icon-graphic"),
            JP("7 10 10 5"),
            A2(Gy, "focusable", "false")
        ]), y([
            A2(vN, y([
                Px("mdc-select__dropdown-icon-inactive"),
                hN("none"),
                bN("evenodd"),
                lN("7 10 12 15 17 10")
            ]), w),
            A2(vN, y([
                Px("mdc-select__dropdown-icon-active"),
                hN("none"),
                bN("evenodd"),
                lN("7 15 12 10 17 15")
            ]), w)
        ]))
    ])), $N = function(n) {
        return n ? dt : st(Jl("mdc-select--filled"));
    }, mN = function(n) {
        return A2(Yu, function(n) {
            return A2(Lv, y([
                Jl("mdc-floating-label")
            ]), y([
                kv(n)
            ]));
        }, n.bt);
    }, pN = function(n) {
        return A2(Yu, function() {
            return Jl("mdc-select--with-leading-icon");
        }, n.bv);
    }, wN = function(n) {
        var r = n.bv;
        if (1 === r.$) return kv("");
        if (r.a.$) return t = r.a.a.ap, e = r.a.a.fn, u = r.a.a.cg, a = r.a.a.bP, A2(r.a.a.cf, A2(bt, Px("mdc-select__icon"), function() {
            if (e.$) return a;
            var n = e.a;
            return t ? A2(bt, Lx(-1), A2(bt, A2(Yy, "role", "button"), a)) : A2(bt, Lx(0), A2(bt, A2(Yy, "role", "button"), A2(bt, Nx(n), A2(bt, A2(sx, "keydown", A2(ye, function(r) {
                return 13 === r ? Pe(n) : Eu("");
            }, Bx)), a))));
        }()), u);
        var t = r.a.a.ap, e = r.a.a.fn, u = r.a.a.cg, a = r.a.a.bP;
        return A2(r.a.a.cf, A2(bt, Jl("mdc-select__icon"), function() {
            if (e.$) return a;
            var n = e.a;
            return t ? A2(bt, Lx(-1), A2(bt, A2(Yy, "role", "button"), a)) : A2(bt, Lx(0), A2(bt, A2(Yy, "role", "button"), A2(bt, Nx(n), A2(bt, A2(sx, "keydown", A2(ye, function(r) {
                return 13 === r ? Pe(n) : Eu("");
            }, Bx)), a))));
        }()), u);
    }, kN = A2($B, y([
        Jl("mdc-line-ripple")
    ]), w), _N = F2(function(n, r) {
        return A2(Lv, A2(bt, Jl("mdc-deprecated-list-item__graphic"), n), r);
    }), yN = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), xN = F2(function(n, r) {
        return $(r, {
            ap: n
        });
    }), HN = F3(function(n, r, t) {
        var e = t.cy, u = t.ap, c = t.bL;
        return (r.$ ? Ne : kP((0, r.a)(c)))(A2(_P, a(n, st(c)) ? st(1) : dt, A2(yN, e, A2(xN, u, tP))));
    }), AN = F4(function(n, r, t, e) {
        var u = e.b;
        return A2($P, A3(HN, r, t, e.a), cd(y([
            a(n, dt) ? w : y([
                A2(_N, w, w)
            ]),
            y([
                A2(Lv, y([
                    Jl("mdc-deprecated-list-item__text")
                ]), y([
                    kv(u)
                ]))
            ])
        ])));
    }), PN = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), BN = F5(function(n, r, t, e, u) {
        return A3(tA, A2(PN, y([
            Jl("mdc-select__menu"),
            A2(Ml, "width", "100%")
        ]), LP), A4(AN, n, r, t, e), A2(Qe, A3(AN, n, r, t), u));
    }), NN = function(n) {
        return A2(ql, y([
            Jl("mdc-notched-outline")
        ]), y([
            A2(ql, y([
                Jl("mdc-notched-outline__leading")
            ]), w),
            A2(ql, y([
                Jl("mdc-notched-outline__notch")
            ]), A2(Ru, Ne, y([
                mN(n)
            ]))),
            A2(ql, y([
                Jl("mdc-notched-outline__trailing")
            ]), w)
        ]));
    }, LN = function(n) {
        return 1 === n ? st(Jl("mdc-select--outlined")) : dt;
    }, IN = function(n) {
        return st(A2(tx, "required", As(n.be)));
    }, TN = st(A2(ql, y([
        Jl("mdc-select__ripple")
    ]), w)), SN = st(Jl("mdc-select")), CN = function(n) {
        return st(A2(tx, "selectedIndex", ls(A2(_i, -1, n))));
    }, EN = A2(ql, y([
        Jl("mdc-select__selected-text")
    ]), w), zN = A2(ql, y([
        Jl("mdc-select__selected-text-container")
    ]), y([
        EN
    ])), XN = function(n) {
        return st(A2(tx, "valid", As(n.d0)));
    }, jN = F4(function(n, r, t, e) {
        var u, c = r.$7, i = r.cy, o = r.dM, f = r.bv, s = Gu(A2(Ru, Ne, A2(qt, F2(function(n, r) {
            return a(st(r.a.bL), o) ? st(n) : dt;
        }), A2(bt, t, e))));
        return A3(jx, "mdc-select", p(A2(Ru, Ne, y([
            SN,
            (u = r, a(u.bt, dt) ? st(Jl("mdc-select--no-label")) : dt),
            $N(n),
            LN(n),
            pN(r),
            dN(r),
            CN(s),
            XN(r),
            IN(r)
        ])), i), y([
            A2(sN, w, cd(y([
                n ? y([
                    NN(r)
                ]) : A2(Ru, Ne, y([
                    TN,
                    mN(r)
                ])),
                y([
                    wN(r),
                    zN,
                    gN
                ]),
                n ? w : y([
                    kN
                ])
            ]))),
            A5(BN, f, o, c, t, e)
        ]));
    }), qN = F3(function(n, r, t) {
        return A4(jN, 1, n, r, t);
    }), MN = function(n) {
        return A2(uH, !0, n);
    }, RN = A2(Lv, y([
        Jl("mdc-radio__inner-circle")
    ]), w), ON = A2(Lv, y([
        Jl("mdc-radio__outer-circle")
    ]), w), DN = A2(Lv, y([
        Jl("mdc-radio__background")
    ]), y([
        ON,
        RN
    ])), FN = function(n) {
        return st(A2(tx, "checked", As(n.aG)));
    }, VN = function(n) {
        return st(A2(tx, "disabled", As(n.ap)));
    }, ZN = st(Jl("mdc-radio__native-control")), GN = st(Hv("radio")), YN = function(n) {
        var r;
        return A2(sv, A2(Ru, Ne, y([
            ZN,
            GN,
            FN(n),
            (r = n, A2(Yu, function(n) {
                return A2(sx, "change", Pe(n));
            }, r.$7))
        ])), w);
    }, UN = A2(Lv, y([
        Jl("mdc-radio__ripple")
    ]), w), QN = st(Jl("mdc-radio")), JN = function(n) {
        var r, t, e = n.cy, u = n.bH;
        return r = A3(jx, "mdc-radio", p(A2(Ru, Ne, y([
            QN,
            (t = n, t.bH ? st(Jl("mdc-radio--touch")) : dt),
            FN(n),
            VN(n)
        ])), e), y([
            YN(n),
            DN,
            UN
        ])), u ? A2(Lv, y([
            Jl("mdc-touch-target-wrapper")
        ]), y([
            r
        ])) : r;
    }, KN = F2(function(n, r) {
        return A3(dA, 1, n, r);
    }), WN = fr("section"), nL = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rL = nL, tL = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), eL = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), uL = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), aL = F2(function(n, r) {
        return $(r, {
            cy: n
        });
    }), cL = F2(function(n, r) {
        return $(r, {
            aG: n
        });
    }), iL = F2(function(n, r) {
        return $(r, {
            cH: n
        });
    }), oL = F2(function(n, r) {
        return $(r, {
            ap: n
        });
    }), fL = F2(function(n, r) {
        return $(r, {
            bt: n
        });
    }), sL = F2(function(n, r) {
        return $(r, {
            bt: n
        });
    }), dL = F2(function(n, r) {
        return $(r, {
            $7: st(n)
        });
    }), bL = F2(function(n, r) {
        return $(r, {
            $7: st(n)
        });
    }), lL = F2(function(n, r) {
        return $(r, {
            $7: st(n)
        });
    }), vL = F2(function(n, r) {
        return $(r, {
            dp: st(n)
        });
    }), hL = F2(function(n, r) {
        return $(r, {
            dM: n
        });
    }), gL = F2(function(n, r) {
        return $(r, {
            dO: n
        });
    }), $L = F2(function(n, r) {
        return $(r, {
            co: n
        });
    }), mL = F2(function(n, r) {
        return $(r, {
            cu: n
        });
    }), pL = F2(function(n, r) {
        return $(r, {
            d0: n
        });
    }), wL = A2(lu, nd, _o), kL = F2(function(n, r) {
        var t = function() {
            switch(n){
                case 0:
                case 1:
                case 2:
                default:
                    return "B";
                case 3:
                    return "O";
            }
        }();
        return 1024 > r ? Lt(r) + "\xa0" + t : 0 > f(r, 1048576) ? Lt(r / 1024 | 0) + "\xa0KiB" : 0 > f(r, 1073741824) ? Lt(r / 1048576 | 0) + "\xa0MiB" : Lt(r / 1073741824 | 0) + "\xa0GiB";
    }), _L = F2(function(n, r) {
        return A2(fx, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r));
    }), yL = Jl("mdc-theme--primary"), xL = function(n) {
        return n ? p(xL(n / 2 | 0), A2(Lu, 2, n) ? "1" : "0") : "";
    }, HL = F2(function(n, r) {
        var t = r.iK, e = function(n) {
            var r, t, e;
            return {
                gz: function() {
                    return w;
                },
                gN: function() {
                    return w;
                },
                gO: function() {
                    return w;
                },
                hx: function(n) {
                    var r = n.hy, t = n.hz;
                    return y([
                        A2(Lv, y([
                            Jl("form-field form-field--full-width form-field--summary form-field--input")
                        ]), function() {
                            switch(t.$){
                                case 0:
                                    var e = t.a, u = A3(Cv, n.gH, "", A2(_i, !1, gh(n.d2)) ? qf(function(n) {
                                        switch(n){
                                            case 0:
                                                return "ja";
                                            case 1:
                                                return "yes";
                                            case 2:
                                                return "s\xed";
                                            case 3:
                                                return "oui";
                                            default:
                                                return "\u0434\u0430";
                                        }
                                    }) : qf(function(n) {
                                        switch(n){
                                            case 0:
                                                return "nein";
                                            case 1:
                                            case 2:
                                                return "no";
                                            case 3:
                                                return "non";
                                            default:
                                                return "\u043D\u0435\u0442";
                                        }
                                    }));
                                    return cd(y([
                                        A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), Yk(A3(Cv, n.gH, "", e) + ":\xa0" + u))
                                    ]));
                                case 1:
                                    var a = t.b, c = (u = $h(n.d2), A2(Yu, function(r) {
                                        return A3(no, r, function(n) {
                                            return n.bt;
                                        }, A2(Gb, A2(lu, oe(r), function(n) {
                                            return n.bL;
                                        }), A3(Cv, n.gH, w, A2(lh, function() {
                                            return No;
                                        }, a))));
                                    }, u));
                                    return y([
                                        kv(A3(Cv, n.gH, "", r.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", c))
                                    ]);
                                case 2:
                                    return u = $h(n.d2), y([
                                        kv(A3(Cv, n.gH, "", r.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", u))
                                    ]);
                                case 3:
                                    var i = t.a.eH, o = t.a.e3;
                                    return u = $h(n.d2), a = n.gH.aS.h4({
                                        eH: i,
                                        e3: o
                                    }), c = A2(Yu, function(r) {
                                        return A3(no, r, A2(lu, A2(Cv, n.gH, ""), function(n) {
                                            return n.bt;
                                        }), A2(Gb, A2(lu, oe(r), function(n) {
                                            return n.bL;
                                        }), a));
                                    }, u), y([
                                        kv(A3(Cv, n.gH, "", r.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", c))
                                    ]);
                                default:
                                    return c = A2(Yu, hh, $h(n.d2)), y([
                                        kv(A3(Cv, n.gH, "", r.bt)),
                                        kv(":\xa0"),
                                        kv(A2(_i, "-", c))
                                    ]);
                            }
                        }())
                    ]);
                },
                hK: (r = function(n) {
                    return A2(Ev, F2(function(r, t) {
                        if (4 !== r.$) return t;
                        switch(r.a){
                            case 1:
                                return p(t, y([
                                    A2(Sh, n ? 3 : 2, r.b)
                                ]));
                            case 2:
                                return p(t, y([
                                    A2(Sh, n ? 4 : 3, r.b)
                                ]));
                            default:
                                return t;
                        }
                    }), w);
                }, t = F2(function(n, r) {
                    return A2(Lv, y([
                        Jl("edit-button")
                    ]), y([
                        kv("("),
                        A2(Tl, y([
                            Cl("#"),
                            A2(_L, "click", Pe(h(r, !0)))
                        ]), y([
                            kv(A3(Cv, n, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "bearbeiten";
                                    case 1:
                                        return "edit";
                                    case 2:
                                        return "editar";
                                    case 3:
                                        return "modifier";
                                    default:
                                        return "\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C";
                                }
                            })))
                        ])),
                        kv(")")
                    ]));
                }), e = F4(function(e, u, c, i) {
                    return $(i, {
                        g9: r(u),
                        ie: $(n, {
                            hk: function(r) {
                                var i = r.gy;
                                return a(r.hF, u ? 3 : 2) ? n.hk($(r, {
                                    gy: p(i, y([
                                        kv("\xa0"),
                                        A2(t, e, c)
                                    ]))
                                })) : n.hk(r);
                            }
                        })
                    });
                }), function(n) {
                    var r = n.ii;
                    return A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), A2(Gk, A4(e, n.gH, n.bc, n.b$, Nv), A3(Cv, n.gH, "", r)));
                }),
                hP: function() {
                    return w;
                },
                hR: function(n) {
                    return n.gH.aB;
                },
                h2: function(n) {
                    var r = n.g7;
                    return n.hB ? A2(bt, A2(uv, y([
                        Jl("form-field form-field--full-width"),
                        yL
                    ]), y([
                        kv(A3(no, "", Wk, A2(Si, n.b$.gN, n.d2.h0.dy)))
                    ])), r) : r;
                },
                dy: function(n) {
                    return cd(A2(qt, function(r) {
                        return A3(no, !0, function(n) {
                            return n > 1;
                        }, n.bw.b) ? Bt(y([
                            A2(av, y([
                                Jl("form-field form-field--full-width")
                            ]), y([
                                kv(p(A3(Cv, n.gH, "", qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Teilnehmende Person ";
                                        case 1:
                                            return "Participant ";
                                        case 2:
                                            return "Persona participante ";
                                        case 3:
                                            return "Personne participante ";
                                        default:
                                            return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ";
                                    }
                                })), Lt(r + 1)))
                            ]))
                        ])) : Ne;
                    }, n.g8));
                },
                it: function() {
                    return w;
                },
                iE: function(n) {
                    var r = n.il;
                    return A2(Ru, function(n) {
                        return A2(Yu, function(r) {
                            return h(r.b, n);
                        }, A2(Gb, A2(lu, oe(n.fZ), ge), r));
                    }, n.gH.aB).b ? A2(Qe, function(r) {
                        var t = r.a, e = r.b;
                        return A2(Lv, y([
                            Jl("ticket ticket--summary"),
                            Jl("form-field form-field--summary form-field--full-width")
                        ]), y([
                            A2(Lv, y([
                                Jl("ticket__label")
                            ]), y([
                                A2(ql, y([
                                    Jl("ticket__title")
                                ]), y([
                                    kv(Lt(t) + "x\xa0" + A3(Cv, n.gH, "", e.bt))
                                ])),
                                A3(no, kv(""), function(r) {
                                    return A2(ql, y([
                                        Jl("ticket__price")
                                    ]), y([
                                        A2(ql, w, y([
                                            kv(!r && e.eQ ? "kostenfrei" : (t > 1 ? Bt("\xe1\xa0") : Ne)(A2(bh, n.gH.e, r)))
                                        ]))
                                    ]));
                                }, e.fz)
                            ]))
                        ]));
                    }, A2(Ru, function(n) {
                        return A2(Yu, function(r) {
                            return h(r.b, n);
                        }, A2(Gb, A2(lu, oe(n.fZ), ge), r));
                    }, n.gH.aB)) : y([
                        A2(Lv, y([
                            Jl("form-field form-field--summary form-field--full-width")
                        ]), y([
                            kv(A3(Cv, n.gH, "", n.fo))
                        ]))
                    ]);
                }
            };
        }(n), u = F2(function(n, r) {
            return 0 > f(xL(r.e$), xL(t)) ? A2(n, e, r) : w;
        });
        return {
            gz: u(function(n) {
                return n.gz;
            }),
            gN: u(function(n) {
                return n.gN;
            }),
            gO: u(function(n) {
                return n.gO;
            }),
            hx: u(function(n) {
                return n.hx;
            }),
            hK: u(function(n) {
                return n.hK;
            }),
            hP: u(function(n) {
                return n.hP;
            }),
            hR: e.hR,
            h2: u(function(n) {
                return n.h2;
            }),
            dy: u(function(n) {
                return n.dy;
            }),
            it: u(function(n) {
                return n.it;
            }),
            iE: u(function(n) {
                return n.iE;
            })
        };
    }), AL = function(n) {
        switch(n.$){
            case 0:
                return n.a;
            case 1:
                return function(n) {
                    switch(n.$){
                        case 0:
                            return dt;
                        case 1:
                            return st(Gc);
                        default:
                            return st(A2(nd, n.a.fZ, A2(_i, 1, n.a.hN)));
                    }
                }(n.a);
            default:
                return function(n) {
                    return n.$ ? st(Wc(A2(Qe, function(n) {
                        return h(n, 1);
                    }, gt(n.a.dY)))) : dt;
                }(n.a);
        }
    }, PL = function(n) {
        return 1 === n.$ ? n.a : function(n) {
            var r = A2(Yu, vt, n);
            if (r.$) return Gd;
            if (r.a.b && !r.a.b.b) {
                var t = r.a.a, e = t.a;
                return Zd({
                    hN: st(A2(be, 0, t.b)),
                    fZ: e
                });
            }
            return Vd;
        }(AL(n));
    }, BL = function(n) {
        var r = n.iN;
        return A2(Lv, y([
            Jl("mdc-text-field-helper-line")
        ]), y([
            A2(fH, A2(SH, !0, A2(LH, !0, Jy)), A3(no, "", function(n) {
                return n.cY;
            }, r))
        ]));
    }, NL = function(n) {
        return Et(n.b) + 1;
    }, LL = Rd({
        dY: Fo
    }), IL = F3(function(n, r, t) {
        var e = Lt(n.e$) + "-" + Lt(t);
        return A2(t_, function() {
            return LL;
        }, A2($B, y([
            cB(y([
                h("form-field--checkbox", !0),
                h("form-field--full-width", !0),
                h("form-field--invalid", r.a9),
                h("form-field", !0),
                h("ticket", !0)
            ]))
        ]), y([
            A2(Lv, y([
                Jl("ticket__label ticket__label--no-option")
            ]), y([
                A2(Lv, y([
                    Jl("ticket__native-control")
                ]), y([
                    r.di ? aB(A2(dL, 0, A2($L, st(r.aG ? 1 : 0), A2(tL, y([
                        yB(e)
                    ]), iB)))) : JN(A2(bL, 0, A2(cL, r.aG, A2(eL, y([
                        yB(e)
                    ]), sB))))
                ])),
                A2(Lv, y([
                    Jl("ticket__title")
                ]), y([
                    kv(p(A3(Cv, n.gH, "", r.fo), r.be ? "*" : ""))
                ]))
            ]))
        ])));
    }), TL = F2(function(n, r) {
        return !!r.$ && A2(g_, n, r.a.dY);
    }), SL = F2(function(n, r) {
        return $(r, {
            ap: n
        });
    }), CL = F2(function(n, r) {
        return $(r, {
            ap: n
        });
    }), EL = F2(function(n, r) {
        return A2(Mi, n, r);
    }), zL = F2(function(n, r) {
        if (r.$) {
            var t = r.a.dY;
            return Rd({
                dY: A2(A2(g_, n, t) ? EL : Zo, n, t)
            });
        }
        var e;
        return Rd({
            dY: (e = n, A2(nd, e, 0))
        });
    }), XL = F4(function(n, r, t, e) {
        var u, a = e.fZ, c = A2(ii, e.fZ, A2(_i, w, A2(Yu, No, A2(ju, Si(n.dX), A2(ju, function(n) {
            return n.eR;
        }, n.gH.cI))))), i = r.aG, o = Lt(n.e$) + "-" + Lt(t), f = e.a9, s = Et(A2(ei, oe(a), 1 === (u = n.ct).$ ? w : u.a.$ ? A2(id, function(n) {
            return cd(rd(n.aB));
        }, rd(u.a.a.dy)) : cd(rd(u.a.a.aB)))), d = A3(no, !1, function(n) {
            return 0 >= n.dI - s;
        }, e.dF), b = !i && (d || f), l = !i && c ? A2(_i, !1, A2(Yu, function(n) {
            return 0 >= n - s;
        }, A2(Yu, function(n) {
            return n.dI;
        }, e.dF))) ? st("Das Kontingent f\xfcr Ihre kostenfreien Tickets ist ersch\xf6pft.") : dt : !i && d ? st(A3(Cv, n.gH, "", qf(function(n) {
            switch(n){
                case 0:
                    return "ausgebucht";
                case 1:
                    return "sold out";
                case 2:
                    return "completo";
                case 3:
                    return "complet";
                default:
                    return "\u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442 \u043D\u0435\u0442";
            }
        }))) : dt;
        return A2(t_, function() {
            return A2(zL, a, n.d2);
        }, A2($B, y([
            cB(y([
                h("form-field--checkbox", !0),
                h("form-field--full-width", !0),
                h("form-field--invalid", r.a9),
                h("form-field", !0),
                h("ticket", !0),
                h("ticket--disabled", b)
            ]))
        ]), y([
            A2(Lv, y([
                Jl("ticket__label")
            ]), y([
                A2(Lv, y([
                    Jl("ticket__native-control")
                ]), y([
                    r.di ? aB(A2(SL, b, A2(dL, 0, A2($L, st(r.aG ? 1 : 0), A2(tL, y([
                        yB(o)
                    ]), iB))))) : JN(A2(CL, b, A2(bL, 0, A2(cL, r.aG, A2(eL, y([
                        yB(o)
                    ]), sB)))))
                ])),
                A2(Lv, y([
                    Jl("ticket__title")
                ]), y([
                    kv(p(A3(Cv, n.gH, "", e.bt), r.be ? "*" : ""))
                ])),
                A3(no, kv(""), function(r) {
                    return A2(Lv, y([
                        Jl("ticket__price")
                    ]), y([
                        A2(ql, w, y([
                            kv(!r && e.eQ ? "kostenfrei" : A2(bh, n.gH.e, r))
                        ]))
                    ]));
                }, e.fz)
            ])),
            A2(Lv, y([
                Jl("ticket__description")
            ]), A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), Yk(A3(no, "", A2(Cv, n.gH, ""), e.eA)))),
            function() {
                if (l.$) return kv("");
                var n = l.a;
                return A2(Lv, y([
                    Jl("ticket__error")
                ]), y([
                    kv(n)
                ]));
            }()
        ])));
    }), jL = F2(function(n, r) {
        var t = h(r, n);
        if (1 === t.b.$) return Vd;
        switch(t.a.$){
            case 0:
            case 1:
                return Zd({
                    hN: dt,
                    fZ: t.b.a
                });
            default:
                return Zd({
                    hN: t.a.a.hN,
                    fZ: t.b.a
                });
        }
    }), qL = F3(function(n, r, t) {
        var e = Lt(n.e$) + "-" + Lt(t);
        return A2(t_, function() {
            return A2(jL, dt, n.d2);
        }, A2($B, y([
            cB(y([
                h("form-field--checkbox", !0),
                h("form-field--full-width", !0),
                h("form-field--invalid", r.a9),
                h("form-field", !0),
                h("ticket", !0)
            ]))
        ]), y([
            A2(Lv, y([
                Jl("ticket__label ticket__label--no-option")
            ]), y([
                A2(Lv, y([
                    Jl("ticket__native-control")
                ]), y([
                    r.di ? aB(A2(dL, 0, A2($L, st(r.aG ? 1 : 0), A2(tL, y([
                        yB(e)
                    ]), iB)))) : JN(A2(bL, 0, A2(cL, r.aG, A2(eL, y([
                        yB(e)
                    ]), sB))))
                ])),
                A2(Lv, y([
                    Jl("ticket__title")
                ]), y([
                    kv(p(A3(Cv, n.gH, "", r.fo), r.be ? "*" : ""))
                ]))
            ]))
        ])));
    }), ML = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
                return !1;
            default:
                return a(r.a.fZ, n);
        }
    }), RL = F2(function(n, r) {
        return $(r, {
            ap: n
        });
    }), OL = F3(function(n, r) {
        return Zd({
            hN: st(r),
            fZ: n
        });
    }), DL = F4(function(n, r, t, e) {
        var u, a = e.fZ, c = A2(ii, e.fZ, A2(_i, w, A2(Yu, No, A2(ju, Si(n.dX), A2(ju, function(n) {
            return n.eR;
        }, n.gH.cI))))), i = r.aG, o = Lt(n.e$) + "-" + Lt(t), f = e.a9, s = Et(A2(ei, oe(a), 1 === (u = n.ct).$ ? w : u.a.$ ? A2(id, function(n) {
            return cd(rd(n.aB));
        }, rd(u.a.a.dy)) : cd(rd(u.a.a.aB)))), d = A3(no, !1, function(n) {
            return 0 >= n.dI - s;
        }, e.dF), b = !i && (d || f), l = !i && c ? A2(_i, !1, A2(Yu, function(n) {
            return 0 >= n - s;
        }, A2(Yu, function(n) {
            return n.dI;
        }, e.dF))) ? st("Das Kontingent f\xfcr Ihre kostenfreien Tickets ist ersch\xf6pft.") : dt : !i && d ? st(A3(Cv, n.gH, "", qf(function(n) {
            switch(n){
                case 0:
                    return "ausgebucht";
                case 1:
                    return "sold out";
                case 2:
                    return "completo";
                case 3:
                    return "complet";
                default:
                    return "\u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442 \u043D\u0435\u0442";
            }
        }))) : dt;
        return A2(t_, function() {
            return A2(jL, st(a), n.d2);
        }, A2($B, y([
            cB(y([
                h("form-field--checkbox", !0),
                h("form-field--full-width", !0),
                h("form-field--invalid", r.a9),
                h("form-field", !0),
                h("ticket", !0),
                h("ticket--disabled", b)
            ]))
        ]), y([
            A2(Lv, y([
                Jl("ticket__label")
            ]), y([
                A2(Lv, y([
                    Jl("ticket__native-control")
                ]), y([
                    r.di ? aB(A2(SL, b, A2(dL, 0, A2($L, st(r.aG ? 1 : 0), A2(tL, y([
                        yB(o)
                    ]), iB))))) : JN(A2(CL, b, A2(bL, 0, A2(cL, r.aG, A2(eL, y([
                        yB(o)
                    ]), sB)))))
                ])),
                A2(Lv, y([
                    Jl("ticket__title")
                ]), y([
                    kv(p(A3(Cv, n.gH, "", e.bt), r.be ? "*" : ""))
                ])),
                A3(no, kv(""), function(r) {
                    return A2(Lv, y([
                        Jl("ticket__price")
                    ]), y([
                        A2(ql, w, y([
                            kv(!r && e.eQ ? "kostenfrei" : A2(bh, n.gH.e, r))
                        ]))
                    ]));
                }, e.fz)
            ])),
            A2(Lv, y([
                Jl("ticket__description")
            ]), A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), Yk(A3(no, "", A2(Cv, n.gH, ""), e.eA)))),
            function() {
                if (l.$) return kv("");
                var n = l.a;
                return A2(Lv, y([
                    Jl("ticket__error")
                ]), y([
                    kv(n)
                ]));
            }()
        ])));
    }), FL = function(n) {
        var r;
        return n.di ? A2(Qe, t_(uy(qd)), function(n) {
            var r = n.be, t = n.di, e = n.iN, u = function(r) {
                var t = A2(Yu, NL, A2(ju, oi, A2(Yu, ei(oe(r.fZ)), A2(ju, Si(n.dX), A2(Yu, Vs(function() {
                    return No;
                }), A2(ju, function(n) {
                    return n.eR;
                }, n.gH.cI))))));
                return t.$ ? r : $(r, {
                    dF: st({
                        dI: t.a
                    })
                });
            }, a = function(r) {
                return A2(TL, r, n.d2);
            }, c = kd(e), i = A2(Qe, u, A2(ei, function(n) {
                return !n.a9 || a(n.fZ);
            }, n.gs));
            return p(A2(qt, F2(function(e, u) {
                return A2(t_, ny, A4(XL, n, {
                    aG: a(u.fZ),
                    a9: c,
                    di: t,
                    be: r
                }, e, u));
            }), i), p(r ? w : y([
                A2(t_, ny, A3(IL, n, {
                    aG: xy(n.d2) && zl(Cb(n.d2)),
                    a9: c,
                    di: t,
                    fo: n.fo,
                    be: r
                }, Et(i)))
            ]), y([
                BL({
                    aF: n,
                    iN: e
                })
            ])));
        }({
            gs: n.gs,
            gH: n.gH,
            eL: n.eL,
            e$: n.e$,
            di: n.di,
            fo: n.fo,
            be: n.be,
            il: n.il,
            dX: n.dX,
            ct: n.ct,
            iN: n.iN,
            d2: (r = n.d2, 2 === r.$ ? r.a : function(n) {
                if (1 === n.$) return Od;
                var r = n.a;
                return Rd({
                    dY: Go(ht(A2(qb, F2(function(n, r) {
                        return r > 0;
                    }), r)))
                });
            }(AL(r)))
        })) : A2(Qe, t_(uy(Md)), function(n) {
            var r = n.be, t = n.di, e = n.iN, u = function(r) {
                var t = A2(Yu, NL, A2(ju, oi, A2(Yu, ei(oe(r.fZ)), A2(ju, Si(n.dX), A2(Yu, Vs(function() {
                    return No;
                }), A2(ju, function(n) {
                    return n.eR;
                }, n.gH.cI))))));
                return t.$ ? r : $(r, {
                    dF: st({
                        dI: t.a
                    })
                });
            }, c = function(r) {
                return A2(ML, r, n.d2);
            }, i = kd(e), o = A2(Qe, u, A2(ei, function(n) {
                return !n.a9 || c(n.fZ);
            }, n.gs));
            return p(A2(qt, F2(function(e, u) {
                return A2(t_, ny, A4(DL, n, {
                    aG: c(u.fZ),
                    a9: i,
                    di: t,
                    be: r
                }, e, u));
            }), o), p(r ? w : y([
                A2(t_, ny, A3(qL, n, {
                    aG: A2(By, {
                        eL: n.eL
                    }, n.d2) && zl(zb(n.d2)),
                    a9: i,
                    di: t,
                    fo: n.fo,
                    be: r
                }, Et(o)))
            ]), p(y([
                BL({
                    aF: n,
                    iN: e.$ ? dt : a(e.a.e$, Lt(n.e$) + "-0") ? e : dt
                })
            ]), function() {
                var r = h(n.eL, !a(zb(n.d2), w));
                if (!r.a.$ && r.b) {
                    var t = r.a.a, u = function(n) {
                        return A2(rL, bB({
                            bL: n
                        }), Lt(n));
                    }, c = A2(Qe, u, A2(jt, 2, 10)), o = u(1), f = A2(Ho, o, c), s = function() {
                        var r = n.d2;
                        switch(r.$){
                            case 0:
                            case 1:
                                return h(dt, dt);
                            default:
                                var t = r.a;
                                return h(st(t.fZ), t.hN);
                        }
                    }(), d = s.a, b = s.b, l = pd(d);
                    return p(y([
                        A2(Lv, y([
                            Jl("form-field form-field--full-width")
                        ]), A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), Yk(A3(Cv, n.gH, "", t.fr)))),
                        A2(Lv, y([
                            cB(y([
                                h("form-field form-field--full-width", !0),
                                h("form-field--invalid", i)
                            ]))
                        ]), y([
                            A2(BP, qN(A2(lL, function(r) {
                                return ny(d.$ ? n.d2 : A3(OL, d.a, r, n.d2));
                            }, A2(RL, l, A2(pL, !i, A2(hL, b, A2(sL, st(A3(Cv, n.gH, "", t.e2)), dB)))))), f)
                        ]))
                    ]), y([
                        BL({
                            aF: n,
                            iN: e.$ ? dt : a(e.a.e$, Lt(n.e$) + "-1") ? e : dt
                        })
                    ]));
                }
                return w;
            }())));
        }({
            gs: n.gs,
            gH: n.gH,
            eL: n.eL,
            e$: n.e$,
            di: n.di,
            fo: n.fo,
            be: n.be,
            il: n.il,
            dX: n.dX,
            ct: n.ct,
            iN: n.iN,
            d2: PL(n.d2)
        }));
    }, VL = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ZL = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GL = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), YL = F3(function(n, r, t) {
        switch(t.$){
            case 0:
                return A3(ma, function() {
                    return RP(n.d2);
                }, ZL, r.bp);
            case 1:
                return RP(t.a);
            case 2:
                return A2(VL, t.a, t.b);
            default:
                return A3(GL, t.a, t.b, t.c);
        }
    }), UL = F6(function(n, r, t, e, u, c) {
        var i = A4(n_, n, u, {
            gz: function(n) {
                var r = rd(A2(qb, F2(function(r) {
                    return A2(ii, r, n.iD);
                }), n.d2)), t = oi(zd(A2(Qe, function(r) {
                    return A2(Gb, A2(lu, oe(r), function(n) {
                        return n.fZ;
                    }), n.gH.aB);
                }, A2(Qe, ge, A2(id, Xb, r)))));
                return y([
                    A2(Lv, y([
                        Jl("chosen-ticket")
                    ]), y([
                        kv(A3(Cv, n.gH, "", qf(function(n) {
                            switch(n){
                                case 0:
                                    return "Ihre Auswahl";
                                case 1:
                                case 3:
                                    return "Your selection";
                                case 2:
                                    return "Tu selecci\xf3n";
                                default:
                                    return "\u0412\u0430\u0448 \u0432\u044B\u0431\u043E\u0440";
                            }
                        })) + ": "),
                        A2(Pl, w, y([
                            kv(A3(no, "-", A2(lu, It(", "), No), A2(Yu, mP(A2(lu, A2(Cv, n.gH, ""), function(n) {
                                return n.bt;
                            })), t)))
                        ]))
                    ]))
                ]);
            },
            gN: function(n) {
                var r;
                return y([
                    A2(lv, y([
                        Jl("current-person"),
                        Jl("form-field"),
                        Jl("form-field--full-width")
                    ]), y([
                        A2(Pl, w, y([
                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "Teilnehmende Person:";
                                    case 1:
                                        return "Participant:";
                                    case 2:
                                        return "Persona participante:";
                                    case 3:
                                        return "Personne participante:";
                                    default:
                                        return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A:";
                                }
                            }))),
                            kv(" "),
                            kv((r = n.d2, A2(It, " ", A2(Ru, $h, A2(Ru, function(n) {
                                return Gu(zd(A2(Qe, function(n) {
                                    return A2(Si, n, r.a4);
                                }, n)));
                            }, y([
                                y([
                                    "Titel",
                                    "Official title"
                                ]),
                                y([
                                    "Vorname",
                                    "First name"
                                ]),
                                y([
                                    "Nachname",
                                    "Last name"
                                ])
                            ]))))))
                        ]))
                    ]))
                ]);
            },
            gO: function(n) {
                var r = A2(kh, n.gH, n.ct), t = A3(no, h(dt, {
                    e4: 0,
                    fz: 0
                }), zf(st), A3(rl, n.gH, n.d2.h0, n.gH.aq)), e = t.a, u = t.b;
                return y([
                    A2(lv, y([
                        Jl("current-price"),
                        Jl("form-field"),
                        Jl("form-field--full-width")
                    ]), y([
                        kv(A3(Cv, n.gH, "", qf(function(n) {
                            switch(n){
                                case 0:
                                    return "Gesamtsumme";
                                case 1:
                                    return "Price (total)";
                                case 2:
                                    return "Importe (total)";
                                case 3:
                                    return "Montant total";
                                default:
                                    return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F)";
                            }
                        }))),
                        kv(": "),
                        A2(Pl, w, r ? p(y([
                            kv(A2(bh, n.gH.e, r - u.fz))
                        ]), kd(e) ? y([
                            kv(" ("),
                            kv(A2(bh, n.gH.e, u.fz)),
                            kv(")")
                        ]) : w) : y([
                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "kostenfrei";
                                    case 1:
                                        return "free of cost";
                                    case 2:
                                        return "gratis";
                                    case 3:
                                        return "gratuit";
                                    default:
                                        return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                }
                            })))
                        ]))
                    ]))
                ]);
            },
            hx: function(n) {
                var r = n.gH, t = n.hz, e = n.e$, u = n.hy, c = n.iN;
                return y([
                    A2(Lv, y([
                        cB(y([
                            h("form-field", !0),
                            h("form-field--full-width", u.a5 || function() {
                                switch(t.$){
                                    case 0:
                                        return !0;
                                    case 1:
                                        return t.a.dG;
                                    default:
                                        return !1;
                                }
                            }()),
                            h("form-field--checkbox", !t.$),
                            h("form-field--radio-group", 1 === t.$ && t.a.dG),
                            h("form-field--invalid", kd(c)),
                            h("form-field--file", 4 === t.$)
                        ]))
                    ]), function() {
                        switch(t.$){
                            case 0:
                                var i = t.a, o = A2(_i, !1, gh(n.d2));
                                return y([
                                    A2(wB, fB, y([
                                        aB(A2(dL, ny(tf(!o)), A2($L, st(o ? 1 : 0), A2(tL, y([
                                            yB(Lt(e))
                                        ]), iB)))),
                                        A2($B, y([
                                            Nx(ny(tf(!o))),
                                            hB(Lt(e))
                                        ]), A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), Yk(p(A3(Cv, n.gH, "", i), u.be ? "\\*" : ""))))
                                    ])),
                                    _B({
                                        aF: n,
                                        iN: c
                                    })
                                ]);
                            case 1:
                                var f = t.b;
                                if (t.a.dG) {
                                    var s = A3(Cv, n.gH, w, A2(lh, function() {
                                        return No;
                                    }, f)), d = F2(function(r, t) {
                                        var c = t.bL, i = t.bt;
                                        return A2(wB, A2(vL, ny(cf(c)), A2(fL, st(p(i, u.be ? "*" : "")), fB)), y([
                                            JN((r ? Ne : eL(y([
                                                yB(Lt(e))
                                            ])))(A2(cL, a($h(n.d2), st(c)), A2(bL, ny(cf(c)), sB))))
                                        ]));
                                    });
                                    return p(A2(qt, d, s), y([
                                        _B({
                                            aF: n,
                                            iN: c
                                        })
                                    ]));
                                }
                                s = A3(Cv, n.gH, w, A2(lh, function() {
                                    return No;
                                }, f));
                                var b = F2(function(n, r) {
                                    var t = r.bt;
                                    return A2(rL, A2(oL, n.ap, bB({
                                        bL: r.bL
                                    })), t);
                                });
                                return y([
                                    A3(qN, A2(pL, pd(c), A2(lL, A2(lu, ny, cf), A2(hL, $h(n.d2), A2(sL, st(p(A3(Cv, n.gH, "", u.bt), u.be ? "*" : "")), A2(uL, y([
                                        yB(Lt(e))
                                    ]), dB))))), A2(b, u.be ? {
                                        ap: !0
                                    } : {
                                        ap: !1
                                    }, {
                                        bt: "",
                                        bL: ""
                                    }), A2(Qe, b({
                                        ap: !1
                                    }), s)),
                                    _B({
                                        aF: n,
                                        iN: c
                                    })
                                ]);
                            case 2:
                                return o = $h(n.d2), y([
                                    MN(A2(TH, pd(c), A2(NH, A2(lu, ny, cf), A2(CH, o, A2(PH, st(p(A3(Cv, n.gH, "", u.bt), u.be ? "*" : "")), A2(aL, y([
                                        yB(Lt(e))
                                    ]), Wy)))))),
                                    _B({
                                        aF: n,
                                        iN: c
                                    })
                                ]);
                            case 3:
                                return s = r.aS.h4({
                                    eH: t.a.eH,
                                    e3: t.a.e3
                                }), b = F2(function(n, t) {
                                    var e = t.bt;
                                    return A2(rL, A2(oL, n.ap, bB({
                                        bL: t.bL
                                    })), A3(Cv, r, "", e));
                                }), y([
                                    A3(qN, A2(pL, pd(c), A2(lL, A2(lu, ny, cf), A2(hL, $h(n.d2), A2(sL, st(p(A3(Cv, n.gH, "", u.bt), u.be ? "*" : "")), A2(uL, y([
                                        yB(Lt(e))
                                    ]), dB))))), A2(b, u.be ? {
                                        ap: !0
                                    } : {
                                        ap: !1
                                    }, {
                                        bt: A2(wL, r.gX, ""),
                                        bL: ""
                                    }), A2(Qe, b({
                                        ap: !1
                                    }), s)),
                                    _B({
                                        aF: n,
                                        iN: c
                                    })
                                ]);
                            default:
                                var l = t.a.hM, v = t.a.d7, g = 1 === (x = n.fv).$ ? U_(u.br) : A2(Ho, "persons", y([
                                    Lt(x.a),
                                    u.br
                                ])), $ = (k = h(A2(kB, g, n.gH.aj), $h(n.d2)), o = k.a.$ ? k.b.$ ? dt : st(xt(k.b.a)) : st(wt(k.a.a)), function() {
                                    if (1 === o.$) return !1;
                                    if (!o.a.$) return !1;
                                    switch(o.a.a.$){
                                        case 0:
                                        case 1:
                                            return !0;
                                        default:
                                            return !1;
                                    }
                                }()), m = 1 === o.$ ? "" : o.a.$ ? o.a.a.a.dj : hh(o.a.a);
                                return y([
                                    A3(jx, "x-user-upload", y([
                                        A2(sx, "filereplaced", A2(He, A2(ey, {
                                            hM: l
                                        }, g), A2(iu, "detail", vB))),
                                        A2(tx, "accept", ha(v))
                                    ]), y([
                                        A2(Lv, y([
                                            A2(Yy, "slot", "root")
                                        ]), y([
                                            MN(A2(TH, pd(c), A2(NH, function() {
                                                return ny(n.d2);
                                            }, A2(CH, st(m), A2(PH, st(p(A3(Cv, n.gH, "", u.bt), u.be ? "*" : "")), A2(mL, st(A3(lB, ql, w, y([
                                                eN(A2(iL, !$, A2(gL, 2, oB)))
                                            ]))), A2(aL, y([
                                                yB(Lt(e))
                                            ]), Wy)))))))
                                        ]))
                                    ])),
                                    _B({
                                        aF: n,
                                        iN: (_ = A2(ju, function(r) {
                                            if (!r.$) return dt;
                                            switch(r.a.$){
                                                case 0:
                                                case 1:
                                                    return st({
                                                        cY: A3(Cv, n.gH, "", qf(function(n) {
                                                            switch(n){
                                                                case 0:
                                                                    return "Die Datei wird noch hochgeladen.";
                                                                case 1:
                                                                    return "The file is still uploading.";
                                                                case 2:
                                                                    return "El archivo a\xfan se est\xe1 cargando.";
                                                                case 3:
                                                                    return "Le fichier est en cours de t\xe9l\xe9chargement.";
                                                                default:
                                                                    return "\u0424\u0430\u0439\u043B \u0432\u0441\u0435 \u0435\u0449\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F.";
                                                            }
                                                        })),
                                                        e$: Lt(e),
                                                        fd: n.b$
                                                    });
                                                case 2:
                                                    return st({
                                                        cY: A3(Cv, n.gH, "", qf(function(n) {
                                                            switch(n){
                                                                case 0:
                                                                    return "Die Datei konnte nicht hochgeladen werden.";
                                                                case 1:
                                                                    return "The file failed to upload.";
                                                                case 2:
                                                                    return "No se ha podido cargar el archivo.";
                                                                case 3:
                                                                    return "Le fichier n'a pas pu \xeatre t\xe9l\xe9charg\xe9.";
                                                                default:
                                                                    return "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B.";
                                                            }
                                                        })),
                                                        e$: Lt(e),
                                                        fd: n.b$
                                                    });
                                                default:
                                                    return st({
                                                        cY: A3(Cv, n.gH, "", qf(function(n) {
                                                            switch(n){
                                                                case 0:
                                                                    return "Die Datei ist zu gro\xdf (max. " + A2(kL, n, l) + ").";
                                                                case 1:
                                                                    return "The file is too large (max. " + A2(kL, n, l) + ").";
                                                                case 2:
                                                                    return "El fichero es demasiado grande (m\xe1x. " + A2(kL, n, l) + ").";
                                                                case 3:
                                                                    return "Le fichier est trop important (max. " + A2(kL, n, l) + ").";
                                                                default:
                                                                    return "\u0424\u0430\u0439\u043B \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u0435\u043B\u0438\u043A (\u043C\u0430\u043A\u0441. " + A2(kL, n, l) + ").";
                                                            }
                                                        })),
                                                        e$: Lt(e),
                                                        fd: n.b$
                                                    });
                                            }
                                        }, o), A2(ju, function() {
                                            return A2(Nd, c, _);
                                        }, c))
                                    })
                                ]);
                        }
                        var k, _, x;
                    }())
                ]);
            },
            hK: function(n) {
                var r = n.ii;
                return A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), A2(Gk, $(Nv, {
                    ie: wA
                }), A3(Cv, n.gH, "", r)));
            },
            hP: function() {
                return w;
            },
            hR: function(n) {
                var r, t = A2(_i, w, A2(Yu, No, A2(ju, Si(n.dX), A2(ju, function(n) {
                    return n.eR;
                }, n.gH.cI)))), e = p(n.dY, t);
                return r = ei(A2(lu, A2(io, ii, e), function(n) {
                    return n.fZ;
                }))(n.gH.aB), A2(ci, A2(lu, kd, function(n) {
                    return n.el;
                }), r) ? A2(ei, A2(lu, kd, function(n) {
                    return n.el;
                }), r) : r;
            },
            h2: function(n) {
                var r, t, e = n.iI, u = n.g7, c = n.iM, i = n.hV, o = n.h6;
                if (a(n.d2.b0, n.b$)) {
                    var f = function(r) {
                        var t;
                        return A2(Lv, y([
                            Jl("page-button--prev")
                        ]), y([
                            A2(MP, A2(BH, ny((t = n.d2, $(t, {
                                b0: r
                            }))), Qy), A3(Cv, n.gH, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "Zur\xfcck";
                                    case 1:
                                        return "Back";
                                    case 2:
                                        return "Atr\xe1s";
                                    case 3:
                                        return "Retour";
                                    default:
                                        return "\u041D\u0430\u0437\u0430\u0434";
                                }
                            })))
                        ]));
                    }, s = pd(i);
                    return y([
                        A2(WN, y([
                            Jl("page"),
                            yB(Lt(n.e$))
                        ]), y([
                            A2(Lv, y([
                                Jl("page__form form-field-wrapper")
                            ]), u),
                            s ? A3(no, kv(""), A2(lu, function(r) {
                                return A2(Lv, y([
                                    Jl("form-field--global-validation form-field-wrapper form-field--invalid")
                                ]), y([
                                    _B({
                                        aF: n,
                                        iN: st($(r, {
                                            cY: A3(Cv, n.gH, "", qf(function(n) {
                                                return 1 === n ? "Your order is incomplete. Please complete the pages marked in red." : "Ihre Bestellung ist unvollst\xe4ndig. Bitte erg\xe4nzen Sie die im Men\xfc rot hervorgehobenen Seiten.";
                                            }))
                                        }))
                                    })
                                ]));
                            }, ld), a(n.d2.cn, ed) ? A2(ju, IP(A2(lu, Tc(n.b$), function(n) {
                                return n.fd;
                            })), e) : dt) : kv(""),
                            A2(Lv, y([
                                Jl("page__buttons")
                            ]), A2(bt, (r = i, A2(Lv, y([
                                Jl("page-button--next")
                            ]), y([
                                A2(KN, A2(BH, (t = n.d2, r.$ ? c && a(e, dt) ? ty : ny($(t, {
                                    cn: ed
                                })) : ny($(t, c ? {
                                    b0: r.a
                                } : {
                                    cn: A3(Ct, aN, t.cn, n.bc ? y([
                                        n.b$
                                    ]) : A2(Qe, function(r) {
                                        return {
                                            gM: n.b$.gM,
                                            gN: r
                                        };
                                    }, A2(bt, 0, ht(n.d2.h0.dy))))
                                }))), Qy), A3(Cv, n.gH, "", i.$ ? kd(n.gH.ba) ? qf(A2(kh, n.gH, n.ct) ? function(n) {
                                    return 1 === n ? "Update registration incl. payment" : "Kostenpflichtige \xc4nderung vornehmen";
                                } : function(n) {
                                    return 1 === n ? "Update registration" : "\xc4nderung vornehmen";
                                }) : qf(A2(kh, n.gH, n.ct) ? function(n) {
                                    switch(n){
                                        case 0:
                                            return "Kostenpflichtige Registrierung abschlie\xdfen";
                                        case 1:
                                            return "Complete registration incl. payment";
                                        case 2:
                                            return "Completar la inscripci\xf3n de pago";
                                        case 3:
                                            return "Finaliser l'inscription payante";
                                        default:
                                            return "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0443";
                                    }
                                } : function(n) {
                                    switch(n){
                                        case 0:
                                            return "Registrierung abschlie\xdfen";
                                        case 1:
                                            return "Complete registration";
                                        case 2:
                                            return "Completar la inscripci\xf3n";
                                        case 3:
                                            return "Finaliser l'inscription";
                                        default:
                                            return "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E";
                                    }
                                }) : qf(function(n) {
                                    switch(n){
                                        case 0:
                                            return "Weiter";
                                        case 1:
                                            return "Next";
                                        case 2:
                                            return "Continuar";
                                        case 3:
                                            return "Prochain";
                                        default:
                                            return "\u0414\u0430\u043B\u0435\u0435";
                                    }
                                })))
                            ]))), zd(y([
                                A2(Yu, f, o)
                            ]))))
                        ]))
                    ]);
                }
                return w;
            },
            dy: function(n) {
                var r = n.bw, t = n.g8, e = A2(lu, A2(lu, A2(lu, A2(lu, Wc, qt(oo)), Qe(Ws)), pi(ge)), vt);
                return p(cd(A2(qt, function(t) {
                    return A3(no, !0, function(n) {
                        return n > 1;
                    }, r.b) ? bt(A2(uv, y([
                        Jl("form-field form-field--full-width")
                    ]), A2(bt, kv(p(A3(Cv, n.gH, "", qf(function(n) {
                        switch(n){
                            case 0:
                                return "Teilnehmende Person ";
                            case 1:
                                return "Participant ";
                            case 2:
                                return "Persona participante ";
                            case 3:
                                return "Personne participante ";
                            default:
                                return "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ";
                        }
                    })), Lt(t + 1))), Kb(n.d2) > 1 ? y([
                        A2(cN, A2(BH, A2(ry, t, e(A2(Mi, t, n.d2))), Qy), A3(Cv, n.gH, "", qf(function(n) {
                            switch(n){
                                case 0:
                                    return "entfernen";
                                case 1:
                                    return "remove";
                                case 2:
                                    return "eliminar";
                                case 3:
                                    return "supprimer";
                                default:
                                    return "\u0443\u0434\u0430\u043B\u0438\u0442\u044C";
                            }
                        })))
                    ]) : w))) : Ne;
                }, t)), A3(no, !1, function(n) {
                    return 1 >= n;
                }, r.b) ? w : y([
                    A2(Lv, y([
                        Jl("form-field form-field--full-width")
                    ]), y([
                        A2(cN, A2(AH, A3(no, !1, md(Kb(n.d2)), r.b), A2(BH, ny(Db(n.d2) ? Wc(y([
                            h(0, pl),
                            h(1, pl)
                        ])) : A3(Kc, Kb(n.d2), pl, n.d2)), Qy)), A3(Cv, n.gH, "", qf(function(n) {
                            switch(n){
                                case 0:
                                    return "Neue Person hinzuf\xfcgen";
                                case 1:
                                    return "Add participant";
                                case 2:
                                    return "A\xf1adir nuevo participante";
                                case 3:
                                    return "Ajouter une nouvelle personne";
                                default:
                                    return "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430";
                            }
                        })))
                    ]))
                ]));
            },
            it: function(n) {
                var r = !A2(Il, function(n) {
                    return !A2(_i, 0, n.fz);
                }, n.gH.aB), t = n.bE({
                    iK: n.e$
                });
                return y([
                    A2(ev, y([
                        Jl("form-field form-field--full-width")
                    ]), y([
                        kv(A3(Cv, n.gH, "", qf(function(n) {
                            switch(n){
                                case 0:
                                    return "Zusammenfassung";
                                case 1:
                                    return "Summary";
                                case 2:
                                    return "Resumen";
                                case 3:
                                    return "R\xe9capitulatif";
                                default:
                                    return "\u041A\u0440\u0430\u0442\u043A\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435";
                            }
                        })))
                    ])),
                    A2(Lv, y([
                        Jl("summary")
                    ]), p(t, function() {
                        if (r) {
                            var t = A2(_h, n.gH, n.ct), e = A2(kh, n.gH, n.ct), u = A3(no, h(dt, {
                                e4: 0,
                                fz: 0
                            }), zf(st), A3(rl, n.gH, n.d2.h0, n.gH.aq)), a = u.a, c = u.b;
                            return y([
                                A3(no, kv(""), function() {
                                    return A2(Lv, y([
                                        Jl("total")
                                    ]), y([
                                        A2(ql, w, y([
                                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                                switch(n){
                                                    case 0:
                                                        return "enthaltene MwSt. (vor Rabatt)";
                                                    case 1:
                                                        return "tax (included before discount)";
                                                    case 2:
                                                        return "IVA incluido (antes del descuento)";
                                                    case 3:
                                                        return "TVA incluse (avant remise)";
                                                    default:
                                                        return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421 (\u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                                }
                                            })))
                                        ])),
                                        A2(ql, w, y([
                                            kv(t ? A2(bh, n.gH.e, t) : A3(Cv, n.gH, "", qf(function(n) {
                                                switch(n){
                                                    case 0:
                                                        return "steuerfrei";
                                                    case 1:
                                                        return "free of tax";
                                                    case 2:
                                                        return "Libre de impuestos";
                                                    case 3:
                                                        return "exon\xe9r\xe9 d'imp\xf4t";
                                                    default:
                                                        return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                                }
                                            })))
                                        ]))
                                    ]));
                                }, a),
                                A3(no, kv(""), function() {
                                    return A2(Lv, y([
                                        Jl("total")
                                    ]), y([
                                        A2(ql, w, y([
                                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                                switch(n){
                                                    case 0:
                                                        return "Gesamtsumme (vor Rabatt)";
                                                    case 1:
                                                        return "Price (total before discount)";
                                                    case 2:
                                                        return "Importe (total antes del descuento)";
                                                    case 3:
                                                        return "Montant total (avant remise)";
                                                    default:
                                                        return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F \u0431\u0435\u0437 \u0443\u0447\u0435\u0442\u0430 \u0441\u043A\u0438\u0434\u043A\u0438)";
                                                }
                                            })))
                                        ])),
                                        A2(ql, w, y([
                                            kv(e ? A2(bh, n.gH.e, e) : A3(Cv, n.gH, "", qf(function(n) {
                                                switch(n){
                                                    case 0:
                                                        return "kostenfrei";
                                                    case 1:
                                                        return "free of cost";
                                                    case 2:
                                                        return "gratis";
                                                    case 3:
                                                        return "gratuit";
                                                    default:
                                                        return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                                }
                                            })))
                                        ]))
                                    ]));
                                }, a),
                                A3(no, kv(""), function(r) {
                                    return A2(Lv, y([
                                        Jl("total")
                                    ]), y([
                                        A2(ql, w, y([
                                            kv(A3(Cv, n.gH, "", qf(function(n) {
                                                switch(n){
                                                    case 0:
                                                        return "Rabatt";
                                                    case 1:
                                                        return "Discount";
                                                    case 2:
                                                        return "Descuento";
                                                    case 3:
                                                        return "Remise";
                                                    default:
                                                        return "\u0421\u043A\u0438\u0434\u043A\u0430";
                                                }
                                            }))),
                                            kv(" ("),
                                            kv(A3(Cv, n.gH, "", r.bt)),
                                            kv(")")
                                        ])),
                                        A2(ql, w, y([
                                            kv(A2(bh, n.gH.e, -c.fz))
                                        ]))
                                    ]));
                                }, a),
                                A2(Lv, y([
                                    Jl("total")
                                ]), y([
                                    A2(ql, w, y([
                                        kv(A3(Cv, n.gH, "", qf(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "enthaltene MwSt.";
                                                case 1:
                                                    return "tax (included)";
                                                case 2:
                                                    return "IVA incluido";
                                                case 3:
                                                    return "TVA incluse";
                                                default:
                                                    return "\u0432\u043A\u043B\u044E\u0447\u0430\u044F \u041D\u0414\u0421";
                                            }
                                        })))
                                    ])),
                                    A2(ql, w, y([
                                        kv(t ? A2(bh, n.gH.e, t - c.e4) : A3(Cv, n.gH, "", qf(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "steuerfrei";
                                                case 1:
                                                    return "free of tax";
                                                case 2:
                                                    return "libre de impuestos";
                                                case 3:
                                                    return "exon\xe9r\xe9 d'imp\xf4t";
                                                default:
                                                    return "\u043D\u0435 \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C";
                                            }
                                        })))
                                    ]))
                                ])),
                                A2(Lv, y([
                                    Jl("total")
                                ]), y([
                                    A2(ql, w, y([
                                        kv(A3(Cv, n.gH, "", qf(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "Gesamtsumme";
                                                case 1:
                                                    return "Price (total)";
                                                case 2:
                                                    return "Importe (total)";
                                                case 3:
                                                    return "Montant total";
                                                default:
                                                    return "\u0426\u0435\u043D\u0430 (\u043E\u0431\u0449\u0430\u044F)";
                                            }
                                        })))
                                    ])),
                                    A2(ql, w, y([
                                        kv(e ? A2(bh, n.gH.e, e - c.fz) : A3(Cv, n.gH, "", qf(function(n) {
                                            switch(n){
                                                case 0:
                                                    return "kostenfrei";
                                                case 1:
                                                    return "free of cost";
                                                case 2:
                                                    return "gratis";
                                                case 3:
                                                    return "gratuit";
                                                default:
                                                    return "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E";
                                            }
                                        })))
                                    ]))
                                ]))
                            ]);
                        }
                        return w;
                    }()))
                ]);
            },
            iE: FL
        }, function(r) {
            return A2(Kk, c, A4(n_, n, u, A2(HL, wA, r), function() {
                return w;
            })).a.iP;
        }), o = A2(Kk, c, i), f = o.a, s = o.b, d = Qk(f.bp);
        return A2(Lv, y([
            Jl("form-wrapper__inner"),
            A2(Yy, "style", Uy(s.gH.aS.eq))
        ]), y([
            A3(no, kv(""), t_(A2(no, OP, function(n) {
                return RP($(u, {
                    b0: n
                }));
            })), A2(Yu, function(r) {
                return A4(r, u.b0, n.ba, d, s);
            }, r)),
            A2(Lv, y([
                Jl("form-wrapper__wrapper")
            ]), y([
                A3(no, kv(""), t_(A2(ma, DP, A2(no, OP, function(n) {
                    return RP($(u, {
                        b0: n
                    }));
                }))), A2(Yu, function(r) {
                    return A3(r, n.ba, d, s);
                }, t)),
                A2(t_, A2(YL, s, f), A3(VP, "div", A2(bt, Jl("form"), A2(Qe, FP(Ve), e)), A2(qt, A2(lu, oo, F2(function(n, r) {
                    return Lt(n.gM) + ":" + Lt(n.gN) + ":" + Lt(r);
                })(u.b0)), f.iP)))
            ]))
        ]));
    }), QL = A2(Lv, y([
        Jl("loading")
    ]), y([
        eN(oB)
    ])), JL = vA(function(n) {
        switch(n.$){
            case 0:
                return pA(n.a);
            case 1:
                return r = n.a, A2(Lv, y([
                    Jl("error-view")
                ]), y([
                    A3(ma, function(n) {
                        return A2(vv, w, y([
                            kv(n)
                        ]));
                    }, Lv(w), Yk(A3(Cv, r, "", qf(function(n) {
                        switch(n){
                            case 0:
                                return "\n# Kontingent ersch\xf6pft\n\nDas Kontingent f\xfcr den Code **" + r.cI + "** ist ersch\xf6pft. Haben Sie sich verschrieben oder sind Sie bereits angemeldet?\n";
                            case 1:
                                return "\n# Quota Exceeded\n\nThe quota for the code **" + r.cI + "** is exceeded. Did you spell the code incorrectly, or have you registered already?\n";
                            case 2:
                                return "\n# Contingente agotado\n\nSe ha superado la cuota para el c\xf3digo **" + r.cI + "** . \xbfHa escrito mal el c\xf3digo o ya se has registrado anteriormente?\n";
                            case 3:
                                return "\nContingent d\xe9pass\xe9\n\nLe contingent pour le code **" + r.cI + "** est d\xe9pass\xe9. Avez-vous fait une erreur ou \xeates-vous d\xe9j\xe0 inscrit ?\n";
                            default:
                                return "\n\u041A\u0432\u043E\u0442\u0430 \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D\u0430\n\n\u041A\u0432\u043E\u0442\u0430 \u0434\u043B\u044F \u043A\u043E\u0434\u0430 **" + r.cI + "** \u0438\u0441\u0447\u0435\u0440\u043F\u0430\u043D\u0430. \u0412\u044B \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043B\u0438 \u043E\u043F\u0435\u0447\u0430\u0442\u043A\u0443 \u0438\u043B\u0438 \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C?\n";
                        }
                    })))),
                    A3(ma, function(n) {
                        return A2(vv, w, y([
                            kv(n)
                        ]));
                    }, Lv(w), Yk(A3(Cv, r, "", qf(function(n) {
                        switch(n){
                            case 0:
                                return "\nBei Fragen zur Registrierung stehen wir Ihnen gern unter den folgenden Kontaktdaten zur Verf\xfcgung:\n\nFrau Shaira Quihano - Telefon: [+49(0)511 898813-16](tel:+49511898813-16) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            case 1:
                                return "\nPlease do not hesitate to contact us in case of any further questions regarding your registration.\n\nPhone: [+49(0)511 898813-0](tel:+49511898813-0) - E-Mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            case 2:
                                return "\nSi tiene alguna pregunta sobre la inscripci\xf3n, no dude en ponerse en contacto con nosotros utilizando los siguientes datos de contacto:\n\nTel\xe9fono: [+49(0)511 898813-0](tel:+49511898813-0) - Correo electr\xf3nico: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            case 3:
                                return "\nSi vous avez des questions concernant l'enregistrement, n'h\xe9sitez pas \xe0 nous contacter aux coordonn\xe9es suivantes:\n\nT\xe9l.: [+49(0)511 898813-0](tel:+49511898813-0) - E-mail: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                            default:
                                return "\n\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u0430\u0448\u0435\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438, \u043E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u043A \u043D\u0430\u043C:\n\n\u0413-\u0436\u0430 \u0421\u0430\u043D\u0434\u0440\u0438\u043D\u0435 \u0427\u0435\u0445, \u0442\u0435\u043B\u0435\u0444\u043E\u043D: [+49(0)511 898813-0](tel:+49511 898813-0) - \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430: [registrierungen@congresscheck.de](mailto:registrierungen@congresscheck.de)\n";
                        }
                    }))))
                ]));
            case 2:
                return function(n) {
                    var r, t = n.v, e = zy(n.B), u = $l(n);
                    return A2(Lv, y([
                        Jl("form-wrapper")
                    ]), y([
                        (r = n, r.aS.hI ? kv("") : A2(Lv, y([
                            Jl("debug-banner")
                        ]), y([
                            kv(A3(Cv, r, "", qf(function(n) {
                                switch(n){
                                    case 0:
                                        return "Die Registrierung befindet sich in der Entwicklung. Zahlung ist NICHT live.";
                                    case 1:
                                        return "This registration is being developed. Payment is NOT live.";
                                    case 2:
                                        return "La inscripci\xf3n est\xe1 en desarrollo. El pago NO est\xe1 activo.";
                                    case 3:
                                        return "L'inscription est en cours de r\xe9alisation. Le paiement n'est PAS en direct.";
                                    default:
                                        return "\u042D\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0430\u0434\u0438\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438. \u0424\u0443\u043D\u043A\u0446\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u041D\u0415 \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \xab\u043B\u0430\u0439\u0444\xbb.";
                                }
                            })))
                        ]))),
                        A2(t_, yA, A6(UL, u, kd(n.aD) ? nP(n.aE) ? dt : st(A3(NP, {
                            gX: n.gX,
                            e: n.e
                        }, n.B, e)) : dt, kd(n.aD) && 1 === nP(n.aE) ? st(A3(zP, {
                            gX: n.gX,
                            e: n.e,
                            bA: n.bA
                        }, n.B, e)) : dt, w, t, e)),
                        A2(QA, A2(jP, _A, A2(qP, A3(no, !1, rP, n.ao), HA)), {
                            gm: y([
                                A2(MP, A2(BH, _A, Qy), "Abbrechen"),
                                A2(MP, A2(XP, y([
                                    JA
                                ]), A2(BH, A3(no, _A, A2(lu, A2(lu, kA, function(n) {
                                    return n.dq;
                                }), KA), n.ao), Qy)), "Enternen")
                            ]),
                            bY: p(y([
                                A2(lv, w, y([
                                    kv("Durch das Entfernen des Teilnehmenden werden die folgenden assoziierten Buchungsdaten entfernt.")
                                ]))
                            ]), A3(no, w, A2(lu, A2(lu, A2(lu, A2(lu, hv, t_(function() {
                                return xA;
                            })), Lv(y([
                                A2(Ml, "opacity", "0.5")
                            ]))), function(n) {
                                return n.bY;
                            }), KA), n.ao)),
                            iG: "Teilnehmenden entfernen"
                        })
                    ]));
                }(n.a);
            case 3:
                return QL;
            case 4:
                return function(n) {
                    return A2(Lv, y([
                        Jl("form")
                    ]), y([
                        A2(Lv, y([
                            Jl("page__form form-field-wrapper")
                        ]), A2(Iv, A2(lu, A2(lu, A2(lu, hv, vv(w)), hv), kv), A2(Gk, $(Nv, {
                            ie: wA
                        }), A3(Cv, n, "", n.ag))))
                    ]));
                }(n.a);
            case 5:
                return function(n) {
                    return A2(Lv, y([
                        Jl("error-view")
                    ]), y([
                        A3(ma, function(n) {
                            return A2(vv, w, y([
                                kv(n)
                            ]));
                        }, Lv(w), Yk(A3(Cv, n, "", qf(function(n) {
                            switch(n){
                                case 0:
                                    return "\n# Zahlung\n\nBitte schlie\xdfen Sie die Zahlung bei unserem externen Zahlungsprovider ab.\n";
                                case 1:
                                    return "\n# Checkout\n\nPlease complete the payment with our external payment provider.\n";
                                case 2:
                                    return "\n# Pago\n\nPor favor, completa el pago con nuestro proveedor de pago externo.\n";
                                case 3:
                                    return "\n# R\xe8glement\n\nVeuillez finaliser le r\xe8glement aupr\xe8s de notre prestataire de paiement externe.\n";
                                default:
                                    return "\n# \u0427\u0435\u043A-\u0430\u0443\u0442\n\n\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u044B\u0445 \u0443\u0441\u043B\u0443\u0433\n";
                            }
                        })))),
                        A3(jx, "slot", y([
                            A2(Yy, "name", "checkout")
                        ]), w)
                    ]));
                }(n.a);
            default:
                return function(n) {
                    return A3(ma, function(r) {
                        return pA({
                            gX: n.gX,
                            cX: hA(r),
                            e: n.e
                        });
                    }, Lv(w), Yk(A3(Cv, n, "", n.bV)));
                }(n.a);
        }
        var r;
    });
    Sk = {
        Frontend: {
            init: cu({
                hw: rb,
                is: $b,
                cv: Oy,
                iP: JL
            })(A2(ye, function(n) {
                return A2(ye, function(r) {
                    return A2(ye, function(t) {
                        return A2(ye, function(e) {
                            return A2(ye, function(u) {
                                return A2(ye, function(a) {
                                    return A2(ye, function(c) {
                                        return A2(ye, function(i) {
                                            return A2(ye, function(o) {
                                                return A2(ye, function(f) {
                                                    return A2(ye, function(s) {
                                                        return A2(ye, function(d) {
                                                            return A2(ye, function(b) {
                                                                return A2(ye, function(l) {
                                                                    return Pe({
                                                                        ad: l,
                                                                        aH: b,
                                                                        cI: d,
                                                                        cJ: s,
                                                                        aq: f,
                                                                        e$: o,
                                                                        ak: i,
                                                                        db: c,
                                                                        e: a,
                                                                        aN: u,
                                                                        B: e,
                                                                        aB: t,
                                                                        d2: r,
                                                                        aE: n
                                                                    });
                                                                }, A2(iu, "auth", xa(y([
                                                                    si(dt),
                                                                    A2(He, st, A2(ye, function(n) {
                                                                        return A2(ye, function(r) {
                                                                            return Pe({
                                                                                gJ: r,
                                                                                gK: n
                                                                            });
                                                                        }, A2(iu, "cookieName", va));
                                                                    }, A2(iu, "cookieValue", va)))
                                                                ]))));
                                                            }, A2(iu, "checkout", xa(y([
                                                                si(dt),
                                                                A2(He, st, hi)
                                                            ]))));
                                                        }, A2(iu, "code", xa(y([
                                                            si(dt),
                                                            A2(He, st, va)
                                                        ]))));
                                                    }, A2(iu, "crashed", xa(y([
                                                        si(dt),
                                                        A2(He, st, va)
                                                    ]))));
                                                }, A2(iu, "discounts", xa(y([
                                                    si(dt),
                                                    A2(He, st, hi)
                                                ]))));
                                            }, A2(iu, "id", xa(y([
                                                si(dt),
                                                A2(He, st, va)
                                            ]))));
                                        }, A2(iu, "idempotencyToken", va));
                                    }, A2(iu, "loading", xa(y([
                                        si(dt),
                                        A2(He, st, xe)
                                    ]))));
                                }, A2(iu, "locale", xa(y([
                                    si(dt),
                                    A2(He, st, va)
                                ]))));
                            }, A2(iu, "origin", va));
                        }, A2(iu, "pages", xa(y([
                            si(dt),
                            A2(He, st, hi)
                        ]))));
                    }, A2(iu, "tickets", xa(y([
                        si(dt),
                        A2(He, st, hi)
                    ]))));
                }, A2(iu, "values", xa(y([
                    si(dt),
                    A2(He, st, hi)
                ]))));
            }, A2(iu, "width", xa(y([
                si(dt),
                A2(He, st, Mo)
            ])))))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Sk) : n.Elm = Sk;
}($b0acb6cf65ffb89e$exports);


var $694f8530f561f6d3$exports = {};
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/material-components/material-components-web/blob/master/LICENSE
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $694f8530f561f6d3$exports = factory();
})($694f8530f561f6d3$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./packages/material-components-web/index.ts");
    /******/ }({
        /***/ "./node_modules/@webcomponents/custom-elements/custom-elements.min.js": /*!****************************************************************************!*\
  !*** ./node_modules/@webcomponents/custom-elements/custom-elements.min.js ***!
  \****************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            (function() {
                /*

 Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 This code may only be used under the BSD style license found at
 http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 Google as part of the polymer project is also subject to an additional IP
 rights grant found at http://polymer.github.io/PATENTS.txt
*/ "use strict";
                var n = window.Document.prototype.createElement, p = window.Document.prototype.createElementNS, aa = window.Document.prototype.importNode, ba = window.Document.prototype.prepend, ca = window.Document.prototype.append, da = window.DocumentFragment.prototype.prepend, ea = window.DocumentFragment.prototype.append, q = window.Node.prototype.cloneNode, r = window.Node.prototype.appendChild, t = window.Node.prototype.insertBefore, u = window.Node.prototype.removeChild, v = window.Node.prototype.replaceChild, w = Object.getOwnPropertyDescriptor(window.Node.prototype, "textContent"), y = window.Element.prototype.attachShadow, z = Object.getOwnPropertyDescriptor(window.Element.prototype, "innerHTML"), A = window.Element.prototype.getAttribute, B = window.Element.prototype.setAttribute, C = window.Element.prototype.removeAttribute, D = window.Element.prototype.toggleAttribute, E = window.Element.prototype.getAttributeNS, F = window.Element.prototype.setAttributeNS, G = window.Element.prototype.removeAttributeNS, H = window.Element.prototype.insertAdjacentElement, fa = window.Element.prototype.insertAdjacentHTML, ha = window.Element.prototype.prepend, ia = window.Element.prototype.append, ja = window.Element.prototype.before, ka = window.Element.prototype.after, la = window.Element.prototype.replaceWith, ma = window.Element.prototype.remove, na = window.HTMLElement, I = Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, "innerHTML"), oa = window.HTMLElement.prototype.insertAdjacentElement, pa = window.HTMLElement.prototype.insertAdjacentHTML;
                var qa = new Set;
                "annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" ").forEach(function(a) {
                    return qa.add(a);
                });
                function ra(a) {
                    var b = qa.has(a);
                    a = /^[a-z][.0-9_a-z]*-[-.0-9_a-z]*$/.test(a);
                    return !b && a;
                }
                var sa = document.contains ? document.contains.bind(document) : document.documentElement.contains.bind(document.documentElement);
                function J(a) {
                    var b = a.isConnected;
                    if (void 0 !== b) return b;
                    if (sa(a)) return !0;
                    for(; a && !(a.__CE_isImportDocument || a instanceof Document);)a = a.parentNode || (window.ShadowRoot && a instanceof ShadowRoot ? a.host : void 0);
                    return !(!a || !(a.__CE_isImportDocument || a instanceof Document));
                }
                function K(a) {
                    var b = a.children;
                    if (b) return Array.prototype.slice.call(b);
                    b = [];
                    for(a = a.firstChild; a; a = a.nextSibling)a.nodeType === Node.ELEMENT_NODE && b.push(a);
                    return b;
                }
                function L(a, b) {
                    for(; b && b !== a && !b.nextSibling;)b = b.parentNode;
                    return b && b !== a ? b.nextSibling : null;
                }
                function M(a, b, d) {
                    for(var f = a; f;){
                        if (f.nodeType === Node.ELEMENT_NODE) {
                            var c = f;
                            b(c);
                            var e = c.localName;
                            if ("link" === e && "import" === c.getAttribute("rel")) {
                                f = c.import;
                                void 0 === d && (d = new Set);
                                if (f instanceof Node && !d.has(f)) for(d.add(f), f = f.firstChild; f; f = f.nextSibling)M(f, b, d);
                                f = L(a, c);
                                continue;
                            } else if ("template" === e) {
                                f = L(a, c);
                                continue;
                            }
                            if (c = c.__CE_shadowRoot) for(c = c.firstChild; c; c = c.nextSibling)M(c, b, d);
                        }
                        f = f.firstChild ? f.firstChild : L(a, f);
                    }
                }
                function N() {
                    var a = !(null === O || void 0 === O || !O.noDocumentConstructionObserver), b = !(null === O || void 0 === O || !O.shadyDomFastWalk);
                    this.m = [];
                    this.g = [];
                    this.j = !1;
                    this.shadyDomFastWalk = b;
                    this.I = !a;
                }
                function P(a, b, d, f) {
                    var c = window.ShadyDOM;
                    if (a.shadyDomFastWalk && c && c.inUse) {
                        if (b.nodeType === Node.ELEMENT_NODE && d(b), b.querySelectorAll) for(a = c.nativeMethods.querySelectorAll.call(b, "*"), b = 0; b < a.length; b++)d(a[b]);
                    } else M(b, d, f);
                }
                function ta(a, b) {
                    a.j = !0;
                    a.m.push(b);
                }
                function ua(a, b) {
                    a.j = !0;
                    a.g.push(b);
                }
                function Q(a, b) {
                    a.j && P(a, b, function(d) {
                        return R(a, d);
                    });
                }
                function R(a, b) {
                    if (a.j && !b.__CE_patched) {
                        b.__CE_patched = !0;
                        for(var d = 0; d < a.m.length; d++)a.m[d](b);
                        for(d = 0; d < a.g.length; d++)a.g[d](b);
                    }
                }
                function S(a, b) {
                    var d = [];
                    P(a, b, function(c) {
                        return d.push(c);
                    });
                    for(b = 0; b < d.length; b++){
                        var f = d[b];
                        1 === f.__CE_state ? a.connectedCallback(f) : T(a, f);
                    }
                }
                function U(a, b) {
                    var d = [];
                    P(a, b, function(c) {
                        return d.push(c);
                    });
                    for(b = 0; b < d.length; b++){
                        var f = d[b];
                        1 === f.__CE_state && a.disconnectedCallback(f);
                    }
                }
                function V(a, b, d) {
                    d = void 0 === d ? {} : d;
                    var f = d.J, c = d.upgrade || function(g) {
                        return T(a, g);
                    }, e = [];
                    P(a, b, function(g) {
                        a.j && R(a, g);
                        if ("link" === g.localName && "import" === g.getAttribute("rel")) {
                            var h = g.import;
                            h instanceof Node && (h.__CE_isImportDocument = !0, h.__CE_registry = document.__CE_registry);
                            h && "complete" === h.readyState ? h.__CE_documentLoadHandled = !0 : g.addEventListener("load", function() {
                                var k = g.import;
                                if (!k.__CE_documentLoadHandled) {
                                    k.__CE_documentLoadHandled = !0;
                                    var l = new Set;
                                    f && (f.forEach(function(m) {
                                        return l.add(m);
                                    }), l.delete(k));
                                    V(a, k, {
                                        J: l,
                                        upgrade: c
                                    });
                                }
                            });
                        } else e.push(g);
                    }, f);
                    for(b = 0; b < e.length; b++)c(e[b]);
                }
                function T(a, b) {
                    try {
                        var d = b.ownerDocument, f = d.__CE_registry;
                        var c = f && (d.defaultView || d.__CE_isImportDocument) ? W(f, b.localName) : void 0;
                        if (c && void 0 === b.__CE_state) {
                            c.constructionStack.push(b);
                            try {
                                try {
                                    if (new c.constructorFunction !== b) throw Error("The custom element constructor did not produce the element being upgraded.");
                                } finally{
                                    c.constructionStack.pop();
                                }
                            } catch (k) {
                                throw b.__CE_state = 2, k;
                            }
                            b.__CE_state = 1;
                            b.__CE_definition = c;
                            if (c.attributeChangedCallback && b.hasAttributes()) {
                                var e = c.observedAttributes;
                                for(c = 0; c < e.length; c++){
                                    var g = e[c], h = b.getAttribute(g);
                                    null !== h && a.attributeChangedCallback(b, g, null, h, null);
                                }
                            }
                            J(b) && a.connectedCallback(b);
                        }
                    } catch (k) {
                        X(k);
                    }
                }
                N.prototype.connectedCallback = function(a) {
                    var b = a.__CE_definition;
                    if (b.connectedCallback) try {
                        b.connectedCallback.call(a);
                    } catch (d) {
                        X(d);
                    }
                };
                N.prototype.disconnectedCallback = function(a) {
                    var b = a.__CE_definition;
                    if (b.disconnectedCallback) try {
                        b.disconnectedCallback.call(a);
                    } catch (d) {
                        X(d);
                    }
                };
                N.prototype.attributeChangedCallback = function(a, b, d, f, c) {
                    var e = a.__CE_definition;
                    if (e.attributeChangedCallback && -1 < e.observedAttributes.indexOf(b)) try {
                        e.attributeChangedCallback.call(a, b, d, f, c);
                    } catch (g) {
                        X(g);
                    }
                };
                function va(a, b, d, f) {
                    var c = b.__CE_registry;
                    if (c && (null === f || "http://www.w3.org/1999/xhtml" === f) && (c = W(c, d))) try {
                        var e = new c.constructorFunction;
                        if (void 0 === e.__CE_state || void 0 === e.__CE_definition) throw Error("Failed to construct '" + d + "': The returned value was not constructed with the HTMLElement constructor.");
                        if ("http://www.w3.org/1999/xhtml" !== e.namespaceURI) throw Error("Failed to construct '" + d + "': The constructed element's namespace must be the HTML namespace.");
                        if (e.hasAttributes()) throw Error("Failed to construct '" + d + "': The constructed element must not have any attributes.");
                        if (null !== e.firstChild) throw Error("Failed to construct '" + d + "': The constructed element must not have any children.");
                        if (null !== e.parentNode) throw Error("Failed to construct '" + d + "': The constructed element must not have a parent node.");
                        if (e.ownerDocument !== b) throw Error("Failed to construct '" + d + "': The constructed element's owner document is incorrect.");
                        if (e.localName !== d) throw Error("Failed to construct '" + d + "': The constructed element's local name is incorrect.");
                        return e;
                    } catch (g) {
                        return X(g), b = null === f ? n.call(b, d) : p.call(b, f, d), Object.setPrototypeOf(b, HTMLUnknownElement.prototype), b.__CE_state = 2, b.__CE_definition = void 0, R(a, b), b;
                    }
                    b = null === f ? n.call(b, d) : p.call(b, f, d);
                    R(a, b);
                    return b;
                }
                function X(a) {
                    var b = "", d = "", f = 0, c = 0;
                    a instanceof Error ? (b = a.message, d = a.sourceURL || a.fileName || "", f = a.line || a.lineNumber || 0, c = a.column || a.columnNumber || 0) : b = "Uncaught " + String(a);
                    var e = void 0;
                    void 0 === ErrorEvent.prototype.initErrorEvent ? e = new ErrorEvent("error", {
                        cancelable: !0,
                        message: b,
                        filename: d,
                        lineno: f,
                        colno: c,
                        error: a
                    }) : (e = document.createEvent("ErrorEvent"), e.initErrorEvent("error", !1, !0, b, d, f), e.preventDefault = function() {
                        Object.defineProperty(this, "defaultPrevented", {
                            configurable: !0,
                            get: function() {
                                return !0;
                            }
                        });
                    });
                    void 0 === e.error && Object.defineProperty(e, "error", {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return a;
                        }
                    });
                    window.dispatchEvent(e);
                    e.defaultPrevented || console.error(a);
                }
                function wa() {
                    var a = this;
                    this.g = void 0;
                    this.F = new Promise(function(b) {
                        a.l = b;
                    });
                }
                wa.prototype.resolve = function(a) {
                    if (this.g) throw Error("Already resolved.");
                    this.g = a;
                    this.l(a);
                };
                function xa(a) {
                    var b = document;
                    this.l = void 0;
                    this.h = a;
                    this.g = b;
                    V(this.h, this.g);
                    "loading" === this.g.readyState && (this.l = new MutationObserver(this.G.bind(this)), this.l.observe(this.g, {
                        childList: !0,
                        subtree: !0
                    }));
                }
                function ya(a) {
                    a.l && a.l.disconnect();
                }
                xa.prototype.G = function(a) {
                    var b = this.g.readyState;
                    "interactive" !== b && "complete" !== b || ya(this);
                    for(b = 0; b < a.length; b++)for(var d = a[b].addedNodes, f = 0; f < d.length; f++)V(this.h, d[f]);
                };
                function Y(a) {
                    this.s = new Map;
                    this.u = new Map;
                    this.C = new Map;
                    this.A = !1;
                    this.B = new Map;
                    this.o = function(b) {
                        return b();
                    };
                    this.i = !1;
                    this.v = [];
                    this.h = a;
                    this.D = a.I ? new xa(a) : void 0;
                }
                Y.prototype.H = function(a, b) {
                    var d = this;
                    if (!(b instanceof Function)) throw new TypeError("Custom element constructor getters must be functions.");
                    za(this, a);
                    this.s.set(a, b);
                    this.v.push(a);
                    this.i || (this.i = !0, this.o(function() {
                        return Aa(d);
                    }));
                };
                Y.prototype.define = function(a, b) {
                    var d = this;
                    if (!(b instanceof Function)) throw new TypeError("Custom element constructors must be functions.");
                    za(this, a);
                    Ba(this, a, b);
                    this.v.push(a);
                    this.i || (this.i = !0, this.o(function() {
                        return Aa(d);
                    }));
                };
                function za(a, b) {
                    if (!ra(b)) throw new SyntaxError("The element name '" + b + "' is not valid.");
                    if (W(a, b)) throw Error("A custom element with name '" + (b + "' has already been defined."));
                    if (a.A) throw Error("A custom element is already being defined.");
                }
                function Ba(a, b, d) {
                    a.A = !0;
                    var f;
                    try {
                        var c = d.prototype;
                        if (!(c instanceof Object)) throw new TypeError("The custom element constructor's prototype is not an object.");
                        var e = function(m) {
                            var x = c[m];
                            if (void 0 !== x && !(x instanceof Function)) throw Error("The '" + m + "' callback must be a function.");
                            return x;
                        };
                        var g = e("connectedCallback");
                        var h = e("disconnectedCallback");
                        var k = e("adoptedCallback");
                        var l = (f = e("attributeChangedCallback")) && d.observedAttributes || [];
                    } catch (m) {
                        throw m;
                    } finally{
                        a.A = !1;
                    }
                    d = {
                        localName: b,
                        constructorFunction: d,
                        connectedCallback: g,
                        disconnectedCallback: h,
                        adoptedCallback: k,
                        attributeChangedCallback: f,
                        observedAttributes: l,
                        constructionStack: []
                    };
                    a.u.set(b, d);
                    a.C.set(d.constructorFunction, d);
                    return d;
                }
                Y.prototype.upgrade = function(a) {
                    V(this.h, a);
                };
                function Aa(a) {
                    if (!1 !== a.i) {
                        a.i = !1;
                        for(var b = [], d = a.v, f = new Map, c = 0; c < d.length; c++)f.set(d[c], []);
                        V(a.h, document, {
                            upgrade: function(k) {
                                if (void 0 === k.__CE_state) {
                                    var l = k.localName, m = f.get(l);
                                    m ? m.push(k) : a.u.has(l) && b.push(k);
                                }
                            }
                        });
                        for(c = 0; c < b.length; c++)T(a.h, b[c]);
                        for(c = 0; c < d.length; c++){
                            for(var e = d[c], g = f.get(e), h = 0; h < g.length; h++)T(a.h, g[h]);
                            (e = a.B.get(e)) && e.resolve(void 0);
                        }
                        d.length = 0;
                    }
                }
                Y.prototype.get = function(a) {
                    if (a = W(this, a)) return a.constructorFunction;
                };
                Y.prototype.whenDefined = function(a) {
                    if (!ra(a)) return Promise.reject(new SyntaxError("'" + a + "' is not a valid custom element name."));
                    var b = this.B.get(a);
                    if (b) return b.F;
                    b = new wa;
                    this.B.set(a, b);
                    var d = this.u.has(a) || this.s.has(a);
                    a = -1 === this.v.indexOf(a);
                    d && a && b.resolve(void 0);
                    return b.F;
                };
                Y.prototype.polyfillWrapFlushCallback = function(a) {
                    this.D && ya(this.D);
                    var b = this.o;
                    this.o = function(d) {
                        return a(function() {
                            return b(d);
                        });
                    };
                };
                function W(a, b) {
                    var d = a.u.get(b);
                    if (d) return d;
                    if (d = a.s.get(b)) {
                        a.s.delete(b);
                        try {
                            return Ba(a, b, d());
                        } catch (f) {
                            X(f);
                        }
                    }
                }
                Y.prototype.define = Y.prototype.define;
                Y.prototype.upgrade = Y.prototype.upgrade;
                Y.prototype.get = Y.prototype.get;
                Y.prototype.whenDefined = Y.prototype.whenDefined;
                Y.prototype.polyfillDefineLazy = Y.prototype.H;
                Y.prototype.polyfillWrapFlushCallback = Y.prototype.polyfillWrapFlushCallback;
                function Z(a, b, d) {
                    function f(c) {
                        return function(e) {
                            for(var g = [], h = 0; h < arguments.length; ++h)g[h] = arguments[h];
                            h = [];
                            for(var k = [], l = 0; l < g.length; l++){
                                var m = g[l];
                                m instanceof Element && J(m) && k.push(m);
                                if (m instanceof DocumentFragment) for(m = m.firstChild; m; m = m.nextSibling)h.push(m);
                                else h.push(m);
                            }
                            c.apply(this, g);
                            for(g = 0; g < k.length; g++)U(a, k[g]);
                            if (J(this)) for(g = 0; g < h.length; g++)k = h[g], k instanceof Element && S(a, k);
                        };
                    }
                    void 0 !== d.prepend && (b.prepend = f(d.prepend));
                    void 0 !== d.append && (b.append = f(d.append));
                }
                function Ca(a) {
                    Document.prototype.createElement = function(b) {
                        return va(a, this, b, null);
                    };
                    Document.prototype.importNode = function(b, d) {
                        b = aa.call(this, b, !!d);
                        this.__CE_registry ? V(a, b) : Q(a, b);
                        return b;
                    };
                    Document.prototype.createElementNS = function(b, d) {
                        return va(a, this, d, b);
                    };
                    Z(a, Document.prototype, {
                        prepend: ba,
                        append: ca
                    });
                }
                function Da(a) {
                    function b(f) {
                        return function(c) {
                            for(var e = [], g = 0; g < arguments.length; ++g)e[g] = arguments[g];
                            g = [];
                            for(var h = [], k = 0; k < e.length; k++){
                                var l = e[k];
                                l instanceof Element && J(l) && h.push(l);
                                if (l instanceof DocumentFragment) for(l = l.firstChild; l; l = l.nextSibling)g.push(l);
                                else g.push(l);
                            }
                            f.apply(this, e);
                            for(e = 0; e < h.length; e++)U(a, h[e]);
                            if (J(this)) for(e = 0; e < g.length; e++)h = g[e], h instanceof Element && S(a, h);
                        };
                    }
                    var d = Element.prototype;
                    void 0 !== ja && (d.before = b(ja));
                    void 0 !== ka && (d.after = b(ka));
                    void 0 !== la && (d.replaceWith = function(f) {
                        for(var c = [], e = 0; e < arguments.length; ++e)c[e] = arguments[e];
                        e = [];
                        for(var g = [], h = 0; h < c.length; h++){
                            var k = c[h];
                            k instanceof Element && J(k) && g.push(k);
                            if (k instanceof DocumentFragment) for(k = k.firstChild; k; k = k.nextSibling)e.push(k);
                            else e.push(k);
                        }
                        h = J(this);
                        la.apply(this, c);
                        for(c = 0; c < g.length; c++)U(a, g[c]);
                        if (h) for(U(a, this), c = 0; c < e.length; c++)g = e[c], g instanceof Element && S(a, g);
                    });
                    void 0 !== ma && (d.remove = function() {
                        var f = J(this);
                        ma.call(this);
                        f && U(a, this);
                    });
                }
                function Ea(a) {
                    function b(c, e) {
                        Object.defineProperty(c, "innerHTML", {
                            enumerable: e.enumerable,
                            configurable: !0,
                            get: e.get,
                            set: function(g) {
                                var h = this, k = void 0;
                                J(this) && (k = [], P(a, this, function(x) {
                                    x !== h && k.push(x);
                                }));
                                e.set.call(this, g);
                                if (k) for(var l = 0; l < k.length; l++){
                                    var m = k[l];
                                    1 === m.__CE_state && a.disconnectedCallback(m);
                                }
                                this.ownerDocument.__CE_registry ? V(a, this) : Q(a, this);
                                return g;
                            }
                        });
                    }
                    function d(c, e) {
                        c.insertAdjacentElement = function(g, h) {
                            var k = J(h);
                            g = e.call(this, g, h);
                            k && U(a, h);
                            J(g) && S(a, h);
                            return g;
                        };
                    }
                    function f(c, e) {
                        function g(h, k) {
                            for(var l = []; h !== k; h = h.nextSibling)l.push(h);
                            for(k = 0; k < l.length; k++)V(a, l[k]);
                        }
                        c.insertAdjacentHTML = function(h, k) {
                            h = h.toLowerCase();
                            if ("beforebegin" === h) {
                                var l = this.previousSibling;
                                e.call(this, h, k);
                                g(l || this.parentNode.firstChild, this);
                            } else if ("afterbegin" === h) l = this.firstChild, e.call(this, h, k), g(this.firstChild, l);
                            else if ("beforeend" === h) l = this.lastChild, e.call(this, h, k), g(l || this.firstChild, null);
                            else if ("afterend" === h) l = this.nextSibling, e.call(this, h, k), g(this.nextSibling, l);
                            else throw new SyntaxError("The value provided (" + String(h) + ") is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
                        };
                    }
                    y && (Element.prototype.attachShadow = function(c) {
                        c = y.call(this, c);
                        if (a.j && !c.__CE_patched) {
                            c.__CE_patched = !0;
                            for(var e = 0; e < a.m.length; e++)a.m[e](c);
                        }
                        return this.__CE_shadowRoot = c;
                    });
                    z && z.get ? b(Element.prototype, z) : I && I.get ? b(HTMLElement.prototype, I) : ua(a, function(c) {
                        b(c, {
                            enumerable: !0,
                            configurable: !0,
                            get: function() {
                                return q.call(this, !0).innerHTML;
                            },
                            set: function(e) {
                                var g = "template" === this.localName, h = g ? this.content : this, k = p.call(document, this.namespaceURI, this.localName);
                                for(k.innerHTML = e; 0 < h.childNodes.length;)u.call(h, h.childNodes[0]);
                                for(e = g ? k.content : k; 0 < e.childNodes.length;)r.call(h, e.childNodes[0]);
                            }
                        });
                    });
                    Element.prototype.setAttribute = function(c, e) {
                        if (1 !== this.__CE_state) return B.call(this, c, e);
                        var g = A.call(this, c);
                        B.call(this, c, e);
                        e = A.call(this, c);
                        a.attributeChangedCallback(this, c, g, e, null);
                    };
                    Element.prototype.setAttributeNS = function(c, e, g) {
                        if (1 !== this.__CE_state) return F.call(this, c, e, g);
                        var h = E.call(this, c, e);
                        F.call(this, c, e, g);
                        g = E.call(this, c, e);
                        a.attributeChangedCallback(this, e, h, g, c);
                    };
                    Element.prototype.removeAttribute = function(c) {
                        if (1 !== this.__CE_state) return C.call(this, c);
                        var e = A.call(this, c);
                        C.call(this, c);
                        null !== e && a.attributeChangedCallback(this, c, e, null, null);
                    };
                    D && (Element.prototype.toggleAttribute = function(c, e) {
                        if (1 !== this.__CE_state) return D.call(this, c, e);
                        var g = A.call(this, c), h = null !== g;
                        e = D.call(this, c, e);
                        h !== e && a.attributeChangedCallback(this, c, g, e ? "" : null, null);
                        return e;
                    });
                    Element.prototype.removeAttributeNS = function(c, e) {
                        if (1 !== this.__CE_state) return G.call(this, c, e);
                        var g = E.call(this, c, e);
                        G.call(this, c, e);
                        var h = E.call(this, c, e);
                        g !== h && a.attributeChangedCallback(this, e, g, h, c);
                    };
                    oa ? d(HTMLElement.prototype, oa) : H && d(Element.prototype, H);
                    pa ? f(HTMLElement.prototype, pa) : fa && f(Element.prototype, fa);
                    Z(a, Element.prototype, {
                        prepend: ha,
                        append: ia
                    });
                    Da(a);
                }
                var Fa = {};
                function Ga(a) {
                    function b() {
                        var d = this.constructor;
                        var f = document.__CE_registry.C.get(d);
                        if (!f) throw Error("Failed to construct a custom element: The constructor was not registered with `customElements`.");
                        var c = f.constructionStack;
                        if (0 === c.length) return c = n.call(document, f.localName), Object.setPrototypeOf(c, d.prototype), c.__CE_state = 1, c.__CE_definition = f, R(a, c), c;
                        var e = c.length - 1, g = c[e];
                        if (g === Fa) throw Error("Failed to construct '" + f.localName + "': This element was already constructed.");
                        c[e] = Fa;
                        Object.setPrototypeOf(g, d.prototype);
                        R(a, g);
                        return g;
                    }
                    b.prototype = na.prototype;
                    Object.defineProperty(HTMLElement.prototype, "constructor", {
                        writable: !0,
                        configurable: !0,
                        enumerable: !1,
                        value: b
                    });
                    window.HTMLElement = b;
                }
                function Ha(a) {
                    function b(d, f) {
                        Object.defineProperty(d, "textContent", {
                            enumerable: f.enumerable,
                            configurable: !0,
                            get: f.get,
                            set: function(c) {
                                if (this.nodeType === Node.TEXT_NODE) f.set.call(this, c);
                                else {
                                    var e = void 0;
                                    if (this.firstChild) {
                                        var g = this.childNodes, h = g.length;
                                        if (0 < h && J(this)) {
                                            e = Array(h);
                                            for(var k = 0; k < h; k++)e[k] = g[k];
                                        }
                                    }
                                    f.set.call(this, c);
                                    if (e) for(c = 0; c < e.length; c++)U(a, e[c]);
                                }
                            }
                        });
                    }
                    Node.prototype.insertBefore = function(d, f) {
                        if (d instanceof DocumentFragment) {
                            var c = K(d);
                            d = t.call(this, d, f);
                            if (J(this)) for(f = 0; f < c.length; f++)S(a, c[f]);
                            return d;
                        }
                        c = d instanceof Element && J(d);
                        f = t.call(this, d, f);
                        c && U(a, d);
                        J(this) && S(a, d);
                        return f;
                    };
                    Node.prototype.appendChild = function(d) {
                        if (d instanceof DocumentFragment) {
                            var f = K(d);
                            d = r.call(this, d);
                            if (J(this)) for(var c = 0; c < f.length; c++)S(a, f[c]);
                            return d;
                        }
                        f = d instanceof Element && J(d);
                        c = r.call(this, d);
                        f && U(a, d);
                        J(this) && S(a, d);
                        return c;
                    };
                    Node.prototype.cloneNode = function(d) {
                        d = q.call(this, !!d);
                        this.ownerDocument.__CE_registry ? V(a, d) : Q(a, d);
                        return d;
                    };
                    Node.prototype.removeChild = function(d) {
                        var f = d instanceof Element && J(d), c = u.call(this, d);
                        f && U(a, d);
                        return c;
                    };
                    Node.prototype.replaceChild = function(d, f) {
                        if (d instanceof DocumentFragment) {
                            var c = K(d);
                            d = v.call(this, d, f);
                            if (J(this)) for(U(a, f), f = 0; f < c.length; f++)S(a, c[f]);
                            return d;
                        }
                        c = d instanceof Element && J(d);
                        var e = v.call(this, d, f), g = J(this);
                        g && U(a, f);
                        c && U(a, d);
                        g && S(a, d);
                        return e;
                    };
                    w && w.get ? b(Node.prototype, w) : ta(a, function(d) {
                        b(d, {
                            enumerable: !0,
                            configurable: !0,
                            get: function() {
                                for(var f = [], c = this.firstChild; c; c = c.nextSibling)c.nodeType !== Node.COMMENT_NODE && f.push(c.textContent);
                                return f.join("");
                            },
                            set: function(f) {
                                for(; this.firstChild;)u.call(this, this.firstChild);
                                null != f && "" !== f && r.call(this, document.createTextNode(f));
                            }
                        });
                    });
                }
                var O = window.customElements;
                function Ia() {
                    var a = new N;
                    Ga(a);
                    Ca(a);
                    Z(a, DocumentFragment.prototype, {
                        prepend: da,
                        append: ea
                    });
                    Ha(a);
                    Ea(a);
                    window.CustomElementRegistry = Y;
                    a = new Y(a);
                    document.__CE_registry = a;
                    Object.defineProperty(window, "customElements", {
                        configurable: !0,
                        enumerable: !0,
                        value: a
                    });
                }
                O && !O.forcePolyfill && "function" == typeof O.define && "function" == typeof O.get || Ia();
                window.__CE_installPolyfill = Ia;
            }).call(self);
        //# sourceMappingURL=custom-elements.min.js.map
        /***/ },
        /***/ "./node_modules/focus-trap/dist/focus-trap.esm.js": /*!********************************************************!*\
  !*** ./node_modules/focus-trap/dist/focus-trap.esm.js ***!
  \********************************************************/ /*! exports provided: createFocusTrap */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFocusTrap", function() {
                return createFocusTrap;
            });
            /* harmony import */ var tabbable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tabbable */ "./node_modules/tabbable/dist/index.esm.js");
            /*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    })), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread2(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            var activeFocusTraps = function() {
                var trapQueue = [];
                return {
                    activateTrap: function activateTrap(trap) {
                        if (trapQueue.length > 0) {
                            var activeTrap = trapQueue[trapQueue.length - 1];
                            if (activeTrap !== trap) activeTrap.pause();
                        }
                        var trapIndex = trapQueue.indexOf(trap);
                        if (trapIndex === -1) trapQueue.push(trap);
                        else {
                            // move this existing trap to the front of the queue
                            trapQueue.splice(trapIndex, 1);
                            trapQueue.push(trap);
                        }
                    },
                    deactivateTrap: function deactivateTrap(trap) {
                        var trapIndex = trapQueue.indexOf(trap);
                        if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
                        if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
                    }
                };
            }();
            var isSelectableInput = function isSelectableInput(node) {
                return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
            };
            var isEscapeEvent = function isEscapeEvent(e) {
                return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
            };
            var isTabEvent = function isTabEvent(e) {
                return e.key === "Tab" || e.keyCode === 9;
            };
            var delay = function delay(fn) {
                return setTimeout(fn, 0);
            }; // Array.find/findIndex() are not supported on IE; this replicates enough
            //  of Array.findIndex() for our needs
            var findIndex = function findIndex(arr, fn) {
                var idx = -1;
                arr.every(function(value, i) {
                    if (fn(value)) {
                        idx = i;
                        return false; // break
                    }
                    return true; // next
                });
                return idx;
            };
            /**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var valueOrHandler = function valueOrHandler(value) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return typeof value === "function" ? value.apply(void 0, params) : value;
            };
            var getActualTarget = function getActualTarget(event) {
                // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
                //  shadow host. However, event.target.composedPath() will be an array of
                //  nodes "clicked" from inner-most (the actual element inside the shadow) to
                //  outer-most (the host HTML document). If we have access to composedPath(),
                //  then use its first element; otherwise, fall back to event.target (and
                //  this only works for an _open_ shadow DOM; otherwise,
                //  composedPath()[0] === event.target always).
                return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
            };
            var createFocusTrap = function createFocusTrap(elements, userOptions) {
                // SSR: a live trap shouldn't be created in this type of environment so this
                //  should be safe code to execute if the `document` option isn't specified
                var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
                var config = _objectSpread2({
                    returnFocusOnDeactivate: true,
                    escapeDeactivates: true,
                    delayInitialFocus: true
                }, userOptions);
                var state = {
                    // containers given to createFocusTrap()
                    // @type {Array<HTMLElement>}
                    containers: [],
                    // list of objects identifying tabbable nodes in `containers` in the trap
                    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
                    //  is active, but the trap should never get to a state where there isn't at least one group
                    //  with at least one tabbable node in it (that would lead to an error condition that would
                    //  result in an error being thrown)
                    // @type {Array<{
                    //   container: HTMLElement,
                    //   tabbableNodes: Array<HTMLElement>, // empty if none
                    //   focusableNodes: Array<HTMLElement>, // empty if none
                    //   firstTabbableNode: HTMLElement|null,
                    //   lastTabbableNode: HTMLElement|null,
                    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
                    // }>}
                    containerGroups: [],
                    // same order/length as `containers` list
                    // references to objects in `containerGroups`, but only those that actually have
                    //  tabbable nodes in them
                    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
                    //  the same length
                    tabbableGroups: [],
                    nodeFocusedBeforeActivation: null,
                    mostRecentlyFocusedNode: null,
                    active: false,
                    paused: false,
                    // timer ID for when delayInitialFocus is true and initial focus in this trap
                    //  has been delayed during activation
                    delayInitialFocusTimer: undefined
                };
                var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
                /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
                    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
                };
                /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element) {
                    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
                    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
                    //  and we still need to find the element in there
                    return state.containerGroups.findIndex(function(_ref) {
                        var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
                        return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
                        //  web components if the `tabbableOptions.getShadowRoot` option was used for
                        //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
                        //  look inside web components even if open)
                        tabbableNodes.find(function(node) {
                            return node === element;
                        });
                    });
                };
                /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
                    var optionValue = config[optionName];
                    if (typeof optionValue === "function") {
                        for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                        optionValue = optionValue.apply(void 0, params);
                    }
                    if (optionValue === true) optionValue = undefined; // use default value
                    if (!optionValue) {
                        if (optionValue === undefined || optionValue === false) return optionValue;
                         // else, empty string (invalid), null (invalid), 0 (invalid)
                        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
                    }
                    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
                    if (typeof optionValue === "string") {
                        node = doc.querySelector(optionValue); // resolve to node, or null if fails
                        if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
                    }
                    return node;
                };
                var getInitialFocusNode = function getInitialFocusNode() {
                    var node = getNodeForOption("initialFocus"); // false explicitly indicates we want no initialFocus at all
                    if (node === false) return false;
                    if (node === undefined) {
                        // option not specified: use fallback options
                        if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
                        else {
                            var firstTabbableGroup = state.tabbableGroups[0];
                            var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                            node = firstTabbableNode || getNodeForOption("fallbackFocus");
                        }
                    }
                    if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
                    return node;
                };
                var updateTabbableNodes = function updateTabbableNodes() {
                    state.containerGroups = state.containers.map(function(container) {
                        var tabbableNodes = Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["tabbable"])(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
                        //  are a superset of tabbable nodes
                        var focusableNodes = Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["focusable"])(container, config.tabbableOptions);
                        return {
                            container: container,
                            tabbableNodes: tabbableNodes,
                            focusableNodes: focusableNodes,
                            firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                            lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                            /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                                var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                                // NOTE: If tabindex is positive (in order to manipulate the tab order separate
                                //  from the DOM order), this __will not work__ because the list of focusableNodes,
                                //  while it contains tabbable nodes, does not sort its nodes in any order other
                                //  than DOM order, because it can't: Where would you place focusable (but not
                                //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
                                // Support for positive tabindex is already broken and hard to manage (possibly
                                //  not supportable, TBD), so this isn't going to make things worse than they
                                //  already are, and at least makes things better for the majority of cases where
                                //  tabindex is either 0/unset or negative.
                                // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
                                var nodeIdx = focusableNodes.findIndex(function(n) {
                                    return n === node;
                                });
                                if (nodeIdx < 0) return undefined;
                                if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                                    return Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(n, config.tabbableOptions);
                                });
                                return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                                    return Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(n, config.tabbableOptions);
                                });
                            }
                        };
                    });
                    state.tabbableGroups = state.containerGroups.filter(function(group) {
                        return group.tabbableNodes.length > 0;
                    }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either
                    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
                    ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
                };
                var tryFocus = function tryFocus(node) {
                    if (node === false) return;
                    if (node === doc.activeElement) return;
                    if (!node || !node.focus) {
                        tryFocus(getInitialFocusNode());
                        return;
                    }
                    node.focus({
                        preventScroll: !!config.preventScroll
                    });
                    state.mostRecentlyFocusedNode = node;
                    if (isSelectableInput(node)) node.select();
                };
                var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
                    var node = getNodeForOption("setReturnFocus", previousActiveElement);
                    return node ? node : node === false ? false : previousActiveElement;
                }; // This needs to be done on mousedown and touchstart instead of click
                // so that it precedes the focus event.
                var checkPointerDown = function checkPointerDown(e) {
                    var target = getActualTarget(e);
                    if (findContainerIndex(target) >= 0) // allow the click since it ocurred inside the trap
                    return;
                    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
                        // immediately deactivate the trap
                        trap.deactivate({
                            // if, on deactivation, we should return focus to the node originally-focused
                            //  when the trap was activated (or the configured `setReturnFocus` node),
                            //  then assume it's also OK to return focus to the outside node that was
                            //  just clicked, causing deactivation, as long as that node is focusable;
                            //  if it isn't focusable, then return focus to the original node focused
                            //  on activation (or the configured `setReturnFocus` node)
                            // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                            //  which will result in the outside click setting focus to the node
                            //  that was clicked, whether it's focusable or not; by setting
                            //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                            //  on activation (or the configured `setReturnFocus` node)
                            returnFocus: config.returnFocusOnDeactivate && !Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isFocusable"])(target, config.tabbableOptions)
                        });
                        return;
                    } // This is needed for mobile devices.
                    // (If we'll only let `click` events through,
                    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
                    if (valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
                    return;
                     // otherwise, prevent the click
                    e.preventDefault();
                }; // In case focus escapes the trap for some strange reason, pull it back in.
                var checkFocusIn = function checkFocusIn(e) {
                    var target = getActualTarget(e);
                    var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.
                    if (targetContained || target instanceof Document) {
                        if (targetContained) state.mostRecentlyFocusedNode = target;
                    } else {
                        // escaped! pull it back in to where it just left
                        e.stopImmediatePropagation();
                        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
                    }
                }; // Hijack Tab events on the first and last focusable nodes of the trap,
                // in order to prevent focus from escaping. If it escapes for even a
                // moment it can end up scrolling the page and causing confusion so we
                // kind of need to capture the action at the keydown phase.
                var checkTab = function checkTab(e) {
                    var target = getActualTarget(e);
                    updateTabbableNodes();
                    var destinationNode = null;
                    if (state.tabbableGroups.length > 0) {
                        // make sure the target is actually contained in a group
                        // NOTE: the target may also be the container itself if it's focusable
                        //  with tabIndex='-1' and was given initial focus
                        var containerIndex = findContainerIndex(target);
                        var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
                        if (containerIndex < 0) {
                            // target not found in any group: quite possible focus has escaped the trap,
                            //  so bring it back in to...
                            if (e.shiftKey) // ...the last node in the last group
                            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                            else // ...the first node in the first group
                            destinationNode = state.tabbableGroups[0].firstTabbableNode;
                        } else if (e.shiftKey) {
                            // REVERSE
                            // is the target the first tabbable node in a group?
                            var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                                var firstTabbableNode = _ref2.firstTabbableNode;
                                return target === firstTabbableNode;
                            });
                            if (startOfGroupIndex < 0 && (containerGroup.container === target || Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isFocusable"])(target, config.tabbableOptions) && !Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                            //  a non-tabbable node that was given focus (i.e. tabindex is negative
                            //  and user clicked on it or node was programmatically given focus)
                            //  and is not followed by any other tabbable node, in which
                            //  case, we should handle shift+tab as if focus were on the container's
                            //  first tabbable node, and go to the last tabbable node of the LAST group
                            startOfGroupIndex = containerIndex;
                            if (startOfGroupIndex >= 0) {
                                // YES: then shift+tab should go to the last tabbable node in the
                                //  previous group (and wrap around to the last tabbable node of
                                //  the LAST group if it's the first tabbable node of the FIRST group)
                                var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                                var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                                destinationNode = destinationGroup.lastTabbableNode;
                            }
                        } else {
                            // FORWARD
                            // is the target the last tabbable node in a group?
                            var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                                var lastTabbableNode = _ref3.lastTabbableNode;
                                return target === lastTabbableNode;
                            });
                            if (lastOfGroupIndex < 0 && (containerGroup.container === target || Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isFocusable"])(target, config.tabbableOptions) && !Object(tabbable__WEBPACK_IMPORTED_MODULE_0__["isTabbable"])(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                            //  a non-tabbable node that was given focus (i.e. tabindex is negative
                            //  and user clicked on it or node was programmatically given focus)
                            //  and is not followed by any other tabbable node, in which
                            //  case, we should handle tab as if focus were on the container's
                            //  last tabbable node, and go to the first tabbable node of the FIRST group
                            lastOfGroupIndex = containerIndex;
                            if (lastOfGroupIndex >= 0) {
                                // YES: then tab should go to the first tabbable node in the next
                                //  group (and wrap around to the first tabbable node of the FIRST
                                //  group if it's the last tabbable node of the LAST group)
                                var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                                var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                                destinationNode = _destinationGroup.firstTabbableNode;
                            }
                        }
                    } else // NOTE: the fallbackFocus option does not support returning false to opt-out
                    destinationNode = getNodeForOption("fallbackFocus");
                    if (destinationNode) {
                        e.preventDefault();
                        tryFocus(destinationNode);
                    } // else, let the browser take care of [shift+]tab and move the focus
                };
                var checkKey = function checkKey(e) {
                    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
                        e.preventDefault();
                        trap.deactivate();
                        return;
                    }
                    if (isTabEvent(e)) {
                        checkTab(e);
                        return;
                    }
                };
                var checkClick = function checkClick(e) {
                    var target = getActualTarget(e);
                    if (findContainerIndex(target) >= 0) return;
                    if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
                    if (valueOrHandler(config.allowOutsideClick, e)) return;
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }; //
                // EVENT LISTENERS
                //
                var addListeners = function addListeners() {
                    if (!state.active) return;
                     // There can be only one listening focus trap at a time
                    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
                    // that caused the focus trap activation.
                    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
                        tryFocus(getInitialFocusNode());
                    }) : tryFocus(getInitialFocusNode());
                    doc.addEventListener("focusin", checkFocusIn, true);
                    doc.addEventListener("mousedown", checkPointerDown, {
                        capture: true,
                        passive: false
                    });
                    doc.addEventListener("touchstart", checkPointerDown, {
                        capture: true,
                        passive: false
                    });
                    doc.addEventListener("click", checkClick, {
                        capture: true,
                        passive: false
                    });
                    doc.addEventListener("keydown", checkKey, {
                        capture: true,
                        passive: false
                    });
                    return trap;
                };
                var removeListeners = function removeListeners() {
                    if (!state.active) return;
                    doc.removeEventListener("focusin", checkFocusIn, true);
                    doc.removeEventListener("mousedown", checkPointerDown, true);
                    doc.removeEventListener("touchstart", checkPointerDown, true);
                    doc.removeEventListener("click", checkClick, true);
                    doc.removeEventListener("keydown", checkKey, true);
                    return trap;
                }; //
                // TRAP DEFINITION
                //
                trap = {
                    get active () {
                        return state.active;
                    },
                    get paused () {
                        return state.paused;
                    },
                    activate: function activate(activateOptions) {
                        if (state.active) return this;
                        var onActivate = getOption(activateOptions, "onActivate");
                        var onPostActivate = getOption(activateOptions, "onPostActivate");
                        var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
                        if (!checkCanFocusTrap) updateTabbableNodes();
                        state.active = true;
                        state.paused = false;
                        state.nodeFocusedBeforeActivation = doc.activeElement;
                        if (onActivate) onActivate();
                        var finishActivation = function finishActivation() {
                            if (checkCanFocusTrap) updateTabbableNodes();
                            addListeners();
                            if (onPostActivate) onPostActivate();
                        };
                        if (checkCanFocusTrap) {
                            checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                            return this;
                        }
                        finishActivation();
                        return this;
                    },
                    deactivate: function deactivate(deactivateOptions) {
                        if (!state.active) return this;
                        var options = _objectSpread2({
                            onDeactivate: config.onDeactivate,
                            onPostDeactivate: config.onPostDeactivate,
                            checkCanReturnFocus: config.checkCanReturnFocus
                        }, deactivateOptions);
                        clearTimeout(state.delayInitialFocusTimer); // noop if undefined
                        state.delayInitialFocusTimer = undefined;
                        removeListeners();
                        state.active = false;
                        state.paused = false;
                        activeFocusTraps.deactivateTrap(trap);
                        var onDeactivate = getOption(options, "onDeactivate");
                        var onPostDeactivate = getOption(options, "onPostDeactivate");
                        var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
                        var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
                        if (onDeactivate) onDeactivate();
                        var finishDeactivation = function finishDeactivation() {
                            delay(function() {
                                if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                                if (onPostDeactivate) onPostDeactivate();
                            });
                        };
                        if (returnFocus && checkCanReturnFocus) {
                            checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                            return this;
                        }
                        finishDeactivation();
                        return this;
                    },
                    pause: function pause() {
                        if (state.paused || !state.active) return this;
                        state.paused = true;
                        removeListeners();
                        return this;
                    },
                    unpause: function unpause() {
                        if (!state.paused || !state.active) return this;
                        state.paused = false;
                        updateTabbableNodes();
                        addListeners();
                        return this;
                    },
                    updateContainerElements: function updateContainerElements(containerElements) {
                        var elementsAsArray = [].concat(containerElements).filter(Boolean);
                        state.containers = elementsAsArray.map(function(element) {
                            return typeof element === "string" ? doc.querySelector(element) : element;
                        });
                        if (state.active) updateTabbableNodes();
                        return this;
                    }
                }; // initialize container elements
                trap.updateContainerElements(elements);
                return trap;
            };
        //# sourceMappingURL=focus-trap.esm.js.map
        /***/ },
        /***/ "./node_modules/tabbable/dist/index.esm.js": /*!*************************************************!*\
  !*** ./node_modules/tabbable/dist/index.esm.js ***!
  \*************************************************/ /*! exports provided: focusable, isFocusable, isTabbable, tabbable */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusable", function() {
                return focusable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFocusable", function() {
                return isFocusable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTabbable", function() {
                return isTabbable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tabbable", function() {
                return tabbable;
            });
            /*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var candidateSelectors = [
                "input",
                "select",
                "textarea",
                "a[href]",
                "button",
                "[tabindex]:not(slot)",
                "audio[controls]",
                "video[controls]",
                '[contenteditable]:not([contenteditable="false"])',
                "details>summary:first-of-type",
                "details"
            ];
            var candidateSelector = /* #__PURE__ */ candidateSelectors.join(",");
            var NoElement = typeof Element === "undefined";
            var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
            var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
                return element.getRootNode();
            } : function(element) {
                return element.ownerDocument;
            };
            /**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
                var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
                if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
                candidates = candidates.filter(filter);
                return candidates;
            };
            /**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
                var candidates = [];
                var elementsToCheck = Array.from(elements);
                while(elementsToCheck.length){
                    var element = elementsToCheck.shift();
                    if (element.tagName === "SLOT") {
                        // add shadow dom slot scope (slot itself cannot be focusable)
                        var assigned = element.assignedElements();
                        var content = assigned.length ? assigned : element.children;
                        var nestedCandidates = getCandidatesIteratively(content, true, options);
                        if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
                        else candidates.push({
                            scope: element,
                            candidates: nestedCandidates
                        });
                    } else {
                        // check candidate element
                        var validCandidate = matches.call(element, candidateSelector);
                        if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
                         // iterate over shadow content if possible
                        var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
                        typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
                        var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
                        if (shadowRoot && validShadowRoot) {
                            // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                            //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                            //  child candidates found because they're likely slotted elements (elements that are
                            //  children of the web component element (which has the shadow), in the light dom, but
                            //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                            //  _after_ we return from this recursive call
                            var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                            if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                            else candidates.push({
                                scope: element,
                                candidates: _nestedCandidates
                            });
                        } else // there's not shadow so just dig into the element's (light dom) children
                        //  __without__ giving the element special scope treatment
                        elementsToCheck.unshift.apply(elementsToCheck, element.children);
                    }
                }
                return candidates;
            };
            var getTabindex = function getTabindex(node, isScope) {
                if (node.tabIndex < 0) {
                    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
                    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
                    // yet they are still part of the regular tab order; in FF, they get a default
                    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
                    // order, consider their tab index to be 0.
                    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
                    // so if they don't have a tabindex attribute specifically set, assume it's 0.
                    //
                    // isScope is positive for custom element with shadow root or slot that by default
                    // have tabIndex -1, but need to be sorted by document order in order for their
                    // content to be inserted in the correct position
                    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
                }
                return node.tabIndex;
            };
            var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
                return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
            };
            var isInput = function isInput(node) {
                return node.tagName === "INPUT";
            };
            var isHiddenInput = function isHiddenInput(node) {
                return isInput(node) && node.type === "hidden";
            };
            var isDetailsWithSummary = function isDetailsWithSummary(node) {
                var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
                    return child.tagName === "SUMMARY";
                });
                return r;
            };
            var getCheckedRadio = function getCheckedRadio(nodes, form) {
                for(var i = 0; i < nodes.length; i++){
                    if (nodes[i].checked && nodes[i].form === form) return nodes[i];
                }
            };
            var isTabbableRadio = function isTabbableRadio(node) {
                if (!node.name) return true;
                var radioScope = node.form || getRootNode(node);
                var queryRadios = function queryRadios(name) {
                    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
                };
                var radioSet;
                if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
                else try {
                    radioSet = queryRadios(node.name);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
                    return false;
                }
                var checked = getCheckedRadio(radioSet, node.form);
                return !checked || checked === node;
            };
            var isRadio = function isRadio(node) {
                return isInput(node) && node.type === "radio";
            };
            var isNonTabbableRadio = function isNonTabbableRadio(node) {
                return isRadio(node) && !isTabbableRadio(node);
            };
            var isZeroArea = function isZeroArea(node) {
                var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
                return width === 0 && height === 0;
            };
            var isHidden = function isHidden(node, _ref) {
                var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
                // NOTE: visibility will be `undefined` if node is detached from the document
                //  (see notes about this further down), which means we will consider it visible
                //  (this is legacy behavior from a very long way back)
                // NOTE: we check this regardless of `displayCheck="none"` because this is a
                //  _visibility_ check, not a _display_ check
                if (getComputedStyle(node).visibility === "hidden") return true;
                var isDirectSummary = matches.call(node, "details>summary:first-of-type");
                var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
                if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
                 // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
                //  (but NOT _the_ document; see second 'If' comment below for more).
                // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
                //  is attached, and the one we need to check if it's in the document or not (because the
                //  shadow, and all nodes it contains, is never considered in the document since shadows
                //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
                //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
                //  visibility, including all the nodes it contains). The host could be any normal node,
                //  or a custom element (i.e. web component). Either way, that's the one that is considered
                //  part of the document, not the shadow root, nor any of its children (i.e. the node being
                //  tested).
                // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
                //  document (per the docs) and while it's a Document-type object, that document does not
                //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
                //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
                //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
                //  node is actually detached.
                var nodeRootHost = getRootNode(node).host;
                var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
                if (!displayCheck || displayCheck === "full") {
                    if (typeof getShadowRoot === "function") {
                        // figure out if we should consider the node to be in an undisclosed shadow and use the
                        //  'non-zero-area' fallback
                        var originalNode = node;
                        while(node){
                            var parentElement = node.parentElement;
                            var rootNode = getRootNode(node);
                            if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                            ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                            //  fall back to a non-zero-area test
                            return isZeroArea(node);
                            else if (node.assignedSlot) // iterate up slot
                            node = node.assignedSlot;
                            else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                            node = rootNode.host;
                            else // iterate up normal dom
                            node = parentElement;
                        }
                        node = originalNode;
                    } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
                    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
                    //  it might be a falsy value, which means shadow DOM support is disabled
                    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
                    //  now we can just test to see if it would normally be visible or not, provided it's
                    //  attached to the main document.
                    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
                    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
                    if (nodeIsAttached) // this works wherever the node is: if there's at least one client rect, it's
                    //  somehow displayed; it also covers the CSS 'display: contents' case where the
                    //  node itself is hidden in place of its contents; and there's no need to search
                    //  up the hierarchy either
                    return !node.getClientRects().length;
                     // Else, the node isn't attached to the document, which means the `getClientRects()`
                //  API will __always__ return zero rects (this can happen, for example, if React
                //  is used to render nodes onto a detached tree, as confirmed in this thread:
                //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
                //
                // It also means that even window.getComputedStyle(node).display will return `undefined`
                //  because styles are only computed for nodes that are in the document.
                //
                // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
                //  somehow. Though it was never stated officially, anyone who has ever used tabbable
                //  APIs on nodes in detached containers has actually implicitly used tabbable in what
                //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
                //  considering __everything__ to be visible because of the innability to determine styles.
                } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
                //  whether it's displayed, and that a detached node will __always__ have a zero-area
                //  client rect, we don't special-case for whether the node is attached or not. In
                //  this mode, we do want to consider nodes that have a zero area to be hidden at all
                //  times, and that includes attached or not.
                return isZeroArea(node);
                 // visible, as far as we can tell, or per current `displayCheck` mode
                return false;
            }; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
            //  unless they are in the _first_ <legend> element of the top-most disabled
            //  fieldset
            var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
                if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
                    var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>
                    while(parentNode){
                        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                            // look for the first <legend> among the children of the disabled <fieldset>
                            for(var i = 0; i < parentNode.children.length; i++){
                                var child = parentNode.children.item(i); // when the first <legend> (in document order) is found
                                if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                                // return whether `node` is a descendant of its first <legend>
                                return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                            } // the disabled <fieldset> containing `node` has no <legend>
                            return true;
                        }
                        parentNode = parentNode.parentElement;
                    }
                } // else, node's tabbable/focusable state should not be affected by a fieldset's
                //  enabled/disabled state
                return false;
            };
            var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
                if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
                isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
                return true;
            };
            var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
                if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
                return true;
            };
            var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
                var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
                if (isNaN(tabIndex) || tabIndex >= 0) return true;
                 // If a custom element has an explicit negative tabindex,
                // browsers will not allow tab targeting said element's children.
                return false;
            };
            /**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
                var regularTabbables = [];
                var orderedTabbables = [];
                candidates.forEach(function(item, i) {
                    var isScope = !!item.scope;
                    var element = isScope ? item.scope : item;
                    var candidateTabindex = getTabindex(element, isScope);
                    var elements = isScope ? sortByOrder(item.candidates) : element;
                    if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
                    else orderedTabbables.push({
                        documentOrder: i,
                        tabIndex: candidateTabindex,
                        item: item,
                        isScope: isScope,
                        content: elements
                    });
                });
                return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
                    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
                    return acc;
                }, []).concat(regularTabbables);
            };
            var tabbable = function tabbable(el, options) {
                options = options || {};
                var candidates;
                if (options.getShadowRoot) candidates = getCandidatesIteratively([
                    el
                ], options.includeContainer, {
                    filter: isNodeMatchingSelectorTabbable.bind(null, options),
                    flatten: false,
                    getShadowRoot: options.getShadowRoot,
                    shadowRootFilter: isValidShadowRootTabbable
                });
                else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
                return sortByOrder(candidates);
            };
            var focusable = function focusable(el, options) {
                options = options || {};
                var candidates;
                if (options.getShadowRoot) candidates = getCandidatesIteratively([
                    el
                ], options.includeContainer, {
                    filter: isNodeMatchingSelectorFocusable.bind(null, options),
                    flatten: true,
                    getShadowRoot: options.getShadowRoot
                });
                else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
                return candidates;
            };
            var isTabbable = function isTabbable(node, options) {
                options = options || {};
                if (!node) throw new Error("No node provided");
                if (matches.call(node, candidateSelector) === false) return false;
                return isNodeMatchingSelectorTabbable(options, node);
            };
            var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat("iframe").join(",");
            var isFocusable = function isFocusable(node, options) {
                options = options || {};
                if (!node) throw new Error("No node provided");
                if (matches.call(node, focusableCandidateSelector) === false) return false;
                return isNodeMatchingSelectorFocusable(options, node);
            };
        //# sourceMappingURL=index.esm.js.map
        /***/ },
        /***/ "./packages/material-components-web/index.ts": /*!***************************************************!*\
  !*** ./packages/material-components-web/index.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            __webpack_require__(/*! ./native-shim.es5.js */ "./packages/material-components-web/native-shim.es5.js");
            __webpack_require__(/*! @webcomponents/custom-elements */ "./node_modules/@webcomponents/custom-elements/custom-elements.min.js");
            __webpack_require__(/*! @material/button/custom-element */ "./packages/mdc-button/custom-element.js");
            __webpack_require__(/*! @material/card/custom-element */ "./packages/mdc-card/custom-element.js");
            __webpack_require__(/*! @material/checkbox/custom-element */ "./packages/mdc-checkbox/custom-element.js");
            __webpack_require__(/*! @material/chips/chip-set/custom-element */ "./packages/mdc-chips/chip-set/custom-element.js");
            __webpack_require__(/*! @material/chips/chip/custom-element */ "./packages/mdc-chips/chip/custom-element.js");
            __webpack_require__(/*! @material/circular-progress/custom-element */ "./packages/mdc-circular-progress/custom-element.js");
            __webpack_require__(/*! @material/data-table/custom-element */ "./packages/mdc-data-table/custom-element.js");
            __webpack_require__(/*! @material/dialog/custom-element */ "./packages/mdc-dialog/custom-element.js");
            __webpack_require__(/*! @material/drawer/custom-element */ "./packages/mdc-drawer/custom-element.js");
            __webpack_require__(/*! @material/fab/custom-element */ "./packages/mdc-fab/custom-element.js");
            __webpack_require__(/*! @material/form-field/custom-element */ "./packages/mdc-form-field/custom-element.js");
            __webpack_require__(/*! @material/icon-button/custom-element */ "./packages/mdc-icon-button/custom-element.js");
            __webpack_require__(/*! @material/image-list/custom-element */ "./packages/mdc-image-list/custom-element.js");
            __webpack_require__(/*! @material/layout-grid/custom-element */ "./packages/mdc-layout-grid/custom-element.js");
            __webpack_require__(/*! @material/linear-progress/custom-element */ "./packages/mdc-linear-progress/custom-element.js");
            __webpack_require__(/*! @material/list/custom-element */ "./packages/mdc-list/custom-element.js");
            __webpack_require__(/*! @material/menu/custom-element */ "./packages/mdc-menu/custom-element.js");
            __webpack_require__(/*! @material/radio/custom-element */ "./packages/mdc-radio/custom-element.js");
            __webpack_require__(/*! @material/ripple/custom-element */ "./packages/mdc-ripple/custom-element.js");
            __webpack_require__(/*! @material/select/custom-element */ "./packages/mdc-select/custom-element.js");
            __webpack_require__(/*! @material/slider/custom-element */ "./packages/mdc-slider/custom-element.js");
            __webpack_require__(/*! @material/snackbar/custom-element */ "./packages/mdc-snackbar/custom-element.js");
            __webpack_require__(/*! @material/switch/custom-element */ "./packages/mdc-switch/custom-element.js");
            __webpack_require__(/*! @material/tab-bar/custom-element */ "./packages/mdc-tab-bar/custom-element.js");
            __webpack_require__(/*! @material/tab/custom-element */ "./packages/mdc-tab/custom-element.js");
            __webpack_require__(/*! @material/textfield/custom-element */ "./packages/mdc-textfield/custom-element.js");
            __webpack_require__(/*! @material/top-app-bar/custom-element */ "./packages/mdc-top-app-bar/custom-element.js");
        /***/ },
        /***/ "./packages/material-components-web/native-shim.es5.js": /*!*************************************************************!*\
  !*** ./packages/material-components-web/native-shim.es5.js ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */ /**
 * This shim allows elements written in, or compiled to, ES5 to work on native
 * implementations of Custom Elements v1. It sets new.target to the value of
 * this.constructor so that the native HTMLElement constructor can access the
 * current under-construction element's definition.
 */ (function() {
                if (// No Reflect, no classes, no need for shim because native custom elements
                // require ES2015 classes or Reflect.
                window.Reflect === undefined || window.customElements === undefined || // The webcomponentsjs custom elements polyfill doesn't require
                // ES2015-compatible construction (`super()` or `Reflect.construct`).
                window.customElements.polyfillWrapFlushCallback) return;
                var BuiltInHTMLElement = HTMLElement;
                /**
     * With jscompiler's RECOMMENDED_FLAGS the function name will be optimized away.
     * However, if we declare the function as a property on an object literal, and
     * use quotes for the property name, then closure will leave that much intact,
     * which is enough for the JS VM to correctly set Function.prototype.name.
     */ var wrapperForTheName = {
                    "HTMLElement": function HTMLElement1() {
                        return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
                    }
                };
                window.HTMLElement = wrapperForTheName["HTMLElement"];
                HTMLElement.prototype = BuiltInHTMLElement.prototype;
                HTMLElement.prototype.constructor = HTMLElement;
                Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
            })();
        // # sourceMappingURL=native-shim.js.map
        /***/ },
        /***/ "./packages/mdc-animation/animationframe.ts": /*!**************************************************!*\
  !*** ./packages/mdc-animation/animationframe.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AnimationFrame = void 0;
            /**
 * AnimationFrame provides a user-friendly abstraction around requesting
 * and canceling animation frames.
 */ var AnimationFrame = /** @class */ function() {
                function AnimationFrame() {
                    this.rafIDs = new Map();
                }
                /**
     * Requests an animation frame. Cancels any existing frame with the same key.
     * @param {string} key The key for this callback.
     * @param {FrameRequestCallback} callback The callback to be executed.
     */ AnimationFrame.prototype.request = function(key, callback) {
                    var _this = this;
                    this.cancel(key);
                    var frameID = requestAnimationFrame(function(frame) {
                        _this.rafIDs.delete(key);
                        // Callback must come *after* the key is deleted so that nested calls to
                        // request with the same key are not deleted.
                        callback(frame);
                    });
                    this.rafIDs.set(key, frameID);
                };
                /**
     * Cancels a queued callback with the given key.
     * @param {string} key The key for this callback.
     */ AnimationFrame.prototype.cancel = function(key) {
                    var rafID = this.rafIDs.get(key);
                    if (rafID) {
                        cancelAnimationFrame(rafID);
                        this.rafIDs.delete(key);
                    }
                };
                /**
     * Cancels all queued callback.
     */ AnimationFrame.prototype.cancelAll = function() {
                    var _this = this;
                    // Need to use forEach because it's the only iteration method supported
                    // by IE11. Suppress the underscore because we don't need it.
                    // tslint:disable-next-line:enforce-name-casing
                    this.rafIDs.forEach(function(_, key) {
                        _this.cancel(key);
                    });
                };
                /**
     * Returns the queue of unexecuted callback keys.
     */ AnimationFrame.prototype.getQueue = function() {
                    var queue = [];
                    // Need to use forEach because it's the only iteration method supported
                    // by IE11. Suppress the underscore because we don't need it.
                    // tslint:disable-next-line:enforce-name-casing
                    this.rafIDs.forEach(function(_, key) {
                        queue.push(key);
                    });
                    return queue;
                };
                return AnimationFrame;
            }();
            exports.AnimationFrame = AnimationFrame;
        /***/ },
        /***/ "./packages/mdc-animation/util.ts": /*!****************************************!*\
  !*** ./packages/mdc-animation/util.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getCorrectEventName = exports.getCorrectPropertyName = void 0;
            var cssPropertyNameMap = {
                animation: {
                    prefixed: "-webkit-animation",
                    standard: "animation"
                },
                transform: {
                    prefixed: "-webkit-transform",
                    standard: "transform"
                },
                transition: {
                    prefixed: "-webkit-transition",
                    standard: "transition"
                }
            };
            var jsEventTypeMap = {
                animationend: {
                    cssProperty: "animation",
                    prefixed: "webkitAnimationEnd",
                    standard: "animationend"
                },
                animationiteration: {
                    cssProperty: "animation",
                    prefixed: "webkitAnimationIteration",
                    standard: "animationiteration"
                },
                animationstart: {
                    cssProperty: "animation",
                    prefixed: "webkitAnimationStart",
                    standard: "animationstart"
                },
                transitionend: {
                    cssProperty: "transition",
                    prefixed: "webkitTransitionEnd",
                    standard: "transitionend"
                }
            };
            function isWindow(windowObj) {
                return Boolean(windowObj.document) && typeof windowObj.document.createElement === "function";
            }
            function getCorrectPropertyName(windowObj, cssProperty) {
                if (isWindow(windowObj) && cssProperty in cssPropertyNameMap) {
                    var el = windowObj.document.createElement("div");
                    var _a = cssPropertyNameMap[cssProperty], standard = _a.standard, prefixed = _a.prefixed;
                    var isStandard = standard in el.style;
                    return isStandard ? standard : prefixed;
                }
                return cssProperty;
            }
            exports.getCorrectPropertyName = getCorrectPropertyName;
            function getCorrectEventName(windowObj, eventType) {
                if (isWindow(windowObj) && eventType in jsEventTypeMap) {
                    var el = windowObj.document.createElement("div");
                    var _a = jsEventTypeMap[eventType], standard = _a.standard, prefixed = _a.prefixed, cssProperty = _a.cssProperty;
                    var isStandard = cssProperty in el.style;
                    return isStandard ? standard : prefixed;
                }
                return eventType;
            }
            exports.getCorrectEventName = getCorrectEventName;
        /***/ },
        /***/ "./packages/mdc-base/component.ts": /*!****************************************!*\
  !*** ./packages/mdc-base/component.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __read = this && this.__read || function(o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m) return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
                } catch (error) {
                    e = {
                        error: error
                    };
                } finally{
                    try {
                        if (r && !r.done && (m = i["return"])) m.call(i);
                    } finally{
                        if (e) throw e.error;
                    }
                }
                return ar;
            };
            var __spreadArray = this && this.__spreadArray || function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCComponent = void 0;
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-base/foundation.ts");
            var MDCComponent = /** @class */ function() {
                function MDCComponent(root, foundation) {
                    var args = [];
                    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
                    this.root = root;
                    this.initialize.apply(this, __spreadArray([], __read(args)));
                    // Note that we initialize foundation here and not within the constructor's default param so that
                    // this.root_ is defined and can be used within the foundation class.
                    this.foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
                    this.foundation.init();
                    this.initialSyncWithDOM();
                }
                MDCComponent.attachTo = function(root) {
                    // Subclasses which extend MDCBase should provide an attachTo() method that takes a root element and
                    // returns an instantiated component with its root set to that element. Also note that in the cases of
                    // subclasses, an explicit foundation class will not have to be passed in; it will simply be initialized
                    // from getDefaultFoundation().
                    return new MDCComponent(root, new foundation_1.MDCFoundation({}));
                };
                /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */ MDCComponent.prototype.initialize = function() {
                    var _args = [];
                    for(var _i = 0; _i < arguments.length; _i++)_args[_i] = arguments[_i];
                // Subclasses can override this to do any additional setup work that would be considered part of a
                // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
                // initialized. Any additional arguments besides root and foundation will be passed in here.
                };
                MDCComponent.prototype.getDefaultFoundation = function() {
                    // Subclasses must override this method to return a properly configured foundation class for the
                    // component.
                    throw new Error("Subclasses must override getDefaultFoundation to return a properly configured foundation class");
                };
                MDCComponent.prototype.initialSyncWithDOM = function() {
                // Subclasses should override this method if they need to perform work to synchronize with a host DOM
                // object. An example of this would be a form control wrapper that needs to synchronize its internal state
                // to some property or attribute of the host DOM. Please note: this is *not* the place to perform DOM
                // reads/writes that would cause layout / paint, as this is called synchronously from within the constructor.
                };
                MDCComponent.prototype.destroy = function() {
                    // Subclasses may implement this method to release any resources / deregister any listeners they have
                    // attached. An example of this might be deregistering a resize event from the window object.
                    this.foundation.destroy();
                };
                MDCComponent.prototype.listen = function(evtType, handler, options) {
                    this.root.addEventListener(evtType, handler, options);
                };
                MDCComponent.prototype.unlisten = function(evtType, handler, options) {
                    this.root.removeEventListener(evtType, handler, options);
                };
                /**
     * Fires a cross-browser-compatible custom event from the component root of the given type, with the given data.
     */ MDCComponent.prototype.emit = function(evtType, evtData, shouldBubble) {
                    if (shouldBubble === void 0) shouldBubble = false;
                    var evt;
                    if (typeof CustomEvent === "function") evt = new CustomEvent(evtType, {
                        bubbles: shouldBubble,
                        detail: evtData
                    });
                    else {
                        evt = document.createEvent("CustomEvent");
                        evt.initCustomEvent(evtType, shouldBubble, false, evtData);
                    }
                    this.root.dispatchEvent(evt);
                };
                return MDCComponent;
            }();
            exports.MDCComponent = MDCComponent;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCComponent;
        /***/ },
        /***/ "./packages/mdc-base/foundation.ts": /*!*****************************************!*\
  !*** ./packages/mdc-base/foundation.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFoundation = void 0;
            var MDCFoundation = /** @class */ function() {
                function MDCFoundation(adapter) {
                    if (adapter === void 0) adapter = {};
                    this.adapter = adapter;
                }
                Object.defineProperty(MDCFoundation, "cssClasses", {
                    get: function get() {
                        // Classes extending MDCFoundation should implement this method to return an object which exports every
                        // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFoundation, "strings", {
                    get: function get() {
                        // Classes extending MDCFoundation should implement this method to return an object which exports all
                        // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFoundation, "numbers", {
                    get: function get() {
                        // Classes extending MDCFoundation should implement this method to return an object which exports all
                        // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFoundation, "defaultAdapter", {
                    get: function get() {
                        // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
                        // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
                        // validation.
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCFoundation.prototype.init = function() {
                // Subclasses should override this method to perform initialization routines (registering events, etc.)
                };
                MDCFoundation.prototype.destroy = function() {
                // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
                };
                return MDCFoundation;
            }();
            exports.MDCFoundation = MDCFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFoundation;
        /***/ },
        /***/ "./packages/mdc-button/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-button/custom-element.js ***!
  \***********************************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcButton = function(_HTMLElement) {
                _inherits(MdcButton, _HTMLElement);
                function MdcButton() {
                    _classCallCheck(this, MdcButton);
                    var _this = _possibleConstructorReturn(this, (MdcButton.__proto__ || Object.getPrototypeOf(MdcButton)).call(this));
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcButton, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this.querySelector(".mdc-button"));
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcButton;
            }(HTMLElement);
            /* harmony default export */ __webpack_exports__["default"] = MdcButton;
            customElements.define("mdc-button", MdcButton);
        /***/ },
        /***/ "./packages/mdc-card/custom-element.js": /*!*********************************************!*\
  !*** ./packages/mdc-card/custom-element.js ***!
  \*********************************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcCard = function(_HTMLElement) {
                _inherits(MdcCard, _HTMLElement);
                _createClass(MdcCard, [
                    {
                        key: "focus",
                        value: function focus() {
                            if (!!this.primaryAction_) this.primaryAction_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (!!this.primaryAction_) this.primaryAction_.blur();
                        }
                    }
                ]);
                function MdcCard() {
                    _classCallCheck(this, MdcCard);
                    var _this = _possibleConstructorReturn(this, (MdcCard.__proto__ || Object.getPrototypeOf(MdcCard)).call(this));
                    _this.primaryAction_;
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcCard, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            var primaryActionElement = this.querySelector(".mdc-card__primary-action");
                            if (!!primaryActionElement) this.primaryAction_ = primaryActionElement;
                            if (!!this.primaryAction_) this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this.primaryAction_);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            if (this.ripple_) this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcCard;
            }(HTMLElement);
            /* harmony default export */ __webpack_exports__["default"] = MdcCard;
            customElements.define("mdc-card", MdcCard);
        /***/ },
        /***/ "./packages/mdc-checkbox/component.ts": /*!********************************************!*\
  !*** ./packages/mdc-checkbox/component.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCheckbox = void 0;
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-checkbox/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-checkbox/foundation.ts");
            var CB_PROTO_PROPS = [
                "checked",
                "indeterminate"
            ];
            var MDCCheckbox = /** @class */ function(_super) {
                __extends(MDCCheckbox, _super);
                function MDCCheckbox() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.ripple_ = _this.createRipple_();
                    return _this;
                }
                MDCCheckbox.attachTo = function(root) {
                    return new MDCCheckbox(root);
                };
                Object.defineProperty(MDCCheckbox.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "checked", {
                    get: function get() {
                        return this.nativeControl_.checked;
                    },
                    set: function set(checked) {
                        this.nativeControl_.checked = checked;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "indeterminate", {
                    get: function get() {
                        return this.nativeControl_.indeterminate;
                    },
                    set: function set(indeterminate) {
                        this.nativeControl_.indeterminate = indeterminate;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "disabled", {
                    get: function get() {
                        return this.nativeControl_.disabled;
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckbox.prototype, "value", {
                    get: function get() {
                        return this.nativeControl_.value;
                    },
                    set: function set(value) {
                        this.nativeControl_.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCCheckbox.prototype.initialize = function() {
                    var DATA_INDETERMINATE_ATTR = constants_1.strings.DATA_INDETERMINATE_ATTR;
                    this.nativeControl_.indeterminate = this.nativeControl_.getAttribute(DATA_INDETERMINATE_ATTR) === "true";
                    this.nativeControl_.removeAttribute(DATA_INDETERMINATE_ATTR);
                };
                MDCCheckbox.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleAnimationEnd_ = function() {
                        return _this.foundation.handleAnimationEnd();
                    };
                    this.listen(util_1.getCorrectEventName(window, "animationend"), this.handleAnimationEnd_);
                    this.installPropertyChangeHooks_();
                };
                MDCCheckbox.prototype.destroy = function() {
                    this.ripple_.destroy();
                    this.unlisten(util_1.getCorrectEventName(window, "animationend"), this.handleAnimationEnd_);
                    this.uninstallPropertyChangeHooks_();
                    _super.prototype.destroy.call(this);
                };
                MDCCheckbox.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        forceLayout: function forceLayout() {
                            return _this.root.offsetWidth;
                        },
                        hasNativeControl: function hasNativeControl() {
                            return !!_this.nativeControl_;
                        },
                        isAttachedToDOM: function isAttachedToDOM() {
                            return Boolean(_this.root.parentNode);
                        },
                        isChecked: function isChecked() {
                            return _this.checked;
                        },
                        isIndeterminate: function isIndeterminate() {
                            return _this.indeterminate;
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        removeNativeControlAttr: function removeNativeControlAttr(attr) {
                            _this.nativeControl_.removeAttribute(attr);
                        },
                        setNativeControlAttr: function setNativeControlAttr(attr, value) {
                            _this.nativeControl_.setAttribute(attr, value);
                        },
                        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
                            _this.nativeControl_.disabled = disabled;
                        }
                    };
                    return new foundation_2.MDCCheckboxFoundation(adapter);
                };
                MDCCheckbox.prototype.createRipple_ = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill_1.matches(_this.nativeControl_, ":active");
                        },
                        isUnbounded: function isUnbounded() {
                            return true;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.addEventListener(evtType, handler, events_1.applyPassive());
                        }
                    });
                    return new component_2.MDCRipple(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                MDCCheckbox.prototype.installPropertyChangeHooks_ = function() {
                    var _this = this;
                    var nativeCb = this.nativeControl_;
                    var cbProto = Object.getPrototypeOf(nativeCb);
                    CB_PROTO_PROPS.forEach(function(controlState) {
                        var desc = Object.getOwnPropertyDescriptor(cbProto, controlState);
                        // We have to check for this descriptor, since some browsers (Safari) don't support its return.
                        // See: https://bugs.webkit.org/show_bug.cgi?id=49739
                        if (!validDescriptor(desc)) return;
                        // Type cast is needed for compatibility with Closure Compiler.
                        var nativeGetter = desc.get;
                        var nativeCbDesc = {
                            configurable: desc.configurable,
                            enumerable: desc.enumerable,
                            get: nativeGetter,
                            set: function set(state) {
                                desc.set.call(nativeCb, state);
                                _this.foundation.handleChange();
                            }
                        };
                        Object.defineProperty(nativeCb, controlState, nativeCbDesc);
                    });
                };
                MDCCheckbox.prototype.uninstallPropertyChangeHooks_ = function() {
                    var nativeCb = this.nativeControl_;
                    var cbProto = Object.getPrototypeOf(nativeCb);
                    CB_PROTO_PROPS.forEach(function(controlState) {
                        var desc = Object.getOwnPropertyDescriptor(cbProto, controlState);
                        if (!validDescriptor(desc)) return;
                        Object.defineProperty(nativeCb, controlState, desc);
                    });
                };
                Object.defineProperty(MDCCheckbox.prototype, "nativeControl_", {
                    get: function get() {
                        var NATIVE_CONTROL_SELECTOR = constants_1.strings.NATIVE_CONTROL_SELECTOR;
                        var el = this.root.querySelector(NATIVE_CONTROL_SELECTOR);
                        if (!el) throw new Error("Checkbox component requires a " + NATIVE_CONTROL_SELECTOR + " element");
                        return el;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MDCCheckbox;
            }(component_1.MDCComponent);
            exports.MDCCheckbox = MDCCheckbox;
            function validDescriptor(inputPropDesc) {
                return !!inputPropDesc && typeof inputPropDesc.set === "function";
            }
        /***/ },
        /***/ "./packages/mdc-checkbox/constants.ts": /*!********************************************!*\
  !*** ./packages/mdc-checkbox/constants.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                ANIM_CHECKED_INDETERMINATE: "mdc-checkbox--anim-checked-indeterminate",
                ANIM_CHECKED_UNCHECKED: "mdc-checkbox--anim-checked-unchecked",
                ANIM_INDETERMINATE_CHECKED: "mdc-checkbox--anim-indeterminate-checked",
                ANIM_INDETERMINATE_UNCHECKED: "mdc-checkbox--anim-indeterminate-unchecked",
                ANIM_UNCHECKED_CHECKED: "mdc-checkbox--anim-unchecked-checked",
                ANIM_UNCHECKED_INDETERMINATE: "mdc-checkbox--anim-unchecked-indeterminate",
                BACKGROUND: "mdc-checkbox__background",
                CHECKED: "mdc-checkbox--checked",
                CHECKMARK: "mdc-checkbox__checkmark",
                CHECKMARK_PATH: "mdc-checkbox__checkmark-path",
                DISABLED: "mdc-checkbox--disabled",
                INDETERMINATE: "mdc-checkbox--indeterminate",
                MIXEDMARK: "mdc-checkbox__mixedmark",
                NATIVE_CONTROL: "mdc-checkbox__native-control",
                ROOT: "mdc-checkbox",
                SELECTED: "mdc-checkbox--selected",
                UPGRADED: "mdc-checkbox--upgraded"
            };
            exports.strings = {
                ARIA_CHECKED_ATTR: "aria-checked",
                ARIA_CHECKED_INDETERMINATE_VALUE: "mixed",
                DATA_INDETERMINATE_ATTR: "data-indeterminate",
                NATIVE_CONTROL_SELECTOR: ".mdc-checkbox__native-control",
                TRANSITION_STATE_CHECKED: "checked",
                TRANSITION_STATE_INDETERMINATE: "indeterminate",
                TRANSITION_STATE_INIT: "init",
                TRANSITION_STATE_UNCHECKED: "unchecked"
            };
            exports.numbers = {
                ANIM_END_LATCH_MS: 250
            };
        /***/ },
        /***/ "./packages/mdc-checkbox/custom-element.js": /*!*************************************************!*\
  !*** ./packages/mdc-checkbox/custom-element.js ***!
  \*************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-checkbox/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcCheckbox = function(_HTMLElement) {
                _inherits(MdcCheckbox, _HTMLElement);
                _createClass(MdcCheckbox, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.checkbox_.nativeControl_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.checkbox_.nativeControl_.blur();
                        }
                    },
                    {
                        key: "checked",
                        get: function get() {
                            return this.checked_;
                        },
                        set: function set(checked) {
                            this.checked_ = checked;
                            if (!!this.checkbox_) this.checkbox_.checked = checked;
                        }
                    },
                    {
                        key: "indeterminate",
                        get: function get() {
                            return this.indeterminate_;
                        },
                        set: function set(indeterminate) {
                            this.indeterminate_ = indeterminate;
                            if (!!this.checkbox_) this.checkbox_.indeterminate = indeterminate;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.checkbox_) this.checkbox_.disabled = disabled;
                        }
                    }
                ]);
                function MdcCheckbox() {
                    _classCallCheck(this, MdcCheckbox);
                    var _this = _possibleConstructorReturn(this, (MdcCheckbox.__proto__ || Object.getPrototypeOf(MdcCheckbox)).call(this));
                    _this.checked_ = false;
                    _this.indeterminate_ = false;
                    _this.disabled_ = false;
                    _this.checkbox_;
                    return _this;
                }
                _createClass(MdcCheckbox, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.checkbox_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCCheckbox"](this);
                            this.checkbox_.checked = this.checked_;
                            this.checkbox_.indeterminate = this.indeterminate_;
                            this.checkbox_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "destroy",
                        value: function destroy() {
                            this.checkbox_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcCheckbox;
            }(HTMLElement);
            customElements.define("mdc-checkbox", MdcCheckbox);
        /***/ },
        /***/ "./packages/mdc-checkbox/foundation.ts": /*!*********************************************!*\
  !*** ./packages/mdc-checkbox/foundation.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCheckboxFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-checkbox/constants.ts");
            var MDCCheckboxFoundation = /** @class */ function(_super) {
                __extends(MDCCheckboxFoundation, _super);
                function MDCCheckboxFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCCheckboxFoundation.defaultAdapter), adapter)) || this;
                    _this.currentCheckState_ = constants_1.strings.TRANSITION_STATE_INIT;
                    _this.currentAnimationClass_ = "";
                    _this.animEndLatchTimer_ = 0;
                    _this.enableAnimationEndHandler_ = false;
                    return _this;
                }
                Object.defineProperty(MDCCheckboxFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckboxFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckboxFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCheckboxFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            forceLayout: function forceLayout() {
                                return undefined;
                            },
                            hasNativeControl: function hasNativeControl() {
                                return false;
                            },
                            isAttachedToDOM: function isAttachedToDOM() {
                                return false;
                            },
                            isChecked: function isChecked() {
                                return false;
                            },
                            isIndeterminate: function isIndeterminate() {
                                return false;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            removeNativeControlAttr: function removeNativeControlAttr() {
                                return undefined;
                            },
                            setNativeControlAttr: function setNativeControlAttr() {
                                return undefined;
                            },
                            setNativeControlDisabled: function setNativeControlDisabled() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCCheckboxFoundation.prototype.init = function() {
                    this.currentCheckState_ = this.determineCheckState_();
                    this.updateAriaChecked_();
                    this.adapter.addClass(constants_1.cssClasses.UPGRADED);
                };
                MDCCheckboxFoundation.prototype.destroy = function() {
                    clearTimeout(this.animEndLatchTimer_);
                };
                MDCCheckboxFoundation.prototype.setDisabled = function(disabled) {
                    this.adapter.setNativeControlDisabled(disabled);
                    if (disabled) this.adapter.addClass(constants_1.cssClasses.DISABLED);
                    else this.adapter.removeClass(constants_1.cssClasses.DISABLED);
                };
                /**
     * Handles the animationend event for the checkbox
     */ MDCCheckboxFoundation.prototype.handleAnimationEnd = function() {
                    var _this = this;
                    if (!this.enableAnimationEndHandler_) return;
                    clearTimeout(this.animEndLatchTimer_);
                    this.animEndLatchTimer_ = setTimeout(function() {
                        _this.adapter.removeClass(_this.currentAnimationClass_);
                        _this.enableAnimationEndHandler_ = false;
                    }, constants_1.numbers.ANIM_END_LATCH_MS);
                };
                /**
     * Handles the change event for the checkbox
     */ MDCCheckboxFoundation.prototype.handleChange = function() {
                    this.transitionCheckState_();
                };
                MDCCheckboxFoundation.prototype.transitionCheckState_ = function() {
                    if (!this.adapter.hasNativeControl()) return;
                    var oldState = this.currentCheckState_;
                    var newState = this.determineCheckState_();
                    if (oldState === newState) return;
                    this.updateAriaChecked_();
                    var TRANSITION_STATE_UNCHECKED = constants_1.strings.TRANSITION_STATE_UNCHECKED;
                    var SELECTED = constants_1.cssClasses.SELECTED;
                    if (newState === TRANSITION_STATE_UNCHECKED) this.adapter.removeClass(SELECTED);
                    else this.adapter.addClass(SELECTED);
                    // Check to ensure that there isn't a previously existing animation class, in case for example
                    // the user interacted with the checkbox before the animation was finished.
                    if (this.currentAnimationClass_.length > 0) {
                        clearTimeout(this.animEndLatchTimer_);
                        this.adapter.forceLayout();
                        this.adapter.removeClass(this.currentAnimationClass_);
                    }
                    this.currentAnimationClass_ = this.getTransitionAnimationClass_(oldState, newState);
                    this.currentCheckState_ = newState;
                    // Check for parentNode so that animations are only run when the element is attached
                    // to the DOM.
                    if (this.adapter.isAttachedToDOM() && this.currentAnimationClass_.length > 0) {
                        this.adapter.addClass(this.currentAnimationClass_);
                        this.enableAnimationEndHandler_ = true;
                    }
                };
                MDCCheckboxFoundation.prototype.determineCheckState_ = function() {
                    var TRANSITION_STATE_INDETERMINATE = constants_1.strings.TRANSITION_STATE_INDETERMINATE, TRANSITION_STATE_CHECKED = constants_1.strings.TRANSITION_STATE_CHECKED, TRANSITION_STATE_UNCHECKED = constants_1.strings.TRANSITION_STATE_UNCHECKED;
                    if (this.adapter.isIndeterminate()) return TRANSITION_STATE_INDETERMINATE;
                    return this.adapter.isChecked() ? TRANSITION_STATE_CHECKED : TRANSITION_STATE_UNCHECKED;
                };
                MDCCheckboxFoundation.prototype.getTransitionAnimationClass_ = function(oldState, newState) {
                    var TRANSITION_STATE_INIT = constants_1.strings.TRANSITION_STATE_INIT, TRANSITION_STATE_CHECKED = constants_1.strings.TRANSITION_STATE_CHECKED, TRANSITION_STATE_UNCHECKED = constants_1.strings.TRANSITION_STATE_UNCHECKED;
                    var _a = MDCCheckboxFoundation.cssClasses, ANIM_UNCHECKED_CHECKED = _a.ANIM_UNCHECKED_CHECKED, ANIM_UNCHECKED_INDETERMINATE = _a.ANIM_UNCHECKED_INDETERMINATE, ANIM_CHECKED_UNCHECKED = _a.ANIM_CHECKED_UNCHECKED, ANIM_CHECKED_INDETERMINATE = _a.ANIM_CHECKED_INDETERMINATE, ANIM_INDETERMINATE_CHECKED = _a.ANIM_INDETERMINATE_CHECKED, ANIM_INDETERMINATE_UNCHECKED = _a.ANIM_INDETERMINATE_UNCHECKED;
                    switch(oldState){
                        case TRANSITION_STATE_INIT:
                            if (newState === TRANSITION_STATE_UNCHECKED) return "";
                            return newState === TRANSITION_STATE_CHECKED ? ANIM_INDETERMINATE_CHECKED : ANIM_INDETERMINATE_UNCHECKED;
                        case TRANSITION_STATE_UNCHECKED:
                            return newState === TRANSITION_STATE_CHECKED ? ANIM_UNCHECKED_CHECKED : ANIM_UNCHECKED_INDETERMINATE;
                        case TRANSITION_STATE_CHECKED:
                            return newState === TRANSITION_STATE_UNCHECKED ? ANIM_CHECKED_UNCHECKED : ANIM_CHECKED_INDETERMINATE;
                        default:
                            // TRANSITION_STATE_INDETERMINATE
                            return newState === TRANSITION_STATE_CHECKED ? ANIM_INDETERMINATE_CHECKED : ANIM_INDETERMINATE_UNCHECKED;
                    }
                };
                MDCCheckboxFoundation.prototype.updateAriaChecked_ = function() {
                    // Ensure aria-checked is set to mixed if checkbox is in indeterminate state.
                    if (this.adapter.isIndeterminate()) this.adapter.setNativeControlAttr(constants_1.strings.ARIA_CHECKED_ATTR, constants_1.strings.ARIA_CHECKED_INDETERMINATE_VALUE);
                    else // The on/off state does not need to keep track of aria-checked, since
                    // the screenreader uses the checked property on the checkbox element.
                    this.adapter.removeNativeControlAttr(constants_1.strings.ARIA_CHECKED_ATTR);
                };
                return MDCCheckboxFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCCheckboxFoundation = MDCCheckboxFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCCheckboxFoundation;
        /***/ },
        /***/ "./packages/mdc-chips/chip-set/custom-element.js": /*!*******************************************************!*\
  !*** ./packages/mdc-chips/chip-set/custom-element.js ***!
  \*******************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../deprecated/chip-set/component */ "./packages/mdc-chips/deprecated/chip-set/component.ts");
            /* harmony import */ var _deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0__);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcChipSet = function(_HTMLElement) {
                _inherits(MdcChipSet, _HTMLElement);
                _createClass(MdcChipSet, [
                    {
                        key: "focus",
                        value: function focus() {
                            var selectedChip = null;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = this.chipset_.chips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var chip = _step.value;
                                    if (chip.selected) {
                                        selectedChip = chip;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            if (!!selectedChip) selectedChip.focusPrimaryAction();
                            else if (this.chipset_.chips.length > 0) this.chipset_.chips[0].focusPrimaryAction();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    }
                ]);
                function MdcChipSet() {
                    _classCallCheck(this, MdcChipSet);
                    return _possibleConstructorReturn(this, (MdcChipSet.__proto__ || Object.getPrototypeOf(MdcChipSet)).call(this));
                }
                _createClass(MdcChipSet, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.chipset_ = new _deprecated_chip_set_component__WEBPACK_IMPORTED_MODULE_0__["MDCChipSet"](this);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.chipset_.destroy();
                        }
                    }
                ]);
                return MdcChipSet;
            }(HTMLElement);
            customElements.define("mdc-chip-set", MdcChipSet);
        /***/ },
        /***/ "./packages/mdc-chips/chip/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-chips/chip/custom-element.js ***!
  \***************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../deprecated/chip/component */ "./packages/mdc-chips/deprecated/chip/component.ts");
            /* harmony import */ var _deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var idCounter = 0;
            var MdcChip = function(_HTMLElement) {
                _inherits(MdcChip, _HTMLElement);
                _createClass(MdcChip, [
                    {
                        key: "id",
                        get: function get() {
                            return this.id_;
                        },
                        set: function set(id) {
                            this.id_ = id;
                        }
                    },
                    {
                        key: "selected",
                        get: function get() {
                            return this.selected_;
                        },
                        set: function set(selected) {
                            this.selected_ = selected;
                            if (!!this.chip_) this.chip_.selected = selected;
                        }
                    }
                ]);
                function MdcChip() {
                    _classCallCheck(this, MdcChip);
                    var _this = _possibleConstructorReturn(this, (MdcChip.__proto__ || Object.getPrototypeOf(MdcChip)).call(this));
                    _this.selected_ = false;
                    _this.id_ = "mdc-chip-" + ++idCounter;
                    _this.chipset_ = null;
                    return _this;
                }
                _createClass(MdcChip, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.chip_ = new _deprecated_chip_component__WEBPACK_IMPORTED_MODULE_0__["MDCChip"](this);
                            this.chip_.selected = this.selected_;
                            this.chipset_ = this.parentElement.parentElement.chipset_;
                            this.chipset_.addChip(this);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.chip_.destroy();
                            this.chipset_.foundation.adapter.removeChipAtIndex(this.chipset_.findChipIndex_(this.id));
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcChip;
            }(HTMLElement);
            customElements.define("mdc-chip", MdcChip);
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip-set/component.ts": /*!*************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip-set/component.ts ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipSet = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var announce_1 = __webpack_require__(/*! @material/dom/announce */ "./packages/mdc-dom/announce.ts");
            var foundation_1 = __webpack_require__(/*! ../chip/foundation */ "./packages/mdc-chips/deprecated/chip/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-chips/deprecated/chip-set/foundation.ts");
            var _a = foundation_1.MDCChipFoundation.strings, INTERACTION_EVENT = _a.INTERACTION_EVENT, SELECTION_EVENT = _a.SELECTION_EVENT, REMOVAL_EVENT = _a.REMOVAL_EVENT, NAVIGATION_EVENT = _a.NAVIGATION_EVENT;
            var MDCChipSet = /** @class */ function(_super) {
                __extends(MDCChipSet, _super);
                function MDCChipSet() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCChipSet.attachTo = function(root) {
                    return new MDCChipSet(root);
                };
                Object.defineProperty(MDCChipSet.prototype, "chips", {
                    get: function get() {
                        return this.chips_.slice();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipSet.prototype, "selectedChipIds", {
                    /**
         * @return An array of the IDs of all selected chips.
         */ get: function get() {
                        return this.foundation.getSelectedChipIds();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * @param chipFactory A function which creates a new MDCChip.
     */ MDCChipSet.prototype.initialize = function() {
                    this.chipFactory_ = function(el) {
                        return el.chip_;
                    };
                    this.chips_ = [];
                };
                MDCChipSet.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.chips_.forEach(function(chip) {
                        if (chip.id && chip.selected) _this.foundation.select(chip.id);
                    });
                    this.handleChipInteraction_ = function(evt) {
                        return _this.foundation.handleChipInteraction(evt.detail);
                    };
                    this.handleChipSelection_ = function(evt) {
                        return _this.foundation.handleChipSelection(evt.detail);
                    };
                    this.handleChipRemoval_ = function(evt) {
                        return _this.foundation.handleChipRemoval(evt.detail);
                    };
                    this.handleChipNavigation_ = function(evt) {
                        return _this.foundation.handleChipNavigation(evt.detail);
                    };
                    this.listen(INTERACTION_EVENT, this.handleChipInteraction_);
                    this.listen(SELECTION_EVENT, this.handleChipSelection_);
                    this.listen(NAVIGATION_EVENT, this.handleChipNavigation_);
                };
                MDCChipSet.prototype.destroy = function() {
                    this.chips_.forEach(function(chip) {
                        chip.destroy();
                    });
                    this.unlisten(INTERACTION_EVENT, this.handleChipInteraction_);
                    this.unlisten(SELECTION_EVENT, this.handleChipSelection_);
                    this.unlisten(REMOVAL_EVENT, this.handleChipRemoval_);
                    this.unlisten(NAVIGATION_EVENT, this.handleChipNavigation_);
                    _super.prototype.destroy.call(this);
                };
                /**
     * Adds a new chip object to the chip set from the given chip element.
     */ MDCChipSet.prototype.addChip = function(chipEl) {
                    this.chips_.push(this.chipFactory_(chipEl));
                    if (this.chips_.length === 1) this.chips_[0].makePrimaryActionFocusable();
                };
                MDCChipSet.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        announceMessage: function announceMessage(message) {
                            announce_1.announce(message);
                        },
                        focusChipPrimaryActionAtIndex: function focusChipPrimaryActionAtIndex(index) {
                            _this.chips_[index].focusPrimaryAction();
                        },
                        focusChipTrailingActionAtIndex: function focusChipTrailingActionAtIndex(index) {
                            _this.chips_[index].focusTrailingAction();
                        },
                        getChipListCount: function getChipListCount() {
                            return _this.chips_.length;
                        },
                        getIndexOfChipById: function getIndexOfChipById(chipId) {
                            return _this.findChipIndex_(chipId);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        isRTL: function isRTL() {
                            return window.getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        removeChipAtIndex: function removeChipAtIndex(index) {
                            if (index >= 0 && index < _this.chips_.length) {
                                _this.chips_.splice(index, 1);
                                if (_this.chips_.length > 0 && !_this.chips_.some(function(chip) {
                                    return chip.isPrimaryActionFocusable();
                                })) _this.chips_[Math.max(0, index - 1)].makePrimaryActionFocusable();
                            }
                        },
                        removeFocusFromChipAtIndex: function removeFocusFromChipAtIndex(index) {
                            _this.chips_[index].removeFocus();
                        },
                        selectChipAtIndex: function selectChipAtIndex(index, selected, shouldNotifyClients) {
                            if (index >= 0 && index < _this.chips_.length) _this.chips_[index].setSelectedFromChipSet(selected, shouldNotifyClients);
                        }
                    };
                    return new foundation_2.MDCChipSetFoundation(adapter);
                };
                /**
     * Returns the index of the chip with the given id, or -1 if the chip does not exist.
     */ MDCChipSet.prototype.findChipIndex_ = function(chipId) {
                    for(var i = 0; i < this.chips_.length; i++){
                        if (this.chips_[i].id === chipId) return i;
                    }
                    return -1;
                };
                return MDCChipSet;
            }(component_1.MDCComponent);
            exports.MDCChipSet = MDCChipSet;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip-set/constants.ts": /*!*************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip-set/constants.ts ***!
  \*************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            exports.strings = {
                CHIP_SELECTOR: ".mdc-chip"
            };
            exports.cssClasses = {
                CHOICE: "mdc-chip-set--choice",
                FILTER: "mdc-chip-set--filter"
            };
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip-set/foundation.ts": /*!**************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip-set/foundation.ts ***!
  \**************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipSetFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ../chip/constants */ "./packages/mdc-chips/deprecated/chip/constants.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/chip-set/constants.ts");
            var MDCChipSetFoundation = /** @class */ function(_super) {
                __extends(MDCChipSetFoundation, _super);
                function MDCChipSetFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCChipSetFoundation.defaultAdapter), adapter)) || this;
                    /**
         * The ids of the selected chips in the set. Only used for choice chip set or filter chip set.
         */ _this.selectedChipIds_ = [];
                    return _this;
                }
                Object.defineProperty(MDCChipSetFoundation, "strings", {
                    get: function get() {
                        return constants_2.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipSetFoundation, "cssClasses", {
                    get: function get() {
                        return constants_2.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipSetFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            announceMessage: function announceMessage() {
                                return undefined;
                            },
                            focusChipPrimaryActionAtIndex: function focusChipPrimaryActionAtIndex() {
                                return undefined;
                            },
                            focusChipTrailingActionAtIndex: function focusChipTrailingActionAtIndex() {
                                return undefined;
                            },
                            getChipListCount: function getChipListCount() {
                                return -1;
                            },
                            getIndexOfChipById: function getIndexOfChipById() {
                                return -1;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            removeChipAtIndex: function removeChipAtIndex() {
                                return undefined;
                            },
                            removeFocusFromChipAtIndex: function removeFocusFromChipAtIndex() {
                                return undefined;
                            },
                            selectChipAtIndex: function selectChipAtIndex() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns an array of the IDs of all selected chips.
     */ MDCChipSetFoundation.prototype.getSelectedChipIds = function() {
                    return this.selectedChipIds_.slice();
                };
                /**
     * Selects the chip with the given id. Deselects all other chips if the chip set is of the choice variant.
     * Does not notify clients of the updated selection state.
     */ MDCChipSetFoundation.prototype.select = function(chipId) {
                    this.select_(chipId, false);
                };
                /**
     * Handles a chip interaction event
     */ MDCChipSetFoundation.prototype.handleChipInteraction = function(_a) {
                    var chipId = _a.chipId;
                    var index = this.adapter.getIndexOfChipById(chipId);
                    this.removeFocusFromChipsExcept_(index);
                };
                /**
     * Handles a chip selection event, used to handle discrepancy when selection state is set directly on the Chip.
     */ MDCChipSetFoundation.prototype.handleChipSelection = function(_a) {
                    var chipId = _a.chipId, selected = _a.selected, shouldIgnore = _a.shouldIgnore;
                    // Early exit if we should ignore the event
                    if (shouldIgnore) return;
                    var chipIsSelected = this.selectedChipIds_.indexOf(chipId) >= 0;
                    if (selected && !chipIsSelected) this.select(chipId);
                    else if (!selected && chipIsSelected) this.deselect_(chipId);
                };
                /**
     * Handles the event when a chip is removed.
     */ MDCChipSetFoundation.prototype.handleChipRemoval = function(_a) {
                    var chipId = _a.chipId, removedAnnouncement = _a.removedAnnouncement;
                    if (removedAnnouncement) this.adapter.announceMessage(removedAnnouncement);
                    var index = this.adapter.getIndexOfChipById(chipId);
                    this.deselectAndNotifyClients_(chipId);
                    this.adapter.removeChipAtIndex(index);
                    var maxIndex = this.adapter.getChipListCount() - 1;
                    if (maxIndex < 0) return;
                    var nextIndex = Math.min(index, maxIndex);
                    this.removeFocusFromChipsExcept_(nextIndex);
                    // After removing a chip, we should focus the trailing action for the next chip.
                    this.adapter.focusChipTrailingActionAtIndex(nextIndex);
                };
                /**
     * Handles a chip navigation event.
     */ MDCChipSetFoundation.prototype.handleChipNavigation = function(_a) {
                    var chipId = _a.chipId, key = _a.key, source = _a.source;
                    var maxIndex = this.adapter.getChipListCount() - 1;
                    var index = this.adapter.getIndexOfChipById(chipId);
                    // Early exit if the index is out of range or the key is unusable
                    if (index === -1 || !constants_1.navigationKeys.has(key)) return;
                    var isRTL = this.adapter.isRTL();
                    var isLeftKey = key === constants_1.strings.ARROW_LEFT_KEY || key === constants_1.strings.IE_ARROW_LEFT_KEY;
                    var isRightKey = key === constants_1.strings.ARROW_RIGHT_KEY || key === constants_1.strings.IE_ARROW_RIGHT_KEY;
                    var isDownKey = key === constants_1.strings.ARROW_DOWN_KEY || key === constants_1.strings.IE_ARROW_DOWN_KEY;
                    var shouldIncrement = !isRTL && isRightKey || isRTL && isLeftKey || isDownKey;
                    var isHome = key === constants_1.strings.HOME_KEY;
                    var isEnd = key === constants_1.strings.END_KEY;
                    if (shouldIncrement) index++;
                    else if (isHome) index = 0;
                    else if (isEnd) index = maxIndex;
                    else index--;
                    // Early exit if the index is out of bounds
                    if (index < 0 || index > maxIndex) return;
                    this.removeFocusFromChipsExcept_(index);
                    this.focusChipAction_(index, key, source);
                };
                MDCChipSetFoundation.prototype.focusChipAction_ = function(index, key, source) {
                    var shouldJumpChips = constants_1.jumpChipKeys.has(key);
                    if (shouldJumpChips && source === constants_1.EventSource.PRIMARY) return this.adapter.focusChipPrimaryActionAtIndex(index);
                    if (shouldJumpChips && source === constants_1.EventSource.TRAILING) return this.adapter.focusChipTrailingActionAtIndex(index);
                    var dir = this.getDirection_(key);
                    if (dir === constants_1.Direction.LEFT) return this.adapter.focusChipTrailingActionAtIndex(index);
                    if (dir === constants_1.Direction.RIGHT) return this.adapter.focusChipPrimaryActionAtIndex(index);
                };
                MDCChipSetFoundation.prototype.getDirection_ = function(key) {
                    var isRTL = this.adapter.isRTL();
                    var isLeftKey = key === constants_1.strings.ARROW_LEFT_KEY || key === constants_1.strings.IE_ARROW_LEFT_KEY;
                    var isRightKey = key === constants_1.strings.ARROW_RIGHT_KEY || key === constants_1.strings.IE_ARROW_RIGHT_KEY;
                    if (!isRTL && isLeftKey || isRTL && isRightKey) return constants_1.Direction.LEFT;
                    return constants_1.Direction.RIGHT;
                };
                /**
     * Deselects the chip with the given id and optionally notifies clients.
     */ MDCChipSetFoundation.prototype.deselect_ = function(chipId, shouldNotifyClients) {
                    if (shouldNotifyClients === void 0) shouldNotifyClients = false;
                    var index = this.selectedChipIds_.indexOf(chipId);
                    if (index >= 0) {
                        this.selectedChipIds_.splice(index, 1);
                        var chipIndex = this.adapter.getIndexOfChipById(chipId);
                        this.adapter.selectChipAtIndex(chipIndex, /** isSelected */ false, shouldNotifyClients);
                    }
                };
                /**
     * Deselects the chip with the given id and notifies clients.
     */ MDCChipSetFoundation.prototype.deselectAndNotifyClients_ = function(chipId) {
                    this.deselect_(chipId, true);
                };
                MDCChipSetFoundation.prototype.removeFocusFromChipsExcept_ = function(index) {
                    var chipCount = this.adapter.getChipListCount();
                    for(var i = 0; i < chipCount; i++)if (i !== index) this.adapter.removeFocusFromChipAtIndex(i);
                };
                MDCChipSetFoundation.prototype.select_ = function(chipId, shouldNotifyClients) {
                    if (this.selectedChipIds_.indexOf(chipId) >= 0) return;
                    if (this.adapter.hasClass(constants_2.cssClasses.CHOICE) && this.selectedChipIds_.length > 0) {
                        var previouslySelectedChip = this.selectedChipIds_[0];
                        var previouslySelectedIndex = this.adapter.getIndexOfChipById(previouslySelectedChip);
                        this.selectedChipIds_ = [];
                        this.adapter.selectChipAtIndex(previouslySelectedIndex, /** isSelected */ false, shouldNotifyClients);
                    }
                    this.selectedChipIds_.push(chipId);
                    var index = this.adapter.getIndexOfChipById(chipId);
                    this.adapter.selectChipAtIndex(index, /** isSelected */ true, shouldNotifyClients);
                };
                return MDCChipSetFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCChipSetFoundation = MDCChipSetFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCChipSetFoundation;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip/component.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip/component.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChip = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var component_3 = __webpack_require__(/*! ../trailingaction/component */ "./packages/mdc-chips/deprecated/trailingaction/component.ts");
            var constants_1 = __webpack_require__(/*! ../trailingaction/constants */ "./packages/mdc-chips/deprecated/trailingaction/constants.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/chip/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-chips/deprecated/chip/foundation.ts");
            var MDCChip = /** @class */ function(_super) {
                __extends(MDCChip, _super);
                function MDCChip() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCChip.prototype, "selected", {
                    /**
         * @return Whether the chip is selected.
         */ get: function get() {
                        return this.foundation.isSelected();
                    },
                    /**
         * Sets selected state on the chip.
         */ set: function set(selected) {
                        this.foundation.setSelected(selected);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "shouldRemoveOnTrailingIconClick", {
                    /**
         * @return Whether a trailing icon click should trigger exit/removal of the chip.
         */ get: function get() {
                        return this.foundation.getShouldRemoveOnTrailingIconClick();
                    },
                    /**
         * Sets whether a trailing icon click should trigger exit/removal of the chip.
         */ set: function set(shouldRemove) {
                        this.foundation.setShouldRemoveOnTrailingIconClick(shouldRemove);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "setShouldFocusPrimaryActionOnClick", {
                    /**
         * Sets whether a clicking on the chip should focus the primary action.
         */ set: function set(shouldFocus) {
                        this.foundation.setShouldFocusPrimaryActionOnClick(shouldFocus);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChip.prototype, "id", {
                    get: function get() {
                        return this.root.id;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChip.attachTo = function(root) {
                    return new MDCChip(root);
                };
                MDCChip.prototype.initialize = function(rippleFactory, trailingActionFactory) {
                    var _this = this;
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_2.MDCRipple(el, foundation);
                    };
                    if (trailingActionFactory === void 0) trailingActionFactory = function trailingActionFactory(el) {
                        return new component_3.MDCChipTrailingAction(el);
                    };
                    this.leadingIcon_ = this.root.querySelector(constants_2.strings.LEADING_ICON_SELECTOR);
                    this.checkmark_ = this.root.querySelector(constants_2.strings.CHECKMARK_SELECTOR);
                    this.primaryAction_ = this.root.querySelector(constants_2.strings.PRIMARY_ACTION_SELECTOR);
                    var trailingActionEl = this.root.querySelector(constants_2.strings.TRAILING_ACTION_SELECTOR);
                    if (trailingActionEl) this.trailingAction_ = trailingActionFactory(trailingActionEl);
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var rippleAdapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        computeBoundingRect: function computeBoundingRect() {
                            return _this.foundation.getDimensions();
                        }
                    });
                    this.ripple_ = rippleFactory(this.root, new foundation_1.MDCRippleFoundation(rippleAdapter));
                };
                MDCChip.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    // Custom events
                    this.handleTrailingActionInteraction_ = function() {
                        _this.foundation.handleTrailingActionInteraction();
                    };
                    this.handleTrailingActionNavigation_ = function(evt) {
                        _this.foundation.handleTrailingActionNavigation(evt);
                    };
                    // Native events
                    this.handleClick_ = function() {
                        _this.foundation.handleClick();
                    };
                    this.handleKeydown_ = function(evt) {
                        _this.foundation.handleKeydown(evt);
                    };
                    this.handleTransitionEnd_ = function(evt) {
                        _this.foundation.handleTransitionEnd(evt);
                    };
                    this.handleFocusIn_ = function(evt) {
                        _this.foundation.handleFocusIn(evt);
                    };
                    this.handleFocusOut_ = function(evt) {
                        _this.foundation.handleFocusOut(evt);
                    };
                    this.listen("transitionend", this.handleTransitionEnd_);
                    this.listen("click", this.handleClick_);
                    this.listen("keydown", this.handleKeydown_);
                    this.listen("focusin", this.handleFocusIn_);
                    this.listen("focusout", this.handleFocusOut_);
                    if (this.trailingAction_) {
                        this.listen(constants_1.strings.INTERACTION_EVENT, this.handleTrailingActionInteraction_);
                        this.listen(constants_1.strings.NAVIGATION_EVENT, this.handleTrailingActionNavigation_);
                    }
                };
                MDCChip.prototype.destroy = function() {
                    this.ripple_.destroy();
                    this.unlisten("transitionend", this.handleTransitionEnd_);
                    this.unlisten("keydown", this.handleKeydown_);
                    this.unlisten("click", this.handleClick_);
                    this.unlisten("focusin", this.handleFocusIn_);
                    this.unlisten("focusout", this.handleFocusOut_);
                    if (this.trailingAction_) {
                        this.unlisten(constants_1.strings.INTERACTION_EVENT, this.handleTrailingActionInteraction_);
                        this.unlisten(constants_1.strings.NAVIGATION_EVENT, this.handleTrailingActionNavigation_);
                    }
                    _super.prototype.destroy.call(this);
                };
                /**
     * Begins the exit animation which leads to removal of the chip.
     */ MDCChip.prototype.beginExit = function() {
                    this.foundation.beginExit();
                };
                MDCChip.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        addClassToLeadingIcon: function addClassToLeadingIcon(className) {
                            if (_this.leadingIcon_) _this.leadingIcon_.classList.add(className);
                        },
                        eventTargetHasClass: function eventTargetHasClass(target, className) {
                            return target ? target.classList.contains(className) : false;
                        },
                        focusPrimaryAction: function focusPrimaryAction() {
                            if (_this.primaryAction_) _this.primaryAction_.focus();
                        },
                        focusTrailingAction: function focusTrailingAction() {
                            if (_this.trailingAction_) _this.trailingAction_.focus();
                        },
                        getAttribute: function getAttribute(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                            return _this.checkmark_ ? _this.checkmark_.getBoundingClientRect() : null;
                        },
                        getComputedStyleValue: function getComputedStyleValue(propertyName) {
                            return window.getComputedStyle(_this.root).getPropertyValue(propertyName);
                        },
                        getRootBoundingClientRect: function getRootBoundingClientRect() {
                            return _this.root.getBoundingClientRect();
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        hasLeadingIcon: function hasLeadingIcon() {
                            return !!_this.leadingIcon_;
                        },
                        isRTL: function isRTL() {
                            return window.getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        isTrailingActionNavigable: function isTrailingActionNavigable() {
                            if (_this.trailingAction_) return _this.trailingAction_.isNavigable();
                            return false;
                        },
                        notifyInteraction: function notifyInteraction() {
                            return _this.emit(constants_2.strings.INTERACTION_EVENT, {
                                chipId: _this.id
                            }, true);
                        },
                        notifyNavigation: function notifyNavigation(key, source) {
                            return _this.emit(constants_2.strings.NAVIGATION_EVENT, {
                                chipId: _this.id,
                                key: key,
                                source: source
                            }, true);
                        },
                        notifyRemoval: function notifyRemoval(removedAnnouncement) {
                            _this.emit(constants_2.strings.REMOVAL_EVENT, {
                                chipId: _this.id,
                                removedAnnouncement: removedAnnouncement
                            }, true);
                        },
                        notifySelection: function notifySelection(selected, shouldIgnore) {
                            return _this.emit(constants_2.strings.SELECTION_EVENT, {
                                chipId: _this.id,
                                selected: selected,
                                shouldIgnore: shouldIgnore
                            }, true);
                        },
                        notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                            return _this.emit(constants_2.strings.TRAILING_ICON_INTERACTION_EVENT, {
                                chipId: _this.id
                            }, true);
                        },
                        notifyEditStart: function notifyEditStart() {},
                        notifyEditFinish: function notifyEditFinish() {},
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        removeClassFromLeadingIcon: function removeClassFromLeadingIcon(className) {
                            if (_this.leadingIcon_) _this.leadingIcon_.classList.remove(className);
                        },
                        removeTrailingActionFocus: function removeTrailingActionFocus() {
                            if (_this.trailingAction_) _this.trailingAction_.removeFocus();
                        },
                        setPrimaryActionAttr: function setPrimaryActionAttr(attr, value) {
                            if (_this.primaryAction_) _this.primaryAction_.setAttribute(attr, value);
                        },
                        setStyleProperty: function setStyleProperty(propertyName, value) {
                            return _this.root.style.setProperty(propertyName, value);
                        }
                    };
                    return new foundation_2.MDCChipFoundation(adapter);
                };
                MDCChip.prototype.setSelectedFromChipSet = function(selected, shouldNotifyClients) {
                    this.foundation.setSelectedFromChipSet(selected, shouldNotifyClients);
                };
                MDCChip.prototype.focusPrimaryAction = function() {
                    this.foundation.focusPrimaryAction();
                };
                MDCChip.prototype.focusTrailingAction = function() {
                    this.foundation.focusTrailingAction();
                };
                MDCChip.prototype.removeFocus = function() {
                    this.foundation.removeFocus();
                };
                MDCChip.prototype.makePrimaryActionFocusable = function() {
                    if (!this.primaryAction_) return;
                    this.primaryAction_.setAttribute("tabindex", "0");
                };
                MDCChip.prototype.isPrimaryActionFocusable = function() {
                    if (!this.primaryAction_) return false;
                    return this.primaryAction_.getAttribute("tabindex") === "0";
                };
                return MDCChip;
            }(component_1.MDCComponent);
            exports.MDCChip = MDCChip;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip/constants.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip/constants.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.jumpChipKeys = exports.navigationKeys = exports.cssClasses = exports.strings = exports.EventSource = exports.Direction = void 0;
            var Direction;
            (function(Direction) {
                Direction["LEFT"] = "left";
                Direction["RIGHT"] = "right";
            })(Direction = exports.Direction || (exports.Direction = {}));
            var EventSource;
            (function(EventSource) {
                EventSource["PRIMARY"] = "primary";
                EventSource["TRAILING"] = "trailing";
                EventSource["NONE"] = "none";
            })(EventSource = exports.EventSource || (exports.EventSource = {}));
            exports.strings = {
                ADDED_ANNOUNCEMENT_ATTRIBUTE: "data-mdc-chip-added-announcement",
                ARIA_CHECKED: "aria-checked",
                ARROW_DOWN_KEY: "ArrowDown",
                ARROW_LEFT_KEY: "ArrowLeft",
                ARROW_RIGHT_KEY: "ArrowRight",
                ARROW_UP_KEY: "ArrowUp",
                BACKSPACE_KEY: "Backspace",
                CHECKMARK_SELECTOR: ".mdc-chip__checkmark",
                DELETE_KEY: "Delete",
                END_KEY: "End",
                ENTER_KEY: "Enter",
                ENTRY_ANIMATION_NAME: "mdc-chip-entry",
                HOME_KEY: "Home",
                IE_ARROW_DOWN_KEY: "Down",
                IE_ARROW_LEFT_KEY: "Left",
                IE_ARROW_RIGHT_KEY: "Right",
                IE_ARROW_UP_KEY: "Up",
                IE_DELETE_KEY: "Del",
                INTERACTION_EVENT: "MDCChip:interaction",
                LEADING_ICON_SELECTOR: ".mdc-chip__icon--leading",
                NAVIGATION_EVENT: "MDCChip:navigation",
                PRIMARY_ACTION_SELECTOR: ".mdc-chip__primary-action",
                REMOVED_ANNOUNCEMENT_ATTRIBUTE: "data-mdc-chip-removed-announcement",
                REMOVAL_EVENT: "MDCChip:removal",
                SELECTION_EVENT: "MDCChip:selection",
                SPACEBAR_KEY: " ",
                TAB_INDEX: "tabindex",
                TRAILING_ACTION_SELECTOR: ".mdc-chip-trailing-action",
                TRAILING_ICON_INTERACTION_EVENT: "MDCChip:trailingIconInteraction",
                TRAILING_ICON_SELECTOR: ".mdc-chip__icon--trailing"
            };
            exports.cssClasses = {
                CHECKMARK: "mdc-chip__checkmark",
                CHIP_EXIT: "mdc-chip--exit",
                DELETABLE: "mdc-chip--deletable",
                EDITABLE: "mdc-chip--editable",
                EDITING: "mdc-chip--editing",
                HIDDEN_LEADING_ICON: "mdc-chip__icon--leading-hidden",
                LEADING_ICON: "mdc-chip__icon--leading",
                PRIMARY_ACTION: "mdc-chip__primary-action",
                PRIMARY_ACTION_FOCUSED: "mdc-chip--primary-action-focused",
                SELECTED: "mdc-chip--selected",
                TEXT: "mdc-chip__text",
                TRAILING_ACTION: "mdc-chip__trailing-action",
                TRAILING_ICON: "mdc-chip__icon--trailing"
            };
            exports.navigationKeys = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this by hand
            exports.navigationKeys.add(exports.strings.ARROW_LEFT_KEY);
            exports.navigationKeys.add(exports.strings.ARROW_RIGHT_KEY);
            exports.navigationKeys.add(exports.strings.ARROW_DOWN_KEY);
            exports.navigationKeys.add(exports.strings.ARROW_UP_KEY);
            exports.navigationKeys.add(exports.strings.END_KEY);
            exports.navigationKeys.add(exports.strings.HOME_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_LEFT_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_RIGHT_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_DOWN_KEY);
            exports.navigationKeys.add(exports.strings.IE_ARROW_UP_KEY);
            exports.jumpChipKeys = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this by hand
            exports.jumpChipKeys.add(exports.strings.ARROW_UP_KEY);
            exports.jumpChipKeys.add(exports.strings.ARROW_DOWN_KEY);
            exports.jumpChipKeys.add(exports.strings.HOME_KEY);
            exports.jumpChipKeys.add(exports.strings.END_KEY);
            exports.jumpChipKeys.add(exports.strings.IE_ARROW_UP_KEY);
            exports.jumpChipKeys.add(exports.strings.IE_ARROW_DOWN_KEY);
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/chip/foundation.ts": /*!**********************************************************!*\
  !*** ./packages/mdc-chips/deprecated/chip/foundation.ts ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/chip/constants.ts");
            var emptyClientRect = {
                bottom: 0,
                height: 0,
                left: 0,
                right: 0,
                top: 0,
                width: 0
            };
            var FocusBehavior;
            (function(FocusBehavior) {
                FocusBehavior[FocusBehavior["SHOULD_FOCUS"] = 0] = "SHOULD_FOCUS";
                FocusBehavior[FocusBehavior["SHOULD_NOT_FOCUS"] = 1] = "SHOULD_NOT_FOCUS";
            })(FocusBehavior || (FocusBehavior = {}));
            var MDCChipFoundation = /** @class */ function(_super) {
                __extends(MDCChipFoundation, _super);
                function MDCChipFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCChipFoundation.defaultAdapter), adapter)) || this;
                    /** Whether a trailing icon click should immediately trigger exit/removal of the chip. */ _this.shouldRemoveOnTrailingIconClick_ = true;
                    /**
         * Whether the primary action should receive focus on click. Should only be
         * set to true for clients who programmatically give focus to a different
         * element on the page when a chip is clicked (like a menu).
         */ _this.shouldFocusPrimaryActionOnClick_ = true;
                    return _this;
                }
                Object.defineProperty(MDCChipFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            addClassToLeadingIcon: function addClassToLeadingIcon() {
                                return undefined;
                            },
                            eventTargetHasClass: function eventTargetHasClass() {
                                return false;
                            },
                            focusPrimaryAction: function focusPrimaryAction() {
                                return undefined;
                            },
                            focusTrailingAction: function focusTrailingAction() {
                                return undefined;
                            },
                            getAttribute: function getAttribute() {
                                return null;
                            },
                            getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                                return emptyClientRect;
                            },
                            getComputedStyleValue: function getComputedStyleValue() {
                                return "";
                            },
                            getRootBoundingClientRect: function getRootBoundingClientRect() {
                                return emptyClientRect;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            hasLeadingIcon: function hasLeadingIcon() {
                                return false;
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            isTrailingActionNavigable: function isTrailingActionNavigable() {
                                return false;
                            },
                            notifyEditFinish: function notifyEditFinish() {
                                return undefined;
                            },
                            notifyEditStart: function notifyEditStart() {
                                return undefined;
                            },
                            notifyInteraction: function notifyInteraction() {
                                return undefined;
                            },
                            notifyNavigation: function notifyNavigation() {
                                return undefined;
                            },
                            notifyRemoval: function notifyRemoval() {
                                return undefined;
                            },
                            notifySelection: function notifySelection() {
                                return undefined;
                            },
                            notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            removeClassFromLeadingIcon: function removeClassFromLeadingIcon() {
                                return undefined;
                            },
                            removeTrailingActionFocus: function removeTrailingActionFocus() {
                                return undefined;
                            },
                            setPrimaryActionAttr: function setPrimaryActionAttr() {
                                return undefined;
                            },
                            setStyleProperty: function setStyleProperty() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChipFoundation.prototype.isSelected = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.SELECTED);
                };
                MDCChipFoundation.prototype.isEditable = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.EDITABLE);
                };
                MDCChipFoundation.prototype.isEditing = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.EDITING);
                };
                MDCChipFoundation.prototype.setSelected = function(selected) {
                    this.setSelected_(selected);
                    this.notifySelection_(selected);
                };
                MDCChipFoundation.prototype.setSelectedFromChipSet = function(selected, shouldNotifyClients) {
                    this.setSelected_(selected);
                    if (shouldNotifyClients) this.notifyIgnoredSelection_(selected);
                };
                MDCChipFoundation.prototype.getShouldRemoveOnTrailingIconClick = function() {
                    return this.shouldRemoveOnTrailingIconClick_;
                };
                MDCChipFoundation.prototype.setShouldRemoveOnTrailingIconClick = function(shouldRemove) {
                    this.shouldRemoveOnTrailingIconClick_ = shouldRemove;
                };
                MDCChipFoundation.prototype.setShouldFocusPrimaryActionOnClick = function(shouldFocus) {
                    this.shouldFocusPrimaryActionOnClick_ = shouldFocus;
                };
                MDCChipFoundation.prototype.getDimensions = function() {
                    var _this = this;
                    var getRootRect = function getRootRect() {
                        return _this.adapter.getRootBoundingClientRect();
                    };
                    var getCheckmarkRect = function getCheckmarkRect() {
                        return _this.adapter.getCheckmarkBoundingClientRect();
                    };
                    // When a chip has a checkmark and not a leading icon, the bounding rect changes in size depending on the current
                    // size of the checkmark.
                    if (!this.adapter.hasLeadingIcon()) {
                        var checkmarkRect = getCheckmarkRect();
                        if (checkmarkRect) {
                            var rootRect = getRootRect();
                            // Checkmark is a square, meaning the client rect's width and height are identical once the animation completes.
                            // However, the checkbox is initially hidden by setting the width to 0.
                            // To account for an initial width of 0, we use the checkbox's height instead (which equals the end-state width)
                            // when adding it to the root client rect's width.
                            return {
                                bottom: rootRect.bottom,
                                height: rootRect.height,
                                left: rootRect.left,
                                right: rootRect.right,
                                top: rootRect.top,
                                width: rootRect.width + checkmarkRect.height
                            };
                        }
                    }
                    return getRootRect();
                };
                /**
     * Begins the exit animation which leads to removal of the chip.
     */ MDCChipFoundation.prototype.beginExit = function() {
                    this.adapter.addClass(constants_1.cssClasses.CHIP_EXIT);
                };
                MDCChipFoundation.prototype.handleClick = function() {
                    this.adapter.notifyInteraction();
                    this.setPrimaryActionFocusable_(this.getFocusBehavior_());
                };
                MDCChipFoundation.prototype.handleDoubleClick = function() {
                    if (this.isEditable()) this.startEditing();
                };
                /**
     * Handles a transition end event on the root element.
     */ MDCChipFoundation.prototype.handleTransitionEnd = function(evt) {
                    var _this = this;
                    // Handle transition end event on the chip when it is about to be removed.
                    var shouldHandle = this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.CHIP_EXIT);
                    var widthIsAnimating = evt.propertyName === "width";
                    var opacityIsAnimating = evt.propertyName === "opacity";
                    if (shouldHandle && opacityIsAnimating) {
                        // See: https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-5
                        var chipWidth_1 = this.adapter.getComputedStyleValue("width");
                        // On the next frame (once we get the computed width), explicitly set the chip's width
                        // to its current pixel width, so we aren't transitioning out of 'auto'.
                        requestAnimationFrame(function() {
                            _this.adapter.setStyleProperty("width", chipWidth_1);
                            // To mitigate jitter, start transitioning padding and margin before width.
                            _this.adapter.setStyleProperty("padding", "0");
                            _this.adapter.setStyleProperty("margin", "0");
                            // On the next frame (once width is explicitly set), transition width to 0.
                            requestAnimationFrame(function() {
                                _this.adapter.setStyleProperty("width", "0");
                            });
                        });
                        return;
                    }
                    if (shouldHandle && widthIsAnimating) {
                        this.removeFocus();
                        var removedAnnouncement = this.adapter.getAttribute(constants_1.strings.REMOVED_ANNOUNCEMENT_ATTRIBUTE);
                        this.adapter.notifyRemoval(removedAnnouncement);
                    }
                    // Handle a transition end event on the leading icon or checkmark, since the transition end event bubbles.
                    if (!opacityIsAnimating) return;
                    var shouldHideLeadingIcon = this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.LEADING_ICON) && this.adapter.hasClass(constants_1.cssClasses.SELECTED);
                    var shouldShowLeadingIcon = this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.CHECKMARK) && !this.adapter.hasClass(constants_1.cssClasses.SELECTED);
                    if (shouldHideLeadingIcon) {
                        this.adapter.addClassToLeadingIcon(constants_1.cssClasses.HIDDEN_LEADING_ICON);
                        return;
                    }
                    if (shouldShowLeadingIcon) {
                        this.adapter.removeClassFromLeadingIcon(constants_1.cssClasses.HIDDEN_LEADING_ICON);
                        return;
                    }
                };
                MDCChipFoundation.prototype.handleFocusIn = function(evt) {
                    // Early exit if the event doesn't come from the primary action
                    if (!this.eventFromPrimaryAction_(evt)) return;
                    this.adapter.addClass(constants_1.cssClasses.PRIMARY_ACTION_FOCUSED);
                };
                MDCChipFoundation.prototype.handleFocusOut = function(evt) {
                    // Early exit if the event doesn't come from the primary action
                    if (!this.eventFromPrimaryAction_(evt)) return;
                    if (this.isEditing()) this.finishEditing();
                    this.adapter.removeClass(constants_1.cssClasses.PRIMARY_ACTION_FOCUSED);
                };
                /**
     * Handles an interaction event on the trailing icon element. This is used to
     * prevent the ripple from activating on interaction with the trailing icon.
     */ MDCChipFoundation.prototype.handleTrailingActionInteraction = function() {
                    this.adapter.notifyTrailingIconInteraction();
                    this.removeChip_();
                };
                /**
     * Handles a keydown event from the root element.
     */ MDCChipFoundation.prototype.handleKeydown = function(evt) {
                    if (this.isEditing()) {
                        if (this.shouldFinishEditing(evt)) {
                            evt.preventDefault();
                            this.finishEditing();
                        }
                        // When editing, the foundation should only handle key events that finish
                        // the editing process.
                        return;
                    }
                    if (this.isEditable()) {
                        if (this.shouldStartEditing(evt)) {
                            evt.preventDefault();
                            this.startEditing();
                        }
                    }
                    if (this.shouldNotifyInteraction_(evt)) {
                        this.adapter.notifyInteraction();
                        this.setPrimaryActionFocusable_(this.getFocusBehavior_());
                        evt.preventDefault();
                        return;
                    }
                    if (this.isDeleteAction_(evt)) {
                        evt.preventDefault();
                        this.removeChip_();
                        return;
                    }
                    // Early exit if the key is not usable
                    if (!constants_1.navigationKeys.has(evt.key)) return;
                    // Prevent default behavior for movement keys which could include scrolling
                    evt.preventDefault();
                    this.focusNextAction_(evt.key, constants_1.EventSource.PRIMARY);
                };
                MDCChipFoundation.prototype.handleTrailingActionNavigation = function(evt) {
                    return this.focusNextAction_(evt.detail.key, constants_1.EventSource.TRAILING);
                };
                /**
     * Called by the chip set to remove focus from the chip actions.
     */ MDCChipFoundation.prototype.removeFocus = function() {
                    this.adapter.setPrimaryActionAttr(constants_1.strings.TAB_INDEX, "-1");
                    this.adapter.removeTrailingActionFocus();
                };
                /**
     * Called by the chip set to focus the primary action.
     *
     */ MDCChipFoundation.prototype.focusPrimaryAction = function() {
                    this.setPrimaryActionFocusable_(FocusBehavior.SHOULD_FOCUS);
                };
                /**
     * Called by the chip set to focus the trailing action (if present), otherwise
     * gives focus to the trailing action.
     */ MDCChipFoundation.prototype.focusTrailingAction = function() {
                    var trailingActionIsNavigable = this.adapter.isTrailingActionNavigable();
                    if (trailingActionIsNavigable) {
                        this.adapter.setPrimaryActionAttr(constants_1.strings.TAB_INDEX, "-1");
                        this.adapter.focusTrailingAction();
                        return;
                    }
                    this.focusPrimaryAction();
                };
                MDCChipFoundation.prototype.setPrimaryActionFocusable_ = function(focusBehavior) {
                    this.adapter.setPrimaryActionAttr(constants_1.strings.TAB_INDEX, "0");
                    if (focusBehavior === FocusBehavior.SHOULD_FOCUS) this.adapter.focusPrimaryAction();
                    this.adapter.removeTrailingActionFocus();
                };
                MDCChipFoundation.prototype.getFocusBehavior_ = function() {
                    if (this.shouldFocusPrimaryActionOnClick_) return FocusBehavior.SHOULD_FOCUS;
                    return FocusBehavior.SHOULD_NOT_FOCUS;
                };
                MDCChipFoundation.prototype.focusNextAction_ = function(key, source) {
                    var isTrailingActionNavigable = this.adapter.isTrailingActionNavigable();
                    var dir = this.getDirection_(key);
                    // Early exit if the key should jump chips
                    if (constants_1.jumpChipKeys.has(key) || !isTrailingActionNavigable) return this.adapter.notifyNavigation(key, source);
                    if (source === constants_1.EventSource.PRIMARY && dir === constants_1.Direction.RIGHT) return this.focusTrailingAction();
                    if (source === constants_1.EventSource.TRAILING && dir === constants_1.Direction.LEFT) return this.focusPrimaryAction();
                    this.adapter.notifyNavigation(key, constants_1.EventSource.NONE);
                };
                MDCChipFoundation.prototype.getDirection_ = function(key) {
                    var isRTL = this.adapter.isRTL();
                    var isLeftKey = key === constants_1.strings.ARROW_LEFT_KEY || key === constants_1.strings.IE_ARROW_LEFT_KEY;
                    var isRightKey = key === constants_1.strings.ARROW_RIGHT_KEY || key === constants_1.strings.IE_ARROW_RIGHT_KEY;
                    if (!isRTL && isLeftKey || isRTL && isRightKey) return constants_1.Direction.LEFT;
                    return constants_1.Direction.RIGHT;
                };
                MDCChipFoundation.prototype.removeChip_ = function() {
                    if (this.shouldRemoveOnTrailingIconClick_) this.beginExit();
                };
                MDCChipFoundation.prototype.shouldStartEditing = function(evt) {
                    return this.eventFromPrimaryAction_(evt) && evt.key === constants_1.strings.ENTER_KEY;
                };
                MDCChipFoundation.prototype.shouldFinishEditing = function(evt) {
                    return evt.key === constants_1.strings.ENTER_KEY;
                };
                MDCChipFoundation.prototype.shouldNotifyInteraction_ = function(evt) {
                    return evt.key === constants_1.strings.ENTER_KEY || evt.key === constants_1.strings.SPACEBAR_KEY;
                };
                MDCChipFoundation.prototype.isDeleteAction_ = function(evt) {
                    var isDeletable = this.adapter.hasClass(constants_1.cssClasses.DELETABLE);
                    return isDeletable && (evt.key === constants_1.strings.BACKSPACE_KEY || evt.key === constants_1.strings.DELETE_KEY || evt.key === constants_1.strings.IE_DELETE_KEY);
                };
                MDCChipFoundation.prototype.setSelected_ = function(selected) {
                    if (selected) {
                        this.adapter.addClass(constants_1.cssClasses.SELECTED);
                        this.adapter.setPrimaryActionAttr(constants_1.strings.ARIA_CHECKED, "true");
                    } else {
                        this.adapter.removeClass(constants_1.cssClasses.SELECTED);
                        this.adapter.setPrimaryActionAttr(constants_1.strings.ARIA_CHECKED, "false");
                    }
                };
                MDCChipFoundation.prototype.notifySelection_ = function(selected) {
                    this.adapter.notifySelection(selected, false);
                };
                MDCChipFoundation.prototype.notifyIgnoredSelection_ = function(selected) {
                    this.adapter.notifySelection(selected, true);
                };
                MDCChipFoundation.prototype.eventFromPrimaryAction_ = function(evt) {
                    return this.adapter.eventTargetHasClass(evt.target, constants_1.cssClasses.PRIMARY_ACTION);
                };
                MDCChipFoundation.prototype.startEditing = function() {
                    this.adapter.addClass(constants_1.cssClasses.EDITING);
                    this.adapter.notifyEditStart();
                };
                MDCChipFoundation.prototype.finishEditing = function() {
                    this.adapter.removeClass(constants_1.cssClasses.EDITING);
                    this.adapter.notifyEditFinish();
                };
                return MDCChipFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCChipFoundation = MDCChipFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCChipFoundation;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/trailingaction/component.ts": /*!*******************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/trailingaction/component.ts ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipTrailingAction = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/trailingaction/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-chips/deprecated/trailingaction/foundation.ts");
            var MDCChipTrailingAction = /** @class */ function(_super) {
                __extends(MDCChipTrailingAction, _super);
                function MDCChipTrailingAction() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCChipTrailingAction.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChipTrailingAction.attachTo = function(root) {
                    return new MDCChipTrailingAction(root);
                };
                MDCChipTrailingAction.prototype.initialize = function(rippleFactory) {
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_2.MDCRipple(el, foundation);
                    };
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var rippleAdapter = component_2.MDCRipple.createAdapter(this);
                    this.ripple_ = rippleFactory(this.root, new foundation_1.MDCRippleFoundation(rippleAdapter));
                };
                MDCChipTrailingAction.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleClick_ = function(evt) {
                        _this.foundation.handleClick(evt);
                    };
                    this.handleKeydown_ = function(evt) {
                        _this.foundation.handleKeydown(evt);
                    };
                    this.listen("click", this.handleClick_);
                    this.listen("keydown", this.handleKeydown_);
                };
                MDCChipTrailingAction.prototype.destroy = function() {
                    this.ripple_.destroy();
                    this.unlisten("click", this.handleClick_);
                    this.unlisten("keydown", this.handleKeydown_);
                    _super.prototype.destroy.call(this);
                };
                MDCChipTrailingAction.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        focus: function focus() {
                            // TODO(b/157231863): Migate MDCComponent#root to HTMLElement
                            _this.root.focus();
                        },
                        getAttribute: function getAttribute(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        notifyInteraction: function notifyInteraction(trigger) {
                            return _this.emit(constants_1.strings.INTERACTION_EVENT, {
                                trigger: trigger
                            }, true);
                        },
                        notifyNavigation: function notifyNavigation(key) {
                            _this.emit(constants_1.strings.NAVIGATION_EVENT, {
                                key: key
                            }, true);
                        },
                        setAttribute: function setAttribute(attr, value) {
                            _this.root.setAttribute(attr, value);
                        }
                    };
                    return new foundation_2.MDCChipTrailingActionFoundation(adapter);
                };
                MDCChipTrailingAction.prototype.isNavigable = function() {
                    return this.foundation.isNavigable();
                };
                MDCChipTrailingAction.prototype.focus = function() {
                    this.foundation.focus();
                };
                MDCChipTrailingAction.prototype.removeFocus = function() {
                    this.foundation.removeFocus();
                };
                return MDCChipTrailingAction;
            }(component_1.MDCComponent);
            exports.MDCChipTrailingAction = MDCChipTrailingAction;
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/trailingaction/constants.ts": /*!*******************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/trailingaction/constants.ts ***!
  \*******************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.InteractionTrigger = void 0;
            var InteractionTrigger;
            (function(InteractionTrigger) {
                InteractionTrigger[InteractionTrigger["UNSPECIFIED"] = 0] = "UNSPECIFIED";
                InteractionTrigger[InteractionTrigger["CLICK"] = 1] = "CLICK";
                InteractionTrigger[InteractionTrigger["BACKSPACE_KEY"] = 2] = "BACKSPACE_KEY";
                InteractionTrigger[InteractionTrigger["DELETE_KEY"] = 3] = "DELETE_KEY";
                InteractionTrigger[InteractionTrigger["SPACEBAR_KEY"] = 4] = "SPACEBAR_KEY";
                InteractionTrigger[InteractionTrigger["ENTER_KEY"] = 5] = "ENTER_KEY";
            })(InteractionTrigger = exports.InteractionTrigger || (exports.InteractionTrigger = {}));
            exports.strings = {
                ARIA_HIDDEN: "aria-hidden",
                INTERACTION_EVENT: "MDCChipTrailingAction:interaction",
                NAVIGATION_EVENT: "MDCChipTrailingAction:navigation",
                TAB_INDEX: "tabindex"
            };
        /***/ },
        /***/ "./packages/mdc-chips/deprecated/trailingaction/foundation.ts": /*!********************************************************************!*\
  !*** ./packages/mdc-chips/deprecated/trailingaction/foundation.ts ***!
  \********************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCChipTrailingActionFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-chips/deprecated/trailingaction/constants.ts");
            var MDCChipTrailingActionFoundation = /** @class */ function(_super) {
                __extends(MDCChipTrailingActionFoundation, _super);
                function MDCChipTrailingActionFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCChipTrailingActionFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCChipTrailingActionFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCChipTrailingActionFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            focus: function focus() {
                                return undefined;
                            },
                            getAttribute: function getAttribute() {
                                return null;
                            },
                            setAttribute: function setAttribute() {
                                return undefined;
                            },
                            notifyInteraction: function notifyInteraction() {
                                return undefined;
                            },
                            notifyNavigation: function notifyNavigation() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCChipTrailingActionFoundation.prototype.handleClick = function(evt) {
                    evt.stopPropagation();
                    this.adapter.notifyInteraction(constants_1.InteractionTrigger.CLICK);
                };
                MDCChipTrailingActionFoundation.prototype.handleKeydown = function(evt) {
                    evt.stopPropagation();
                    var key = keyboard_1.normalizeKey(evt);
                    if (this.shouldNotifyInteractionFromKey_(key)) {
                        var trigger = this.getTriggerFromKey_(key);
                        this.adapter.notifyInteraction(trigger);
                        return;
                    }
                    if (keyboard_1.isNavigationEvent(evt)) {
                        this.adapter.notifyNavigation(key);
                        return;
                    }
                };
                MDCChipTrailingActionFoundation.prototype.removeFocus = function() {
                    this.adapter.setAttribute(constants_1.strings.TAB_INDEX, "-1");
                };
                MDCChipTrailingActionFoundation.prototype.focus = function() {
                    this.adapter.setAttribute(constants_1.strings.TAB_INDEX, "0");
                    this.adapter.focus();
                };
                MDCChipTrailingActionFoundation.prototype.isNavigable = function() {
                    return this.adapter.getAttribute(constants_1.strings.ARIA_HIDDEN) !== "true";
                };
                MDCChipTrailingActionFoundation.prototype.shouldNotifyInteractionFromKey_ = function(key) {
                    var isFromActionKey = key === keyboard_1.KEY.ENTER || key === keyboard_1.KEY.SPACEBAR;
                    var isFromDeleteKey = key === keyboard_1.KEY.BACKSPACE || key === keyboard_1.KEY.DELETE;
                    return isFromActionKey || isFromDeleteKey;
                };
                MDCChipTrailingActionFoundation.prototype.getTriggerFromKey_ = function(key) {
                    if (key === keyboard_1.KEY.SPACEBAR) return constants_1.InteractionTrigger.SPACEBAR_KEY;
                    if (key === keyboard_1.KEY.ENTER) return constants_1.InteractionTrigger.ENTER_KEY;
                    if (key === keyboard_1.KEY.DELETE) return constants_1.InteractionTrigger.DELETE_KEY;
                    if (key === keyboard_1.KEY.BACKSPACE) return constants_1.InteractionTrigger.BACKSPACE_KEY;
                    // Default case, should never be returned
                    return constants_1.InteractionTrigger.UNSPECIFIED;
                };
                return MDCChipTrailingActionFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCChipTrailingActionFoundation = MDCChipTrailingActionFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCChipTrailingActionFoundation;
        /***/ },
        /***/ "./packages/mdc-circular-progress/component.ts": /*!*****************************************************!*\
  !*** ./packages/mdc-circular-progress/component.ts ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCircularProgress = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-circular-progress/foundation.ts");
            var MDCCircularProgress = /** @class */ function(_super) {
                __extends(MDCCircularProgress, _super);
                function MDCCircularProgress() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCCircularProgress.prototype.initialize = function() {
                    this.determinateCircle_ = this.root.querySelector(foundation_1.MDCCircularProgressFoundation.strings.DETERMINATE_CIRCLE_SELECTOR);
                };
                MDCCircularProgress.attachTo = function(root) {
                    return new MDCCircularProgress(root);
                };
                Object.defineProperty(MDCCircularProgress.prototype, "determinate", {
                    /**
         * Sets whether the progress indicator is in determinate mode.
         * @param isDeterminate Whether the indicator should be determinate.
         */ set: function set(value) {
                        this.foundation.setDeterminate(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgress.prototype, "progress", {
                    /**
         * Sets the current progress value. In indeterminate mode, this has no
         * visual effect but will be reflected if the indicator is switched to
         * determinate mode.
         * @param value The current progress value, which must be between 0 and 1.
         */ set: function set(value) {
                        this.foundation.setProgress(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgress.prototype, "isClosed", {
                    /**
         * Whether the progress indicator is hidden.
         */ get: function get() {
                        return this.foundation.isClosed();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Shows the progress indicator.
     */ MDCCircularProgress.prototype.open = function() {
                    this.foundation.open();
                };
                /**
     * Hides the progress indicator.
     */ MDCCircularProgress.prototype.close = function() {
                    this.foundation.close();
                };
                MDCCircularProgress.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        getDeterminateCircleAttribute: function getDeterminateCircleAttribute(attributeName) {
                            return _this.determinateCircle_.getAttribute(attributeName);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        removeAttribute: function removeAttribute(attributeName) {
                            return _this.root.removeAttribute(attributeName);
                        },
                        setAttribute: function setAttribute(attributeName, value) {
                            return _this.root.setAttribute(attributeName, value);
                        },
                        setDeterminateCircleAttribute: function setDeterminateCircleAttribute(attributeName, value) {
                            return _this.determinateCircle_.setAttribute(attributeName, value);
                        }
                    };
                    return new foundation_1.MDCCircularProgressFoundation(adapter);
                };
                return MDCCircularProgress;
            }(component_1.MDCComponent);
            exports.MDCCircularProgress = MDCCircularProgress;
        /***/ },
        /***/ "./packages/mdc-circular-progress/constants.ts": /*!*****************************************************!*\
  !*** ./packages/mdc-circular-progress/constants.ts ***!
  \*****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            /**
 * CSS class names used in component.
 */ exports.cssClasses = {
                INDETERMINATE_CLASS: "mdc-circular-progress--indeterminate",
                CLOSED_CLASS: "mdc-circular-progress--closed"
            };
            /**
 * Attributes and selectors used in component.
 */ exports.strings = {
                ARIA_HIDDEN: "aria-hidden",
                ARIA_VALUENOW: "aria-valuenow",
                DETERMINATE_CIRCLE_SELECTOR: ".mdc-circular-progress__determinate-circle",
                RADIUS: "r",
                STROKE_DASHOFFSET: "stroke-dashoffset"
            };
        /***/ },
        /***/ "./packages/mdc-circular-progress/custom-element.js": /*!**********************************************************!*\
  !*** ./packages/mdc-circular-progress/custom-element.js ***!
  \**********************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-circular-progress/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcCircularProgress = function(_HTMLElement) {
                _inherits(MdcCircularProgress, _HTMLElement);
                _createClass(MdcCircularProgress, [
                    {
                        key: "determinate",
                        get: function get() {
                            return this.determinate_;
                        },
                        set: function set(determinate) {
                            this.determinate_ = determinate;
                            if (!!this.circularProgress_) this.circularProgress_.determinate = determinate;
                        }
                    },
                    {
                        key: "progress",
                        get: function get() {
                            return this.progress_;
                        },
                        set: function set(progress) {
                            this.progress_ = progress;
                            if (!!this.circularProgress_) this.circularProgress_.progress = progress;
                        }
                    },
                    {
                        key: "closed",
                        get: function get() {
                            return this.closed_;
                        },
                        set: function set(closed) {
                            this.closed_ = closed;
                            if (!!this.circularProgress_) {
                                if (closed) this.circularProgress_.close();
                                else this.circularProgress_.open();
                            }
                        }
                    }
                ]);
                function MdcCircularProgress() {
                    _classCallCheck(this, MdcCircularProgress);
                    var _this = _possibleConstructorReturn(this, (MdcCircularProgress.__proto__ || Object.getPrototypeOf(MdcCircularProgress)).call(this));
                    _this.determinate_ = false;
                    _this.progress_ = 0;
                    _this.closed_ = false;
                    _this.circularProgress_;
                    return _this;
                }
                _createClass(MdcCircularProgress, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.circularProgress_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCCircularProgress"](this);
                            this.circularProgress_.determinate = this.determinate_;
                            this.circularProgress_.progress = this.progress_;
                            if (this.closed_) this.circularProgress_.close();
                            else this.circularProgress_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.circularProgress_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcCircularProgress;
            }(HTMLElement);
            customElements.define("mdc-circular-progress", MdcCircularProgress);
        /***/ },
        /***/ "./packages/mdc-circular-progress/foundation.ts": /*!******************************************************!*\
  !*** ./packages/mdc-circular-progress/foundation.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCCircularProgressFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-circular-progress/constants.ts");
            var MDCCircularProgressFoundation = /** @class */ function(_super) {
                __extends(MDCCircularProgressFoundation, _super);
                function MDCCircularProgressFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCCircularProgressFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCCircularProgressFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgressFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCCircularProgressFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            getDeterminateCircleAttribute: function getDeterminateCircleAttribute() {
                                return null;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            removeAttribute: function removeAttribute() {
                                return undefined;
                            },
                            setAttribute: function setAttribute() {
                                return undefined;
                            },
                            setDeterminateCircleAttribute: function setDeterminateCircleAttribute() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCCircularProgressFoundation.prototype.init = function() {
                    this.closed = this.adapter.hasClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.determinate = !this.adapter.hasClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                    this.progress = 0;
                    if (this.determinate) this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, this.progress.toString());
                    this.radius = Number(this.adapter.getDeterminateCircleAttribute(constants_1.strings.RADIUS));
                };
                /**
     * Sets whether the progress indicator is in determinate mode.
     * @param determinate Whether the indicator should be determinate.
     */ MDCCircularProgressFoundation.prototype.setDeterminate = function(determinate) {
                    this.determinate = determinate;
                    if (this.determinate) {
                        this.adapter.removeClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                        this.setProgress(this.progress);
                    } else {
                        this.adapter.addClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                        this.adapter.removeAttribute(constants_1.strings.ARIA_VALUENOW);
                    }
                };
                MDCCircularProgressFoundation.prototype.isDeterminate = function() {
                    return this.determinate;
                };
                /**
     * Sets the current progress value. In indeterminate mode, this has no
     * visual effect but will be reflected if the indicator is switched to
     * determinate mode.
     * @param value The current progress value, which must be between 0 and 1.
     */ MDCCircularProgressFoundation.prototype.setProgress = function(value) {
                    this.progress = value;
                    if (this.determinate) {
                        var unfilledArcLength = (1 - this.progress) * (2 * Math.PI * this.radius);
                        this.adapter.setDeterminateCircleAttribute(constants_1.strings.STROKE_DASHOFFSET, "" + unfilledArcLength);
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, this.progress.toString());
                    }
                };
                MDCCircularProgressFoundation.prototype.getProgress = function() {
                    return this.progress;
                };
                /**
     * Shows the progress indicator.
     */ MDCCircularProgressFoundation.prototype.open = function() {
                    this.closed = false;
                    this.adapter.removeClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_HIDDEN);
                };
                /**
     * Hides the progress indicator
     */ MDCCircularProgressFoundation.prototype.close = function() {
                    this.closed = true;
                    this.adapter.addClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.setAttribute(constants_1.strings.ARIA_HIDDEN, "true");
                };
                /**
     * @return Returns whether the progress indicator is hidden.
     */ MDCCircularProgressFoundation.prototype.isClosed = function() {
                    return this.closed;
                };
                return MDCCircularProgressFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCCircularProgressFoundation = MDCCircularProgressFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCCircularProgressFoundation;
        /***/ },
        /***/ "./packages/mdc-data-table/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-data-table/custom-element.js ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcDataTable = function(_HTMLElement) {
                _inherits(MdcDataTable, _HTMLElement);
                function MdcDataTable() {
                    _classCallCheck(this, MdcDataTable);
                    return _possibleConstructorReturn(this, (MdcDataTable.__proto__ || Object.getPrototypeOf(MdcDataTable)).call(this));
                }
                _createClass(MdcDataTable, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {}
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {}
                    }
                ]);
                return MdcDataTable;
            }(HTMLElement);
            customElements.define("mdc-data-table", MdcDataTable);
        /***/ },
        /***/ "./packages/mdc-dialog/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-dialog/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDialog = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-dialog/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-dialog/util.ts"));
            var strings = foundation_1.MDCDialogFoundation.strings;
            var MDCDialog = /** @class */ function(_super) {
                __extends(MDCDialog, _super);
                function MDCDialog() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCDialog.prototype, "isOpen", {
                    get: function get() {
                        return this.foundation.isOpen();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialog.prototype, "escapeKeyAction", {
                    get: function get() {
                        return this.foundation.getEscapeKeyAction();
                    },
                    set: function set(action) {
                        this.foundation.setEscapeKeyAction(action);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialog.prototype, "scrimClickAction", {
                    get: function get() {
                        return this.foundation.getScrimClickAction();
                    },
                    set: function set(action) {
                        this.foundation.setScrimClickAction(action);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialog.prototype, "autoStackButtons", {
                    get: function get() {
                        return this.foundation.getAutoStackButtons();
                    },
                    set: function set(autoStack) {
                        this.foundation.setAutoStackButtons(autoStack);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDialog.attachTo = function(root) {
                    return new MDCDialog(root);
                };
                MDCDialog.prototype.initialize = function(focusTrapFactory) {
                    var container = this.root.querySelector(strings.CONTAINER_SELECTOR);
                    if (!container) throw new Error("Dialog component requires a " + strings.CONTAINER_SELECTOR + " container element");
                    this.container = container;
                    this.content = this.root.querySelector(strings.CONTENT_SELECTOR);
                    this.buttons = [].slice.call(this.root.querySelectorAll(strings.BUTTON_SELECTOR));
                    this.defaultButton = this.root.querySelector("[" + strings.BUTTON_DEFAULT_ATTRIBUTE + "]");
                    this.focusTrapFactory = focusTrapFactory;
                };
                MDCDialog.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.focusTrap = util.createFocusTrapInstance(this.container, this.focusTrapFactory, this.getInitialFocusEl() || undefined);
                    this.handleClick = this.handleClick_.bind(this);
                    this.handleKeydown = this.foundation.handleKeydown.bind(this.foundation);
                    this.handleDocumentKeydown = this.handleDocumentKeydown_.bind(this);
                    // this.handleLayout = this.layout.bind(this);
                    this.handleOpening = function() {
                        document.addEventListener("keydown", _this.handleDocumentKeydown);
                    };
                    this.handleClosing = function() {
                        document.removeEventListener("keydown", _this.handleDocumentKeydown);
                    };
                    this.listen("click", this.handleClick);
                    this.listen("keydown", this.handleKeydown);
                    this.listen(strings.OPENING_EVENT, this.handleOpening);
                    this.listen(strings.CLOSING_EVENT, this.handleClosing);
                };
                MDCDialog.prototype.handleClick_ = function(evt) {
                    var isScrim = this.eventTargetMatches(evt.target, strings.SCRIM_SELECTOR);
                    // Check for scrim click first since it doesn't require querying ancestors.
                    if (isScrim && this.foundation.getScrimClickAction() !== "") {
                        this.close(this.scrimClickAction);
                        this.emit("MDCDialog:close", {});
                    }
                };
                MDCDialog.prototype.eventTargetMatches = function(target, selector) {
                    return target ? ponyfill_1.matches(target, selector) : false;
                };
                MDCDialog.prototype.handleDocumentKeydown_ = function(evt) {
                    var isEscape = evt.key === "Escape" || evt.keyCode === 27;
                    if (isEscape) this.emit("MDCDialog:close", {});
                };
                MDCDialog.prototype.destroy = function() {
                    this.unlisten("click", this.handleClick);
                    this.unlisten("keydown", this.handleKeydown);
                    this.unlisten(strings.OPENING_EVENT, this.handleOpening);
                    this.unlisten(strings.CLOSING_EVENT, this.handleClosing);
                    this.handleClosing();
                    _super.prototype.destroy.call(this);
                };
                MDCDialog.prototype.layout = function() {
                    this.foundation.layout();
                };
                MDCDialog.prototype.open = function() {
                    this.foundation.open();
                };
                MDCDialog.prototype.close = function(action) {
                    if (action === void 0) action = "";
                    this.foundation.close(action);
                };
                MDCDialog.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addBodyClass: function addBodyClass(className) {
                            return document.body.classList.add(className);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        areButtonsStacked: function areButtonsStacked() {
                            return util.areTopsMisaligned(_this.buttons);
                        },
                        clickDefaultButton: function clickDefaultButton() {
                            if (_this.defaultButton) _this.defaultButton.click();
                        },
                        eventTargetMatches: function eventTargetMatches(target, selector) {
                            return target ? ponyfill_1.matches(target, selector) : false;
                        },
                        getActionFromEvent: function getActionFromEvent(evt) {
                            if (!evt.target) return "";
                            var element = ponyfill_1.closest(evt.target, "[" + strings.ACTION_ATTRIBUTE + "]");
                            return element && element.getAttribute(strings.ACTION_ATTRIBUTE);
                        },
                        getInitialFocusEl: function getInitialFocusEl() {
                            return _this.getInitialFocusEl();
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        isContentScrollable: function isContentScrollable() {
                            return util.isScrollable(_this.content);
                        },
                        notifyClosed: function notifyClosed(action) {
                            return _this.emit(strings.CLOSED_EVENT, action ? {
                                action: action
                            } : {});
                        },
                        notifyClosing: function notifyClosing(action) {
                            return _this.emit(strings.CLOSING_EVENT, action ? {
                                action: action
                            } : {});
                        },
                        notifyOpened: function notifyOpened() {
                            return _this.emit(strings.OPENED_EVENT, {});
                        },
                        notifyOpening: function notifyOpening() {
                            return _this.emit(strings.OPENING_EVENT, {});
                        },
                        releaseFocus: function releaseFocus() {
                            _this.focusTrap.deactivate();
                        },
                        removeBodyClass: function removeBodyClass(className) {
                            return document.body.classList.remove(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        reverseButtons: function reverseButtons() {
                            _this.buttons.reverse();
                            _this.buttons.forEach(function(button) {
                                button.parentElement.appendChild(button);
                            });
                        },
                        trapFocus: function trapFocus() {
                            _this.focusTrap.activate();
                        },
                        registerContentEventHandler: function registerContentEventHandler(evt, handler) {
                            if (_this.content instanceof HTMLElement) _this.content.addEventListener(evt, handler);
                        },
                        deregisterContentEventHandler: function deregisterContentEventHandler(evt, handler) {
                            if (_this.content instanceof HTMLElement) _this.content.removeEventListener(evt, handler);
                        },
                        isScrollableContentAtTop: function isScrollableContentAtTop() {
                            return util.isScrollAtTop(_this.content);
                        },
                        isScrollableContentAtBottom: function isScrollableContentAtBottom() {
                            return util.isScrollAtBottom(_this.content);
                        },
                        registerWindowEventHandler: function registerWindowEventHandler(evt, handler) {
                            window.addEventListener(evt, handler);
                        },
                        deregisterWindowEventHandler: function deregisterWindowEventHandler(evt, handler) {
                            window.removeEventListener(evt, handler);
                        }
                    };
                    return new foundation_1.MDCDialogFoundation(adapter);
                };
                MDCDialog.prototype.getInitialFocusEl = function() {
                    return this.root.querySelector("[" + strings.INITIAL_FOCUS_ATTRIBUTE + "]");
                };
                return MDCDialog;
            }(component_1.MDCComponent);
            exports.MDCDialog = MDCDialog;
        /***/ },
        /***/ "./packages/mdc-dialog/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-dialog/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                CLOSING: "mdc-dialog--closing",
                OPEN: "mdc-dialog--open",
                OPENING: "mdc-dialog--opening",
                SCROLLABLE: "mdc-dialog--scrollable",
                SCROLL_LOCK: "mdc-dialog-scroll-lock",
                STACKED: "mdc-dialog--stacked",
                FULLSCREEN: "mdc-dialog--fullscreen",
                // Class for showing a scroll divider on full-screen dialog header element.
                // Should only be displayed on scrollable content, when the dialog content is
                // scrolled "underneath" the header.
                SCROLL_DIVIDER_HEADER: "mdc-dialog-scroll-divider-header",
                // Class for showing a scroll divider on a full-screen dialog footer element.
                // Should only be displayed on scrolalble content, when the dialog content is
                // obscured "underneath" the footer.
                SCROLL_DIVIDER_FOOTER: "mdc-dialog-scroll-divider-footer",
                // The "surface scrim" is a scrim covering only the surface of a dialog. This
                // is used in situations where a confirmation dialog is shown over an already
                // opened full-screen dialog. On larger screen-sizes, the full-screen dialog
                // is sized as a modal and so in these situations we display a "surface scrim"
                // to prevent a "double scrim" (where the scrim from the secondary
                // confirmation dialog would overlap with the scrim from the full-screen
                // dialog).
                SURFACE_SCRIM_SHOWN: "mdc-dialog__surface-scrim--shown",
                // "Showing" animating class for the surface-scrim.
                SURFACE_SCRIM_SHOWING: "mdc-dialog__surface-scrim--showing",
                // "Hiding" animating class for the surface-scrim.
                SURFACE_SCRIM_HIDING: "mdc-dialog__surface-scrim--hiding",
                // Class to hide a dialog's scrim (used in conjunction with a surface-scrim).
                // Note that we only hide the original scrim rather than removing it entirely
                // to prevent interactions with the content behind this scrim, and to capture
                // scrim clicks.
                SCRIM_HIDDEN: "mdc-dialog__scrim--hidden"
            };
            exports.strings = {
                ACTION_ATTRIBUTE: "data-mdc-dialog-action",
                BUTTON_DEFAULT_ATTRIBUTE: "data-mdc-dialog-button-default",
                BUTTON_SELECTOR: ".mdc-dialog__button",
                CLOSED_EVENT: "MDCDialog:closed",
                CLOSE_ACTION: "close",
                CLOSING_EVENT: "MDCDialog:closing",
                CONTAINER_SELECTOR: ".mdc-dialog__container",
                CONTENT_SELECTOR: ".mdc-dialog__content",
                DESTROY_ACTION: "destroy",
                INITIAL_FOCUS_ATTRIBUTE: "data-mdc-dialog-initial-focus",
                OPENED_EVENT: "MDCDialog:opened",
                OPENING_EVENT: "MDCDialog:opening",
                SCRIM_SELECTOR: ".mdc-dialog__scrim",
                SUPPRESS_DEFAULT_PRESS_SELECTOR: [
                    "textarea",
                    ".mdc-menu .mdc-list-item",
                    ".mdc-menu .mdc-deprecated-list-item"
                ].join(", "),
                SURFACE_SELECTOR: ".mdc-dialog__surface"
            };
            exports.numbers = {
                DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
                DIALOG_ANIMATION_OPEN_TIME_MS: 150
            };
        /***/ },
        /***/ "./packages/mdc-dialog/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-dialog/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-dialog/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcDialog = function(_HTMLElement) {
                _inherits(MdcDialog, _HTMLElement);
                _createClass(MdcDialog, [
                    {
                        key: "open",
                        get: function get() {
                            return this.open_;
                        },
                        set: function set(open) {
                            this.open_ = open;
                            if (!!this.dialog_) {
                                if (open) this.dialog_.open();
                                else this.dialog_.close();
                            }
                        }
                    },
                    {
                        key: "scrimClickAction",
                        get: function get() {
                            return this.scrimClickAction_;
                        },
                        set: function set(scrimClickAction) {
                            this.scrimClickAction_ = scrimClickAction;
                            if (!!this.dialog_) this.dialog_.scrimClickAction = scrimClickAction_;
                        }
                    },
                    {
                        key: "escapeKeyAction",
                        get: function get() {
                            return this.escapeKeyAction_;
                        },
                        set: function set(escapeKeyAction) {
                            this.escapeKeyAction_ = escapeKeyAction;
                            if (!!this.dialog_) this.dialog_.escapeKeyAction = escapeKeyAction_;
                        }
                    }
                ]);
                function MdcDialog() {
                    _classCallCheck(this, MdcDialog);
                    var _this = _possibleConstructorReturn(this, (MdcDialog.__proto__ || Object.getPrototypeOf(MdcDialog)).call(this));
                    _this.open_ = false;
                    _this.scrimClickAction_ = "close";
                    _this.escapeKeyAction_ = "close";
                    return _this;
                }
                _createClass(MdcDialog, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.dialog_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCDialog"](this);
                            this.dialog_.scrimClickAction = this.scrimClickAction_;
                            this.dialog_.escapeKeyAction = this.escapeKeyAction_;
                            if (this.open_) this.dialog_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.dialog_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcDialog;
            }(HTMLElement);
            customElements.define("mdc-dialog", MdcDialog);
        /***/ },
        /***/ "./packages/mdc-dialog/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-dialog/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDialogFoundation = void 0;
            var animationframe_1 = __webpack_require__(/*! @material/animation/animationframe */ "./packages/mdc-animation/animationframe.ts");
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-dialog/constants.ts");
            var AnimationKeys;
            (function(AnimationKeys) {
                AnimationKeys["POLL_SCROLL_POS"] = "poll_scroll_position";
                AnimationKeys["POLL_LAYOUT_CHANGE"] = "poll_layout_change";
            })(AnimationKeys || (AnimationKeys = {}));
            var MDCDialogFoundation = /** @class */ function(_super) {
                __extends(MDCDialogFoundation, _super);
                function MDCDialogFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCDialogFoundation.defaultAdapter), adapter)) || this;
                    _this.dialogOpen = false;
                    _this.isFullscreen = false;
                    _this.animationFrame = 0;
                    _this.animationTimer = 0;
                    _this.escapeKeyAction = constants_1.strings.CLOSE_ACTION;
                    _this.scrimClickAction = constants_1.strings.CLOSE_ACTION;
                    _this.autoStackButtons = true;
                    _this.areButtonsStacked = false;
                    _this.suppressDefaultPressSelector = constants_1.strings.SUPPRESS_DEFAULT_PRESS_SELECTOR;
                    _this.animFrame = new animationframe_1.AnimationFrame();
                    _this.contentScrollHandler = function() {
                        _this.handleScrollEvent();
                    };
                    _this.windowResizeHandler = function() {
                        _this.layout();
                    };
                    _this.windowOrientationChangeHandler = function() {
                        _this.layout();
                    };
                    return _this;
                }
                Object.defineProperty(MDCDialogFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialogFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialogFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDialogFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addBodyClass: function addBodyClass() {
                                return undefined;
                            },
                            addClass: function addClass() {
                                return undefined;
                            },
                            areButtonsStacked: function areButtonsStacked() {
                                return false;
                            },
                            clickDefaultButton: function clickDefaultButton() {
                                return undefined;
                            },
                            eventTargetMatches: function eventTargetMatches() {
                                return false;
                            },
                            getActionFromEvent: function getActionFromEvent() {
                                return "";
                            },
                            getInitialFocusEl: function getInitialFocusEl() {
                                return null;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            isContentScrollable: function isContentScrollable() {
                                return false;
                            },
                            notifyClosed: function notifyClosed() {
                                return undefined;
                            },
                            notifyClosing: function notifyClosing() {
                                return undefined;
                            },
                            notifyOpened: function notifyOpened() {
                                return undefined;
                            },
                            notifyOpening: function notifyOpening() {
                                return undefined;
                            },
                            releaseFocus: function releaseFocus() {
                                return undefined;
                            },
                            removeBodyClass: function removeBodyClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            reverseButtons: function reverseButtons() {
                                return undefined;
                            },
                            trapFocus: function trapFocus() {
                                return undefined;
                            },
                            registerContentEventHandler: function registerContentEventHandler() {
                                return undefined;
                            },
                            deregisterContentEventHandler: function deregisterContentEventHandler() {
                                return undefined;
                            },
                            isScrollableContentAtTop: function isScrollableContentAtTop() {
                                return false;
                            },
                            isScrollableContentAtBottom: function isScrollableContentAtBottom() {
                                return false;
                            },
                            registerWindowEventHandler: function registerWindowEventHandler() {
                                return undefined;
                            },
                            deregisterWindowEventHandler: function deregisterWindowEventHandler() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDialogFoundation.prototype.init = function() {
                    if (this.adapter.hasClass(constants_1.cssClasses.STACKED)) this.setAutoStackButtons(false);
                    this.isFullscreen = this.adapter.hasClass(constants_1.cssClasses.FULLSCREEN);
                };
                MDCDialogFoundation.prototype.destroy = function() {
                    if (this.dialogOpen) this.close(constants_1.strings.DESTROY_ACTION);
                    if (this.animationTimer) {
                        clearTimeout(this.animationTimer);
                        this.handleAnimationTimerEnd();
                    }
                    if (this.isFullscreen) this.adapter.deregisterContentEventHandler("scroll", this.contentScrollHandler);
                    this.animFrame.cancelAll();
                    this.adapter.deregisterWindowEventHandler("resize", this.windowResizeHandler);
                    this.adapter.deregisterWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
                };
                MDCDialogFoundation.prototype.open = function(dialogOptions) {
                    var _this = this;
                    this.dialogOpen = true;
                    this.adapter.notifyOpening();
                    this.adapter.addClass(constants_1.cssClasses.OPENING);
                    if (this.isFullscreen) // A scroll event listener is registered even if the dialog is not
                    // scrollable on open, since the window resize event, or orientation
                    // change may make the dialog scrollable after it is opened.
                    this.adapter.registerContentEventHandler("scroll", this.contentScrollHandler);
                    if (dialogOptions && dialogOptions.isAboveFullscreenDialog) this.adapter.addClass(constants_1.cssClasses.SCRIM_HIDDEN);
                    this.adapter.registerWindowEventHandler("resize", this.windowResizeHandler);
                    this.adapter.registerWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
                    // Wait a frame once display is no longer "none", to establish basis for
                    // animation
                    this.runNextAnimationFrame(function() {
                        _this.adapter.addClass(constants_1.cssClasses.OPEN);
                        _this.adapter.addBodyClass(constants_1.cssClasses.SCROLL_LOCK);
                        _this.layout();
                        _this.animationTimer = setTimeout(function() {
                            _this.handleAnimationTimerEnd();
                            _this.adapter.trapFocus(_this.adapter.getInitialFocusEl());
                            _this.adapter.notifyOpened();
                        }, constants_1.numbers.DIALOG_ANIMATION_OPEN_TIME_MS);
                    });
                };
                MDCDialogFoundation.prototype.close = function(action) {
                    var _this = this;
                    if (action === void 0) action = "";
                    if (!this.dialogOpen) // Avoid redundant close calls (and events), e.g. from keydown on elements
                    // that inherently emit click
                    return;
                    this.dialogOpen = false;
                    this.adapter.notifyClosing(action);
                    this.adapter.addClass(constants_1.cssClasses.CLOSING);
                    this.adapter.removeClass(constants_1.cssClasses.OPEN);
                    this.adapter.removeBodyClass(constants_1.cssClasses.SCROLL_LOCK);
                    if (this.isFullscreen) this.adapter.deregisterContentEventHandler("scroll", this.contentScrollHandler);
                    this.adapter.deregisterWindowEventHandler("resize", this.windowResizeHandler);
                    this.adapter.deregisterWindowEventHandler("orientationchange", this.windowOrientationChangeHandler);
                    cancelAnimationFrame(this.animationFrame);
                    this.animationFrame = 0;
                    clearTimeout(this.animationTimer);
                    this.animationTimer = setTimeout(function() {
                        _this.adapter.releaseFocus();
                        _this.handleAnimationTimerEnd();
                        _this.adapter.notifyClosed(action);
                    }, constants_1.numbers.DIALOG_ANIMATION_CLOSE_TIME_MS);
                };
                /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Shows the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.showSurfaceScrim = function() {
                    var _this = this;
                    this.adapter.addClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWING);
                    this.runNextAnimationFrame(function() {
                        _this.adapter.addClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWN);
                    });
                };
                /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Hides the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.hideSurfaceScrim = function() {
                    this.adapter.removeClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWN);
                    this.adapter.addClass(constants_1.cssClasses.SURFACE_SCRIM_HIDING);
                };
                /**
     * Handles `transitionend` event triggered when surface scrim animation is
     * finished.
     */ MDCDialogFoundation.prototype.handleSurfaceScrimTransitionEnd = function() {
                    this.adapter.removeClass(constants_1.cssClasses.SURFACE_SCRIM_HIDING);
                    this.adapter.removeClass(constants_1.cssClasses.SURFACE_SCRIM_SHOWING);
                };
                MDCDialogFoundation.prototype.isOpen = function() {
                    return this.dialogOpen;
                };
                MDCDialogFoundation.prototype.getEscapeKeyAction = function() {
                    return this.escapeKeyAction;
                };
                MDCDialogFoundation.prototype.setEscapeKeyAction = function(action) {
                    this.escapeKeyAction = action;
                };
                MDCDialogFoundation.prototype.getScrimClickAction = function() {
                    return this.scrimClickAction;
                };
                MDCDialogFoundation.prototype.setScrimClickAction = function(action) {
                    this.scrimClickAction = action;
                };
                MDCDialogFoundation.prototype.getAutoStackButtons = function() {
                    return this.autoStackButtons;
                };
                MDCDialogFoundation.prototype.setAutoStackButtons = function(autoStack) {
                    this.autoStackButtons = autoStack;
                };
                MDCDialogFoundation.prototype.getSuppressDefaultPressSelector = function() {
                    return this.suppressDefaultPressSelector;
                };
                MDCDialogFoundation.prototype.setSuppressDefaultPressSelector = function(selector) {
                    this.suppressDefaultPressSelector = selector;
                };
                MDCDialogFoundation.prototype.layout = function() {
                    var _this = this;
                    this.animFrame.request(AnimationKeys.POLL_LAYOUT_CHANGE, function() {
                        _this.layoutInternal();
                    });
                };
                /** Handles click on the dialog root element. */ MDCDialogFoundation.prototype.handleClick = function(evt) {
                    var isScrim = this.adapter.eventTargetMatches(evt.target, constants_1.strings.SCRIM_SELECTOR);
                    // Check for scrim click first since it doesn't require querying ancestors.
                    if (isScrim && this.scrimClickAction !== "") this.close(this.scrimClickAction);
                    else {
                        var action = this.adapter.getActionFromEvent(evt);
                        if (action) this.close(action);
                    }
                };
                /** Handles keydown on the dialog root element. */ MDCDialogFoundation.prototype.handleKeydown = function(evt) {
                    var isEnter = evt.key === "Enter" || evt.keyCode === 13;
                    if (!isEnter) return;
                    var action = this.adapter.getActionFromEvent(evt);
                    if (action) // Action button callback is handled in `handleClick`,
                    // since space/enter keydowns on buttons trigger click events.
                    return;
                    // `composedPath` is used here, when available, to account for use cases
                    // where a target meant to suppress the default press behaviour
                    // may exist in a shadow root.
                    // For example, a textarea inside a web component:
                    // <mwc-dialog>
                    //   <horizontal-layout>
                    //     #shadow-root (open)
                    //       <mwc-textarea>
                    //         #shadow-root (open)
                    //           <textarea></textarea>
                    //       </mwc-textarea>
                    //   </horizontal-layout>
                    // </mwc-dialog>
                    var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
                    var isDefault = this.suppressDefaultPressSelector ? !this.adapter.eventTargetMatches(target, this.suppressDefaultPressSelector) : true;
                    if (isEnter && isDefault) this.adapter.clickDefaultButton();
                };
                /** Handles keydown on the document. */ MDCDialogFoundation.prototype.handleDocumentKeydown = function(evt) {
                    var isEscape = evt.key === "Escape" || evt.keyCode === 27;
                    if (isEscape && this.escapeKeyAction !== "") this.close(this.escapeKeyAction);
                };
                /**
     * Handles scroll event on the dialog's content element -- showing a scroll
     * divider on the header or footer based on the scroll position. This handler
     * should only be registered on full-screen dialogs with scrollable content.
     */ MDCDialogFoundation.prototype.handleScrollEvent = function() {
                    var _this = this;
                    // Since scroll events can fire at a high rate, we throttle these events by
                    // using requestAnimationFrame.
                    this.animFrame.request(AnimationKeys.POLL_SCROLL_POS, function() {
                        _this.toggleScrollDividerHeader();
                        _this.toggleScrollDividerFooter();
                    });
                };
                MDCDialogFoundation.prototype.layoutInternal = function() {
                    if (this.autoStackButtons) this.detectStackedButtons();
                    this.toggleScrollableClasses();
                };
                MDCDialogFoundation.prototype.handleAnimationTimerEnd = function() {
                    this.animationTimer = 0;
                    this.adapter.removeClass(constants_1.cssClasses.OPENING);
                    this.adapter.removeClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Runs the given logic on the next animation frame, using setTimeout to
     * factor in Firefox reflow behavior.
     */ MDCDialogFoundation.prototype.runNextAnimationFrame = function(callback) {
                    var _this = this;
                    cancelAnimationFrame(this.animationFrame);
                    this.animationFrame = requestAnimationFrame(function() {
                        _this.animationFrame = 0;
                        clearTimeout(_this.animationTimer);
                        _this.animationTimer = setTimeout(callback, 0);
                    });
                };
                MDCDialogFoundation.prototype.detectStackedButtons = function() {
                    // Remove the class first to let us measure the buttons' natural positions.
                    this.adapter.removeClass(constants_1.cssClasses.STACKED);
                    var areButtonsStacked = this.adapter.areButtonsStacked();
                    if (areButtonsStacked) this.adapter.addClass(constants_1.cssClasses.STACKED);
                    if (areButtonsStacked !== this.areButtonsStacked) {
                        this.adapter.reverseButtons();
                        this.areButtonsStacked = areButtonsStacked;
                    }
                };
                MDCDialogFoundation.prototype.toggleScrollableClasses = function() {
                    // Remove the class first to let us measure the natural height of the
                    // content.
                    this.adapter.removeClass(constants_1.cssClasses.SCROLLABLE);
                    if (this.adapter.isContentScrollable()) {
                        this.adapter.addClass(constants_1.cssClasses.SCROLLABLE);
                        if (this.isFullscreen) {
                            // If dialog is full-screen and scrollable, check if a scroll divider
                            // should be shown.
                            this.toggleScrollDividerHeader();
                            this.toggleScrollDividerFooter();
                        }
                    }
                };
                MDCDialogFoundation.prototype.toggleScrollDividerHeader = function() {
                    if (!this.adapter.isScrollableContentAtTop()) this.adapter.addClass(constants_1.cssClasses.SCROLL_DIVIDER_HEADER);
                    else if (this.adapter.hasClass(constants_1.cssClasses.SCROLL_DIVIDER_HEADER)) this.adapter.removeClass(constants_1.cssClasses.SCROLL_DIVIDER_HEADER);
                };
                MDCDialogFoundation.prototype.toggleScrollDividerFooter = function() {
                    if (!this.adapter.isScrollableContentAtBottom()) this.adapter.addClass(constants_1.cssClasses.SCROLL_DIVIDER_FOOTER);
                    else if (this.adapter.hasClass(constants_1.cssClasses.SCROLL_DIVIDER_FOOTER)) this.adapter.removeClass(constants_1.cssClasses.SCROLL_DIVIDER_FOOTER);
                };
                return MDCDialogFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCDialogFoundation = MDCDialogFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCDialogFoundation;
        /***/ },
        /***/ "./packages/mdc-dialog/util.ts": /*!*************************************!*\
  !*** ./packages/mdc-dialog/util.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.areTopsMisaligned = exports.isScrollAtBottom = exports.isScrollAtTop = exports.isScrollable = exports.createFocusTrapInstance = void 0;
            var focus_trap_1 = __webpack_require__(/*! focus-trap */ "./node_modules/focus-trap/dist/focus-trap.esm.js");
            function createFocusTrapInstance(surfaceEl, focusTrapFactory, initialFocusEl) {
                if (focusTrapFactory === void 0) focusTrapFactory = focus_trap_1.createFocusTrap;
                return focusTrapFactory(surfaceEl, {
                    allowOutsideClick: true,
                    clickOutsideDeactivates: false,
                    escapeDeactivates: true,
                    initialFocus: initialFocusEl
                });
            }
            exports.createFocusTrapInstance = createFocusTrapInstance;
            function isScrollable(el) {
                return el ? el.scrollHeight > el.offsetHeight : false;
            }
            exports.isScrollable = isScrollable;
            /**
 * For scrollable content, returns true if the content has not been scrolled
 * (that is, the scroll content is as the "top"). This is used in full-screen
 * dialogs, where the scroll divider is expected only to appear once the
 * content has been scrolled "underneath" the header bar.
 */ function isScrollAtTop(el) {
                return el ? el.scrollTop === 0 : false;
            }
            exports.isScrollAtTop = isScrollAtTop;
            /**
 * For scrollable content, returns true if the content has been scrolled all the
 * way to the bottom. This is used in full-screen dialogs, where the footer
 * scroll divider is expected only to appear when the content is "cut-off" by
 * the footer bar.
 */ function isScrollAtBottom(el) {
                return el ? Math.ceil(el.scrollHeight - el.scrollTop) === el.clientHeight : false;
            }
            exports.isScrollAtBottom = isScrollAtBottom;
            function areTopsMisaligned(els) {
                var tops = new Set();
                [].forEach.call(els, function(el) {
                    return tops.add(el.offsetTop);
                });
                return tops.size > 1;
            }
            exports.areTopsMisaligned = areTopsMisaligned;
        /***/ },
        /***/ "./packages/mdc-dom/announce.ts": /*!**************************************!*\
  !*** ./packages/mdc-dom/announce.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.announce = exports.DATA_MDC_DOM_ANNOUNCE = exports.AnnouncerPriority = void 0;
            /**
 * Priorities for the announce function
 */ var AnnouncerPriority;
            (function(AnnouncerPriority) {
                AnnouncerPriority["POLITE"] = "polite";
                AnnouncerPriority["ASSERTIVE"] = "assertive";
            })(AnnouncerPriority = exports.AnnouncerPriority || (exports.AnnouncerPriority = {}));
            /**
 * Data attribute added to live region element.
 */ exports.DATA_MDC_DOM_ANNOUNCE = "data-mdc-dom-announce";
            /**
 * Announces the given message with optional priority, defaulting to "polite"
 */ function announce(message, priority) {
                Announcer.getInstance().say(message, priority);
            }
            exports.announce = announce;
            var Announcer = /** @class */ function() {
                // Constructor made private to ensure only the singleton is used
                function Announcer() {
                    this.liveRegions = new Map();
                }
                Announcer.getInstance = function() {
                    if (!Announcer.instance) Announcer.instance = new Announcer();
                    return Announcer.instance;
                };
                Announcer.prototype.say = function(message, priority) {
                    if (priority === void 0) priority = AnnouncerPriority.POLITE;
                    var liveRegion = this.getLiveRegion(priority);
                    // Reset the region to pick up the message, even if the message is the
                    // exact same as before.
                    liveRegion.textContent = "";
                    // Timeout is necessary for screen readers like NVDA and VoiceOver.
                    setTimeout(function() {
                        liveRegion.textContent = message;
                        document.addEventListener("click", clearLiveRegion);
                    }, 1);
                    function clearLiveRegion() {
                        liveRegion.textContent = "";
                        document.removeEventListener("click", clearLiveRegion);
                    }
                };
                Announcer.prototype.getLiveRegion = function(priority) {
                    var existingLiveRegion = this.liveRegions.get(priority);
                    if (existingLiveRegion && document.body.contains(existingLiveRegion)) return existingLiveRegion;
                    var liveRegion = this.createLiveRegion(priority);
                    this.liveRegions.set(priority, liveRegion);
                    return liveRegion;
                };
                Announcer.prototype.createLiveRegion = function(priority) {
                    var el = document.createElement("div");
                    el.style.position = "absolute";
                    el.style.top = "-9999px";
                    el.style.left = "-9999px";
                    el.style.height = "1px";
                    el.style.overflow = "hidden";
                    el.setAttribute("aria-atomic", "true");
                    el.setAttribute("aria-live", priority);
                    el.setAttribute(exports.DATA_MDC_DOM_ANNOUNCE, "true");
                    document.body.appendChild(el);
                    return el;
                };
                return Announcer;
            }();
        /***/ },
        /***/ "./packages/mdc-dom/events.ts": /*!************************************!*\
  !*** ./packages/mdc-dom/events.ts ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.applyPassive = void 0;
            /**
 * Determine whether the current browser supports passive event listeners, and
 * if so, use them.
 */ function applyPassive(globalObj) {
                if (globalObj === void 0) globalObj = window;
                return supportsPassiveOption(globalObj) ? {
                    passive: true
                } : false;
            }
            exports.applyPassive = applyPassive;
            function supportsPassiveOption(globalObj) {
                if (globalObj === void 0) globalObj = window;
                // See
                // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
                var passiveSupported = false;
                try {
                    var options = {
                        // This function will be called when the browser
                        // attempts to access the passive property.
                        get passive () {
                            passiveSupported = true;
                            return false;
                        }
                    };
                    var handler = function handler() {};
                    globalObj.document.addEventListener("test", handler, options);
                    globalObj.document.removeEventListener("test", handler, options);
                } catch (err) {
                    passiveSupported = false;
                }
                return passiveSupported;
            }
        /***/ },
        /***/ "./packages/mdc-dom/keyboard.ts": /*!**************************************!*\
  !*** ./packages/mdc-dom/keyboard.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.isNavigationEvent = exports.normalizeKey = exports.KEY = void 0;
            /**
 * KEY provides normalized string values for keys.
 */ exports.KEY = {
                UNKNOWN: "Unknown",
                BACKSPACE: "Backspace",
                ENTER: "Enter",
                SPACEBAR: "Spacebar",
                PAGE_UP: "PageUp",
                PAGE_DOWN: "PageDown",
                END: "End",
                HOME: "Home",
                ARROW_LEFT: "ArrowLeft",
                ARROW_UP: "ArrowUp",
                ARROW_RIGHT: "ArrowRight",
                ARROW_DOWN: "ArrowDown",
                DELETE: "Delete",
                ESCAPE: "Escape",
                TAB: "Tab"
            };
            var normalizedKeys = new Set();
            // IE11 has no support for new Map with iterable so we need to initialize this
            // by hand.
            normalizedKeys.add(exports.KEY.BACKSPACE);
            normalizedKeys.add(exports.KEY.ENTER);
            normalizedKeys.add(exports.KEY.SPACEBAR);
            normalizedKeys.add(exports.KEY.PAGE_UP);
            normalizedKeys.add(exports.KEY.PAGE_DOWN);
            normalizedKeys.add(exports.KEY.END);
            normalizedKeys.add(exports.KEY.HOME);
            normalizedKeys.add(exports.KEY.ARROW_LEFT);
            normalizedKeys.add(exports.KEY.ARROW_UP);
            normalizedKeys.add(exports.KEY.ARROW_RIGHT);
            normalizedKeys.add(exports.KEY.ARROW_DOWN);
            normalizedKeys.add(exports.KEY.DELETE);
            normalizedKeys.add(exports.KEY.ESCAPE);
            normalizedKeys.add(exports.KEY.TAB);
            var KEY_CODE = {
                BACKSPACE: 8,
                ENTER: 13,
                SPACEBAR: 32,
                PAGE_UP: 33,
                PAGE_DOWN: 34,
                END: 35,
                HOME: 36,
                ARROW_LEFT: 37,
                ARROW_UP: 38,
                ARROW_RIGHT: 39,
                ARROW_DOWN: 40,
                DELETE: 46,
                ESCAPE: 27,
                TAB: 9
            };
            var mappedKeyCodes = new Map();
            // IE11 has no support for new Map with iterable so we need to initialize this
            // by hand.
            mappedKeyCodes.set(KEY_CODE.BACKSPACE, exports.KEY.BACKSPACE);
            mappedKeyCodes.set(KEY_CODE.ENTER, exports.KEY.ENTER);
            mappedKeyCodes.set(KEY_CODE.SPACEBAR, exports.KEY.SPACEBAR);
            mappedKeyCodes.set(KEY_CODE.PAGE_UP, exports.KEY.PAGE_UP);
            mappedKeyCodes.set(KEY_CODE.PAGE_DOWN, exports.KEY.PAGE_DOWN);
            mappedKeyCodes.set(KEY_CODE.END, exports.KEY.END);
            mappedKeyCodes.set(KEY_CODE.HOME, exports.KEY.HOME);
            mappedKeyCodes.set(KEY_CODE.ARROW_LEFT, exports.KEY.ARROW_LEFT);
            mappedKeyCodes.set(KEY_CODE.ARROW_UP, exports.KEY.ARROW_UP);
            mappedKeyCodes.set(KEY_CODE.ARROW_RIGHT, exports.KEY.ARROW_RIGHT);
            mappedKeyCodes.set(KEY_CODE.ARROW_DOWN, exports.KEY.ARROW_DOWN);
            mappedKeyCodes.set(KEY_CODE.DELETE, exports.KEY.DELETE);
            mappedKeyCodes.set(KEY_CODE.ESCAPE, exports.KEY.ESCAPE);
            mappedKeyCodes.set(KEY_CODE.TAB, exports.KEY.TAB);
            var navigationKeys = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this
            // by hand.
            navigationKeys.add(exports.KEY.PAGE_UP);
            navigationKeys.add(exports.KEY.PAGE_DOWN);
            navigationKeys.add(exports.KEY.END);
            navigationKeys.add(exports.KEY.HOME);
            navigationKeys.add(exports.KEY.ARROW_LEFT);
            navigationKeys.add(exports.KEY.ARROW_UP);
            navigationKeys.add(exports.KEY.ARROW_RIGHT);
            navigationKeys.add(exports.KEY.ARROW_DOWN);
            /**
 * normalizeKey returns the normalized string for a navigational action.
 */ function normalizeKey(evt) {
                var key = evt.key;
                // If the event already has a normalized key, return it
                if (normalizedKeys.has(key)) return key;
                // tslint:disable-next-line:deprecation
                var mappedKey = mappedKeyCodes.get(evt.keyCode);
                if (mappedKey) return mappedKey;
                return exports.KEY.UNKNOWN;
            }
            exports.normalizeKey = normalizeKey;
            /**
 * isNavigationEvent returns whether the event is a navigation event
 */ function isNavigationEvent(evt) {
                return navigationKeys.has(normalizeKey(evt));
            }
            exports.isNavigationEvent = isNavigationEvent;
        /***/ },
        /***/ "./packages/mdc-dom/ponyfill.ts": /*!**************************************!*\
  !*** ./packages/mdc-dom/ponyfill.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.estimateScrollWidth = exports.matches = exports.closest = void 0;
            /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function closest(element, selector) {
                if (element.closest) return element.closest(selector);
                var el = element;
                while(el){
                    if (matches(el, selector)) return el;
                    el = el.parentElement;
                }
                return null;
            }
            exports.closest = closest;
            function matches(element, selector) {
                var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
                return nativeMatches.call(element, selector);
            }
            exports.matches = matches;
            /**
 * Used to compute the estimated scroll width of elements. When an element is
 * hidden due to display: none; being applied to a parent element, the width is
 * returned as 0. However, the element will have a true width once no longer
 * inside a display: none context. This method computes an estimated width when
 * the element is hidden or returns the true width when the element is visble.
 * @param {Element} element the element whose width to estimate
 */ function estimateScrollWidth(element) {
                // Check the offsetParent. If the element inherits display: none from any
                // parent, the offsetParent property will be null (see
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
                // This check ensures we only clone the node when necessary.
                var htmlEl = element;
                if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
                var clone = htmlEl.cloneNode(true);
                clone.style.setProperty("position", "absolute");
                clone.style.setProperty("transform", "translate(-9999px, -9999px)");
                document.documentElement.appendChild(clone);
                var scrollWidth = clone.scrollWidth;
                document.documentElement.removeChild(clone);
                return scrollWidth;
            }
            exports.estimateScrollWidth = estimateScrollWidth;
        /***/ },
        /***/ "./packages/mdc-drawer/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-drawer/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                    "default": mod
                };
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDrawer = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var focus_trap_1 = __importDefault(__webpack_require__(/*! focus-trap */ "./node_modules/focus-trap/dist/focus-trap.esm.js"));
            var foundation_1 = __webpack_require__(/*! ./dismissible/foundation */ "./packages/mdc-drawer/dismissible/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./modal/foundation */ "./packages/mdc-drawer/modal/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-drawer/util.ts"));
            var cssClasses = foundation_1.MDCDismissibleDrawerFoundation.cssClasses, strings = foundation_1.MDCDismissibleDrawerFoundation.strings;
            /**
 * @events `MDCDrawer:closed {}` Emits when the navigation drawer has closed.
 * @events `MDCDrawer:opened {}` Emits when the navigation drawer has opened.
 */ var MDCDrawer = /** @class */ function(_super) {
                __extends(MDCDrawer, _super);
                function MDCDrawer() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCDrawer.attachTo = function(root) {
                    return new MDCDrawer(root);
                };
                Object.defineProperty(MDCDrawer.prototype, "open", {
                    /**
         * @return boolean Proxies to the foundation's `open`/`close` methods.
         * Also returns true if drawer is in the open position.
         */ get: function get() {
                        return this.foundation.isOpen();
                    },
                    /**
         * Toggles the drawer open and closed.
         */ set: function set(isOpen) {
                        if (isOpen) this.foundation.open();
                        else this.foundation.close();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDrawer.prototype, "list", {
                    // initialSyncWithDOM()
                    get: function get() {
                        return this.list_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDrawer.prototype.initialize = function(focusTrapFactory) {
                    if (focusTrapFactory === void 0) focusTrapFactory = focus_trap_1.default;
                    /* TODO(revise): list setup */ /* TODO(drawer): list wrapFocus
        const listEl = this.root.querySelector(strings.LIST_SELECTOR);
        if (listEl) {
          listEl.wrapFocus = true;
        }
        */ this.focusTrapFactory_ = focusTrapFactory;
                };
                MDCDrawer.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    var MODAL = cssClasses.MODAL;
                    var SCRIM_SELECTOR = strings.SCRIM_SELECTOR;
                    this.scrim_ = this.root.parentNode.querySelector(SCRIM_SELECTOR);
                    if (this.scrim_ && this.root.classList.contains(MODAL)) {
                        this.handleScrimClick_ = function() {
                            return _this.handleScrimClick();
                        };
                        this.scrim_.addEventListener("click", this.handleScrimClick_);
                        this.focusTrap_ = util.createFocusTrapInstance(this.root, this.focusTrapFactory_);
                    }
                    this.handleKeydown_ = function(evt) {
                        return _this.handleKeydown(evt);
                    };
                    this.handleTransitionEnd_ = function(evt) {
                        return _this.foundation.handleTransitionEnd(evt);
                    };
                    this.listen("keydown", this.handleKeydown_);
                    this.listen("transitionend", this.handleTransitionEnd_);
                };
                MDCDrawer.prototype.handleScrimClick = function() {
                    this.emit("MDCDrawer:close", {}, true);
                };
                MDCDrawer.prototype.handleKeydown = function(evt) {
                    var keyCode = evt.keyCode, key = evt.key;
                    var isEscape = key === "Escape" || keyCode === 27;
                    if (isEscape) this.emit("MDCDrawer:close", {}, true);
                };
                MDCDrawer.prototype.destroy = function() {
                    this.unlisten("keydown", this.handleKeydown_);
                    this.unlisten("transitionend", this.handleTransitionEnd_);
                    var MODAL = cssClasses.MODAL;
                    if (this.scrim_ && this.handleScrimClick_ && this.root.classList.contains(MODAL)) {
                        this.scrim_.removeEventListener("click", this.handleScrimClick_);
                        // Ensure drawer is closed to hide scrim and release focus
                        this.open = false;
                    }
                };
                MDCDrawer.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        elementHasClass: function elementHasClass(element, className) {
                            return element.classList.contains(className);
                        },
                        saveFocus: function saveFocus() {
                            return _this.previousFocus_ = document.activeElement;
                        },
                        restoreFocus: function restoreFocus() {
                            var previousFocus = _this.previousFocus_;
                            if (previousFocus && previousFocus.focus && _this.root.contains(document.activeElement)) previousFocus.focus();
                        },
                        focusActiveNavigationItem: function focusActiveNavigationItem() {
                            var activeNavItemEl = _this.root.querySelector(strings.LIST_ITEM_ACTIVATED_SELECTOR);
                            if (activeNavItemEl) activeNavItemEl.focus();
                        },
                        notifyClose: function notifyClose() {
                            return _this.emit(strings.CLOSE_EVENT, {}, true);
                        },
                        notifyOpen: function notifyOpen() {
                            return _this.emit(strings.OPEN_EVENT, {}, true);
                        },
                        trapFocus: function trapFocus() {
                            return _this.focusTrap_.activate();
                        },
                        releaseFocus: function releaseFocus() {
                            return _this.focusTrap_.deactivate();
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    var DISMISSIBLE = cssClasses.DISMISSIBLE, MODAL = cssClasses.MODAL;
                    if (this.root.classList.contains(DISMISSIBLE)) return new foundation_1.MDCDismissibleDrawerFoundation(adapter);
                    else if (this.root.classList.contains(MODAL)) return new foundation_2.MDCModalDrawerFoundation(adapter);
                    else throw new Error("MDCDrawer: Failed to instantiate component. Supported variants are " + DISMISSIBLE + " and " + MODAL + ".");
                };
                return MDCDrawer;
            }(component_1.MDCComponent);
            exports.MDCDrawer = MDCDrawer;
        /***/ },
        /***/ "./packages/mdc-drawer/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-drawer/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ANIMATE: "mdc-drawer--animate",
                CLOSING: "mdc-drawer--closing",
                DISMISSIBLE: "mdc-drawer--dismissible",
                MODAL: "mdc-drawer--modal",
                OPEN: "mdc-drawer--open",
                OPENING: "mdc-drawer--opening",
                ROOT: "mdc-drawer"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                APP_CONTENT_SELECTOR: ".mdc-drawer-app-content",
                CLOSE_EVENT: "MDCDrawer:closed",
                OPEN_EVENT: "MDCDrawer:opened",
                SCRIM_SELECTOR: ".mdc-drawer-scrim",
                LIST_SELECTOR: ".mdc-list,.mdc-deprecated-list",
                LIST_ITEM_ACTIVATED_SELECTOR: ".mdc-list-item--activated,.mdc-deprecated-list-item--activated"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-drawer/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-drawer/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-drawer/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcDrawer = function(_HTMLElement) {
                _inherits(MdcDrawer, _HTMLElement);
                _createClass(MdcDrawer, [
                    {
                        key: "open",
                        get: function get() {
                            return this.open_;
                        },
                        set: function set(open) {
                            this.open_ = open;
                            if (!!this.drawer_) this.drawer_.open = open;
                        }
                    }
                ]);
                function MdcDrawer() {
                    _classCallCheck(this, MdcDrawer);
                    var _this = _possibleConstructorReturn(this, (MdcDrawer.__proto__ || Object.getPrototypeOf(MdcDrawer)).call(this));
                    _this.open_ = false;
                    _this.drawer_;
                    return _this;
                }
                _createClass(MdcDrawer, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.drawer_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCDrawer"](this);
                            this.drawer_.open = this.open_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.drawer_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcDrawer;
            }(HTMLElement);
            customElements.define("mdc-drawer", MdcDrawer);
        /***/ },
        /***/ "./packages/mdc-drawer/dismissible/foundation.ts": /*!*******************************************************!*\
  !*** ./packages/mdc-drawer/dismissible/foundation.ts ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCDismissibleDrawerFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-drawer/constants.ts");
            var MDCDismissibleDrawerFoundation = /** @class */ function(_super) {
                __extends(MDCDismissibleDrawerFoundation, _super);
                function MDCDismissibleDrawerFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCDismissibleDrawerFoundation.defaultAdapter), adapter)) || this;
                    _this.animationFrame_ = 0;
                    _this.animationTimer_ = 0;
                    return _this;
                }
                Object.defineProperty(MDCDismissibleDrawerFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDismissibleDrawerFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCDismissibleDrawerFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            elementHasClass: function elementHasClass() {
                                return false;
                            },
                            notifyClose: function notifyClose() {
                                return undefined;
                            },
                            notifyOpen: function notifyOpen() {
                                return undefined;
                            },
                            saveFocus: function saveFocus() {
                                return undefined;
                            },
                            restoreFocus: function restoreFocus() {
                                return undefined;
                            },
                            focusActiveNavigationItem: function focusActiveNavigationItem() {
                                return undefined;
                            },
                            trapFocus: function trapFocus() {
                                return undefined;
                            },
                            releaseFocus: function releaseFocus() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCDismissibleDrawerFoundation.prototype.destroy = function() {
                    if (this.animationFrame_) cancelAnimationFrame(this.animationFrame_);
                    if (this.animationTimer_) clearTimeout(this.animationTimer_);
                };
                /**
     * Opens the drawer from the closed state.
     */ MDCDismissibleDrawerFoundation.prototype.open = function() {
                    var _this = this;
                    if (this.isOpen() || this.isOpening() || this.isClosing()) return;
                    this.adapter.addClass(constants_1.cssClasses.OPEN);
                    this.adapter.addClass(constants_1.cssClasses.ANIMATE);
                    // Wait a frame once display is no longer "none", to establish basis for animation
                    this.runNextAnimationFrame_(function() {
                        _this.adapter.addClass(constants_1.cssClasses.OPENING);
                    });
                    this.adapter.saveFocus();
                };
                /**
     * Closes the drawer from the open state.
     */ MDCDismissibleDrawerFoundation.prototype.close = function() {
                    if (!this.isOpen() || this.isOpening() || this.isClosing()) return;
                    this.adapter.addClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Returns true if the drawer is in the open position.
     * @return true if drawer is in open state.
     */ MDCDismissibleDrawerFoundation.prototype.isOpen = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.OPEN);
                };
                /**
     * Returns true if the drawer is animating open.
     * @return true if drawer is animating open.
     */ MDCDismissibleDrawerFoundation.prototype.isOpening = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.OPENING) || this.adapter.hasClass(constants_1.cssClasses.ANIMATE);
                };
                /**
     * Returns true if the drawer is animating closed.
     * @return true if drawer is animating closed.
     */ MDCDismissibleDrawerFoundation.prototype.isClosing = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Keydown handler to close drawer when key is escape.
     */ MDCDismissibleDrawerFoundation.prototype.handleKeydown = function(evt) {
                    var keyCode = evt.keyCode, key = evt.key;
                    var isEscape = key === "Escape" || keyCode === 27;
                    if (isEscape) this.close();
                };
                /**
     * Handles the `transitionend` event when the drawer finishes opening/closing.
     */ MDCDismissibleDrawerFoundation.prototype.handleTransitionEnd = function(evt) {
                    var OPENING = constants_1.cssClasses.OPENING, CLOSING = constants_1.cssClasses.CLOSING, OPEN = constants_1.cssClasses.OPEN, ANIMATE = constants_1.cssClasses.ANIMATE, ROOT = constants_1.cssClasses.ROOT;
                    // In Edge, transitionend on ripple pseudo-elements yields a target without classList, so check for Element first.
                    var isRootElement = this.isElement_(evt.target) && this.adapter.elementHasClass(evt.target, ROOT);
                    if (!isRootElement) return;
                    if (this.isClosing()) {
                        this.adapter.removeClass(OPEN);
                        this.closed_();
                        this.adapter.restoreFocus();
                        this.adapter.notifyClose();
                    } else {
                        this.adapter.focusActiveNavigationItem();
                        this.opened_();
                        this.adapter.notifyOpen();
                    }
                    this.adapter.removeClass(ANIMATE);
                    this.adapter.removeClass(OPENING);
                    this.adapter.removeClass(CLOSING);
                };
                /**
     * Extension point for when drawer finishes open animation.
     */ MDCDismissibleDrawerFoundation.prototype.opened_ = function() {}; // tslint:disable-line:no-empty
                /**
     * Extension point for when drawer finishes close animation.
     */ MDCDismissibleDrawerFoundation.prototype.closed_ = function() {}; // tslint:disable-line:no-empty
                /**
     * Runs the given logic on the next animation frame, using setTimeout to factor in Firefox reflow behavior.
     */ MDCDismissibleDrawerFoundation.prototype.runNextAnimationFrame_ = function(callback) {
                    var _this = this;
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = requestAnimationFrame(function() {
                        _this.animationFrame_ = 0;
                        clearTimeout(_this.animationTimer_);
                        _this.animationTimer_ = setTimeout(callback, 0);
                    });
                };
                MDCDismissibleDrawerFoundation.prototype.isElement_ = function(element) {
                    // In Edge, transitionend on ripple pseudo-elements yields a target without classList.
                    return Boolean(element.classList);
                };
                return MDCDismissibleDrawerFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCDismissibleDrawerFoundation = MDCDismissibleDrawerFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCDismissibleDrawerFoundation;
        /***/ },
        /***/ "./packages/mdc-drawer/modal/foundation.ts": /*!*************************************************!*\
  !*** ./packages/mdc-drawer/modal/foundation.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCModalDrawerFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! ../dismissible/foundation */ "./packages/mdc-drawer/dismissible/foundation.ts");
            /* istanbul ignore next: subclass is not a branch statement */ var MDCModalDrawerFoundation = /** @class */ function(_super) {
                __extends(MDCModalDrawerFoundation, _super);
                function MDCModalDrawerFoundation() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                /**
     * Handles click event on scrim.
     */ MDCModalDrawerFoundation.prototype.handleScrimClick = function() {
                    this.close();
                };
                /**
     * Called when drawer finishes open animation.
     */ MDCModalDrawerFoundation.prototype.opened_ = function() {
                    this.adapter.trapFocus();
                };
                /**
     * Called when drawer finishes close animation.
     */ MDCModalDrawerFoundation.prototype.closed_ = function() {
                    this.adapter.releaseFocus();
                };
                return MDCModalDrawerFoundation;
            }(foundation_1.MDCDismissibleDrawerFoundation);
            exports.MDCModalDrawerFoundation = MDCModalDrawerFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCModalDrawerFoundation;
        /***/ },
        /***/ "./packages/mdc-drawer/util.ts": /*!*************************************!*\
  !*** ./packages/mdc-drawer/util.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.createFocusTrapInstance = void 0;
            var focus_trap_1 = __webpack_require__(/*! focus-trap */ "./node_modules/focus-trap/dist/focus-trap.esm.js");
            function createFocusTrapInstance(surfaceEl, focusTrapFactory) {
                if (focusTrapFactory === void 0) focusTrapFactory = focus_trap_1.createFocusTrap;
                return focusTrapFactory(surfaceEl, {
                    clickOutsideDeactivates: true,
                    escapeDeactivates: false,
                    initialFocus: undefined,
                    returnFocusOnDeactivate: false
                });
            }
            exports.createFocusTrapInstance = createFocusTrapInstance;
        /***/ },
        /***/ "./packages/mdc-fab/custom-element.js": /*!********************************************!*\
  !*** ./packages/mdc-fab/custom-element.js ***!
  \********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcFab = function(_HTMLElement) {
                _inherits(MdcFab, _HTMLElement);
                function MdcFab() {
                    _classCallCheck(this, MdcFab);
                    var _this = _possibleConstructorReturn(this, (MdcFab.__proto__ || Object.getPrototypeOf(MdcFab)).call(this));
                    _this.handleKeydown_;
                    return _this;
                }
                _createClass(MdcFab, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this);
                            this.handleKeydown_ = this.handleKeydown.bind(this);
                            this.addEventListener("keydown", this.handleKeydown_);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                            this.removeEventListener("keydown", this.handleKeydown_);
                        }
                    },
                    {
                        key: "handleKeydown",
                        value: function handleKeydown(event) {
                            var isSpace = event.key === "Space" || event.keyCode == 32;
                            var isEnter = event.key === "Enter" || event.keyCode == 12;
                            if (isSpace || isEnter) {
                                this.click();
                                event.preventDefault();
                            }
                        }
                    }
                ]);
                return MdcFab;
            }(HTMLElement);
            customElements.define("mdc-fab", MdcFab);
        /***/ },
        /***/ "./packages/mdc-floating-label/component.ts": /*!**************************************************!*\
  !*** ./packages/mdc-floating-label/component.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFloatingLabel = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-floating-label/foundation.ts");
            var MDCFloatingLabel = /** @class */ function(_super) {
                __extends(MDCFloatingLabel, _super);
                function MDCFloatingLabel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCFloatingLabel.attachTo = function(root) {
                    return new MDCFloatingLabel(root);
                };
                /**
     * Styles the label to produce the label shake for errors.
     * @param shouldShake If true, shakes the label by adding a CSS class; otherwise, stops shaking by removing the class.
     */ MDCFloatingLabel.prototype.shake = function(shouldShake) {
                    this.foundation.shake(shouldShake);
                };
                /**
     * Styles the label to float/dock.
     * @param shouldFloat If true, floats the label by adding a CSS class; otherwise, docks it by removing the class.
     */ MDCFloatingLabel.prototype.float = function(shouldFloat) {
                    this.foundation.float(shouldFloat);
                };
                /**
     * Styles the label as required.
     * @param isRequired If true, adds an asterisk to the label, indicating that it is required.
     */ MDCFloatingLabel.prototype.setRequired = function(isRequired) {
                    this.foundation.setRequired(isRequired);
                };
                MDCFloatingLabel.prototype.getWidth = function() {
                    return this.foundation.getWidth();
                };
                MDCFloatingLabel.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        getWidth: function getWidth() {
                            return ponyfill_1.estimateScrollWidth(_this.root);
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCFloatingLabelFoundation(adapter);
                };
                return MDCFloatingLabel;
            }(component_1.MDCComponent);
            exports.MDCFloatingLabel = MDCFloatingLabel;
        /***/ },
        /***/ "./packages/mdc-floating-label/constants.ts": /*!**************************************************!*\
  !*** ./packages/mdc-floating-label/constants.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = void 0;
            exports.cssClasses = {
                LABEL_FLOAT_ABOVE: "mdc-floating-label--float-above",
                LABEL_REQUIRED: "mdc-floating-label--required",
                LABEL_SHAKE: "mdc-floating-label--shake",
                ROOT: "mdc-floating-label"
            };
        /***/ },
        /***/ "./packages/mdc-floating-label/foundation.ts": /*!***************************************************!*\
  !*** ./packages/mdc-floating-label/foundation.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFloatingLabelFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-floating-label/constants.ts");
            var MDCFloatingLabelFoundation = /** @class */ function(_super) {
                __extends(MDCFloatingLabelFoundation, _super);
                function MDCFloatingLabelFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCFloatingLabelFoundation.defaultAdapter), adapter)) || this;
                    _this.shakeAnimationEndHandler_ = function() {
                        return _this.handleShakeAnimationEnd_();
                    };
                    return _this;
                }
                Object.defineProperty(MDCFloatingLabelFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFloatingLabelFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCFloatingLabelAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            getWidth: function getWidth() {
                                return 0;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCFloatingLabelFoundation.prototype.init = function() {
                    this.adapter.registerInteractionHandler("animationend", this.shakeAnimationEndHandler_);
                };
                MDCFloatingLabelFoundation.prototype.destroy = function() {
                    this.adapter.deregisterInteractionHandler("animationend", this.shakeAnimationEndHandler_);
                };
                /**
     * Returns the width of the label element.
     */ MDCFloatingLabelFoundation.prototype.getWidth = function() {
                    return this.adapter.getWidth();
                };
                /**
     * Styles the label to produce a shake animation to indicate an error.
     * @param shouldShake If true, adds the shake CSS class; otherwise, removes shake class.
     */ MDCFloatingLabelFoundation.prototype.shake = function(shouldShake) {
                    var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
                    if (shouldShake) this.adapter.addClass(LABEL_SHAKE);
                    else this.adapter.removeClass(LABEL_SHAKE);
                };
                /**
     * Styles the label to float or dock.
     * @param shouldFloat If true, adds the float CSS class; otherwise, removes float and shake classes to dock the label.
     */ MDCFloatingLabelFoundation.prototype.float = function(shouldFloat) {
                    var _a = MDCFloatingLabelFoundation.cssClasses, LABEL_FLOAT_ABOVE = _a.LABEL_FLOAT_ABOVE, LABEL_SHAKE = _a.LABEL_SHAKE;
                    if (shouldFloat) this.adapter.addClass(LABEL_FLOAT_ABOVE);
                    else {
                        this.adapter.removeClass(LABEL_FLOAT_ABOVE);
                        this.adapter.removeClass(LABEL_SHAKE);
                    }
                };
                /**
     * Styles the label as required.
     * @param isRequired If true, adds an asterisk to the label, indicating that it is required.
     */ MDCFloatingLabelFoundation.prototype.setRequired = function(isRequired) {
                    var LABEL_REQUIRED = MDCFloatingLabelFoundation.cssClasses.LABEL_REQUIRED;
                    if (isRequired) this.adapter.addClass(LABEL_REQUIRED);
                    else this.adapter.removeClass(LABEL_REQUIRED);
                };
                MDCFloatingLabelFoundation.prototype.handleShakeAnimationEnd_ = function() {
                    var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
                    this.adapter.removeClass(LABEL_SHAKE);
                };
                return MDCFloatingLabelFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCFloatingLabelFoundation = MDCFloatingLabelFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFloatingLabelFoundation;
        /***/ },
        /***/ "./packages/mdc-form-field/component.ts": /*!**********************************************!*\
  !*** ./packages/mdc-form-field/component.ts ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFormField = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-form-field/foundation.ts");
            var MDCFormField = /** @class */ function(_super) {
                __extends(MDCFormField, _super);
                function MDCFormField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCFormField.attachTo = function(root) {
                    return new MDCFormField(root);
                };
                MDCFormField.prototype.labelEl = function() {
                    var LABEL_SELECTOR = foundation_1.MDCFormFieldFoundation.strings.LABEL_SELECTOR;
                    return this.root.querySelector(LABEL_SELECTOR);
                };
                MDCFormField.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        activateInputRipple: function activateInputRipple() {
                            if (_this.input && _this.input.ripple) _this.input.ripple.activate();
                        },
                        deactivateInputRipple: function deactivateInputRipple() {
                            if (_this.input && _this.input.ripple) _this.input.ripple.deactivate();
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            var labelEl = _this.labelEl();
                            if (labelEl) labelEl.removeEventListener(evtType, handler);
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            var labelEl = _this.labelEl();
                            if (labelEl) labelEl.addEventListener(evtType, handler);
                        }
                    };
                    return new foundation_1.MDCFormFieldFoundation(adapter);
                };
                return MDCFormField;
            }(component_1.MDCComponent);
            exports.MDCFormField = MDCFormField;
        /***/ },
        /***/ "./packages/mdc-form-field/constants.ts": /*!**********************************************!*\
  !*** ./packages/mdc-form-field/constants.ts ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                ROOT: "mdc-form-field"
            };
            exports.strings = {
                LABEL_SELECTOR: ".mdc-form-field > label"
            };
        /***/ },
        /***/ "./packages/mdc-form-field/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-form-field/custom-element.js ***!
  \***************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-form-field/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcFormField = function(_HTMLElement) {
                _inherits(MdcFormField, _HTMLElement);
                _createClass(MdcFormField, [
                    {
                        key: "focus",
                        value: function focus() {
                            if (!!this.formField_.input) this.formField_.input.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (!!this.formField_.input) this.formField_.input.blur();
                        }
                    }
                ]);
                function MdcFormField() {
                    _classCallCheck(this, MdcFormField);
                    var _this = _possibleConstructorReturn(this, (MdcFormField.__proto__ || Object.getPrototypeOf(MdcFormField)).call(this));
                    _this.formField_;
                    return _this;
                }
                _createClass(MdcFormField, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.formField_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCFormField"](this);
                            var inputElement = this.querySelector("input");
                            if (inputElement) this.formField_.input = inputElement;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.formField_.destroy();
                        }
                    }
                ]);
                return MdcFormField;
            }(HTMLElement);
            customElements.define("mdc-form-field", MdcFormField);
        /***/ },
        /***/ "./packages/mdc-form-field/foundation.ts": /*!***********************************************!*\
  !*** ./packages/mdc-form-field/foundation.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFormFieldFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-form-field/constants.ts");
            var MDCFormFieldFoundation = /** @class */ function(_super) {
                __extends(MDCFormFieldFoundation, _super);
                function MDCFormFieldFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCFormFieldFoundation.defaultAdapter), adapter)) || this;
                    _this.click = function() {
                        _this.handleClick();
                    };
                    return _this;
                }
                Object.defineProperty(MDCFormFieldFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFormFieldFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCFormFieldFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            activateInputRipple: function activateInputRipple() {
                                return undefined;
                            },
                            deactivateInputRipple: function deactivateInputRipple() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCFormFieldFoundation.prototype.init = function() {
                    this.adapter.registerInteractionHandler("click", this.click);
                };
                MDCFormFieldFoundation.prototype.destroy = function() {
                    this.adapter.deregisterInteractionHandler("click", this.click);
                };
                MDCFormFieldFoundation.prototype.handleClick = function() {
                    var _this = this;
                    this.adapter.activateInputRipple();
                    requestAnimationFrame(function() {
                        _this.adapter.deactivateInputRipple();
                    });
                };
                return MDCFormFieldFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCFormFieldFoundation = MDCFormFieldFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFormFieldFoundation;
        /***/ },
        /***/ "./packages/mdc-icon-button/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-icon-button/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCIconButtonToggle = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-icon-button/foundation.ts");
            var strings = foundation_1.MDCIconButtonToggleFoundation.strings;
            var MDCIconButtonToggle = /** @class */ function(_super) {
                __extends(MDCIconButtonToggle, _super);
                function MDCIconButtonToggle() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.rippleComponent = _this.createRipple();
                    return _this;
                }
                MDCIconButtonToggle.attachTo = function(root) {
                    return new MDCIconButtonToggle(root);
                };
                MDCIconButtonToggle.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleClick = function() {
                        _this.foundation.handleClick();
                    };
                    this.handleClick_ = this.handleClick_.bind(this);
                    this.listen("click", this.handleClick);
                };
                MDCIconButtonToggle.prototype.destroy = function() {
                    this.unlisten("click", this.handleClick);
                    this.ripple.destroy();
                    _super.prototype.destroy.call(this);
                };
                MDCIconButtonToggle.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        notifyChange: function notifyChange() {},
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        getAttr: function getAttr(attrName) {
                            return _this.root.getAttribute(attrName);
                        },
                        setAttr: function setAttr(attrName, attrValue) {
                            return _this.root.setAttribute(attrName, attrValue);
                        }
                    };
                    return new foundation_1.MDCIconButtonToggleFoundation(adapter);
                };
                MDCIconButtonToggle.prototype.handleClick_ = function() {
                    this.emit(strings.CHANGE_EVENT, {
                        isOn: !this.on
                    });
                };
                Object.defineProperty(MDCIconButtonToggle.prototype, "ripple", {
                    get: function get() {
                        return this.rippleComponent;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCIconButtonToggle.prototype, "on", {
                    get: function get() {
                        return this.foundation.isOn();
                    },
                    set: function set(isOn) {
                        this.foundation.toggle(isOn);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCIconButtonToggle.prototype.createRipple = function() {
                    var ripple = new component_2.MDCRipple(this.root);
                    ripple.unbounded = true;
                    return ripple;
                };
                return MDCIconButtonToggle;
            }(component_1.MDCComponent);
            exports.MDCIconButtonToggle = MDCIconButtonToggle;
        /***/ },
        /***/ "./packages/mdc-icon-button/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-icon-button/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                ICON_BUTTON_ON: "mdc-icon-button--on",
                ROOT: "mdc-icon-button"
            };
            exports.strings = {
                ARIA_LABEL: "aria-label",
                ARIA_PRESSED: "aria-pressed",
                DATA_ARIA_LABEL_OFF: "data-aria-label-off",
                DATA_ARIA_LABEL_ON: "data-aria-label-on",
                CHANGE_EVENT: "MDCIconButtonToggle:change"
            };
        /***/ },
        /***/ "./packages/mdc-icon-button/custom-element.js": /*!****************************************************!*\
  !*** ./packages/mdc-icon-button/custom-element.js ***!
  \****************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mdc-icon-button/component */ "./packages/mdc-icon-button/component.ts");
            /* harmony import */ var _mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcIconButton = function(_HTMLElement) {
                _inherits(MdcIconButton, _HTMLElement);
                function MdcIconButton() {
                    _classCallCheck(this, MdcIconButton);
                    var _this = _possibleConstructorReturn(this, (MdcIconButton.__proto__ || Object.getPrototypeOf(MdcIconButton)).call(this));
                    _this.root_;
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcIconButton, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.root_ = this.querySelector(".mdc-icon-button");
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this.root_);
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__["MDCRipple"](this.root_);
                            this.ripple_.unbounded = true;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this.root_);
                        }
                    }
                ]);
                return MdcIconButton;
            }(HTMLElement);
            customElements.define("mdc-icon-button", MdcIconButton);
            var MdcIconToggle = function(_HTMLElement2) {
                _inherits(MdcIconToggle, _HTMLElement2);
                _createClass(MdcIconToggle, [
                    {
                        key: "on",
                        get: function get() {
                            return this.on_;
                        },
                        set: function set(on) {
                            this.on_ = on;
                            if (!!this.iconButtonToggle_) this.iconButtonToggle_.on = on;
                        }
                    }
                ]);
                function MdcIconToggle() {
                    _classCallCheck(this, MdcIconToggle);
                    var _this2 = _possibleConstructorReturn(this, (MdcIconToggle.__proto__ || Object.getPrototypeOf(MdcIconToggle)).call(this));
                    _this2.root_;
                    _this2.on_ = false;
                    _this2.iconButtonToggle_;
                    return _this2;
                }
                _createClass(MdcIconToggle, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.root_ = this.querySelector(".mdc-icon-button");
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this.root_);
                            this.iconButtonToggle_ = new _mdc_icon_button_component__WEBPACK_IMPORTED_MODULE_0__["MDCIconButtonToggle"](this.root_);
                            this.iconButtonToggle_.on = this.on_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.iconButtonToggle_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this.root_);
                        }
                    }
                ]);
                return MdcIconToggle;
            }(HTMLElement);
            customElements.define("mdc-icon-toggle", MdcIconToggle);
        /***/ },
        /***/ "./packages/mdc-icon-button/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-icon-button/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCIconButtonToggleFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-icon-button/constants.ts");
            var MDCIconButtonToggleFoundation = /** @class */ function(_super) {
                __extends(MDCIconButtonToggleFoundation, _super);
                function MDCIconButtonToggleFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCIconButtonToggleFoundation.defaultAdapter), adapter)) || this;
                    /**
         * Whether the icon button has an aria label that changes depending on
         * toggled state.
         */ _this.hasToggledAriaLabel = false;
                    return _this;
                }
                Object.defineProperty(MDCIconButtonToggleFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCIconButtonToggleFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCIconButtonToggleFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            notifyChange: function notifyChange() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCIconButtonToggleFoundation.prototype.init = function() {
                    var ariaLabelOn = this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_ON);
                    var ariaLabelOff = this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_OFF);
                    if (ariaLabelOn && ariaLabelOff) {
                        if (this.adapter.getAttr(constants_1.strings.ARIA_PRESSED) !== null) throw new Error("MDCIconButtonToggleFoundation: Button should not set `aria-pressed` if it has a toggled aria label.");
                        this.hasToggledAriaLabel = true;
                    } else this.adapter.setAttr(constants_1.strings.ARIA_PRESSED, String(this.isOn()));
                };
                MDCIconButtonToggleFoundation.prototype.handleClick = function() {
                    this.toggle();
                    this.adapter.notifyChange({
                        isOn: this.isOn()
                    });
                };
                MDCIconButtonToggleFoundation.prototype.isOn = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.ICON_BUTTON_ON);
                };
                MDCIconButtonToggleFoundation.prototype.toggle = function(isOn) {
                    if (isOn === void 0) isOn = !this.isOn();
                    // Toggle UI based on state.
                    if (isOn) this.adapter.addClass(constants_1.cssClasses.ICON_BUTTON_ON);
                    else this.adapter.removeClass(constants_1.cssClasses.ICON_BUTTON_ON);
                    // Toggle aria attributes based on state.
                    if (this.hasToggledAriaLabel) {
                        var ariaLabel = isOn ? this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_ON) : this.adapter.getAttr(constants_1.strings.DATA_ARIA_LABEL_OFF);
                        this.adapter.setAttr(constants_1.strings.ARIA_LABEL, ariaLabel || "");
                    } else this.adapter.setAttr(constants_1.strings.ARIA_PRESSED, "" + isOn);
                };
                return MDCIconButtonToggleFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCIconButtonToggleFoundation = MDCIconButtonToggleFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCIconButtonToggleFoundation;
        /***/ },
        /***/ "./packages/mdc-image-list/custom-element.js": /*!***************************************************!*\
  !*** ./packages/mdc-image-list/custom-element.js ***!
  \***************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcImageList = function(_HTMLElement) {
                _inherits(MdcImageList, _HTMLElement);
                function MdcImageList() {
                    _classCallCheck(this, MdcImageList);
                    return _possibleConstructorReturn(this, (MdcImageList.__proto__ || Object.getPrototypeOf(MdcImageList)).call(this));
                }
                _createClass(MdcImageList, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {}
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {}
                    }
                ]);
                return MdcImageList;
            }(HTMLElement);
            customElements.define("mdc-image-list", MdcImageList);
            var MdcImageListItem = function(_HTMLElement2) {
                _inherits(MdcImageListItem, _HTMLElement2);
                function MdcImageListItem() {
                    _classCallCheck(this, MdcImageListItem);
                    var _this2 = _possibleConstructorReturn(this, (MdcImageListItem.__proto__ || Object.getPrototypeOf(MdcImageListItem)).call(this));
                    _this2.ripple_;
                    return _this2;
                }
                _createClass(MdcImageListItem, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.style.display = "block";
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            var rippleSurfaceElement = this.querySelector(".mdc-ripple-surface");
                            if (!!rippleSurfaceElement) this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](rippleSurfaceElement);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            if (!!this.ripple_) this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcImageListItem;
            }(HTMLElement);
            customElements.define("mdc-image-list-item", MdcImageListItem);
        /***/ },
        /***/ "./packages/mdc-layout-grid/custom-element.js": /*!****************************************************!*\
  !*** ./packages/mdc-layout-grid/custom-element.js ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcLayoutGrid = function(_HTMLElement) {
                _inherits(MdcLayoutGrid, _HTMLElement);
                function MdcLayoutGrid() {
                    _classCallCheck(this, MdcLayoutGrid);
                    return _possibleConstructorReturn(this, (MdcLayoutGrid.__proto__ || Object.getPrototypeOf(MdcLayoutGrid)).call(this));
                }
                _createClass(MdcLayoutGrid, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {}
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {}
                    }
                ]);
                return MdcLayoutGrid;
            }(HTMLElement);
            customElements.define("mdc-layout-grid", MdcLayoutGrid);
        /***/ },
        /***/ "./packages/mdc-line-ripple/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-line-ripple/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLineRipple = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-line-ripple/foundation.ts");
            var MDCLineRipple = /** @class */ function(_super) {
                __extends(MDCLineRipple, _super);
                function MDCLineRipple() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCLineRipple.attachTo = function(root) {
                    return new MDCLineRipple(root);
                };
                /**
     * Activates the line ripple
     */ MDCLineRipple.prototype.activate = function() {
                    this.foundation.activate();
                };
                /**
     * Deactivates the line ripple
     */ MDCLineRipple.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                /**
     * Sets the transform origin given a user's click location.
     * The `rippleCenter` is the x-coordinate of the middle of the ripple.
     */ MDCLineRipple.prototype.setRippleCenter = function(xCoordinate) {
                    this.foundation.setRippleCenter(xCoordinate);
                };
                MDCLineRipple.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        setStyle: function setStyle(propertyName, value) {
                            return _this.root.style.setProperty(propertyName, value);
                        },
                        registerEventHandler: function registerEventHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterEventHandler: function deregisterEventHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCLineRippleFoundation(adapter);
                };
                return MDCLineRipple;
            }(component_1.MDCComponent);
            exports.MDCLineRipple = MDCLineRipple;
        /***/ },
        /***/ "./packages/mdc-line-ripple/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-line-ripple/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = void 0;
            var cssClasses = {
                LINE_RIPPLE_ACTIVE: "mdc-line-ripple--active",
                LINE_RIPPLE_DEACTIVATING: "mdc-line-ripple--deactivating"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-line-ripple/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-line-ripple/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLineRippleFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-line-ripple/constants.ts");
            var MDCLineRippleFoundation = /** @class */ function(_super) {
                __extends(MDCLineRippleFoundation, _super);
                function MDCLineRippleFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCLineRippleFoundation.defaultAdapter), adapter)) || this;
                    _this.transitionEndHandler_ = function(evt) {
                        return _this.handleTransitionEnd(evt);
                    };
                    return _this;
                }
                Object.defineProperty(MDCLineRippleFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLineRippleFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCLineRippleAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setStyle: function setStyle() {
                                return undefined;
                            },
                            registerEventHandler: function registerEventHandler() {
                                return undefined;
                            },
                            deregisterEventHandler: function deregisterEventHandler() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCLineRippleFoundation.prototype.init = function() {
                    this.adapter.registerEventHandler("transitionend", this.transitionEndHandler_);
                };
                MDCLineRippleFoundation.prototype.destroy = function() {
                    this.adapter.deregisterEventHandler("transitionend", this.transitionEndHandler_);
                };
                MDCLineRippleFoundation.prototype.activate = function() {
                    this.adapter.removeClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                    this.adapter.addClass(constants_1.cssClasses.LINE_RIPPLE_ACTIVE);
                };
                MDCLineRippleFoundation.prototype.setRippleCenter = function(xCoordinate) {
                    this.adapter.setStyle("transform-origin", xCoordinate + "px center");
                };
                MDCLineRippleFoundation.prototype.deactivate = function() {
                    this.adapter.addClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                };
                MDCLineRippleFoundation.prototype.handleTransitionEnd = function(evt) {
                    // Wait for the line ripple to be either transparent or opaque
                    // before emitting the animation end event
                    var isDeactivating = this.adapter.hasClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                    if (evt.propertyName === "opacity") {
                        if (isDeactivating) {
                            this.adapter.removeClass(constants_1.cssClasses.LINE_RIPPLE_ACTIVE);
                            this.adapter.removeClass(constants_1.cssClasses.LINE_RIPPLE_DEACTIVATING);
                        }
                    }
                };
                return MDCLineRippleFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCLineRippleFoundation = MDCLineRippleFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCLineRippleFoundation;
        /***/ },
        /***/ "./packages/mdc-linear-progress/component.ts": /*!***************************************************!*\
  !*** ./packages/mdc-linear-progress/component.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLinearProgress = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-linear-progress/foundation.ts");
            var MDCLinearProgress = /** @class */ function(_super) {
                __extends(MDCLinearProgress, _super);
                function MDCLinearProgress() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCLinearProgress.attachTo = function(root) {
                    return new MDCLinearProgress(root);
                };
                Object.defineProperty(MDCLinearProgress.prototype, "determinate", {
                    set: function set(value) {
                        this.foundation.setDeterminate(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgress.prototype, "progress", {
                    set: function set(value) {
                        this.foundation.setProgress(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgress.prototype, "buffer", {
                    set: function set(value) {
                        this.foundation.setBuffer(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCLinearProgress.prototype.open = function() {
                    this.foundation.open();
                };
                MDCLinearProgress.prototype.close = function() {
                    this.foundation.close();
                };
                MDCLinearProgress.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.root.addEventListener("transitionend", function() {
                        _this.foundation.handleTransitionEnd();
                    });
                };
                MDCLinearProgress.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            _this.root.classList.add(className);
                        },
                        forceLayout: function forceLayout() {
                            _this.root.getBoundingClientRect();
                        },
                        setBufferBarStyle: function setBufferBarStyle(styleProperty, value) {
                            var bufferBar = _this.root.querySelector(foundation_1.MDCLinearProgressFoundation.strings.BUFFER_BAR_SELECTOR);
                            if (bufferBar) bufferBar.style.setProperty(styleProperty, value);
                        },
                        setPrimaryBarStyle: function setPrimaryBarStyle(styleProperty, value) {
                            var primaryBar = _this.root.querySelector(foundation_1.MDCLinearProgressFoundation.strings.PRIMARY_BAR_SELECTOR);
                            if (primaryBar) primaryBar.style.setProperty(styleProperty, value);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        removeAttribute: function removeAttribute(attributeName) {
                            _this.root.removeAttribute(attributeName);
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        setAttribute: function setAttribute(attributeName, value) {
                            _this.root.setAttribute(attributeName, value);
                        },
                        setStyle: function setStyle(name, value) {
                            _this.root.style.setProperty(name, value);
                        },
                        attachResizeObserver: function attachResizeObserver(callback) {
                            var RO = window.ResizeObserver;
                            if (RO) {
                                var ro = new RO(callback);
                                ro.observe(_this.root);
                                return ro;
                            }
                            return null;
                        },
                        getWidth: function getWidth() {
                            return _this.root.offsetWidth;
                        }
                    };
                    return new foundation_1.MDCLinearProgressFoundation(adapter);
                };
                return MDCLinearProgress;
            }(component_1.MDCComponent);
            exports.MDCLinearProgress = MDCLinearProgress;
        /***/ },
        /***/ "./packages/mdc-linear-progress/constants.ts": /*!***************************************************!*\
  !*** ./packages/mdc-linear-progress/constants.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.animationDimensionPercentages = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                CLOSED_CLASS: "mdc-linear-progress--closed",
                CLOSED_ANIMATION_OFF_CLASS: "mdc-linear-progress--closed-animation-off",
                INDETERMINATE_CLASS: "mdc-linear-progress--indeterminate",
                REVERSED_CLASS: "mdc-linear-progress--reversed",
                ANIMATION_READY_CLASS: "mdc-linear-progress--animation-ready"
            };
            exports.strings = {
                ARIA_HIDDEN: "aria-hidden",
                ARIA_VALUEMAX: "aria-valuemax",
                ARIA_VALUEMIN: "aria-valuemin",
                ARIA_VALUENOW: "aria-valuenow",
                BUFFER_BAR_SELECTOR: ".mdc-linear-progress__buffer-bar",
                FLEX_BASIS: "flex-basis",
                PRIMARY_BAR_SELECTOR: ".mdc-linear-progress__primary-bar"
            };
            // these are percentages pulled from keyframes.scss
            exports.animationDimensionPercentages = {
                PRIMARY_HALF: .8367142,
                PRIMARY_FULL: 2.00611057,
                SECONDARY_QUARTER: .37651913,
                SECONDARY_HALF: .84386165,
                SECONDARY_FULL: 1.60277782
            };
        /***/ },
        /***/ "./packages/mdc-linear-progress/custom-element.js": /*!********************************************************!*\
  !*** ./packages/mdc-linear-progress/custom-element.js ***!
  \********************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-linear-progress/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcLinearProgress = function(_HTMLElement) {
                _inherits(MdcLinearProgress, _HTMLElement);
                _createClass(MdcLinearProgress, [
                    {
                        key: "determinate",
                        get: function get() {
                            return this.determinate_;
                        },
                        set: function set(determinate) {
                            this.determinate_ = determinate;
                            if (!!this.linearProgress_) this.linearProgress_.determinate = determinate;
                        }
                    },
                    {
                        key: "progress",
                        get: function get() {
                            return this.progress_;
                        },
                        set: function set(progress) {
                            this.progress_ = progress;
                            if (!!this.linearProgress_) this.linearProgress_.progress = progress;
                        }
                    },
                    {
                        key: "buffer",
                        get: function get() {
                            return this.buffer_;
                        },
                        set: function set(buffer) {
                            this.buffer_ = buffer;
                            if (!!this.linearProgress_) this.linearProgress_.buffer = buffer;
                        }
                    },
                    {
                        key: "closed",
                        get: function get() {
                            return this.closed_;
                        },
                        set: function set(closed) {
                            this.closed_ = closed;
                            if (!!this.linearProgress_) {
                                if (closed) this.linearProgress_.close();
                                else this.linearProgress_.open();
                            }
                        }
                    }
                ]);
                function MdcLinearProgress() {
                    _classCallCheck(this, MdcLinearProgress);
                    var _this = _possibleConstructorReturn(this, (MdcLinearProgress.__proto__ || Object.getPrototypeOf(MdcLinearProgress)).call(this));
                    _this.determinate_ = false;
                    _this.progress_ = 0;
                    _this.buffer_ = 1;
                    _this.closed_ = false;
                    _this.linearProgress_;
                    return _this;
                }
                _createClass(MdcLinearProgress, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.linearProgress_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCLinearProgress"](this);
                            this.linearProgress_.determinate = this.determinate_;
                            this.linearProgress_.progress = this.progress_;
                            this.linearProgress_.buffer = this.buffer_;
                            if (this.closed_) this.linearProgress_.close();
                            else this.linearProgress_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.linearProgress_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcLinearProgress;
            }(HTMLElement);
            customElements.define("mdc-linear-progress", MdcLinearProgress);
        /***/ },
        /***/ "./packages/mdc-linear-progress/foundation.ts": /*!****************************************************!*\
  !*** ./packages/mdc-linear-progress/foundation.ts ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __values = this && this.__values || function(o) {
                var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
                if (m) return m.call(o);
                if (o && typeof o.length === "number") return {
                    next: function next() {
                        if (o && i >= o.length) o = void 0;
                        return {
                            value: o && o[i++],
                            done: !o
                        };
                    }
                };
                throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCLinearProgressFoundation = void 0;
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-linear-progress/constants.ts");
            var MDCLinearProgressFoundation = /** @class */ function(_super) {
                __extends(MDCLinearProgressFoundation, _super);
                function MDCLinearProgressFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCLinearProgressFoundation.defaultAdapter), adapter)) || this;
                    _this.observer = null;
                    return _this;
                }
                Object.defineProperty(MDCLinearProgressFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgressFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCLinearProgressFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            attachResizeObserver: function attachResizeObserver() {
                                return null;
                            },
                            forceLayout: function forceLayout() {
                                return undefined;
                            },
                            getWidth: function getWidth() {
                                return 0;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setBufferBarStyle: function setBufferBarStyle() {
                                return null;
                            },
                            setPrimaryBarStyle: function setPrimaryBarStyle() {
                                return null;
                            },
                            setStyle: function setStyle() {
                                return undefined;
                            },
                            removeAttribute: function removeAttribute() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setAttribute: function setAttribute() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCLinearProgressFoundation.prototype.init = function() {
                    var _this = this;
                    this.determinate = !this.adapter.hasClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                    this.adapter.addClass(constants_1.cssClasses.ANIMATION_READY_CLASS);
                    this.progress = 0;
                    this.buffer = 1;
                    this.observer = this.adapter.attachResizeObserver(function(entries) {
                        var e_1, _a;
                        if (_this.determinate) return;
                        try {
                            for(var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()){
                                var entry = entries_1_1.value;
                                if (entry.contentRect) _this.calculateAndSetDimensions(entry.contentRect.width);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                    });
                    if (!this.determinate && this.observer) this.calculateAndSetDimensions(this.adapter.getWidth());
                };
                MDCLinearProgressFoundation.prototype.setDeterminate = function(isDeterminate) {
                    this.determinate = isDeterminate;
                    if (this.determinate) {
                        this.adapter.removeClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, this.progress.toString());
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUEMAX, "1");
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUEMIN, "0");
                        this.setPrimaryBarProgress(this.progress);
                        this.setBufferBarProgress(this.buffer);
                        return;
                    }
                    if (this.observer) this.calculateAndSetDimensions(this.adapter.getWidth());
                    this.adapter.addClass(constants_1.cssClasses.INDETERMINATE_CLASS);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_VALUENOW);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_VALUEMAX);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_VALUEMIN);
                    this.setPrimaryBarProgress(1);
                    this.setBufferBarProgress(1);
                };
                MDCLinearProgressFoundation.prototype.isDeterminate = function() {
                    return this.determinate;
                };
                MDCLinearProgressFoundation.prototype.setProgress = function(value) {
                    this.progress = value;
                    if (this.determinate) {
                        this.setPrimaryBarProgress(value);
                        this.adapter.setAttribute(constants_1.strings.ARIA_VALUENOW, value.toString());
                    }
                };
                MDCLinearProgressFoundation.prototype.getProgress = function() {
                    return this.progress;
                };
                MDCLinearProgressFoundation.prototype.setBuffer = function(value) {
                    this.buffer = value;
                    if (this.determinate) this.setBufferBarProgress(value);
                };
                MDCLinearProgressFoundation.prototype.getBuffer = function() {
                    return this.buffer;
                };
                MDCLinearProgressFoundation.prototype.open = function() {
                    this.adapter.removeClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.removeClass(constants_1.cssClasses.CLOSED_ANIMATION_OFF_CLASS);
                    this.adapter.removeAttribute(constants_1.strings.ARIA_HIDDEN);
                };
                MDCLinearProgressFoundation.prototype.close = function() {
                    this.adapter.addClass(constants_1.cssClasses.CLOSED_CLASS);
                    this.adapter.setAttribute(constants_1.strings.ARIA_HIDDEN, "true");
                };
                MDCLinearProgressFoundation.prototype.isClosed = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.CLOSED_CLASS);
                };
                /**
     * Handles the transitionend event emitted after `close()` is called and the
     * opacity fades out. This is so that animations are removed only after the
     * progress indicator is completely hidden.
     */ MDCLinearProgressFoundation.prototype.handleTransitionEnd = function() {
                    if (this.adapter.hasClass(constants_1.cssClasses.CLOSED_CLASS)) this.adapter.addClass(constants_1.cssClasses.CLOSED_ANIMATION_OFF_CLASS);
                };
                MDCLinearProgressFoundation.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    if (this.observer) this.observer.disconnect();
                };
                MDCLinearProgressFoundation.prototype.restartAnimation = function() {
                    this.adapter.removeClass(constants_1.cssClasses.ANIMATION_READY_CLASS);
                    this.adapter.forceLayout();
                    this.adapter.addClass(constants_1.cssClasses.ANIMATION_READY_CLASS);
                };
                MDCLinearProgressFoundation.prototype.setPrimaryBarProgress = function(progressValue) {
                    var value = "scaleX(" + progressValue + ")";
                    // Accessing `window` without a `typeof` check will throw on Node
                    // environments.
                    var transformProp = typeof window !== "undefined" ? util_1.getCorrectPropertyName(window, "transform") : "transform";
                    this.adapter.setPrimaryBarStyle(transformProp, value);
                };
                MDCLinearProgressFoundation.prototype.setBufferBarProgress = function(progressValue) {
                    var value = progressValue * 100 + "%";
                    this.adapter.setBufferBarStyle(constants_1.strings.FLEX_BASIS, value);
                };
                MDCLinearProgressFoundation.prototype.calculateAndSetDimensions = function(width) {
                    var primaryHalf = width * constants_1.animationDimensionPercentages.PRIMARY_HALF;
                    var primaryFull = width * constants_1.animationDimensionPercentages.PRIMARY_FULL;
                    var secondaryQuarter = width * constants_1.animationDimensionPercentages.SECONDARY_QUARTER;
                    var secondaryHalf = width * constants_1.animationDimensionPercentages.SECONDARY_HALF;
                    var secondaryFull = width * constants_1.animationDimensionPercentages.SECONDARY_FULL;
                    this.adapter.setStyle("--mdc-linear-progress-primary-half", primaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-primary-half-neg", -primaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-primary-full", primaryFull + "px");
                    this.adapter.setStyle("--mdc-linear-progress-primary-full-neg", -primaryFull + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-quarter", secondaryQuarter + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-quarter-neg", -secondaryQuarter + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-half", secondaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-half-neg", -secondaryHalf + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-full", secondaryFull + "px");
                    this.adapter.setStyle("--mdc-linear-progress-secondary-full-neg", -secondaryFull + "px");
                    // need to restart animation for custom props to apply to keyframes
                    this.restartAnimation();
                };
                return MDCLinearProgressFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCLinearProgressFoundation = MDCLinearProgressFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCLinearProgressFoundation;
        /***/ },
        /***/ "./packages/mdc-list/component.ts": /*!****************************************!*\
  !*** ./packages/mdc-list/component.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCList = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-list/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-list/foundation.ts");
            var MDCList = /** @class */ function(_super) {
                __extends(MDCList, _super);
                function MDCList() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MDCList.prototype, "vertical", {
                    set: function set(value) {
                        this.foundation.setVerticalOrientation(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "listElements", {
                    get: function get() {
                        return Array.from(this.root.querySelectorAll("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS]));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "wrapFocus", {
                    set: function set(value) {
                        this.foundation.setWrapFocus(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "typeaheadInProgress", {
                    /**
         * @return Whether typeahead is currently matching a user-specified prefix.
         */ get: function get() {
                        return this.foundation.isTypeaheadInProgress();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "hasTypeahead", {
                    /**
         * Sets whether typeahead functionality is enabled on the list.
         * @param hasTypeahead Whether typeahead is enabled.
         */ set: function set(hasTypeahead) {
                        this.foundation.setHasTypeahead(hasTypeahead);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "singleSelection", {
                    set: function set(isSingleSelectionList) {
                        this.foundation.setSingleSelection(isSingleSelectionList);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCList.prototype, "selectedIndex", {
                    get: function get() {
                        return this.foundation.getSelectedIndex();
                    },
                    set: function set(index) {
                        this.foundation.setSelectedIndex(index);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCList.attachTo = function(root) {
                    return new MDCList(root);
                };
                MDCList.prototype.initialSyncWithDOM = function() {
                    this.isEvolutionEnabled = constants_1.evolutionAttribute in this.root.dataset;
                    if (this.isEvolutionEnabled) this.classNameMap = constants_1.evolutionClassNameMap;
                    else if (ponyfill_1.matches(this.root, constants_1.strings.DEPRECATED_SELECTOR)) this.classNameMap = constants_1.deprecatedClassNameMap;
                    else this.classNameMap = Object.values(constants_1.cssClasses).reduce(function(obj, className) {
                        obj[className] = className;
                        return obj;
                    }, {});
                    this.handleClick = this.handleClickEvent.bind(this);
                    this.handleKeydown = this.handleKeydownEvent.bind(this);
                    this.focusInEventListener = this.handleFocusInEvent.bind(this);
                    this.focusOutEventListener = this.handleFocusOutEvent.bind(this);
                    this.listen("keydown", this.handleKeydown);
                    this.listen("click", this.handleClick);
                    this.listen("focusin", this.focusInEventListener);
                    this.listen("focusout", this.focusOutEventListener);
                    this.layout();
                    this.initializeListType();
                    this.ensureFocusable();
                };
                MDCList.prototype.destroy = function() {
                    this.unlisten("keydown", this.handleKeydown);
                    this.unlisten("click", this.handleClick);
                    this.unlisten("focusin", this.focusInEventListener);
                    this.unlisten("focusout", this.focusOutEventListener);
                };
                MDCList.prototype.layout = function() {
                    var direction = this.root.getAttribute(constants_1.strings.ARIA_ORIENTATION);
                    this.vertical = direction !== constants_1.strings.ARIA_ORIENTATION_HORIZONTAL;
                    var itemSelector = "." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + ":not([tabindex])";
                    var childSelector = constants_1.strings.FOCUSABLE_CHILD_ELEMENTS;
                    // List items need to have at least tabindex=-1 to be focusable.
                    var itemEls = this.root.querySelectorAll(itemSelector);
                    if (itemEls.length) Array.prototype.forEach.call(itemEls, function(el) {
                        el.setAttribute("tabindex", "-1");
                    });
                    // Child button/a elements are not tabbable until the list item is focused.
                    var focusableChildEls = this.root.querySelectorAll(childSelector);
                    if (focusableChildEls.length) Array.prototype.forEach.call(focusableChildEls, function(el) {
                        el.setAttribute("tabindex", "-1");
                    });
                    if (this.isEvolutionEnabled) this.foundation.setUseSelectedAttribute(true);
                    this.foundation.layout();
                };
                /**
     * Extracts the primary text from a list item.
     * @param item The list item element.
     * @return The primary text in the element.
     */ MDCList.prototype.getPrimaryText = function(item) {
                    var _a;
                    var primaryText = item.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS]);
                    if (this.isEvolutionEnabled || primaryText) return (_a = primaryText === null || primaryText === void 0 ? void 0 : primaryText.textContent) !== null && _a !== void 0 ? _a : "";
                    var singleLineText = item.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_TEXT_CLASS]);
                    return singleLineText && singleLineText.textContent || "";
                };
                /**
     * Initialize selectedIndex value based on pre-selected list items.
     */ MDCList.prototype.initializeListType = function() {
                    var _this = this;
                    this.isInteractive = ponyfill_1.matches(this.root, constants_1.strings.ARIA_INTERACTIVE_ROLES_SELECTOR);
                    if (this.isEvolutionEnabled && this.isInteractive) {
                        var selection = Array.from(this.root.querySelectorAll(constants_1.strings.SELECTED_ITEM_SELECTOR), function(listItem) {
                            return _this.listElements.indexOf(listItem);
                        });
                        if (ponyfill_1.matches(this.root, constants_1.strings.ARIA_MULTI_SELECTABLE_SELECTOR)) this.selectedIndex = selection;
                        else if (selection.length > 0) this.selectedIndex = selection[0];
                        return;
                    }
                    var checkboxListItems = this.root.querySelectorAll(constants_1.strings.ARIA_ROLE_CHECKBOX_SELECTOR);
                    var radioSelectedListItem = this.root.querySelector(constants_1.strings.ARIA_CHECKED_RADIO_SELECTOR);
                    if (checkboxListItems.length) {
                        var preselectedItems = this.root.querySelectorAll(constants_1.strings.ARIA_CHECKED_CHECKBOX_SELECTOR);
                        this.selectedIndex = Array.from(preselectedItems, function(listItem) {
                            return _this.listElements.indexOf(listItem);
                        });
                    } else if (radioSelectedListItem) this.selectedIndex = this.listElements.indexOf(radioSelectedListItem);
                };
                /**
     * Updates the list item at itemIndex to the desired isEnabled state.
     * @param itemIndex Index of the list item
     * @param isEnabled Sets the list item to enabled or disabled.
     */ MDCList.prototype.setEnabled = function(itemIndex, isEnabled) {
                    this.foundation.setEnabled(itemIndex, isEnabled);
                };
                /**
     * Given the next desired character from the user, adds it to the typeahead
     * buffer. Then, attempts to find the next option matching the buffer. Wraps
     * around if at the end of options.
     *
     * @param nextChar The next character to add to the prefix buffer.
     * @param startingIndex The index from which to start matching. Defaults to
     *     the currently focused index.
     * @return The index of the matched item.
     */ MDCList.prototype.typeaheadMatchItem = function(nextChar, startingIndex) {
                    return this.foundation.typeaheadMatchItem(nextChar, startingIndex, /** skipFocus */ true);
                };
                MDCList.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take
                    // a Partial<MDCFooAdapter>. To ensure we don't accidentally omit any
                    // methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClassForElementIndex: function addClassForElementIndex(index, className) {
                            var element = _this.listElements[index];
                            if (element) element.classList.add(_this.classNameMap[className]);
                        },
                        focusItemAtIndex: function focusItemAtIndex(index) {
                            var element = _this.listElements[index];
                            if (element) element.focus();
                        },
                        getAttributeForElementIndex: function getAttributeForElementIndex(index, attr) {
                            return _this.listElements[index].getAttribute(attr);
                        },
                        getFocusedElementIndex: function getFocusedElementIndex() {
                            return _this.listElements.indexOf(document.activeElement);
                        },
                        getListItemCount: function getListItemCount() {
                            return _this.listElements.length;
                        },
                        getPrimaryTextAtIndex: function getPrimaryTextAtIndex(index) {
                            return _this.getPrimaryText(_this.listElements[index]);
                        },
                        hasCheckboxAtIndex: function hasCheckboxAtIndex(index) {
                            var listItem = _this.listElements[index];
                            return !!listItem.querySelector(constants_1.strings.CHECKBOX_SELECTOR);
                        },
                        hasRadioAtIndex: function hasRadioAtIndex(index) {
                            var listItem = _this.listElements[index];
                            return !!listItem.querySelector(constants_1.strings.RADIO_SELECTOR);
                        },
                        isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex(index) {
                            var listItem = _this.listElements[index];
                            var toggleEl = listItem.querySelector(constants_1.strings.CHECKBOX_SELECTOR + ", " + constants_1.strings.RADIO_SELECTOR);
                            return toggleEl.checked;
                        },
                        isFocusInsideList: function isFocusInsideList() {
                            return _this.root !== document.activeElement && _this.root.contains(document.activeElement);
                        },
                        isRootFocused: function isRootFocused() {
                            return document.activeElement === _this.root;
                        },
                        listItemAtIndexHasClass: function listItemAtIndexHasClass(index, className) {
                            return _this.listElements[index].classList.contains(_this.classNameMap[className]);
                        },
                        notifyAction: function notifyAction(index) {
                            _this.emit(constants_1.strings.ACTION_EVENT, {
                                index: index
                            }, /** shouldBubble */ true);
                        },
                        removeClassForElementIndex: function removeClassForElementIndex(index, className) {
                            var element = _this.listElements[index];
                            if (element) element.classList.remove(_this.classNameMap[className]);
                        },
                        setAttributeForElementIndex: function setAttributeForElementIndex(index, attr, value) {
                            var element = _this.listElements[index];
                            if (element) element.setAttribute(attr, value);
                        },
                        setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex(index) {
                            var listItem = _this.listElements[index];
                            var toggleEl = listItem.querySelector(constants_1.strings.CHECKBOX_RADIO_SELECTOR);
                            var event = document.createEvent("Event");
                            event.initEvent("change", true, true);
                            toggleEl.dispatchEvent(event);
                        },
                        setTabIndexForListItemChildren: function setTabIndexForListItemChildren(listItemIndex, tabIndexValue) {
                            var element = _this.listElements[listItemIndex];
                            var selector = constants_1.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX;
                            Array.prototype.forEach.call(element.querySelectorAll(selector), function(el) {
                                el.setAttribute("tabindex", tabIndexValue);
                            });
                        }
                    };
                    return new foundation_1.MDCListFoundation(adapter);
                };
                /**
     * Ensures that at least one item is focusable if the list is interactive and
     * doesn't specify a suitable tabindex.
     */ MDCList.prototype.ensureFocusable = function() {
                    if (this.isEvolutionEnabled && this.isInteractive) {
                        if (!this.root.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + '[tabindex="0"]')) {
                            var index = this.initialFocusIndex();
                            if (index !== -1) this.listElements[index].tabIndex = 0;
                        }
                    }
                };
                MDCList.prototype.initialFocusIndex = function() {
                    if (this.selectedIndex instanceof Array && this.selectedIndex.length > 0) return this.selectedIndex[0];
                    if (typeof this.selectedIndex === "number" && this.selectedIndex !== constants_1.numbers.UNSET_INDEX) return this.selectedIndex;
                    var el = this.root.querySelector("." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + ":not(." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS] + ")");
                    if (el === null) return -1;
                    return this.getListItemIndex(el);
                };
                /**
     * Used to figure out which list item this event is targetting. Or returns -1
     * if there is no list item
     */ MDCList.prototype.getListItemIndex = function(el) {
                    var nearestParent = ponyfill_1.closest(el, "." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS] + ", ." + this.classNameMap[constants_1.cssClasses.ROOT]);
                    // Get the index of the element if it is a list item.
                    if (nearestParent && ponyfill_1.matches(nearestParent, "." + this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS])) return this.listElements.indexOf(nearestParent);
                    return -1;
                };
                /**
     * Used to figure out which element was clicked before sending the event to
     * the foundation.
     */ MDCList.prototype.handleFocusInEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    this.foundation.handleFocusIn(evt, index);
                };
                /**
     * Used to figure out which element was clicked before sending the event to
     * the foundation.
     */ MDCList.prototype.handleFocusOutEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    this.foundation.handleFocusOut(evt, index);
                };
                /**
     * Used to figure out which element was focused when keydown event occurred
     * before sending the event to the foundation.
     */ MDCList.prototype.handleKeydownEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    var target = evt.target;
                    this.foundation.handleKeydown(evt, target.classList.contains(this.classNameMap[constants_1.cssClasses.LIST_ITEM_CLASS]), index);
                };
                /**
     * Used to figure out which element was clicked before sending the event to
     * the foundation.
     */ MDCList.prototype.handleClickEvent = function(evt) {
                    var index = this.getListItemIndex(evt.target);
                    var target = evt.target;
                    // Toggle the checkbox only if it's not the target of the event, or the
                    // checkbox will have 2 change events.
                    var toggleCheckbox = !ponyfill_1.matches(target, constants_1.strings.CHECKBOX_RADIO_SELECTOR);
                    this.foundation.handleClick(index, toggleCheckbox);
                };
                return MDCList;
            }(component_1.MDCComponent);
            exports.MDCList = MDCList;
        /***/ },
        /***/ "./packages/mdc-list/constants.ts": /*!****************************************!*\
  !*** ./packages/mdc-list/constants.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var _a, _b;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.evolutionClassNameMap = exports.evolutionAttribute = exports.deprecatedClassNameMap = exports.numbers = exports.cssClasses = exports.strings = void 0;
            var cssClasses = {
                LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
                LIST_ITEM_CLASS: "mdc-list-item",
                LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
                LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
                LIST_ITEM_TEXT_CLASS: "mdc-list-item__text",
                LIST_ITEM_PRIMARY_TEXT_CLASS: "mdc-list-item__primary-text",
                ROOT: "mdc-list"
            };
            exports.cssClasses = cssClasses;
            var evolutionClassNameMap = (_a = {}, _a["" + cssClasses.LIST_ITEM_ACTIVATED_CLASS] = "mdc-list-item--activated", _a["" + cssClasses.LIST_ITEM_CLASS] = "mdc-list-item", _a["" + cssClasses.LIST_ITEM_DISABLED_CLASS] = "mdc-list-item--disabled", _a["" + cssClasses.LIST_ITEM_SELECTED_CLASS] = "mdc-list-item--selected", _a["" + cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-list-item__primary-text", _a["" + cssClasses.ROOT] = "mdc-list", _a);
            exports.evolutionClassNameMap = evolutionClassNameMap;
            var deprecatedClassNameMap = (_b = {}, _b["" + cssClasses.LIST_ITEM_ACTIVATED_CLASS] = "mdc-deprecated-list-item--activated", _b["" + cssClasses.LIST_ITEM_CLASS] = "mdc-deprecated-list-item", _b["" + cssClasses.LIST_ITEM_DISABLED_CLASS] = "mdc-deprecated-list-item--disabled", _b["" + cssClasses.LIST_ITEM_SELECTED_CLASS] = "mdc-deprecated-list-item--selected", _b["" + cssClasses.LIST_ITEM_TEXT_CLASS] = "mdc-deprecated-list-item__text", _b["" + cssClasses.LIST_ITEM_PRIMARY_TEXT_CLASS] = "mdc-deprecated-list-item__primary-text", _b["" + cssClasses.ROOT] = "mdc-deprecated-list", _b);
            exports.deprecatedClassNameMap = deprecatedClassNameMap;
            var strings = {
                ACTION_EVENT: "MDCList:action",
                ARIA_CHECKED: "aria-checked",
                ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
                ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
                ARIA_CURRENT: "aria-current",
                ARIA_DISABLED: "aria-disabled",
                ARIA_ORIENTATION: "aria-orientation",
                ARIA_ORIENTATION_HORIZONTAL: "horizontal",
                ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
                ARIA_SELECTED: "aria-selected",
                ARIA_INTERACTIVE_ROLES_SELECTOR: '[role="listbox"], [role="menu"]',
                ARIA_MULTI_SELECTABLE_SELECTOR: '[aria-multiselectable="true"]',
                CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"], input[type="radio"]',
                CHECKBOX_SELECTOR: 'input[type="checkbox"]',
                CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + cssClasses.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + cssClasses.LIST_ITEM_CLASS + " a,\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " a\n  ",
                DEPRECATED_SELECTOR: ".mdc-deprecated-list",
                FOCUSABLE_CHILD_ELEMENTS: "\n    ." + cssClasses.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + cssClasses.LIST_ITEM_CLASS + " a,\n    ." + cssClasses.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + cssClasses.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled),\n    .' + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + " a,\n    ." + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + ' input[type="radio"]:not(:disabled),\n    .' + deprecatedClassNameMap[cssClasses.LIST_ITEM_CLASS] + ' input[type="checkbox"]:not(:disabled)\n  ',
                RADIO_SELECTOR: 'input[type="radio"]',
                SELECTED_ITEM_SELECTOR: '[aria-selected="true"], [aria-current="true"]'
            };
            exports.strings = strings;
            var numbers = {
                UNSET_INDEX: -1,
                TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS: 300
            };
            exports.numbers = numbers;
            var evolutionAttribute = "evolution";
            exports.evolutionAttribute = evolutionAttribute;
        /***/ },
        /***/ "./packages/mdc-list/custom-element.js": /*!*********************************************!*\
  !*** ./packages/mdc-list/custom-element.js ***!
  \*********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-list/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _material_ripple_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_material_ripple_component__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcList = function(_HTMLElement) {
                _inherits(MdcList, _HTMLElement);
                _createClass(MdcList, [
                    {
                        key: "focus",
                        value: function focus() {
                            var selectedIndex = this.list_.foundation.getSelectedIndex();
                            if (typeof selectedIndex !== "number") selectedIndex = selectedIndex.length > 0 ? selectedIndex[0] : -1;
                            if (0 <= selectedIndex && selectedIndex < this.list_.listElements.length) this.list_.listElements[selectedIndex].focus();
                            else if (this.list_.listElements.length > 0) this.list_.listElements[0].focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    },
                    {
                        key: "selectedIndex",
                        get: function get() {
                            return this.selectedIndex_;
                        },
                        set: function set(selectedIndex) {
                            var previousSelectedIndex = this.selectedIndex_;
                            this.selectedIndex_ = selectedIndex;
                            if (this.list_) {
                                this.list_.selectedIndex = selectedIndex;
                                var previousIndex = previousSelectedIndex.length > 0 ? previousSelectedIndex[0] : -1;
                                if (previousIndex !== -1 && this.list_.listElements[previousIndex]) this.list_.listElements[previousIndex].setAttribute("tabindex", "-1");
                                if (selectedIndex.length > 0 && this.list_.listElements.length > selectedIndex[0]) this.list_.listElements[selectedIndex[0]].setAttribute("tabindex", "0");
                                else if (this.list_.listElements.length > 0) this.list_.listElements[0].setAttribute("tabindex", "0");
                            }
                        }
                    },
                    {
                        key: "vertical",
                        get: function get() {
                            return this.vertical_;
                        },
                        set: function set(vertical) {
                            this.vertical_ = vertical;
                            if (this.list_) this.list_.vertical = vertical;
                        }
                    },
                    {
                        key: "wrapFocus",
                        get: function get() {
                            return this.wrapFocus_;
                        },
                        set: function set(wrapFocus) {
                            this.wrapFocus_ = wrapFocus;
                            if (this.list_) this.list_.wrapFocus = wrapFocus;
                        }
                    },
                    {
                        key: "interactive",
                        get: function get() {
                            return this.interactive_;
                        },
                        set: function set(interactive) {
                            var oldInteractive = this.interactive_;
                            this.interactive_ = interactive;
                            if (oldInteractive !== interactive && this.init_) {
                                if (this.interactive_) this.initInteractive();
                                else this.deinitInteractive();
                            }
                        }
                    }
                ]);
                function MdcList() {
                    _classCallCheck(this, MdcList);
                    var _this = _possibleConstructorReturn(this, (MdcList.__proto__ || Object.getPrototypeOf(MdcList)).call(this));
                    _this.init_ = false;
                    _this.selectedIndex_ = -1;
                    _this.wrapFocus_ = false;
                    _this.vertical_ = true;
                    _this.interactive_ = false;
                    _this.list_;
                    return _this;
                }
                _createClass(MdcList, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            this.style.display = "block";
                            this.style.pointerEvents = "none";
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this);
                            if (this.interactive_) this.initInteractive();
                        }
                    },
                    {
                        key: "initInteractive",
                        value: function initInteractive() {
                            if (this.list_) return;
                            this.style.pointerEvents = "auto";
                            this.list_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCList"](this);
                            this.list_.selectedIndex = this.selectedIndex_;
                            this.list_.vertical = this.vertical_;
                            this.list_.wrapFocus = this.wrapFocus_;
                            var firstSelectedListItem = this.querySelector(".mdc-deprecated-list-item--selected, .mdc-deprecated-list-item--activated");
                            if (firstSelectedListItem) firstSelectedListItem.setAttribute("tabindex", 0);
                            else {
                                var firstListItem = this.querySelector(".mdc-deprecated-list-item");
                                if (firstListItem) firstListItem.setAttribute("tabindex", 0);
                            }
                        }
                    },
                    {
                        key: "deinitInteractive",
                        value: function deinitInteractive() {
                            if (!this.list_) return;
                            this.style.pointerEvents = "none";
                            this.list_.destroy();
                            delete this.list_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.deinitInteractive();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcList;
            }(HTMLElement);
            customElements.define("mdc-list", MdcList);
            var MdcListItem = function(_HTMLElement2) {
                _inherits(MdcListItem, _HTMLElement2);
                function MdcListItem() {
                    _classCallCheck(this, MdcListItem);
                    var _this2 = _possibleConstructorReturn(this, (MdcListItem.__proto__ || Object.getPrototypeOf(MdcListItem)).call(this));
                    _this2.ripples_ = false;
                    _this2.init_ = false;
                    _this2.ripple_;
                    return _this2;
                }
                _createClass(MdcListItem, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["installClassNameChangeHook"].call(this.listItemElement);
                            if (this.ripples_) this.initRipple();
                        }
                    },
                    {
                        key: "initRipple",
                        value: function initRipple() {
                            if (this.ripple_) return;
                            this.ripple_ = new _material_ripple_component__WEBPACK_IMPORTED_MODULE_1__["MDCRipple"](this.listItemElement);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.deinitRipple();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_2__["uninstallClassNameChangeHook"].call(this.listItemElement);
                        }
                    },
                    {
                        key: "deinitRipple",
                        value: function deinitRipple() {
                            if (!this.ripple_) return;
                            this.ripple_.destroy();
                            delete this.ripple_;
                        }
                    },
                    {
                        key: "ripples",
                        set: function set(ripples) {
                            var oldRipples = this.ripples_;
                            this.ripples_ = ripples;
                            if (oldRipples !== this.ripples_ && this.init_) {
                                if (this.ripples_) this.initRipple();
                                else this.dinitRipple();
                            }
                        },
                        get: function get() {
                            return this.ripples_;
                        }
                    },
                    {
                        key: "listItemElement",
                        get: function get() {
                            return this.classList.contains("mdc-deprecated-list-item") ? this : this.querySelector(".mdc-deprecated-list-item");
                        }
                    }
                ]);
                return MdcListItem;
            }(HTMLElement);
            customElements.define("mdc-list-item", MdcListItem);
        /***/ },
        /***/ "./packages/mdc-list/events.ts": /*!*************************************!*\
  !*** ./packages/mdc-list/events.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.preventDefaultEvent = void 0;
            var ELEMENTS_KEY_ALLOWED_IN = [
                "input",
                "button",
                "textarea",
                "select"
            ];
            /**
 * Ensures that preventDefault is only called if the containing element
 * doesn't consume the event, and it will cause an unintended scroll.
 *
 * @param evt keyboard event to be prevented.
 */ var preventDefaultEvent = function preventDefaultEvent(evt) {
                var target = evt.target;
                if (!target) return;
                var tagName = ("" + target.tagName).toLowerCase();
                if (ELEMENTS_KEY_ALLOWED_IN.indexOf(tagName) === -1) evt.preventDefault();
            };
            exports.preventDefaultEvent = preventDefaultEvent;
        /***/ },
        /***/ "./packages/mdc-list/foundation.ts": /*!*****************************************!*\
  !*** ./packages/mdc-list/foundation.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCListFoundation = void 0;
            // TODO(b/152410470): Remove trailing underscores from private properties
            // tslint:disable:strip-private-property-underscore
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-list/constants.ts");
            var events_1 = __webpack_require__(/*! ./events */ "./packages/mdc-list/events.ts");
            var typeahead = __importStar(__webpack_require__(/*! ./typeahead */ "./packages/mdc-list/typeahead.ts"));
            function isNumberArray(selectedIndex) {
                return selectedIndex instanceof Array;
            }
            var MDCListFoundation = /** @class */ function(_super) {
                __extends(MDCListFoundation, _super);
                function MDCListFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCListFoundation.defaultAdapter), adapter)) || this;
                    _this.wrapFocus_ = false;
                    _this.isVertical_ = true;
                    _this.isSingleSelectionList_ = false;
                    _this.selectedIndex_ = constants_1.numbers.UNSET_INDEX;
                    _this.focusedItemIndex = constants_1.numbers.UNSET_INDEX;
                    _this.useSelectedAttr_ = false;
                    _this.ariaCurrentAttrValue_ = null;
                    _this.isCheckboxList_ = false;
                    _this.isRadioList_ = false;
                    _this.hasTypeahead = false;
                    // Transiently holds current typeahead prefix from user.
                    _this.typeaheadState = typeahead.initState();
                    _this.sortedIndexByFirstChar = new Map();
                    return _this;
                }
                Object.defineProperty(MDCListFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCListFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCListFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCListFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClassForElementIndex: function addClassForElementIndex() {
                                return undefined;
                            },
                            focusItemAtIndex: function focusItemAtIndex() {
                                return undefined;
                            },
                            getAttributeForElementIndex: function getAttributeForElementIndex() {
                                return null;
                            },
                            getFocusedElementIndex: function getFocusedElementIndex() {
                                return 0;
                            },
                            getListItemCount: function getListItemCount() {
                                return 0;
                            },
                            hasCheckboxAtIndex: function hasCheckboxAtIndex() {
                                return false;
                            },
                            hasRadioAtIndex: function hasRadioAtIndex() {
                                return false;
                            },
                            isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex() {
                                return false;
                            },
                            isFocusInsideList: function isFocusInsideList() {
                                return false;
                            },
                            isRootFocused: function isRootFocused() {
                                return false;
                            },
                            listItemAtIndexHasClass: function listItemAtIndexHasClass() {
                                return false;
                            },
                            notifyAction: function notifyAction() {
                                return undefined;
                            },
                            removeClassForElementIndex: function removeClassForElementIndex() {
                                return undefined;
                            },
                            setAttributeForElementIndex: function setAttributeForElementIndex() {
                                return undefined;
                            },
                            setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex() {
                                return undefined;
                            },
                            setTabIndexForListItemChildren: function setTabIndexForListItemChildren() {
                                return undefined;
                            },
                            getPrimaryTextAtIndex: function getPrimaryTextAtIndex() {
                                return "";
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCListFoundation.prototype.layout = function() {
                    if (this.adapter.getListItemCount() === 0) return;
                    // TODO(b/172274142): consider all items when determining the list's type.
                    if (this.adapter.hasCheckboxAtIndex(0)) this.isCheckboxList_ = true;
                    else if (this.adapter.hasRadioAtIndex(0)) this.isRadioList_ = true;
                    else this.maybeInitializeSingleSelection();
                    if (this.hasTypeahead) this.sortedIndexByFirstChar = this.typeaheadInitSortedIndex();
                };
                /**
     * Sets the private wrapFocus_ variable.
     */ MDCListFoundation.prototype.setWrapFocus = function(value) {
                    this.wrapFocus_ = value;
                };
                /**
     * Sets the isVertical_ private variable.
     */ MDCListFoundation.prototype.setVerticalOrientation = function(value) {
                    this.isVertical_ = value;
                };
                /**
     * Sets the isSingleSelectionList_ private variable.
     */ MDCListFoundation.prototype.setSingleSelection = function(value) {
                    this.isSingleSelectionList_ = value;
                    if (value) this.maybeInitializeSingleSelection();
                };
                /**
     * Automatically determines whether the list is single selection list. If so,
     * initializes the internal state to match the selected item.
     */ MDCListFoundation.prototype.maybeInitializeSingleSelection = function() {
                    var listItemsCount = this.adapter.getListItemCount();
                    for(var i = 0; i < listItemsCount; i++){
                        var hasSelectedClass = this.adapter.listItemAtIndexHasClass(i, constants_1.cssClasses.LIST_ITEM_SELECTED_CLASS);
                        var hasActivatedClass = this.adapter.listItemAtIndexHasClass(i, constants_1.cssClasses.LIST_ITEM_ACTIVATED_CLASS);
                        if (!(hasSelectedClass || hasActivatedClass)) continue;
                        this.isSingleSelectionList_ = true;
                        this.selectedIndex_ = i;
                        return;
                    }
                };
                /**
     * Sets whether typeahead is enabled on the list.
     * @param hasTypeahead Whether typeahead is enabled.
     */ MDCListFoundation.prototype.setHasTypeahead = function(hasTypeahead) {
                    this.hasTypeahead = hasTypeahead;
                    if (hasTypeahead) this.sortedIndexByFirstChar = this.typeaheadInitSortedIndex();
                };
                /**
     * @return Whether typeahead is currently matching a user-specified prefix.
     */ MDCListFoundation.prototype.isTypeaheadInProgress = function() {
                    return this.hasTypeahead && typeahead.isTypingInProgress(this.typeaheadState);
                };
                /**
     * Sets the useSelectedAttr_ private variable.
     */ MDCListFoundation.prototype.setUseSelectedAttribute = function(useSelected) {
                    this.useSelectedAttr_ = useSelected;
                };
                MDCListFoundation.prototype.getSelectedIndex = function() {
                    return this.selectedIndex_;
                };
                MDCListFoundation.prototype.setSelectedIndex = function(index) {
                    if (!this.isIndexValid_(index)) return;
                    if (this.isCheckboxList_) this.setCheckboxAtIndex_(index);
                    else if (this.isRadioList_) this.setCheckboxAtIndex_(index);
                    else this.setSingleSelectionAtIndex_(index);
                };
                /**
     * Focus in handler for the list items.
     */ MDCListFoundation.prototype.handleFocusIn = function(_, listItemIndex) {
                    if (listItemIndex >= 0) {
                        this.focusedItemIndex = listItemIndex;
                        this.adapter.setAttributeForElementIndex(listItemIndex, "tabindex", "0");
                        this.adapter.setTabIndexForListItemChildren(listItemIndex, "0");
                    }
                };
                /**
     * Focus out handler for the list items.
     */ MDCListFoundation.prototype.handleFocusOut = function(_, listItemIndex) {
                    var _this = this;
                    if (listItemIndex >= 0) {
                        this.adapter.setAttributeForElementIndex(listItemIndex, "tabindex", "-1");
                        this.adapter.setTabIndexForListItemChildren(listItemIndex, "-1");
                    }
                    /**
         * Between Focusout & Focusin some browsers do not have focus on any
         * element. Setting a delay to wait till the focus is moved to next element.
         */ setTimeout(function() {
                        if (!_this.adapter.isFocusInsideList()) _this.setTabindexToFirstSelectedOrFocusedItem();
                    }, 0);
                };
                /**
     * Key handler for the list.
     */ MDCListFoundation.prototype.handleKeydown = function(event, isRootListItem, listItemIndex) {
                    var _this = this;
                    var isArrowLeft = keyboard_1.normalizeKey(event) === "ArrowLeft";
                    var isArrowUp = keyboard_1.normalizeKey(event) === "ArrowUp";
                    var isArrowRight = keyboard_1.normalizeKey(event) === "ArrowRight";
                    var isArrowDown = keyboard_1.normalizeKey(event) === "ArrowDown";
                    var isHome = keyboard_1.normalizeKey(event) === "Home";
                    var isEnd = keyboard_1.normalizeKey(event) === "End";
                    var isEnter = keyboard_1.normalizeKey(event) === "Enter";
                    var isSpace = keyboard_1.normalizeKey(event) === "Spacebar";
                    // Have to check both upper and lower case, because having caps lock on affects the value.
                    var isLetterA = event.key === "A" || event.key === "a";
                    if (this.adapter.isRootFocused()) {
                        if (isArrowUp || isEnd) {
                            event.preventDefault();
                            this.focusLastElement();
                        } else if (isArrowDown || isHome) {
                            event.preventDefault();
                            this.focusFirstElement();
                        }
                        if (this.hasTypeahead) {
                            var handleKeydownOpts = {
                                event: event,
                                focusItemAtIndex: function focusItemAtIndex(index) {
                                    _this.focusItemAtIndex(index);
                                },
                                focusedItemIndex: -1,
                                isTargetListItem: isRootListItem,
                                sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                                isItemAtIndexDisabled: function isItemAtIndexDisabled(index) {
                                    return _this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                                }
                            };
                            typeahead.handleKeydown(handleKeydownOpts, this.typeaheadState);
                        }
                        return;
                    }
                    var currentIndex = this.adapter.getFocusedElementIndex();
                    if (currentIndex === -1) {
                        currentIndex = listItemIndex;
                        if (currentIndex < 0) // If this event doesn't have a mdc-list-item ancestor from the
                        // current list (not from a sublist), return early.
                        return;
                    }
                    if (this.isVertical_ && isArrowDown || !this.isVertical_ && isArrowRight) {
                        events_1.preventDefaultEvent(event);
                        this.focusNextElement(currentIndex);
                    } else if (this.isVertical_ && isArrowUp || !this.isVertical_ && isArrowLeft) {
                        events_1.preventDefaultEvent(event);
                        this.focusPrevElement(currentIndex);
                    } else if (isHome) {
                        events_1.preventDefaultEvent(event);
                        this.focusFirstElement();
                    } else if (isEnd) {
                        events_1.preventDefaultEvent(event);
                        this.focusLastElement();
                    } else if (isLetterA && event.ctrlKey && this.isCheckboxList_) {
                        event.preventDefault();
                        this.toggleAll(this.selectedIndex_ === constants_1.numbers.UNSET_INDEX ? [] : this.selectedIndex_);
                    } else if (isEnter || isSpace) {
                        if (isRootListItem) {
                            // Return early if enter key is pressed on anchor element which triggers
                            // synthetic MouseEvent event.
                            var target = event.target;
                            if (target && target.tagName === "A" && isEnter) return;
                            events_1.preventDefaultEvent(event);
                            if (this.adapter.listItemAtIndexHasClass(currentIndex, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS)) return;
                            if (!this.isTypeaheadInProgress()) {
                                if (this.isSelectableList_()) this.setSelectedIndexOnAction_(currentIndex);
                                this.adapter.notifyAction(currentIndex);
                            }
                        }
                    }
                    if (this.hasTypeahead) {
                        var handleKeydownOpts = {
                            event: event,
                            focusItemAtIndex: function focusItemAtIndex(index) {
                                _this.focusItemAtIndex(index);
                            },
                            focusedItemIndex: this.focusedItemIndex,
                            isTargetListItem: isRootListItem,
                            sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                            isItemAtIndexDisabled: function isItemAtIndexDisabled(index) {
                                return _this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                            }
                        };
                        typeahead.handleKeydown(handleKeydownOpts, this.typeaheadState);
                    }
                };
                /**
     * Click handler for the list.
     */ MDCListFoundation.prototype.handleClick = function(index, toggleCheckbox) {
                    if (index === constants_1.numbers.UNSET_INDEX) return;
                    if (this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS)) return;
                    if (this.isSelectableList_()) this.setSelectedIndexOnAction_(index, toggleCheckbox);
                    this.adapter.notifyAction(index);
                };
                /**
     * Focuses the next element on the list.
     */ MDCListFoundation.prototype.focusNextElement = function(index) {
                    var count = this.adapter.getListItemCount();
                    var nextIndex = index + 1;
                    if (nextIndex >= count) {
                        if (this.wrapFocus_) nextIndex = 0;
                        else // Return early because last item is already focused.
                        return index;
                    }
                    this.focusItemAtIndex(nextIndex);
                    return nextIndex;
                };
                /**
     * Focuses the previous element on the list.
     */ MDCListFoundation.prototype.focusPrevElement = function(index) {
                    var prevIndex = index - 1;
                    if (prevIndex < 0) {
                        if (this.wrapFocus_) prevIndex = this.adapter.getListItemCount() - 1;
                        else // Return early because first item is already focused.
                        return index;
                    }
                    this.focusItemAtIndex(prevIndex);
                    return prevIndex;
                };
                MDCListFoundation.prototype.focusFirstElement = function() {
                    this.focusItemAtIndex(0);
                    return 0;
                };
                MDCListFoundation.prototype.focusLastElement = function() {
                    var lastIndex = this.adapter.getListItemCount() - 1;
                    this.focusItemAtIndex(lastIndex);
                    return lastIndex;
                };
                MDCListFoundation.prototype.focusInitialElement = function() {
                    var initialIndex = this.getFirstSelectedOrFocusedItemIndex();
                    this.focusItemAtIndex(initialIndex);
                    return initialIndex;
                };
                /**
     * @param itemIndex Index of the list item
     * @param isEnabled Sets the list item to enabled or disabled.
     */ MDCListFoundation.prototype.setEnabled = function(itemIndex, isEnabled) {
                    if (!this.isIndexValid_(itemIndex)) return;
                    if (isEnabled) this.adapter.setAttributeForElementIndex(itemIndex, constants_1.strings.ARIA_DISABLED, "false");
                    else this.adapter.setAttributeForElementIndex(itemIndex, constants_1.strings.ARIA_DISABLED, "true");
                };
                MDCListFoundation.prototype.setSingleSelectionAtIndex_ = function(index) {
                    if (Array.isArray(index)) index = index.length > 0 ? index[0] : -1;
                    if (this.selectedIndex_ === index) return;
                    this.setAriaForSingleSelectionAtIndex_(index);
                    this.setTabindexAtIndex(index);
                    this.selectedIndex_ = index;
                };
                /**
     * Sets aria attribute for single selection at given index.
     */ MDCListFoundation.prototype.setAriaForSingleSelectionAtIndex_ = function(index) {
                    // Detect the presence of aria-current and get the value only during list
                    // initialization when it is in unset state.
                    if (this.selectedIndex_ === constants_1.numbers.UNSET_INDEX) this.ariaCurrentAttrValue_ = this.adapter.getAttributeForElementIndex(index, constants_1.strings.ARIA_CURRENT);
                    var isAriaCurrent = this.ariaCurrentAttrValue_ !== null;
                    var ariaAttribute = isAriaCurrent ? constants_1.strings.ARIA_CURRENT : constants_1.strings.ARIA_SELECTED;
                    if (index !== constants_1.numbers.UNSET_INDEX) {
                        var ariaAttributeValue = isAriaCurrent ? this.ariaCurrentAttrValue_ : "true";
                        this.adapter.setAttributeForElementIndex(index, ariaAttribute, ariaAttributeValue);
                    }
                };
                /**
     * Returns the attribute to use for indicating selection status.
     */ MDCListFoundation.prototype.getSelectionAttribute = function() {
                    return this.useSelectedAttr_ ? constants_1.strings.ARIA_SELECTED : constants_1.strings.ARIA_CHECKED;
                };
                MDCListFoundation.prototype.setCheckboxAtIndex_ = function(index) {
                    var selectionAttribute = this.getSelectionAttribute();
                    for(var i = 0; i < this.adapter.getListItemCount(); i++){
                        var isChecked = false;
                        if (index.indexOf(i) >= 0) isChecked = true;
                        this.adapter.setAttributeForElementIndex(i, selectionAttribute, isChecked ? "true" : "false");
                    }
                    this.selectedIndex_ = index;
                };
                MDCListFoundation.prototype.setTabindexAtIndex = function(index) {
                    if (this.focusedItemIndex === constants_1.numbers.UNSET_INDEX && index !== 0) // If some list item was selected set first list item's tabindex to -1.
                    // Generally, tabindex is set to 0 on first list item of list that has no
                    // preselected items.
                    this.adapter.setAttributeForElementIndex(0, "tabindex", "-1");
                    else if (this.focusedItemIndex >= 0 && this.focusedItemIndex !== index) this.adapter.setAttributeForElementIndex(this.focusedItemIndex, "tabindex", "-1");
                    // Set the previous selection's tabindex to -1. We need this because
                    // in selection menus that are not visible, programmatically setting an
                    // option will not change focus but will change where tabindex should be 0.
                    if (!(this.selectedIndex_ instanceof Array) && this.selectedIndex_ !== index) this.adapter.setAttributeForElementIndex(this.selectedIndex_, "tabindex", "-1");
                    if (index !== constants_1.numbers.UNSET_INDEX) this.adapter.setAttributeForElementIndex(index, "tabindex", "0");
                };
                /**
     * @return Return true if it is single selectin list, checkbox list or radio
     *     list.
     */ MDCListFoundation.prototype.isSelectableList_ = function() {
                    return this.isSingleSelectionList_ || this.isCheckboxList_ || this.isRadioList_;
                };
                MDCListFoundation.prototype.setTabindexToFirstSelectedOrFocusedItem = function() {
                    var targetIndex = this.getFirstSelectedOrFocusedItemIndex();
                    this.setTabindexAtIndex(targetIndex);
                };
                MDCListFoundation.prototype.getFirstSelectedOrFocusedItemIndex = function() {
                    var targetIndex = this.focusedItemIndex >= 0 ? this.focusedItemIndex : 0;
                    if (this.isSelectableList_()) {
                        if (typeof this.selectedIndex_ === "number" && this.selectedIndex_ !== constants_1.numbers.UNSET_INDEX) targetIndex = this.selectedIndex_;
                        else if (isNumberArray(this.selectedIndex_) && this.selectedIndex_.length > 0) targetIndex = this.selectedIndex_.reduce(function(currentIndex, minIndex) {
                            return Math.min(currentIndex, minIndex);
                        });
                    }
                    return targetIndex;
                };
                MDCListFoundation.prototype.isIndexValid_ = function(index) {
                    var _this = this;
                    if (index instanceof Array) {
                        if (index.length === 0) return true;
                        else return index.some(function(i) {
                            return _this.isIndexInRange_(i);
                        });
                    } else return false;
                };
                MDCListFoundation.prototype.isIndexInRange_ = function(index) {
                    var listSize = this.adapter.getListItemCount();
                    return index >= 0 && index < listSize;
                };
                /**
     * Sets selected index on user action, toggles checkbox / radio based on
     * toggleCheckbox value. User interaction should not toggle list item(s) when
     * disabled.
     */ MDCListFoundation.prototype.setSelectedIndexOnAction_ = function(index, toggleCheckbox) {
                    if (toggleCheckbox === void 0) toggleCheckbox = true;
                    if (this.isCheckboxList_ || this.isRadioList_) this.toggleCheckboxAtIndex_(index, toggleCheckbox);
                    else this.setSelectedIndex([
                        index
                    ]);
                };
                MDCListFoundation.prototype.toggleCheckboxAtIndex_ = function(index, toggleCheckbox) {
                    var isChecked = this.adapter.isCheckboxCheckedAtIndex(index);
                    if (toggleCheckbox) {
                        isChecked = !isChecked;
                        this.adapter.setCheckedCheckboxOrRadioAtIndex(index, isChecked);
                    }
                };
                MDCListFoundation.prototype.focusItemAtIndex = function(index) {
                    this.adapter.focusItemAtIndex(index);
                    this.focusedItemIndex = index;
                };
                MDCListFoundation.prototype.toggleAll = function(currentlySelectedIndexes) {
                    var count = this.adapter.getListItemCount();
                    // If all items are selected, deselect everything.
                    if (currentlySelectedIndexes.length === count) this.setCheckboxAtIndex_([]);
                    else {
                        // Otherwise select all enabled options.
                        var allIndexes = [];
                        for(var i = 0; i < count; i++)if (!this.adapter.listItemAtIndexHasClass(i, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS) || currentlySelectedIndexes.indexOf(i) > -1) allIndexes.push(i);
                        this.setCheckboxAtIndex_(allIndexes);
                    }
                };
                /**
     * Given the next desired character from the user, adds it to the typeahead
     * buffer. Then, attempts to find the next option matching the buffer. Wraps
     * around if at the end of options.
     *
     * @param nextChar The next character to add to the prefix buffer.
     * @param startingIndex The index from which to start matching. Only relevant
     *     when starting a new match sequence. To start a new match sequence,
     *     clear the buffer using `clearTypeaheadBuffer`, or wait for the buffer
     *     to clear after a set interval defined in list foundation. Defaults to
     *     the currently focused index.
     * @return The index of the matched item, or -1 if no match.
     */ MDCListFoundation.prototype.typeaheadMatchItem = function(nextChar, startingIndex, skipFocus) {
                    var _this = this;
                    if (skipFocus === void 0) skipFocus = false;
                    var opts = {
                        focusItemAtIndex: function focusItemAtIndex(index) {
                            _this.focusItemAtIndex(index);
                        },
                        focusedItemIndex: startingIndex ? startingIndex : this.focusedItemIndex,
                        nextChar: nextChar,
                        sortedIndexByFirstChar: this.sortedIndexByFirstChar,
                        skipFocus: skipFocus,
                        isItemAtIndexDisabled: function isItemAtIndexDisabled(index) {
                            return _this.adapter.listItemAtIndexHasClass(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                        }
                    };
                    return typeahead.matchItem(opts, this.typeaheadState);
                };
                /**
     * Initializes the MDCListTextAndIndex data structure by indexing the current
     * list items by primary text.
     *
     * @return The primary texts of all the list items sorted by first character.
     */ MDCListFoundation.prototype.typeaheadInitSortedIndex = function() {
                    return typeahead.initSortedIndex(this.adapter.getListItemCount(), this.adapter.getPrimaryTextAtIndex);
                };
                /**
     * Clears the typeahead buffer.
     */ MDCListFoundation.prototype.clearTypeaheadBuffer = function() {
                    typeahead.clearBuffer(this.typeaheadState);
                };
                return MDCListFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCListFoundation = MDCListFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCListFoundation;
        /***/ },
        /***/ "./packages/mdc-list/typeahead.ts": /*!****************************************!*\
  !*** ./packages/mdc-list/typeahead.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.handleKeydown = exports.clearBuffer = exports.isTypingInProgress = exports.matchItem = exports.initSortedIndex = exports.initState = void 0;
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-list/constants.ts");
            var events_1 = __webpack_require__(/*! ./events */ "./packages/mdc-list/events.ts");
            /**
 * Initializes a state object for typeahead. Use the same reference for calls to
 * typeahead functions.
 *
 * @return The current state of the typeahead process. Each state reference
 *     represents a typeahead instance as the reference is typically mutated
 *     in-place.
 */ function initState() {
                var state = {
                    bufferClearTimeout: 0,
                    currentFirstChar: "",
                    sortedIndexCursor: 0,
                    typeaheadBuffer: ""
                };
                return state;
            }
            exports.initState = initState;
            /**
 * Initializes typeahead state by indexing the current list items by primary
 * text into the sortedIndexByFirstChar data structure.
 *
 * @param listItemCount numer of items in the list
 * @param getPrimaryTextByItemIndex function that returns the primary text at a
 *     given index
 *
 * @return Map that maps the first character of the primary text to the full
 *     list text and it's index
 */ function initSortedIndex(listItemCount, getPrimaryTextByItemIndex) {
                var sortedIndexByFirstChar = new Map();
                // Aggregate item text to index mapping
                for(var i = 0; i < listItemCount; i++){
                    var primaryText = getPrimaryTextByItemIndex(i).trim();
                    if (!primaryText) continue;
                    var firstChar = primaryText[0].toLowerCase();
                    if (!sortedIndexByFirstChar.has(firstChar)) sortedIndexByFirstChar.set(firstChar, []);
                    sortedIndexByFirstChar.get(firstChar).push({
                        text: primaryText.toLowerCase(),
                        index: i
                    });
                }
                // Sort the mapping
                // TODO(b/157162694): Investigate replacing forEach with Map.values()
                sortedIndexByFirstChar.forEach(function(values) {
                    values.sort(function(first, second) {
                        return first.index - second.index;
                    });
                });
                return sortedIndexByFirstChar;
            }
            exports.initSortedIndex = initSortedIndex;
            /**
 * Given the next desired character from the user, it attempts to find the next
 * list option matching the buffer. Wraps around if at the end of options.
 *
 * @param opts Options and accessors
 *   - nextChar - the next character to match against items
 *   - sortedIndexByFirstChar - output of `initSortedIndex(...)`
 *   - focusedItemIndex - the index of the currently focused item
 *   - focusItemAtIndex - function that focuses a list item at given index
 *   - skipFocus - whether or not to focus the matched item
 *   - isItemAtIndexDisabled - function that determines whether an item at a
 *        given index is disabled
 * @param state The typeahead state instance. See `initState`.
 *
 * @return The index of the matched item, or -1 if no match.
 */ function matchItem(opts, state) {
                var nextChar = opts.nextChar, focusItemAtIndex = opts.focusItemAtIndex, sortedIndexByFirstChar = opts.sortedIndexByFirstChar, focusedItemIndex = opts.focusedItemIndex, skipFocus = opts.skipFocus, isItemAtIndexDisabled = opts.isItemAtIndexDisabled;
                clearTimeout(state.bufferClearTimeout);
                state.bufferClearTimeout = setTimeout(function() {
                    clearBuffer(state);
                }, constants_1.numbers.TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS);
                state.typeaheadBuffer = state.typeaheadBuffer + nextChar;
                var index;
                if (state.typeaheadBuffer.length === 1) index = matchFirstChar(sortedIndexByFirstChar, focusedItemIndex, isItemAtIndexDisabled, state);
                else index = matchAllChars(sortedIndexByFirstChar, isItemAtIndexDisabled, state);
                if (index !== -1 && !skipFocus) focusItemAtIndex(index);
                return index;
            }
            exports.matchItem = matchItem;
            /**
 * Matches the user's single input character in the buffer to the
 * next option that begins with such character. Wraps around if at
 * end of options. Returns -1 if no match is found.
 */ function matchFirstChar(sortedIndexByFirstChar, focusedItemIndex, isItemAtIndexDisabled, state) {
                var firstChar = state.typeaheadBuffer[0];
                var itemsMatchingFirstChar = sortedIndexByFirstChar.get(firstChar);
                if (!itemsMatchingFirstChar) return -1;
                // Has the same firstChar been recently matched?
                // Also, did starting index remain the same between key presses?
                // If both hold true, simply increment index.
                if (firstChar === state.currentFirstChar && itemsMatchingFirstChar[state.sortedIndexCursor].index === focusedItemIndex) {
                    state.sortedIndexCursor = (state.sortedIndexCursor + 1) % itemsMatchingFirstChar.length;
                    var newIndex = itemsMatchingFirstChar[state.sortedIndexCursor].index;
                    if (!isItemAtIndexDisabled(newIndex)) return newIndex;
                }
                // If we're here, it means one of the following happened:
                // - either firstChar or startingIndex has changed, invalidating the
                // cursor.
                // - The next item of typeahead is disabled, so we have to look further.
                state.currentFirstChar = firstChar;
                var newCursorPosition = -1;
                var cursorPosition;
                // Find the first non-disabled item as a fallback.
                for(cursorPosition = 0; cursorPosition < itemsMatchingFirstChar.length; cursorPosition++)if (!isItemAtIndexDisabled(itemsMatchingFirstChar[cursorPosition].index)) {
                    newCursorPosition = cursorPosition;
                    break;
                }
                // Advance cursor to first item matching the firstChar that is positioned
                // after starting item. Cursor is unchanged from fallback if there's no
                // such item.
                for(; cursorPosition < itemsMatchingFirstChar.length; cursorPosition++)if (itemsMatchingFirstChar[cursorPosition].index > focusedItemIndex && !isItemAtIndexDisabled(itemsMatchingFirstChar[cursorPosition].index)) {
                    newCursorPosition = cursorPosition;
                    break;
                }
                if (newCursorPosition !== -1) {
                    state.sortedIndexCursor = newCursorPosition;
                    return itemsMatchingFirstChar[state.sortedIndexCursor].index;
                }
                return -1;
            }
            /**
 * Attempts to find the next item that matches all of the typeahead buffer.
 * Wraps around if at end of options. Returns -1 if no match is found.
 */ function matchAllChars(sortedIndexByFirstChar, isItemAtIndexDisabled, state) {
                var firstChar = state.typeaheadBuffer[0];
                var itemsMatchingFirstChar = sortedIndexByFirstChar.get(firstChar);
                if (!itemsMatchingFirstChar) return -1;
                // Do nothing if text already matches
                var startingItem = itemsMatchingFirstChar[state.sortedIndexCursor];
                if (startingItem.text.lastIndexOf(state.typeaheadBuffer, 0) === 0 && !isItemAtIndexDisabled(startingItem.index)) return startingItem.index;
                // Find next item that matches completely; if no match, we'll eventually
                // loop around to same position
                var cursorPosition = (state.sortedIndexCursor + 1) % itemsMatchingFirstChar.length;
                var nextCursorPosition = -1;
                while(cursorPosition !== state.sortedIndexCursor){
                    var currentItem = itemsMatchingFirstChar[cursorPosition];
                    var matches = currentItem.text.lastIndexOf(state.typeaheadBuffer, 0) === 0;
                    var isEnabled = !isItemAtIndexDisabled(currentItem.index);
                    if (matches && isEnabled) {
                        nextCursorPosition = cursorPosition;
                        break;
                    }
                    cursorPosition = (cursorPosition + 1) % itemsMatchingFirstChar.length;
                }
                if (nextCursorPosition !== -1) {
                    state.sortedIndexCursor = nextCursorPosition;
                    return itemsMatchingFirstChar[state.sortedIndexCursor].index;
                }
                return -1;
            }
            /**
 * Whether or not the given typeahead instaance state is currently typing.
 *
 * @param state The typeahead state instance. See `initState`.
 */ function isTypingInProgress(state) {
                return state.typeaheadBuffer.length > 0;
            }
            exports.isTypingInProgress = isTypingInProgress;
            /**
 * Clears the typeahaed buffer so that it resets item matching to the first
 * character.
 *
 * @param state The typeahead state instance. See `initState`.
 */ function clearBuffer(state) {
                state.typeaheadBuffer = "";
            }
            exports.clearBuffer = clearBuffer;
            /**
 * Given a keydown event, it calculates whether or not to automatically focus a
 * list item depending on what was typed mimicing the typeahead functionality of
 * a standard <select> element that is open.
 *
 * @param opts Options and accessors
 *   - event - the KeyboardEvent to handle and parse
 *   - sortedIndexByFirstChar - output of `initSortedIndex(...)`
 *   - focusedItemIndex - the index of the currently focused item
 *   - focusItemAtIndex - function that focuses a list item at given index
 *   - isItemAtFocusedIndexDisabled - whether or not the currently focused item
 *      is disabled
 *   - isTargetListItem - whether or not the event target is a list item
 * @param state The typeahead state instance. See `initState`.
 *
 * @returns index of the item matched by the keydown. -1 if not matched.
 */ function handleKeydown(opts, state) {
                var event = opts.event, isTargetListItem = opts.isTargetListItem, focusedItemIndex = opts.focusedItemIndex, focusItemAtIndex = opts.focusItemAtIndex, sortedIndexByFirstChar = opts.sortedIndexByFirstChar, isItemAtIndexDisabled = opts.isItemAtIndexDisabled;
                var isArrowLeft = keyboard_1.normalizeKey(event) === "ArrowLeft";
                var isArrowUp = keyboard_1.normalizeKey(event) === "ArrowUp";
                var isArrowRight = keyboard_1.normalizeKey(event) === "ArrowRight";
                var isArrowDown = keyboard_1.normalizeKey(event) === "ArrowDown";
                var isHome = keyboard_1.normalizeKey(event) === "Home";
                var isEnd = keyboard_1.normalizeKey(event) === "End";
                var isEnter = keyboard_1.normalizeKey(event) === "Enter";
                var isSpace = keyboard_1.normalizeKey(event) === "Spacebar";
                if (event.ctrlKey || event.metaKey || isArrowLeft || isArrowUp || isArrowRight || isArrowDown || isHome || isEnd || isEnter) return -1;
                var isCharacterKey = !isSpace && event.key.length === 1;
                if (isCharacterKey) {
                    events_1.preventDefaultEvent(event);
                    var matchItemOpts = {
                        focusItemAtIndex: focusItemAtIndex,
                        focusedItemIndex: focusedItemIndex,
                        nextChar: event.key.toLowerCase(),
                        sortedIndexByFirstChar: sortedIndexByFirstChar,
                        skipFocus: false,
                        isItemAtIndexDisabled: isItemAtIndexDisabled
                    };
                    return matchItem(matchItemOpts, state);
                }
                if (!isSpace) return -1;
                if (isTargetListItem) events_1.preventDefaultEvent(event);
                var typeaheadOnListItem = isTargetListItem && isTypingInProgress(state);
                if (typeaheadOnListItem) {
                    var matchItemOpts = {
                        focusItemAtIndex: focusItemAtIndex,
                        focusedItemIndex: focusedItemIndex,
                        nextChar: " ",
                        sortedIndexByFirstChar: sortedIndexByFirstChar,
                        skipFocus: false,
                        isItemAtIndexDisabled: isItemAtIndexDisabled
                    };
                    // space participates in typeahead matching if in rapid typing mode
                    return matchItem(matchItemOpts, state);
                }
                return -1;
            }
            exports.handleKeydown = handleKeydown;
        /***/ },
        /***/ "./packages/mdc-menu-surface/component.ts": /*!************************************************!*\
  !*** ./packages/mdc-menu-surface/component.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenuSurface = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu-surface/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-menu-surface/foundation.ts");
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var MDCMenuSurface = /** @class */ function(_super) {
                __extends(MDCMenuSurface, _super);
                function MDCMenuSurface() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCMenuSurface.attachTo = function(root) {
                    return new MDCMenuSurface(root);
                };
                MDCMenuSurface.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    var parentEl = this.root.parentElement;
                    this.anchorElement = parentEl && parentEl.classList.contains(constants_1.cssClasses.ANCHOR) ? parentEl : null;
                    if (this.root.classList.contains(constants_1.cssClasses.FIXED)) this.setFixedPosition(true);
                    this.handleKeydown = function(evt) {
                        return _this.handleKeydown_(evt);
                    };
                    this.handleBodyClick = function(evt) {
                        return _this.handleBodyClick_(evt);
                    };
                    // capture so that no race between handleBodyClick and quickOpen when
                    // menusurface opened on button click which registers this listener
                    this.registerBodyClickListener = function() {
                        document.body.addEventListener("click", _this.handleBodyClick, {
                            capture: true
                        });
                    };
                    this.deregisterBodyClickListener = function() {
                        document.body.removeEventListener("click", _this.handleBodyClick, {
                            capture: true
                        });
                    };
                    this.listen("keydown", this.handleKeydown);
                    this.listen(constants_1.strings.OPENED_EVENT, this.registerBodyClickListener);
                    this.listen(constants_1.strings.CLOSED_EVENT, this.deregisterBodyClickListener);
                };
                /** Handle clicks and close if not within menu-surface element. */ MDCMenuSurface.prototype.handleBodyClick_ = function(evt) {
                    var el = evt.target;
                    if (this.isElementInContainer(el)) return;
                    this.emit("MDCMenuSurface:close", {}, true);
                };
                /** Handle keys that close the surface. */ MDCMenuSurface.prototype.handleKeydown_ = function(evt) {
                    var keyCode = evt.keyCode, key = evt.key;
                    var isEscape = key === "Escape" || keyCode === 27;
                    if (isEscape) this.emit("MDCMenuSurface:close", {}, true);
                };
                MDCMenuSurface.prototype.isElementInContainer = function(el) {
                    return this.root.contains(el);
                };
                MDCMenuSurface.prototype.destroy = function() {
                    this.unlisten("keydown", this.handleKeydown);
                    this.unlisten(constants_1.strings.OPENED_EVENT, this.registerBodyClickListener);
                    this.unlisten(constants_1.strings.CLOSED_EVENT, this.deregisterBodyClickListener);
                    this.deregisterBodyClickListener();
                    _super.prototype.destroy.call(this);
                };
                MDCMenuSurface.prototype.isOpen = function() {
                    return this.foundation.isOpen();
                };
                MDCMenuSurface.prototype.open = function() {
                    this.foundation.open();
                };
                MDCMenuSurface.prototype.close = function(skipRestoreFocus) {
                    if (skipRestoreFocus === void 0) skipRestoreFocus = false;
                    this.foundation.close(skipRestoreFocus);
                };
                Object.defineProperty(MDCMenuSurface.prototype, "quickOpen", {
                    set: function set(quickOpen) {
                        this.foundation.setQuickOpen(quickOpen);
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Sets the foundation to use page offsets for an positioning when the menu is hoisted to the body. */ MDCMenuSurface.prototype.setIsHoisted = function(isHoisted) {
                    this.foundation.setIsHoisted(isHoisted);
                };
                /** Sets the element that the menu-surface is anchored to. */ MDCMenuSurface.prototype.setMenuSurfaceAnchorElement = function(element) {
                    this.anchorElement = element;
                };
                /** Sets the menu-surface to position: fixed. */ MDCMenuSurface.prototype.setFixedPosition = function(isFixed) {
                    if (isFixed) this.root.classList.add(constants_1.cssClasses.FIXED);
                    else this.root.classList.remove(constants_1.cssClasses.FIXED);
                    this.foundation.setFixedPosition(isFixed);
                };
                /** Sets the absolute x/y position to position based on. Requires the menu to be hoisted. */ MDCMenuSurface.prototype.setAbsolutePosition = function(x, y) {
                    this.foundation.setAbsolutePosition(x, y);
                    this.setIsHoisted(true);
                };
                /**
     * @param corner Default anchor corner alignment of top-left surface corner.
     */ MDCMenuSurface.prototype.setAnchorCorner = function(corner) {
                    this.foundation.setAnchorCorner(corner);
                };
                MDCMenuSurface.prototype.setAnchorMargin = function(margin) {
                    this.foundation.setAnchorMargin(margin);
                };
                MDCMenuSurface.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        hasAnchor: function hasAnchor() {
                            return !!_this.anchorElement;
                        },
                        notifyClose: function notifyClose() {
                            return _this.emit(foundation_1.MDCMenuSurfaceFoundation.strings.CLOSED_EVENT, {});
                        },
                        notifyClosing: function notifyClosing() {
                            _this.emit(foundation_1.MDCMenuSurfaceFoundation.strings.CLOSING_EVENT, {});
                        },
                        notifyOpen: function notifyOpen() {
                            return _this.emit(foundation_1.MDCMenuSurfaceFoundation.strings.OPENED_EVENT, {});
                        },
                        isElementInContainer: function isElementInContainer(el) {
                            return _this.root.contains(el);
                        },
                        isRtl: function isRtl() {
                            return getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        setTransformOrigin: function setTransformOrigin(origin) {
                            var propertyName = util_1.getCorrectPropertyName(window, "transform") + "-origin";
                            _this.root.style.setProperty(propertyName, origin);
                        },
                        isFocused: function isFocused() {
                            return document.activeElement === _this.root;
                        },
                        saveFocus: function saveFocus() {
                            _this.previousFocus = document.activeElement;
                        },
                        restoreFocus: function restoreFocus() {
                            if (_this.root.contains(document.activeElement)) {
                                if (_this.previousFocus && _this.previousFocus.focus) _this.previousFocus.focus();
                            }
                        },
                        getInnerDimensions: function getInnerDimensions() {
                            return {
                                width: _this.root.offsetWidth,
                                height: _this.root.offsetHeight
                            };
                        },
                        getAnchorDimensions: function getAnchorDimensions() {
                            return _this.anchorElement ? _this.anchorElement.getBoundingClientRect() : null;
                        },
                        getWindowDimensions: function getWindowDimensions() {
                            return {
                                width: window.innerWidth,
                                height: window.innerHeight
                            };
                        },
                        getBodyDimensions: function getBodyDimensions() {
                            return {
                                width: document.body.clientWidth,
                                height: document.body.clientHeight
                            };
                        },
                        getWindowScroll: function getWindowScroll() {
                            return {
                                x: window.pageXOffset,
                                y: window.pageYOffset
                            };
                        },
                        setPosition: function setPosition(position) {
                            var rootHTML = _this.root;
                            rootHTML.style.left = "left" in position ? position.left + "px" : "";
                            rootHTML.style.right = "right" in position ? position.right + "px" : "";
                            rootHTML.style.top = "top" in position ? position.top + "px" : "";
                            rootHTML.style.bottom = "bottom" in position ? position.bottom + "px" : "";
                        },
                        setMaxHeight: function setMaxHeight(height) {
                            _this.root.style.maxHeight = height;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCMenuSurfaceFoundation(adapter);
                };
                return MDCMenuSurface;
            }(component_1.MDCComponent);
            exports.MDCMenuSurface = MDCMenuSurface;
        /***/ },
        /***/ "./packages/mdc-menu-surface/constants.ts": /*!************************************************!*\
  !*** ./packages/mdc-menu-surface/constants.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Corner = exports.CornerBit = exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ANCHOR: "mdc-menu-surface--anchor",
                ANIMATING_CLOSED: "mdc-menu-surface--animating-closed",
                ANIMATING_OPEN: "mdc-menu-surface--animating-open",
                FIXED: "mdc-menu-surface--fixed",
                IS_OPEN_BELOW: "mdc-menu-surface--is-open-below",
                OPEN: "mdc-menu-surface--open",
                ROOT: "mdc-menu-surface"
            };
            exports.cssClasses = cssClasses;
            // tslint:disable:object-literal-sort-keys
            var strings = {
                CLOSED_EVENT: "MDCMenuSurface:closed",
                CLOSING_EVENT: "MDCMenuSurface:closing",
                OPENED_EVENT: "MDCMenuSurface:opened",
                FOCUSABLE_ELEMENTS: [
                    "button:not(:disabled)",
                    '[href]:not([aria-disabled="true"])',
                    "input:not(:disabled)",
                    "select:not(:disabled)",
                    "textarea:not(:disabled)",
                    '[tabindex]:not([tabindex="-1"]):not([aria-disabled="true"])'
                ].join(", ")
            };
            exports.strings = strings;
            // tslint:enable:object-literal-sort-keys
            var numbers = {
                /** Total duration of menu-surface open animation. */ TRANSITION_OPEN_DURATION: 120,
                /** Total duration of menu-surface close animation. */ TRANSITION_CLOSE_DURATION: 75,
                /** Margin left to the edge of the viewport when menu-surface is at maximum possible height. Also used as a viewport margin. */ MARGIN_TO_EDGE: 32,
                /** Ratio of anchor width to menu-surface width for switching from corner positioning to center positioning. */ ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO: 0.67
            };
            exports.numbers = numbers;
            /**
 * Enum for bits in the {@see Corner) bitmap.
 */ var CornerBit;
            (function(CornerBit) {
                CornerBit[CornerBit["BOTTOM"] = 1] = "BOTTOM";
                CornerBit[CornerBit["CENTER"] = 2] = "CENTER";
                CornerBit[CornerBit["RIGHT"] = 4] = "RIGHT";
                CornerBit[CornerBit["FLIP_RTL"] = 8] = "FLIP_RTL";
            })(CornerBit || (CornerBit = {}));
            exports.CornerBit = CornerBit;
            /**
 * Enum for representing an element corner for positioning the menu-surface.
 *
 * The START constants map to LEFT if element directionality is left
 * to right and RIGHT if the directionality is right to left.
 * Likewise END maps to RIGHT or LEFT depending on the directionality.
 */ var Corner;
            (function(Corner) {
                Corner[Corner["TOP_LEFT"] = 0] = "TOP_LEFT";
                Corner[Corner["TOP_RIGHT"] = 4] = "TOP_RIGHT";
                Corner[Corner["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
                Corner[Corner["BOTTOM_RIGHT"] = 5] = "BOTTOM_RIGHT";
                Corner[Corner["TOP_START"] = 8] = "TOP_START";
                Corner[Corner["TOP_END"] = 12] = "TOP_END";
                Corner[Corner["BOTTOM_START"] = 9] = "BOTTOM_START";
                Corner[Corner["BOTTOM_END"] = 13] = "BOTTOM_END";
            })(Corner || (Corner = {}));
            exports.Corner = Corner;
        /***/ },
        /***/ "./packages/mdc-menu-surface/foundation.ts": /*!*************************************************!*\
  !*** ./packages/mdc-menu-surface/foundation.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __values = this && this.__values || function(o) {
                var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
                if (m) return m.call(o);
                if (o && typeof o.length === "number") return {
                    next: function next() {
                        if (o && i >= o.length) o = void 0;
                        return {
                            value: o && o[i++],
                            done: !o
                        };
                    }
                };
                throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenuSurfaceFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu-surface/constants.ts");
            var MDCMenuSurfaceFoundation = /** @class */ function(_super) {
                __extends(MDCMenuSurfaceFoundation, _super);
                function MDCMenuSurfaceFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCMenuSurfaceFoundation.defaultAdapter), adapter)) || this;
                    _this.isSurfaceOpen = false;
                    _this.isQuickOpen = false;
                    _this.isHoistedElement = false;
                    _this.isFixedPosition = false;
                    _this.isHorizontallyCenteredOnViewport = false;
                    _this.maxHeight = 0;
                    _this.openAnimationEndTimerId = 0;
                    _this.closeAnimationEndTimerId = 0;
                    _this.animationRequestId = 0;
                    _this.anchorCorner = constants_1.Corner.TOP_START;
                    /**
         * Corner of the menu surface to which menu surface is attached to anchor.
         *
         *  Anchor corner --->+----------+
         *                    |  ANCHOR  |
         *                    +----------+
         *  Origin corner --->+--------------+
         *                    |              |
         *                    |              |
         *                    | MENU SURFACE |
         *                    |              |
         *                    |              |
         *                    +--------------+
         */ _this.originCorner = constants_1.Corner.TOP_START;
                    _this.anchorMargin = {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };
                    _this.position = {
                        x: 0,
                        y: 0
                    };
                    return _this;
                }
                Object.defineProperty(MDCMenuSurfaceFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "Corner", {
                    get: function get() {
                        return constants_1.Corner;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuSurfaceFoundation, "defaultAdapter", {
                    /**
         * @see {@link MDCMenuSurfaceAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            hasAnchor: function hasAnchor() {
                                return false;
                            },
                            isElementInContainer: function isElementInContainer() {
                                return false;
                            },
                            isFocused: function isFocused() {
                                return false;
                            },
                            isRtl: function isRtl() {
                                return false;
                            },
                            getInnerDimensions: function getInnerDimensions() {
                                return {
                                    height: 0,
                                    width: 0
                                };
                            },
                            getAnchorDimensions: function getAnchorDimensions() {
                                return null;
                            },
                            getWindowDimensions: function getWindowDimensions() {
                                return {
                                    height: 0,
                                    width: 0
                                };
                            },
                            getBodyDimensions: function getBodyDimensions() {
                                return {
                                    height: 0,
                                    width: 0
                                };
                            },
                            getWindowScroll: function getWindowScroll() {
                                return {
                                    x: 0,
                                    y: 0
                                };
                            },
                            setPosition: function setPosition() {
                                return undefined;
                            },
                            setMaxHeight: function setMaxHeight() {
                                return undefined;
                            },
                            setTransformOrigin: function setTransformOrigin() {
                                return undefined;
                            },
                            saveFocus: function saveFocus() {
                                return undefined;
                            },
                            restoreFocus: function restoreFocus() {
                                return undefined;
                            },
                            notifyClose: function notifyClose() {
                                return undefined;
                            },
                            notifyOpen: function notifyOpen() {
                                return undefined;
                            },
                            notifyClosing: function notifyClosing() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCMenuSurfaceFoundation.prototype.init = function() {
                    var _a = MDCMenuSurfaceFoundation.cssClasses, ROOT = _a.ROOT, OPEN = _a.OPEN;
                    if (!this.adapter.hasClass(ROOT)) throw new Error(ROOT + " class required in root element.");
                    if (this.adapter.hasClass(OPEN)) this.isSurfaceOpen = true;
                };
                MDCMenuSurfaceFoundation.prototype.destroy = function() {
                    clearTimeout(this.openAnimationEndTimerId);
                    clearTimeout(this.closeAnimationEndTimerId);
                    // Cancel any currently running animations.
                    cancelAnimationFrame(this.animationRequestId);
                };
                /**
     * @param corner Default anchor corner alignment of top-left menu surface corner.
     */ MDCMenuSurfaceFoundation.prototype.setAnchorCorner = function(corner) {
                    this.anchorCorner = corner;
                };
                /**
     * Flip menu corner horizontally.
     */ MDCMenuSurfaceFoundation.prototype.flipCornerHorizontally = function() {
                    this.originCorner = this.originCorner ^ constants_1.CornerBit.RIGHT;
                };
                /**
     * @param margin Set of margin values from anchor.
     */ MDCMenuSurfaceFoundation.prototype.setAnchorMargin = function(margin) {
                    this.anchorMargin.top = margin.top || 0;
                    this.anchorMargin.right = margin.right || 0;
                    this.anchorMargin.bottom = margin.bottom || 0;
                    this.anchorMargin.left = margin.left || 0;
                };
                /** Used to indicate if the menu-surface is hoisted to the body. */ MDCMenuSurfaceFoundation.prototype.setIsHoisted = function(isHoisted) {
                    this.isHoistedElement = isHoisted;
                };
                /** Used to set the menu-surface calculations based on a fixed position menu. */ MDCMenuSurfaceFoundation.prototype.setFixedPosition = function(isFixedPosition) {
                    this.isFixedPosition = isFixedPosition;
                };
                /** Sets the menu-surface position on the page. */ MDCMenuSurfaceFoundation.prototype.setAbsolutePosition = function(x, y) {
                    this.position.x = this.isFinite(x) ? x : 0;
                    this.position.y = this.isFinite(y) ? y : 0;
                };
                /** Sets whether menu-surface should be horizontally centered to viewport. */ MDCMenuSurfaceFoundation.prototype.setIsHorizontallyCenteredOnViewport = function(isCentered) {
                    this.isHorizontallyCenteredOnViewport = isCentered;
                };
                MDCMenuSurfaceFoundation.prototype.setQuickOpen = function(quickOpen) {
                    this.isQuickOpen = quickOpen;
                };
                /**
     * Sets maximum menu-surface height on open.
     * @param maxHeight The desired max-height. Set to 0 (default) to
     *     automatically calculate max height based on available viewport space.
     */ MDCMenuSurfaceFoundation.prototype.setMaxHeight = function(maxHeight) {
                    this.maxHeight = maxHeight;
                };
                MDCMenuSurfaceFoundation.prototype.isOpen = function() {
                    return this.isSurfaceOpen;
                };
                /**
     * Open the menu surface.
     */ MDCMenuSurfaceFoundation.prototype.open = function() {
                    var _this = this;
                    if (this.isSurfaceOpen) return;
                    this.adapter.saveFocus();
                    if (this.isQuickOpen) {
                        this.isSurfaceOpen = true;
                        this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                        this.dimensions = this.adapter.getInnerDimensions();
                        this.autoposition();
                        this.adapter.notifyOpen();
                    } else {
                        this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_OPEN);
                        this.animationRequestId = requestAnimationFrame(function() {
                            _this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                            _this.dimensions = _this.adapter.getInnerDimensions();
                            _this.autoposition();
                            _this.openAnimationEndTimerId = setTimeout(function() {
                                _this.openAnimationEndTimerId = 0;
                                _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_OPEN);
                                _this.adapter.notifyOpen();
                            }, constants_1.numbers.TRANSITION_OPEN_DURATION);
                        });
                        this.isSurfaceOpen = true;
                    }
                };
                /**
     * Closes the menu surface.
     */ MDCMenuSurfaceFoundation.prototype.close = function(skipRestoreFocus) {
                    var _this = this;
                    if (skipRestoreFocus === void 0) skipRestoreFocus = false;
                    if (!this.isSurfaceOpen) return;
                    this.adapter.notifyClosing();
                    if (this.isQuickOpen) {
                        this.isSurfaceOpen = false;
                        if (!skipRestoreFocus) this.maybeRestoreFocus();
                        this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                        this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
                        this.adapter.notifyClose();
                        return;
                    }
                    this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_CLOSED);
                    requestAnimationFrame(function() {
                        _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.OPEN);
                        _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
                        _this.closeAnimationEndTimerId = setTimeout(function() {
                            _this.closeAnimationEndTimerId = 0;
                            _this.adapter.removeClass(MDCMenuSurfaceFoundation.cssClasses.ANIMATING_CLOSED);
                            _this.adapter.notifyClose();
                        }, constants_1.numbers.TRANSITION_CLOSE_DURATION);
                    });
                    this.isSurfaceOpen = false;
                    if (!skipRestoreFocus) this.maybeRestoreFocus();
                };
                MDCMenuSurfaceFoundation.prototype.autoposition = function() {
                    var _a;
                    // Compute measurements for autoposition methods reuse.
                    this.measurements = this.getAutoLayoutmeasurements();
                    var corner = this.getoriginCorner();
                    var maxMenuSurfaceHeight = this.getMenuSurfaceMaxHeight(corner);
                    var verticalAlignment = this.hasBit(corner, constants_1.CornerBit.BOTTOM) ? "bottom" : "top";
                    var horizontalAlignment = this.hasBit(corner, constants_1.CornerBit.RIGHT) ? "right" : "left";
                    var horizontalOffset = this.getHorizontalOriginOffset(corner);
                    var verticalOffset = this.getVerticalOriginOffset(corner);
                    var _b = this.measurements, anchorSize = _b.anchorSize, surfaceSize = _b.surfaceSize;
                    var position = (_a = {}, _a[horizontalAlignment] = horizontalOffset, _a[verticalAlignment] = verticalOffset, _a);
                    // Center align when anchor width is comparable or greater than menu surface, otherwise keep corner.
                    if (anchorSize.width / surfaceSize.width > constants_1.numbers.ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO) horizontalAlignment = "center";
                    // If the menu-surface has been hoisted to the body, it's no longer relative to the anchor element
                    if (this.isHoistedElement || this.isFixedPosition) this.adjustPositionForHoistedElement(position);
                    this.adapter.setTransformOrigin(horizontalAlignment + " " + verticalAlignment);
                    this.adapter.setPosition(position);
                    this.adapter.setMaxHeight(maxMenuSurfaceHeight ? maxMenuSurfaceHeight + "px" : "");
                    // If it is opened from the top then add is-open-below class
                    if (!this.hasBit(corner, constants_1.CornerBit.BOTTOM)) this.adapter.addClass(MDCMenuSurfaceFoundation.cssClasses.IS_OPEN_BELOW);
                };
                /**
     * @return Measurements used to position menu surface popup.
     */ MDCMenuSurfaceFoundation.prototype.getAutoLayoutmeasurements = function() {
                    var anchorRect = this.adapter.getAnchorDimensions();
                    var bodySize = this.adapter.getBodyDimensions();
                    var viewportSize = this.adapter.getWindowDimensions();
                    var windowScroll = this.adapter.getWindowScroll();
                    if (!anchorRect) // tslint:disable:object-literal-sort-keys Positional properties are more readable when they're grouped together
                    anchorRect = {
                        top: this.position.y,
                        right: this.position.x,
                        bottom: this.position.y,
                        left: this.position.x,
                        width: 0,
                        height: 0
                    };
                    return {
                        anchorSize: anchorRect,
                        bodySize: bodySize,
                        surfaceSize: this.dimensions,
                        viewportDistance: {
                            // tslint:disable:object-literal-sort-keys Positional properties are more readable when they're grouped together
                            top: anchorRect.top,
                            right: viewportSize.width - anchorRect.right,
                            bottom: viewportSize.height - anchorRect.bottom,
                            left: anchorRect.left
                        },
                        viewportSize: viewportSize,
                        windowScroll: windowScroll
                    };
                };
                /**
     * Computes the corner of the anchor from which to animate and position the
     * menu surface.
     *
     * Only LEFT or RIGHT bit is used to position the menu surface ignoring RTL
     * context. E.g., menu surface will be positioned from right side on TOP_END.
     */ MDCMenuSurfaceFoundation.prototype.getoriginCorner = function() {
                    var corner = this.originCorner;
                    var _a = this.measurements, viewportDistance = _a.viewportDistance, anchorSize = _a.anchorSize, surfaceSize = _a.surfaceSize;
                    var MARGIN_TO_EDGE = MDCMenuSurfaceFoundation.numbers.MARGIN_TO_EDGE;
                    var isAnchoredToBottom = this.hasBit(this.anchorCorner, constants_1.CornerBit.BOTTOM);
                    var availableTop;
                    var availableBottom;
                    if (isAnchoredToBottom) {
                        availableTop = viewportDistance.top - MARGIN_TO_EDGE + this.anchorMargin.bottom;
                        availableBottom = viewportDistance.bottom - MARGIN_TO_EDGE - this.anchorMargin.bottom;
                    } else {
                        availableTop = viewportDistance.top - MARGIN_TO_EDGE + this.anchorMargin.top;
                        availableBottom = viewportDistance.bottom - MARGIN_TO_EDGE + anchorSize.height - this.anchorMargin.top;
                    }
                    var isAvailableBottom = availableBottom - surfaceSize.height > 0;
                    if (!isAvailableBottom && availableTop > availableBottom) // Attach bottom side of surface to the anchor.
                    corner = this.setBit(corner, constants_1.CornerBit.BOTTOM);
                    var isRtl = this.adapter.isRtl();
                    var isFlipRtl = this.hasBit(this.anchorCorner, constants_1.CornerBit.FLIP_RTL);
                    var hasRightBit = this.hasBit(this.anchorCorner, constants_1.CornerBit.RIGHT) || this.hasBit(corner, constants_1.CornerBit.RIGHT);
                    // Whether surface attached to right side of anchor element.
                    var isAnchoredToRight = false;
                    // Anchored to start
                    if (isRtl && isFlipRtl) isAnchoredToRight = !hasRightBit;
                    else // Anchored to right
                    isAnchoredToRight = hasRightBit;
                    var availableLeft;
                    var availableRight;
                    if (isAnchoredToRight) {
                        availableLeft = viewportDistance.left + anchorSize.width + this.anchorMargin.right;
                        availableRight = viewportDistance.right - this.anchorMargin.right;
                    } else {
                        availableLeft = viewportDistance.left + this.anchorMargin.left;
                        availableRight = viewportDistance.right + anchorSize.width - this.anchorMargin.left;
                    }
                    var isAvailableLeft = availableLeft - surfaceSize.width > 0;
                    var isAvailableRight = availableRight - surfaceSize.width > 0;
                    var isOriginCornerAlignedToEnd = this.hasBit(corner, constants_1.CornerBit.FLIP_RTL) && this.hasBit(corner, constants_1.CornerBit.RIGHT);
                    if (isAvailableRight && isOriginCornerAlignedToEnd && isRtl || !isAvailableLeft && isOriginCornerAlignedToEnd) // Attach left side of surface to the anchor.
                    corner = this.unsetBit(corner, constants_1.CornerBit.RIGHT);
                    else if (isAvailableLeft && isAnchoredToRight && isRtl || isAvailableLeft && !isAnchoredToRight && hasRightBit || !isAvailableRight && availableLeft >= availableRight) // Attach right side of surface to the anchor.
                    corner = this.setBit(corner, constants_1.CornerBit.RIGHT);
                    return corner;
                };
                /**
     * @param corner Origin corner of the menu surface.
     * @return Maximum height of the menu surface, based on available space. 0 indicates should not be set.
     */ MDCMenuSurfaceFoundation.prototype.getMenuSurfaceMaxHeight = function(corner) {
                    if (this.maxHeight > 0) return this.maxHeight;
                    var viewportDistance = this.measurements.viewportDistance;
                    var maxHeight = 0;
                    var isBottomAligned = this.hasBit(corner, constants_1.CornerBit.BOTTOM);
                    var isBottomAnchored = this.hasBit(this.anchorCorner, constants_1.CornerBit.BOTTOM);
                    var MARGIN_TO_EDGE = MDCMenuSurfaceFoundation.numbers.MARGIN_TO_EDGE;
                    // When maximum height is not specified, it is handled from CSS.
                    if (isBottomAligned) {
                        maxHeight = viewportDistance.top + this.anchorMargin.top - MARGIN_TO_EDGE;
                        if (!isBottomAnchored) maxHeight += this.measurements.anchorSize.height;
                    } else {
                        maxHeight = viewportDistance.bottom - this.anchorMargin.bottom + this.measurements.anchorSize.height - MARGIN_TO_EDGE;
                        if (isBottomAnchored) maxHeight -= this.measurements.anchorSize.height;
                    }
                    return maxHeight;
                };
                /**
     * @param corner Origin corner of the menu surface.
     * @return Horizontal offset of menu surface origin corner from corresponding anchor corner.
     */ MDCMenuSurfaceFoundation.prototype.getHorizontalOriginOffset = function(corner) {
                    var anchorSize = this.measurements.anchorSize;
                    // isRightAligned corresponds to using the 'right' property on the surface.
                    var isRightAligned = this.hasBit(corner, constants_1.CornerBit.RIGHT);
                    var avoidHorizontalOverlap = this.hasBit(this.anchorCorner, constants_1.CornerBit.RIGHT);
                    if (isRightAligned) {
                        var rightOffset = avoidHorizontalOverlap ? anchorSize.width - this.anchorMargin.left : this.anchorMargin.right;
                        // For hoisted or fixed elements, adjust the offset by the difference
                        // between viewport width and body width so when we calculate the right
                        // value (`adjustPositionForHoistedElement`) based on the element
                        // position, the right property is correct.
                        if (this.isHoistedElement || this.isFixedPosition) return rightOffset - (this.measurements.viewportSize.width - this.measurements.bodySize.width);
                        return rightOffset;
                    }
                    return avoidHorizontalOverlap ? anchorSize.width - this.anchorMargin.right : this.anchorMargin.left;
                };
                /**
     * @param corner Origin corner of the menu surface.
     * @return Vertical offset of menu surface origin corner from corresponding anchor corner.
     */ MDCMenuSurfaceFoundation.prototype.getVerticalOriginOffset = function(corner) {
                    var anchorSize = this.measurements.anchorSize;
                    var isBottomAligned = this.hasBit(corner, constants_1.CornerBit.BOTTOM);
                    var avoidVerticalOverlap = this.hasBit(this.anchorCorner, constants_1.CornerBit.BOTTOM);
                    var y = 0;
                    if (isBottomAligned) y = avoidVerticalOverlap ? anchorSize.height - this.anchorMargin.top : -this.anchorMargin.bottom;
                    else y = avoidVerticalOverlap ? anchorSize.height + this.anchorMargin.bottom : this.anchorMargin.top;
                    return y;
                };
                /** Calculates the offsets for positioning the menu-surface when the menu-surface has been hoisted to the body. */ MDCMenuSurfaceFoundation.prototype.adjustPositionForHoistedElement = function(position) {
                    var e_1, _a;
                    var _b = this.measurements, windowScroll = _b.windowScroll, viewportDistance = _b.viewportDistance, surfaceSize = _b.surfaceSize, viewportSize = _b.viewportSize;
                    var props = Object.keys(position);
                    try {
                        for(var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                            var prop = props_1_1.value;
                            var value = position[prop] || 0;
                            if (this.isHorizontallyCenteredOnViewport && (prop === "left" || prop === "right")) {
                                position[prop] = (viewportSize.width - surfaceSize.width) / 2;
                                continue;
                            }
                            // Hoisted surfaces need to have the anchor elements location on the page added to the
                            // position properties for proper alignment on the body.
                            value += viewportDistance[prop];
                            // Surfaces that are absolutely positioned need to have additional calculations for scroll
                            // and bottom positioning.
                            if (!this.isFixedPosition) {
                                if (prop === "top") value += windowScroll.y;
                                else if (prop === "bottom") value -= windowScroll.y;
                                else if (prop === "left") value += windowScroll.x;
                                else // prop === 'right'
                                value -= windowScroll.x;
                            }
                            position[prop] = value;
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                };
                /**
     * The last focused element when the menu surface was opened should regain focus, if the user is
     * focused on or within the menu surface when it is closed.
     */ MDCMenuSurfaceFoundation.prototype.maybeRestoreFocus = function() {
                    var isRootFocused = this.adapter.isFocused();
                    var childHasFocus = document.activeElement && this.adapter.isElementInContainer(document.activeElement);
                    if (isRootFocused || childHasFocus) this.adapter.restoreFocus();
                };
                MDCMenuSurfaceFoundation.prototype.hasBit = function(corner, bit) {
                    return Boolean(corner & bit); // tslint:disable-line:no-bitwise
                };
                MDCMenuSurfaceFoundation.prototype.setBit = function(corner, bit) {
                    return corner | bit; // tslint:disable-line:no-bitwise
                };
                MDCMenuSurfaceFoundation.prototype.unsetBit = function(corner, bit) {
                    return corner ^ bit;
                };
                /**
     * isFinite that doesn't force conversion to number type.
     * Equivalent to Number.isFinite in ES2015, which is not supported in IE.
     */ MDCMenuSurfaceFoundation.prototype.isFinite = function(num) {
                    return typeof num === "number" && isFinite(num);
                };
                return MDCMenuSurfaceFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCMenuSurfaceFoundation = MDCMenuSurfaceFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCMenuSurfaceFoundation;
        /***/ },
        /***/ "./packages/mdc-menu/component.ts": /*!****************************************!*\
  !*** ./packages/mdc-menu/component.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenu = void 0;
            // TODO(b/152410470): Remove trailing underscores from private properties
            // tslint:disable:strip-private-property-underscore
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var constants_1 = __webpack_require__(/*! @material/list/constants */ "./packages/mdc-list/constants.ts");
            var foundation_1 = __webpack_require__(/*! @material/list/foundation */ "./packages/mdc-list/foundation.ts");
            var component_2 = __webpack_require__(/*! @material/menu-surface/component */ "./packages/mdc-menu-surface/component.ts");
            var foundation_2 = __webpack_require__(/*! @material/menu-surface/foundation */ "./packages/mdc-menu-surface/foundation.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu/constants.ts");
            var foundation_3 = __webpack_require__(/*! ./foundation */ "./packages/mdc-menu/foundation.ts");
            var MDCMenu = /** @class */ function(_super) {
                __extends(MDCMenu, _super);
                function MDCMenu() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCMenu.attachTo = function(root) {
                    return new MDCMenu(root);
                };
                MDCMenu.prototype.initialize = function(menuSurfaceFactory) {
                    if (menuSurfaceFactory === void 0) menuSurfaceFactory = function menuSurfaceFactory(el) {
                        return new component_2.MDCMenuSurface(el);
                    };
                    this.menuSurfaceFactory_ = menuSurfaceFactory;
                };
                MDCMenu.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.menuSurface_ = this.menuSurfaceFactory_(this.root);
                    var list = this.root.querySelector(constants_2.strings.LIST_SELECTOR);
                    if (list) {
                        list.init();
                        this.list_ = list.list_;
                        /* TODO(list): wrapFocus */ this.list_.wrapFocus = true;
                    } else this.list_ = null;
                    this.handleKeydown_ = function(evt) {
                        return _this.foundation.handleKeydown(evt);
                    };
                    this.handleItemAction_ = function(evt) {
                        return _this.foundation.handleItemAction(_this.items[evt.detail.index]);
                    };
                    this.handleMenuSurfaceOpened_ = function() {
                        return _this.foundation.handleMenuSurfaceOpened();
                    };
                    this.menuSurface_.listen(foundation_2.MDCMenuSurfaceFoundation.strings.OPENED_EVENT, this.handleMenuSurfaceOpened_);
                    this.listen("keydown", this.handleKeydown_);
                    this.listen(foundation_1.MDCListFoundation.strings.ACTION_EVENT, this.handleItemAction_);
                };
                MDCMenu.prototype.destroy = function() {
                    this.menuSurface_.destroy();
                    this.menuSurface_.unlisten(foundation_2.MDCMenuSurfaceFoundation.strings.OPENED_EVENT, this.handleMenuSurfaceOpened_);
                    this.unlisten("keydown", this.handleKeydown_);
                    this.unlisten(foundation_1.MDCListFoundation.strings.ACTION_EVENT, this.handleItemAction_);
                    _super.prototype.destroy.call(this);
                };
                Object.defineProperty(MDCMenu.prototype, "open", {
                    get: function get() {
                        return this.menuSurface_.isOpen();
                    },
                    set: function set(value) {
                        if (value) this.menuSurface_.open();
                        else this.menuSurface_.close();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "wrapFocus", {
                    get: function get() {
                        return this.list_ ? this.list_.wrapFocus : false;
                    },
                    set: function set(value) {
                        if (this.list_) this.list_.wrapFocus = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "hasTypeahead", {
                    /**
         * Sets whether the menu has typeahead functionality.
         * @param value Whether typeahead is enabled.
         */ set: function set(value) {
                        if (this.list_) this.list_.hasTypeahead = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "typeaheadInProgress", {
                    /**
         * @return Whether typeahead logic is currently matching some user prefix.
         */ get: function get() {
                        return this.list_ ? this.list_.typeaheadInProgress : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Given the next desired character from the user, adds it to the typeahead
     * buffer. Then, attempts to find the next option matching the buffer. Wraps
     * around if at the end of options.
     *
     * @param nextChar The next character to add to the prefix buffer.
     * @param startingIndex The index from which to start matching. Only relevant
     *     when starting a new match sequence. To start a new match sequence,
     *     clear the buffer using `clearTypeaheadBuffer`, or wait for the buffer
     *     to clear after a set interval defined in list foundation. Defaults to
     *     the currently focused index.
     * @return The index of the matched item, or -1 if no match.
     */ MDCMenu.prototype.typeaheadMatchItem = function(nextChar, startingIndex) {
                    if (this.list_) return this.list_.typeaheadMatchItem(nextChar, startingIndex);
                    return -1;
                };
                /**
     * Layout the underlying list element in the case of any dynamic updates
     * to its structure.
     */ MDCMenu.prototype.layout = function() {
                    if (this.list_) this.list_.layout();
                };
                Object.defineProperty(MDCMenu.prototype, "items", {
                    /**
         * Return the items within the menu. Note that this only contains the set of elements within
         * the items container that are proper list items, and not supplemental / presentational DOM
         * elements.
         */ get: function get() {
                        return this.list_ ? this.list_.listElements : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "singleSelection", {
                    /**
         * Turns on/off the underlying list's single selection mode. Used mainly
         * by select menu.
         *
         * @param singleSelection Whether to enable single selection mode.
         */ set: function set(singleSelection) {
                        if (this.list_) this.list_.singleSelection = singleSelection;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "selectedIndex", {
                    /**
         * Retrieves the selected index. Only applicable to select menus.
         * @return The selected index, which is a number for single selection and
         *     radio lists, and an array of numbers for checkbox lists.
         */ get: function get() {
                        return this.list_ ? this.list_.selectedIndex : constants_1.numbers.UNSET_INDEX;
                    },
                    /**
         * Sets the selected index of the list. Only applicable to select menus.
         * @param index The selected index, which is a number for single selection and
         *     radio lists, and an array of numbers for checkbox lists.
         */ set: function set(index) {
                        if (this.list_) this.list_.selectedIndex = index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenu.prototype, "quickOpen", {
                    set: function set(quickOpen) {
                        this.menuSurface_.quickOpen = quickOpen;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets default focus state where the menu should focus every time when menu
     * is opened. Focuses the list root (`DefaultFocusState.LIST_ROOT`) element by
     * default.
     * @param focusState Default focus state.
     */ MDCMenu.prototype.setDefaultFocusState = function(focusState) {
                    this.foundation.setDefaultFocusState(focusState);
                };
                /**
     * @param corner Default anchor corner alignment of top-left menu corner.
     */ MDCMenu.prototype.setAnchorCorner = function(corner) {
                    this.menuSurface_.setAnchorCorner(corner);
                };
                MDCMenu.prototype.setAnchorMargin = function(margin) {
                    this.menuSurface_.setAnchorMargin(margin);
                };
                /**
     * Sets the list item as the selected row at the specified index.
     * @param index Index of list item within menu.
     */ MDCMenu.prototype.setSelectedIndex = function(index) {
                    this.foundation.setSelectedIndex(index);
                };
                /**
     * Sets the enabled state to isEnabled for the menu item at the given index.
     * @param index Index of the menu item
     * @param isEnabled The desired enabled state of the menu item.
     */ MDCMenu.prototype.setEnabled = function(index, isEnabled) {
                    this.foundation.setEnabled(index, isEnabled);
                };
                /**
     * @return The item within the menu at the index specified.
     */ MDCMenu.prototype.getOptionByIndex = function(index) {
                    var items = this.items;
                    if (index < items.length) return this.items[index];
                    else return null;
                };
                /**
     * @param index A menu item's index.
     * @return The primary text within the menu at the index specified.
     */ MDCMenu.prototype.getPrimaryTextAtIndex = function(index) {
                    var item = this.getOptionByIndex(index);
                    if (item && this.list_) return this.list_.getPrimaryText(item) || "";
                    return "";
                };
                MDCMenu.prototype.setFixedPosition = function(isFixed) {
                    this.menuSurface_.setFixedPosition(isFixed);
                };
                MDCMenu.prototype.setIsHoisted = function(isHoisted) {
                    this.menuSurface_.setIsHoisted(isHoisted);
                };
                MDCMenu.prototype.setAbsolutePosition = function(x, y) {
                    this.menuSurface_.setAbsolutePosition(x, y);
                };
                /**
     * Sets the element that the menu-surface is anchored to.
     */ MDCMenu.prototype.setAnchorElement = function(element) {
                    this.menuSurface_.anchorElement = element;
                };
                MDCMenu.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClassToElementAtIndex: function addClassToElementAtIndex(index, className) {
                            var list = _this.items;
                            list[index].classList.add(className);
                        },
                        removeClassFromElementAtIndex: function removeClassFromElementAtIndex(index, className) {
                            var list = _this.items;
                            list[index].classList.remove(className);
                        },
                        addAttributeToElementAtIndex: function addAttributeToElementAtIndex(index, attr, value) {
                            var list = _this.items;
                            list[index].setAttribute(attr, value);
                        },
                        removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex(index, attr) {
                            var list = _this.items;
                            list[index].removeAttribute(attr);
                        },
                        elementContainsClass: function elementContainsClass(element, className) {
                            return element.classList.contains(className);
                        },
                        closeSurface: function closeSurface() {
                            return _this.emit("MDCMenu:close", {}, true);
                        },
                        getElementIndex: function getElementIndex(element) {
                            return _this.items.indexOf(element);
                        },
                        notifySelected: function notifySelected(evtData) {
                            return _this.emit(constants_2.strings.SELECTED_EVENT, {
                                index: evtData.index,
                                item: _this.items[evtData.index]
                            });
                        },
                        getMenuItemCount: function getMenuItemCount() {
                            return _this.items.length;
                        },
                        focusItemAtIndex: function focusItemAtIndex(index) {
                            return _this.items[index].focus();
                        },
                        focusListRoot: function focusListRoot() {
                            return _this.root.querySelector(constants_2.strings.LIST_SELECTOR).focus();
                        },
                        isSelectableItemAtIndex: function isSelectableItemAtIndex(index) {
                            return !!ponyfill_1.closest(_this.items[index], "." + constants_2.cssClasses.MENU_SELECTION_GROUP);
                        },
                        getSelectedSiblingOfItemAtIndex: function getSelectedSiblingOfItemAtIndex(index) {
                            var selectionGroupEl = ponyfill_1.closest(_this.items[index], "." + constants_2.cssClasses.MENU_SELECTION_GROUP);
                            var selectedItemEl = selectionGroupEl.querySelector("." + constants_2.cssClasses.MENU_SELECTED_LIST_ITEM);
                            return selectedItemEl ? _this.items.indexOf(selectedItemEl) : -1;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_3.MDCMenuFoundation(adapter);
                };
                return MDCMenu;
            }(component_1.MDCComponent);
            exports.MDCMenu = MDCMenu;
        /***/ },
        /***/ "./packages/mdc-menu/constants.ts": /*!****************************************!*\
  !*** ./packages/mdc-menu/constants.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DefaultFocusState = exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                MENU_SELECTED_LIST_ITEM: "mdc-menu-item--selected",
                MENU_SELECTION_GROUP: "mdc-menu__selection-group",
                ROOT: "mdc-menu"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_CHECKED_ATTR: "aria-checked",
                ARIA_DISABLED_ATTR: "aria-disabled",
                CHECKBOX_SELECTOR: 'input[type="checkbox"]',
                LIST_SELECTOR: ".mdc-list,.mdc-deprecated-list",
                SELECTED_EVENT: "MDCMenu:selected"
            };
            exports.strings = strings;
            var numbers = {
                FOCUS_ROOT_INDEX: -1
            };
            exports.numbers = numbers;
            var DefaultFocusState;
            (function(DefaultFocusState) {
                DefaultFocusState[DefaultFocusState["NONE"] = 0] = "NONE";
                DefaultFocusState[DefaultFocusState["LIST_ROOT"] = 1] = "LIST_ROOT";
                DefaultFocusState[DefaultFocusState["FIRST_ITEM"] = 2] = "FIRST_ITEM";
                DefaultFocusState[DefaultFocusState["LAST_ITEM"] = 3] = "LAST_ITEM";
            })(DefaultFocusState || (DefaultFocusState = {}));
            exports.DefaultFocusState = DefaultFocusState;
        /***/ },
        /***/ "./packages/mdc-menu/custom-element.js": /*!*********************************************!*\
  !*** ./packages/mdc-menu/custom-element.js ***!
  \*********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-menu/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcMenu = function(_HTMLElement) {
                _inherits(MdcMenu, _HTMLElement);
                _createClass(MdcMenu, [
                    {
                        key: "open",
                        get: function get() {
                            return this.open_;
                        },
                        set: function set(open) {
                            this.open_ = open;
                            if (!!this.menu_) this.menu_.open = open;
                        }
                    },
                    {
                        key: "quickOpen",
                        get: function get() {
                            return this.quickOpen_;
                        },
                        set: function set(quickOpen) {
                            this.quickOpen_ = quickOpen;
                            if (!!this.menu_) this.menu_.quickOpen = quickOpen;
                        }
                    }
                ]);
                function MdcMenu() {
                    _classCallCheck(this, MdcMenu);
                    var _this = _possibleConstructorReturn(this, (MdcMenu.__proto__ || Object.getPrototypeOf(MdcMenu)).call(this));
                    _this.init_ = false;
                    _this.open_ = false;
                    _this.quickOpen_ = false;
                    _this.menu_;
                    return _this;
                }
                _createClass(MdcMenu, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.menu_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCMenu"](this);
                            this.menu_.open = this.open_;
                            this.menu_.quickOpen = this.quickOpen_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.menu_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcMenu;
            }(HTMLElement);
            customElements.define("mdc-menu", MdcMenu);
        /***/ },
        /***/ "./packages/mdc-menu/foundation.ts": /*!*****************************************!*\
  !*** ./packages/mdc-menu/foundation.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCMenuFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! @material/list/constants */ "./packages/mdc-list/constants.ts");
            var foundation_2 = __webpack_require__(/*! @material/menu-surface/foundation */ "./packages/mdc-menu-surface/foundation.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-menu/constants.ts");
            var MDCMenuFoundation = /** @class */ function(_super) {
                __extends(MDCMenuFoundation, _super);
                function MDCMenuFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCMenuFoundation.defaultAdapter), adapter)) || this;
                    _this.closeAnimationEndTimerId_ = 0;
                    _this.defaultFocusState_ = constants_2.DefaultFocusState.LIST_ROOT;
                    return _this;
                }
                Object.defineProperty(MDCMenuFoundation, "cssClasses", {
                    get: function get() {
                        return constants_2.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuFoundation, "strings", {
                    get: function get() {
                        return constants_2.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuFoundation, "numbers", {
                    get: function get() {
                        return constants_2.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCMenuFoundation, "defaultAdapter", {
                    /**
         * @see {@link MDCMenuAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClassToElementAtIndex: function addClassToElementAtIndex() {
                                return undefined;
                            },
                            removeClassFromElementAtIndex: function removeClassFromElementAtIndex() {
                                return undefined;
                            },
                            addAttributeToElementAtIndex: function addAttributeToElementAtIndex() {
                                return undefined;
                            },
                            removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex() {
                                return undefined;
                            },
                            elementContainsClass: function elementContainsClass() {
                                return false;
                            },
                            closeSurface: function closeSurface() {
                                return undefined;
                            },
                            getElementIndex: function getElementIndex() {
                                return -1;
                            },
                            notifySelected: function notifySelected() {
                                return undefined;
                            },
                            getMenuItemCount: function getMenuItemCount() {
                                return 0;
                            },
                            focusItemAtIndex: function focusItemAtIndex() {
                                return undefined;
                            },
                            focusListRoot: function focusListRoot() {
                                return undefined;
                            },
                            getSelectedSiblingOfItemAtIndex: function getSelectedSiblingOfItemAtIndex() {
                                return -1;
                            },
                            isSelectableItemAtIndex: function isSelectableItemAtIndex() {
                                return false;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCMenuFoundation.prototype.destroy = function() {
                    if (this.closeAnimationEndTimerId_) clearTimeout(this.closeAnimationEndTimerId_);
                    this.adapter.closeSurface();
                };
                MDCMenuFoundation.prototype.handleKeydown = function(evt) {
                    var key = evt.key, keyCode = evt.keyCode;
                    var isTab = key === "Tab" || keyCode === 9;
                    if (isTab) this.adapter.closeSurface(/** skipRestoreFocus */ true);
                };
                MDCMenuFoundation.prototype.handleItemAction = function(listItem) {
                    var _this = this;
                    var index = this.adapter.getElementIndex(listItem);
                    if (index < 0) return;
                    this.adapter.notifySelected({
                        index: index
                    });
                    this.adapter.closeSurface();
                    // Wait for the menu to close before adding/removing classes that affect styles.
                    this.closeAnimationEndTimerId_ = setTimeout(function() {
                        // Recompute the index in case the menu contents have changed.
                        var recomputedIndex = _this.adapter.getElementIndex(listItem);
                        if (recomputedIndex >= 0 && _this.adapter.isSelectableItemAtIndex(recomputedIndex)) _this.setSelectedIndex(recomputedIndex);
                    }, foundation_2.MDCMenuSurfaceFoundation.numbers.TRANSITION_CLOSE_DURATION);
                };
                MDCMenuFoundation.prototype.handleMenuSurfaceOpened = function() {
                    switch(this.defaultFocusState_){
                        case constants_2.DefaultFocusState.FIRST_ITEM:
                            this.adapter.focusItemAtIndex(0);
                            break;
                        case constants_2.DefaultFocusState.LAST_ITEM:
                            this.adapter.focusItemAtIndex(this.adapter.getMenuItemCount() - 1);
                            break;
                        case constants_2.DefaultFocusState.NONE:
                            break;
                        default:
                            this.adapter.focusListRoot();
                            break;
                    }
                };
                /**
     * Sets default focus state where the menu should focus every time when menu
     * is opened. Focuses the list root (`DefaultFocusState.LIST_ROOT`) element by
     * default.
     */ MDCMenuFoundation.prototype.setDefaultFocusState = function(focusState) {
                    this.defaultFocusState_ = focusState;
                };
                /**
     * Selects the list item at `index` within the menu.
     * @param index Index of list item within the menu.
     */ MDCMenuFoundation.prototype.setSelectedIndex = function(index) {
                    this.validatedIndex_(index);
                    if (!this.adapter.isSelectableItemAtIndex(index)) throw new Error("MDCMenuFoundation: No selection group at specified index.");
                    var prevSelectedIndex = this.adapter.getSelectedSiblingOfItemAtIndex(index);
                    if (prevSelectedIndex >= 0) {
                        this.adapter.removeAttributeFromElementAtIndex(prevSelectedIndex, constants_2.strings.ARIA_CHECKED_ATTR);
                        this.adapter.removeClassFromElementAtIndex(prevSelectedIndex, constants_2.cssClasses.MENU_SELECTED_LIST_ITEM);
                    }
                    this.adapter.addClassToElementAtIndex(index, constants_2.cssClasses.MENU_SELECTED_LIST_ITEM);
                    this.adapter.addAttributeToElementAtIndex(index, constants_2.strings.ARIA_CHECKED_ATTR, "true");
                };
                /**
     * Sets the enabled state to isEnabled for the menu item at the given index.
     * @param index Index of the menu item
     * @param isEnabled The desired enabled state of the menu item.
     */ MDCMenuFoundation.prototype.setEnabled = function(index, isEnabled) {
                    this.validatedIndex_(index);
                    if (isEnabled) {
                        this.adapter.removeClassFromElementAtIndex(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                        this.adapter.addAttributeToElementAtIndex(index, constants_2.strings.ARIA_DISABLED_ATTR, "false");
                    } else {
                        this.adapter.addClassToElementAtIndex(index, constants_1.cssClasses.LIST_ITEM_DISABLED_CLASS);
                        this.adapter.addAttributeToElementAtIndex(index, constants_2.strings.ARIA_DISABLED_ATTR, "true");
                    }
                };
                MDCMenuFoundation.prototype.validatedIndex_ = function(index) {
                    var menuSize = this.adapter.getMenuItemCount();
                    var isIndexInRange = index >= 0 && index < menuSize;
                    if (!isIndexInRange) throw new Error("MDCMenuFoundation: No list item at specified index.");
                };
                return MDCMenuFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCMenuFoundation = MDCMenuFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCMenuFoundation;
        /***/ },
        /***/ "./packages/mdc-notched-outline/component.ts": /*!***************************************************!*\
  !*** ./packages/mdc-notched-outline/component.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCNotchedOutline = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/floating-label/foundation */ "./packages/mdc-floating-label/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-notched-outline/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-notched-outline/foundation.ts");
            var MDCNotchedOutline = /** @class */ function(_super) {
                __extends(MDCNotchedOutline, _super);
                function MDCNotchedOutline() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCNotchedOutline.attachTo = function(root) {
                    return new MDCNotchedOutline(root);
                };
                MDCNotchedOutline.prototype.initialSyncWithDOM = function() {
                    this.notchElement_ = this.root.querySelector(constants_1.strings.NOTCH_ELEMENT_SELECTOR);
                    var label = this.root.querySelector("." + foundation_1.MDCFloatingLabelFoundation.cssClasses.ROOT);
                    if (label) {
                        label.style.transitionDuration = "0s";
                        this.root.classList.add(constants_1.cssClasses.OUTLINE_UPGRADED);
                        requestAnimationFrame(function() {
                            label.style.transitionDuration = "";
                        });
                    } else this.root.classList.add(constants_1.cssClasses.NO_LABEL);
                };
                /**
     * Updates classes and styles to open the notch to the specified width.
     * @param notchWidth The notch width in the outline.
     */ MDCNotchedOutline.prototype.notch = function(notchWidth) {
                    this.foundation.notch(notchWidth);
                };
                /**
     * Updates classes and styles to close the notch.
     */ MDCNotchedOutline.prototype.closeNotch = function() {
                    this.foundation.closeNotch();
                };
                MDCNotchedOutline.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setNotchWidthProperty: function setNotchWidthProperty(width) {
                            return _this.notchElement_.style.setProperty("width", width + "px");
                        },
                        removeNotchWidthProperty: function removeNotchWidthProperty() {
                            return _this.notchElement_.style.removeProperty("width");
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_2.MDCNotchedOutlineFoundation(adapter);
                };
                return MDCNotchedOutline;
            }(component_1.MDCComponent);
            exports.MDCNotchedOutline = MDCNotchedOutline;
        /***/ },
        /***/ "./packages/mdc-notched-outline/constants.ts": /*!***************************************************!*\
  !*** ./packages/mdc-notched-outline/constants.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.numbers = exports.cssClasses = void 0;
            var strings = {
                NOTCH_ELEMENT_SELECTOR: ".mdc-notched-outline__notch"
            };
            exports.strings = strings;
            var numbers = {
                // This should stay in sync with $mdc-notched-outline-padding * 2.
                NOTCH_ELEMENT_PADDING: 8
            };
            exports.numbers = numbers;
            var cssClasses = {
                NO_LABEL: "mdc-notched-outline--no-label",
                OUTLINE_NOTCHED: "mdc-notched-outline--notched",
                OUTLINE_UPGRADED: "mdc-notched-outline--upgraded"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-notched-outline/foundation.ts": /*!****************************************************!*\
  !*** ./packages/mdc-notched-outline/foundation.ts ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCNotchedOutlineFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-notched-outline/constants.ts");
            var MDCNotchedOutlineFoundation = /** @class */ function(_super) {
                __extends(MDCNotchedOutlineFoundation, _super);
                function MDCNotchedOutlineFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCNotchedOutlineFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCNotchedOutlineFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCNotchedOutlineFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCNotchedOutlineFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCNotchedOutlineFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCNotchedOutlineAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setNotchWidthProperty: function setNotchWidthProperty() {
                                return undefined;
                            },
                            removeNotchWidthProperty: function removeNotchWidthProperty() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Adds the outline notched selector and updates the notch width calculated based off of notchWidth.
     */ MDCNotchedOutlineFoundation.prototype.notch = function(notchWidth) {
                    var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
                    if (notchWidth > 0) notchWidth += constants_1.numbers.NOTCH_ELEMENT_PADDING; // Add padding from left/right.
                    this.adapter.setNotchWidthProperty(notchWidth);
                    this.adapter.addClass(OUTLINE_NOTCHED);
                };
                /**
     * Removes notched outline selector to close the notch in the outline.
     */ MDCNotchedOutlineFoundation.prototype.closeNotch = function() {
                    var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
                    this.adapter.removeClass(OUTLINE_NOTCHED);
                    this.adapter.removeNotchWidthProperty();
                };
                return MDCNotchedOutlineFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCNotchedOutlineFoundation = MDCNotchedOutlineFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCNotchedOutlineFoundation;
        /***/ },
        /***/ "./packages/mdc-radio/component.ts": /*!*****************************************!*\
  !*** ./packages/mdc-radio/component.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRadio = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-radio/foundation.ts");
            var MDCRadio = /** @class */ function(_super) {
                __extends(MDCRadio, _super);
                function MDCRadio() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.ripple_ = _this.createRipple_();
                    return _this;
                }
                MDCRadio.attachTo = function(root) {
                    return new MDCRadio(root);
                };
                Object.defineProperty(MDCRadio.prototype, "checked", {
                    get: function get() {
                        return this.nativeControl_.checked;
                    },
                    set: function set(checked) {
                        this.nativeControl_.checked = checked;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadio.prototype, "disabled", {
                    get: function get() {
                        return this.nativeControl_.disabled;
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadio.prototype, "value", {
                    get: function get() {
                        return this.nativeControl_.value;
                    },
                    set: function set(value) {
                        this.nativeControl_.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadio.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRadio.prototype.destroy = function() {
                    this.ripple_.destroy();
                    _super.prototype.destroy.call(this);
                };
                MDCRadio.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
                            return _this.nativeControl_.disabled = disabled;
                        }
                    };
                    return new foundation_2.MDCRadioFoundation(adapter);
                };
                MDCRadio.prototype.createRipple_ = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.nativeControl_.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        // Radio buttons technically go "active" whenever there is *any* keyboard interaction.
                        // This is not the UI we desire.
                        isSurfaceActive: function isSurfaceActive() {
                            return false;
                        },
                        isUnbounded: function isUnbounded() {
                            return true;
                        }
                    });
                    // tslint:enable:object-literal-sort-keys
                    return new component_2.MDCRipple(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                Object.defineProperty(MDCRadio.prototype, "nativeControl_", {
                    get: function get() {
                        var NATIVE_CONTROL_SELECTOR = foundation_2.MDCRadioFoundation.strings.NATIVE_CONTROL_SELECTOR;
                        var el = this.root.querySelector(NATIVE_CONTROL_SELECTOR);
                        if (!el) throw new Error("Radio component requires a " + NATIVE_CONTROL_SELECTOR + " element");
                        return el;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MDCRadio;
            }(component_1.MDCComponent);
            exports.MDCRadio = MDCRadio;
        /***/ },
        /***/ "./packages/mdc-radio/constants.ts": /*!*****************************************!*\
  !*** ./packages/mdc-radio/constants.ts ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var strings = {
                NATIVE_CONTROL_SELECTOR: ".mdc-radio__native-control"
            };
            exports.strings = strings;
            var cssClasses = {
                DISABLED: "mdc-radio--disabled",
                ROOT: "mdc-radio"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-radio/custom-element.js": /*!**********************************************!*\
  !*** ./packages/mdc-radio/custom-element.js ***!
  \**********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-radio/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcRadio = function(_HTMLElement) {
                _inherits(MdcRadio, _HTMLElement);
                _createClass(MdcRadio, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.radio_.nativeControl_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.radio_.nativeControl_.blur();
                        }
                    },
                    {
                        key: "checked",
                        get: function get() {
                            return this.checked_;
                        },
                        set: function set(checked) {
                            this.checked_ = checked;
                            if (!!this.radio_) this.radio_.checked = checked;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.radio_) this.radio_.disabled = disabled;
                        }
                    }
                ]);
                function MdcRadio() {
                    _classCallCheck(this, MdcRadio);
                    var _this = _possibleConstructorReturn(this, (MdcRadio.__proto__ || Object.getPrototypeOf(MdcRadio)).call(this));
                    _this.checked_ = false;
                    _this.disabled_ = false;
                    _this.radio_;
                    return _this;
                }
                _createClass(MdcRadio, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.radio_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCRadio"](this);
                            this.radio_.checked = this.checked_;
                            this.radio_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.radio_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcRadio;
            }(HTMLElement);
            customElements.define("mdc-radio", MdcRadio);
        /***/ },
        /***/ "./packages/mdc-radio/foundation.ts": /*!******************************************!*\
  !*** ./packages/mdc-radio/foundation.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRadioFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-radio/constants.ts");
            var MDCRadioFoundation = /** @class */ function(_super) {
                __extends(MDCRadioFoundation, _super);
                function MDCRadioFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCRadioFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCRadioFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadioFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRadioFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setNativeControlDisabled: function setNativeControlDisabled() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRadioFoundation.prototype.setDisabled = function(disabled) {
                    var DISABLED = MDCRadioFoundation.cssClasses.DISABLED;
                    this.adapter.setNativeControlDisabled(disabled);
                    if (disabled) this.adapter.addClass(DISABLED);
                    else this.adapter.removeClass(DISABLED);
                };
                return MDCRadioFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCRadioFoundation = MDCRadioFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCRadioFoundation;
        /***/ },
        /***/ "./packages/mdc-ripple/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-ripple/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRipple = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-ripple/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-ripple/util.ts"));
            var MDCRipple = /** @class */ function(_super) {
                __extends(MDCRipple, _super);
                function MDCRipple() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.disabled = false;
                    return _this;
                }
                MDCRipple.attachTo = function(root, opts) {
                    if (opts === void 0) opts = {
                        isUnbounded: undefined
                    };
                    var ripple = new MDCRipple(root);
                    // Only override unbounded behavior if option is explicitly specified
                    if (opts.isUnbounded !== undefined) ripple.unbounded = opts.isUnbounded;
                    return ripple;
                };
                MDCRipple.createAdapter = function(instance) {
                    return {
                        addClass: function addClass(className) {
                            return instance.root.classList.add(className);
                        },
                        browserSupportsCssVars: function browserSupportsCssVars() {
                            return util.supportsCssVariables(window);
                        },
                        computeBoundingRect: function computeBoundingRect() {
                            return instance.root.getBoundingClientRect();
                        },
                        containsEventTarget: function containsEventTarget(target) {
                            return instance.root.contains(target);
                        },
                        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(evtType, handler) {
                            return document.documentElement.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return instance.root.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterResizeHandler: function deregisterResizeHandler(handler) {
                            return window.removeEventListener("resize", handler);
                        },
                        getWindowPageOffset: function getWindowPageOffset() {
                            return {
                                x: window.pageXOffset,
                                y: window.pageYOffset
                            };
                        },
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill_1.matches(instance.root, ":active");
                        },
                        isSurfaceDisabled: function isSurfaceDisabled() {
                            return Boolean(instance.disabled);
                        },
                        isUnbounded: function isUnbounded() {
                            return Boolean(instance.unbounded);
                        },
                        registerDocumentInteractionHandler: function registerDocumentInteractionHandler(evtType, handler) {
                            return document.documentElement.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return instance.root.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        registerResizeHandler: function registerResizeHandler(handler) {
                            return window.addEventListener("resize", handler);
                        },
                        removeClass: function removeClass(className) {
                            return instance.root.classList.remove(className);
                        },
                        updateCssVariable: function updateCssVariable(varName, value) {
                            return instance.root.style.setProperty(varName, value);
                        }
                    };
                };
                Object.defineProperty(MDCRipple.prototype, "unbounded", {
                    get: function get() {
                        return Boolean(this.unbounded_);
                    },
                    set: function set(unbounded) {
                        this.unbounded_ = Boolean(unbounded);
                        this.setUnbounded_();
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRipple.prototype.activate = function() {
                    this.foundation.activate();
                };
                MDCRipple.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                MDCRipple.prototype.layout = function() {
                    this.foundation.layout();
                };
                MDCRipple.prototype.getDefaultFoundation = function() {
                    return new foundation_1.MDCRippleFoundation(MDCRipple.createAdapter(this));
                };
                MDCRipple.prototype.initialSyncWithDOM = function() {
                    var root = this.root;
                    this.unbounded = "mdcRippleIsUnbounded" in root.dataset;
                };
                /**
     * Closure Compiler throws an access control error when directly accessing a
     * protected or private property inside a getter/setter, like unbounded above.
     * By accessing the protected property inside a method, we solve that problem.
     * That's why this function exists.
     */ MDCRipple.prototype.setUnbounded_ = function() {
                    this.foundation.setUnbounded(Boolean(this.unbounded_));
                };
                return MDCRipple;
            }(component_1.MDCComponent);
            exports.MDCRipple = MDCRipple;
        /***/ },
        /***/ "./packages/mdc-ripple/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-ripple/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            exports.cssClasses = {
                // Ripple is a special case where the "root" component is really a "mixin" of sorts,
                // given that it's an 'upgrade' to an existing component. That being said it is the root
                // CSS class that all other CSS classes derive from.
                BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
                FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
                FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
                ROOT: "mdc-ripple-upgraded",
                UNBOUNDED: "mdc-ripple-upgraded--unbounded"
            };
            exports.strings = {
                VAR_FG_SCALE: "--mdc-ripple-fg-scale",
                VAR_FG_SIZE: "--mdc-ripple-fg-size",
                VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
                VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
                VAR_LEFT: "--mdc-ripple-left",
                VAR_TOP: "--mdc-ripple-top"
            };
            exports.numbers = {
                DEACTIVATION_TIMEOUT_MS: 225,
                FG_DEACTIVATION_MS: 150,
                INITIAL_ORIGIN_SCALE: 0.6,
                PADDING: 10,
                TAP_DELAY_MS: 300
            };
        /***/ },
        /***/ "./packages/mdc-ripple/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-ripple/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-ripple/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcRipple = function(_HTMLElement) {
                _inherits(MdcRipple, _HTMLElement);
                _createClass(MdcRipple, [
                    {
                        key: "unbounded",
                        get: function get() {
                            return this.unbounded_;
                        },
                        set: function set(unbounded) {
                            this.unbounded_ = unbounded;
                            if (!!this.ripple_) this.ripple_.unbounded = unbounded;
                        }
                    }
                ]);
                function MdcRipple() {
                    _classCallCheck(this, MdcRipple);
                    var _this = _possibleConstructorReturn(this, (MdcRipple.__proto__ || Object.getPrototypeOf(MdcRipple)).call(this));
                    _this.unbounded_ = false;
                    _this.ripple_;
                    return _this;
                }
                _createClass(MdcRipple, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.ripple_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCRipple"](this);
                            this.ripple_.unbounded = this.unbounded_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.ripple_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcRipple;
            }(HTMLElement);
            customElements.define("mdc-ripple", MdcRipple);
        /***/ },
        /***/ "./packages/mdc-ripple/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-ripple/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCRippleFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-ripple/constants.ts");
            var util_1 = __webpack_require__(/*! ./util */ "./packages/mdc-ripple/util.ts");
            // Activation events registered on the root element of each instance for activation
            var ACTIVATION_EVENT_TYPES = [
                "touchstart",
                "pointerdown",
                "mousedown",
                "keydown"
            ];
            // Deactivation events registered on documentElement when a pointer-related down event occurs
            var POINTER_DEACTIVATION_EVENT_TYPES = [
                "touchend",
                "pointerup",
                "mouseup",
                "contextmenu"
            ];
            // simultaneous nested activations
            var activatedTargets = [];
            var MDCRippleFoundation = /** @class */ function(_super) {
                __extends(MDCRippleFoundation, _super);
                function MDCRippleFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCRippleFoundation.defaultAdapter), adapter)) || this;
                    _this.activationAnimationHasEnded_ = false;
                    _this.activationTimer_ = 0;
                    _this.fgDeactivationRemovalTimer_ = 0;
                    _this.fgScale_ = "0";
                    _this.frame_ = {
                        width: 0,
                        height: 0
                    };
                    _this.initialSize_ = 0;
                    _this.layoutFrame_ = 0;
                    _this.maxRadius_ = 0;
                    _this.unboundedCoords_ = {
                        left: 0,
                        top: 0
                    };
                    _this.activationState_ = _this.defaultActivationState_();
                    _this.activationTimerCallback_ = function() {
                        _this.activationAnimationHasEnded_ = true;
                        _this.runDeactivationUXLogicIfReady_();
                    };
                    _this.activateHandler_ = function(e) {
                        return _this.activate_(e);
                    };
                    _this.deactivateHandler_ = function() {
                        return _this.deactivate_();
                    };
                    _this.focusHandler_ = function() {
                        return _this.handleFocus();
                    };
                    _this.blurHandler_ = function() {
                        return _this.handleBlur();
                    };
                    _this.resizeHandler_ = function() {
                        return _this.layout();
                    };
                    return _this;
                }
                Object.defineProperty(MDCRippleFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRippleFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRippleFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            browserSupportsCssVars: function browserSupportsCssVars() {
                                return true;
                            },
                            computeBoundingRect: function computeBoundingRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            containsEventTarget: function containsEventTarget() {
                                return true;
                            },
                            deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            deregisterResizeHandler: function deregisterResizeHandler() {
                                return undefined;
                            },
                            getWindowPageOffset: function getWindowPageOffset() {
                                return {
                                    x: 0,
                                    y: 0
                                };
                            },
                            isSurfaceActive: function isSurfaceActive() {
                                return true;
                            },
                            isSurfaceDisabled: function isSurfaceDisabled() {
                                return true;
                            },
                            isUnbounded: function isUnbounded() {
                                return true;
                            },
                            registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            registerResizeHandler: function registerResizeHandler() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            updateCssVariable: function updateCssVariable() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCRippleFoundation.prototype.init = function() {
                    var _this = this;
                    var supportsPressRipple = this.supportsPressRipple_();
                    this.registerRootHandlers_(supportsPressRipple);
                    if (supportsPressRipple) {
                        var _a = MDCRippleFoundation.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
                        requestAnimationFrame(function() {
                            _this.adapter.addClass(ROOT_1);
                            if (_this.adapter.isUnbounded()) {
                                _this.adapter.addClass(UNBOUNDED_1);
                                // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
                                _this.layoutInternal_();
                            }
                        });
                    }
                };
                MDCRippleFoundation.prototype.destroy = function() {
                    var _this = this;
                    if (this.supportsPressRipple_()) {
                        if (this.activationTimer_) {
                            clearTimeout(this.activationTimer_);
                            this.activationTimer_ = 0;
                            this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_ACTIVATION);
                        }
                        if (this.fgDeactivationRemovalTimer_) {
                            clearTimeout(this.fgDeactivationRemovalTimer_);
                            this.fgDeactivationRemovalTimer_ = 0;
                            this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_DEACTIVATION);
                        }
                        var _a = MDCRippleFoundation.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
                        requestAnimationFrame(function() {
                            _this.adapter.removeClass(ROOT_2);
                            _this.adapter.removeClass(UNBOUNDED_2);
                            _this.removeCssVars_();
                        });
                    }
                    this.deregisterRootHandlers_();
                    this.deregisterDeactivationHandlers_();
                };
                /**
     * @param evt Optional event containing position information.
     */ MDCRippleFoundation.prototype.activate = function(evt) {
                    this.activate_(evt);
                };
                MDCRippleFoundation.prototype.deactivate = function() {
                    this.deactivate_();
                };
                MDCRippleFoundation.prototype.layout = function() {
                    var _this = this;
                    if (this.layoutFrame_) cancelAnimationFrame(this.layoutFrame_);
                    this.layoutFrame_ = requestAnimationFrame(function() {
                        _this.layoutInternal_();
                        _this.layoutFrame_ = 0;
                    });
                };
                MDCRippleFoundation.prototype.setUnbounded = function(unbounded) {
                    var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
                    if (unbounded) this.adapter.addClass(UNBOUNDED);
                    else this.adapter.removeClass(UNBOUNDED);
                };
                MDCRippleFoundation.prototype.handleFocus = function() {
                    var _this = this;
                    requestAnimationFrame(function() {
                        return _this.adapter.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
                    });
                };
                MDCRippleFoundation.prototype.handleBlur = function() {
                    var _this = this;
                    requestAnimationFrame(function() {
                        return _this.adapter.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
                    });
                };
                /**
     * We compute this property so that we are not querying information about the client
     * until the point in time where the foundation requests it. This prevents scenarios where
     * client-side feature-detection may happen too early, such as when components are rendered on the server
     * and then initialized at mount time on the client.
     */ MDCRippleFoundation.prototype.supportsPressRipple_ = function() {
                    return this.adapter.browserSupportsCssVars();
                };
                MDCRippleFoundation.prototype.defaultActivationState_ = function() {
                    return {
                        activationEvent: undefined,
                        hasDeactivationUXRun: false,
                        isActivated: false,
                        isProgrammatic: false,
                        wasActivatedByPointer: false,
                        wasElementMadeActive: false
                    };
                };
                /**
     * supportsPressRipple Passed from init to save a redundant function call
     */ MDCRippleFoundation.prototype.registerRootHandlers_ = function(supportsPressRipple) {
                    var _this = this;
                    if (supportsPressRipple) {
                        ACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                            _this.adapter.registerInteractionHandler(evtType, _this.activateHandler_);
                        });
                        if (this.adapter.isUnbounded()) this.adapter.registerResizeHandler(this.resizeHandler_);
                    }
                    this.adapter.registerInteractionHandler("focus", this.focusHandler_);
                    this.adapter.registerInteractionHandler("blur", this.blurHandler_);
                };
                MDCRippleFoundation.prototype.registerDeactivationHandlers_ = function(evt) {
                    var _this = this;
                    if (evt.type === "keydown") this.adapter.registerInteractionHandler("keyup", this.deactivateHandler_);
                    else POINTER_DEACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                        _this.adapter.registerDocumentInteractionHandler(evtType, _this.deactivateHandler_);
                    });
                };
                MDCRippleFoundation.prototype.deregisterRootHandlers_ = function() {
                    var _this = this;
                    ACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                        _this.adapter.deregisterInteractionHandler(evtType, _this.activateHandler_);
                    });
                    this.adapter.deregisterInteractionHandler("focus", this.focusHandler_);
                    this.adapter.deregisterInteractionHandler("blur", this.blurHandler_);
                    if (this.adapter.isUnbounded()) this.adapter.deregisterResizeHandler(this.resizeHandler_);
                };
                MDCRippleFoundation.prototype.deregisterDeactivationHandlers_ = function() {
                    var _this = this;
                    this.adapter.deregisterInteractionHandler("keyup", this.deactivateHandler_);
                    POINTER_DEACTIVATION_EVENT_TYPES.forEach(function(evtType) {
                        _this.adapter.deregisterDocumentInteractionHandler(evtType, _this.deactivateHandler_);
                    });
                };
                MDCRippleFoundation.prototype.removeCssVars_ = function() {
                    var _this = this;
                    var rippleStrings = MDCRippleFoundation.strings;
                    var keys = Object.keys(rippleStrings);
                    keys.forEach(function(key) {
                        if (key.indexOf("VAR_") === 0) _this.adapter.updateCssVariable(rippleStrings[key], null);
                    });
                };
                MDCRippleFoundation.prototype.activate_ = function(evt) {
                    var _this = this;
                    if (this.adapter.isSurfaceDisabled()) return;
                    var activationState = this.activationState_;
                    if (activationState.isActivated) return;
                    // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
                    var previousActivationEvent = this.previousActivationEvent_;
                    var isSameInteraction = previousActivationEvent && evt !== undefined && previousActivationEvent.type !== evt.type;
                    if (isSameInteraction) return;
                    activationState.isActivated = true;
                    activationState.isProgrammatic = evt === undefined;
                    activationState.activationEvent = evt;
                    activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== undefined && (evt.type === "mousedown" || evt.type === "touchstart" || evt.type === "pointerdown");
                    var hasActivatedChild = evt !== undefined && activatedTargets.length > 0 && activatedTargets.some(function(target) {
                        return _this.adapter.containsEventTarget(target);
                    });
                    if (hasActivatedChild) {
                        // Immediately reset activation state, while preserving logic that prevents touch follow-on events
                        this.resetActivationState_();
                        return;
                    }
                    if (evt !== undefined) {
                        activatedTargets.push(evt.target);
                        this.registerDeactivationHandlers_(evt);
                    }
                    activationState.wasElementMadeActive = this.checkElementMadeActive_(evt);
                    if (activationState.wasElementMadeActive) this.animateActivation_();
                    requestAnimationFrame(function() {
                        // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
                        activatedTargets = [];
                        if (!activationState.wasElementMadeActive && evt !== undefined && (evt.key === " " || evt.keyCode === 32)) {
                            // If space was pressed, try again within an rAF call to detect :active, because different UAs report
                            // active states inconsistently when they're called within event handling code:
                            // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
                            // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
                            // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
                            // variable is set within a rAF callback for a submit button interaction (#2241).
                            activationState.wasElementMadeActive = _this.checkElementMadeActive_(evt);
                            if (activationState.wasElementMadeActive) _this.animateActivation_();
                        }
                        if (!activationState.wasElementMadeActive) // Reset activation state immediately if element was not made active.
                        _this.activationState_ = _this.defaultActivationState_();
                    });
                };
                MDCRippleFoundation.prototype.checkElementMadeActive_ = function(evt) {
                    return evt !== undefined && evt.type === "keydown" ? this.adapter.isSurfaceActive() : true;
                };
                MDCRippleFoundation.prototype.animateActivation_ = function() {
                    var _this = this;
                    var _a = MDCRippleFoundation.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
                    var _b = MDCRippleFoundation.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
                    var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
                    this.layoutInternal_();
                    var translateStart = "";
                    var translateEnd = "";
                    if (!this.adapter.isUnbounded()) {
                        var _c = this.getFgTranslationCoordinates_(), startPoint = _c.startPoint, endPoint = _c.endPoint;
                        translateStart = startPoint.x + "px, " + startPoint.y + "px";
                        translateEnd = endPoint.x + "px, " + endPoint.y + "px";
                    }
                    this.adapter.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
                    this.adapter.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
                    // Cancel any ongoing activation/deactivation animations
                    clearTimeout(this.activationTimer_);
                    clearTimeout(this.fgDeactivationRemovalTimer_);
                    this.rmBoundedActivationClasses_();
                    this.adapter.removeClass(FG_DEACTIVATION);
                    // Force layout in order to re-trigger the animation.
                    this.adapter.computeBoundingRect();
                    this.adapter.addClass(FG_ACTIVATION);
                    this.activationTimer_ = setTimeout(function() {
                        return _this.activationTimerCallback_();
                    }, DEACTIVATION_TIMEOUT_MS);
                };
                MDCRippleFoundation.prototype.getFgTranslationCoordinates_ = function() {
                    var _a = this.activationState_, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
                    var startPoint;
                    if (wasActivatedByPointer) startPoint = util_1.getNormalizedEventCoords(activationEvent, this.adapter.getWindowPageOffset(), this.adapter.computeBoundingRect());
                    else startPoint = {
                        x: this.frame_.width / 2,
                        y: this.frame_.height / 2
                    };
                    // Center the element around the start point.
                    startPoint = {
                        x: startPoint.x - this.initialSize_ / 2,
                        y: startPoint.y - this.initialSize_ / 2
                    };
                    var endPoint = {
                        x: this.frame_.width / 2 - this.initialSize_ / 2,
                        y: this.frame_.height / 2 - this.initialSize_ / 2
                    };
                    return {
                        startPoint: startPoint,
                        endPoint: endPoint
                    };
                };
                MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady_ = function() {
                    var _this = this;
                    // This method is called both when a pointing device is released, and when the activation animation ends.
                    // The deactivation animation should only run after both of those occur.
                    var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
                    var _a = this.activationState_, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
                    var activationHasEnded = hasDeactivationUXRun || !isActivated;
                    if (activationHasEnded && this.activationAnimationHasEnded_) {
                        this.rmBoundedActivationClasses_();
                        this.adapter.addClass(FG_DEACTIVATION);
                        this.fgDeactivationRemovalTimer_ = setTimeout(function() {
                            _this.adapter.removeClass(FG_DEACTIVATION);
                        }, constants_1.numbers.FG_DEACTIVATION_MS);
                    }
                };
                MDCRippleFoundation.prototype.rmBoundedActivationClasses_ = function() {
                    var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
                    this.adapter.removeClass(FG_ACTIVATION);
                    this.activationAnimationHasEnded_ = false;
                    this.adapter.computeBoundingRect();
                };
                MDCRippleFoundation.prototype.resetActivationState_ = function() {
                    var _this = this;
                    this.previousActivationEvent_ = this.activationState_.activationEvent;
                    this.activationState_ = this.defaultActivationState_();
                    // Touch devices may fire additional events for the same interaction within a short time.
                    // Store the previous event until it's safe to assume that subsequent events are for new interactions.
                    setTimeout(function() {
                        return _this.previousActivationEvent_ = undefined;
                    }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
                };
                MDCRippleFoundation.prototype.deactivate_ = function() {
                    var _this = this;
                    var activationState = this.activationState_;
                    // This can happen in scenarios such as when you have a keyup event that blurs the element.
                    if (!activationState.isActivated) return;
                    var state = __assign({}, activationState);
                    if (activationState.isProgrammatic) {
                        requestAnimationFrame(function() {
                            return _this.animateDeactivation_(state);
                        });
                        this.resetActivationState_();
                    } else {
                        this.deregisterDeactivationHandlers_();
                        requestAnimationFrame(function() {
                            _this.activationState_.hasDeactivationUXRun = true;
                            _this.animateDeactivation_(state);
                            _this.resetActivationState_();
                        });
                    }
                };
                MDCRippleFoundation.prototype.animateDeactivation_ = function(_a) {
                    var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
                    if (wasActivatedByPointer || wasElementMadeActive) this.runDeactivationUXLogicIfReady_();
                };
                MDCRippleFoundation.prototype.layoutInternal_ = function() {
                    var _this = this;
                    this.frame_ = this.adapter.computeBoundingRect();
                    var maxDim = Math.max(this.frame_.height, this.frame_.width);
                    // Surface diameter is treated differently for unbounded vs. bounded ripples.
                    // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
                    // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
                    // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
                    // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
                    // `overflow: hidden`.
                    var getBoundedRadius = function getBoundedRadius() {
                        var hypotenuse = Math.sqrt(Math.pow(_this.frame_.width, 2) + Math.pow(_this.frame_.height, 2));
                        return hypotenuse + MDCRippleFoundation.numbers.PADDING;
                    };
                    this.maxRadius_ = this.adapter.isUnbounded() ? maxDim : getBoundedRadius();
                    // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
                    var initialSize = Math.floor(maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE);
                    // Unbounded ripple size should always be even number to equally center align.
                    if (this.adapter.isUnbounded() && initialSize % 2 !== 0) this.initialSize_ = initialSize - 1;
                    else this.initialSize_ = initialSize;
                    this.fgScale_ = "" + this.maxRadius_ / this.initialSize_;
                    this.updateLayoutCssVars_();
                };
                MDCRippleFoundation.prototype.updateLayoutCssVars_ = function() {
                    var _a = MDCRippleFoundation.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
                    this.adapter.updateCssVariable(VAR_FG_SIZE, this.initialSize_ + "px");
                    this.adapter.updateCssVariable(VAR_FG_SCALE, this.fgScale_);
                    if (this.adapter.isUnbounded()) {
                        this.unboundedCoords_ = {
                            left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
                            top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
                        };
                        this.adapter.updateCssVariable(VAR_LEFT, this.unboundedCoords_.left + "px");
                        this.adapter.updateCssVariable(VAR_TOP, this.unboundedCoords_.top + "px");
                    }
                };
                return MDCRippleFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCRippleFoundation = MDCRippleFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCRippleFoundation;
        /***/ },
        /***/ "./packages/mdc-ripple/util.ts": /*!*************************************!*\
  !*** ./packages/mdc-ripple/util.ts ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getNormalizedEventCoords = exports.supportsCssVariables = void 0;
            /**
 * Stores result from supportsCssVariables to avoid redundant processing to
 * detect CSS custom variable support.
 */ var supportsCssVariables_;
            function supportsCssVariables(windowObj, forceRefresh) {
                if (forceRefresh === void 0) forceRefresh = false;
                var CSS = windowObj.CSS;
                var supportsCssVars = supportsCssVariables_;
                if (typeof supportsCssVariables_ === "boolean" && !forceRefresh) return supportsCssVariables_;
                var supportsFunctionPresent = CSS && typeof CSS.supports === "function";
                if (!supportsFunctionPresent) return false;
                var explicitlySupportsCssVars = CSS.supports("--css-vars", "yes");
                // See: https://bugs.webkit.org/show_bug.cgi?id=154669
                // See: README section on Safari
                var weAreFeatureDetectingSafari10plus = CSS.supports("(--css-vars: yes)") && CSS.supports("color", "#00000000");
                supportsCssVars = explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
                if (!forceRefresh) supportsCssVariables_ = supportsCssVars;
                return supportsCssVars;
            }
            exports.supportsCssVariables = supportsCssVariables;
            function getNormalizedEventCoords(evt, pageOffset, clientRect) {
                if (!evt) return {
                    x: 0,
                    y: 0
                };
                var x = pageOffset.x, y = pageOffset.y;
                var documentX = x + clientRect.left;
                var documentY = y + clientRect.top;
                var normalizedX;
                var normalizedY;
                // Determine touch point relative to the ripple container.
                if (evt.type === "touchstart") {
                    var touchEvent = evt;
                    normalizedX = touchEvent.changedTouches[0].pageX - documentX;
                    normalizedY = touchEvent.changedTouches[0].pageY - documentY;
                } else {
                    var mouseEvent = evt;
                    normalizedX = mouseEvent.pageX - documentX;
                    normalizedY = mouseEvent.pageY - documentY;
                }
                return {
                    x: normalizedX,
                    y: normalizedY
                };
            }
            exports.getNormalizedEventCoords = getNormalizedEventCoords;
        /***/ },
        /***/ "./packages/mdc-select/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-select/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelect = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/floating-label/component */ "./packages/mdc-floating-label/component.ts");
            var component_3 = __webpack_require__(/*! @material/line-ripple/component */ "./packages/mdc-line-ripple/component.ts");
            var menuSurfaceConstants = __importStar(__webpack_require__(/*! @material/menu-surface/constants */ "./packages/mdc-menu-surface/constants.ts"));
            var menuConstants = __importStar(__webpack_require__(/*! @material/menu/constants */ "./packages/mdc-menu/constants.ts"));
            var component_4 = __webpack_require__(/*! @material/notched-outline/component */ "./packages/mdc-notched-outline/component.ts");
            var component_5 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-select/foundation.ts");
            var component_6 = __webpack_require__(/*! ./helper-text/component */ "./packages/mdc-select/helper-text/component.ts");
            var component_7 = __webpack_require__(/*! ./icon/component */ "./packages/mdc-select/icon/component.ts");
            var MDCSelect = /** @class */ function(_super) {
                __extends(MDCSelect, _super);
                function MDCSelect() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSelect.attachTo = function(root) {
                    return new MDCSelect(root);
                };
                MDCSelect.prototype.initialize = function(labelFactory, lineRippleFactory, outlineFactory, iconFactory, helperTextFactory) {
                    if (labelFactory === void 0) labelFactory = function labelFactory(el) {
                        return new component_2.MDCFloatingLabel(el);
                    };
                    if (lineRippleFactory === void 0) lineRippleFactory = function lineRippleFactory(el) {
                        return new component_3.MDCLineRipple(el);
                    };
                    if (outlineFactory === void 0) outlineFactory = function outlineFactory(el) {
                        return new component_4.MDCNotchedOutline(el);
                    };
                    if (iconFactory === void 0) iconFactory = function iconFactory(el) {
                        return new component_7.MDCSelectIcon(el);
                    };
                    if (helperTextFactory === void 0) helperTextFactory = function helperTextFactory(el) {
                        return new component_6.MDCSelectHelperText(el);
                    };
                    this.selectAnchor = this.root.querySelector(constants_1.strings.SELECT_ANCHOR_SELECTOR);
                    this.selectedText = this.root.querySelector(constants_1.strings.SELECTED_TEXT_SELECTOR);
                    this.hiddenInput = this.root.querySelector(constants_1.strings.HIDDEN_INPUT_SELECTOR);
                    if (!this.selectedText) throw new Error("MDCSelect: Missing required element: The following selector must be present: " + ("'" + constants_1.strings.SELECTED_TEXT_SELECTOR + "'"));
                    if (this.selectAnchor.hasAttribute(constants_1.strings.ARIA_CONTROLS)) {
                        var helperTextElement = document.getElementById(this.selectAnchor.getAttribute(constants_1.strings.ARIA_CONTROLS));
                        if (helperTextElement) this.helperText = helperTextFactory(helperTextElement);
                    }
                    this.menuSetup();
                    var labelElement = this.root.querySelector(constants_1.strings.LABEL_SELECTOR);
                    this.label = labelElement ? labelFactory(labelElement) : null;
                    var lineRippleElement = this.root.querySelector(constants_1.strings.LINE_RIPPLE_SELECTOR);
                    this.lineRipple = lineRippleElement ? lineRippleFactory(lineRippleElement) : null;
                    var outlineElement = this.root.querySelector(constants_1.strings.OUTLINE_SELECTOR);
                    this.outline = outlineElement ? outlineFactory(outlineElement) : null;
                    var leadingIcon = this.root.querySelector(constants_1.strings.LEADING_ICON_SELECTOR);
                    if (leadingIcon) this.leadingIcon = iconFactory(leadingIcon);
                    if (!this.root.classList.contains(constants_1.cssClasses.OUTLINED)) this.ripple = this.createRipple();
                };
                /**
     * Initializes the select's event listeners and internal state based
     * on the environment's state.
     */ MDCSelect.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleFocus = function() {
                        _this.foundation.handleFocus();
                    };
                    this.handleBlur = function() {
                        _this.foundation.handleBlur();
                    };
                    this.handleClick = function(evt) {
                        _this.selectAnchor.focus();
                        _this.foundation.handleClick(_this.getNormalizedXCoordinate(evt));
                    };
                    this.handleKeydown = function(evt) {
                        _this.foundation.handleKeydown(evt);
                    };
                    this.handleMenuItemAction = function(evt) {
                        _this.foundation.handleMenuItemAction(evt.detail.index);
                    };
                    this.handleMenuOpened = function() {
                        _this.foundation.handleMenuOpened();
                    };
                    this.handleMenuClose = function() {
                        _this.menu.open = false;
                    };
                    this.handleMenuClosed = function() {
                        _this.foundation.handleMenuClosed();
                    };
                    this.handleMenuClosing = function() {
                        _this.foundation.handleMenuClosing();
                    };
                    this.selectAnchor.addEventListener("focus", this.handleFocus);
                    this.selectAnchor.addEventListener("blur", this.handleBlur);
                    this.selectAnchor.addEventListener("click", this.handleClick);
                    this.selectAnchor.addEventListener("keydown", this.handleKeydown);
                    this.menu.listen("MDCMenuSurface:close", this.handleMenuClose);
                    this.menu.listen(menuSurfaceConstants.strings.CLOSED_EVENT, this.handleMenuClosed);
                    this.menu.listen(menuSurfaceConstants.strings.CLOSING_EVENT, this.handleMenuClosing);
                    this.menu.listen(menuSurfaceConstants.strings.OPENED_EVENT, this.handleMenuOpened);
                    this.menu.listen(menuConstants.strings.SELECTED_EVENT, this.handleMenuItemAction);
                    if (this.hiddenInput) {
                        if (this.hiddenInput.value) {
                            // If the hidden input already has a value, use it to restore the
                            // select's value. This can happen e.g. if the user goes back or (in
                            // some browsers) refreshes the page.
                            this.foundation.layout();
                            return;
                        }
                    }
                };
                MDCSelect.prototype.destroy = function() {
                    this.selectAnchor.removeEventListener("focus", this.handleFocus);
                    this.selectAnchor.removeEventListener("blur", this.handleBlur);
                    this.selectAnchor.removeEventListener("keydown", this.handleKeydown);
                    this.selectAnchor.removeEventListener("click", this.handleClick);
                    this.menu.unlisten("MDCMenuSurface:close", this.handleMenuClose);
                    this.menu.unlisten(menuSurfaceConstants.strings.CLOSED_EVENT, this.handleMenuClosed);
                    this.menu.unlisten(menuSurfaceConstants.strings.CLOSING_EVENT, this.handleMenuClosed);
                    this.menu.unlisten(menuSurfaceConstants.strings.OPENED_EVENT, this.handleMenuOpened);
                    this.menu.unlisten(menuConstants.strings.SELECTED_EVENT, this.handleMenuItemAction);
                    this.menu.destroy();
                    if (this.ripple) this.ripple.destroy();
                    if (this.outline) this.outline.destroy();
                    if (this.leadingIcon) this.leadingIcon.destroy();
                    if (this.helperText) this.helperText.destroy();
                    _super.prototype.destroy.call(this);
                };
                Object.defineProperty(MDCSelect.prototype, "menuItemValues", {
                    get: function get() {
                        return this.menu.items.map(function(el) {
                            return el.getAttribute(constants_1.strings.VALUE_ATTR) || "";
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelect.prototype.clickMenuItem = function(index) {
                    if (index < 0 || index >= this.menu.items.length) return;
                    this.menu.items[index].click();
                };
                Object.defineProperty(MDCSelect.prototype, "selectedIndex", {
                    get: function get() {
                        return this.foundation.getSelectedIndex();
                    },
                    set: function set(selectedIndex) {
                        this.foundation.setSelectedIndex(selectedIndex, /* closeMenu */ true);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelect.prototype.setSelectedIndex = function(selectedIndex, skipNotify) {
                    if (skipNotify === void 0) skipNotify = false;
                    this.foundation.setSelectedIndex(selectedIndex, /* closeMenu */ true, skipNotify);
                };
                Object.defineProperty(MDCSelect.prototype, "disabled", {
                    get: function get() {
                        return this.foundation.getDisabled();
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                        if (this.hiddenInput) this.hiddenInput.disabled = disabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "leadingIconAriaLabel", {
                    set: function set(label) {
                        this.foundation.setLeadingIconAriaLabel(label);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "leadingIconContent", {
                    /**
         * Sets the text content of the leading icon.
         */ set: function set(content) {
                        this.foundation.setLeadingIconContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "helperTextContent", {
                    /**
         * Sets the text content of the helper text.
         */ set: function set(content) {
                        this.foundation.setHelperTextContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "useDefaultValidation", {
                    /**
         * Enables or disables the default validation scheme where a required select
         * must be non-empty. Set to false for custom validation.
         * @param useDefaultValidation Set this to false to ignore default
         *     validation scheme.
         */ set: function set(useDefaultValidation) {
                        this.foundation.setUseDefaultValidation(useDefaultValidation);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "valid", {
                    /**
         * Checks if the select is in a valid state.
         */ get: function get() {
                        return this.foundation.isValid();
                    },
                    /**
         * Sets the current invalid state of the select.
         */ set: function set(isValid) {
                        this.foundation.setValid(isValid);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelect.prototype, "required", {
                    /**
         * Returns whether the select is required.
         */ get: function get() {
                        return this.foundation.getRequired();
                    },
                    /**
         * Sets the control to the required state.
         */ set: function set(isRequired) {
                        this.foundation.setRequired(isRequired);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Re-calculates if the notched outline should be notched and if the label
     * should float.
     */ MDCSelect.prototype.layout = function() {
                    this.foundation.layout();
                };
                /**
     * Synchronizes the list of options with the state of the foundation. Call
     * this whenever menu options are dynamically updated.
     */ MDCSelect.prototype.layoutOptions = function() {
                    this.foundation.layoutOptions();
                    this.menu.layout();
                };
                MDCSelect.prototype.getDefaultFoundation = function() {
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = __assign(__assign(__assign(__assign({}, this.getSelectAdapterMethods()), this.getCommonAdapterMethods()), this.getOutlineAdapterMethods()), this.getLabelAdapterMethods());
                    return new foundation_2.MDCSelectFoundation(adapter, this.getFoundationMap());
                };
                /**
     * Handles setup for the menu.
     */ MDCSelect.prototype.menuSetup = function() {
                    this.menuElement = this.root.querySelector(constants_1.strings.MENU_SELECTOR);
                    this.menuElement.init();
                    this.menu = this.menuElement.menu_;
                    /* TODO(revise): hasTypeahead */ this.menu.hasTypeahead = true;
                    /* TODO(revise): singleSelection */ this.menu.singleSelection = true;
                };
                MDCSelect.prototype.createRipple = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign({}, component_5.MDCRipple.createAdapter({
                        root: this.selectAnchor
                    })), {
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            _this.selectAnchor.addEventListener(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            _this.selectAnchor.removeEventListener(evtType, handler);
                        }
                    });
                    // tslint:enable:object-literal-sort-keys
                    return new component_5.MDCRipple(this.selectAnchor, new foundation_1.MDCRippleFoundation(adapter));
                };
                MDCSelect.prototype.getSelectAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        getMenuItemAttr: function getMenuItemAttr(menuItem, attr) {
                            return menuItem.getAttribute(attr);
                        },
                        setSelectedText: function setSelectedText(text) {
                            _this.selectedText.textContent = text;
                        },
                        isSelectAnchorFocused: function isSelectAnchorFocused() {
                            return document.activeElement === _this.selectAnchor;
                        },
                        getSelectAnchorAttr: function getSelectAnchorAttr(attr) {
                            return _this.selectAnchor.getAttribute(attr);
                        },
                        setSelectAnchorAttr: function setSelectAnchorAttr(attr, value) {
                            _this.selectAnchor.setAttribute(attr, value);
                        },
                        removeSelectAnchorAttr: function removeSelectAnchorAttr(attr) {
                            _this.selectAnchor.removeAttribute(attr);
                        },
                        addMenuClass: function addMenuClass(className) {
                            _this.menuElement.classList.add(className);
                        },
                        removeMenuClass: function removeMenuClass(className) {
                            _this.menuElement.classList.remove(className);
                        },
                        openMenu: function openMenu() {
                            _this.menu.open = true;
                        },
                        closeMenu: function closeMenu() {
                            _this.menu.open = false;
                        },
                        getAnchorElement: function getAnchorElement() {
                            return _this.root.querySelector(constants_1.strings.SELECT_ANCHOR_SELECTOR);
                        },
                        setMenuAnchorElement: function setMenuAnchorElement(anchorEl) {
                            _this.menu.setAnchorElement(anchorEl);
                        },
                        setMenuAnchorCorner: function setMenuAnchorCorner(anchorCorner) {
                            _this.menu.setAnchorCorner(anchorCorner);
                        },
                        setMenuWrapFocus: function setMenuWrapFocus(wrapFocus) {
                            _this.menu.wrapFocus = wrapFocus;
                        },
                        getSelectedIndex: function getSelectedIndex() {
                            var index = _this.menu.selectedIndex;
                            return index instanceof Array ? index[0] : index;
                        },
                        setSelectedIndex: function setSelectedIndex(index) {
                            _this.menu.selectedIndex = index;
                        },
                        focusMenuItemAtIndex: function focusMenuItemAtIndex(index) {
                            _this.menu.items[index].focus();
                        },
                        getMenuItemCount: function getMenuItemCount() {
                            return _this.menu.items.length;
                        },
                        // Cache menu item values. layoutOptions() updates this cache.
                        getMenuItemValues: function getMenuItemValues() {
                            return _this.menuItemValues;
                        },
                        clickMenuItem: function clickMenuItem(index) {
                            return _this.clickMenuItem(index);
                        },
                        getMenuItemTextAtIndex: function getMenuItemTextAtIndex(index) {
                            return _this.menu.getPrimaryTextAtIndex(index);
                        },
                        isTypeaheadInProgress: function isTypeaheadInProgress() {
                            return _this.menu.typeaheadInProgress;
                        },
                        typeaheadMatchItem: function typeaheadMatchItem(nextChar, startingIndex) {
                            return _this.menu.typeaheadMatchItem(nextChar, startingIndex);
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCSelect.prototype.getCommonAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        addClass: function addClass(className) {
                            _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        setRippleCenter: function setRippleCenter(normalizedX) {
                            _this.lineRipple && _this.lineRipple.setRippleCenter(normalizedX);
                        },
                        activateBottomLine: function activateBottomLine() {
                            _this.lineRipple && _this.lineRipple.activate();
                        },
                        deactivateBottomLine: function deactivateBottomLine() {
                            _this.lineRipple && _this.lineRipple.deactivate();
                        },
                        notifyChange: function notifyChange(value) {
                            if (_this.hiddenInput) _this.hiddenInput.value = value;
                            var index = _this.selectedIndex;
                            _this.emit(constants_1.strings.CHANGE_EVENT, {
                                value: value,
                                index: index
                            }, true);
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCSelect.prototype.getOutlineAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        hasOutline: function hasOutline() {
                            return Boolean(_this.outline);
                        },
                        notchOutline: function notchOutline(labelWidth) {
                            _this.outline && _this.outline.notch(labelWidth);
                        },
                        closeOutline: function closeOutline() {
                            _this.outline && _this.outline.closeNotch();
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCSelect.prototype.getLabelAdapterMethods = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        hasLabel: function hasLabel() {
                            return !!_this.label;
                        },
                        floatLabel: function floatLabel(shouldFloat) {
                            _this.label && _this.label.float(shouldFloat);
                        },
                        getLabelWidth: function getLabelWidth() {
                            return _this.label ? _this.label.getWidth() : 0;
                        },
                        setLabelRequired: function setLabelRequired(isRequired) {
                            _this.label && _this.label.setRequired(isRequired);
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                /**
     * Calculates where the line ripple should start based on the x coordinate within the component.
     */ MDCSelect.prototype.getNormalizedXCoordinate = function(evt) {
                    var targetClientRect = evt.target.getBoundingClientRect();
                    var xCoordinate = this.isTouchEvent(evt) ? evt.touches[0].clientX : evt.clientX;
                    return xCoordinate - targetClientRect.left;
                };
                MDCSelect.prototype.isTouchEvent = function(evt) {
                    return Boolean(evt.touches);
                };
                /**
     * Returns a map of all subcomponents to subfoundations.
     */ MDCSelect.prototype.getFoundationMap = function() {
                    return {
                        helperText: this.helperText ? this.helperText.foundationForSelect : undefined,
                        leadingIcon: this.leadingIcon ? this.leadingIcon.foundationForSelect : undefined
                    };
                };
                return MDCSelect;
            }(component_1.MDCComponent);
            exports.MDCSelect = MDCSelect;
        /***/ },
        /***/ "./packages/mdc-select/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-select/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ACTIVATED: "mdc-select--activated",
                DISABLED: "mdc-select--disabled",
                FOCUSED: "mdc-select--focused",
                INVALID: "mdc-select--invalid",
                MENU_INVALID: "mdc-select__menu--invalid",
                OUTLINED: "mdc-select--outlined",
                REQUIRED: "mdc-select--required",
                ROOT: "mdc-select",
                WITH_LEADING_ICON: "mdc-select--with-leading-icon"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_CONTROLS: "aria-controls",
                ARIA_DESCRIBEDBY: "aria-describedby",
                ARIA_SELECTED_ATTR: "aria-selected",
                CHANGE_EVENT: "MDCSelect:change",
                HIDDEN_INPUT_SELECTOR: 'input[type="hidden"]',
                LABEL_SELECTOR: ".mdc-floating-label",
                LEADING_ICON_SELECTOR: ".mdc-select__icon",
                LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
                MENU_SELECTOR: ".mdc-select__menu",
                OUTLINE_SELECTOR: ".mdc-notched-outline",
                SELECTED_TEXT_SELECTOR: ".mdc-select__selected-text",
                SELECT_ANCHOR_SELECTOR: ".mdc-select__anchor",
                VALUE_ATTR: "data-value"
            };
            exports.strings = strings;
            var numbers = {
                LABEL_SCALE: 0.75,
                UNSET_INDEX: -1,
                CLICK_DEBOUNCE_TIMEOUT_MS: 330
            };
            exports.numbers = numbers;
        /***/ },
        /***/ "./packages/mdc-select/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-select/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-select/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSelect = function(_HTMLElement) {
                _inherits(MdcSelect, _HTMLElement);
                _createClass(MdcSelect, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.select_.selectAnchor.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.select_.selectAnchor.blur();
                        }
                    },
                    {
                        key: "selectedIndex",
                        get: function get() {
                            return !!this.select_ ? this.select_.selectedIndex : this.selectedIndex_;
                        },
                        set: function set(selectedIndex) {
                            this.selectedIndex_ = selectedIndex;
                            if (!!this.select_) this.select_.selectedIndex = selectedIndex;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return !!this.select_ ? this.select_.disabled : this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.select_) this.select_.disabled = disabled;
                        }
                    },
                    {
                        key: "valid",
                        get: function get() {
                            return !!this.select_ ? this.select_.valid : this.valid_;
                        },
                        set: function set(valid) {
                            this.valid_ = valid;
                            if (!!this.select_) this.select_.valid = valid;
                        }
                    },
                    {
                        key: "required",
                        get: function get() {
                            return !!this.select_ ? this.select_.required : this.required_;
                        },
                        set: function set(required) {
                            this.required_ = required;
                            if (!!this.select_) this.select_.required = required;
                        }
                    }
                ]);
                function MdcSelect() {
                    _classCallCheck(this, MdcSelect);
                    var _this = _possibleConstructorReturn(this, (MdcSelect.__proto__ || Object.getPrototypeOf(MdcSelect)).call(this));
                    _this.selectedIndex_ = -1;
                    _this.disabled_ = false;
                    _this.valid_ = true;
                    _this.required_ = false;
                    _this.select_;
                    return _this;
                }
                _createClass(MdcSelect, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.select_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSelect"](this);
                            this.select_.disabled = this.disabled_;
                            this.select_.valid = this.valid_;
                            this.select_.required = this.required_;
                            this.select_.selectedIndex = this.selectedIndex_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.select_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSelect;
            }(HTMLElement);
            customElements.define("mdc-select", MdcSelect);
        /***/ },
        /***/ "./packages/mdc-select/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-select/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var keyboard_1 = __webpack_require__(/*! @material/dom/keyboard */ "./packages/mdc-dom/keyboard.ts");
            var constants_1 = __webpack_require__(/*! @material/menu-surface/constants */ "./packages/mdc-menu-surface/constants.ts");
            var constants_2 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/constants.ts");
            var MDCSelectFoundation = /** @class */ function(_super) {
                __extends(MDCSelectFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCSelectFoundation(adapter, foundationMap) {
                    if (foundationMap === void 0) foundationMap = {};
                    var _this = _super.call(this, __assign(__assign({}, MDCSelectFoundation.defaultAdapter), adapter)) || this;
                    // Disabled state
                    _this.disabled = false;
                    // isMenuOpen is used to track the state of the menu by listening to the
                    // MDCMenuSurface:closed event For reference, menu.open will return false if
                    // the menu is still closing, but isMenuOpen returns false only after the menu
                    // has closed
                    _this.isMenuOpen = false;
                    // By default, select is invalid if it is required but no value is selected.
                    _this.useDefaultValidation = true;
                    _this.customValidity = true;
                    _this.lastSelectedIndex = constants_2.numbers.UNSET_INDEX;
                    _this.clickDebounceTimeout = 0;
                    _this.recentlyClicked = false;
                    _this.leadingIcon = foundationMap.leadingIcon;
                    _this.helperText = foundationMap.helperText;
                    return _this;
                }
                Object.defineProperty(MDCSelectFoundation, "cssClasses", {
                    get: function get() {
                        return constants_2.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectFoundation, "numbers", {
                    get: function get() {
                        return constants_2.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectFoundation, "strings", {
                    get: function get() {
                        return constants_2.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCSelectAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            activateBottomLine: function activateBottomLine() {
                                return undefined;
                            },
                            deactivateBottomLine: function deactivateBottomLine() {
                                return undefined;
                            },
                            getSelectedIndex: function getSelectedIndex() {
                                return -1;
                            },
                            setSelectedIndex: function setSelectedIndex() {
                                return undefined;
                            },
                            hasLabel: function hasLabel() {
                                return false;
                            },
                            floatLabel: function floatLabel() {
                                return undefined;
                            },
                            getLabelWidth: function getLabelWidth() {
                                return 0;
                            },
                            setLabelRequired: function setLabelRequired() {
                                return undefined;
                            },
                            hasOutline: function hasOutline() {
                                return false;
                            },
                            notchOutline: function notchOutline() {
                                return undefined;
                            },
                            closeOutline: function closeOutline() {
                                return undefined;
                            },
                            setRippleCenter: function setRippleCenter() {
                                return undefined;
                            },
                            notifyChange: function notifyChange() {
                                return undefined;
                            },
                            setSelectedText: function setSelectedText() {
                                return undefined;
                            },
                            isSelectAnchorFocused: function isSelectAnchorFocused() {
                                return false;
                            },
                            getSelectAnchorAttr: function getSelectAnchorAttr() {
                                return "";
                            },
                            setSelectAnchorAttr: function setSelectAnchorAttr() {
                                return undefined;
                            },
                            removeSelectAnchorAttr: function removeSelectAnchorAttr() {
                                return undefined;
                            },
                            addMenuClass: function addMenuClass() {
                                return undefined;
                            },
                            removeMenuClass: function removeMenuClass() {
                                return undefined;
                            },
                            openMenu: function openMenu() {
                                return undefined;
                            },
                            closeMenu: function closeMenu() {
                                return undefined;
                            },
                            getAnchorElement: function getAnchorElement() {
                                return null;
                            },
                            setMenuAnchorElement: function setMenuAnchorElement() {
                                return undefined;
                            },
                            setMenuAnchorCorner: function setMenuAnchorCorner() {
                                return undefined;
                            },
                            setMenuWrapFocus: function setMenuWrapFocus() {
                                return undefined;
                            },
                            focusMenuItemAtIndex: function focusMenuItemAtIndex() {
                                return undefined;
                            },
                            getMenuItemCount: function getMenuItemCount() {
                                return 0;
                            },
                            clickMenuItem: function clickMenuItem() {
                                return undefined;
                            },
                            getMenuItemValues: function getMenuItemValues() {
                                return [];
                            },
                            getMenuItemTextAtIndex: function getMenuItemTextAtIndex() {
                                return "";
                            },
                            isTypeaheadInProgress: function isTypeaheadInProgress() {
                                return false;
                            },
                            typeaheadMatchItem: function typeaheadMatchItem() {
                                return -1;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Returns the index of the currently selected menu item, or -1 if none. */ MDCSelectFoundation.prototype.getSelectedIndex = function() {
                    return this.adapter.getSelectedIndex();
                };
                MDCSelectFoundation.prototype.setSelectedIndex = function(index, closeMenu, skipNotify) {
                    if (closeMenu === void 0) closeMenu = false;
                    if (skipNotify === void 0) skipNotify = false;
                    if (index >= this.adapter.getMenuItemCount()) return;
                    if (index === constants_2.numbers.UNSET_INDEX) this.adapter.setSelectedText("");
                    else this.adapter.setSelectedText(this.adapter.getMenuItemTextAtIndex(index).trim());
                    this.adapter.setSelectedIndex(index);
                    if (closeMenu) this.adapter.closeMenu();
                    if (!skipNotify && this.lastSelectedIndex !== index) this.handleChange();
                    this.lastSelectedIndex = index;
                };
                MDCSelectFoundation.prototype.getValue = function() {
                    var index = this.adapter.getSelectedIndex();
                    var menuItemValues = this.adapter.getMenuItemValues();
                    return index !== constants_2.numbers.UNSET_INDEX ? menuItemValues[index] : "";
                };
                MDCSelectFoundation.prototype.getDisabled = function() {
                    return this.disabled;
                };
                MDCSelectFoundation.prototype.setDisabled = function(isDisabled) {
                    this.disabled = isDisabled;
                    if (this.disabled) {
                        this.adapter.addClass(constants_2.cssClasses.DISABLED);
                        this.adapter.closeMenu();
                    } else this.adapter.removeClass(constants_2.cssClasses.DISABLED);
                    if (this.leadingIcon) this.leadingIcon.setDisabled(this.disabled);
                    if (this.disabled) // Prevent click events from focusing select. Simply pointer-events: none
                    // is not enough since screenreader clicks may bypass this.
                    this.adapter.removeSelectAnchorAttr("tabindex");
                    else this.adapter.setSelectAnchorAttr("tabindex", "0");
                    this.adapter.setSelectAnchorAttr("aria-disabled", this.disabled.toString());
                };
                /** Opens the menu. */ MDCSelectFoundation.prototype.openMenu = function() {
                    this.adapter.addClass(constants_2.cssClasses.ACTIVATED);
                    this.adapter.openMenu();
                    this.isMenuOpen = true;
                    this.adapter.setSelectAnchorAttr("aria-expanded", "true");
                };
                /**
     * @param content Sets the content of the helper text.
     */ MDCSelectFoundation.prototype.setHelperTextContent = function(content) {
                    if (this.helperText) this.helperText.setContent(content);
                };
                /**
     * Re-calculates if the notched outline should be notched and if the label
     * should float.
     */ MDCSelectFoundation.prototype.layout = function() {
                    if (this.adapter.hasLabel()) {
                        var optionHasValue = this.getSelectedIndex() !== constants_2.numbers.UNSET_INDEX && this.adapter.getMenuItemTextAtIndex(this.getSelectedIndex()).length > 0;
                        var isFocused = this.adapter.hasClass(constants_2.cssClasses.FOCUSED);
                        var shouldFloatAndNotch = optionHasValue || isFocused;
                        var isRequired = this.adapter.hasClass(constants_2.cssClasses.REQUIRED);
                        this.notchOutline(shouldFloatAndNotch);
                        this.adapter.floatLabel(shouldFloatAndNotch);
                        this.adapter.setLabelRequired(isRequired);
                    }
                };
                /**
     * Synchronizes the list of options with the state of the foundation. Call
     * this whenever menu options are dynamically updated.
     */ MDCSelectFoundation.prototype.layoutOptions = function() {
                    var menuItemValues = this.adapter.getMenuItemValues();
                    var selectedIndex = menuItemValues.indexOf(this.getValue());
                    this.setSelectedIndex(selectedIndex, /** closeMenu */ false, /** skipNotify */ true);
                };
                MDCSelectFoundation.prototype.handleMenuOpened = function() {
                    if (this.adapter.getMenuItemValues().length === 0) return;
                    // Menu should open to the last selected element, should open to first menu item otherwise.
                    var selectedIndex = this.getSelectedIndex();
                    var focusItemIndex = selectedIndex >= 0 ? selectedIndex : 0;
                    this.adapter.focusMenuItemAtIndex(focusItemIndex);
                };
                MDCSelectFoundation.prototype.handleMenuClosing = function() {
                    this.adapter.setSelectAnchorAttr("aria-expanded", "false");
                };
                MDCSelectFoundation.prototype.handleMenuClosed = function() {
                    this.adapter.removeClass(constants_2.cssClasses.ACTIVATED);
                    this.isMenuOpen = false;
                    // Unfocus the select if menu is closed without a selection
                    if (!this.adapter.isSelectAnchorFocused()) this.blur();
                };
                /**
     * Handles value changes, via change event or programmatic updates.
     */ MDCSelectFoundation.prototype.handleChange = function() {
                    this.layout();
                    var isRequired = this.adapter.hasClass(constants_2.cssClasses.REQUIRED);
                    if (isRequired && this.useDefaultValidation) this.setValid(this.isValid());
                };
                MDCSelectFoundation.prototype.handleMenuItemAction = function(index) {
                    this.setSelectedIndex(index, /** closeMenu */ true);
                };
                /**
     * Handles focus events from select element.
     */ MDCSelectFoundation.prototype.handleFocus = function() {
                    this.adapter.addClass(constants_2.cssClasses.FOCUSED);
                    this.layout();
                    this.adapter.activateBottomLine();
                };
                /**
     * Handles blur events from select element.
     */ MDCSelectFoundation.prototype.handleBlur = function() {
                    if (this.isMenuOpen) return;
                    this.blur();
                };
                MDCSelectFoundation.prototype.handleClick = function(normalizedX) {
                    if (this.disabled || this.recentlyClicked) return;
                    this.setClickDebounceTimeout();
                    if (this.isMenuOpen) {
                        this.adapter.closeMenu();
                        return;
                    }
                    this.adapter.setRippleCenter(normalizedX);
                    this.openMenu();
                };
                /**
     * Handles keydown events on select element. Depending on the type of
     * character typed, does typeahead matching or opens menu.
     */ MDCSelectFoundation.prototype.handleKeydown = function(event) {
                    if (this.isMenuOpen || !this.adapter.hasClass(constants_2.cssClasses.FOCUSED)) return;
                    var isEnter = keyboard_1.normalizeKey(event) === keyboard_1.KEY.ENTER;
                    var isSpace = keyboard_1.normalizeKey(event) === keyboard_1.KEY.SPACEBAR;
                    var arrowUp = keyboard_1.normalizeKey(event) === keyboard_1.KEY.ARROW_UP;
                    var arrowDown = keyboard_1.normalizeKey(event) === keyboard_1.KEY.ARROW_DOWN;
                    var isModifier = event.ctrlKey || event.metaKey;
                    // Typeahead
                    if (!isModifier && (!isSpace && event.key && event.key.length === 1 || isSpace && this.adapter.isTypeaheadInProgress())) {
                        var key = isSpace ? " " : event.key;
                        var typeaheadNextIndex = this.adapter.typeaheadMatchItem(key, this.getSelectedIndex());
                        if (typeaheadNextIndex >= 0) {
                            this.adapter.clickMenuItem(typeaheadNextIndex);
                            this.setSelectedIndex(typeaheadNextIndex);
                        }
                        event.preventDefault();
                        return;
                    }
                    if (!isEnter && !isSpace && !arrowUp && !arrowDown) return;
                    this.openMenu();
                    event.preventDefault();
                };
                /**
     * Opens/closes the notched outline.
     */ MDCSelectFoundation.prototype.notchOutline = function(openNotch) {
                    if (!this.adapter.hasOutline()) return;
                    var isFocused = this.adapter.hasClass(constants_2.cssClasses.FOCUSED);
                    if (openNotch) {
                        var labelScale = constants_2.numbers.LABEL_SCALE;
                        var labelWidth = this.adapter.getLabelWidth() * labelScale;
                        this.adapter.notchOutline(labelWidth);
                    } else if (!isFocused) this.adapter.closeOutline();
                };
                /**
     * Sets the aria label of the leading icon.
     */ MDCSelectFoundation.prototype.setLeadingIconAriaLabel = function(label) {
                    if (this.leadingIcon) this.leadingIcon.setAriaLabel(label);
                };
                /**
     * Sets the text content of the leading icon.
     */ MDCSelectFoundation.prototype.setLeadingIconContent = function(content) {
                    if (this.leadingIcon) this.leadingIcon.setContent(content);
                };
                MDCSelectFoundation.prototype.setUseDefaultValidation = function(useDefaultValidation) {
                    this.useDefaultValidation = useDefaultValidation;
                };
                MDCSelectFoundation.prototype.setValid = function(isValid) {
                    if (!this.useDefaultValidation) this.customValidity = isValid;
                    this.adapter.setSelectAnchorAttr("aria-invalid", (!isValid).toString());
                    if (isValid) {
                        this.adapter.removeClass(constants_2.cssClasses.INVALID);
                        this.adapter.removeMenuClass(constants_2.cssClasses.MENU_INVALID);
                    } else {
                        this.adapter.addClass(constants_2.cssClasses.INVALID);
                        this.adapter.addMenuClass(constants_2.cssClasses.MENU_INVALID);
                    }
                    this.syncHelperTextValidity(isValid);
                };
                MDCSelectFoundation.prototype.isValid = function() {
                    if (this.useDefaultValidation && this.adapter.hasClass(constants_2.cssClasses.REQUIRED) && !this.adapter.hasClass(constants_2.cssClasses.DISABLED)) // See notes for required attribute under https://www.w3.org/TR/html52/sec-forms.html#the-select-element
                    // TL;DR: Invalid if no index is selected, or if the first index is selected and has an empty value.
                    return this.getSelectedIndex() !== constants_2.numbers.UNSET_INDEX && (this.getSelectedIndex() !== 0 || this.adapter.getMenuItemTextAtIndex(this.getSelectedIndex()).length > 0);
                    return this.customValidity;
                };
                MDCSelectFoundation.prototype.setRequired = function(isRequired) {
                    if (isRequired) this.adapter.addClass(constants_2.cssClasses.REQUIRED);
                    else this.adapter.removeClass(constants_2.cssClasses.REQUIRED);
                    this.adapter.setSelectAnchorAttr("aria-required", isRequired.toString());
                    this.adapter.setLabelRequired(isRequired);
                };
                MDCSelectFoundation.prototype.getRequired = function() {
                    return this.adapter.getSelectAnchorAttr("aria-required") === "true";
                };
                MDCSelectFoundation.prototype.init = function() {
                    var anchorEl = this.adapter.getAnchorElement();
                    if (anchorEl) {
                        this.adapter.setMenuAnchorElement(anchorEl);
                        this.adapter.setMenuAnchorCorner(constants_1.Corner.BOTTOM_START);
                    }
                    this.adapter.setMenuWrapFocus(false);
                    this.setDisabled(this.adapter.hasClass(constants_2.cssClasses.DISABLED));
                    this.syncHelperTextValidity(!this.adapter.hasClass(constants_2.cssClasses.INVALID));
                    this.layout();
                    this.layoutOptions();
                };
                /**
     * Unfocuses the select component.
     */ MDCSelectFoundation.prototype.blur = function() {
                    this.adapter.removeClass(constants_2.cssClasses.FOCUSED);
                    this.layout();
                    this.adapter.deactivateBottomLine();
                    var isRequired = this.adapter.hasClass(constants_2.cssClasses.REQUIRED);
                    if (isRequired && this.useDefaultValidation) this.setValid(this.isValid());
                };
                MDCSelectFoundation.prototype.syncHelperTextValidity = function(isValid) {
                    if (!this.helperText) return;
                    this.helperText.setValidity(isValid);
                    var helperTextVisible = this.helperText.isVisible();
                    var helperTextId = this.helperText.getId();
                    if (helperTextVisible && helperTextId) this.adapter.setSelectAnchorAttr(constants_2.strings.ARIA_DESCRIBEDBY, helperTextId);
                    else // Needed because screenreaders will read labels pointed to by
                    // `aria-describedby` even if they are `aria-hidden`.
                    this.adapter.removeSelectAnchorAttr(constants_2.strings.ARIA_DESCRIBEDBY);
                };
                MDCSelectFoundation.prototype.setClickDebounceTimeout = function() {
                    var _this = this;
                    clearTimeout(this.clickDebounceTimeout);
                    this.clickDebounceTimeout = setTimeout(function() {
                        _this.recentlyClicked = false;
                    }, constants_2.numbers.CLICK_DEBOUNCE_TIMEOUT_MS);
                    this.recentlyClicked = true;
                };
                return MDCSelectFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSelectFoundation = MDCSelectFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSelectFoundation;
        /***/ },
        /***/ "./packages/mdc-select/helper-text/component.ts": /*!******************************************************!*\
  !*** ./packages/mdc-select/helper-text/component.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectHelperText = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-select/helper-text/foundation.ts");
            var MDCSelectHelperText = /** @class */ function(_super) {
                __extends(MDCSelectHelperText, _super);
                function MDCSelectHelperText() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSelectHelperText.attachTo = function(root) {
                    return new MDCSelectHelperText(root);
                };
                Object.defineProperty(MDCSelectHelperText.prototype, "foundationForSelect", {
                    // Provided for access by MDCSelect component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelectHelperText.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCSelectHelperTextFoundation(adapter);
                };
                return MDCSelectHelperText;
            }(component_1.MDCComponent);
            exports.MDCSelectHelperText = MDCSelectHelperText;
        /***/ },
        /***/ "./packages/mdc-select/helper-text/constants.ts": /*!******************************************************!*\
  !*** ./packages/mdc-select/helper-text/constants.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var strings = {
                ARIA_HIDDEN: "aria-hidden",
                ROLE: "role"
            };
            exports.strings = strings;
            var cssClasses = {
                HELPER_TEXT_VALIDATION_MSG: "mdc-select-helper-text--validation-msg",
                HELPER_TEXT_VALIDATION_MSG_PERSISTENT: "mdc-select-helper-text--validation-msg-persistent"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-select/helper-text/foundation.ts": /*!*******************************************************!*\
  !*** ./packages/mdc-select/helper-text/foundation.ts ***!
  \*******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectHelperTextFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/helper-text/constants.ts");
            var MDCSelectHelperTextFoundation = /** @class */ function(_super) {
                __extends(MDCSelectHelperTextFoundation, _super);
                function MDCSelectHelperTextFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCSelectHelperTextFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCSelectHelperTextFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectHelperTextFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectHelperTextFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCSelectHelperTextAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            getAttr: function getAttr() {
                                return null;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * @return The ID of the helper text, or null if none is set.
     */ MDCSelectHelperTextFoundation.prototype.getId = function() {
                    return this.adapter.getAttr("id");
                };
                /**
     * @return Whether the helper text is currently visible.
     */ MDCSelectHelperTextFoundation.prototype.isVisible = function() {
                    return this.adapter.getAttr(constants_1.strings.ARIA_HIDDEN) !== "true";
                };
                /**
     * Sets the content of the helper text field.
     */ MDCSelectHelperTextFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                /**
     * Sets the helper text to act as a validation message.
     * By default, validation messages are hidden when the select is valid and
     * visible when the select is invalid.
     *
     * @param isValidation True to make the helper text act as an error validation
     *     message.
     */ MDCSelectHelperTextFoundation.prototype.setValidation = function(isValidation) {
                    if (isValidation) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                };
                /**
     * Sets the persistency of the validation helper text.
     * This keeps the validation message visible even if the select is valid,
     * though it will be displayed in the normal (grey) color.
     */ MDCSelectHelperTextFoundation.prototype.setValidationMsgPersistent = function(isPersistent) {
                    if (isPersistent) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG_PERSISTENT);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG_PERSISTENT);
                };
                /**
     * When acting as a validation message, shows/hides the helper text and
     * triggers alerts as necessary based on the select's validity.
     */ MDCSelectHelperTextFoundation.prototype.setValidity = function(selectIsValid) {
                    var isValidationMsg = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    if (!isValidationMsg) // Non-validating helper-text is always displayed and does not participate
                    // in validation logic.
                    return;
                    var isPersistentValidationMsg = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG_PERSISTENT);
                    // Validating helper text is displayed if select is invalid, unless it is
                    // set as persistent, in which case it always displays.
                    var msgShouldDisplay = !selectIsValid || isPersistentValidationMsg;
                    if (msgShouldDisplay) {
                        this.showToScreenReader();
                        // In addition to displaying, also trigger an alert if the select
                        // has become invalid.
                        if (!selectIsValid) this.adapter.setAttr(constants_1.strings.ROLE, "alert");
                        else this.adapter.removeAttr(constants_1.strings.ROLE);
                        return;
                    }
                    // Hide everything.
                    this.adapter.removeAttr(constants_1.strings.ROLE);
                    this.hide();
                };
                /**
     * Makes the helper text visible to screen readers.
     */ MDCSelectHelperTextFoundation.prototype.showToScreenReader = function() {
                    this.adapter.removeAttr(constants_1.strings.ARIA_HIDDEN);
                };
                /**
     * Hides the help text from screen readers.
     */ MDCSelectHelperTextFoundation.prototype.hide = function() {
                    this.adapter.setAttr(constants_1.strings.ARIA_HIDDEN, "true");
                };
                return MDCSelectHelperTextFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSelectHelperTextFoundation = MDCSelectHelperTextFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSelectHelperTextFoundation;
        /***/ },
        /***/ "./packages/mdc-select/icon/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-select/icon/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectIcon = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-select/icon/foundation.ts");
            var MDCSelectIcon = /** @class */ function(_super) {
                __extends(MDCSelectIcon, _super);
                function MDCSelectIcon() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSelectIcon.attachTo = function(root) {
                    return new MDCSelectIcon(root);
                };
                Object.defineProperty(MDCSelectIcon.prototype, "foundationForSelect", {
                    // Provided for access by MDCSelect component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelectIcon.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        },
                        notifyIconAction: function notifyIconAction() {
                            return _this.emit(foundation_1.MDCSelectIconFoundation.strings.ICON_EVENT, {} /* evtData */ , true);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCSelectIconFoundation(adapter);
                };
                return MDCSelectIcon;
            }(component_1.MDCComponent);
            exports.MDCSelectIcon = MDCSelectIcon;
        /***/ },
        /***/ "./packages/mdc-select/icon/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-select/icon/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = void 0;
            var strings = {
                ICON_EVENT: "MDCSelect:icon",
                ICON_ROLE: "button"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-select/icon/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-select/icon/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSelectIconFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-select/icon/constants.ts");
            var INTERACTION_EVENTS = [
                "click",
                "keydown"
            ];
            var MDCSelectIconFoundation = /** @class */ function(_super) {
                __extends(MDCSelectIconFoundation, _super);
                function MDCSelectIconFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCSelectIconFoundation.defaultAdapter), adapter)) || this;
                    _this.savedTabIndex_ = null;
                    _this.interactionHandler_ = function(evt) {
                        return _this.handleInteraction(evt);
                    };
                    return _this;
                }
                Object.defineProperty(MDCSelectIconFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSelectIconFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCSelectIconAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            notifyIconAction: function notifyIconAction() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSelectIconFoundation.prototype.init = function() {
                    var _this = this;
                    this.savedTabIndex_ = this.adapter.getAttr("tabindex");
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCSelectIconFoundation.prototype.destroy = function() {
                    var _this = this;
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCSelectIconFoundation.prototype.setDisabled = function(disabled) {
                    if (!this.savedTabIndex_) return;
                    if (disabled) {
                        this.adapter.setAttr("tabindex", "-1");
                        this.adapter.removeAttr("role");
                    } else {
                        this.adapter.setAttr("tabindex", this.savedTabIndex_);
                        this.adapter.setAttr("role", constants_1.strings.ICON_ROLE);
                    }
                };
                MDCSelectIconFoundation.prototype.setAriaLabel = function(label) {
                    this.adapter.setAttr("aria-label", label);
                };
                MDCSelectIconFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                MDCSelectIconFoundation.prototype.handleInteraction = function(evt) {
                    var isEnterKey = evt.key === "Enter" || evt.keyCode === 13;
                    if (evt.type === "click" || isEnterKey) this.adapter.notifyIconAction();
                };
                return MDCSelectIconFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSelectIconFoundation = MDCSelectIconFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSelectIconFoundation;
        /***/ },
        /***/ "./packages/mdc-slider/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-slider/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSlider = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-slider/constants.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-slider/foundation.ts");
            var types_1 = __webpack_require__(/*! ./types */ "./packages/mdc-slider/types.ts");
            /** Vanilla JS implementation of slider component. */ var MDCSlider = /** @class */ function(_super) {
                __extends(MDCSlider, _super);
                function MDCSlider() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.skipInitialUIUpdate = false;
                    // Function that maps a slider value to the value of the `aria-valuetext`
                    // attribute on the thumb element.
                    _this.valueToAriaValueTextFn = null;
                    return _this;
                }
                MDCSlider.attachTo = function(root, options) {
                    if (options === void 0) options = {};
                    return new MDCSlider(root, undefined, options);
                };
                MDCSlider.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same
                    // order as the adapter interface.
                    var adapter = {
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        addClass: function addClass(className) {
                            _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            _this.root.classList.remove(className);
                        },
                        addThumbClass: function addThumbClass(className, thumb) {
                            _this.getThumbEl(thumb).classList.add(className);
                        },
                        removeThumbClass: function removeThumbClass(className, thumb) {
                            _this.getThumbEl(thumb).classList.remove(className);
                        },
                        getAttribute: function getAttribute(attribute) {
                            return _this.root.getAttribute(attribute);
                        },
                        getInputValue: function getInputValue(thumb) {
                            return _this.getInput(thumb).value;
                        },
                        setInputValue: function setInputValue(value, thumb) {
                            _this.getInput(thumb).value = value;
                        },
                        getInputAttribute: function getInputAttribute(attribute, thumb) {
                            return _this.getInput(thumb).getAttribute(attribute);
                        },
                        setInputAttribute: function setInputAttribute(attribute, value, thumb) {
                            _this.getInput(thumb).setAttribute(attribute, value);
                        },
                        removeInputAttribute: function removeInputAttribute(attribute, thumb) {
                            _this.getInput(thumb).removeAttribute(attribute);
                        },
                        focusInput: function focusInput(thumb) {
                            _this.getInput(thumb).focus();
                        },
                        isInputFocused: function isInputFocused(thumb) {
                            return _this.getInput(thumb) === document.activeElement;
                        },
                        getThumbKnobWidth: function getThumbKnobWidth(thumb) {
                            return _this.getThumbEl(thumb).querySelector("." + constants_1.cssClasses.THUMB_KNOB).getBoundingClientRect().width;
                        },
                        getThumbBoundingClientRect: function getThumbBoundingClientRect(thumb) {
                            return _this.getThumbEl(thumb).getBoundingClientRect();
                        },
                        getBoundingClientRect: function getBoundingClientRect() {
                            return _this.root.getBoundingClientRect();
                        },
                        isRTL: function isRTL() {
                            return getComputedStyle(_this.root).direction === "rtl";
                        },
                        setThumbStyleProperty: function setThumbStyleProperty(propertyName, value, thumb) {
                            _this.getThumbEl(thumb).style.setProperty(propertyName, value);
                        },
                        removeThumbStyleProperty: function removeThumbStyleProperty(propertyName, thumb) {
                            _this.getThumbEl(thumb).style.removeProperty(propertyName);
                        },
                        setTrackActiveStyleProperty: function setTrackActiveStyleProperty(propertyName, value) {
                            _this.trackActive.style.setProperty(propertyName, value);
                        },
                        removeTrackActiveStyleProperty: function removeTrackActiveStyleProperty(propertyName) {
                            _this.trackActive.style.removeProperty(propertyName);
                        },
                        setValueIndicatorText: function setValueIndicatorText(value, thumb) {
                            var valueIndicatorEl = _this.getThumbEl(thumb).querySelector("." + constants_1.cssClasses.VALUE_INDICATOR_TEXT);
                            valueIndicatorEl.textContent = String(value);
                        },
                        getValueToAriaValueTextFn: function getValueToAriaValueTextFn() {
                            return _this.valueToAriaValueTextFn;
                        },
                        updateTickMarks: function updateTickMarks(tickMarks) {
                            var tickMarksContainer = _this.root.querySelector("." + constants_1.cssClasses.TICK_MARKS_CONTAINER);
                            if (!tickMarksContainer) {
                                tickMarksContainer = document.createElement("div");
                                tickMarksContainer.classList.add(constants_1.cssClasses.TICK_MARKS_CONTAINER);
                                var track = _this.root.querySelector("." + constants_1.cssClasses.TRACK);
                                track.appendChild(tickMarksContainer);
                            }
                            if (tickMarks.length !== tickMarksContainer.children.length) {
                                tickMarksContainer.innerHTML = "";
                                _this.addTickMarks(tickMarksContainer, tickMarks);
                            } else _this.updateTickMarks(tickMarksContainer, tickMarks);
                        },
                        setPointerCapture: function setPointerCapture(pointerId) {
                            _this.root.setPointerCapture(pointerId);
                        },
                        emitChangeEvent: function emitChangeEvent(value, thumb) {
                            _this.emit(constants_1.events.CHANGE, {
                                value: value,
                                thumb: thumb
                            });
                        },
                        emitInputEvent: function emitInputEvent(value, thumb) {
                            _this.emit(constants_1.events.INPUT, {
                                value: value,
                                thumb: thumb
                            });
                        },
                        emitDragStartEvent: function emitDragStartEvent(_, thumb) {
                            // Emitting event is not yet implemented. See issue:
                            // https://github.com/material-components/material-components-web/issues/6448
                            _this.getRipple(thumb).activate();
                        },
                        emitDragEndEvent: function emitDragEndEvent(_, thumb) {
                            // Emitting event is not yet implemented. See issue:
                            // https://github.com/material-components/material-components-web/issues/6448
                            _this.getRipple(thumb).deactivate();
                        },
                        registerEventHandler: function registerEventHandler(evtType, handler) {
                            _this.listen(evtType, handler);
                        },
                        deregisterEventHandler: function deregisterEventHandler(evtType, handler) {
                            _this.unlisten(evtType, handler);
                        },
                        registerThumbEventHandler: function registerThumbEventHandler(thumb, evtType, handler) {
                            _this.getThumbEl(thumb).addEventListener(evtType, handler);
                        },
                        deregisterThumbEventHandler: function deregisterThumbEventHandler(thumb, evtType, handler) {
                            _this.getThumbEl(thumb).removeEventListener(evtType, handler);
                        },
                        registerInputEventHandler: function registerInputEventHandler(thumb, evtType, handler) {
                            _this.getInput(thumb).addEventListener(evtType, handler);
                        },
                        deregisterInputEventHandler: function deregisterInputEventHandler(thumb, evtType, handler) {
                            _this.getInput(thumb).removeEventListener(evtType, handler);
                        },
                        registerBodyEventHandler: function registerBodyEventHandler(evtType, handler) {
                            document.body.addEventListener(evtType, handler);
                        },
                        deregisterBodyEventHandler: function deregisterBodyEventHandler(evtType, handler) {
                            document.body.removeEventListener(evtType, handler);
                        },
                        registerWindowEventHandler: function registerWindowEventHandler(evtType, handler) {
                            window.addEventListener(evtType, handler);
                        },
                        deregisterWindowEventHandler: function deregisterWindowEventHandler(evtType, handler) {
                            window.removeEventListener(evtType, handler);
                        }
                    };
                    return new foundation_2.MDCSliderFoundation(adapter);
                };
                /**
     * Initializes component, with the following options:
     * - `skipInitialUIUpdate`: Whether to skip updating the UI when initially
     *   syncing with the DOM. This should be enabled when the slider position
     *   is set before component initialization.
     */ MDCSlider.prototype.initialize = function(_a) {
                    var _b = _a === void 0 ? {} : _a, skipInitialUIUpdate = _b.skipInitialUIUpdate;
                    this.inputs = [].slice.call(this.root.querySelectorAll("." + constants_1.cssClasses.INPUT));
                    this.thumbs = [].slice.call(this.root.querySelectorAll("." + constants_1.cssClasses.THUMB));
                    this.trackActive = this.root.querySelector("." + constants_1.cssClasses.TRACK_ACTIVE);
                    this.ripples = this.createRipples();
                    if (skipInitialUIUpdate) this.skipInitialUIUpdate = true;
                };
                MDCSlider.prototype.initialSyncWithDOM = function() {
                    this.foundation.layout({
                        skipUpdateUI: this.skipInitialUIUpdate
                    });
                };
                /** Redraws UI based on DOM (e.g. element dimensions, RTL). */ MDCSlider.prototype.layout = function() {
                    this.foundation.layout();
                };
                MDCSlider.prototype.getValueStart = function() {
                    return this.foundation.getValueStart();
                };
                MDCSlider.prototype.setValueStart = function(valueStart) {
                    this.foundation.setValueStart(valueStart);
                };
                MDCSlider.prototype.getValue = function() {
                    return this.foundation.getValue();
                };
                MDCSlider.prototype.setValue = function(value) {
                    this.foundation.setValue(value);
                };
                /** @return Slider disabled state. */ MDCSlider.prototype.getDisabled = function() {
                    return this.foundation.getDisabled();
                };
                /** Sets slider disabled state. */ MDCSlider.prototype.setDisabled = function(disabled) {
                    this.foundation.setDisabled(disabled);
                };
                /**
     * Sets a function that maps the slider value to the value of the
     * `aria-valuetext` attribute on the thumb element.
     */ MDCSlider.prototype.setValueToAriaValueTextFn = function(mapFn) {
                    this.valueToAriaValueTextFn = mapFn;
                };
                MDCSlider.prototype.getThumbEl = function(thumb) {
                    return thumb === types_1.Thumb.END ? this.thumbs[this.thumbs.length - 1] : this.thumbs[0];
                };
                MDCSlider.prototype.getInput = function(thumb) {
                    return thumb === types_1.Thumb.END ? this.inputs[this.inputs.length - 1] : this.inputs[0];
                };
                MDCSlider.prototype.getRipple = function(thumb) {
                    return thumb === types_1.Thumb.END ? this.ripples[this.ripples.length - 1] : this.ripples[0];
                };
                /** Adds tick mark elements to the given container. */ MDCSlider.prototype.addTickMarks = function(tickMarkContainer, tickMarks) {
                    var fragment = document.createDocumentFragment();
                    for(var i = 0; i < tickMarks.length; i++){
                        var div = document.createElement("div");
                        var tickMarkClass = tickMarks[i] === types_1.TickMark.ACTIVE ? constants_1.cssClasses.TICK_MARK_ACTIVE : constants_1.cssClasses.TICK_MARK_INACTIVE;
                        div.classList.add(tickMarkClass);
                        fragment.appendChild(div);
                    }
                    tickMarkContainer.appendChild(fragment);
                };
                /** Updates tick mark elements' classes in the given container. */ MDCSlider.prototype.updateTickMarks = function(tickMarkContainer, tickMarks) {
                    var tickMarkEls = Array.from(tickMarkContainer.children);
                    for(var i = 0; i < tickMarkEls.length; i++)if (tickMarks[i] === types_1.TickMark.ACTIVE) {
                        tickMarkEls[i].classList.add(constants_1.cssClasses.TICK_MARK_ACTIVE);
                        tickMarkEls[i].classList.remove(constants_1.cssClasses.TICK_MARK_INACTIVE);
                    } else {
                        tickMarkEls[i].classList.add(constants_1.cssClasses.TICK_MARK_INACTIVE);
                        tickMarkEls[i].classList.remove(constants_1.cssClasses.TICK_MARK_ACTIVE);
                    }
                };
                /** Initializes thumb ripples. */ MDCSlider.prototype.createRipples = function() {
                    var ripples = [];
                    var rippleSurfaces = [].slice.call(this.root.querySelectorAll("." + constants_1.cssClasses.THUMB));
                    var _loop_1 = function _loop_1(i) {
                        var rippleSurface = rippleSurfaces[i];
                        // Use the corresponding input as the focus source for the ripple (i.e.
                        // when the input is focused, the ripple is in the focused state).
                        var input = this_1.inputs[i];
                        var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this_1)), {
                            addClass: function addClass(className) {
                                rippleSurface.classList.add(className);
                            },
                            computeBoundingRect: function computeBoundingRect() {
                                return rippleSurface.getBoundingClientRect();
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                                input.removeEventListener(evtType, handler);
                            },
                            isSurfaceActive: function isSurfaceActive() {
                                return ponyfill_1.matches(input, ":active");
                            },
                            isUnbounded: function isUnbounded() {
                                return true;
                            },
                            registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                                input.addEventListener(evtType, handler, events_1.applyPassive());
                            },
                            removeClass: function removeClass(className) {
                                rippleSurface.classList.remove(className);
                            },
                            updateCssVariable: function updateCssVariable(varName, value) {
                                rippleSurface.style.setProperty(varName, value);
                            }
                        });
                        var ripple = new component_2.MDCRipple(rippleSurface, new foundation_1.MDCRippleFoundation(adapter));
                        ripple.unbounded = true;
                        ripples.push(ripple);
                    };
                    var this_1 = this;
                    for(var i = 0; i < rippleSurfaces.length; i++)_loop_1(i);
                    return ripples;
                };
                return MDCSlider;
            }(component_1.MDCComponent);
            exports.MDCSlider = MDCSlider;
        /***/ },
        /***/ "./packages/mdc-slider/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-slider/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.events = exports.attributes = exports.numbers = exports.cssClasses = void 0;
            /** Slider element classes. */ exports.cssClasses = {
                DISABLED: "mdc-slider--disabled",
                DISCRETE: "mdc-slider--discrete",
                INPUT: "mdc-slider__input",
                RANGE: "mdc-slider--range",
                THUMB: "mdc-slider__thumb",
                // Applied when thumb is in the focused state.
                THUMB_FOCUSED: "mdc-slider__thumb--focused",
                THUMB_KNOB: "mdc-slider__thumb-knob",
                // Class added to the top thumb (for overlapping thumbs in range slider).
                THUMB_TOP: "mdc-slider__thumb--top",
                THUMB_WITH_INDICATOR: "mdc-slider__thumb--with-indicator",
                TICK_MARKS: "mdc-slider--tick-marks",
                TICK_MARKS_CONTAINER: "mdc-slider__tick-marks",
                TICK_MARK_ACTIVE: "mdc-slider__tick-mark--active",
                TICK_MARK_INACTIVE: "mdc-slider__tick-mark--inactive",
                TRACK: "mdc-slider__track",
                // The active track fill element that will be scaled as the value changes.
                TRACK_ACTIVE: "mdc-slider__track--active_fill",
                VALUE_INDICATOR_TEXT: "mdc-slider__value-indicator-text"
            };
            /** Slider numbers. */ exports.numbers = {
                // Default step size.
                STEP_SIZE: 1,
                // Minimum absolute difference between clientX of move event / down event
                // for which to update thumb, in the case of overlapping thumbs.
                // This is needed to reduce chances of choosing the thumb based on
                // pointer jitter.
                THUMB_UPDATE_MIN_PX: 5
            };
            /** Slider attributes. */ exports.attributes = {
                ARIA_VALUETEXT: "aria-valuetext",
                INPUT_DISABLED: "disabled",
                INPUT_MIN: "min",
                INPUT_MAX: "max",
                INPUT_VALUE: "value",
                INPUT_STEP: "step"
            };
            /** Slider events. */ exports.events = {
                CHANGE: "MDCSlider:change",
                INPUT: "MDCSlider:input"
            };
        /***/ },
        /***/ "./packages/mdc-slider/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-slider/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-slider/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSlider = function(_HTMLElement) {
                _inherits(MdcSlider, _HTMLElement);
                _createClass(MdcSlider, [
                    {
                        key: "focus",
                        value: function focus() {
                            var input = this.querySelector(".mdc-slider__input");
                            if (!input) return;
                            input.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    },
                    {
                        key: "value",
                        get: function get() {
                            if (!!this.slider_) return this.slider_.value;
                            else return this.value_;
                        },
                        set: function set(value) {
                            this.value_ = value;
                            if (!!this.slider_) this.slider_.value = value;
                        }
                    },
                    {
                        key: "min",
                        get: function get() {
                            return this.min_;
                        },
                        set: function set(min) {
                            this.min_ = min;
                            if (!!this.slider_) this.slider_.min = min;
                        }
                    },
                    {
                        key: "max",
                        get: function get() {
                            return this.max_;
                        },
                        set: function set(max) {
                            this.max_ = max;
                            if (!!this.slider_) this.slider_.max = max;
                        }
                    },
                    {
                        key: "step",
                        get: function get() {
                            return this.step_;
                        },
                        set: function set(step) {
                            this.step_ = step;
                            if (!!this.slider_) this.slider_.step = step;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.slider_) this.slider_.disabled = disabled;
                        }
                    }
                ]);
                function MdcSlider() {
                    _classCallCheck(this, MdcSlider);
                    var _this = _possibleConstructorReturn(this, (MdcSlider.__proto__ || Object.getPrototypeOf(MdcSlider)).call(this));
                    _this.value_ = 0;
                    _this.min_ = 0;
                    _this.max_ = 100;
                    _this.step_ = 0;
                    _this.disabled_ = false;
                    _this.slider_;
                    return _this;
                }
                _createClass(MdcSlider, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.style.display = "block";
                            /* TODO(width) */ this.style.width = "100%";
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.slider_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSlider"](this);
                            this.slider_.value = this.value_;
                            this.slider_.min = this.min_;
                            this.slider_.max = this.max_;
                            this.slider_.step = this.step_;
                            this.slider_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.slider_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSlider;
            }(HTMLElement);
            customElements.define("mdc-slider", MdcSlider);
        /***/ },
        /***/ "./packages/mdc-slider/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-slider/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSliderFoundation = void 0;
            var animationframe_1 = __webpack_require__(/*! @material/animation/animationframe */ "./packages/mdc-animation/animationframe.ts");
            var util_1 = __webpack_require__(/*! @material/animation/util */ "./packages/mdc-animation/util.ts");
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-slider/constants.ts");
            var types_1 = __webpack_require__(/*! ./types */ "./packages/mdc-slider/types.ts");
            var AnimationKeys;
            (function(AnimationKeys) {
                AnimationKeys["SLIDER_UPDATE"] = "slider_update";
            })(AnimationKeys || (AnimationKeys = {}));
            // Accessing `window` without a `typeof` check will throw on Node environments.
            var HAS_WINDOW = typeof window !== "undefined";
            /**
 * Foundation class for slider. Responsibilities include:
 * - Updating slider values (internal state and DOM updates) based on client
 *   'x' position.
 * - Updating DOM after slider property updates (e.g. min, max).
 */ var MDCSliderFoundation = /** @class */ function(_super) {
                __extends(MDCSliderFoundation, _super);
                function MDCSliderFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCSliderFoundation.defaultAdapter), adapter)) || this;
                    // Whether the initial styles (to position the thumb, before component
                    // initialization) have been removed.
                    _this.initialStylesRemoved = false;
                    _this.isDisabled = false;
                    _this.isDiscrete = false;
                    _this.step = constants_1.numbers.STEP_SIZE;
                    _this.hasTickMarks = false;
                    // The following properties are only set for range sliders.
                    _this.isRange = false;
                    // Tracks the thumb being moved across a slider pointer interaction (down,
                    // move event).
                    _this.thumb = null;
                    // `clientX` from the most recent down event. Used in subsequent move
                    // events to determine which thumb to move (in the case of
                    // overlapping thumbs).
                    _this.downEventClientX = null;
                    // Width of the start thumb knob.
                    _this.startThumbKnobWidth = 0;
                    // Width of the end thumb knob.
                    _this.endThumbKnobWidth = 0;
                    _this.animFrame = new animationframe_1.AnimationFrame();
                    return _this;
                }
                Object.defineProperty(MDCSliderFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same
                        // order as the adapter interface.
                        return {
                            hasClass: function hasClass() {
                                return false;
                            },
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            addThumbClass: function addThumbClass() {
                                return undefined;
                            },
                            removeThumbClass: function removeThumbClass() {
                                return undefined;
                            },
                            getAttribute: function getAttribute() {
                                return null;
                            },
                            getInputValue: function getInputValue() {
                                return "";
                            },
                            setInputValue: function setInputValue() {
                                return undefined;
                            },
                            getInputAttribute: function getInputAttribute() {
                                return null;
                            },
                            setInputAttribute: function setInputAttribute() {
                                return null;
                            },
                            removeInputAttribute: function removeInputAttribute() {
                                return null;
                            },
                            focusInput: function focusInput() {
                                return undefined;
                            },
                            isInputFocused: function isInputFocused() {
                                return false;
                            },
                            getThumbKnobWidth: function getThumbKnobWidth() {
                                return 0;
                            },
                            getThumbBoundingClientRect: function getThumbBoundingClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            getBoundingClientRect: function getBoundingClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            setThumbStyleProperty: function setThumbStyleProperty() {
                                return undefined;
                            },
                            removeThumbStyleProperty: function removeThumbStyleProperty() {
                                return undefined;
                            },
                            setTrackActiveStyleProperty: function setTrackActiveStyleProperty() {
                                return undefined;
                            },
                            removeTrackActiveStyleProperty: function removeTrackActiveStyleProperty() {
                                return undefined;
                            },
                            setValueIndicatorText: function setValueIndicatorText() {
                                return undefined;
                            },
                            getValueToAriaValueTextFn: function getValueToAriaValueTextFn() {
                                return null;
                            },
                            updateTickMarks: function updateTickMarks() {
                                return undefined;
                            },
                            setPointerCapture: function setPointerCapture() {
                                return undefined;
                            },
                            emitChangeEvent: function emitChangeEvent() {
                                return undefined;
                            },
                            emitInputEvent: function emitInputEvent() {
                                return undefined;
                            },
                            emitDragStartEvent: function emitDragStartEvent() {
                                return undefined;
                            },
                            emitDragEndEvent: function emitDragEndEvent() {
                                return undefined;
                            },
                            registerEventHandler: function registerEventHandler() {
                                return undefined;
                            },
                            deregisterEventHandler: function deregisterEventHandler() {
                                return undefined;
                            },
                            registerThumbEventHandler: function registerThumbEventHandler() {
                                return undefined;
                            },
                            deregisterThumbEventHandler: function deregisterThumbEventHandler() {
                                return undefined;
                            },
                            registerInputEventHandler: function registerInputEventHandler() {
                                return undefined;
                            },
                            deregisterInputEventHandler: function deregisterInputEventHandler() {
                                return undefined;
                            },
                            registerBodyEventHandler: function registerBodyEventHandler() {
                                return undefined;
                            },
                            deregisterBodyEventHandler: function deregisterBodyEventHandler() {
                                return undefined;
                            },
                            registerWindowEventHandler: function registerWindowEventHandler() {
                                return undefined;
                            },
                            deregisterWindowEventHandler: function deregisterWindowEventHandler() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSliderFoundation.prototype.init = function() {
                    var _this = this;
                    this.isDisabled = this.adapter.hasClass(constants_1.cssClasses.DISABLED);
                    this.isDiscrete = this.adapter.hasClass(constants_1.cssClasses.DISCRETE);
                    this.hasTickMarks = this.adapter.hasClass(constants_1.cssClasses.TICK_MARKS);
                    this.isRange = this.adapter.hasClass(constants_1.cssClasses.RANGE);
                    var min = this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_MIN, this.isRange ? types_1.Thumb.START : types_1.Thumb.END), constants_1.attributes.INPUT_MIN);
                    var max = this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_MAX, types_1.Thumb.END), constants_1.attributes.INPUT_MAX);
                    var value = this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_VALUE, types_1.Thumb.END), constants_1.attributes.INPUT_VALUE);
                    var valueStart = this.isRange ? this.convertAttributeValueToNumber(this.adapter.getInputAttribute(constants_1.attributes.INPUT_VALUE, types_1.Thumb.START), constants_1.attributes.INPUT_VALUE) : min;
                    var stepAttr = this.adapter.getInputAttribute(constants_1.attributes.INPUT_STEP, types_1.Thumb.END);
                    var step = stepAttr ? this.convertAttributeValueToNumber(stepAttr, constants_1.attributes.INPUT_STEP) : this.step;
                    this.validateProperties({
                        min: min,
                        max: max,
                        value: value,
                        valueStart: valueStart,
                        step: step
                    });
                    this.min = min;
                    this.max = max;
                    this.value = value;
                    this.valueStart = valueStart;
                    this.step = step;
                    this.numDecimalPlaces = getNumDecimalPlaces(this.step);
                    this.valueBeforeDownEvent = value;
                    this.valueStartBeforeDownEvent = valueStart;
                    this.mousedownOrTouchstartListener = this.handleMousedownOrTouchstart.bind(this);
                    this.moveListener = this.handleMove.bind(this);
                    this.pointerdownListener = this.handlePointerdown.bind(this);
                    this.pointerupListener = this.handlePointerup.bind(this);
                    this.thumbMouseenterListener = this.handleThumbMouseenter.bind(this);
                    this.thumbMouseleaveListener = this.handleThumbMouseleave.bind(this);
                    this.inputStartChangeListener = function() {
                        _this.handleInputChange(types_1.Thumb.START);
                    };
                    this.inputEndChangeListener = function() {
                        _this.handleInputChange(types_1.Thumb.END);
                    };
                    this.inputStartFocusListener = function() {
                        _this.handleInputFocus(types_1.Thumb.START);
                    };
                    this.inputEndFocusListener = function() {
                        _this.handleInputFocus(types_1.Thumb.END);
                    };
                    this.inputStartBlurListener = function() {
                        _this.handleInputBlur(types_1.Thumb.START);
                    };
                    this.inputEndBlurListener = function() {
                        _this.handleInputBlur(types_1.Thumb.END);
                    };
                    this.resizeListener = this.handleResize.bind(this);
                    this.registerEventHandlers();
                };
                MDCSliderFoundation.prototype.destroy = function() {
                    this.deregisterEventHandlers();
                };
                MDCSliderFoundation.prototype.getMin = function() {
                    return this.min;
                };
                MDCSliderFoundation.prototype.getMax = function() {
                    return this.max;
                };
                /**
     * - For single point sliders, returns the thumb value.
     * - For range (two-thumb) sliders, returns the end thumb's value.
     */ MDCSliderFoundation.prototype.getValue = function() {
                    return this.value;
                };
                /**
     * - For single point sliders, sets the thumb value.
     * - For range (two-thumb) sliders, sets the end thumb's value.
     */ MDCSliderFoundation.prototype.setValue = function(value) {
                    if (this.isRange && value < this.valueStart) throw new Error("end thumb value (" + value + ") must be >= start thumb " + ("value (" + this.valueStart + ")"));
                    this.updateValue(value, types_1.Thumb.END);
                };
                /**
     * Only applicable for range sliders.
     * @return The start thumb's value.
     */ MDCSliderFoundation.prototype.getValueStart = function() {
                    if (!this.isRange) throw new Error("`valueStart` is only applicable for range sliders.");
                    return this.valueStart;
                };
                /**
     * Only applicable for range sliders. Sets the start thumb's value.
     */ MDCSliderFoundation.prototype.setValueStart = function(valueStart) {
                    if (!this.isRange) throw new Error("`valueStart` is only applicable for range sliders.");
                    if (this.isRange && valueStart > this.value) throw new Error("start thumb value (" + valueStart + ") must be <= end thumb " + ("value (" + this.value + ")"));
                    this.updateValue(valueStart, types_1.Thumb.START);
                };
                MDCSliderFoundation.prototype.getStep = function() {
                    return this.step;
                };
                MDCSliderFoundation.prototype.getDisabled = function() {
                    return this.isDisabled;
                };
                /**
     * Sets disabled state, including updating styles and thumb tabindex.
     */ MDCSliderFoundation.prototype.setDisabled = function(disabled) {
                    this.isDisabled = disabled;
                    if (disabled) {
                        this.adapter.addClass(constants_1.cssClasses.DISABLED);
                        if (this.isRange) this.adapter.setInputAttribute(constants_1.attributes.INPUT_DISABLED, "", types_1.Thumb.START);
                        this.adapter.setInputAttribute(constants_1.attributes.INPUT_DISABLED, "", types_1.Thumb.END);
                    } else {
                        this.adapter.removeClass(constants_1.cssClasses.DISABLED);
                        if (this.isRange) this.adapter.removeInputAttribute(constants_1.attributes.INPUT_DISABLED, types_1.Thumb.START);
                        this.adapter.removeInputAttribute(constants_1.attributes.INPUT_DISABLED, types_1.Thumb.END);
                    }
                };
                /** @return Whether the slider is a range slider. */ MDCSliderFoundation.prototype.getIsRange = function() {
                    return this.isRange;
                };
                /**
     * - Syncs slider boundingClientRect with the current DOM.
     * - Updates UI based on internal state.
     */ MDCSliderFoundation.prototype.layout = function(_a) {
                    var _b = _a === void 0 ? {} : _a, skipUpdateUI = _b.skipUpdateUI;
                    this.rect = this.adapter.getBoundingClientRect();
                    if (this.isRange) {
                        this.startThumbKnobWidth = this.adapter.getThumbKnobWidth(types_1.Thumb.START);
                        this.endThumbKnobWidth = this.adapter.getThumbKnobWidth(types_1.Thumb.END);
                    }
                    if (!skipUpdateUI) this.updateUI();
                };
                /** Handles resize events on the window. */ MDCSliderFoundation.prototype.handleResize = function() {
                    this.layout();
                };
                /**
     * Handles pointer down events on the slider root element.
     */ MDCSliderFoundation.prototype.handleDown = function(event) {
                    if (this.isDisabled) return;
                    this.valueStartBeforeDownEvent = this.valueStart;
                    this.valueBeforeDownEvent = this.value;
                    var clientX = event.clientX != null ? event.clientX : event.targetTouches[0].clientX;
                    this.downEventClientX = clientX;
                    var value = this.mapClientXOnSliderScale(clientX);
                    this.thumb = this.getThumbFromDownEvent(clientX, value);
                    if (this.thumb === null) return;
                    this.handleDragStart(event, value, this.thumb);
                    this.updateValue(value, this.thumb, {
                        emitInputEvent: true
                    });
                };
                /**
     * Handles pointer move events on the slider root element.
     */ MDCSliderFoundation.prototype.handleMove = function(event) {
                    if (this.isDisabled) return;
                    // Prevent scrolling.
                    event.preventDefault();
                    var clientX = event.clientX != null ? event.clientX : event.targetTouches[0].clientX;
                    var dragAlreadyStarted = this.thumb != null;
                    this.thumb = this.getThumbFromMoveEvent(clientX);
                    if (this.thumb === null) return;
                    var value = this.mapClientXOnSliderScale(clientX);
                    if (!dragAlreadyStarted) {
                        this.handleDragStart(event, value, this.thumb);
                        this.adapter.emitDragStartEvent(value, this.thumb);
                    }
                    this.updateValue(value, this.thumb, {
                        emitInputEvent: true
                    });
                };
                /**
     * Handles pointer up events on the slider root element.
     */ MDCSliderFoundation.prototype.handleUp = function() {
                    if (this.isDisabled || this.thumb === null) return;
                    var oldValue = this.thumb === types_1.Thumb.START ? this.valueStartBeforeDownEvent : this.valueBeforeDownEvent;
                    var newValue = this.thumb === types_1.Thumb.START ? this.valueStart : this.value;
                    if (oldValue !== newValue) this.adapter.emitChangeEvent(newValue, this.thumb);
                    this.adapter.emitDragEndEvent(newValue, this.thumb);
                    this.thumb = null;
                };
                /**
     * For range, discrete slider, shows the value indicator on both thumbs.
     */ MDCSliderFoundation.prototype.handleThumbMouseenter = function() {
                    if (!this.isDiscrete || !this.isRange) return;
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.START);
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.END);
                };
                /**
     * For range, discrete slider, hides the value indicator on both thumbs.
     */ MDCSliderFoundation.prototype.handleThumbMouseleave = function() {
                    if (!this.isDiscrete || !this.isRange) return;
                    if (this.adapter.isInputFocused(types_1.Thumb.START) || this.adapter.isInputFocused(types_1.Thumb.END)) // Leave value indicator shown if either input is focused.
                    return;
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.START);
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, types_1.Thumb.END);
                };
                MDCSliderFoundation.prototype.handleMousedownOrTouchstart = function(event) {
                    var _this = this;
                    var moveEventType = event.type === "mousedown" ? "mousemove" : "touchmove";
                    // After a down event on the slider root, listen for move events on
                    // body (so the slider value is updated for events outside of the
                    // slider root).
                    this.adapter.registerBodyEventHandler(moveEventType, this.moveListener);
                    var upHandler = function upHandler() {
                        _this.handleUp();
                        // Once the drag is finished (up event on body), remove the move
                        // handler.
                        _this.adapter.deregisterBodyEventHandler(moveEventType, _this.moveListener);
                        // Also stop listening for subsequent up events.
                        _this.adapter.deregisterEventHandler("mouseup", upHandler);
                        _this.adapter.deregisterEventHandler("touchend", upHandler);
                    };
                    this.adapter.registerBodyEventHandler("mouseup", upHandler);
                    this.adapter.registerBodyEventHandler("touchend", upHandler);
                    this.handleDown(event);
                };
                MDCSliderFoundation.prototype.handlePointerdown = function(event) {
                    this.adapter.setPointerCapture(event.pointerId);
                    this.adapter.registerEventHandler("pointermove", this.moveListener);
                    this.handleDown(event);
                };
                /**
     * Handles input `change` event by setting internal slider value to match
     * input's new value.
     */ MDCSliderFoundation.prototype.handleInputChange = function(thumb) {
                    var value = Number(this.adapter.getInputValue(thumb));
                    if (thumb === types_1.Thumb.START) this.setValueStart(value);
                    else this.setValue(value);
                    this.adapter.emitChangeEvent(thumb === types_1.Thumb.START ? this.valueStart : this.value, thumb);
                    this.adapter.emitInputEvent(thumb === types_1.Thumb.START ? this.valueStart : this.value, thumb);
                };
                /** Shows activated state and value indicator on thumb(s). */ MDCSliderFoundation.prototype.handleInputFocus = function(thumb) {
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_FOCUSED, thumb);
                    if (!this.isDiscrete) return;
                    this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, thumb);
                    if (this.isRange) {
                        var otherThumb = thumb === types_1.Thumb.START ? types_1.Thumb.END : types_1.Thumb.START;
                        this.adapter.addThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, otherThumb);
                    }
                };
                /** Removes activated state and value indicator from thumb(s). */ MDCSliderFoundation.prototype.handleInputBlur = function(thumb) {
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_FOCUSED, thumb);
                    if (!this.isDiscrete) return;
                    this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, thumb);
                    if (this.isRange) {
                        var otherThumb = thumb === types_1.Thumb.START ? types_1.Thumb.END : types_1.Thumb.START;
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_WITH_INDICATOR, otherThumb);
                    }
                };
                /**
     * Emits custom dragStart event, along with focusing the underlying input.
     */ MDCSliderFoundation.prototype.handleDragStart = function(event, value, thumb) {
                    this.adapter.focusInput(thumb);
                    // Prevent the input (that we just focused) from losing focus.
                    event.preventDefault();
                    this.adapter.emitDragStartEvent(value, thumb);
                };
                /**
     * @return The thumb to be moved based on initial down event.
     */ MDCSliderFoundation.prototype.getThumbFromDownEvent = function(clientX, value) {
                    // For single point slider, thumb to be moved is always the END (only)
                    // thumb.
                    if (!this.isRange) return types_1.Thumb.END;
                    // Check if event press point is in the bounds of any thumb.
                    var thumbStartRect = this.adapter.getThumbBoundingClientRect(types_1.Thumb.START);
                    var thumbEndRect = this.adapter.getThumbBoundingClientRect(types_1.Thumb.END);
                    var inThumbStartBounds = clientX >= thumbStartRect.left && clientX <= thumbStartRect.right;
                    var inThumbEndBounds = clientX >= thumbEndRect.left && clientX <= thumbEndRect.right;
                    if (inThumbStartBounds && inThumbEndBounds) // Thumbs overlapping. Thumb to be moved cannot be determined yet.
                    return null;
                    // If press is in bounds for either thumb on down event, that's the thumb
                    // to be moved.
                    if (inThumbStartBounds) return types_1.Thumb.START;
                    if (inThumbEndBounds) return types_1.Thumb.END;
                    // For presses outside the range, return whichever thumb is closer.
                    if (value < this.valueStart) return types_1.Thumb.START;
                    if (value > this.value) return types_1.Thumb.END;
                    // For presses inside the range, return whichever thumb is closer.
                    return value - this.valueStart <= this.value - value ? types_1.Thumb.START : types_1.Thumb.END;
                };
                /**
     * @return The thumb to be moved based on move event (based on drag
     *     direction from original down event). Only applicable if thumbs
     *     were overlapping in the down event.
     */ MDCSliderFoundation.prototype.getThumbFromMoveEvent = function(clientX) {
                    // Thumb has already been chosen.
                    if (this.thumb !== null) return this.thumb;
                    if (this.downEventClientX === null) throw new Error("`downEventClientX` is null after move event.");
                    var moveDistanceUnderThreshold = Math.abs(this.downEventClientX - clientX) < constants_1.numbers.THUMB_UPDATE_MIN_PX;
                    if (moveDistanceUnderThreshold) return this.thumb;
                    var draggedThumbToLeft = clientX < this.downEventClientX;
                    if (draggedThumbToLeft) return this.adapter.isRTL() ? types_1.Thumb.END : types_1.Thumb.START;
                    else return this.adapter.isRTL() ? types_1.Thumb.START : types_1.Thumb.END;
                };
                /**
     * Updates UI based on internal state.
     * @param thumb Thumb whose value is being updated. If undefined, UI is
     *     updated for both thumbs based on current internal state.
     */ MDCSliderFoundation.prototype.updateUI = function(thumb) {
                    this.updateThumbAndInputAttributes(thumb);
                    this.updateThumbAndTrackUI(thumb);
                    this.updateValueIndicatorUI(thumb);
                    this.updateTickMarksUI();
                };
                /**
     * Updates thumb and input attributes based on current value.
     * @param thumb Thumb whose aria attributes to update.
     */ MDCSliderFoundation.prototype.updateThumbAndInputAttributes = function(thumb) {
                    if (!thumb) return;
                    var value = this.isRange && thumb === types_1.Thumb.START ? this.valueStart : this.value;
                    var valueStr = String(value);
                    this.adapter.setInputAttribute(constants_1.attributes.INPUT_VALUE, valueStr, thumb);
                    if (this.isRange && thumb === types_1.Thumb.START) this.adapter.setInputAttribute(constants_1.attributes.INPUT_MIN, valueStr, types_1.Thumb.END);
                    else if (this.isRange && thumb === types_1.Thumb.END) this.adapter.setInputAttribute(constants_1.attributes.INPUT_MAX, valueStr, types_1.Thumb.START);
                    // Sync attribute with property.
                    if (this.adapter.getInputValue(thumb) !== valueStr) this.adapter.setInputValue(valueStr, thumb);
                    var valueToAriaValueTextFn = this.adapter.getValueToAriaValueTextFn();
                    if (valueToAriaValueTextFn) this.adapter.setInputAttribute(constants_1.attributes.ARIA_VALUETEXT, valueToAriaValueTextFn(value), thumb);
                };
                /**
     * Updates value indicator UI based on current value.
     * @param thumb Thumb whose value indicator to update. If undefined, all
     *     thumbs' value indicators are updated.
     */ MDCSliderFoundation.prototype.updateValueIndicatorUI = function(thumb) {
                    if (!this.isDiscrete) return;
                    var value = this.isRange && thumb === types_1.Thumb.START ? this.valueStart : this.value;
                    this.adapter.setValueIndicatorText(value, thumb === types_1.Thumb.START ? types_1.Thumb.START : types_1.Thumb.END);
                    if (!thumb && this.isRange) this.adapter.setValueIndicatorText(this.valueStart, types_1.Thumb.START);
                };
                /**
     * Updates tick marks UI within slider, based on current min, max, and step.
     */ MDCSliderFoundation.prototype.updateTickMarksUI = function() {
                    if (!this.isDiscrete || !this.hasTickMarks) return;
                    var numTickMarksInactiveStart = (this.valueStart - this.min) / this.step;
                    var numTickMarksActive = (this.value - this.valueStart) / this.step + 1;
                    var numTickMarksInactiveEnd = (this.max - this.value) / this.step;
                    var tickMarksInactiveStart = Array.from({
                        length: numTickMarksInactiveStart
                    }).fill(types_1.TickMark.INACTIVE);
                    var tickMarksActive = Array.from({
                        length: numTickMarksActive
                    }).fill(types_1.TickMark.ACTIVE);
                    var tickMarksInactiveEnd = Array.from({
                        length: numTickMarksInactiveEnd
                    }).fill(types_1.TickMark.INACTIVE);
                    this.adapter.updateTickMarks(tickMarksInactiveStart.concat(tickMarksActive).concat(tickMarksInactiveEnd));
                };
                /** Maps clientX to a value on the slider scale. */ MDCSliderFoundation.prototype.mapClientXOnSliderScale = function(clientX) {
                    var xPos = clientX - this.rect.left;
                    var pctComplete = xPos / this.rect.width;
                    if (this.adapter.isRTL()) pctComplete = 1 - pctComplete;
                    // Fit the percentage complete between the range [min,max]
                    // by remapping from [0, 1] to [min, min+(max-min)].
                    var value = this.min + pctComplete * (this.max - this.min);
                    if (value === this.max || value === this.min) return value;
                    return Number(this.quantize(value).toFixed(this.numDecimalPlaces));
                };
                /** Calculates the quantized value based on step value. */ MDCSliderFoundation.prototype.quantize = function(value) {
                    var numSteps = Math.round((value - this.min) / this.step);
                    return this.min + numSteps * this.step;
                };
                /**
     * Updates slider value (internal state and UI) based on the given value.
     */ MDCSliderFoundation.prototype.updateValue = function(value, thumb, _a) {
                    var _b = _a === void 0 ? {} : _a, emitInputEvent = _b.emitInputEvent;
                    value = this.clampValue(value, thumb);
                    if (this.isRange && thumb === types_1.Thumb.START) {
                        // Exit early if current value is the same as the new value.
                        if (this.valueStart === value) return;
                        this.valueStart = value;
                    } else {
                        // Exit early if current value is the same as the new value.
                        if (this.value === value) return;
                        this.value = value;
                    }
                    this.updateUI(thumb);
                    if (emitInputEvent) this.adapter.emitInputEvent(thumb === types_1.Thumb.START ? this.valueStart : this.value, thumb);
                };
                /**
     * Clamps the given value for the given thumb based on slider properties:
     * - Restricts value within [min, max].
     * - If range slider, clamp start value <= end value, and
     *   end value >= start value.
     */ MDCSliderFoundation.prototype.clampValue = function(value, thumb) {
                    // Clamp value to [min, max] range.
                    value = Math.min(Math.max(value, this.min), this.max);
                    var thumbStartMovedPastThumbEnd = this.isRange && thumb === types_1.Thumb.START && value > this.value;
                    if (thumbStartMovedPastThumbEnd) return this.value;
                    var thumbEndMovedPastThumbStart = this.isRange && thumb === types_1.Thumb.END && value < this.valueStart;
                    if (thumbEndMovedPastThumbStart) return this.valueStart;
                    return value;
                };
                /**
     * Updates the active track and thumb style properties to reflect current
     * value.
     */ MDCSliderFoundation.prototype.updateThumbAndTrackUI = function(thumb) {
                    var _this = this;
                    var _a = this, max = _a.max, min = _a.min;
                    var pctComplete = (this.value - this.valueStart) / (max - min);
                    var rangePx = pctComplete * this.rect.width;
                    var isRtl = this.adapter.isRTL();
                    var transformProp = HAS_WINDOW ? util_1.getCorrectPropertyName(window, "transform") : "transform";
                    if (this.isRange) {
                        var thumbLeftPos_1 = this.adapter.isRTL() ? (max - this.value) / (max - min) * this.rect.width : (this.valueStart - min) / (max - min) * this.rect.width;
                        var thumbRightPos_1 = thumbLeftPos_1 + rangePx;
                        this.animFrame.request(AnimationKeys.SLIDER_UPDATE, function() {
                            // Set active track styles, accounting for animation direction by
                            // setting `transform-origin`.
                            var trackAnimatesFromRight = !isRtl && thumb === types_1.Thumb.START || isRtl && thumb !== types_1.Thumb.START;
                            if (trackAnimatesFromRight) {
                                _this.adapter.setTrackActiveStyleProperty("transform-origin", "right");
                                _this.adapter.setTrackActiveStyleProperty("left", "unset");
                                _this.adapter.setTrackActiveStyleProperty("right", _this.rect.width - thumbRightPos_1 + "px");
                            } else {
                                _this.adapter.setTrackActiveStyleProperty("transform-origin", "left");
                                _this.adapter.setTrackActiveStyleProperty("right", "unset");
                                _this.adapter.setTrackActiveStyleProperty("left", thumbLeftPos_1 + "px");
                            }
                            _this.adapter.setTrackActiveStyleProperty(transformProp, "scaleX(" + pctComplete + ")");
                            // Set thumb styles.
                            var thumbStartPos = isRtl ? thumbRightPos_1 : thumbLeftPos_1;
                            var thumbEndPos = _this.adapter.isRTL() ? thumbLeftPos_1 : thumbRightPos_1;
                            if (thumb === types_1.Thumb.START || !thumb || !_this.initialStylesRemoved) _this.adapter.setThumbStyleProperty(transformProp, "translateX(" + thumbStartPos + "px)", types_1.Thumb.START);
                            if (thumb === types_1.Thumb.END || !thumb || !_this.initialStylesRemoved) _this.adapter.setThumbStyleProperty(transformProp, "translateX(" + thumbEndPos + "px)", types_1.Thumb.END);
                            _this.removeInitialStyles(isRtl);
                            _this.updateOverlappingThumbsUI(thumbStartPos, thumbEndPos, thumb);
                        });
                    } else this.animFrame.request(AnimationKeys.SLIDER_UPDATE, function() {
                        var thumbStartPos = isRtl ? _this.rect.width - rangePx : rangePx;
                        _this.adapter.setThumbStyleProperty(transformProp, "translateX(" + thumbStartPos + "px)", types_1.Thumb.END);
                        _this.adapter.setTrackActiveStyleProperty(transformProp, "scaleX(" + pctComplete + ")");
                        _this.removeInitialStyles(isRtl);
                    });
                };
                /**
     * Removes initial inline styles if not already removed. `left:<...>%`
     * inline styles can be added to position the thumb correctly before JS
     * initialization. However, they need to be removed before the JS starts
     * positioning the thumb. This is because the JS uses
     * `transform:translateX(<...>)px` (for performance reasons) to position
     * the thumb (which is not possible for initial styles since we need the
     * bounding rect measurements).
     */ MDCSliderFoundation.prototype.removeInitialStyles = function(isRtl) {
                    if (this.initialStylesRemoved) return;
                    // Remove thumb position properties that were added for initial render.
                    var position = isRtl ? "right" : "left";
                    this.adapter.removeThumbStyleProperty(position, types_1.Thumb.END);
                    if (this.isRange) this.adapter.removeThumbStyleProperty(position, types_1.Thumb.START);
                    this.initialStylesRemoved = true;
                    this.resetTrackAndThumbAnimation();
                };
                /**
     * Resets track/thumb animation to prevent animation when adding
     * `transform` styles to thumb initially.
     */ MDCSliderFoundation.prototype.resetTrackAndThumbAnimation = function() {
                    var _this = this;
                    if (!this.isDiscrete) return;
                    // Set transition properties to default (no animation), so that the
                    // newly added `transform` styles do not animate thumb/track from
                    // their default positions.
                    var transitionProp = HAS_WINDOW ? util_1.getCorrectPropertyName(window, "transition") : "transition";
                    var transitionDefault = "all 0s ease 0s";
                    this.adapter.setThumbStyleProperty(transitionProp, transitionDefault, types_1.Thumb.END);
                    if (this.isRange) this.adapter.setThumbStyleProperty(transitionProp, transitionDefault, types_1.Thumb.START);
                    this.adapter.setTrackActiveStyleProperty(transitionProp, transitionDefault);
                    // In the next frame, remove the transition inline styles we just
                    // added, such that any animations added in the CSS can now take effect.
                    requestAnimationFrame(function() {
                        _this.adapter.removeThumbStyleProperty(transitionProp, types_1.Thumb.END);
                        _this.adapter.removeTrackActiveStyleProperty(transitionProp);
                        if (_this.isRange) _this.adapter.removeThumbStyleProperty(transitionProp, types_1.Thumb.START);
                    });
                };
                /**
     * Adds THUMB_TOP class to active thumb if thumb knobs overlap; otherwise
     * removes THUMB_TOP class from both thumbs.
     * @param thumb Thumb that is active (being moved).
     */ MDCSliderFoundation.prototype.updateOverlappingThumbsUI = function(thumbStartPos, thumbEndPos, thumb) {
                    var thumbsOverlap = false;
                    if (this.adapter.isRTL()) {
                        var startThumbLeftEdge = thumbStartPos - this.startThumbKnobWidth / 2;
                        var endThumbRightEdge = thumbEndPos + this.endThumbKnobWidth / 2;
                        thumbsOverlap = endThumbRightEdge >= startThumbLeftEdge;
                    } else {
                        var startThumbRightEdge = thumbStartPos + this.startThumbKnobWidth / 2;
                        var endThumbLeftEdge = thumbEndPos - this.endThumbKnobWidth / 2;
                        thumbsOverlap = startThumbRightEdge >= endThumbLeftEdge;
                    }
                    if (thumbsOverlap) {
                        this.adapter.addThumbClass(constants_1.cssClasses.THUMB_TOP, // If no thumb was dragged (in the case of initial layout), end
                        // thumb is on top by default.
                        thumb || types_1.Thumb.END);
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_TOP, thumb === types_1.Thumb.START ? types_1.Thumb.END : types_1.Thumb.START);
                    } else {
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_TOP, types_1.Thumb.START);
                        this.adapter.removeThumbClass(constants_1.cssClasses.THUMB_TOP, types_1.Thumb.END);
                    }
                };
                /**
     * Converts attribute value to a number, e.g. '100' => 100. Throws errors
     * for invalid values.
     * @param attributeValue Attribute value, e.g. 100.
     * @param attributeName Attribute name, e.g. `aria-valuemax`.
     */ MDCSliderFoundation.prototype.convertAttributeValueToNumber = function(attributeValue, attributeName) {
                    if (attributeValue === null) throw new Error("MDCSliderFoundation: `" + attributeName + "` must be non-null.");
                    var value = Number(attributeValue);
                    if (isNaN(value)) throw new Error("MDCSliderFoundation: `" + attributeName + "` value is " + ("`" + attributeValue + "`, but must be a number."));
                    return value;
                };
                /** Checks that the given properties are valid slider values. */ MDCSliderFoundation.prototype.validateProperties = function(_a) {
                    var min = _a.min, max = _a.max, value = _a.value, valueStart = _a.valueStart, step = _a.step;
                    if (min >= max) throw new Error("MDCSliderFoundation: min must be strictly less than max. " + ("Current: [min: " + min + ", max: " + max + "]"));
                    if (step <= 0) throw new Error("MDCSliderFoundation: step must be a positive number. " + ("Current step: " + this.step));
                    if (this.isRange) {
                        if (value < min || value > max || valueStart < min || valueStart > max) throw new Error("MDCSliderFoundation: values must be in [min, max] range. " + ("Current values: [start value: " + valueStart + ", end value: " + value + "]"));
                        if (valueStart > value) throw new Error("MDCSliderFoundation: start value must be <= end value. " + ("Current values: [start value: " + valueStart + ", end value: " + value + "]"));
                        var numStepsValueStartFromMin = (valueStart - min) / step;
                        var numStepsValueFromMin = (value - min) / step;
                        if (numStepsValueStartFromMin % 1 !== 0 || numStepsValueFromMin % 1 !== 0) throw new Error("MDCSliderFoundation: Slider values must be valid based on the " + ("step value. Current values: [start value: " + valueStart + ", ") + ("end value: " + value + "]"));
                    } else {
                        // Single point slider.
                        if (value < min || value > max) throw new Error("MDCSliderFoundation: value must be in [min, max] range. " + ("Current value: " + value));
                        var numStepsValueFromMin = (value - min) / step;
                        if (numStepsValueFromMin % 1 !== 0) throw new Error("MDCSliderFoundation: Slider value must be valid based on the " + ("step value. Current value: " + value));
                    }
                };
                MDCSliderFoundation.prototype.registerEventHandlers = function() {
                    this.adapter.registerWindowEventHandler("resize", this.resizeListener);
                    if (MDCSliderFoundation.SUPPORTS_POINTER_EVENTS) {
                        // If supported, use pointer events API with #setPointerCapture.
                        this.adapter.registerEventHandler("pointerdown", this.pointerdownListener);
                        this.adapter.registerEventHandler("pointerup", this.pointerupListener);
                    } else {
                        // Otherwise, fall back to mousedown/touchstart events.
                        this.adapter.registerEventHandler("mousedown", this.mousedownOrTouchstartListener);
                        this.adapter.registerEventHandler("touchstart", this.mousedownOrTouchstartListener);
                    }
                    if (this.isRange) {
                        this.adapter.registerThumbEventHandler(types_1.Thumb.START, "mouseenter", this.thumbMouseenterListener);
                        this.adapter.registerThumbEventHandler(types_1.Thumb.START, "mouseleave", this.thumbMouseleaveListener);
                        this.adapter.registerInputEventHandler(types_1.Thumb.START, "change", this.inputStartChangeListener);
                        this.adapter.registerInputEventHandler(types_1.Thumb.START, "focus", this.inputStartFocusListener);
                        this.adapter.registerInputEventHandler(types_1.Thumb.START, "blur", this.inputStartBlurListener);
                    }
                    this.adapter.registerThumbEventHandler(types_1.Thumb.END, "mouseenter", this.thumbMouseenterListener);
                    this.adapter.registerThumbEventHandler(types_1.Thumb.END, "mouseleave", this.thumbMouseleaveListener);
                    this.adapter.registerInputEventHandler(types_1.Thumb.END, "change", this.inputEndChangeListener);
                    this.adapter.registerInputEventHandler(types_1.Thumb.END, "focus", this.inputEndFocusListener);
                    this.adapter.registerInputEventHandler(types_1.Thumb.END, "blur", this.inputEndBlurListener);
                };
                MDCSliderFoundation.prototype.deregisterEventHandlers = function() {
                    this.adapter.deregisterWindowEventHandler("resize", this.resizeListener);
                    if (MDCSliderFoundation.SUPPORTS_POINTER_EVENTS) {
                        this.adapter.deregisterEventHandler("pointerdown", this.pointerdownListener);
                        this.adapter.deregisterEventHandler("pointerup", this.pointerupListener);
                    } else {
                        this.adapter.deregisterEventHandler("mousedown", this.mousedownOrTouchstartListener);
                        this.adapter.deregisterEventHandler("touchstart", this.mousedownOrTouchstartListener);
                    }
                    if (this.isRange) {
                        this.adapter.deregisterThumbEventHandler(types_1.Thumb.START, "mouseenter", this.thumbMouseenterListener);
                        this.adapter.deregisterThumbEventHandler(types_1.Thumb.START, "mouseleave", this.thumbMouseleaveListener);
                        this.adapter.deregisterInputEventHandler(types_1.Thumb.START, "change", this.inputStartChangeListener);
                        this.adapter.deregisterInputEventHandler(types_1.Thumb.START, "focus", this.inputStartFocusListener);
                        this.adapter.deregisterInputEventHandler(types_1.Thumb.START, "blur", this.inputStartBlurListener);
                    }
                    this.adapter.deregisterThumbEventHandler(types_1.Thumb.END, "mouseenter", this.thumbMouseenterListener);
                    this.adapter.deregisterThumbEventHandler(types_1.Thumb.END, "mouseleave", this.thumbMouseleaveListener);
                    this.adapter.deregisterInputEventHandler(types_1.Thumb.END, "change", this.inputEndChangeListener);
                    this.adapter.deregisterInputEventHandler(types_1.Thumb.END, "focus", this.inputEndFocusListener);
                    this.adapter.deregisterInputEventHandler(types_1.Thumb.END, "blur", this.inputEndBlurListener);
                };
                MDCSliderFoundation.prototype.handlePointerup = function() {
                    this.handleUp();
                    this.adapter.deregisterEventHandler("pointermove", this.moveListener);
                };
                MDCSliderFoundation.SUPPORTS_POINTER_EVENTS = HAS_WINDOW && Boolean(window.PointerEvent) && // #setPointerCapture is buggy on iOS, so we can't use pointer events
                // until the following bug is fixed:
                // https://bugs.webkit.org/show_bug.cgi?id=220196
                !isIOS();
                return MDCSliderFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSliderFoundation = MDCSliderFoundation;
            function isIOS() {
                // Source:
                // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
                return [
                    "iPad Simulator",
                    "iPhone Simulator",
                    "iPod Simulator",
                    "iPad",
                    "iPhone",
                    "iPod"
                ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
            }
            /**
 * Given a number, returns the number of digits that appear after the
 * decimal point.
 * See
 * https://stackoverflow.com/questions/9539513/is-there-a-reliable-way-in-javascript-to-obtain-the-number-of-decimal-places-of
 */ function getNumDecimalPlaces(n) {
                // Pull out the fraction and the exponent.
                var match = /(?:\.(\d+))?(?:[eE]([+\-]?\d+))?$/.exec(String(n));
                // NaN or Infinity or integer.
                // We arbitrarily decide that Infinity is integral.
                if (!match) return 0;
                var fraction = match[1] || ""; // E.g. 1.234e-2 => 234
                var exponent = match[2] || 0; // E.g. 1.234e-2 => -2
                // Count the number of digits in the fraction and subtract the
                // exponent to simulate moving the decimal point left by exponent places.
                // 1.234e+2 has 1 fraction digit and '234'.length -  2 == 1
                // 1.234e-2 has 5 fraction digit and '234'.length - -2 == 5
                return Math.max(0, (fraction === "0" ? 0 : fraction.length) - Number(exponent));
            }
        /***/ },
        /***/ "./packages/mdc-slider/types.ts": /*!**************************************!*\
  !*** ./packages/mdc-slider/types.ts ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Thumb = exports.TickMark = void 0;
            /** Tick mark enum, for discrete sliders. */ var TickMark;
            (function(TickMark) {
                TickMark[TickMark["ACTIVE"] = 0] = "ACTIVE";
                TickMark[TickMark["INACTIVE"] = 1] = "INACTIVE";
            })(TickMark = exports.TickMark || (exports.TickMark = {}));
            /**
 * Thumb types: range slider has two thumbs (START, END) whereas single point
 * slider only has one thumb (END).
 */ var Thumb;
            (function(Thumb) {
                // Thumb at start of slider (e.g. in LTR mode, left thumb on range slider).
                Thumb[Thumb["START"] = 1] = "START";
                // Thumb at end of slider (e.g. in LTR mode, right thumb on range slider,
                // or only thumb on single point slider).
                Thumb[Thumb["END"] = 2] = "END";
            })(Thumb = exports.Thumb || (exports.Thumb = {}));
        /***/ },
        /***/ "./packages/mdc-snackbar/component.ts": /*!********************************************!*\
  !*** ./packages/mdc-snackbar/component.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSnackbar = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-snackbar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-snackbar/foundation.ts");
            var SURFACE_SELECTOR = constants_1.strings.SURFACE_SELECTOR, LABEL_SELECTOR = constants_1.strings.LABEL_SELECTOR, ACTION_SELECTOR = constants_1.strings.ACTION_SELECTOR, DISMISS_SELECTOR = constants_1.strings.DISMISS_SELECTOR, OPENING_EVENT = constants_1.strings.OPENING_EVENT, OPENED_EVENT = constants_1.strings.OPENED_EVENT, CLOSING_EVENT = constants_1.strings.CLOSING_EVENT, CLOSED_EVENT = constants_1.strings.CLOSED_EVENT;
            var MDCSnackbar = /** @class */ function(_super) {
                __extends(MDCSnackbar, _super);
                function MDCSnackbar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSnackbar.attachTo = function(root) {
                    return new MDCSnackbar(root);
                };
                MDCSnackbar.prototype.initialize = function() {};
                MDCSnackbar.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.surfaceEl_ = this.root.querySelector(SURFACE_SELECTOR);
                    this.labelEl_ = this.root.querySelector(LABEL_SELECTOR);
                    this.actionEl_ = this.root.querySelector(ACTION_SELECTOR);
                    this.handleKeyDown_ = function(evt) {
                        return _this.foundation.handleKeyDown(evt);
                    };
                    this.handleSurfaceClick_ = function(evt) {
                        var target = evt.target;
                        if (_this.isActionButton_(target)) _this.foundation.handleActionButtonClick(evt);
                        else if (_this.isActionIcon_(target)) _this.foundation.handleActionIconClick(evt);
                    };
                    this.registerKeyDownHandler_(this.handleKeyDown_);
                    this.registerSurfaceClickHandler_(this.handleSurfaceClick_);
                };
                MDCSnackbar.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.deregisterKeyDownHandler_(this.handleKeyDown_);
                    this.deregisterSurfaceClickHandler_(this.handleSurfaceClick_);
                };
                MDCSnackbar.prototype.open = function() {
                    this.foundation.open();
                };
                /**
     * @param reason Why the snackbar was closed. Value will be passed to CLOSING_EVENT and CLOSED_EVENT via the
     *     `event.detail.reason` property. Standard values are REASON_ACTION and REASON_DISMISS, but custom
     *     client-specific values may also be used if desired.
     */ MDCSnackbar.prototype.close = function(reason) {
                    if (reason === void 0) reason = "";
                    this.foundation.close(reason);
                };
                MDCSnackbar.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        announce: function announce() {},
                        notifyClosed: function notifyClosed(reason) {
                            return _this.emit(CLOSED_EVENT, reason ? {
                                reason: reason
                            } : {});
                        },
                        notifyClosing: function notifyClosing(reason) {
                            return _this.emit(CLOSING_EVENT, reason ? {
                                reason: reason
                            } : {});
                        },
                        notifyOpened: function notifyOpened() {
                            return _this.emit(OPENED_EVENT, {});
                        },
                        notifyOpening: function notifyOpening() {
                            return _this.emit(OPENING_EVENT, {});
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        }
                    };
                    return new foundation_1.MDCSnackbarFoundation(adapter);
                };
                Object.defineProperty(MDCSnackbar.prototype, "timeoutMs", {
                    get: function get() {
                        return this.foundation.getTimeoutMs();
                    },
                    set: function set(timeoutMs) {
                        this.foundation.setTimeoutMs(timeoutMs);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "closeOnEscape", {
                    get: function get() {
                        return this.foundation.getCloseOnEscape();
                    },
                    set: function set(closeOnEscape) {
                        this.foundation.setCloseOnEscape(closeOnEscape);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "isOpen", {
                    get: function get() {
                        return this.foundation.isOpen();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "labelText", {
                    get: function get() {
                        // This property only returns null if the node is a document, DOCTYPE, or notation.
                        // On Element nodes, it always returns a string.
                        return this.labelEl_.textContent;
                    },
                    set: function set(labelText) {
                        this.labelEl_.textContent = labelText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbar.prototype, "actionButtonText", {
                    get: function get() {
                        return this.actionEl_.textContent;
                    },
                    set: function set(actionButtonText) {
                        this.actionEl_.textContent = actionButtonText;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSnackbar.prototype.registerKeyDownHandler_ = function(handler) {
                    this.listen("keydown", handler);
                };
                MDCSnackbar.prototype.deregisterKeyDownHandler_ = function(handler) {
                    this.unlisten("keydown", handler);
                };
                MDCSnackbar.prototype.registerSurfaceClickHandler_ = function(handler) {
                    this.surfaceEl_.addEventListener("click", handler);
                };
                MDCSnackbar.prototype.deregisterSurfaceClickHandler_ = function(handler) {
                    this.surfaceEl_.removeEventListener("click", handler);
                };
                MDCSnackbar.prototype.isActionButton_ = function(target) {
                    return Boolean(ponyfill_1.closest(target, ACTION_SELECTOR));
                };
                MDCSnackbar.prototype.isActionIcon_ = function(target) {
                    return Boolean(ponyfill_1.closest(target, DISMISS_SELECTOR));
                };
                return MDCSnackbar;
            }(component_1.MDCComponent);
            exports.MDCSnackbar = MDCSnackbar;
        /***/ },
        /***/ "./packages/mdc-snackbar/constants.ts": /*!********************************************!*\
  !*** ./packages/mdc-snackbar/constants.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.numbers = exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                CLOSING: "mdc-snackbar--closing",
                OPEN: "mdc-snackbar--open",
                OPENING: "mdc-snackbar--opening"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ACTION_SELECTOR: ".mdc-snackbar__action",
                ARIA_LIVE_LABEL_TEXT_ATTR: "data-mdc-snackbar-label-text",
                CLOSED_EVENT: "MDCSnackbar:closed",
                CLOSING_EVENT: "MDCSnackbar:closing",
                DISMISS_SELECTOR: ".mdc-snackbar__dismiss",
                LABEL_SELECTOR: ".mdc-snackbar__label",
                OPENED_EVENT: "MDCSnackbar:opened",
                OPENING_EVENT: "MDCSnackbar:opening",
                REASON_ACTION: "action",
                REASON_DISMISS: "dismiss",
                SURFACE_SELECTOR: ".mdc-snackbar__surface"
            };
            exports.strings = strings;
            var numbers = {
                DEFAULT_AUTO_DISMISS_TIMEOUT_MS: 5000,
                INDETERMINATE: -1,
                MAX_AUTO_DISMISS_TIMEOUT_MS: 10000,
                MIN_AUTO_DISMISS_TIMEOUT_MS: 4000,
                // These variables need to be kept in sync with the values in _variables.scss.
                SNACKBAR_ANIMATION_CLOSE_TIME_MS: 75,
                SNACKBAR_ANIMATION_OPEN_TIME_MS: 150,
                /**
     * Number of milliseconds to wait between temporarily clearing the label text
     * in the DOM and subsequently restoring it. This is necessary to force IE 11
     * to pick up the `aria-live` content change and announce it to the user.
     */ ARIA_LIVE_DELAY_MS: 1000
            };
            exports.numbers = numbers;
        /***/ },
        /***/ "./packages/mdc-snackbar/custom-element.js": /*!*************************************************!*\
  !*** ./packages/mdc-snackbar/custom-element.js ***!
  \*************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-snackbar/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSnackbar = function(_HTMLElement) {
                _inherits(MdcSnackbar, _HTMLElement);
                _createClass(MdcSnackbar, [
                    {
                        key: "closeOnEscape",
                        get: function get() {
                            return this.closeOnEscape_;
                        },
                        set: function set(closeOnEscape) {
                            this.closeOnEscape_ = closeOnEscape;
                            if (!!this.snackbar_) this.snackbar_.closeOnEscape = closeOnEscape;
                        }
                    },
                    {
                        key: "timeoutMs",
                        get: function get() {
                            return this.timeoutMs_;
                        },
                        set: function set(timeoutMs) {
                            this.timeoutMs_ = timeoutMs;
                            if (!!this.snackbar_) this.snackbar_.timeoutMs = timeoutMs;
                        }
                    },
                    {
                        key: "messageId",
                        get: function get() {
                            return this.messageId_;
                        },
                        set: function set(messageId) {
                            this.messageId_ = messageId;
                            if (!!this.snackbar_ && messageId !== -1) this.snackbar_.open();
                        }
                    }
                ]);
                function MdcSnackbar() {
                    _classCallCheck(this, MdcSnackbar);
                    var _this = _possibleConstructorReturn(this, (MdcSnackbar.__proto__ || Object.getPrototypeOf(MdcSnackbar)).call(this));
                    _this.closeOnEscape_ = false;
                    _this.timeoutMs_ = 5000;
                    _this.messageId_ = -1;
                    _this.snackbar_;
                    return _this;
                }
                _createClass(MdcSnackbar, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.snackbar_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSnackbar"](this);
                            this.snackbar_.closeOnEscape = this.closeOnEscape_;
                            this.snackbar_.timeoutMs = this.timeoutMs_;
                            if (this.messageId_ !== -1) this.snackbar_.open();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.snackbar_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSnackbar;
            }(HTMLElement);
            customElements.define("mdc-snackbar", MdcSnackbar);
        /***/ },
        /***/ "./packages/mdc-snackbar/foundation.ts": /*!*********************************************!*\
  !*** ./packages/mdc-snackbar/foundation.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSnackbarFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-snackbar/constants.ts");
            var OPENING = constants_1.cssClasses.OPENING, OPEN = constants_1.cssClasses.OPEN, CLOSING = constants_1.cssClasses.CLOSING;
            var REASON_ACTION = constants_1.strings.REASON_ACTION, REASON_DISMISS = constants_1.strings.REASON_DISMISS;
            var MDCSnackbarFoundation = /** @class */ function(_super) {
                __extends(MDCSnackbarFoundation, _super);
                function MDCSnackbarFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCSnackbarFoundation.defaultAdapter), adapter)) || this;
                    _this.isOpen_ = false;
                    _this.animationFrame_ = 0;
                    _this.animationTimer_ = 0;
                    _this.autoDismissTimer_ = 0;
                    _this.autoDismissTimeoutMs_ = constants_1.numbers.DEFAULT_AUTO_DISMISS_TIMEOUT_MS;
                    _this.closeOnEscape_ = true;
                    return _this;
                }
                Object.defineProperty(MDCSnackbarFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbarFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbarFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSnackbarFoundation, "defaultAdapter", {
                    get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            announce: function announce() {
                                return undefined;
                            },
                            notifyClosed: function notifyClosed() {
                                return undefined;
                            },
                            notifyClosing: function notifyClosing() {
                                return undefined;
                            },
                            notifyOpened: function notifyOpened() {
                                return undefined;
                            },
                            notifyOpening: function notifyOpening() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSnackbarFoundation.prototype.destroy = function() {
                    this.clearAutoDismissTimer_();
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = 0;
                    clearTimeout(this.animationTimer_);
                    this.animationTimer_ = 0;
                    this.adapter.removeClass(OPENING);
                    this.adapter.removeClass(OPEN);
                    this.adapter.removeClass(CLOSING);
                };
                MDCSnackbarFoundation.prototype.open = function() {
                    var _this = this;
                    this.clearAutoDismissTimer_();
                    this.isOpen_ = true;
                    this.adapter.notifyOpening();
                    this.adapter.removeClass(CLOSING);
                    this.adapter.addClass(OPENING);
                    this.adapter.announce();
                    // Wait a frame once display is no longer "none", to establish basis for animation
                    this.runNextAnimationFrame_(function() {
                        _this.adapter.addClass(OPEN);
                        _this.animationTimer_ = setTimeout(function() {
                            var timeoutMs = _this.getTimeoutMs();
                            _this.handleAnimationTimerEnd_();
                            _this.adapter.notifyOpened();
                            if (timeoutMs !== constants_1.numbers.INDETERMINATE) _this.autoDismissTimer_ = setTimeout(function() {
                                _this.close(REASON_DISMISS);
                            }, timeoutMs);
                        }, constants_1.numbers.SNACKBAR_ANIMATION_OPEN_TIME_MS);
                    });
                };
                /**
     * @param reason Why the snackbar was closed. Value will be passed to CLOSING_EVENT and CLOSED_EVENT via the
     *     `event.detail.reason` property. Standard values are REASON_ACTION and REASON_DISMISS, but custom
     *     client-specific values may also be used if desired.
     */ MDCSnackbarFoundation.prototype.close = function(reason) {
                    var _this = this;
                    if (reason === void 0) reason = "";
                    if (!this.isOpen_) // Avoid redundant close calls (and events), e.g. repeated interactions as the snackbar is animating closed
                    return;
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = 0;
                    this.clearAutoDismissTimer_();
                    this.isOpen_ = false;
                    this.adapter.notifyClosing(reason);
                    this.adapter.addClass(constants_1.cssClasses.CLOSING);
                    this.adapter.removeClass(constants_1.cssClasses.OPEN);
                    this.adapter.removeClass(constants_1.cssClasses.OPENING);
                    clearTimeout(this.animationTimer_);
                    this.animationTimer_ = setTimeout(function() {
                        _this.handleAnimationTimerEnd_();
                        _this.adapter.notifyClosed(reason);
                    }, constants_1.numbers.SNACKBAR_ANIMATION_CLOSE_TIME_MS);
                };
                MDCSnackbarFoundation.prototype.isOpen = function() {
                    return this.isOpen_;
                };
                MDCSnackbarFoundation.prototype.getTimeoutMs = function() {
                    return this.autoDismissTimeoutMs_;
                };
                MDCSnackbarFoundation.prototype.setTimeoutMs = function(timeoutMs) {
                    // Use shorter variable names to make the code more readable
                    var minValue = constants_1.numbers.MIN_AUTO_DISMISS_TIMEOUT_MS;
                    var maxValue = constants_1.numbers.MAX_AUTO_DISMISS_TIMEOUT_MS;
                    var indeterminateValue = constants_1.numbers.INDETERMINATE;
                    if (timeoutMs === constants_1.numbers.INDETERMINATE || timeoutMs <= maxValue && timeoutMs >= minValue) this.autoDismissTimeoutMs_ = timeoutMs;
                    else throw new Error("\n        timeoutMs must be an integer in the range " + minValue + "\u2013" + maxValue + "\n        (or " + indeterminateValue + " to disable), but got '" + timeoutMs + "'");
                };
                MDCSnackbarFoundation.prototype.getCloseOnEscape = function() {
                    return this.closeOnEscape_;
                };
                MDCSnackbarFoundation.prototype.setCloseOnEscape = function(closeOnEscape) {
                    this.closeOnEscape_ = closeOnEscape;
                };
                MDCSnackbarFoundation.prototype.handleKeyDown = function(evt) {
                    var isEscapeKey = evt.key === "Escape" || evt.keyCode === 27;
                    if (isEscapeKey && this.getCloseOnEscape()) this.close(REASON_DISMISS);
                };
                MDCSnackbarFoundation.prototype.handleActionButtonClick = function(_evt) {
                    this.close(REASON_ACTION);
                };
                MDCSnackbarFoundation.prototype.handleActionIconClick = function(_evt) {
                    this.close(REASON_DISMISS);
                };
                MDCSnackbarFoundation.prototype.clearAutoDismissTimer_ = function() {
                    clearTimeout(this.autoDismissTimer_);
                    this.autoDismissTimer_ = 0;
                };
                MDCSnackbarFoundation.prototype.handleAnimationTimerEnd_ = function() {
                    this.animationTimer_ = 0;
                    this.adapter.removeClass(constants_1.cssClasses.OPENING);
                    this.adapter.removeClass(constants_1.cssClasses.CLOSING);
                };
                /**
     * Runs the given logic on the next animation frame, using setTimeout to factor in Firefox reflow behavior.
     */ MDCSnackbarFoundation.prototype.runNextAnimationFrame_ = function(callback) {
                    var _this = this;
                    cancelAnimationFrame(this.animationFrame_);
                    this.animationFrame_ = requestAnimationFrame(function() {
                        _this.animationFrame_ = 0;
                        clearTimeout(_this.animationTimer_);
                        _this.animationTimer_ = setTimeout(callback, 0);
                    });
                };
                return MDCSnackbarFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSnackbarFoundation = MDCSnackbarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSnackbarFoundation;
        /***/ },
        /***/ "./packages/mdc-switch/component.ts": /*!******************************************!*\
  !*** ./packages/mdc-switch/component.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSwitch = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-switch/foundation.ts");
            var MDCSwitch = /** @class */ function(_super) {
                __extends(MDCSwitch, _super);
                function MDCSwitch() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.ripple_ = _this.createRipple_();
                    return _this;
                }
                MDCSwitch.attachTo = function(root) {
                    return new MDCSwitch(root);
                };
                MDCSwitch.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.ripple_.destroy();
                };
                MDCSwitch.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setNativeControlChecked: function setNativeControlChecked(checked) {
                            return _this.nativeControl_.checked = checked;
                        },
                        setNativeControlDisabled: function setNativeControlDisabled(disabled) {
                            return _this.nativeControl_.disabled = disabled;
                        },
                        setNativeControlAttr: function setNativeControlAttr(attr, value) {
                            return _this.nativeControl_.setAttribute(attr, value);
                        }
                    };
                    return new foundation_2.MDCSwitchFoundation(adapter);
                };
                Object.defineProperty(MDCSwitch.prototype, "ripple", {
                    get: function get() {
                        return this.ripple_;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitch.prototype, "checked", {
                    get: function get() {
                        return this.nativeControl_.checked;
                    },
                    set: function set(checked) {
                        this.foundation.setChecked(checked);
                        this.foundation.handleChange({
                            target: this.nativeControl_
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitch.prototype, "disabled", {
                    get: function get() {
                        return this.nativeControl_.disabled;
                    },
                    set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCSwitch.prototype.createRipple_ = function() {
                    var _this = this;
                    var RIPPLE_SURFACE_SELECTOR = foundation_2.MDCSwitchFoundation.strings.RIPPLE_SURFACE_SELECTOR;
                    var rippleSurface = this.root.querySelector(RIPPLE_SURFACE_SELECTOR);
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = __assign(__assign({}, component_2.MDCRipple.createAdapter(this)), {
                        addClass: function addClass(className) {
                            return rippleSurface.classList.add(className);
                        },
                        computeBoundingRect: function computeBoundingRect() {
                            return rippleSurface.getBoundingClientRect();
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            _this.nativeControl_.removeEventListener(evtType, handler, events_1.applyPassive());
                        },
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill_1.matches(_this.nativeControl_, ":active");
                        },
                        isUnbounded: function isUnbounded() {
                            return true;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            _this.nativeControl_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        removeClass: function removeClass(className) {
                            rippleSurface.classList.remove(className);
                        },
                        updateCssVariable: function updateCssVariable(varName, value) {
                            rippleSurface.style.setProperty(varName, value);
                        }
                    });
                    return new component_2.MDCRipple(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                Object.defineProperty(MDCSwitch.prototype, "nativeControl_", {
                    get: function get() {
                        var NATIVE_CONTROL_SELECTOR = foundation_2.MDCSwitchFoundation.strings.NATIVE_CONTROL_SELECTOR;
                        return this.root.querySelector(NATIVE_CONTROL_SELECTOR);
                    },
                    enumerable: false,
                    configurable: true
                });
                return MDCSwitch;
            }(component_1.MDCComponent);
            exports.MDCSwitch = MDCSwitch;
        /***/ },
        /***/ "./packages/mdc-switch/constants.ts": /*!******************************************!*\
  !*** ./packages/mdc-switch/constants.ts ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            /** CSS classes used by the switch. */ var cssClasses = {
                /** Class used for a switch that is in the "checked" (on) position. */ CHECKED: "mdc-switch--checked",
                /** Class used for a switch that is disabled. */ DISABLED: "mdc-switch--disabled"
            };
            exports.cssClasses = cssClasses;
            /** String constants used by the switch. */ var strings = {
                /** Aria attribute for checked or unchecked state of switch */ ARIA_CHECKED_ATTR: "aria-checked",
                /** A CSS selector used to locate the native HTML control for the switch.  */ NATIVE_CONTROL_SELECTOR: ".mdc-switch__native-control",
                /** A CSS selector used to locate the ripple surface element for the switch. */ RIPPLE_SURFACE_SELECTOR: ".mdc-switch__thumb-underlay"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-switch/custom-element.js": /*!***********************************************!*\
  !*** ./packages/mdc-switch/custom-element.js ***!
  \***********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-switch/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcSwitch = function(_HTMLElement) {
                _inherits(MdcSwitch, _HTMLElement);
                _createClass(MdcSwitch, [
                    {
                        key: "focus",
                        value: function focus() {
                            this.switch_.nativeControl_.focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            this.switch_.nativeControl_.blur();
                        }
                    },
                    {
                        key: "checked",
                        get: function get() {
                            return this.checked_;
                        },
                        set: function set(checked) {
                            this.checked_ = checked;
                            if (!!this.switch_) this.switch_.checked = checked;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.switch_) this.switch_.disabled = disabled;
                        }
                    }
                ]);
                function MdcSwitch() {
                    _classCallCheck(this, MdcSwitch);
                    var _this = _possibleConstructorReturn(this, (MdcSwitch.__proto__ || Object.getPrototypeOf(MdcSwitch)).call(this));
                    _this.checked_ = false;
                    _this.disabled_ = false;
                    _this.switch_;
                    return _this;
                }
                _createClass(MdcSwitch, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.switch_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCSwitch"](this);
                            this.switch_.checked = this.checked_;
                            this.switch_.disabled = this.disabled_;
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.switch_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcSwitch;
            }(HTMLElement);
            customElements.define("mdc-switch", MdcSwitch);
        /***/ },
        /***/ "./packages/mdc-switch/foundation.ts": /*!*******************************************!*\
  !*** ./packages/mdc-switch/foundation.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSwitchFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-switch/constants.ts");
            var MDCSwitchFoundation = /** @class */ function(_super) {
                __extends(MDCSwitchFoundation, _super);
                function MDCSwitchFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCSwitchFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCSwitchFoundation, "strings", {
                    /** The string constants used by the switch. */ get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitchFoundation, "cssClasses", {
                    /** The CSS classes used by the switch. */ get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCSwitchFoundation, "defaultAdapter", {
                    /** The default Adapter for the switch. */ get: function get() {
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            setNativeControlChecked: function setNativeControlChecked() {
                                return undefined;
                            },
                            setNativeControlDisabled: function setNativeControlDisabled() {
                                return undefined;
                            },
                            setNativeControlAttr: function setNativeControlAttr() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Sets the checked state of the switch. */ MDCSwitchFoundation.prototype.setChecked = function(checked) {
                    this.adapter.setNativeControlChecked(checked);
                    this.updateAriaChecked_(checked);
                    this.updateCheckedStyling_(checked);
                };
                /** Sets the disabled state of the switch. */ MDCSwitchFoundation.prototype.setDisabled = function(disabled) {
                    this.adapter.setNativeControlDisabled(disabled);
                    if (disabled) this.adapter.addClass(constants_1.cssClasses.DISABLED);
                    else this.adapter.removeClass(constants_1.cssClasses.DISABLED);
                };
                /** Handles the change event for the switch native control. */ MDCSwitchFoundation.prototype.handleChange = function(evt) {
                    var nativeControl = evt.target;
                    this.updateAriaChecked_(nativeControl.checked);
                    this.updateCheckedStyling_(nativeControl.checked);
                };
                /** Updates the styling of the switch based on its checked state. */ MDCSwitchFoundation.prototype.updateCheckedStyling_ = function(checked) {
                    if (checked) this.adapter.addClass(constants_1.cssClasses.CHECKED);
                    else this.adapter.removeClass(constants_1.cssClasses.CHECKED);
                };
                MDCSwitchFoundation.prototype.updateAriaChecked_ = function(checked) {
                    this.adapter.setNativeControlAttr(constants_1.strings.ARIA_CHECKED_ATTR, "" + !!checked);
                };
                return MDCSwitchFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCSwitchFoundation = MDCSwitchFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSwitchFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-bar/component.ts": /*!*******************************************!*\
  !*** ./packages/mdc-tab-bar/component.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabBar = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/tab-scroller/component */ "./packages/mdc-tab-scroller/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/tab/foundation */ "./packages/mdc-tab/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-bar/foundation.ts");
            var strings = foundation_2.MDCTabBarFoundation.strings;
            var MDCTabBar = /** @class */ function(_super) {
                __extends(MDCTabBar, _super);
                function MDCTabBar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabBar.attachTo = function(root) {
                    return new MDCTabBar(root);
                };
                Object.defineProperty(MDCTabBar.prototype, "focusOnActivate", {
                    set: function set(focusOnActivate) {
                        this.tabList_.forEach(function(tab) {
                            return tab.focusOnActivate = focusOnActivate;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabBar.prototype, "useAutomaticActivation", {
                    set: function set(useAutomaticActivation) {
                        this.foundation.setUseAutomaticActivation(useAutomaticActivation);
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabBar.prototype.initialize = function(tabScrollerFactory) {
                    if (tabScrollerFactory === void 0) tabScrollerFactory = function tabScrollerFactory(el) {
                        return new component_2.MDCTabScroller(el);
                    };
                    this.tabScroller_ = this.instantiateTabScroller_(tabScrollerFactory);
                };
                MDCTabBar.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleTabInteraction_ = function(evt) {
                        return _this.foundation.handleTabInteraction(evt);
                    };
                    this.handleKeyDown_ = function(evt) {
                        return _this.foundation.handleKeyDown(evt);
                    };
                    this.listen(foundation_1.MDCTabFoundation.strings.INTERACTED_EVENT, this.handleTabInteraction_);
                    this.listen("keydown", this.handleKeyDown_);
                    for(var i = 0; i < this.tabList_.length; i++)if (this.tabList_[i].active) {
                        this.scrollIntoView(i);
                        break;
                    }
                };
                MDCTabBar.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.unlisten(foundation_1.MDCTabFoundation.strings.INTERACTED_EVENT, this.handleTabInteraction_);
                    this.unlisten("keydown", this.handleKeyDown_);
                    if (this.tabScroller_) this.tabScroller_.destroy();
                };
                MDCTabBar.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        scrollTo: function scrollTo(scrollX) {
                            return _this.tabScroller_.scrollTo(scrollX);
                        },
                        incrementScroll: function incrementScroll(scrollXIncrement) {
                            return _this.tabScroller_.incrementScroll(scrollXIncrement);
                        },
                        getScrollPosition: function getScrollPosition() {
                            return _this.tabScroller_.getScrollPosition();
                        },
                        getScrollContentWidth: function getScrollContentWidth() {
                            return _this.tabScroller_.getScrollContentWidth();
                        },
                        getOffsetWidth: function getOffsetWidth() {
                            return _this.root.offsetWidth;
                        },
                        isRTL: function isRTL() {
                            return window.getComputedStyle(_this.root).getPropertyValue("direction") === "rtl";
                        },
                        setActiveTab: function setActiveTab() {},
                        activateTabAtIndex: function activateTabAtIndex(index, clientRect) {
                            return _this.tabList_[index].activate(clientRect);
                        },
                        deactivateTabAtIndex: function deactivateTabAtIndex(index) {
                            return _this.tabList_[index].deactivate();
                        },
                        focusTabAtIndex: function focusTabAtIndex(index) {
                            return _this.tabList_[index].focus();
                        },
                        getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex(index) {
                            return _this.tabList_[index].computeIndicatorClientRect();
                        },
                        getTabDimensionsAtIndex: function getTabDimensionsAtIndex(index) {
                            return _this.tabList_[index].computeDimensions();
                        },
                        getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
                            for(var i = 0; i < _this.tabList_.length; i++){
                                if (_this.tabList_[i].active) return i;
                            }
                            return -1;
                        },
                        getFocusedTabIndex: function getFocusedTabIndex() {
                            var tabElements = _this.getTabElements_();
                            var activeElement = document.activeElement;
                            return tabElements.indexOf(activeElement);
                        },
                        getIndexOfTabById: function getIndexOfTabById(id) {
                            for(var i = 0; i < _this.tabList_.length; i++){
                                if (_this.tabList_[i].id === id) return i;
                            }
                            return -1;
                        },
                        getTabListLength: function getTabListLength() {
                            return _this.tabList_.length;
                        },
                        notifyTabActivated: function notifyTabActivated(index) {
                            return _this.emit(strings.TAB_ACTIVATED_EVENT, {
                                index: index
                            }, true);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_2.MDCTabBarFoundation(adapter);
                };
                /**
     * Activates the tab at the given index
     * @param index The index of the tab
     */ MDCTabBar.prototype.activateTab = function(index) {
                    this.foundation.activateTab(index);
                };
                /**
     * Scrolls the tab at the given index into view
     * @param index THe index of the tab
     */ MDCTabBar.prototype.scrollIntoView = function(index) {
                    this.foundation.scrollIntoView(index);
                };
                /**
     * Returns all the tab elements in a nice clean array
     */ MDCTabBar.prototype.getTabElements_ = function() {
                    return [].slice.call(this.root.querySelectorAll(strings.TAB_SELECTOR));
                };
                Object.defineProperty(MDCTabBar.prototype, "tabList_", {
                    get: function get() {
                        return this.getTabElements_().map(function(el) {
                            el.init();
                            return el.tab_;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Instantiates tab scroller component on the child tab scroller element
     */ MDCTabBar.prototype.instantiateTabScroller_ = function(tabScrollerFactory) {
                    var tabScrollerElement = this.root.querySelector(strings.TAB_SCROLLER_SELECTOR);
                    if (tabScrollerElement) return tabScrollerFactory(tabScrollerElement);
                    return null;
                };
                return MDCTabBar;
            }(component_1.MDCComponent);
            exports.MDCTabBar = MDCTabBar;
        /***/ },
        /***/ "./packages/mdc-tab-bar/constants.ts": /*!*******************************************!*\
  !*** ./packages/mdc-tab-bar/constants.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.numbers = void 0;
            var strings = {
                ARROW_LEFT_KEY: "ArrowLeft",
                ARROW_RIGHT_KEY: "ArrowRight",
                END_KEY: "End",
                ENTER_KEY: "Enter",
                HOME_KEY: "Home",
                SPACE_KEY: "Space",
                TAB_ACTIVATED_EVENT: "MDCTabBar:activated",
                TAB_SCROLLER_SELECTOR: ".mdc-tab-scroller",
                TAB_SELECTOR: ".mdc-tab"
            };
            exports.strings = strings;
            var numbers = {
                ARROW_LEFT_KEYCODE: 37,
                ARROW_RIGHT_KEYCODE: 39,
                END_KEYCODE: 35,
                ENTER_KEYCODE: 13,
                EXTRA_SCROLL_AMOUNT: 20,
                HOME_KEYCODE: 36,
                SPACE_KEYCODE: 32
            };
            exports.numbers = numbers;
        /***/ },
        /***/ "./packages/mdc-tab-bar/custom-element.js": /*!************************************************!*\
  !*** ./packages/mdc-tab-bar/custom-element.js ***!
  \************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-tab-bar/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcTabBar = function(_HTMLElement) {
                _inherits(MdcTabBar, _HTMLElement);
                _createClass(MdcTabBar, [
                    {
                        key: "focus",
                        value: function focus() {
                            for(var i = 0; i < this.tabBar_.tabList_.length; i++)if (this.tabBar_.tabList_[i].active) {
                                this.tabBar_.tabList_[i].focus();
                                return;
                            }
                            if (this.tabBar_.tabList[0].length > 0) this.tabBar_.tabList_[0].focus();
                        }
                    },
                    {
                        key: "blur",
                        value: function blur() {
                            if (this.contains(document.activeElement)) document.activeElement.blur();
                        }
                    },
                    {
                        key: "focusOnActivate",
                        get: function get() {
                            return this.focusOnActivate_;
                        },
                        set: function set(focusOnActivate) {
                            this.focusOnActivate_ = focusOnActivate;
                            if (!!this.tabBar_) this.tabBar_.focusOnActivate = focusOnActivate;
                        }
                    },
                    {
                        key: "useAutomaticActivation",
                        get: function get() {
                            return this.useAutomaticActivation_;
                        },
                        set: function set(useAutomaticActivation) {
                            this.useAutomaticActivation_ = useAutomaticActivation;
                            if (!!this.tabBar_) this.tabBar_.useAutomaticActivation = useAutomaticActivation;
                        }
                    },
                    {
                        key: "activeTabIndex",
                        get: function get() {
                            return this.activeTabIndex_;
                        },
                        set: function set(activeTabIndex) {
                            this.activeTabIndex_ = activeTabIndex;
                            if (!!this.tabBar_) this.tabBar_.activateTab(activeTabIndex);
                        }
                    }
                ]);
                function MdcTabBar() {
                    _classCallCheck(this, MdcTabBar);
                    var _this = _possibleConstructorReturn(this, (MdcTabBar.__proto__ || Object.getPrototypeOf(MdcTabBar)).call(this));
                    _this.activeTabIndex_ = -1;
                    _this.focusOnActivate_ = false;
                    _this.useAutomaticActivation_ = false;
                    _this.tabBar_;
                    return _this;
                }
                _createClass(MdcTabBar, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.tabBar_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTabBar"](this);
                            this.tabBar_.focusOnActivate = this.focusOnActivate_;
                            this.tabBar_.useAutomaticActivation = this.useAutomaticActivation_;
                            if (this.activeTabIndex !== -1) this.tabBar_.tabList_[this.activeTabIndex_].activate();
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.tabBar_.destroy();
                        }
                    }
                ]);
                return MdcTabBar;
            }(HTMLElement);
            customElements.define("mdc-tab-bar", MdcTabBar);
        /***/ },
        /***/ "./packages/mdc-tab-bar/foundation.ts": /*!********************************************!*\
  !*** ./packages/mdc-tab-bar/foundation.ts ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabBarFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-bar/constants.ts");
            var ACCEPTABLE_KEYS = new Set();
            // IE11 has no support for new Set with iterable so we need to initialize this by hand
            ACCEPTABLE_KEYS.add(constants_1.strings.ARROW_LEFT_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.ARROW_RIGHT_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.END_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.HOME_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.ENTER_KEY);
            ACCEPTABLE_KEYS.add(constants_1.strings.SPACE_KEY);
            var KEYCODE_MAP = new Map();
            // IE11 has no support for new Map with iterable so we need to initialize this by hand
            KEYCODE_MAP.set(constants_1.numbers.ARROW_LEFT_KEYCODE, constants_1.strings.ARROW_LEFT_KEY);
            KEYCODE_MAP.set(constants_1.numbers.ARROW_RIGHT_KEYCODE, constants_1.strings.ARROW_RIGHT_KEY);
            KEYCODE_MAP.set(constants_1.numbers.END_KEYCODE, constants_1.strings.END_KEY);
            KEYCODE_MAP.set(constants_1.numbers.HOME_KEYCODE, constants_1.strings.HOME_KEY);
            KEYCODE_MAP.set(constants_1.numbers.ENTER_KEYCODE, constants_1.strings.ENTER_KEY);
            KEYCODE_MAP.set(constants_1.numbers.SPACE_KEYCODE, constants_1.strings.SPACE_KEY);
            var MDCTabBarFoundation = /** @class */ function(_super) {
                __extends(MDCTabBarFoundation, _super);
                function MDCTabBarFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTabBarFoundation.defaultAdapter), adapter)) || this;
                    _this.useAutomaticActivation_ = false;
                    return _this;
                }
                Object.defineProperty(MDCTabBarFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabBarFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabBarFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            scrollTo: function scrollTo() {
                                return undefined;
                            },
                            incrementScroll: function incrementScroll() {
                                return undefined;
                            },
                            getScrollPosition: function getScrollPosition() {
                                return 0;
                            },
                            getScrollContentWidth: function getScrollContentWidth() {
                                return 0;
                            },
                            getOffsetWidth: function getOffsetWidth() {
                                return 0;
                            },
                            isRTL: function isRTL() {
                                return false;
                            },
                            setActiveTab: function setActiveTab() {
                                return undefined;
                            },
                            activateTabAtIndex: function activateTabAtIndex() {
                                return undefined;
                            },
                            deactivateTabAtIndex: function deactivateTabAtIndex() {
                                return undefined;
                            },
                            focusTabAtIndex: function focusTabAtIndex() {
                                return undefined;
                            },
                            getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            getTabDimensionsAtIndex: function getTabDimensionsAtIndex() {
                                return {
                                    rootLeft: 0,
                                    rootRight: 0,
                                    contentLeft: 0,
                                    contentRight: 0
                                };
                            },
                            getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
                                return -1;
                            },
                            getFocusedTabIndex: function getFocusedTabIndex() {
                                return -1;
                            },
                            getIndexOfTabById: function getIndexOfTabById() {
                                return -1;
                            },
                            getTabListLength: function getTabListLength() {
                                return 0;
                            },
                            notifyTabActivated: function notifyTabActivated() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Switches between automatic and manual activation modes.
     * See https://www.w3.org/TR/wai-aria-practices/#tabpanel for examples.
     */ MDCTabBarFoundation.prototype.setUseAutomaticActivation = function(useAutomaticActivation) {
                    this.useAutomaticActivation_ = useAutomaticActivation;
                };
                MDCTabBarFoundation.prototype.activateTab = function(index) {
                    var previousActiveIndex = this.adapter.getPreviousActiveTabIndex();
                    if (!this.indexIsInRange_(index) || index === previousActiveIndex) return;
                    var previousClientRect;
                    if (previousActiveIndex !== -1) {
                        this.adapter.deactivateTabAtIndex(previousActiveIndex);
                        previousClientRect = this.adapter.getTabIndicatorClientRectAtIndex(previousActiveIndex);
                    }
                    this.adapter.activateTabAtIndex(index, previousClientRect);
                    this.scrollIntoView(index);
                };
                MDCTabBarFoundation.prototype.handleKeyDown = function(evt) {
                    // Get the key from the event
                    var key = this.getKeyFromEvent_(evt);
                    // Early exit if the event key isn't one of the keyboard navigation keys
                    if (key === undefined) return;
                    // Prevent default behavior for movement keys, but not for activation keys, since :active is used to apply ripple
                    if (!this.isActivationKey_(key)) evt.preventDefault();
                    if (this.useAutomaticActivation_) {
                        if (this.isActivationKey_(key)) return;
                        var index = this.determineTargetFromKey_(this.adapter.getPreviousActiveTabIndex(), key);
                        this.adapter.notifyTabActivated(index);
                        this.scrollIntoView(index);
                    } else {
                        var focusedTabIndex = this.adapter.getFocusedTabIndex();
                        if (this.isActivationKey_(key)) this.adapter.notifyTabActivated(focusedTabIndex);
                        else {
                            var index = this.determineTargetFromKey_(focusedTabIndex, key);
                            this.adapter.focusTabAtIndex(index);
                            this.scrollIntoView(index);
                        }
                    }
                };
                /**
     * Handles the MDCTab:interacted event
     */ MDCTabBarFoundation.prototype.handleTabInteraction = function(evt) {
                    this.adapter.notifyTabActivated(this.adapter.getIndexOfTabById(evt.detail.tabId));
                };
                /**
     * Scrolls the tab at the given index into view
     * @param index The tab index to make visible
     */ MDCTabBarFoundation.prototype.scrollIntoView = function(index) {
                    // Early exit if the index is out of range
                    if (!this.indexIsInRange_(index)) return;
                    // Always scroll to 0 if scrolling to the 0th index
                    if (index === 0) return this.adapter.scrollTo(0);
                    // Always scroll to the max value if scrolling to the Nth index
                    // MDCTabScroller.scrollTo() will never scroll past the max possible value
                    if (index === this.adapter.getTabListLength() - 1) return this.adapter.scrollTo(this.adapter.getScrollContentWidth());
                    if (this.isRTL_()) return this.scrollIntoViewRTL_(index);
                    this.scrollIntoView_(index);
                };
                /**
     * Private method for determining the index of the destination tab based on what key was pressed
     * @param origin The original index from which to determine the destination
     * @param key The name of the key
     */ MDCTabBarFoundation.prototype.determineTargetFromKey_ = function(origin, key) {
                    var isRTL = this.isRTL_();
                    var maxIndex = this.adapter.getTabListLength() - 1;
                    var shouldGoToEnd = key === constants_1.strings.END_KEY;
                    var shouldDecrement = key === constants_1.strings.ARROW_LEFT_KEY && !isRTL || key === constants_1.strings.ARROW_RIGHT_KEY && isRTL;
                    var shouldIncrement = key === constants_1.strings.ARROW_RIGHT_KEY && !isRTL || key === constants_1.strings.ARROW_LEFT_KEY && isRTL;
                    var index = origin;
                    if (shouldGoToEnd) index = maxIndex;
                    else if (shouldDecrement) index -= 1;
                    else if (shouldIncrement) index += 1;
                    else index = 0;
                    if (index < 0) index = maxIndex;
                    else if (index > maxIndex) index = 0;
                    return index;
                };
                /**
     * Calculates the scroll increment that will make the tab at the given index visible
     * @param index The index of the tab
     * @param nextIndex The index of the next tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the Tab Bar
     */ MDCTabBarFoundation.prototype.calculateScrollIncrement_ = function(index, nextIndex, scrollPosition, barWidth) {
                    var nextTabDimensions = this.adapter.getTabDimensionsAtIndex(nextIndex);
                    var relativeContentLeft = nextTabDimensions.contentLeft - scrollPosition - barWidth;
                    var relativeContentRight = nextTabDimensions.contentRight - scrollPosition;
                    var leftIncrement = relativeContentRight - constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    var rightIncrement = relativeContentLeft + constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    if (nextIndex < index) return Math.min(leftIncrement, 0);
                    return Math.max(rightIncrement, 0);
                };
                /**
     * Calculates the scroll increment that will make the tab at the given index visible in RTL
     * @param index The index of the tab
     * @param nextIndex The index of the next tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the Tab Bar
     * @param scrollContentWidth The width of the scroll content
     */ MDCTabBarFoundation.prototype.calculateScrollIncrementRTL_ = function(index, nextIndex, scrollPosition, barWidth, scrollContentWidth) {
                    var nextTabDimensions = this.adapter.getTabDimensionsAtIndex(nextIndex);
                    var relativeContentLeft = scrollContentWidth - nextTabDimensions.contentLeft - scrollPosition;
                    var relativeContentRight = scrollContentWidth - nextTabDimensions.contentRight - scrollPosition - barWidth;
                    var leftIncrement = relativeContentRight + constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    var rightIncrement = relativeContentLeft - constants_1.numbers.EXTRA_SCROLL_AMOUNT;
                    if (nextIndex > index) return Math.max(leftIncrement, 0);
                    return Math.min(rightIncrement, 0);
                };
                /**
     * Determines the index of the adjacent tab closest to either edge of the Tab Bar
     * @param index The index of the tab
     * @param tabDimensions The dimensions of the tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the tab bar
     */ MDCTabBarFoundation.prototype.findAdjacentTabIndexClosestToEdge_ = function(index, tabDimensions, scrollPosition, barWidth) {
                    /**
         * Tabs are laid out in the Tab Scroller like this:
         *
         *    Scroll Position
         *    +---+
         *    |   |   Bar Width
         *    |   +-----------------------------------+
         *    |   |                                   |
         *    |   V                                   V
         *    |   +-----------------------------------+
         *    V   |             Tab Scroller          |
         *    +------------+--------------+-------------------+
         *    |    Tab     |      Tab     |        Tab        |
         *    +------------+--------------+-------------------+
         *        |                                   |
         *        +-----------------------------------+
         *
         * To determine the next adjacent index, we look at the Tab root left and
         * Tab root right, both relative to the scroll position. If the Tab root
         * left is less than 0, then we know it's out of view to the left. If the
         * Tab root right minus the bar width is greater than 0, we know the Tab is
         * out of view to the right. From there, we either increment or decrement
         * the index.
         */ var relativeRootLeft = tabDimensions.rootLeft - scrollPosition;
                    var relativeRootRight = tabDimensions.rootRight - scrollPosition - barWidth;
                    var relativeRootDelta = relativeRootLeft + relativeRootRight;
                    var leftEdgeIsCloser = relativeRootLeft < 0 || relativeRootDelta < 0;
                    var rightEdgeIsCloser = relativeRootRight > 0 || relativeRootDelta > 0;
                    if (leftEdgeIsCloser) return index - 1;
                    if (rightEdgeIsCloser) return index + 1;
                    return -1;
                };
                /**
     * Determines the index of the adjacent tab closest to either edge of the Tab Bar in RTL
     * @param index The index of the tab
     * @param tabDimensions The dimensions of the tab
     * @param scrollPosition The current scroll position
     * @param barWidth The width of the tab bar
     * @param scrollContentWidth The width of the scroller content
     */ MDCTabBarFoundation.prototype.findAdjacentTabIndexClosestToEdgeRTL_ = function(index, tabDimensions, scrollPosition, barWidth, scrollContentWidth) {
                    var rootLeft = scrollContentWidth - tabDimensions.rootLeft - barWidth - scrollPosition;
                    var rootRight = scrollContentWidth - tabDimensions.rootRight - scrollPosition;
                    var rootDelta = rootLeft + rootRight;
                    var leftEdgeIsCloser = rootLeft > 0 || rootDelta > 0;
                    var rightEdgeIsCloser = rootRight < 0 || rootDelta < 0;
                    if (leftEdgeIsCloser) return index + 1;
                    if (rightEdgeIsCloser) return index - 1;
                    return -1;
                };
                /**
     * Returns the key associated with a keydown event
     * @param evt The keydown event
     */ MDCTabBarFoundation.prototype.getKeyFromEvent_ = function(evt) {
                    if (ACCEPTABLE_KEYS.has(evt.key)) return evt.key;
                    return KEYCODE_MAP.get(evt.keyCode);
                };
                MDCTabBarFoundation.prototype.isActivationKey_ = function(key) {
                    return key === constants_1.strings.SPACE_KEY || key === constants_1.strings.ENTER_KEY;
                };
                /**
     * Returns whether a given index is inclusively between the ends
     * @param index The index to test
     */ MDCTabBarFoundation.prototype.indexIsInRange_ = function(index) {
                    return index >= 0 && index < this.adapter.getTabListLength();
                };
                /**
     * Returns the view's RTL property
     */ MDCTabBarFoundation.prototype.isRTL_ = function() {
                    return this.adapter.isRTL();
                };
                /**
     * Scrolls the tab at the given index into view for left-to-right user agents.
     * @param index The index of the tab to scroll into view
     */ MDCTabBarFoundation.prototype.scrollIntoView_ = function(index) {
                    var scrollPosition = this.adapter.getScrollPosition();
                    var barWidth = this.adapter.getOffsetWidth();
                    var tabDimensions = this.adapter.getTabDimensionsAtIndex(index);
                    var nextIndex = this.findAdjacentTabIndexClosestToEdge_(index, tabDimensions, scrollPosition, barWidth);
                    if (!this.indexIsInRange_(nextIndex)) return;
                    var scrollIncrement = this.calculateScrollIncrement_(index, nextIndex, scrollPosition, barWidth);
                    this.adapter.incrementScroll(scrollIncrement);
                };
                /**
     * Scrolls the tab at the given index into view in RTL
     * @param index The tab index to make visible
     */ MDCTabBarFoundation.prototype.scrollIntoViewRTL_ = function(index) {
                    var scrollPosition = this.adapter.getScrollPosition();
                    var barWidth = this.adapter.getOffsetWidth();
                    var tabDimensions = this.adapter.getTabDimensionsAtIndex(index);
                    var scrollWidth = this.adapter.getScrollContentWidth();
                    var nextIndex = this.findAdjacentTabIndexClosestToEdgeRTL_(index, tabDimensions, scrollPosition, barWidth, scrollWidth);
                    if (!this.indexIsInRange_(nextIndex)) return;
                    var scrollIncrement = this.calculateScrollIncrementRTL_(index, nextIndex, scrollPosition, barWidth, scrollWidth);
                    this.adapter.incrementScroll(scrollIncrement);
                };
                return MDCTabBarFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabBarFoundation = MDCTabBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabBarFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/component.ts": /*!*************************************************!*\
  !*** ./packages/mdc-tab-indicator/component.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabIndicator = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var fading_foundation_1 = __webpack_require__(/*! ./fading-foundation */ "./packages/mdc-tab-indicator/fading-foundation.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-indicator/foundation.ts");
            var sliding_foundation_1 = __webpack_require__(/*! ./sliding-foundation */ "./packages/mdc-tab-indicator/sliding-foundation.ts");
            var MDCTabIndicator = /** @class */ function(_super) {
                __extends(MDCTabIndicator, _super);
                function MDCTabIndicator() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabIndicator.attachTo = function(root) {
                    return new MDCTabIndicator(root);
                };
                MDCTabIndicator.prototype.initialize = function() {
                    this.content_ = this.root.querySelector(foundation_1.MDCTabIndicatorFoundation.strings.CONTENT_SELECTOR);
                };
                MDCTabIndicator.prototype.computeContentClientRect = function() {
                    return this.foundation.computeContentClientRect();
                };
                MDCTabIndicator.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        computeContentClientRect: function computeContentClientRect() {
                            return _this.content_.getBoundingClientRect();
                        },
                        setContentStyleProperty: function setContentStyleProperty(prop, value) {
                            return _this.content_.style.setProperty(prop, value);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    if (this.root.classList.contains(foundation_1.MDCTabIndicatorFoundation.cssClasses.FADE)) return new fading_foundation_1.MDCFadingTabIndicatorFoundation(adapter);
                    // Default to the sliding indicator
                    return new sliding_foundation_1.MDCSlidingTabIndicatorFoundation(adapter);
                };
                MDCTabIndicator.prototype.activate = function(previousIndicatorClientRect) {
                    this.foundation.activate(previousIndicatorClientRect);
                };
                MDCTabIndicator.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                return MDCTabIndicator;
            }(component_1.MDCComponent);
            exports.MDCTabIndicator = MDCTabIndicator;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/constants.ts": /*!*************************************************!*\
  !*** ./packages/mdc-tab-indicator/constants.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ACTIVE: "mdc-tab-indicator--active",
                FADE: "mdc-tab-indicator--fade",
                NO_TRANSITION: "mdc-tab-indicator--no-transition"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                CONTENT_SELECTOR: ".mdc-tab-indicator__content"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/fading-foundation.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-tab-indicator/fading-foundation.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFadingTabIndicatorFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-indicator/foundation.ts");
            /* istanbul ignore next: subclass is not a branch statement */ var MDCFadingTabIndicatorFoundation = /** @class */ function(_super) {
                __extends(MDCFadingTabIndicatorFoundation, _super);
                function MDCFadingTabIndicatorFoundation() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCFadingTabIndicatorFoundation.prototype.activate = function() {
                    this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                };
                MDCFadingTabIndicatorFoundation.prototype.deactivate = function() {
                    this.adapter.removeClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                };
                return MDCFadingTabIndicatorFoundation;
            }(foundation_1.MDCTabIndicatorFoundation);
            exports.MDCFadingTabIndicatorFoundation = MDCFadingTabIndicatorFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFadingTabIndicatorFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/foundation.ts": /*!**************************************************!*\
  !*** ./packages/mdc-tab-indicator/foundation.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabIndicatorFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-indicator/constants.ts");
            var MDCTabIndicatorFoundation = /** @class */ function(_super) {
                __extends(MDCTabIndicatorFoundation, _super);
                function MDCTabIndicatorFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTabIndicatorFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTabIndicatorFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabIndicatorFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabIndicatorFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            computeContentClientRect: function computeContentClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            setContentStyleProperty: function setContentStyleProperty() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabIndicatorFoundation.prototype.computeContentClientRect = function() {
                    return this.adapter.computeContentClientRect();
                };
                return MDCTabIndicatorFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabIndicatorFoundation = MDCTabIndicatorFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabIndicatorFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-indicator/sliding-foundation.ts": /*!**********************************************************!*\
  !*** ./packages/mdc-tab-indicator/sliding-foundation.ts ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCSlidingTabIndicatorFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-indicator/foundation.ts");
            /* istanbul ignore next: subclass is not a branch statement */ var MDCSlidingTabIndicatorFoundation = /** @class */ function(_super) {
                __extends(MDCSlidingTabIndicatorFoundation, _super);
                function MDCSlidingTabIndicatorFoundation() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCSlidingTabIndicatorFoundation.prototype.activate = function(previousIndicatorClientRect) {
                    // Early exit if no indicator is present to handle cases where an indicator
                    // may be activated without a prior indicator state
                    if (!previousIndicatorClientRect) {
                        this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                        return;
                    }
                    // This animation uses the FLIP approach. You can read more about it at the link below:
                    // https://aerotwist.com/blog/flip-your-animations/
                    // Calculate the dimensions based on the dimensions of the previous indicator
                    var currentClientRect = this.computeContentClientRect();
                    var widthDelta = previousIndicatorClientRect.width / currentClientRect.width;
                    var xPosition = previousIndicatorClientRect.left - currentClientRect.left;
                    this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.NO_TRANSITION);
                    this.adapter.setContentStyleProperty("transform", "translateX(" + xPosition + "px) scaleX(" + widthDelta + ")");
                    // Force repaint before updating classes and transform to ensure the transform properly takes effect
                    this.computeContentClientRect();
                    this.adapter.removeClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.NO_TRANSITION);
                    this.adapter.addClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                    this.adapter.setContentStyleProperty("transform", "");
                };
                MDCSlidingTabIndicatorFoundation.prototype.deactivate = function() {
                    this.adapter.removeClass(foundation_1.MDCTabIndicatorFoundation.cssClasses.ACTIVE);
                };
                return MDCSlidingTabIndicatorFoundation;
            }(foundation_1.MDCTabIndicatorFoundation);
            exports.MDCSlidingTabIndicatorFoundation = MDCSlidingTabIndicatorFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCSlidingTabIndicatorFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/component.ts": /*!************************************************!*\
  !*** ./packages/mdc-tab-scroller/component.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScroller = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill_1 = __webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab-scroller/foundation.ts");
            var util = __importStar(__webpack_require__(/*! ./util */ "./packages/mdc-tab-scroller/util.ts"));
            var MDCTabScroller = /** @class */ function(_super) {
                __extends(MDCTabScroller, _super);
                function MDCTabScroller() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScroller.attachTo = function(root) {
                    return new MDCTabScroller(root);
                };
                MDCTabScroller.prototype.initialize = function() {
                    this.area_ = this.root.querySelector(foundation_1.MDCTabScrollerFoundation.strings.AREA_SELECTOR);
                    this.content_ = this.root.querySelector(foundation_1.MDCTabScrollerFoundation.strings.CONTENT_SELECTOR);
                };
                MDCTabScroller.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleInteraction_ = function() {
                        return _this.foundation.handleInteraction();
                    };
                    this.handleTransitionEnd_ = function(evt) {
                        return _this.foundation.handleTransitionEnd(evt);
                    };
                    this.area_.addEventListener("wheel", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("touchstart", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("pointerdown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("mousedown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.addEventListener("keydown", this.handleInteraction_, events_1.applyPassive());
                    this.content_.addEventListener("transitionend", this.handleTransitionEnd_);
                };
                MDCTabScroller.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.area_.removeEventListener("wheel", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("touchstart", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("pointerdown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("mousedown", this.handleInteraction_, events_1.applyPassive());
                    this.area_.removeEventListener("keydown", this.handleInteraction_, events_1.applyPassive());
                    this.content_.removeEventListener("transitionend", this.handleTransitionEnd_);
                };
                MDCTabScroller.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        eventTargetMatchesSelector: function eventTargetMatchesSelector(evtTarget, selector) {
                            return ponyfill_1.matches(evtTarget, selector);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        addScrollAreaClass: function addScrollAreaClass(className) {
                            return _this.area_.classList.add(className);
                        },
                        setScrollAreaStyleProperty: function setScrollAreaStyleProperty(prop, value) {
                            return _this.area_.style.setProperty(prop, value);
                        },
                        setScrollContentStyleProperty: function setScrollContentStyleProperty(prop, value) {
                            return _this.content_.style.setProperty(prop, value);
                        },
                        getScrollContentStyleValue: function getScrollContentStyleValue(propName) {
                            return window.getComputedStyle(_this.content_).getPropertyValue(propName);
                        },
                        setScrollAreaScrollLeft: function setScrollAreaScrollLeft(scrollX) {
                            return _this.area_.scrollLeft = scrollX;
                        },
                        getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
                            return _this.area_.scrollLeft;
                        },
                        getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
                            return _this.content_.offsetWidth;
                        },
                        getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
                            return _this.area_.offsetWidth;
                        },
                        computeScrollAreaClientRect: function computeScrollAreaClientRect() {
                            return _this.area_.getBoundingClientRect();
                        },
                        computeScrollContentClientRect: function computeScrollContentClientRect() {
                            return _this.content_.getBoundingClientRect();
                        },
                        computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
                            return util.computeHorizontalScrollbarHeight(document);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCTabScrollerFoundation(adapter);
                };
                /**
     * Returns the current visual scroll position
     */ MDCTabScroller.prototype.getScrollPosition = function() {
                    return this.foundation.getScrollPosition();
                };
                /**
     * Returns the width of the scroll content
     */ MDCTabScroller.prototype.getScrollContentWidth = function() {
                    return this.content_.offsetWidth;
                };
                /**
     * Increments the scroll value by the given amount
     * @param scrollXIncrement The pixel value by which to increment the scroll value
     */ MDCTabScroller.prototype.incrementScroll = function(scrollXIncrement) {
                    this.foundation.incrementScroll(scrollXIncrement);
                };
                /**
     * Scrolls to the given pixel position
     * @param scrollX The pixel value to scroll to
     */ MDCTabScroller.prototype.scrollTo = function(scrollX) {
                    this.foundation.scrollTo(scrollX);
                };
                return MDCTabScroller;
            }(component_1.MDCComponent);
            exports.MDCTabScroller = MDCTabScroller;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/constants.ts": /*!************************************************!*\
  !*** ./packages/mdc-tab-scroller/constants.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ANIMATING: "mdc-tab-scroller--animating",
                SCROLL_AREA_SCROLL: "mdc-tab-scroller__scroll-area--scroll",
                SCROLL_TEST: "mdc-tab-scroller__test"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                AREA_SELECTOR: ".mdc-tab-scroller__scroll-area",
                CONTENT_SELECTOR: ".mdc-tab-scroller__scroll-content"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/foundation.ts": /*!*************************************************!*\
  !*** ./packages/mdc-tab-scroller/foundation.ts ***!
  \*************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __read = this && this.__read || function(o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m) return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
                } catch (error) {
                    e = {
                        error: error
                    };
                } finally{
                    try {
                        if (r && !r.done && (m = i["return"])) m.call(i);
                    } finally{
                        if (e) throw e.error;
                    }
                }
                return ar;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-scroller/constants.ts");
            var rtl_default_scroller_1 = __webpack_require__(/*! ./rtl-default-scroller */ "./packages/mdc-tab-scroller/rtl-default-scroller.ts");
            var rtl_negative_scroller_1 = __webpack_require__(/*! ./rtl-negative-scroller */ "./packages/mdc-tab-scroller/rtl-negative-scroller.ts");
            var rtl_reverse_scroller_1 = __webpack_require__(/*! ./rtl-reverse-scroller */ "./packages/mdc-tab-scroller/rtl-reverse-scroller.ts");
            var MDCTabScrollerFoundation = /** @class */ function(_super) {
                __extends(MDCTabScrollerFoundation, _super);
                function MDCTabScrollerFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTabScrollerFoundation.defaultAdapter), adapter)) || this;
                    /**
         * Controls whether we should handle the transitionend and interaction events during the animation.
         */ _this.isAnimating_ = false;
                    return _this;
                }
                Object.defineProperty(MDCTabScrollerFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabScrollerFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabScrollerFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            eventTargetMatchesSelector: function eventTargetMatchesSelector() {
                                return false;
                            },
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            addScrollAreaClass: function addScrollAreaClass() {
                                return undefined;
                            },
                            setScrollAreaStyleProperty: function setScrollAreaStyleProperty() {
                                return undefined;
                            },
                            setScrollContentStyleProperty: function setScrollContentStyleProperty() {
                                return undefined;
                            },
                            getScrollContentStyleValue: function getScrollContentStyleValue() {
                                return "";
                            },
                            setScrollAreaScrollLeft: function setScrollAreaScrollLeft() {
                                return undefined;
                            },
                            getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
                                return 0;
                            },
                            getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
                                return 0;
                            },
                            getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
                                return 0;
                            },
                            computeScrollAreaClientRect: function computeScrollAreaClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            computeScrollContentClientRect: function computeScrollContentClientRect() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
                                return 0;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabScrollerFoundation.prototype.init = function() {
                    // Compute horizontal scrollbar height on scroller with overflow initially hidden, then update overflow to scroll
                    // and immediately adjust bottom margin to avoid the scrollbar initially appearing before JS runs.
                    var horizontalScrollbarHeight = this.adapter.computeHorizontalScrollbarHeight();
                    this.adapter.setScrollAreaStyleProperty("margin-bottom", -horizontalScrollbarHeight + "px");
                    this.adapter.addScrollAreaClass(MDCTabScrollerFoundation.cssClasses.SCROLL_AREA_SCROLL);
                };
                /**
     * Computes the current visual scroll position
     */ MDCTabScrollerFoundation.prototype.getScrollPosition = function() {
                    if (this.isRTL_()) return this.computeCurrentScrollPositionRTL_();
                    var currentTranslateX = this.calculateCurrentTranslateX_();
                    var scrollLeft = this.adapter.getScrollAreaScrollLeft();
                    return scrollLeft - currentTranslateX;
                };
                /**
     * Handles interaction events that occur during transition
     */ MDCTabScrollerFoundation.prototype.handleInteraction = function() {
                    // Early exit if we aren't animating
                    if (!this.isAnimating_) return;
                    // Prevent other event listeners from handling this event
                    this.stopScrollAnimation_();
                };
                /**
     * Handles the transitionend event
     */ MDCTabScrollerFoundation.prototype.handleTransitionEnd = function(evt) {
                    // Early exit if we aren't animating or the event was triggered by a different element.
                    var evtTarget = evt.target;
                    if (!this.isAnimating_ || !this.adapter.eventTargetMatchesSelector(evtTarget, MDCTabScrollerFoundation.strings.CONTENT_SELECTOR)) return;
                    this.isAnimating_ = false;
                    this.adapter.removeClass(MDCTabScrollerFoundation.cssClasses.ANIMATING);
                };
                /**
     * Increment the scroll value by the scrollXIncrement using animation.
     * @param scrollXIncrement The value by which to increment the scroll position
     */ MDCTabScrollerFoundation.prototype.incrementScroll = function(scrollXIncrement) {
                    // Early exit for non-operational increment values
                    if (scrollXIncrement === 0) return;
                    this.animate_(this.getIncrementScrollOperation_(scrollXIncrement));
                };
                /**
     * Increment the scroll value by the scrollXIncrement without animation.
     * @param scrollXIncrement The value by which to increment the scroll position
     */ MDCTabScrollerFoundation.prototype.incrementScrollImmediate = function(scrollXIncrement) {
                    // Early exit for non-operational increment values
                    if (scrollXIncrement === 0) return;
                    var operation = this.getIncrementScrollOperation_(scrollXIncrement);
                    if (operation.scrollDelta === 0) return;
                    this.stopScrollAnimation_();
                    this.adapter.setScrollAreaScrollLeft(operation.finalScrollPosition);
                };
                /**
     * Scrolls to the given scrollX value
     */ MDCTabScrollerFoundation.prototype.scrollTo = function(scrollX) {
                    if (this.isRTL_()) return this.scrollToRTL_(scrollX);
                    this.scrollTo_(scrollX);
                };
                /**
     * @return Browser-specific {@link MDCTabScrollerRTL} instance.
     */ MDCTabScrollerFoundation.prototype.getRTLScroller = function() {
                    if (!this.rtlScrollerInstance_) this.rtlScrollerInstance_ = this.rtlScrollerFactory_();
                    return this.rtlScrollerInstance_;
                };
                /**
     * @return translateX value from a CSS matrix transform function string.
     */ MDCTabScrollerFoundation.prototype.calculateCurrentTranslateX_ = function() {
                    var transformValue = this.adapter.getScrollContentStyleValue("transform");
                    // Early exit if no transform is present
                    if (transformValue === "none") return 0;
                    // The transform value comes back as a matrix transformation in the form
                    // of `matrix(a, b, c, d, tx, ty)`. We only care about tx (translateX) so
                    // we're going to grab all the parenthesized values, strip out tx, and
                    // parse it.
                    var match = /\((.+?)\)/.exec(transformValue);
                    if (!match) return 0;
                    var matrixParams = match[1];
                    // tslint:disable-next-line:ban-ts-ignore "Unused vars" should be a linter warning, not a compiler error.
                    // @ts-ignore These unused variables should retain their semantic names for clarity.
                    var _a = __read(matrixParams.split(","), 6), a = _a[0], b = _a[1], c = _a[2], d = _a[3], tx = _a[4], ty = _a[5];
                    return parseFloat(tx); // tslint:disable-line:ban
                };
                /**
     * Calculates a safe scroll value that is > 0 and < the max scroll value
     * @param scrollX The distance to scroll
     */ MDCTabScrollerFoundation.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.min(Math.max(edges.left, scrollX), edges.right);
                };
                MDCTabScrollerFoundation.prototype.computeCurrentScrollPositionRTL_ = function() {
                    var translateX = this.calculateCurrentTranslateX_();
                    return this.getRTLScroller().getScrollPositionRTL(translateX);
                };
                MDCTabScrollerFoundation.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: 0,
                        right: contentWidth - rootWidth
                    };
                };
                /**
     * Internal scroll method
     * @param scrollX The new scroll position
     */ MDCTabScrollerFoundation.prototype.scrollTo_ = function(scrollX) {
                    var currentScrollX = this.getScrollPosition();
                    var safeScrollX = this.clampScrollValue_(scrollX);
                    var scrollDelta = safeScrollX - currentScrollX;
                    this.animate_({
                        finalScrollPosition: safeScrollX,
                        scrollDelta: scrollDelta
                    });
                };
                /**
     * Internal RTL scroll method
     * @param scrollX The new scroll position
     */ MDCTabScrollerFoundation.prototype.scrollToRTL_ = function(scrollX) {
                    var animation = this.getRTLScroller().scrollToRTL(scrollX);
                    this.animate_(animation);
                };
                /**
     * Internal method to compute the increment scroll operation values.
     * @param scrollX The desired scroll position increment
     * @return MDCTabScrollerAnimation with the sanitized values for performing the scroll operation.
     */ MDCTabScrollerFoundation.prototype.getIncrementScrollOperation_ = function(scrollX) {
                    if (this.isRTL_()) return this.getRTLScroller().incrementScrollRTL(scrollX);
                    var currentScrollX = this.getScrollPosition();
                    var targetScrollX = scrollX + currentScrollX;
                    var safeScrollX = this.clampScrollValue_(targetScrollX);
                    var scrollDelta = safeScrollX - currentScrollX;
                    return {
                        finalScrollPosition: safeScrollX,
                        scrollDelta: scrollDelta
                    };
                };
                /**
     * Animates the tab scrolling
     * @param animation The animation to apply
     */ MDCTabScrollerFoundation.prototype.animate_ = function(animation) {
                    var _this = this;
                    // Early exit if translateX is 0, which means there's no animation to perform
                    if (animation.scrollDelta === 0) return;
                    this.stopScrollAnimation_();
                    // This animation uses the FLIP approach.
                    // Read more here: https://aerotwist.com/blog/flip-your-animations/
                    this.adapter.setScrollAreaScrollLeft(animation.finalScrollPosition);
                    this.adapter.setScrollContentStyleProperty("transform", "translateX(" + animation.scrollDelta + "px)");
                    // Force repaint
                    this.adapter.computeScrollAreaClientRect();
                    requestAnimationFrame(function() {
                        _this.adapter.addClass(MDCTabScrollerFoundation.cssClasses.ANIMATING);
                        _this.adapter.setScrollContentStyleProperty("transform", "none");
                    });
                    this.isAnimating_ = true;
                };
                /**
     * Stops scroll animation
     */ MDCTabScrollerFoundation.prototype.stopScrollAnimation_ = function() {
                    this.isAnimating_ = false;
                    var currentScrollPosition = this.getAnimatingScrollPosition_();
                    this.adapter.removeClass(MDCTabScrollerFoundation.cssClasses.ANIMATING);
                    this.adapter.setScrollContentStyleProperty("transform", "translateX(0px)");
                    this.adapter.setScrollAreaScrollLeft(currentScrollPosition);
                };
                /**
     * Gets the current scroll position during animation
     */ MDCTabScrollerFoundation.prototype.getAnimatingScrollPosition_ = function() {
                    var currentTranslateX = this.calculateCurrentTranslateX_();
                    var scrollLeft = this.adapter.getScrollAreaScrollLeft();
                    if (this.isRTL_()) return this.getRTLScroller().getAnimatingScrollPosition(scrollLeft, currentTranslateX);
                    return scrollLeft - currentTranslateX;
                };
                /**
     * Determines the RTL Scroller to use
     */ MDCTabScrollerFoundation.prototype.rtlScrollerFactory_ = function() {
                    // Browsers have three different implementations of scrollLeft in RTL mode,
                    // dependent on the browser. The behavior is based off the max LTR
                    // scrollLeft value and 0.
                    //
                    // * Default scrolling in RTL *
                    //    - Left-most value: 0
                    //    - Right-most value: Max LTR scrollLeft value
                    //
                    // * Negative scrolling in RTL *
                    //    - Left-most value: Negated max LTR scrollLeft value
                    //    - Right-most value: 0
                    //
                    // * Reverse scrolling in RTL *
                    //    - Left-most value: Max LTR scrollLeft value
                    //    - Right-most value: 0
                    //
                    // We use those principles below to determine which RTL scrollLeft
                    // behavior is implemented in the current browser.
                    var initialScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    this.adapter.setScrollAreaScrollLeft(initialScrollLeft - 1);
                    var newScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    // If the newScrollLeft value is negative,then we know that the browser has
                    // implemented negative RTL scrolling, since all other implementations have
                    // only positive values.
                    if (newScrollLeft < 0) {
                        // Undo the scrollLeft test check
                        this.adapter.setScrollAreaScrollLeft(initialScrollLeft);
                        return new rtl_negative_scroller_1.MDCTabScrollerRTLNegative(this.adapter);
                    }
                    var rootClientRect = this.adapter.computeScrollAreaClientRect();
                    var contentClientRect = this.adapter.computeScrollContentClientRect();
                    var rightEdgeDelta = Math.round(contentClientRect.right - rootClientRect.right);
                    // Undo the scrollLeft test check
                    this.adapter.setScrollAreaScrollLeft(initialScrollLeft);
                    // By calculating the clientRect of the root element and the clientRect of
                    // the content element, we can determine how much the scroll value changed
                    // when we performed the scrollLeft subtraction above.
                    if (rightEdgeDelta === newScrollLeft) return new rtl_reverse_scroller_1.MDCTabScrollerRTLReverse(this.adapter);
                    return new rtl_default_scroller_1.MDCTabScrollerRTLDefault(this.adapter);
                };
                MDCTabScrollerFoundation.prototype.isRTL_ = function() {
                    return this.adapter.getScrollContentStyleValue("direction") === "rtl";
                };
                return MDCTabScrollerFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabScrollerFoundation = MDCTabScrollerFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerFoundation;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-default-scroller.ts": /*!***********************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-default-scroller.ts ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTLDefault = void 0;
            var rtl_scroller_1 = __webpack_require__(/*! ./rtl-scroller */ "./packages/mdc-tab-scroller/rtl-scroller.ts");
            var MDCTabScrollerRTLDefault = /** @class */ function(_super) {
                __extends(MDCTabScrollerRTLDefault, _super);
                function MDCTabScrollerRTLDefault() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScrollerRTLDefault.prototype.getScrollPositionRTL = function() {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var right = this.calculateScrollEdges_().right;
                    // Scroll values on most browsers are ints instead of floats so we round
                    return Math.round(right - currentScrollLeft);
                };
                MDCTabScrollerRTLDefault.prototype.scrollToRTL = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(edges.right - scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLDefault.prototype.incrementScrollRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(currentScrollLeft - scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLDefault.prototype.getAnimatingScrollPosition = function(scrollX) {
                    return scrollX;
                };
                MDCTabScrollerRTLDefault.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: 0,
                        right: contentWidth - rootWidth
                    };
                };
                MDCTabScrollerRTLDefault.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.min(Math.max(edges.left, scrollX), edges.right);
                };
                return MDCTabScrollerRTLDefault;
            }(rtl_scroller_1.MDCTabScrollerRTL);
            exports.MDCTabScrollerRTLDefault = MDCTabScrollerRTLDefault;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTLDefault;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-negative-scroller.ts": /*!************************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-negative-scroller.ts ***!
  \************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTLNegative = void 0;
            var rtl_scroller_1 = __webpack_require__(/*! ./rtl-scroller */ "./packages/mdc-tab-scroller/rtl-scroller.ts");
            var MDCTabScrollerRTLNegative = /** @class */ function(_super) {
                __extends(MDCTabScrollerRTLNegative, _super);
                function MDCTabScrollerRTLNegative() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScrollerRTLNegative.prototype.getScrollPositionRTL = function(translateX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    return Math.round(translateX - currentScrollLeft);
                };
                MDCTabScrollerRTLNegative.prototype.scrollToRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(-scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLNegative.prototype.incrementScrollRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(currentScrollLeft - scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: clampedScrollLeft - currentScrollLeft
                    };
                };
                MDCTabScrollerRTLNegative.prototype.getAnimatingScrollPosition = function(scrollX, translateX) {
                    return scrollX - translateX;
                };
                MDCTabScrollerRTLNegative.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: rootWidth - contentWidth,
                        right: 0
                    };
                };
                MDCTabScrollerRTLNegative.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.max(Math.min(edges.right, scrollX), edges.left);
                };
                return MDCTabScrollerRTLNegative;
            }(rtl_scroller_1.MDCTabScrollerRTL);
            exports.MDCTabScrollerRTLNegative = MDCTabScrollerRTLNegative;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTLNegative;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-reverse-scroller.ts": /*!***********************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-reverse-scroller.ts ***!
  \***********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTLReverse = void 0;
            var rtl_scroller_1 = __webpack_require__(/*! ./rtl-scroller */ "./packages/mdc-tab-scroller/rtl-scroller.ts");
            var MDCTabScrollerRTLReverse = /** @class */ function(_super) {
                __extends(MDCTabScrollerRTLReverse, _super);
                function MDCTabScrollerRTLReverse() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTabScrollerRTLReverse.prototype.getScrollPositionRTL = function(translateX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    // Scroll values on most browsers are ints instead of floats so we round
                    return Math.round(currentScrollLeft - translateX);
                };
                MDCTabScrollerRTLReverse.prototype.scrollToRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: currentScrollLeft - clampedScrollLeft
                    };
                };
                MDCTabScrollerRTLReverse.prototype.incrementScrollRTL = function(scrollX) {
                    var currentScrollLeft = this.adapter.getScrollAreaScrollLeft();
                    var clampedScrollLeft = this.clampScrollValue_(currentScrollLeft + scrollX);
                    return {
                        finalScrollPosition: clampedScrollLeft,
                        scrollDelta: currentScrollLeft - clampedScrollLeft
                    };
                };
                MDCTabScrollerRTLReverse.prototype.getAnimatingScrollPosition = function(scrollX, translateX) {
                    return scrollX + translateX;
                };
                MDCTabScrollerRTLReverse.prototype.calculateScrollEdges_ = function() {
                    var contentWidth = this.adapter.getScrollContentOffsetWidth();
                    var rootWidth = this.adapter.getScrollAreaOffsetWidth();
                    return {
                        left: contentWidth - rootWidth,
                        right: 0
                    };
                };
                MDCTabScrollerRTLReverse.prototype.clampScrollValue_ = function(scrollX) {
                    var edges = this.calculateScrollEdges_();
                    return Math.min(Math.max(edges.right, scrollX), edges.left);
                };
                return MDCTabScrollerRTLReverse;
            }(rtl_scroller_1.MDCTabScrollerRTL);
            exports.MDCTabScrollerRTLReverse = MDCTabScrollerRTLReverse;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTLReverse;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/rtl-scroller.ts": /*!***************************************************!*\
  !*** ./packages/mdc-tab-scroller/rtl-scroller.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabScrollerRTL = void 0;
            var MDCTabScrollerRTL = /** @class */ function() {
                function MDCTabScrollerRTL(adapter) {
                    this.adapter = adapter;
                }
                return MDCTabScrollerRTL;
            }();
            exports.MDCTabScrollerRTL = MDCTabScrollerRTL;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabScrollerRTL;
        /***/ },
        /***/ "./packages/mdc-tab-scroller/util.ts": /*!*******************************************!*\
  !*** ./packages/mdc-tab-scroller/util.ts ***!
  \*******************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.computeHorizontalScrollbarHeight = void 0;
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab-scroller/constants.ts");
            /**
 * Stores result from computeHorizontalScrollbarHeight to avoid redundant processing.
 */ var horizontalScrollbarHeight_;
            /**
 * Computes the height of browser-rendered horizontal scrollbars using a self-created test element.
 * May return 0 (e.g. on OS X browsers under default configuration).
 */ function computeHorizontalScrollbarHeight(documentObj, shouldCacheResult) {
                if (shouldCacheResult === void 0) shouldCacheResult = true;
                if (shouldCacheResult && typeof horizontalScrollbarHeight_ !== "undefined") return horizontalScrollbarHeight_;
                var el = documentObj.createElement("div");
                el.classList.add(constants_1.cssClasses.SCROLL_TEST);
                documentObj.body.appendChild(el);
                var horizontalScrollbarHeight = el.offsetHeight - el.clientHeight;
                documentObj.body.removeChild(el);
                if (shouldCacheResult) horizontalScrollbarHeight_ = horizontalScrollbarHeight;
                return horizontalScrollbarHeight;
            }
            exports.computeHorizontalScrollbarHeight = computeHorizontalScrollbarHeight;
        /***/ },
        /***/ "./packages/mdc-tab/component.ts": /*!***************************************!*\
  !*** ./packages/mdc-tab/component.ts ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTab = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var component_2 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var component_3 = __webpack_require__(/*! @material/tab-indicator/component */ "./packages/mdc-tab-indicator/component.ts");
            var foundation_2 = __webpack_require__(/*! ./foundation */ "./packages/mdc-tab/foundation.ts");
            var MDCTab = /** @class */ function(_super) {
                __extends(MDCTab, _super);
                function MDCTab() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTab.attachTo = function(root) {
                    return new MDCTab(root);
                };
                MDCTab.prototype.initialize = function(rippleFactory, tabIndicatorFactory) {
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_2.MDCRipple(el, foundation);
                    };
                    if (tabIndicatorFactory === void 0) tabIndicatorFactory = function tabIndicatorFactory(el) {
                        return new component_3.MDCTabIndicator(el);
                    };
                    this.id = this.root.id;
                    var rippleFoundation = new foundation_1.MDCRippleFoundation(component_2.MDCRipple.createAdapter(this));
                    this.ripple_ = rippleFactory(this.root, rippleFoundation);
                    var tabIndicatorElement = this.root.querySelector(foundation_2.MDCTabFoundation.strings.TAB_INDICATOR_SELECTOR);
                    this.tabIndicator_ = tabIndicatorFactory(tabIndicatorElement);
                    this.content_ = this.root.querySelector(foundation_2.MDCTabFoundation.strings.CONTENT_SELECTOR);
                };
                MDCTab.prototype.initialSyncWithDOM = function() {
                    var _this = this;
                    this.handleClick_ = function() {
                        return _this.foundation.handleClick();
                    };
                    this.listen("click", this.handleClick_);
                };
                MDCTab.prototype.destroy = function() {
                    this.unlisten("click", this.handleClick_);
                    this.ripple_.destroy();
                    _super.prototype.destroy.call(this);
                };
                MDCTab.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        activateIndicator: function activateIndicator(previousIndicatorClientRect) {
                            return _this.tabIndicator_.activate(previousIndicatorClientRect);
                        },
                        deactivateIndicator: function deactivateIndicator() {
                            return _this.tabIndicator_.deactivate();
                        },
                        notifyInteracted: function notifyInteracted() {
                            return _this.emit(foundation_2.MDCTabFoundation.strings.INTERACTED_EVENT, {
                                tabId: _this.id
                            }, true);
                        },
                        getOffsetLeft: function getOffsetLeft() {
                            return _this.root.offsetLeft;
                        },
                        getOffsetWidth: function getOffsetWidth() {
                            return _this.root.offsetWidth;
                        },
                        getContentOffsetLeft: function getContentOffsetLeft() {
                            return _this.content_.offsetLeft;
                        },
                        getContentOffsetWidth: function getContentOffsetWidth() {
                            return _this.content_.offsetWidth;
                        },
                        focus: function focus() {
                            return _this.root.focus();
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_2.MDCTabFoundation(adapter);
                };
                Object.defineProperty(MDCTab.prototype, "active", {
                    /**
         * Getter for the active state of the tab
         */ get: function get() {
                        return this.foundation.isActive();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTab.prototype, "focusOnActivate", {
                    set: function set(focusOnActivate) {
                        this.foundation.setFocusOnActivate(focusOnActivate);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Activates the tab
     */ MDCTab.prototype.activate = function(computeIndicatorClientRect) {
                    this.foundation.activate(computeIndicatorClientRect);
                };
                /**
     * Deactivates the tab
     */ MDCTab.prototype.deactivate = function() {
                    this.foundation.deactivate();
                };
                /**
     * Returns the indicator's client rect
     */ MDCTab.prototype.computeIndicatorClientRect = function() {
                    return this.tabIndicator_.computeContentClientRect();
                };
                MDCTab.prototype.computeDimensions = function() {
                    return this.foundation.computeDimensions();
                };
                /**
     * Focuses the tab
     */ MDCTab.prototype.focus = function() {
                    this.root.focus();
                };
                return MDCTab;
            }(component_1.MDCComponent);
            exports.MDCTab = MDCTab;
        /***/ },
        /***/ "./packages/mdc-tab/constants.ts": /*!***************************************!*\
  !*** ./packages/mdc-tab/constants.ts ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.cssClasses = void 0;
            var cssClasses = {
                ACTIVE: "mdc-tab--active"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_SELECTED: "aria-selected",
                CONTENT_SELECTOR: ".mdc-tab__content",
                INTERACTED_EVENT: "MDCTab:interacted",
                RIPPLE_SELECTOR: ".mdc-tab__ripple",
                TABINDEX: "tabIndex",
                TAB_INDICATOR_SELECTOR: ".mdc-tab-indicator"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-tab/custom-element.js": /*!********************************************!*\
  !*** ./packages/mdc-tab/custom-element.js ***!
  \********************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-tab/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var tabIdCounter = 0;
            var MdcTab = function(_HTMLElement) {
                _inherits(MdcTab, _HTMLElement);
                function MdcTab() {
                    _classCallCheck(this, MdcTab);
                    var _this = _possibleConstructorReturn(this, (MdcTab.__proto__ || Object.getPrototypeOf(MdcTab)).call(this));
                    _this.init_ = false;
                    _this.tab_;
                    _this.handleKeydown_ = _this.handleKeydown.bind(_this);
                    return _this;
                }
                _createClass(MdcTab, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            this.init();
                            this.tabIndex = 0;
                        }
                    },
                    {
                        key: "init",
                        value: function init() {
                            if (this.init_) return;
                            this.init_ = true;
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.id = this.id || "mdc-tab-" + ++tabIdCounter;
                            this.tab_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTab"](this);
                            this.addEventListener("keydown", this.handleKeydown_);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.removeEventListener("keydown", this.handleKeydown_);
                            this.tab_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    },
                    {
                        key: "handleKeydown",
                        value: function handleKeydown(event) {
                            if (event.key === "Space" || event.keyCode == 32) event.preventDefault();
                        }
                    }
                ]);
                return MdcTab;
            }(HTMLElement);
            customElements.define("mdc-tab", MdcTab);
        /***/ },
        /***/ "./packages/mdc-tab/foundation.ts": /*!****************************************!*\
  !*** ./packages/mdc-tab/foundation.ts ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTabFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-tab/constants.ts");
            var MDCTabFoundation = /** @class */ function(_super) {
                __extends(MDCTabFoundation, _super);
                function MDCTabFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTabFoundation.defaultAdapter), adapter)) || this;
                    _this.focusOnActivate_ = true;
                    return _this;
                }
                Object.defineProperty(MDCTabFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTabFoundation, "defaultAdapter", {
                    get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            activateIndicator: function activateIndicator() {
                                return undefined;
                            },
                            deactivateIndicator: function deactivateIndicator() {
                                return undefined;
                            },
                            notifyInteracted: function notifyInteracted() {
                                return undefined;
                            },
                            getOffsetLeft: function getOffsetLeft() {
                                return 0;
                            },
                            getOffsetWidth: function getOffsetWidth() {
                                return 0;
                            },
                            getContentOffsetLeft: function getContentOffsetLeft() {
                                return 0;
                            },
                            getContentOffsetWidth: function getContentOffsetWidth() {
                                return 0;
                            },
                            focus: function focus() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTabFoundation.prototype.handleClick = function() {
                    // It's up to the parent component to keep track of the active Tab and
                    // ensure we don't activate a Tab that's already active.
                    this.adapter.notifyInteracted();
                };
                MDCTabFoundation.prototype.isActive = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.ACTIVE);
                };
                /**
     * Sets whether the tab should focus itself when activated
     */ MDCTabFoundation.prototype.setFocusOnActivate = function(focusOnActivate) {
                    this.focusOnActivate_ = focusOnActivate;
                };
                /**
     * Activates the Tab
     */ MDCTabFoundation.prototype.activate = function(previousIndicatorClientRect) {
                    this.adapter.addClass(constants_1.cssClasses.ACTIVE);
                    this.adapter.setAttr(constants_1.strings.ARIA_SELECTED, "true");
                    this.adapter.setAttr(constants_1.strings.TABINDEX, "0");
                    this.adapter.activateIndicator(previousIndicatorClientRect);
                    if (this.focusOnActivate_) this.adapter.focus();
                };
                /**
     * Deactivates the Tab
     */ MDCTabFoundation.prototype.deactivate = function() {
                    // Early exit
                    if (!this.isActive()) return;
                    this.adapter.removeClass(constants_1.cssClasses.ACTIVE);
                    this.adapter.setAttr(constants_1.strings.ARIA_SELECTED, "false");
                    this.adapter.setAttr(constants_1.strings.TABINDEX, "-1");
                    this.adapter.deactivateIndicator();
                };
                /**
     * Returns the dimensions of the Tab
     */ MDCTabFoundation.prototype.computeDimensions = function() {
                    var rootWidth = this.adapter.getOffsetWidth();
                    var rootLeft = this.adapter.getOffsetLeft();
                    var contentWidth = this.adapter.getContentOffsetWidth();
                    var contentLeft = this.adapter.getContentOffsetLeft();
                    return {
                        contentLeft: rootLeft + contentLeft,
                        contentRight: rootLeft + contentLeft + contentWidth,
                        rootLeft: rootLeft,
                        rootRight: rootLeft + rootWidth
                    };
                };
                return MDCTabFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTabFoundation = MDCTabFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTabFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/character-counter/component.ts": /*!***************************************************************!*\
  !*** ./packages/mdc-textfield/character-counter/component.ts ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldCharacterCounter = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/character-counter/foundation.ts");
            var MDCTextFieldCharacterCounter = /** @class */ function(_super) {
                __extends(MDCTextFieldCharacterCounter, _super);
                function MDCTextFieldCharacterCounter() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextFieldCharacterCounter.attachTo = function(root) {
                    return new MDCTextFieldCharacterCounter(root);
                };
                Object.defineProperty(MDCTextFieldCharacterCounter.prototype, "foundationForTextField", {
                    // Provided for access by MDCTextField component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldCharacterCounter.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    var adapter = {
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        }
                    };
                    return new foundation_1.MDCTextFieldCharacterCounterFoundation(adapter);
                };
                return MDCTextFieldCharacterCounter;
            }(component_1.MDCComponent);
            exports.MDCTextFieldCharacterCounter = MDCTextFieldCharacterCounter;
        /***/ },
        /***/ "./packages/mdc-textfield/character-counter/constants.ts": /*!***************************************************************!*\
  !*** ./packages/mdc-textfield/character-counter/constants.ts ***!
  \***************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var cssClasses = {
                ROOT: "mdc-text-field-character-counter"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ROOT_SELECTOR: "." + cssClasses.ROOT
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-textfield/character-counter/foundation.ts": /*!****************************************************************!*\
  !*** ./packages/mdc-textfield/character-counter/foundation.ts ***!
  \****************************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldCharacterCounterFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/character-counter/constants.ts");
            var MDCTextFieldCharacterCounterFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldCharacterCounterFoundation, _super);
                function MDCTextFieldCharacterCounterFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTextFieldCharacterCounterFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTextFieldCharacterCounterFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldCharacterCounterFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldCharacterCounterFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldCharacterCounterAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        return {
                            setContent: function setContent() {
                                return undefined;
                            }
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldCharacterCounterFoundation.prototype.setCounterValue = function(currentLength, maxLength) {
                    currentLength = Math.min(currentLength, maxLength);
                    this.adapter.setContent(currentLength + " / " + maxLength);
                };
                return MDCTextFieldCharacterCounterFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldCharacterCounterFoundation = MDCTextFieldCharacterCounterFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldCharacterCounterFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/component.ts": /*!*********************************************!*\
  !*** ./packages/mdc-textfield/component.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                    enumerable: true,
                    get: function get() {
                        return m[k];
                    }
                });
            } : function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            });
            var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                Object.defineProperty(o, "default", {
                    enumerable: true,
                    value: v
                });
            } : function(o, v) {
                o["default"] = v;
            });
            var __importStar = this && this.__importStar || function(mod) {
                if (mod && mod.__esModule) return mod;
                var result = {};
                if (mod != null) {
                    for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                }
                __setModuleDefault(result, mod);
                return result;
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextField = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var events_1 = __webpack_require__(/*! @material/dom/events */ "./packages/mdc-dom/events.ts");
            var ponyfill = __importStar(__webpack_require__(/*! @material/dom/ponyfill */ "./packages/mdc-dom/ponyfill.ts"));
            var component_2 = __webpack_require__(/*! @material/floating-label/component */ "./packages/mdc-floating-label/component.ts");
            var component_3 = __webpack_require__(/*! @material/line-ripple/component */ "./packages/mdc-line-ripple/component.ts");
            var component_4 = __webpack_require__(/*! @material/notched-outline/component */ "./packages/mdc-notched-outline/component.ts");
            var component_5 = __webpack_require__(/*! @material/ripple/component */ "./packages/mdc-ripple/component.ts");
            var foundation_1 = __webpack_require__(/*! @material/ripple/foundation */ "./packages/mdc-ripple/foundation.ts");
            var component_6 = __webpack_require__(/*! ./character-counter/component */ "./packages/mdc-textfield/character-counter/component.ts");
            var foundation_2 = __webpack_require__(/*! ./character-counter/foundation */ "./packages/mdc-textfield/character-counter/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/constants.ts");
            var foundation_3 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/foundation.ts");
            var component_7 = __webpack_require__(/*! ./helper-text/component */ "./packages/mdc-textfield/helper-text/component.ts");
            var foundation_4 = __webpack_require__(/*! ./helper-text/foundation */ "./packages/mdc-textfield/helper-text/foundation.ts");
            var component_8 = __webpack_require__(/*! ./icon/component */ "./packages/mdc-textfield/icon/component.ts");
            var MDCTextField = /** @class */ function(_super) {
                __extends(MDCTextField, _super);
                function MDCTextField() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextField.attachTo = function(root) {
                    return new MDCTextField(root);
                };
                MDCTextField.prototype.initialize = function(rippleFactory, lineRippleFactory, helperTextFactory, characterCounterFactory, iconFactory, labelFactory, outlineFactory) {
                    if (rippleFactory === void 0) rippleFactory = function rippleFactory(el, foundation) {
                        return new component_5.MDCRipple(el, foundation);
                    };
                    if (lineRippleFactory === void 0) lineRippleFactory = function lineRippleFactory(el) {
                        return new component_3.MDCLineRipple(el);
                    };
                    if (helperTextFactory === void 0) helperTextFactory = function helperTextFactory(el) {
                        return new component_7.MDCTextFieldHelperText(el);
                    };
                    if (characterCounterFactory === void 0) characterCounterFactory = function characterCounterFactory(el) {
                        return new component_6.MDCTextFieldCharacterCounter(el);
                    };
                    if (iconFactory === void 0) iconFactory = function iconFactory(el) {
                        return new component_8.MDCTextFieldIcon(el);
                    };
                    if (labelFactory === void 0) labelFactory = function labelFactory(el) {
                        return new component_2.MDCFloatingLabel(el);
                    };
                    if (outlineFactory === void 0) outlineFactory = function outlineFactory(el) {
                        return new component_4.MDCNotchedOutline(el);
                    };
                    this.input_ = this.root.querySelector(constants_1.strings.INPUT_SELECTOR);
                    var labelElement = this.root.querySelector(constants_1.strings.LABEL_SELECTOR);
                    this.label_ = labelElement ? labelFactory(labelElement) : null;
                    var lineRippleElement = this.root.querySelector(constants_1.strings.LINE_RIPPLE_SELECTOR);
                    this.lineRipple_ = lineRippleElement ? lineRippleFactory(lineRippleElement) : null;
                    var outlineElement = this.root.querySelector(constants_1.strings.OUTLINE_SELECTOR);
                    this.outline_ = outlineElement ? outlineFactory(outlineElement) : null;
                    // Helper text
                    var helperTextStrings = foundation_4.MDCTextFieldHelperTextFoundation.strings;
                    var nextElementSibling = this.root.nextElementSibling;
                    var hasHelperLine = nextElementSibling && nextElementSibling.classList.contains(constants_1.cssClasses.HELPER_LINE);
                    var helperTextEl = hasHelperLine && nextElementSibling && nextElementSibling.querySelector(helperTextStrings.ROOT_SELECTOR);
                    this.helperText_ = helperTextEl ? helperTextFactory(helperTextEl) : null;
                    // Character counter
                    var characterCounterStrings = foundation_2.MDCTextFieldCharacterCounterFoundation.strings;
                    var characterCounterEl = this.root.querySelector(characterCounterStrings.ROOT_SELECTOR);
                    // If character counter is not found in root element search in sibling element.
                    if (!characterCounterEl && hasHelperLine && nextElementSibling) characterCounterEl = nextElementSibling.querySelector(characterCounterStrings.ROOT_SELECTOR);
                    this.characterCounter_ = characterCounterEl ? characterCounterFactory(characterCounterEl) : null;
                    // Leading icon
                    var leadingIconEl = this.root.querySelector(constants_1.strings.LEADING_ICON_SELECTOR);
                    this.leadingIcon_ = leadingIconEl ? iconFactory(leadingIconEl) : null;
                    // Trailing icon
                    var trailingIconEl = this.root.querySelector(constants_1.strings.TRAILING_ICON_SELECTOR);
                    this.trailingIcon_ = trailingIconEl ? iconFactory(trailingIconEl) : null;
                    // Prefix and Suffix
                    this.prefix_ = this.root.querySelector(constants_1.strings.PREFIX_SELECTOR);
                    this.suffix_ = this.root.querySelector(constants_1.strings.SUFFIX_SELECTOR);
                    this.ripple = this.createRipple_(rippleFactory);
                };
                MDCTextField.prototype.destroy = function() {
                    if (this.ripple) this.ripple.destroy();
                    if (this.lineRipple_) this.lineRipple_.destroy();
                    if (this.helperText_) this.helperText_.destroy();
                    if (this.characterCounter_) this.characterCounter_.destroy();
                    if (this.leadingIcon_) this.leadingIcon_.destroy();
                    if (this.trailingIcon_) this.trailingIcon_.destroy();
                    if (this.label_) this.label_.destroy();
                    if (this.outline_) this.outline_.destroy();
                    _super.prototype.destroy.call(this);
                };
                /**
     * Initializes the Text Field's internal state based on the environment's
     * state.
     */ MDCTextField.prototype.initialSyncWithDOM = function() {
                    this.disabled = this.input_.disabled;
                };
                Object.defineProperty(MDCTextField.prototype, "value", {
                    get: function get() {
                        return this.foundation.getValue();
                    },
                    /**
         * @param value The value to set on the input.
         */ set: function set(value) {
                        this.foundation.setValue(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "disabled", {
                    get: function get() {
                        return this.foundation.isDisabled();
                    },
                    /**
         * @param disabled Sets the Text Field disabled or enabled.
         */ set: function set(disabled) {
                        this.foundation.setDisabled(disabled);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "valid", {
                    get: function get() {
                        return this.foundation.isValid();
                    },
                    /**
         * @param valid Sets the Text Field valid or invalid.
         */ set: function set(valid) {
                        this.foundation.setValid(valid);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "required", {
                    get: function get() {
                        return this.input_.required;
                    },
                    /**
         * @param required Sets the Text Field to required.
         */ set: function set(required) {
                        this.input_.required = required;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "pattern", {
                    get: function get() {
                        return this.input_.pattern;
                    },
                    /**
         * @param pattern Sets the input element's validation pattern.
         */ set: function set(pattern) {
                        if (pattern === null) delete this.input_.pattern;
                        else this.input_.pattern = pattern;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "minLength", {
                    get: function get() {
                        return this.input_.minLength;
                    },
                    /**
         * @param minLength Sets the input element's minLength.
         */ set: function set(minLength) {
                        if (minLength < 0) this.input_.removeAttribute("minLength");
                        else this.input_.minLength = minLength;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "maxLength", {
                    get: function get() {
                        return this.input_.maxLength;
                    },
                    /**
         * @param maxLength Sets the input element's maxLength.
         */ set: function set(maxLength) {
                        if (maxLength < 0) this.input_.removeAttribute("maxLength");
                        else this.input_.maxLength = maxLength;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "min", {
                    get: function get() {
                        return this.input_.min;
                    },
                    /**
         * @param min Sets the input element's min.
         */ set: function set(min) {
                        this.input_.min = min;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "max", {
                    get: function get() {
                        return this.input_.max;
                    },
                    /**
         * @param max Sets the input element's max.
         */ set: function set(max) {
                        this.input_.max = max;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "step", {
                    get: function get() {
                        return this.input_.step;
                    },
                    /**
         * @param step Sets the input element's step.
         */ set: function set(step) {
                        this.input_.step = step;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "helperTextContent", {
                    /**
         * Sets the helper text element content.
         */ set: function set(content) {
                        this.foundation.setHelperTextContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "leadingIconAriaLabel", {
                    /**
         * Sets the aria label of the leading icon.
         */ set: function set(label) {
                        this.foundation.setLeadingIconAriaLabel(label);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "leadingIconContent", {
                    /**
         * Sets the text content of the leading icon.
         */ set: function set(content) {
                        this.foundation.setLeadingIconContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "trailingIconAriaLabel", {
                    /**
         * Sets the aria label of the trailing icon.
         */ set: function set(label) {
                        this.foundation.setTrailingIconAriaLabel(label);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "trailingIconContent", {
                    /**
         * Sets the text content of the trailing icon.
         */ set: function set(content) {
                        this.foundation.setTrailingIconContent(content);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "useNativeValidation", {
                    /**
         * Enables or disables the use of native validation. Use this for custom validation.
         * @param useNativeValidation Set this to false to ignore native input validation.
         */ set: function set(useNativeValidation) {
                        this.foundation.setUseNativeValidation(useNativeValidation);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "prefixText", {
                    /**
         * Gets the text content of the prefix, or null if it does not exist.
         */ get: function get() {
                        return this.prefix_ ? this.prefix_.textContent : null;
                    },
                    /**
         * Sets the text content of the prefix, if it exists.
         */ set: function set(prefixText) {
                        if (this.prefix_) this.prefix_.textContent = prefixText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextField.prototype, "suffixText", {
                    /**
         * Gets the text content of the suffix, or null if it does not exist.
         */ get: function get() {
                        return this.suffix_ ? this.suffix_.textContent : null;
                    },
                    /**
         * Sets the text content of the suffix, if it exists.
         */ set: function set(suffixText) {
                        if (this.suffix_) this.suffix_.textContent = suffixText;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Focuses the input element.
     */ MDCTextField.prototype.focus = function() {
                    this.input_.focus();
                };
                /**
     * Recomputes the outline SVG path for the outline element.
     */ MDCTextField.prototype.layout = function() {
                    var openNotch = this.foundation.shouldFloat;
                    this.foundation.notchOutline(openNotch);
                };
                MDCTextField.prototype.getDefaultFoundation = function() {
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign(__assign(__assign(__assign({}, this.getRootAdapterMethods_()), this.getInputAdapterMethods_()), this.getLabelAdapterMethods_()), this.getLineRippleAdapterMethods_()), this.getOutlineAdapterMethods_());
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_3.MDCTextFieldFoundation(adapter, this.getFoundationMap_());
                };
                MDCTextField.prototype.getRootAdapterMethods_ = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler(evtType, handler) {
                            _this.listen(evtType, handler);
                        },
                        deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler(evtType, handler) {
                            _this.unlisten(evtType, handler);
                        },
                        registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler(handler) {
                            var getAttributesList = function getAttributesList(mutationsList) {
                                return mutationsList.map(function(mutation) {
                                    return mutation.attributeName;
                                }).filter(function(attributeName) {
                                    return attributeName;
                                });
                            };
                            var observer = new MutationObserver(function(mutationsList) {
                                return handler(getAttributesList(mutationsList));
                            });
                            var config = {
                                attributes: true
                            };
                            observer.observe(_this.input_, config);
                            return observer;
                        },
                        deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler(observer) {
                            observer.disconnect();
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCTextField.prototype.getInputAdapterMethods_ = function() {
                    var _this = this;
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    return {
                        getNativeInput: function getNativeInput() {
                            return _this.input_;
                        },
                        setInputAttr: function setInputAttr(attr, value) {
                            _this.input_.setAttribute(attr, value);
                        },
                        removeInputAttr: function removeInputAttr(attr) {
                            _this.input_.removeAttribute(attr);
                        },
                        isFocused: function isFocused() {
                            return document.activeElement === _this.input_;
                        },
                        registerInputInteractionHandler: function registerInputInteractionHandler(evtType, handler) {
                            _this.input_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInputInteractionHandler: function deregisterInputInteractionHandler(evtType, handler) {
                            _this.input_.removeEventListener(evtType, handler, events_1.applyPassive());
                        }
                    };
                // tslint:enable:object-literal-sort-keys
                };
                MDCTextField.prototype.getLabelAdapterMethods_ = function() {
                    var _this = this;
                    return {
                        floatLabel: function floatLabel(shouldFloat) {
                            return _this.label_ && _this.label_.float(shouldFloat);
                        },
                        getLabelWidth: function getLabelWidth() {
                            return _this.label_ ? _this.label_.getWidth() : 0;
                        },
                        hasLabel: function hasLabel() {
                            return Boolean(_this.label_);
                        },
                        shakeLabel: function shakeLabel(shouldShake) {
                            return _this.label_ && _this.label_.shake(shouldShake);
                        },
                        setLabelRequired: function setLabelRequired(isRequired) {
                            return _this.label_ && _this.label_.setRequired(isRequired);
                        }
                    };
                };
                MDCTextField.prototype.getLineRippleAdapterMethods_ = function() {
                    var _this = this;
                    return {
                        activateLineRipple: function activateLineRipple() {
                            if (_this.lineRipple_) _this.lineRipple_.activate();
                        },
                        deactivateLineRipple: function deactivateLineRipple() {
                            if (_this.lineRipple_) _this.lineRipple_.deactivate();
                        },
                        setLineRippleTransformOrigin: function setLineRippleTransformOrigin(normalizedX) {
                            if (_this.lineRipple_) _this.lineRipple_.setRippleCenter(normalizedX);
                        }
                    };
                };
                MDCTextField.prototype.getOutlineAdapterMethods_ = function() {
                    var _this = this;
                    return {
                        closeOutline: function closeOutline() {
                            return _this.outline_ && _this.outline_.closeNotch();
                        },
                        hasOutline: function hasOutline() {
                            return Boolean(_this.outline_);
                        },
                        notchOutline: function notchOutline(labelWidth) {
                            return _this.outline_ && _this.outline_.notch(labelWidth);
                        }
                    };
                };
                /**
     * @return A map of all subcomponents to subfoundations.
     */ MDCTextField.prototype.getFoundationMap_ = function() {
                    return {
                        characterCounter: this.characterCounter_ ? this.characterCounter_.foundationForTextField : undefined,
                        helperText: this.helperText_ ? this.helperText_.foundationForTextField : undefined,
                        leadingIcon: this.leadingIcon_ ? this.leadingIcon_.foundationForTextField : undefined,
                        trailingIcon: this.trailingIcon_ ? this.trailingIcon_.foundationForTextField : undefined
                    };
                };
                MDCTextField.prototype.createRipple_ = function(rippleFactory) {
                    var _this = this;
                    var isTextArea = this.root.classList.contains(constants_1.cssClasses.TEXTAREA);
                    var isOutlined = this.root.classList.contains(constants_1.cssClasses.OUTLINED);
                    if (isTextArea || isOutlined) return null;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = __assign(__assign({}, component_5.MDCRipple.createAdapter(this)), {
                        isSurfaceActive: function isSurfaceActive() {
                            return ponyfill.matches(_this.input_, ":active");
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.input_.addEventListener(evtType, handler, events_1.applyPassive());
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.input_.removeEventListener(evtType, handler, events_1.applyPassive());
                        }
                    });
                    // tslint:enable:object-literal-sort-keys
                    return rippleFactory(this.root, new foundation_1.MDCRippleFoundation(adapter));
                };
                return MDCTextField;
            }(component_1.MDCComponent);
            exports.MDCTextField = MDCTextField;
        /***/ },
        /***/ "./packages/mdc-textfield/constants.ts": /*!*********************************************!*\
  !*** ./packages/mdc-textfield/constants.ts ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ALWAYS_FLOAT_TYPES = exports.VALIDATION_ATTR_WHITELIST = exports.numbers = exports.strings = exports.cssClasses = void 0;
            var strings = {
                ARIA_CONTROLS: "aria-controls",
                ARIA_DESCRIBEDBY: "aria-describedby",
                INPUT_SELECTOR: ".mdc-text-field__input",
                LABEL_SELECTOR: ".mdc-floating-label",
                LEADING_ICON_SELECTOR: ".mdc-text-field__icon--leading",
                LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
                OUTLINE_SELECTOR: ".mdc-notched-outline",
                PREFIX_SELECTOR: ".mdc-text-field__affix--prefix",
                SUFFIX_SELECTOR: ".mdc-text-field__affix--suffix",
                TRAILING_ICON_SELECTOR: ".mdc-text-field__icon--trailing"
            };
            exports.strings = strings;
            var cssClasses = {
                DISABLED: "mdc-text-field--disabled",
                FOCUSED: "mdc-text-field--focused",
                HELPER_LINE: "mdc-text-field-helper-line",
                INVALID: "mdc-text-field--invalid",
                LABEL_FLOATING: "mdc-text-field--label-floating",
                NO_LABEL: "mdc-text-field--no-label",
                OUTLINED: "mdc-text-field--outlined",
                ROOT: "mdc-text-field",
                TEXTAREA: "mdc-text-field--textarea",
                WITH_LEADING_ICON: "mdc-text-field--with-leading-icon",
                WITH_TRAILING_ICON: "mdc-text-field--with-trailing-icon"
            };
            exports.cssClasses = cssClasses;
            var numbers = {
                LABEL_SCALE: 0.75
            };
            exports.numbers = numbers;
            /**
 * Whitelist based off of https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation
 * under the "Validation-related attributes" section.
 */ var VALIDATION_ATTR_WHITELIST = [
                "pattern",
                "min",
                "max",
                "required",
                "step",
                "minlength",
                "maxlength"
            ];
            exports.VALIDATION_ATTR_WHITELIST = VALIDATION_ATTR_WHITELIST;
            /**
 * Label should always float for these types as they show some UI even if value is empty.
 */ var ALWAYS_FLOAT_TYPES = [
                "color",
                "date",
                "datetime-local",
                "month",
                "range",
                "time",
                "week"
            ];
            exports.ALWAYS_FLOAT_TYPES = ALWAYS_FLOAT_TYPES;
        /***/ },
        /***/ "./packages/mdc-textfield/custom-element.js": /*!**************************************************!*\
  !*** ./packages/mdc-textfield/custom-element.js ***!
  \**************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-textfield/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcTextField = function(_HTMLElement) {
                _inherits(MdcTextField, _HTMLElement);
                _createClass(MdcTextField, [
                    {
                        key: "focus",
                        value: function focus() {
                            if (this.textField_ && this.textField_.input_) this.textField_.input_.focus();
                        }
                    },
                    {
                        key: "value",
                        get: function get() {
                            if (!!this.textField_) return this.textField_.value;
                            else return this.value_;
                        },
                        set: function set(value) {
                            this.value_ = value;
                            if (!!this.textField_) this.textField_.value = value;
                        }
                    },
                    {
                        key: "disabled",
                        get: function get() {
                            return this.disabled_;
                        },
                        set: function set(disabled) {
                            this.disabled_ = disabled;
                            if (!!this.textField_) this.textField_.disabled = disabled;
                        }
                    },
                    {
                        key: "valid",
                        get: function get() {
                            return this.valid_;
                        },
                        set: function set(valid) {
                            this.valid_ = valid;
                            if (!!this.textField_) this.textField_.valid = valid;
                        }
                    },
                    {
                        key: "required",
                        get: function get() {
                            return this.required_;
                        },
                        set: function set(required) {
                            this.required_ = required;
                            if (!!this.textField_) this.required_ = required;
                        }
                    },
                    {
                        key: "pattern",
                        get: function get() {
                            return this.pattern_;
                        },
                        set: function set(pattern) {
                            this.pattern_ = pattern;
                            if (!!this.textField_) this.textField_.pattern = pattern;
                        }
                    },
                    {
                        key: "minLength",
                        get: function get() {
                            return this.minLength_;
                        },
                        set: function set(minLength) {
                            this.minLength_ = minLength;
                            if (!!this.textField) this.textField_.minLength = minLength;
                        }
                    },
                    {
                        key: "maxLength",
                        get: function get() {
                            return this.maxLength_;
                        },
                        set: function set(maxLength) {
                            this.maxLength_ = maxLength;
                            if (!!this.textField_) this.textField_.maxLength = maxLength;
                        }
                    },
                    {
                        key: "min",
                        get: function get() {
                            return this.min_;
                        },
                        set: function set(min) {
                            this.min_ = min;
                            if (!!this.textField_) this.textField_.min = min;
                        }
                    },
                    {
                        key: "max",
                        get: function get() {
                            return this.max_;
                        },
                        set: function set(max) {
                            this.max_ = max;
                            if (!!this.textField_) this.textField_.max = max;
                        }
                    },
                    {
                        key: "step",
                        get: function get() {
                            return this.step_;
                        },
                        set: function set(step) {
                            this.step_ = step;
                            if (!!this.textField_) this.textField_.step = step;
                        }
                    }
                ]);
                function MdcTextField() {
                    _classCallCheck(this, MdcTextField);
                    var _this = _possibleConstructorReturn(this, (MdcTextField.__proto__ || Object.getPrototypeOf(MdcTextField)).call(this));
                    _this.value_ = "";
                    _this.disabled_ = false;
                    _this.valid_ = true;
                    _this.required_ = false;
                    _this.pattern_ = null;
                    _this.minLength_ = -1;
                    _this.maxLength_ = -1;
                    _this.min_ = "";
                    _this.max_ = "";
                    _this.step_ = "";
                    _this.textField_;
                    return _this;
                }
                _createClass(MdcTextField, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.textField_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTextField"](this);
                            this.textField_.useNativeValidation = false;
                            this.textField_.value = this.value_;
                            this.textField_.disabled = this.disabled_;
                            this.textField_.valid = this.valid_;
                            this.textField_.required = this.required_;
                            this.textField_.pattern = this.pattern_;
                            this.textField_.minLength = this.minLength_;
                            this.textField_.maxLength = this.maxLength_;
                            this.textField_.min = this.min_;
                            this.textField_.max = this.max_;
                            this.textField_.step = this.step_;
                            var floatingLabel = this.querySelector(".mdc-floating-label");
                            if (!!floatingLabel) _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(floatingLabel);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            var floatingLabel = this.querySelector(".mdc-floating-label");
                            if (!!floatingLabel) _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(floatingLabel);
                            this.textField_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcTextField;
            }(HTMLElement);
            customElements.define("mdc-text-field", MdcTextField);
        /***/ },
        /***/ "./packages/mdc-textfield/foundation.ts": /*!**********************************************!*\
  !*** ./packages/mdc-textfield/foundation.ts ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/constants.ts");
            var POINTERDOWN_EVENTS = [
                "mousedown",
                "touchstart"
            ];
            var INTERACTION_EVENTS = [
                "click",
                "keydown"
            ];
            var MDCTextFieldFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldFoundation, _super);
                /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCTextFieldFoundation(adapter, foundationMap) {
                    if (foundationMap === void 0) foundationMap = {};
                    var _this = _super.call(this, __assign(__assign({}, MDCTextFieldFoundation.defaultAdapter), adapter)) || this;
                    _this.isFocused_ = false;
                    _this.receivedUserInput_ = false;
                    _this.isValid_ = true;
                    _this.useNativeValidation_ = true;
                    _this.validateOnValueChange_ = false;
                    _this.helperText_ = foundationMap.helperText;
                    _this.characterCounter_ = foundationMap.characterCounter;
                    _this.leadingIcon_ = foundationMap.leadingIcon;
                    _this.trailingIcon_ = foundationMap.trailingIcon;
                    _this.inputFocusHandler_ = function() {
                        return _this.activateFocus();
                    };
                    _this.inputBlurHandler_ = function() {
                        return _this.deactivateFocus();
                    };
                    _this.inputInputHandler_ = function() {
                        return _this.handleInput();
                    };
                    _this.setPointerXOffset_ = function(evt) {
                        return _this.setTransformOrigin(evt);
                    };
                    _this.textFieldInteractionHandler_ = function() {
                        return _this.handleTextFieldInteraction();
                    };
                    _this.validationAttributeChangeHandler_ = function() {};
                    return _this;
                }
                Object.defineProperty(MDCTextFieldFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldAlwaysFloat_", {
                    get: function get() {
                        var type = this.getNativeInput_().type;
                        return constants_1.ALWAYS_FLOAT_TYPES.indexOf(type) >= 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldFloat", {
                    get: function get() {
                        return this.shouldAlwaysFloat_ || this.isFocused_ || !!this.getValue() || this.isBadInput_();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldShake", {
                    get: function get() {
                        return !this.isFocused_ && !this.isValid() && !!this.getValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldAdapter} for typing information on parameters and
         * return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return true;
                            },
                            setInputAttr: function setInputAttr() {
                                return undefined;
                            },
                            removeInputAttr: function removeInputAttr() {
                                return undefined;
                            },
                            registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler() {
                                return undefined;
                            },
                            deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler() {
                                return undefined;
                            },
                            registerInputInteractionHandler: function registerInputInteractionHandler() {
                                return undefined;
                            },
                            deregisterInputInteractionHandler: function deregisterInputInteractionHandler() {
                                return undefined;
                            },
                            registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler() {
                                return new MutationObserver(function() {
                                    return undefined;
                                });
                            },
                            deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler() {
                                return undefined;
                            },
                            getNativeInput: function getNativeInput() {
                                return null;
                            },
                            isFocused: function isFocused() {
                                return false;
                            },
                            activateLineRipple: function activateLineRipple() {
                                return undefined;
                            },
                            deactivateLineRipple: function deactivateLineRipple() {
                                return undefined;
                            },
                            setLineRippleTransformOrigin: function setLineRippleTransformOrigin() {
                                return undefined;
                            },
                            shakeLabel: function shakeLabel() {
                                return undefined;
                            },
                            floatLabel: function floatLabel() {
                                return undefined;
                            },
                            setLabelRequired: function setLabelRequired() {
                                return undefined;
                            },
                            hasLabel: function hasLabel() {
                                return false;
                            },
                            getLabelWidth: function getLabelWidth() {
                                return 0;
                            },
                            hasOutline: function hasOutline() {
                                return false;
                            },
                            notchOutline: function notchOutline() {
                                return undefined;
                            },
                            closeOutline: function closeOutline() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldFoundation.prototype.init = function() {
                    var _this = this;
                    if (this.adapter.hasLabel() && this.getNativeInput_().required) this.adapter.setLabelRequired(true);
                    if (this.adapter.isFocused()) this.inputFocusHandler_();
                    else if (this.adapter.hasLabel() && this.shouldFloat) {
                        this.notchOutline(true);
                        this.adapter.floatLabel(true);
                        this.styleFloating_(true);
                    }
                    this.adapter.registerInputInteractionHandler("focus", this.inputFocusHandler_);
                    this.adapter.registerInputInteractionHandler("blur", this.inputBlurHandler_);
                    this.adapter.registerInputInteractionHandler("input", this.inputInputHandler_);
                    POINTERDOWN_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerInputInteractionHandler(evtType, _this.setPointerXOffset_);
                    });
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerTextFieldInteractionHandler(evtType, _this.textFieldInteractionHandler_);
                    });
                    this.validationObserver_ = this.adapter.registerValidationAttributeChangeHandler(this.validationAttributeChangeHandler_);
                    this.setCharacterCounter_(this.getValue().length);
                };
                MDCTextFieldFoundation.prototype.destroy = function() {
                    var _this = this;
                    this.adapter.deregisterInputInteractionHandler("focus", this.inputFocusHandler_);
                    this.adapter.deregisterInputInteractionHandler("blur", this.inputBlurHandler_);
                    this.adapter.deregisterInputInteractionHandler("input", this.inputInputHandler_);
                    POINTERDOWN_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterInputInteractionHandler(evtType, _this.setPointerXOffset_);
                    });
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterTextFieldInteractionHandler(evtType, _this.textFieldInteractionHandler_);
                    });
                    this.adapter.deregisterValidationAttributeChangeHandler(this.validationObserver_);
                };
                /**
     * Handles user interactions with the Text Field.
     */ MDCTextFieldFoundation.prototype.handleTextFieldInteraction = function() {
                    var nativeInput = this.adapter.getNativeInput();
                    if (nativeInput && nativeInput.disabled) return;
                    this.receivedUserInput_ = true;
                };
                /**
     * Handles validation attribute changes
     */ MDCTextFieldFoundation.prototype.handleValidationAttributeChange = function(attributesList) {
                    var _this = this;
                    attributesList.some(function(attributeName) {
                        if (constants_1.VALIDATION_ATTR_WHITELIST.indexOf(attributeName) > -1) {
                            _this.styleValidity_(true);
                            _this.adapter.setLabelRequired(_this.getNativeInput_().required);
                            return true;
                        }
                        return false;
                    });
                    if (attributesList.indexOf("maxlength") > -1) this.setCharacterCounter_(this.getValue().length);
                };
                /**
     * Opens/closes the notched outline.
     */ MDCTextFieldFoundation.prototype.notchOutline = function(openNotch) {
                    if (!this.adapter.hasOutline() || !this.adapter.hasLabel()) return;
                    if (openNotch) {
                        var labelWidth = this.adapter.getLabelWidth() * constants_1.numbers.LABEL_SCALE;
                        this.adapter.notchOutline(labelWidth);
                    } else this.adapter.closeOutline();
                };
                /**
     * Activates the text field focus state.
     */ MDCTextFieldFoundation.prototype.activateFocus = function() {
                    this.isFocused_ = true;
                    this.styleFocused_(this.isFocused_);
                    this.adapter.activateLineRipple();
                    if (this.adapter.hasLabel()) {
                        this.notchOutline(this.shouldFloat);
                        this.adapter.floatLabel(this.shouldFloat);
                        this.styleFloating_(this.shouldFloat);
                        this.adapter.shakeLabel(this.shouldShake);
                    }
                    if (this.helperText_ && (this.helperText_.isPersistent() || !this.helperText_.isValidation() || !this.isValid_)) this.helperText_.showToScreenReader();
                };
                /**
     * Sets the line ripple's transform origin, so that the line ripple activate
     * animation will animate out from the user's click location.
     */ MDCTextFieldFoundation.prototype.setTransformOrigin = function(evt) {
                    if (this.isDisabled() || this.adapter.hasOutline()) return;
                    var touches = evt.touches;
                    var targetEvent = touches ? touches[0] : evt;
                    var targetClientRect = targetEvent.target.getBoundingClientRect();
                    var normalizedX = targetEvent.clientX - targetClientRect.left;
                    this.adapter.setLineRippleTransformOrigin(normalizedX);
                };
                /**
     * Handles input change of text input and text area.
     */ MDCTextFieldFoundation.prototype.handleInput = function() {
                    this.autoCompleteFocus();
                    this.setCharacterCounter_(this.getValue().length);
                };
                /**
     * Activates the Text Field's focus state in cases when the input value
     * changes without user input (e.g. programmatically).
     */ MDCTextFieldFoundation.prototype.autoCompleteFocus = function() {
                    if (!this.receivedUserInput_) this.activateFocus();
                };
                /**
     * Deactivates the Text Field's focus state.
     */ MDCTextFieldFoundation.prototype.deactivateFocus = function() {
                    this.isFocused_ = false;
                    this.adapter.deactivateLineRipple();
                    var isValid = this.isValid();
                    this.styleValidity_(isValid);
                    this.styleFocused_(this.isFocused_);
                    if (this.adapter.hasLabel()) {
                        this.notchOutline(this.shouldFloat);
                        this.adapter.floatLabel(this.shouldFloat);
                        this.styleFloating_(this.shouldFloat);
                        this.adapter.shakeLabel(this.shouldShake);
                    }
                    if (!this.shouldFloat) this.receivedUserInput_ = false;
                };
                MDCTextFieldFoundation.prototype.getValue = function() {
                    return this.getNativeInput_().value;
                };
                /**
     * @param value The value to set on the input Element.
     */ MDCTextFieldFoundation.prototype.setValue = function(value) {
                    // Prevent Safari from moving the caret to the end of the input when the
                    // value has not changed.
                    if (this.getValue() !== value) this.getNativeInput_().value = value;
                    this.setCharacterCounter_(value.length);
                    if (this.validateOnValueChange_) {
                        var isValid = this.isValid();
                        this.styleValidity_(isValid);
                    }
                    if (this.adapter.hasLabel()) {
                        this.notchOutline(this.shouldFloat);
                        this.adapter.floatLabel(this.shouldFloat);
                        this.styleFloating_(this.shouldFloat);
                        if (this.validateOnValueChange_) this.adapter.shakeLabel(this.shouldShake);
                    }
                };
                /**
     * @return The custom validity state, if set; otherwise, the result of a
     *     native validity check.
     */ MDCTextFieldFoundation.prototype.isValid = function() {
                    return this.useNativeValidation_ ? this.isNativeInputValid_() : this.isValid_;
                };
                /**
     * @param isValid Sets the custom validity state of the Text Field.
     */ MDCTextFieldFoundation.prototype.setValid = function(isValid) {
                    this.isValid_ = isValid;
                    this.styleValidity_(isValid);
                    var shouldShake = !isValid && !this.isFocused_ && !!this.getValue();
                    if (this.adapter.hasLabel()) this.adapter.shakeLabel(shouldShake);
                };
                /**
     * @param shouldValidate Whether or not validity should be updated on
     *     value change.
     */ MDCTextFieldFoundation.prototype.setValidateOnValueChange = function(shouldValidate) {
                    this.validateOnValueChange_ = shouldValidate;
                };
                /**
     * @return Whether or not validity should be updated on value change. `true`
     *     by default.
     */ MDCTextFieldFoundation.prototype.getValidateOnValueChange = function() {
                    return this.validateOnValueChange_;
                };
                /**
     * Enables or disables the use of native validation. Use this for custom
     * validation.
     * @param useNativeValidation Set this to false to ignore native input
     *     validation.
     */ MDCTextFieldFoundation.prototype.setUseNativeValidation = function(useNativeValidation) {
                    this.useNativeValidation_ = useNativeValidation;
                };
                MDCTextFieldFoundation.prototype.isDisabled = function() {
                    return this.getNativeInput_().disabled;
                };
                /**
     * @param disabled Sets the text-field disabled or enabled.
     */ MDCTextFieldFoundation.prototype.setDisabled = function(disabled) {
                    this.getNativeInput_().disabled = disabled;
                    this.styleDisabled_(disabled);
                };
                /**
     * @param content Sets the content of the helper text.
     */ MDCTextFieldFoundation.prototype.setHelperTextContent = function(content) {
                    if (this.helperText_) this.helperText_.setContent(content);
                };
                /**
     * Sets the aria label of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconAriaLabel = function(label) {
                    if (this.leadingIcon_) this.leadingIcon_.setAriaLabel(label);
                };
                /**
     * Sets the text content of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconContent = function(content) {
                    if (this.leadingIcon_) this.leadingIcon_.setContent(content);
                };
                /**
     * Sets the aria label of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconAriaLabel = function(label) {
                    if (this.trailingIcon_) this.trailingIcon_.setAriaLabel(label);
                };
                /**
     * Sets the text content of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconContent = function(content) {
                    if (this.trailingIcon_) this.trailingIcon_.setContent(content);
                };
                /**
     * Sets character counter values that shows characters used and the total
     * character limit.
     */ MDCTextFieldFoundation.prototype.setCharacterCounter_ = function(currentLength) {
                    if (!this.characterCounter_) return;
                    var maxLength = this.getNativeInput_().maxLength;
                    if (maxLength === -1) throw new Error("MDCTextFieldFoundation: Expected maxlength html property on text input or textarea.");
                    this.characterCounter_.setCounterValue(currentLength, maxLength);
                };
                /**
     * @return True if the Text Field input fails in converting the user-supplied
     *     value.
     */ MDCTextFieldFoundation.prototype.isBadInput_ = function() {
                    // The badInput property is not supported in IE 11 💩.
                    return this.getNativeInput_().validity.badInput || false;
                };
                /**
     * @return The result of native validity checking (ValidityState.valid).
     */ MDCTextFieldFoundation.prototype.isNativeInputValid_ = function() {
                    return this.getNativeInput_().validity.valid;
                };
                /**
     * Styles the component based on the validity state.
     */ MDCTextFieldFoundation.prototype.styleValidity_ = function(isValid) {
                    var INVALID = MDCTextFieldFoundation.cssClasses.INVALID;
                    if (isValid) this.adapter.removeClass(INVALID);
                    else this.adapter.addClass(INVALID);
                    if (this.helperText_) {
                        this.helperText_.setValidity(isValid);
                        // We dynamically set or unset aria-describedby for validation helper text
                        // only, based on whether the field is valid
                        var helperTextValidation = this.helperText_.isValidation();
                        if (!helperTextValidation) return;
                        var helperTextVisible = this.helperText_.isVisible();
                        var helperTextId = this.helperText_.getId();
                        if (helperTextVisible && helperTextId) this.adapter.setInputAttr(constants_1.strings.ARIA_DESCRIBEDBY, helperTextId);
                        else this.adapter.removeInputAttr(constants_1.strings.ARIA_DESCRIBEDBY);
                    }
                };
                /**
     * Styles the component based on the focused state.
     */ MDCTextFieldFoundation.prototype.styleFocused_ = function(isFocused) {
                    var FOCUSED = MDCTextFieldFoundation.cssClasses.FOCUSED;
                    if (isFocused) this.adapter.addClass(FOCUSED);
                    else this.adapter.removeClass(FOCUSED);
                };
                /**
     * Styles the component based on the disabled state.
     */ MDCTextFieldFoundation.prototype.styleDisabled_ = function(isDisabled) {
                    var _a = MDCTextFieldFoundation.cssClasses, DISABLED = _a.DISABLED, INVALID = _a.INVALID;
                    if (isDisabled) {
                        this.adapter.addClass(DISABLED);
                        this.adapter.removeClass(INVALID);
                    } else this.adapter.removeClass(DISABLED);
                    if (this.leadingIcon_) this.leadingIcon_.setDisabled(isDisabled);
                    if (this.trailingIcon_) this.trailingIcon_.setDisabled(isDisabled);
                };
                /**
     * Styles the component based on the label floating state.
     */ MDCTextFieldFoundation.prototype.styleFloating_ = function(isFloating) {
                    var LABEL_FLOATING = MDCTextFieldFoundation.cssClasses.LABEL_FLOATING;
                    if (isFloating) this.adapter.addClass(LABEL_FLOATING);
                    else this.adapter.removeClass(LABEL_FLOATING);
                };
                /**
     * @return The native text input element from the host environment, or an
     *     object with the same shape for unit tests.
     */ MDCTextFieldFoundation.prototype.getNativeInput_ = function() {
                    // this.adapter may be undefined in foundation unit tests. This happens when
                    // testdouble is creating a mock object and invokes the
                    // shouldShake/shouldFloat getters (which in turn call getValue(), which
                    // calls this method) before init() has been called from the MDCTextField
                    // constructor. To work around that issue, we return a dummy object.
                    var nativeInput = this.adapter ? this.adapter.getNativeInput() : null;
                    return nativeInput || {
                        disabled: false,
                        maxLength: -1,
                        required: false,
                        type: "input",
                        validity: {
                            badInput: false,
                            valid: true
                        },
                        value: ""
                    };
                };
                return MDCTextFieldFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldFoundation = MDCTextFieldFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/helper-text/component.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-textfield/helper-text/component.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldHelperText = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/helper-text/foundation.ts");
            var MDCTextFieldHelperText = /** @class */ function(_super) {
                __extends(MDCTextFieldHelperText, _super);
                function MDCTextFieldHelperText() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextFieldHelperText.attachTo = function(root) {
                    return new MDCTextFieldHelperText(root);
                };
                Object.defineProperty(MDCTextFieldHelperText.prototype, "foundationForTextField", {
                    // Provided for access by MDCTextField component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldHelperText.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCTextFieldHelperTextFoundation(adapter);
                };
                return MDCTextFieldHelperText;
            }(component_1.MDCComponent);
            exports.MDCTextFieldHelperText = MDCTextFieldHelperText;
        /***/ },
        /***/ "./packages/mdc-textfield/helper-text/constants.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-textfield/helper-text/constants.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var cssClasses = {
                HELPER_TEXT_PERSISTENT: "mdc-text-field-helper-text--persistent",
                HELPER_TEXT_VALIDATION_MSG: "mdc-text-field-helper-text--validation-msg",
                ROOT: "mdc-text-field-helper-text"
            };
            exports.cssClasses = cssClasses;
            var strings = {
                ARIA_HIDDEN: "aria-hidden",
                ROLE: "role",
                ROOT_SELECTOR: "." + cssClasses.ROOT
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-textfield/helper-text/foundation.ts": /*!**********************************************************!*\
  !*** ./packages/mdc-textfield/helper-text/foundation.ts ***!
  \**********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldHelperTextFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/helper-text/constants.ts");
            var MDCTextFieldHelperTextFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldHelperTextFoundation, _super);
                function MDCTextFieldHelperTextFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTextFieldHelperTextFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTextFieldHelperTextFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldHelperTextFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldHelperTextFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldHelperTextAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldHelperTextFoundation.prototype.getId = function() {
                    return this.adapter.getAttr("id");
                };
                MDCTextFieldHelperTextFoundation.prototype.isVisible = function() {
                    return this.adapter.getAttr(constants_1.strings.ARIA_HIDDEN) !== "true";
                };
                /**
     * Sets the content of the helper text field.
     */ MDCTextFieldHelperTextFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                MDCTextFieldHelperTextFoundation.prototype.isPersistent = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                };
                /**
     * @param isPersistent Sets the persistency of the helper text.
     */ MDCTextFieldHelperTextFoundation.prototype.setPersistent = function(isPersistent) {
                    if (isPersistent) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                };
                /**
     * @return whether the helper text acts as an error validation message.
     */ MDCTextFieldHelperTextFoundation.prototype.isValidation = function() {
                    return this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                };
                /**
     * @param isValidation True to make the helper text act as an error validation message.
     */ MDCTextFieldHelperTextFoundation.prototype.setValidation = function(isValidation) {
                    if (isValidation) this.adapter.addClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    else this.adapter.removeClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                };
                /**
     * Makes the helper text visible to the screen reader.
     */ MDCTextFieldHelperTextFoundation.prototype.showToScreenReader = function() {
                    this.adapter.removeAttr(constants_1.strings.ARIA_HIDDEN);
                };
                /**
     * Sets the validity of the helper text based on the input validity.
     */ MDCTextFieldHelperTextFoundation.prototype.setValidity = function(inputIsValid) {
                    var helperTextIsPersistent = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_PERSISTENT);
                    var helperTextIsValidationMsg = this.adapter.hasClass(constants_1.cssClasses.HELPER_TEXT_VALIDATION_MSG);
                    var validationMsgNeedsDisplay = helperTextIsValidationMsg && !inputIsValid;
                    if (validationMsgNeedsDisplay) {
                        this.showToScreenReader();
                        this.adapter.setAttr(constants_1.strings.ROLE, "alert");
                    } else this.adapter.removeAttr(constants_1.strings.ROLE);
                    if (!helperTextIsPersistent && !validationMsgNeedsDisplay) this.hide_();
                };
                /**
     * Hides the help text from screen readers.
     */ MDCTextFieldHelperTextFoundation.prototype.hide_ = function() {
                    this.adapter.setAttr(constants_1.strings.ARIA_HIDDEN, "true");
                };
                return MDCTextFieldHelperTextFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldHelperTextFoundation = MDCTextFieldHelperTextFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldHelperTextFoundation;
        /***/ },
        /***/ "./packages/mdc-textfield/icon/component.ts": /*!**************************************************!*\
  !*** ./packages/mdc-textfield/icon/component.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldIcon = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var foundation_1 = __webpack_require__(/*! ./foundation */ "./packages/mdc-textfield/icon/foundation.ts");
            var MDCTextFieldIcon = /** @class */ function(_super) {
                __extends(MDCTextFieldIcon, _super);
                function MDCTextFieldIcon() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTextFieldIcon.attachTo = function(root) {
                    return new MDCTextFieldIcon(root);
                };
                Object.defineProperty(MDCTextFieldIcon.prototype, "foundationForTextField", {
                    // Provided for access by MDCTextField component
                    get: function get() {
                        return this.foundation;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldIcon.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        getAttr: function getAttr(attr) {
                            return _this.root.getAttribute(attr);
                        },
                        setAttr: function setAttr(attr, value) {
                            return _this.root.setAttribute(attr, value);
                        },
                        removeAttr: function removeAttr(attr) {
                            return _this.root.removeAttribute(attr);
                        },
                        setContent: function setContent(content) {
                            _this.root.textContent = content;
                        },
                        registerInteractionHandler: function registerInteractionHandler(evtType, handler) {
                            return _this.listen(evtType, handler);
                        },
                        deregisterInteractionHandler: function deregisterInteractionHandler(evtType, handler) {
                            return _this.unlisten(evtType, handler);
                        },
                        notifyIconAction: function notifyIconAction() {
                            return _this.emit(foundation_1.MDCTextFieldIconFoundation.strings.ICON_EVENT, {} /* evtData */ , true);
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    return new foundation_1.MDCTextFieldIconFoundation(adapter);
                };
                return MDCTextFieldIcon;
            }(component_1.MDCComponent);
            exports.MDCTextFieldIcon = MDCTextFieldIcon;
        /***/ },
        /***/ "./packages/mdc-textfield/icon/constants.ts": /*!**************************************************!*\
  !*** ./packages/mdc-textfield/icon/constants.ts ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.cssClasses = exports.strings = void 0;
            var strings = {
                ICON_EVENT: "MDCTextField:icon",
                ICON_ROLE: "button"
            };
            exports.strings = strings;
            var cssClasses = {
                ROOT: "mdc-text-field__icon"
            };
            exports.cssClasses = cssClasses;
        /***/ },
        /***/ "./packages/mdc-textfield/icon/foundation.ts": /*!***************************************************!*\
  !*** ./packages/mdc-textfield/icon/foundation.ts ***!
  \***************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTextFieldIconFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-textfield/icon/constants.ts");
            var INTERACTION_EVENTS = [
                "click",
                "keydown"
            ];
            var MDCTextFieldIconFoundation = /** @class */ function(_super) {
                __extends(MDCTextFieldIconFoundation, _super);
                function MDCTextFieldIconFoundation(adapter) {
                    var _this = _super.call(this, __assign(__assign({}, MDCTextFieldIconFoundation.defaultAdapter), adapter)) || this;
                    _this.savedTabIndex_ = null;
                    _this.interactionHandler_ = function(evt) {
                        return _this.handleInteraction(evt);
                    };
                    return _this;
                }
                Object.defineProperty(MDCTextFieldIconFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldIconFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTextFieldIconFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTextFieldIconAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            getAttr: function getAttr() {
                                return null;
                            },
                            setAttr: function setAttr() {
                                return undefined;
                            },
                            removeAttr: function removeAttr() {
                                return undefined;
                            },
                            setContent: function setContent() {
                                return undefined;
                            },
                            registerInteractionHandler: function registerInteractionHandler() {
                                return undefined;
                            },
                            deregisterInteractionHandler: function deregisterInteractionHandler() {
                                return undefined;
                            },
                            notifyIconAction: function notifyIconAction() {
                                return undefined;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCTextFieldIconFoundation.prototype.init = function() {
                    var _this = this;
                    this.savedTabIndex_ = this.adapter.getAttr("tabindex");
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.registerInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCTextFieldIconFoundation.prototype.destroy = function() {
                    var _this = this;
                    INTERACTION_EVENTS.forEach(function(evtType) {
                        _this.adapter.deregisterInteractionHandler(evtType, _this.interactionHandler_);
                    });
                };
                MDCTextFieldIconFoundation.prototype.setDisabled = function(disabled) {
                    if (!this.savedTabIndex_) return;
                    if (disabled) {
                        this.adapter.setAttr("tabindex", "-1");
                        this.adapter.removeAttr("role");
                    } else {
                        this.adapter.setAttr("tabindex", this.savedTabIndex_);
                        this.adapter.setAttr("role", constants_1.strings.ICON_ROLE);
                    }
                };
                MDCTextFieldIconFoundation.prototype.setAriaLabel = function(label) {
                    this.adapter.setAttr("aria-label", label);
                };
                MDCTextFieldIconFoundation.prototype.setContent = function(content) {
                    this.adapter.setContent(content);
                };
                MDCTextFieldIconFoundation.prototype.handleInteraction = function(evt) {
                    var isEnterKey = evt.key === "Enter" || evt.keyCode === 13;
                    if (evt.type === "click" || isEnterKey) {
                        evt.preventDefault(); // stop click from causing host label to focus
                        // input
                        this.adapter.notifyIconAction();
                    }
                };
                return MDCTextFieldIconFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTextFieldIconFoundation = MDCTextFieldIconFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTextFieldIconFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/component.ts": /*!***********************************************!*\
  !*** ./packages/mdc-top-app-bar/component.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTopAppBar = void 0;
            var component_1 = __webpack_require__(/*! @material/base/component */ "./packages/mdc-base/component.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ./fixed/foundation */ "./packages/mdc-top-app-bar/fixed/foundation.ts");
            var foundation_2 = __webpack_require__(/*! ./short/foundation */ "./packages/mdc-top-app-bar/short/foundation.ts");
            var foundation_3 = __webpack_require__(/*! ./standard/foundation */ "./packages/mdc-top-app-bar/standard/foundation.ts");
            var MDCTopAppBar = /** @class */ function(_super) {
                __extends(MDCTopAppBar, _super);
                function MDCTopAppBar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MDCTopAppBar.attachTo = function(root) {
                    return new MDCTopAppBar(root);
                };
                MDCTopAppBar.prototype.initialize = function() {
                    this.navIcon_ = this.root.querySelector(constants_1.strings.NAVIGATION_ICON_SELECTOR);
                    this.scrollTarget_ = window;
                };
                MDCTopAppBar.prototype.initialSyncWithDOM = function() {
                    this.handleNavigationClick_ = this.foundation.handleNavigationClick.bind(this.foundation);
                    this.handleWindowResize_ = this.foundation.handleWindowResize.bind(this.foundation);
                    this.handleTargetScroll_ = this.foundation.handleTargetScroll.bind(this.foundation);
                    this.scrollTarget_.addEventListener("scroll", this.handleTargetScroll_);
                    if (this.navIcon_) this.navIcon_.addEventListener("click", this.handleNavigationClick_);
                    var isFixed = this.root.classList.contains(constants_1.cssClasses.FIXED_CLASS);
                    var isShort = this.root.classList.contains(constants_1.cssClasses.SHORT_CLASS);
                    if (!isShort && !isFixed) window.addEventListener("resize", this.handleWindowResize_);
                };
                MDCTopAppBar.prototype.destroy = function() {
                    this.scrollTarget_.removeEventListener("scroll", this.handleTargetScroll_);
                    if (this.navIcon_) this.navIcon_.removeEventListener("click", this.handleNavigationClick_);
                    var isFixed = this.root.classList.contains(constants_1.cssClasses.FIXED_CLASS);
                    var isShort = this.root.classList.contains(constants_1.cssClasses.SHORT_CLASS);
                    if (!isShort && !isFixed) window.removeEventListener("resize", this.handleWindowResize_);
                    _super.prototype.destroy.call(this);
                };
                MDCTopAppBar.prototype.setScrollTarget = function(target) {
                    // Remove scroll handler from the previous scroll target
                    this.scrollTarget_.removeEventListener("scroll", this.handleTargetScroll_);
                    this.scrollTarget_ = target;
                    // Initialize scroll handler on the new scroll target
                    this.handleTargetScroll_ = this.foundation.handleTargetScroll.bind(this.foundation);
                    this.scrollTarget_.addEventListener("scroll", this.handleTargetScroll_);
                };
                MDCTopAppBar.prototype.getDefaultFoundation = function() {
                    var _this = this;
                    // DO NOT INLINE this variable. For backward compatibility, foundations take a Partial<MDCFooAdapter>.
                    // To ensure we don't accidentally omit any methods, we need a separate, strongly typed adapter variable.
                    // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                    var adapter = {
                        hasClass: function hasClass(className) {
                            return _this.root.classList.contains(className);
                        },
                        addClass: function addClass(className) {
                            return _this.root.classList.add(className);
                        },
                        removeClass: function removeClass(className) {
                            return _this.root.classList.remove(className);
                        },
                        setStyle: function setStyle(property, value) {
                            return _this.root.style.setProperty(property, value);
                        },
                        getTopAppBarHeight: function getTopAppBarHeight() {
                            return _this.root.clientHeight;
                        },
                        notifyNavigationIconClicked: function notifyNavigationIconClicked() {
                            return _this.emit(constants_1.strings.NAVIGATION_EVENT, {});
                        },
                        getViewportScrollY: function getViewportScrollY() {
                            var win = _this.scrollTarget_;
                            var el = _this.scrollTarget_;
                            return win.pageYOffset !== undefined ? win.pageYOffset : el.scrollTop;
                        },
                        getTotalActionItems: function getTotalActionItems() {
                            return _this.root.querySelectorAll(constants_1.strings.ACTION_ITEM_SELECTOR).length;
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    var foundation;
                    if (this.root.classList.contains(constants_1.cssClasses.SHORT_CLASS)) foundation = new foundation_2.MDCShortTopAppBarFoundation(adapter);
                    else if (this.root.classList.contains(constants_1.cssClasses.FIXED_CLASS)) foundation = new foundation_1.MDCFixedTopAppBarFoundation(adapter);
                    else foundation = new foundation_3.MDCTopAppBarFoundation(adapter);
                    return foundation;
                };
                return MDCTopAppBar;
            }(component_1.MDCComponent);
            exports.MDCTopAppBar = MDCTopAppBar;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/constants.ts": /*!***********************************************!*\
  !*** ./packages/mdc-top-app-bar/constants.ts ***!
  \***********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.strings = exports.numbers = exports.cssClasses = void 0;
            var cssClasses = {
                FIXED_CLASS: "mdc-top-app-bar--fixed",
                FIXED_SCROLLED_CLASS: "mdc-top-app-bar--fixed-scrolled",
                SHORT_CLASS: "mdc-top-app-bar--short",
                SHORT_COLLAPSED_CLASS: "mdc-top-app-bar--short-collapsed",
                SHORT_HAS_ACTION_ITEM_CLASS: "mdc-top-app-bar--short-has-action-item"
            };
            exports.cssClasses = cssClasses;
            var numbers = {
                DEBOUNCE_THROTTLE_RESIZE_TIME_MS: 100,
                MAX_TOP_APP_BAR_HEIGHT: 128
            };
            exports.numbers = numbers;
            var strings = {
                ACTION_ITEM_SELECTOR: ".mdc-top-app-bar__action-item",
                NAVIGATION_EVENT: "MDCTopAppBar:nav",
                NAVIGATION_ICON_SELECTOR: ".mdc-top-app-bar__navigation-icon",
                ROOT_SELECTOR: ".mdc-top-app-bar",
                TITLE_SELECTOR: ".mdc-top-app-bar__title"
            };
            exports.strings = strings;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/custom-element.js": /*!****************************************************!*\
  !*** ./packages/mdc-top-app-bar/custom-element.js ***!
  \****************************************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./component */ "./packages/mdc-top-app-bar/component.ts");
            /* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_component__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _material_utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @material/utils/className */ "./packages/mdc-utils/className.js");
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var MdcTopAppBar = function(_HTMLElement) {
                _inherits(MdcTopAppBar, _HTMLElement);
                function MdcTopAppBar() {
                    _classCallCheck(this, MdcTopAppBar);
                    return _possibleConstructorReturn(this, (MdcTopAppBar.__proto__ || Object.getPrototypeOf(MdcTopAppBar)).call(this));
                }
                _createClass(MdcTopAppBar, [
                    {
                        key: "connectedCallback",
                        value: function connectedCallback() {
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["installClassNameChangeHook"].call(this);
                            this.topAppBar_ = new _component__WEBPACK_IMPORTED_MODULE_0__["MDCTopAppBar"](this);
                        }
                    },
                    {
                        key: "disconnectedCallback",
                        value: function disconnectedCallback() {
                            this.topAppBar_.destroy();
                            _material_utils_className__WEBPACK_IMPORTED_MODULE_1__["uninstallClassNameChangeHook"].call(this);
                        }
                    }
                ]);
                return MdcTopAppBar;
            }(HTMLElement);
            customElements.define("mdc-top-app-bar", MdcTopAppBar);
        /***/ },
        /***/ "./packages/mdc-top-app-bar/fixed/foundation.ts": /*!******************************************************!*\
  !*** ./packages/mdc-top-app-bar/fixed/foundation.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCFixedTopAppBarFoundation = void 0;
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ../standard/foundation */ "./packages/mdc-top-app-bar/standard/foundation.ts");
            var MDCFixedTopAppBarFoundation = /** @class */ function(_super) {
                __extends(MDCFixedTopAppBarFoundation, _super);
                function MDCFixedTopAppBarFoundation() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    /**
         * State variable for the previous scroll iteration top app bar state
         */ _this.wasScrolled_ = false;
                    return _this;
                }
                /**
     * Scroll handler for applying/removing the modifier class on the fixed top app bar.
     * @override
     */ MDCFixedTopAppBarFoundation.prototype.handleTargetScroll = function() {
                    var currentScroll = this.adapter.getViewportScrollY();
                    if (currentScroll <= 0) {
                        if (this.wasScrolled_) {
                            this.adapter.removeClass(constants_1.cssClasses.FIXED_SCROLLED_CLASS);
                            this.wasScrolled_ = false;
                        }
                    } else if (!this.wasScrolled_) {
                        this.adapter.addClass(constants_1.cssClasses.FIXED_SCROLLED_CLASS);
                        this.wasScrolled_ = true;
                    }
                };
                return MDCFixedTopAppBarFoundation;
            }(foundation_1.MDCTopAppBarFoundation);
            exports.MDCFixedTopAppBarFoundation = MDCFixedTopAppBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCFixedTopAppBarFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/foundation.ts": /*!************************************************!*\
  !*** ./packages/mdc-top-app-bar/foundation.ts ***!
  \************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = this && this.__assign || function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTopAppBarBaseFoundation = void 0;
            var foundation_1 = __webpack_require__(/*! @material/base/foundation */ "./packages/mdc-base/foundation.ts");
            var constants_1 = __webpack_require__(/*! ./constants */ "./packages/mdc-top-app-bar/constants.ts");
            var MDCTopAppBarBaseFoundation = /** @class */ function(_super) {
                __extends(MDCTopAppBarBaseFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarBaseFoundation(adapter) {
                    return _super.call(this, __assign(__assign({}, MDCTopAppBarBaseFoundation.defaultAdapter), adapter)) || this;
                }
                Object.defineProperty(MDCTopAppBarBaseFoundation, "strings", {
                    get: function get() {
                        return constants_1.strings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTopAppBarBaseFoundation, "cssClasses", {
                    get: function get() {
                        return constants_1.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTopAppBarBaseFoundation, "numbers", {
                    get: function get() {
                        return constants_1.numbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MDCTopAppBarBaseFoundation, "defaultAdapter", {
                    /**
         * See {@link MDCTopAppBarAdapter} for typing information on parameters and return types.
         */ get: function get() {
                        // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
                        return {
                            addClass: function addClass() {
                                return undefined;
                            },
                            removeClass: function removeClass() {
                                return undefined;
                            },
                            hasClass: function hasClass() {
                                return false;
                            },
                            setStyle: function setStyle() {
                                return undefined;
                            },
                            getTopAppBarHeight: function getTopAppBarHeight() {
                                return 0;
                            },
                            notifyNavigationIconClicked: function notifyNavigationIconClicked() {
                                return undefined;
                            },
                            getViewportScrollY: function getViewportScrollY() {
                                return 0;
                            },
                            getTotalActionItems: function getTotalActionItems() {
                                return 0;
                            }
                        };
                    // tslint:enable:object-literal-sort-keys
                    },
                    enumerable: false,
                    configurable: true
                });
                /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleTargetScroll = function() {}; // tslint:disable-line:no-empty
                /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleWindowResize = function() {}; // tslint:disable-line:no-empty
                MDCTopAppBarBaseFoundation.prototype.handleNavigationClick = function() {
                    this.adapter.notifyNavigationIconClicked();
                };
                return MDCTopAppBarBaseFoundation;
            }(foundation_1.MDCFoundation);
            exports.MDCTopAppBarBaseFoundation = MDCTopAppBarBaseFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTopAppBarBaseFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/short/foundation.ts": /*!******************************************************!*\
  !*** ./packages/mdc-top-app-bar/short/foundation.ts ***!
  \******************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCShortTopAppBarFoundation = void 0;
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ../foundation */ "./packages/mdc-top-app-bar/foundation.ts");
            var MDCShortTopAppBarFoundation = /** @class */ function(_super) {
                __extends(MDCShortTopAppBarFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ function MDCShortTopAppBarFoundation(adapter) {
                    var _this = _super.call(this, adapter) || this;
                    _this.isCollapsed_ = false;
                    _this.isAlwaysCollapsed_ = false;
                    return _this;
                }
                Object.defineProperty(MDCShortTopAppBarFoundation.prototype, "isCollapsed", {
                    // Public visibility for backward compatibility.
                    get: function get() {
                        return this.isCollapsed_;
                    },
                    enumerable: false,
                    configurable: true
                });
                MDCShortTopAppBarFoundation.prototype.init = function() {
                    _super.prototype.init.call(this);
                    if (this.adapter.getTotalActionItems() > 0) this.adapter.addClass(constants_1.cssClasses.SHORT_HAS_ACTION_ITEM_CLASS);
                    // If initialized with SHORT_COLLAPSED_CLASS, the bar should always be collapsed
                    this.setAlwaysCollapsed(this.adapter.hasClass(constants_1.cssClasses.SHORT_COLLAPSED_CLASS));
                };
                /**
     * Set if the short top app bar should always be collapsed.
     *
     * @param value When `true`, bar will always be collapsed. When `false`, bar may collapse or expand based on scroll.
     */ MDCShortTopAppBarFoundation.prototype.setAlwaysCollapsed = function(value) {
                    this.isAlwaysCollapsed_ = !!value;
                    if (this.isAlwaysCollapsed_) this.collapse_();
                    else // let maybeCollapseBar_ determine if the bar should be collapsed
                    this.maybeCollapseBar_();
                };
                MDCShortTopAppBarFoundation.prototype.getAlwaysCollapsed = function() {
                    return this.isAlwaysCollapsed_;
                };
                /**
     * Scroll handler for applying/removing the collapsed modifier class on the short top app bar.
     * @override
     */ MDCShortTopAppBarFoundation.prototype.handleTargetScroll = function() {
                    this.maybeCollapseBar_();
                };
                MDCShortTopAppBarFoundation.prototype.maybeCollapseBar_ = function() {
                    if (this.isAlwaysCollapsed_) return;
                    var currentScroll = this.adapter.getViewportScrollY();
                    if (currentScroll <= 0) {
                        if (this.isCollapsed_) this.uncollapse_();
                    } else if (!this.isCollapsed_) this.collapse_();
                };
                MDCShortTopAppBarFoundation.prototype.uncollapse_ = function() {
                    this.adapter.removeClass(constants_1.cssClasses.SHORT_COLLAPSED_CLASS);
                    this.isCollapsed_ = false;
                };
                MDCShortTopAppBarFoundation.prototype.collapse_ = function() {
                    this.adapter.addClass(constants_1.cssClasses.SHORT_COLLAPSED_CLASS);
                    this.isCollapsed_ = true;
                };
                return MDCShortTopAppBarFoundation;
            }(foundation_1.MDCTopAppBarBaseFoundation);
            exports.MDCShortTopAppBarFoundation = MDCShortTopAppBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCShortTopAppBarFoundation;
        /***/ },
        /***/ "./packages/mdc-top-app-bar/standard/foundation.ts": /*!*********************************************************!*\
  !*** ./packages/mdc-top-app-bar/standard/foundation.ts ***!
  \*********************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var __extends = this && this.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.MDCTopAppBarFoundation = void 0;
            var constants_1 = __webpack_require__(/*! ../constants */ "./packages/mdc-top-app-bar/constants.ts");
            var foundation_1 = __webpack_require__(/*! ../foundation */ "./packages/mdc-top-app-bar/foundation.ts");
            var INITIAL_VALUE = 0;
            var MDCTopAppBarFoundation = /** @class */ function(_super) {
                __extends(MDCTopAppBarFoundation, _super);
                /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarFoundation(adapter) {
                    var _this = _super.call(this, adapter) || this;
                    /**
         * Indicates if the top app bar was docked in the previous scroll handler iteration.
         */ _this.wasDocked_ = true;
                    /**
         * Indicates if the top app bar is docked in the fully shown position.
         */ _this.isDockedShowing_ = true;
                    /**
         * Variable for current scroll position of the top app bar
         */ _this.currentAppBarOffsetTop_ = 0;
                    /**
         * Used to prevent the top app bar from being scrolled out of view during resize events
         */ _this.isCurrentlyBeingResized_ = false;
                    /**
         * The timeout that's used to throttle the resize events
         */ _this.resizeThrottleId_ = INITIAL_VALUE;
                    /**
         * The timeout that's used to debounce toggling the isCurrentlyBeingResized_ variable after a resize
         */ _this.resizeDebounceId_ = INITIAL_VALUE;
                    _this.lastScrollPosition_ = _this.adapter.getViewportScrollY();
                    _this.topAppBarHeight_ = _this.adapter.getTopAppBarHeight();
                    return _this;
                }
                MDCTopAppBarFoundation.prototype.destroy = function() {
                    _super.prototype.destroy.call(this);
                    this.adapter.setStyle("top", "");
                };
                /**
     * Scroll handler for the default scroll behavior of the top app bar.
     * @override
     */ MDCTopAppBarFoundation.prototype.handleTargetScroll = function() {
                    var currentScrollPosition = Math.max(this.adapter.getViewportScrollY(), 0);
                    var diff = currentScrollPosition - this.lastScrollPosition_;
                    this.lastScrollPosition_ = currentScrollPosition;
                    // If the window is being resized the lastScrollPosition_ needs to be updated but the
                    // current scroll of the top app bar should stay in the same position.
                    if (!this.isCurrentlyBeingResized_) {
                        this.currentAppBarOffsetTop_ -= diff;
                        if (this.currentAppBarOffsetTop_ > 0) this.currentAppBarOffsetTop_ = 0;
                        else if (Math.abs(this.currentAppBarOffsetTop_) > this.topAppBarHeight_) this.currentAppBarOffsetTop_ = -this.topAppBarHeight_;
                        this.moveTopAppBar_();
                    }
                };
                /**
     * Top app bar resize handler that throttle/debounce functions that execute updates.
     * @override
     */ MDCTopAppBarFoundation.prototype.handleWindowResize = function() {
                    var _this = this;
                    // Throttle resize events 10 p/s
                    if (!this.resizeThrottleId_) this.resizeThrottleId_ = setTimeout(function() {
                        _this.resizeThrottleId_ = INITIAL_VALUE;
                        _this.throttledResizeHandler_();
                    }, constants_1.numbers.DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
                    this.isCurrentlyBeingResized_ = true;
                    if (this.resizeDebounceId_) clearTimeout(this.resizeDebounceId_);
                    this.resizeDebounceId_ = setTimeout(function() {
                        _this.handleTargetScroll();
                        _this.isCurrentlyBeingResized_ = false;
                        _this.resizeDebounceId_ = INITIAL_VALUE;
                    }, constants_1.numbers.DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
                };
                /**
     * Function to determine if the DOM needs to update.
     */ MDCTopAppBarFoundation.prototype.checkForUpdate_ = function() {
                    var offscreenBoundaryTop = -this.topAppBarHeight_;
                    var hasAnyPixelsOffscreen = this.currentAppBarOffsetTop_ < 0;
                    var hasAnyPixelsOnscreen = this.currentAppBarOffsetTop_ > offscreenBoundaryTop;
                    var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
                    // If it's partially showing, it can't be docked.
                    if (partiallyShowing) this.wasDocked_ = false;
                    else {
                        // Not previously docked and not partially showing, it's now docked.
                        if (!this.wasDocked_) {
                            this.wasDocked_ = true;
                            return true;
                        } else if (this.isDockedShowing_ !== hasAnyPixelsOnscreen) {
                            this.isDockedShowing_ = hasAnyPixelsOnscreen;
                            return true;
                        }
                    }
                    return partiallyShowing;
                };
                /**
     * Function to move the top app bar if needed.
     */ MDCTopAppBarFoundation.prototype.moveTopAppBar_ = function() {
                    if (this.checkForUpdate_()) {
                        // Once the top app bar is fully hidden we use the max potential top app bar height as our offset
                        // so the top app bar doesn't show if the window resizes and the new height > the old height.
                        var offset = this.currentAppBarOffsetTop_;
                        if (Math.abs(offset) >= this.topAppBarHeight_) offset = -constants_1.numbers.MAX_TOP_APP_BAR_HEIGHT;
                        this.adapter.setStyle("top", offset + "px");
                    }
                };
                /**
     * Throttled function that updates the top app bar scrolled values if the
     * top app bar height changes.
     */ MDCTopAppBarFoundation.prototype.throttledResizeHandler_ = function() {
                    var currentHeight = this.adapter.getTopAppBarHeight();
                    if (this.topAppBarHeight_ !== currentHeight) {
                        this.wasDocked_ = false;
                        // Since the top app bar has a different height depending on the screen width, this
                        // will ensure that the top app bar remains in the correct location if
                        // completely hidden and a resize makes the top app bar a different height.
                        this.currentAppBarOffsetTop_ -= this.topAppBarHeight_ - currentHeight;
                        this.topAppBarHeight_ = currentHeight;
                    }
                    this.handleTargetScroll();
                };
                return MDCTopAppBarFoundation;
            }(foundation_1.MDCTopAppBarBaseFoundation);
            exports.MDCTopAppBarFoundation = MDCTopAppBarFoundation;
            // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
            exports.default = MDCTopAppBarFoundation;
        /***/ },
        /***/ "./packages/mdc-utils/className.js": /*!*****************************************!*\
  !*** ./packages/mdc-utils/className.js ***!
  \*****************************************/ /*! exports provided: installClassNameChangeHook, uninstallClassNameChangeHook */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installClassNameChangeHook", function() {
                return installClassNameChangeHook;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uninstallClassNameChangeHook", function() {
                return uninstallClassNameChangeHook;
            });
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            /* Material Components frequently enhance their DOM elements with additional
 * class names that depend on component state (ie. has focus) rather than
 * configuration state (ie. text field value).
 *
 * Since the component state is unknown to Elm, we cannot control those class
 * names in Elm. On the other hand, Elm does controls some class names (ie.
 * mdc-text-field).
 *
 * This means that currently, Elm's virtual dom library assumes sole control
 * over class names, since it sets a DOM node's `className` property. Thus, if
 * a Elm-controlled class name changes, it might delete additional uncontrolled
 * class names.
 *
 * We work around this issue by patching a DOM node's `className` property in
 * the following way:
 * (1) We may assume that Elm only ever touches `className`
 * (2) We may assume that Material Components only ever touch `classList`
 *
 * Thus, whenever a write to `className` happens, we record the list of classes
 * that Elm has control over (classes that have been added via `className`).
 * Then we identify classes removed via `className`, and we only allow removal
 * of classes that Elm has control over. Classes added via the `classList`
 * property cannot be removed via the `className` property.
 *
 * We will not require this fix anymore once Elm's virtual dom implementation
 * uses `classList.add`, `classList.remove` to manage class names.
 *
 * In addition to this, there are some class names that Elm should assume
 * control over for the first frame, but may not remove them in subsequent
 * frames. Those class names are class names that fall into the component
 * state, but may have to be set by Elm in the first frame to prevent a flash
 * of unstyled content (FOUC).
 *
 * The logic for those is implemented similarly, with the exception that the
 * classNames have to be listed in the node's property `foucClassNames`.
 */ function setClassName(className) {
                var css = className.split(" ").filter(function(cs) {
                    return cs !== "";
                });
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = css[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var cs = _step.value;
                        this.classList.add(cs);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = this.className_[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var _cs = _step2.value;
                        if (!!this.foucClassNames && this.foucClassNames.includes(_cs)) return;
                        if (!css.includes(_cs)) this.classList.remove(_cs);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                    } finally{
                        if (_didIteratorError2) throw _iteratorError2;
                    }
                }
                this.className_ = css;
            }
            function getClassName() {
                return "" + this.classList;
            }
            function installClassNameChangeHook() {
                Object.defineProperty(this, "className", {
                    get: getClassName.bind(this),
                    set: setClassName.bind(this),
                    configurable: true
                });
                this.className_ = [].concat(_toConsumableArray(this.classList));
            }
            function uninstallClassNameChangeHook() {
                var object = Object.getPrototypeOf(this);
                var descriptor = void 0;
                while(!(descriptor = Object.getOwnPropertyDescriptor(object, "className")))object = Object.getPrototypeOf(object);
                Object.defineProperty(this, "className", descriptor);
                delete this.className_;
                this.className = getClassName.call(this);
            }
        /***/ }
    });
});


customElements.define("x-checkout", class Checkout extends HTMLElement {
    get locale() {
        return this._locale;
    }
    set locale(newLocale) {
        if (this._locale !== null) console.warn("property `locale' can only be set initially, ignoring");
        this._locale = newLocale;
    }
    get endpoint() {
        return this._endpoint;
    }
    set endpoint(newEndpoint) {
        if (this._endpoint !== null) console.warn("property `endpoint' can only be set initially, ignoring");
        this._endpoint = newEndpoint;
    }
    get checkoutId() {
        return this._checkoutId;
    }
    set checkoutId(newCheckoutId) {
        if (this._checkoutId !== null) console.warn("property `checkoutId' can only be set initially, ignoring");
        this._checkoutId = newCheckoutId;
    }
    get brands() {
        return this._brands;
    }
    set brands(newBrands) {
        if (this._brands !== null) console.warn("property `brands' can only be set initially, ignoring");
        this._brands = newBrands;
    }
    get shopperResultUrl() {
        return this._shopperResultUrl;
    }
    set shopperResultUrl(newShopperResultUrl) {
        if (this._shopperResultUrl !== null) console.warn("property `shopperResultUrl' can only be set initially, ignoring");
        this._shopperResultUrl = newShopperResultUrl;
    }
    constructor(){
        super();
        this._brands = null;
        this._checkoutId = null;
        this._endpoint = null;
        this._shopperResultUrl = null;
        this._locale = null;
    }
    connectedCallback() {
        this._shadowRoot = this.attachShadow({
            mode: "closed"
        });
        const slot = document.createElement("slot");
        slot.setAttribute("name", "form");
        this._shadowRoot.appendChild(slot);
        const form = document.createElement("form");
        form.action = this._shopperResultUrl;
        form.classList.add("paymentWidgets");
        form.dataset.brands = this._brands;
        const formWrapper = document.createElement("div");
        formWrapper.setAttribute("slot", "form");
        formWrapper.appendChild(form);
        this.appendChild(formWrapper);
        const script = document.createElement("script");
        script.textContent = `
      var wpwlOptions = {
          locale: "${this.locale}",
      }
    `;
        document.head.appendChild(script);
        const paymentWidgets = document.createElement("script");
        paymentWidgets.src = `${this._endpoint}v1/paymentWidgets.js?checkoutId=${this._checkoutId}`;
        document.head.appendChild(paymentWidgets);
    }
    disconnectedCallback() {}
});


customElements.define("x-user-upload", class FileUpload extends HTMLElement {
    constructor(){
        super();
        this._accept = null;
    }
    get accept() {
        return this._accept;
    }
    set accept(accept) {
        this._accept = accept;
        if (!this._input) return;
        if (accept) this._input.setAttribute("accept", accept);
        else this._input.removeAttribute("accept");
    }
    connectedCallback() {
        this._shadowRoot = this.attachShadow({
            mode: "closed"
        });
        this._div = document.createElement("div");
        this._div.style.position = "relative";
        this._input = document.createElement("input");
        this._input.setAttribute("type", "file");
        if (this._accept) this._input.setAttribute("accept", this._accept);
        this._input.addEventListener("change", this.handleChange.bind(this));
        this._input.style.position = "absolute";
        this._input.style.inset = "0 0 0 0";
        this._input.style.display = "none";
        this._slot = document.createElement("slot");
        this._slot.name = "root";
        this._slot.style.display = "block";
        this._slot.addEventListener("click", this.handleClick.bind(this));
        this._slot.addEventListener("keypress", this.handleKeypress.bind(this));
        this._div.appendChild(this._input);
        this._div.appendChild(this._slot);
        this._shadowRoot.appendChild(this._div);
    }
    async handleChange(event) {
        const file = this._input.files[0];
        const reader = new FileReader();
        const dataURL = await new Promise((resolve, reject)=>{
            reader.addEventListener("load", ()=>resolve(reader.result), false);
            reader.readAsDataURL(file);
        });
        const detail = {
            lastModified: file.lastModified,
            name: file.name,
            size: file.size,
            type: file.type,
            dataURL: dataURL
        };
        this.dispatchEvent(new CustomEvent("filereplaced", {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }
    async handleFocus(event) {
        this._input.click();
    }
    async handleClick(event) {
        this._input.click();
    }
    async handleKeypress(event) {
        if (event.key !== "Enter" && event.key !== " ") {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
        await this._input.click();
        event.preventDefault();
    }
});


//import debugValues from "../../backend/data/ADDITC/values.json";
const $af29870571d44532$var$trace = (x)=>console.trace(x) || x;
customElements.define("x-ticketshop", class Ticketshop extends HTMLElement {
    config(key, dflt = null) {
        if (this.hasAttribute(key)) return this.getAttribute(key);
        return new URL(document.location).searchParams.get(key) || dflt;
    }
    static get observedAttributes() {
        return [
            "data-locale",
            "data-code"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this[name.slice("data-".length)] = newValue;
    }
    get id() {
        return this._id;
    }
    set id(newId) {
        if (this._id !== null) console.warn("property `id' can only be set initially, ignoring");
        this._id = newId;
    }
    get checkout() {
        return this._checkout;
    }
    set checkout(newCheckout) {
        if (this._checkout !== null) console.warn("property `checkout' can only be set initially, ignoring");
        this._checkout = newCheckout;
    }
    get crashed() {
        return this._crashed;
    }
    set crashed(newCrashed) {
        if (this._crashed !== null) console.warn("property `crashed' can only be set initially, ignoring");
        this._crashed = newCrashed;
    }
    get loading() {
        return this._loading;
    }
    set loading(newLoading) {
        if (this._loading !== null) console.warn("property `loading' can only be set initially, ignoring");
        this._loading = newLoading;
    }
    get code() {
        return this._code;
    }
    set code(newCode) {
        if (this._code !== null) console.warn("property `code' can only be set initially, ignoring");
        this._code = newCode;
    }
    get api() {
        return this._api;
    }
    set api(newApi) {
        if (this._api !== null) console.warn("property `api' can only be set initially, ignoring");
        this._api = newApi;
    }
    get values() {
        return this._values;
    }
    set values(newValues) {
        if (this._values !== null) console.warn("property `values' can only be set initially, ignoring");
        this._values = newValues;
    }
    get pages() {
        return this._pages;
    }
    set pages(newPages) {
        this._pages = newPages;
        if (this.app) this.app.ports.setPages.send(newPages);
    }
    get locale() {
        return this._locale;
    }
    set locale(newLocale) {
        this._locale = newLocale;
        if (this.app) this.app.ports.setLocale.send(this._locale);
    }
    get tickets() {
        return this._tickets;
    }
    set tickets(newTickets) {
        this._tickets = newTickets;
        if (this.app) this.app.ports.setTickets.send(this._tickets);
    }
    get discounts() {
        return this._discounts;
    }
    set discounts(newTickets) {
        this._discounts = newTickets;
        if (this.app) this.app.ports.setDiscounts.send(this._discounts);
    }
    constructor(){
        super();
        this.app = null;
        this._id = new URL(document.location).searchParams.get("order-id");
        this._pages = null;
        this._tickets = null;
        this._discounts = null;
        this._values = null // trace(debugValues);
        ;
        this._locale = this.config("locale");
        this._code = this.config("code");
        this._loginCode = this.config("loginCode");
        this._auth = null;
        this._checkout = null;
        this._crashed = new URL(document.location).searchParams.get("crashed");
        this._loading = null;
    }
    async connectedCallback() {
        this._shadowRoot = this.attachShadow({
            mode: "closed"
        });
        const style = document.createElement("style");
        style.setAttribute("type", "text/css");
        style.textContent = (0, (/*@__PURE__*/$parcel$interopDefault($b7f229489df24bee$exports)));
        this._shadowRoot.appendChild(style);
        const link = document.createElement("link");
        link.setAttribute("href", "https://fonts.googleapis.com/icon?family=Material+Icons");
        link.setAttribute("rel", "stylesheet");
        this._shadowRoot.appendChild(link);
        const node = document.createElement("div");
        this._shadowRoot.appendChild(node);
        const slot = document.createElement("slot");
        slot.setAttribute("name", "checkout");
        this._shadowRoot.appendChild(slot);
        if (this._loginCode) {
            try {
                const auth = await (await fetch(`http://localhost:8080/public/user-account/login/callback?i=${this._loginCode}`, {
                    credentials: "include"
                })).json();
                this._auth = auth;
            } catch (e) {
                console.info(`loginCode: ${e}`);
            }
            const url = new URL(window.location.href);
            url.search = url.search.replace(/[?&]loginCode=[^&]*/, "").replace(/^&/, "?");
            history.replaceState(null, "", `${url}`);
        }
        (()=>{
            const link = document.createElement("link");
            link.setAttribute("href", "https://fonts.googleapis.com/icon?family=Material+Icons");
            link.setAttribute("rel", "stylesheet");
            document.head.append(link);
        })();
        console.log("flags", {
            values: this._values,
            pages: this._pages,
            idempotencyToken: crypto.randomUUID(),
            locale: this._locale,
            tickets: this._tickets,
            discounts: this._discounts,
            api: this._api,
            code: this._code,
            exhibitor: this._exhibitor,
            id: this._id,
            checkout: this._checkout,
            crashed: this._crashed,
            loading: this._loading,
            origin: window.location.href,
            width: this.parentElement.clientWidth,
            auth: this._auth
        });
        this.app = (0, $b0acb6cf65ffb89e$exports.Elm).Frontend.init({
            flags: {
                values: this._values,
                pages: this._pages,
                idempotencyToken: crypto.randomUUID(),
                locale: this._locale,
                tickets: this._tickets,
                discounts: this._discounts,
                api: this._api,
                code: this._code,
                id: this._id,
                checkout: this._checkout,
                crashed: this._crashed,
                loading: this._loading,
                origin: window.location.href,
                width: this.parentElement.clientWidth,
                auth: this._auth
            },
            node: node
        });
        this.app.ports.inspect.subscribe((detail)=>this.dispatchEvent(new CustomEvent("inspect", {
                detail: detail
            })));
        this.app.ports.submit.subscribe((detail)=>this.dispatchEvent(new CustomEvent("submit", {
                detail: detail
            })));
        this.app.ports.navigated.subscribe(()=>window.requestAnimationFrame(()=>this.scrollIntoView()));
        this.app.ports.mountCheckout.subscribe((checkout)=>{
            const node = document.createElement("x-checkout");
            node.setAttribute("slot", "checkout");
            node.brands = checkout.brands.join(" ");
            node.checkoutId = checkout.checkoutId;
            node.endpoint = checkout.endpoint;
            node.shopperResultUrl = checkout.shopperResultUrl;
            node.locale = checkout.locale;
            this.appendChild(node);
        });
        window.addEventListener("resize", ()=>this.app.ports.setWidth.send(this.parentElement.clientWidth));
    /*} catch(e) {
    console.info(e);
    throw e;
  }*/ }
});


//# sourceMappingURL=index.69c0a63a.js.map
